/*! ==== 00-backend-toggle.js ==== */
// Our Worker origin. Every value on the site is loaded from its
// /api/composite/<format> endpoint, including each TE-premium format, which
// the engine prices separately. With no backend there are no values: there
// is deliberately no third-party fallback (module 74).
// Sandbox builds talk to the sandbox Worker; production always talks to
// production. Decided by HOSTNAME rather than by a build flag on purpose --
// a flag can ship to production set wrong, a hostname cannot. Anything served
// from thearmchairoffice.com gets the live API, full stop, even if this file
// is deployed from the 2.0 branch by mistake.
//
// taco-api-v2 is the same code with no crons and no routes (see
// taco-backend/wrangler.sandbox.toml). It exists because Workers have no
// preview environment here, so backend work on 2.0 would otherwise have to go
// to the live API to be testable -- which is exactly how it ended up there on
// launch night.
var BACKEND_URL = (function pickBackend() {
  try {
    var host = window.location.hostname;
    var isProd = host === 'thearmchairoffice.com' || host === 'www.thearmchairoffice.com';
    if (!isProd && /\.pages\.dev$/.test(host)) {
      return 'https://taco-api-v2.owenpodoll.workers.dev';
    }
  } catch (_e) { /* fall through to production */ }
  return 'https://api.thearmchairoffice.com';
})();
window.BACKEND_URL = BACKEND_URL;

/** Shared value math — see shared/values.mjs (source of truth).
 * The one choke point all consensus-value resolution goes through. */
function resolveBackendConsensusValue(entry, scoringTab, position) {
  return TacoValues.resolveConsensusValue(entry, { scoringTab, position });
}

;
/*! ==== 01-state.js ==== */
const STATE = {
  userId: null,
  username: null,
  account: null,        // signed-in account {id,email,tier} or null; tier is server-written
  season: null,
  leagues: [],          // enriched league objects
  playersDB: null,       // Sleeper /players/nfl
  ktcRaw: {},            // { '1QB': [...], 'SF': [...], '1QB TE+': [...], etc }
  ktcLookup: {},         // { 'SF TE+': Map<normalized_name, {value, posRank, age, rookie}> }
  currentTeamIdx: null,
  teamDetailTab: 'overview',
  pendingRoute: null,
  pendingLeagueTab: null,
  scoutMode: false,     // /scout/<id>: one league that is not the viewer's; nav hidden
  scoutViewAs: null,    // owner_id a scouted league is being viewed as, or null
  tradeInitialized: false,
  tradePreload: null,
  tradeCalculatorUsedTracked: false,
  fromLeagueContext: false,
  leagueTeamsInitialized: false,
  leagueRostersInitialized: false,
  rostersRosterId: null, // Rosters view: the team being looked at (null = yours)
  rostersLeagueId: null, // the league that selection belongs to -- roster ids repeat across leagues
  userDisplayName: null,
  userAvatar: null,
  lastSyncAt: null,
  adpByPlayer: {},
  ddMarkets: null,
  _tradeChildren: null,
  _portfolioBootstrap: null,
  _playersDBPromise: null,
  _statsRenderState: null,
  crawlStatus: null,     // /api/crawl/status — trade graph + implied pipeline
  marketRadar: null,     // /api/market/radar — implied vs consensus outliers
  marketRadarFormat: null, // SF | 1QB — user override on the Market tool
  marketSort: 'heat',    // Market tool lens: heat | movers | market
  marketIncludeThin: false, // Market Radar: let trade gaps from < 6 trades rank (56)
  // season -> nflverse-derived advanced stats (CPOE, PROE, xFP, deep / goal-line
  // share) from /api/advanced/nflverse; null = tried and not available.
  advNflverseBySeason: {},
  advStatsBySeason: {},  // season -> raw Sleeper bulk stats map (pid -> stats); one 1.2MB fetch each, cached
  advStatsSeason: null,  // season the Advanced Stats explorer is showing (defaults to current)
  advStatsPos: 'WR',     // primary position view: QB | RB | WR | TE (page is position-first)
  advStatsSort: 'pprPerGame', // sorted metric key (an ADV_METRICS key)
  advStatsSortDir: 'desc',    // desc | asc
  advStatsSearch: '',    // name search filter
  advStatsPreset: 'usage', // table columns: usage | efficiency | scoring | all (90)
  _advStatsFetching: {}, // season -> in-flight promise guard
  _advStatsRows: {},     // season -> computed advanced rows (cache)
  _advStatsValueFormat: null, // which value format the Value column reflects
  mateActivity: null,    // recent trades in user's leagues (leaguemate stream)
  weeklyProjections: null, // /api/projections — { season, week, projections, schedule } for start/sit (TACO-032)
  seasonProjections: null, // /api/projections/season — { season, weeks, weeksPublished } for projected finish
  leagueSchedules: null,   // {league_id: {weeks, matchups}} — Sleeper matchups for projected finish
  leagueSOS: {},           // {league_id: {ready, ranks, sos}} — strength-of-schedule faced, per roster
  standingsTrend: {},      // {league_id: [{week, value_rank, standing_rank, ...}]} — rank history from the backend snapshot store
  liveDraftSessions: [], // active Sleeper drafts { league, draft, picks, draftMeta }
  liveDraftActiveIdx: 0,
  liveDraftCollapsed: false,
  liveDraftPollTimer: null,
  liveDraftPinnedLeagueId: null, // manual open from Picks & Draft tab (incl. pre_draft)
  liveDraftPosFilter: 'ALL',
  liveDraftSortKey: 'need',
  _waiverServerCache: null,
  _tradeSuggestions: {}, // league_id → { loading, data, failed }
  // {week, board} — one matchup fetch per league is expensive, and both the
  // Scoreboard and the Rooting Guide read the same rows. Keyed by week because
  // that is the only thing that invalidates it.
  scoreboardBoard: null,      // the CURRENT NFL week's board (Who You Need + live refresh read this)
  scoreboardBoards: {},       // week -> board, so The Slate can browse past/upcoming weeks without refetching
  slateWeek: null,            // the week The Slate is showing; null = current NFL week
  scoreboardSort: 'closest', // 'closest' | 'winProb'
  // League Investigator: the ranked leaguemate list, the manager being
  // examined, and their overlaps. Cached per session because the answer only
  // moves when the crawl does, not when the page rerenders.
  // League Investigator: the manager board is built from leagues + trade
  // history already in memory, so only the crawl overlay and the UI controls
  // need state of their own.
  investigatorOverlap: null,   // ownerId -> { hiddenLeagues, theirLeagues }
  investigatorSort: 'target',  // the board leads with who to make an offer to
  investigatorQuery: '',
  investigator: null,          // legacy: raw /api/investigator payload
  investigatorSubject: null,   // { subject, mates, sharedWithMe, yourLeagueIds }
  investigatorLoading: false,
  // A username looked up on Sleeper who may be in none of your leagues:
  // { query, loading?, error?, data: { manager, basis, truncated, deep } }
  investigatorLookup: null,
  // Manager dossier (94): { query, status, done, total, user, leaguesTotal,
  // snapshots, data } for the manager currently looked up.
  dossier: null,
  // League scouting report (95): { input, status, league, report }.
  leagueReport: null,
  // Bandwidth (93): { status, done, total, counts: ownerId -> { total, dynasty },
  // mine, at } — each leaguemate's Sleeper league count, run on request.
  bandwidthCheck: null,
  // Commish Desk (97): { week, leaguesRef, byLeague: leagueId -> rosterId ->
  // starters } for the leagues you run, and the league its draft order shows.
  commishLineups: null,
  commishLeague: null,
  // Rookie Odds (98): which position's table is showing.
  rookieOddsPos: 'RB',
  // Sleeper's own answer to "what week is it", from /v1/state/nfl. The local
  // calendar maths in shared/nfl-week.mjs is the fallback, not the authority:
  // it has been wrong twice (a fixed Sept-4 anchor, then a UTC rollover that
  // fired during Monday night football), and each time the Slate showed a week
  // nobody had played. null until the fetch lands.
  nflState: null,
  // Which summary tile The Slate is filtered by: 'all' | 'wins' | 'losses' |
  // 'toss' | 'expected'. Reset to 'all' whenever the week changes, since a
  // bucket that had games last week can be empty in the next one.
  slateFilter: 'all',
  // NFL team -> {opponent, isHome, kickoffAt} for the current week. Filled by the
  // Slate; Who You Need needs the opponent to group players into games.
  weeklyScheduleMap: null,
  // League ids Who You Need is scoped to. Empty array = all leagues, which is
  // the honest default for a tool whose premise is the whole book.
  rootingLeagueFilter: [],
  _draftBoardCache: {}, // league_id → { key, rows, needs }
  tradeHistory: null,
  // Per-league trade cache, keyed by league_id. Lets a league's own tab render
  // from ~2 requests instead of waiting on all 30 leagues. Must be cleared
  // whenever tradeHistory is, since verdicts are computed from player values.
  tradeHistoryByLeague: {},    // Array of enriched trade records, lazy-loaded on first view
  tradeHistoryLoading: false,
  tradeHistoryFilter: 'all', // 'all' | 'mine' | league_id
  tradeHistoryShown: 25, // pagination cap — resets to 25 on filter change, +25 per "Show more"
  // Realized-points grade (how a trade actually played out). Loaded lazily,
  // one league at a time -- see loadRealizedTradeContext in module 70.
  tradeRealizedByLeague: {}, // {league_id: {weeks, throughWeek, resolvePick, ready, error?}}
  tradeRealizedGrades: {},   // {trade_id: grade} — memo, cleared with tradeHistory
  // All-time W-L across every season of every league (module 12). Null until
  // loadAllTimeRecords resolves; the current season renders without it.
  allTimeRecords: null,      // {byLeague: {league_id: summary}, portfolio: summary}
  // Who has left a team and who has taken one over, across every league of
  // yours that has run more than one season (module 12). Commish Desk only.
  ownerTurnover: null,       // aggregateOwnerTurnover output + byLeague
  commishTab: 'lineups',     // Commish Desk tab: lineups | managers | draft | settings
  // Per-league season rosters, newest first, keyed by the CURRENT league id
  // (module 12). Fills in as the turnover walk runs; the manager profile
  // reads any owner's past seasons from it.
  seasonSnapshots: {},
  managerDrawerId: null,     // ownerId whose cross-league profile is open
  dossierTab: 'overview',    // Manager Dossier tab: overview | trading | roster | leagues
  dossierPage: 1,            // Leagues tab page (25 per page; some accounts have hundreds)
  // Observed pick times per draft (module 64). Sleeper does not timestamp
  // picks, so these accrue only while a draft is being watched; mirrored to
  // localStorage so they survive a reload.
  draftClocks: {},
  // Every league-season a manager has played, keyed by Sleeper user id
  // (module 12). Built by asking Sleeper per season rather than walking back
  // from the present, which misses every league they left.
  careers: {},
  careerSeason: 'all',       // the season filter on a dossier: 'all' | '2026' | ...
  rankingsShown: 50,     // player rankings pagination — resets on filter/rookies toggle
  rankingsSort: 'value', // player rankings sort: 'value' | 'movers' (30d momentum)
  myAssetsShown: 50,     // my assets list pagination — resets on filter/sort/search
  tradeFinderFilter: 'ALL',       // TACO-006: position filter for the cross-league feed
  // Roadmap #4: the goal the finder ranks for ('auto' = each league's own
  // style, or contend / rebuild / balanced). Locks live in TacoStorage.
  tradeFinderGoal: 'auto',
  tradeFinderShown: 25,           // pagination cap — resets to 25 on filter change
  tradeFinderDismissed: new Set(), // "not interested" keys, leagueId-namespaced; saved on this device (33)
  tradeFinderDismissedLoaded: false, // whether the saved dismissals have been read into the Set yet
  waiverWireShown: 25,   // cross-league waiver scanner pagination — resets on filter/sort
  marketSource: 'composite', // TACO-001 global market toggle: 'composite' | 'ktc' | 'fc' | 'dp' (session-only)

  // Our own composite values, per scoring format (module 74). The fc* names
  // are historical -- this used to hold FantasyCalc's board.
  // Structure: fcRaw[scoringTab] = [{sleeperId, name, position, team, age, value, overallRank, posRank, trend30Day, momentum30d, slot?, round?, season?}, ...]
  //            fcPlayerLookup[scoringTab] = Map<sleeperId, entry>
  //            fcPickLookup[scoringTab] = Map<"YYYY-R-SS", entry>
  //            fcMaxValue[scoringTab] = number — for KTC-scale conversion
  // valueSource tells the rest of the app where this tab's values came from:
  // 'taco' (our engine) or 'ktc' (an uploaded sheet), or null if neither.
  fcRaw: {},
  fcPlayerLookup: {},
  fcPickLookup: {},
  fcMaxValue: {},
  // DynastyProcess values, keyed by sleeper_id. Loaded once per session at
  // app boot (CSV from GitHub, refreshed weekly upstream).
  //   dpLookup[sleeperId] = { value1qb, value2qb, ecr1qb, ecr2qb, ecrPos, ... }
  dpLookup: {},
  // Backend composite ranks/values per format, populated by loadBackendComposite()
  // when a backend is configured. Keyed by scoringTab. Each value is
  //   { generated_at, format, source_status, players: { sleeperId: {...} }, picks: [...] }
  // When unset/empty, the app falls back to client-side FC + DP composite.
  backendComposite: {},

  valueSource: {},       // { '1QB TE+': 'fc' | 'ktc' | 'fc+dp' | 'dp' }
  // League Rankings sort key. Drives the per-position re-sort in
  // renderPowerRankingsPanel. One of: totalValue, startersValue, QB, RB, WR,
  // TE, Picks. Persisted to localStorage so the choice sticks across reloads.
  powerRankingsSort: 'totalValue',
  // true = rank teams on active players + draft capital, false = players only
  // (the contending read: are you ahead on the field, picks aside).
  powerRankingsIncludePicks: true,
  // League Rankings TOOL (leagueTeams view) sort tab. One of: total (players +
  // picks), starters, QB, RB, WR, TE, picks.
  leagueRankSort: 'total',
  // Format Rankings (team subtab + standalone /rankings tool)
  rankingsFilter: 'ALL',       // ALL | QB | RB | WR | TE | PICK
  drawerScoringTab: null,      // format the surface that opened the player drawer was showing; null = let the drawer pick its own
  rankingsRookiesOnly: false,
  standaloneRankingsLeagueIdx: 0,
  // My Assets browse filters + sort
  myAssetsFilter: 'ALL',       // ALL | QB | RB | WR | TE | PICK
  assetsSortKey: 'exposure',   // exposure | total | avg | age
  assetsSearchQuery: '',
  // Portfolio sort state. key = sort dimension, dir = 'desc' | 'asc'.
  portfolioSortKey: 'totalValue',
  portfolioSortDir: 'desc',
  // League list search query (live filter on All Leagues view).
  leagueSearchQuery: '',
  // Team-style chips on All Leagues act as filters: the archetypes selected
  // here (any number; empty = all). A league has exactly one style, so several
  // selected means "any of these".
  overviewArchetypeFilter: [],
  // The Slate's own team-style chips (86): same archetypes, separate selection,
  // so filtering the portfolio never silently narrows the Slate.
  slateArchetypeFilter: [],
  // Player id (or 'lineup') an Action Queue link asked the league page to
  // scroll to and highlight; consumed once by applyLeagueFocus (14).
  leagueFocus: null,
  // This week's lineup per league from Sleeper's weekly matchups, for the
  // Action Queue: { week, leaguesRef, byLeague: { leagueId: starters[] } }.
  // The roster's own `starters` follow the last-edited week, not this one.
  weekLineups: null,
  // Market tool momentum lens (module 56): position filter + 7d/30d window.
  // (Named for the old Risers & Fallers panel these were introduced with.)
  risersFallersFilter: 'ALL',  // ALL | QB | RB | WR | TE
  risersFallersPeriod: '7d',   // 7d | 30d
  // Set at ingestion when redraft/keeper leagues are filtered out, displayed
  // as a small note on All Leagues so users understand why league counts differ.
  excludedLeagueCount: 0,
  excludedLeagueNames: [],
  // Sleeper trending: { [playerId]: { adds: 1234 } } — 24h add counts
  // league-wide on Sleeper. Independent signal from FC value trend; useful
  // for catching hour-scale breakouts before dynasty rankings react.
  sleeperTrending: {},
  // Sleeper dropping: { [playerId]: { drops: 567 } } — 24h drop counts.
  // Complements adds: high adds + high drops = noise (churn); high adds +
  // low drops = real consensus pickup.
  sleeperDropping: {},
  // Rookie ADP cache: aggregated from the user's own dynasty rookie drafts.
  //   rookieAdp[sleeperId] = { avgPick: 12.4, n: 3, drafts: [...] }
  // Populated lazily by computeRookieAdp() on first Rookie Draft tab visit.
  rookieAdp: null,
  rookieAdpLoading: false,
  // Waiver Wire state
  waiverWireFilter: 'ALL',         // ALL | QB | RB | WR | TE
  waiverWireSearchQuery: '',        // user's search text
  waiverWireLeagueFilter: 'all',    // 'all' | league_id
  waiverWireSortKey: 'value', // value | availability | name
  // Pick simulator state: { [leagueId]: { [pickKey]: playerId } }
  // pickKey is `${season}-${round}-${slot||'?'}` to uniquely identify a pick.
  pickSim: {},
  // Per-player per-season stats cache, lazy-loaded by the drawer.
  //   playerStats[`${pid}-${season}`] = { weeks: [...], season: {...}, fetchedAt }
  //   _statsFetches[key] = in-flight Promise (dedupes concurrent requests)
  playerStats: {},
  nflSeasonStats: {},
  _statsFetches: {},
  // News state: items[] populated by fetchNewsFeeds(), byPlayerId map filled
  // by matchNewsToPlayers(). lastFetch + inFlight prevent duplicate fetches.
  newsItems: null,
  newsByPlayerId: {},
  newsLastFetch: 0,
  _newsFetchInFlight: null,
};

/** Classic scripts isolate top-level const per file — export for all modules. */
window.STATE = STATE;

;
/*! ==== 37-util.js ==== */
// Delegates. The local copy was byte-identical to the shared one, and these
// modules concatenate into a single bundle, so an unqualified ordinal() call
// resolved to whichever copy came last -- and only the shared one is tested.
function ordinal(n) {
  return TacoCore.ordinal(n);
}
window.ordinal = ordinal;

function escapeHtml(s) {
  if (s == null) return '';
  return String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
}
window.escapeHtml = escapeHtml;

function formatCompactNumber(n) {
  if (n == null || isNaN(n)) return '-';
  const num = Number(n);
  const abs = Math.abs(num);
  if (abs >= 1_000_000) return (num / 1_000_000).toFixed(2).replace(/\.?0+$/, '') + 'M';
  if (abs >= 10_000) return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
  if (abs >= 1000) return Math.round(num).toLocaleString();
  return Math.round(num).toString();
}
window.formatCompactNumber = formatCompactNumber;

function formatTrend(trend, compact = false) {
  if (!trend || Math.abs(trend) < 50) return '';
  const isUp = trend > 0;
  const magnitude = Math.abs(Math.round(trend)).toLocaleString();
  const cls = isUp ? 'trend-up' : 'trend-down';
  const sign = isUp ? '+' : '−';
  const iconName = isUp ? 'trendUp' : 'trendDown';
  return compact
    ? `<span class="trend ${cls}">${icon(iconName, 11)}${sign}${magnitude}</span>`
    : `<span class="trend ${cls}">${icon(iconName, 12)} ${sign}${magnitude} 30d</span>`;
}
window.formatTrend = formatTrend;

function formatMomentumTrend(m30, m7, compact = false) {
  const m = m30 != null ? m30 : m7;
  if (m == null || Math.abs(m) < 0.25) return '';
  const isUp = m > 0;
  const cls = isUp ? 'trend-up' : 'trend-down';
  const sign = isUp ? '+' : '−';
  const iconName = isUp ? 'trendUp' : 'trendDown';
  const label = m30 != null ? '30d' : '7d';
  const text = `${sign}${Math.abs(m).toFixed(1)}%`;
  return compact
    ? `<span class="trend ${cls}">${icon(iconName, 11)}${text}</span>`
    : `<span class="trend ${cls}">${icon(iconName, 12)} ${text} ${label}</span>`;
}
window.formatMomentumTrend = formatMomentumTrend;

function formatMomentumRankings(m30) {
  if (m30 == null || Math.abs(m30) < 0.25) return '';
  const sign = m30 > 0 ? '+' : '';
  const cls = m30 > 0.5 ? 'mom-up' : m30 < -0.5 ? 'mom-down' : 'mom-flat';
  return `<span class="rankings-momentum ${cls}">${sign}${m30.toFixed(1)}%</span>`;
}
window.formatMomentumRankings = formatMomentumRankings;

function drawerMomentumLabel(m30, m7, m1) {
  if (m30 != null) {
    const sign = m30 > 0 ? '+' : '';
    const cls = m30 > 0.5 ? 'trend-up' : m30 < -0.5 ? 'trend-down' : '';
    return { label: `${sign}${m30.toFixed(1)}%`, cls, caption: '30d momentum' };
  }
  if (m7 != null) {
    const sign = m7 > 0 ? '+' : '';
    const cls = m7 > 0.5 ? 'trend-up' : m7 < -0.5 ? 'trend-down' : '';
    return { label: `${sign}${m7.toFixed(1)}%`, cls, caption: '7d momentum' };
  }
  if (m1 != null) {
    const sign = m1 > 0 ? '+' : '';
    const cls = m1 > 0.5 ? 'trend-up' : m1 < -0.5 ? 'trend-down' : '';
    return { label: `${sign}${m1.toFixed(1)}%`, cls, caption: '1d momentum' };
  }
  return null;
}
window.drawerMomentumLabel = drawerMomentumLabel;

// Pick equivalence label - maps a dynasty value to a human-readable pick tier.
// Returns strings like "≈ E 1st", "≈ L 2nd", or null below the noise floor.
// Thresholds are format-aware: SF inflates QB values so the first-round bar is
// slightly higher than in 1QB.
function pickEquivLabel(value, scoringTab) {
  if (!value || value < 900) return null;
  const isSF = scoringTab && scoringTab.indexOf('SF') >= 0;
  const tiers = isSF
    ? [[7000,'≈ E 1st'],[5000,'≈ M 1st'],[3200,'≈ L 1st'],[2100,'≈ E 2nd'],[1400,'≈ M 2nd'],[900,'≈ L 2nd']]
    : [[6000,'≈ E 1st'],[4000,'≈ M 1st'],[2500,'≈ L 1st'],[1700,'≈ E 2nd'],[1100,'≈ M 2nd'],[700,'≈ L 2nd']];
  for (let i = 0; i < tiers.length; i++) {
    if (value >= tiers[i][0]) return tiers[i][1];
  }
  return null;
}
window.pickEquivLabel = pickEquivLabel;

// Depth weighting for roster-strength math (positional summaries, terciles,
// archetype starter totals). TE gets a fixed 3-deep window at 70%: with one
// starter slot in most leagues, startable TE depth carries real bye-week and
// trade-leverage value that a 1-starter formula misses. Other positions get
// N deep (capped at 3) at 50% - their extra starter slots already absorb
// depth value.
function depthWeighting(pos, starterN) {
  if (pos === 'TE') return { depthN: 3, depthWeight: 0.70 };
  return { depthN: Math.min(starterN, 3), depthWeight: 0.50 };
}
window.depthWeighting = depthWeighting;

// Plain-English gloss for a scoring-format code ("SF TE+", "1QB", etc.), for a
// hover tooltip. The terse code stays on screen -- it's standard vocabulary for
// a dynasty manager -- but a newer reader can hover to learn what it means.
function formatGloss(tab) {
  const code = String(tab || '').trim();
  if (!code) return '';
  const parts = [];
  parts.push(code.indexOf('SF') >= 0 ? 'Superflex - you can start a second QB' : 'Single-QB scoring');
  if (code.indexOf('+') >= 0) parts.push('TE premium - tight ends earn bonus points per catch');
  return parts.join(' · ');
}
window.formatGloss = formatGloss;

function formatAdpAsPick(avgPick, numTeams) {
  if (avgPick == null) return '';
  const overall = Math.round(avgPick);
  const round = Math.ceil(overall / numTeams);
  const slot = overall - (round - 1) * numTeams;
  return `${round}.${String(slot).padStart(2, '0')}`;
}
window.formatAdpAsPick = formatAdpAsPick;

// ============================================================
// Overlay focus management (2026-10-17)
//
// Every overlay in the app already closed on Escape, but none of them moved
// focus IN on open or restored it on close. Opening the player drawer from a
// rankings row with the keyboard left focus on the row behind it, so Tab then
// walked the page underneath -- which is scroll-locked, so you were tabbing to
// things you could not see or reach. #leaguePickerPopover was the one overlay
// that did this properly; this is that behaviour, shared.
//
// A stack, not a single slot: the glossary can open on top of the player
// drawer, and closing it must return focus to the drawer rather than to
// whatever was focused before the drawer.
// ============================================================
const TacoFocus = (() => {
  const stack = [];
  const FOCUSABLE = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled])',
    'select:not([disabled])', 'textarea:not([disabled])', 'summary',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  const focusableIn = (el) => Array.from(el.querySelectorAll(FOCUSABLE))
    // offsetParent is null for display:none; a drawer mid-transition still
    // reports a box, so this is about skipping genuinely hidden controls.
    .filter((n) => n.offsetParent !== null || n === document.activeElement);

  function onKeydown(e) {
    if (e.key !== 'Tab' || !stack.length) return;
    const top = stack[stack.length - 1];
    const items = focusableIn(top.el);
    if (!items.length) { e.preventDefault(); return; }
    const first = items[0];
    const last = items[items.length - 1];
    const active = document.activeElement;
    if (!top.el.contains(active)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && active === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }

  return {
    /** Remember what had focus, move into the overlay, and trap Tab there. */
    capture(el, opts) {
      if (!el) return;
      const prev = document.activeElement;
      if (!stack.length) document.addEventListener('keydown', onKeydown, true);
      stack.push({ el, prev });
      // Prefer an explicit target (usually the close button): landing on the
      // control that gets you back out is the least surprising entry point.
      const want = (opts && opts.focus && el.querySelector(opts.focus)) || focusableIn(el)[0] || el;
      // The overlay animates in; focusing a transitioning element can be
      // ignored, so defer a frame.
      setTimeout(() => { try { want.focus({ preventScroll: true }); } catch (_e) { /* not focusable */ } }, 30);
    },
    /** Hand focus back to whatever opened it. */
    release(el) {
      if (!stack.length) return;
      const i = el ? stack.findIndex((f) => f.el === el) : stack.length - 1;
      if (i === -1) return;
      const [entry] = stack.splice(i, 1);
      if (!stack.length) document.removeEventListener('keydown', onKeydown, true);
      const prev = entry.prev;
      if (prev && document.contains(prev) && prev.offsetParent !== null) {
        try { prev.focus({ preventScroll: true }); } catch (_e) { /* gone */ }
      }
    },
  };
})();
window.TacoFocus = TacoFocus;

/** scrollIntoView that respects prefers-reduced-motion (2026-10-17).
 *
 * The CSS side of reduced motion is fully handled -- app.css kills every
 * animation and transition with !important on *, ::before and ::after -- but
 * a smooth scroll is driven by JS and ignored that, so the one kind of motion
 * most likely to make someone ill was the one that still ran. Same
 * matchMedia check the count-up animation already uses. */
function scrollIntoViewSafely(el, opts) {
  if (!el || typeof el.scrollIntoView !== 'function') return;
  const o = opts || {};
  let reduce = false;
  try {
    reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (_e) { /* no matchMedia: behave as before */ }
  el.scrollIntoView(reduce ? { ...o, behavior: 'auto' } : o);
}
window.scrollIntoViewSafely = scrollIntoViewSafely;

;
/*! ==== 02-value-history-parked-until-hosted.js ==== */
/**
 * PARKED / HISTORICAL — value history snapshot feature.
 * Was extracted during monolith split. Deferred until hosted storage / cloud sync is solid.
 * Do not rely on these functions. They are not wired into the current app.
 * When reviving: move math to shared/, wire through TacoStorage or backend user data.
 *
 * Functions below are intentionally left but unused (audit will flag).
 * This file exists as a marker so the extraction history isn't lost.
 */

function snapshotValuesToHistory() {
  // parked
}

function buildDrawerValueTrendSection() {
  // parked — must return '' (not undefined). The caller interpolates this
  // directly into a template literal; a bare `undefined` return rendered the
  // literal text "undefined" into every player drawer.
  return '';
}

;
/*! ==== 76-news-fetch-parse.js ==== */
// News RSS fetch + player matching — extracted from 03.

const NEWS_PROXIES = [
  (url) => 'https://taco-proxy.owenpodoll.workers.dev/?url=' + encodeURIComponent(url),
  (url) => 'https://corsproxy.io/?url=' + encodeURIComponent(url),
  (url) => 'https://api.allorigins.win/raw?url=' + encodeURIComponent(url),
  (url) => 'https://api.codetabs.com/v1/proxy?quest=' + encodeURIComponent(url),
];

// Reddit removed — Owen's call. Too noisy, too unreliable, CORS issues.
// Keeping the array for code-path simplicity (the news fetcher iterates it
// in parallel with RSS), but empty by default. If we ever want to add curated
// dynasty-specific subs back, this is where they'd go.
const REDDIT_SOURCES = [];

// RSS sources. Routed through taco-proxy first, public proxies as fallback.
// All upstream domains must also be in the taco-proxy Worker's ALLOWED_HOSTS
// allowlist or requests get 403'd by our own Worker.
//
// Removed feeds (do not re-add without verifying they're alive):
// - FantasyPros (feed.php returns 243KB of HTML homepage, not RSS — they
//   broke or removed their public feed and haven't restored it)
// - Bleacher Report (feed?tag_id=10 returns 404 — endpoint moved or killed)
//
// Active feeds — all verified to return parseable RSS at time of writing.
// If any of these die upstream, drop them rather than letting them generate
// 4 failed proxy requests per page load.
const RSS_FEEDS = [
  { url: 'https://www.espn.com/espn/rss/nfl/news', source: 'ESPN' },
  { url: 'https://www.rotoballer.com/feed', source: 'RotoBaller' },
  { url: 'https://profootballtalk.nbcsports.com/feed/', source: 'PFT' },
  { url: 'https://www.cbssports.com/rss/headlines/nfl/', source: 'CBS Sports' },
  { url: 'https://sports.yahoo.com/nfl/rss.xml', source: 'Yahoo NFL' },
  { url: 'https://www.rotowire.com/rss/news.php?sport=NFL', source: 'RotoWire' },
];

const NEWS_TTL_MS = 15 * 60 * 1000;  // 15-minute cache window
const NEWS_MAX_ITEMS = 400;  // hard cap to keep memory + matching cheap

async function fetchNewsFeeds(force = false) {
  const now = Date.now();
  if (!force && STATE.newsLastFetch && (now - STATE.newsLastFetch) < NEWS_TTL_MS && STATE.newsItems?.length) {
    return STATE.newsItems;
  }
  if (STATE._newsFetchInFlight) return STATE._newsFetchInFlight;

  STATE._newsFetchInFlight = (async () => {
    // Primary: our own API aggregates and parses all feeds server-side and
    // edge-caches the result. One first-party fetch — no CORS proxies for
    // ad-blockers or proxy outages to kill. The browser-side proxy chain
    // below survives only as a fallback if the API is unreachable.
    let items = await fetchNewsFromBackend();
    let succeeded = items.length ? 1 : 0;
    let attempted = 1;

    if (!items.length) {
      console.warn('[news] backend feed unavailable - falling back to browser proxy chain');
      const promises = [
        ...REDDIT_SOURCES.map(s => fetchRedditSub(s.sub, s.source, s.limit)),
        ...RSS_FEEDS.map(f => fetchOneFeed(f.url, f.source)),
      ];
      attempted = promises.length;
      succeeded = 0;
      const results = await Promise.allSettled(promises);
      const allSourceNames = [
        ...REDDIT_SOURCES.map(s => s.source),
        ...RSS_FEEDS.map(f => f.source),
      ];
      for (let i = 0; i < results.length; i++) {
        const r = results[i];
        const sourceName = allSourceNames[i];
        if (r.status === 'fulfilled' && Array.isArray(r.value) && r.value.length > 0) {
          items.push(...r.value);
          succeeded++;
          console.log(`[news] ✓ ${sourceName}: ${r.value.length} items`);
        } else {
          const reason = r.status === 'rejected' ? r.reason?.message : 'empty';
          console.warn(`[news] ✗ ${sourceName}: ${reason}`);
        }
      }
    }

    items.sort((a, b) => (b.pubDate || 0) - (a.pubDate || 0));
    const trimmed = items.slice(0, NEWS_MAX_ITEMS);
    matchNewsToPlayers(trimmed);
    STATE.newsItems = trimmed;
    STATE.newsLastFetch = Date.now();
    STATE._newsFetchInFlight = null;
    const matchedCount = Object.keys(STATE.newsByPlayerId || {}).length;
    console.log(`[news] DONE: ${trimmed.length} items, ${succeeded}/${attempted} sources OK, matched to ${matchedCount} players`);
    return trimmed;
  })();
  return STATE._newsFetchInFlight;
}

// One fetch to our API for the whole pre-parsed bundle. Returns [] on any
// failure so the caller can fall back to the legacy proxy chain.
async function fetchNewsFromBackend() {
  try {
    const res = await fetch(`${BACKEND_URL}/api/news`, { headers: { 'Accept': 'application/json' } });
    if (!res.ok) {
      console.warn(`[news] backend /api/news returned ${res.status}`);
      return [];
    }
    const data = await res.json();
    const items = Array.isArray(data?.items) ? data.items : [];
    if (items.length) {
      const srcSummary = Object.entries(data.sources || {}).map(([s, n]) => `${s}:${n}`).join(' ');
      console.log(`[news] ✓ backend: ${items.length} items (${srcSummary})`);
    }
    return items.map(it => ({ ...it, matchedPlayerIds: new Set() }));
  } catch (e) {
    console.warn('[news] backend /api/news threw:', e.message);
    return [];
  }
}

// Reddit JSON fetcher — direct, no proxy. Reddit serves CORS headers natively
// for all public endpoints. Returns posts (not comments) sorted by recency.
async function fetchRedditSub(subreddit, source, limit = 25) {
  // Reddit removed CORS headers from www.reddit.com/r/*/new.json some time
  // around early 2026 — direct browser fetches now fail with "No Access-
  // Control-Allow-Origin header." Route through taco-proxy, which has
  // reddit.com on its upstream allowlist and adds proper CORS headers.
  const directUrl = `https://www.reddit.com/r/${subreddit}/new.json?limit=${limit}&raw_json=1`;
  const url = `${TACO_PROXY}/?url=${encodeURIComponent(directUrl)}`;
  try {
    const res = await fetch(url, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
    });
    if (!res.ok) {
      console.warn(`[news] reddit ${source} returned ${res.status}`);
      return [];
    }
    const data = await res.json();
    const children = data?.data?.children || [];
    const items = [];
    for (const c of children) {
      const post = c?.data;
      if (!post) continue;
      // Skip stickied (mod posts), removed, and pure-image posts
      if (post.stickied) continue;
      if (post.removed_by_category) continue;
      // Title is the main signal — Reddit titles are often news summaries
      const title = post.title?.trim();
      if (!title) continue;
      // Use selftext as summary if present, otherwise leave blank
      const summary = (post.selftext || '').trim().slice(0, 280);
      items.push({
        id: 'reddit:' + post.id,
        title: stripHtml(title),
        link: 'https://www.reddit.com' + (post.permalink || ''),
        pubDate: (post.created_utc || 0) * 1000,
        source,
        summary: stripHtml(summary),
        matchedPlayerIds: new Set(),
      });
    }
    return items;
  } catch (e) {
    console.warn(`[news] reddit ${source} threw:`, e.message);
    return [];
  }
}

// Try each proxy in order until one returns parseable RSS. Logs which proxy
// worked or all failures, so when the user opens devtools they can see why.
async function fetchOneFeed(url, source) {
  // taco-proxy is our own Worker — allowlisted upstreams, edge-cached, no
  // rate limits. Try it first. Public proxies are kept as fallback only.
  const proxyChain = [
    (u) => `${TACO_PROXY}/?url=${encodeURIComponent(u)}`,
    ...NEWS_PROXIES,
  ];
  for (let i = 0; i < proxyChain.length; i++) {
    const proxyUrl = proxyChain[i](url);
    const proxyLabel = i === 0 ? 'taco-proxy' : `proxy${i}`;
    try {
      const res = await fetch(proxyUrl, {
        method: 'GET',
        headers: { 'Accept': 'application/xml, application/rss+xml, text/xml, */*' },
      });
      if (!res.ok) {
        console.warn(`[news] ${source} ${proxyLabel} returned ${res.status}`);
        continue;
      }
      const xmlText = await res.text();
      if (!xmlText || xmlText.length < 100) {
        console.warn(`[news] ${source} ${proxyLabel} returned empty/tiny body (${xmlText?.length || 0}b)`);
        continue;
      }
      const parsed = parseRssToItems(xmlText, source);
      if (parsed.length > 0) return parsed;
      // When parse returns 0, log the response signature so we can diagnose
      // format changes. Most common cases: HTML page (bot wall, redirect),
      // JSON instead of XML, or the feed structure changed.
      const preview = xmlText.slice(0, 200).replace(/\s+/g, ' ');
      console.warn(`[news] ${source} ${proxyLabel} returned ${xmlText.length}b but parsed 0 items. First 200 chars: ${preview}`);
    } catch (_e) {
      console.warn(`[news] ${source} ${proxyLabel} threw:`, _e.message);
    }
  }
  return [];
}

// Parse an RSS XML string into our item shape. Supports both RSS 2.0
// (<item>) and Atom (<entry>). If XML parsing produces a parsererror (common
// with feeds that have unescaped & or other malformed bits), retries with
// the HTML parser, which is far more permissive.
function parseRssToItems(xmlText, source) {
  let doc;
  try {
    doc = new DOMParser().parseFromString(xmlText, 'application/xml');
    // Detect XML parse errors — DOMParser inserts a <parsererror> node rather
    // than throwing for malformed input. If found, retry as HTML.
    if (doc.querySelector('parsererror')) {
      console.warn(`[news] ${source} XML parse failed, retrying as HTML`);
      doc = new DOMParser().parseFromString(xmlText, 'text/html');
    }
  } catch (_e) {
    try {
      doc = new DOMParser().parseFromString(xmlText, 'text/html');
    } catch (_e2) {
      return [];
    }
  }
  if (!doc) return [];

  const items = [];
  // RSS items
  const rssItems = doc.querySelectorAll('item');
  for (const node of rssItems) {
    const title = node.querySelector('title')?.textContent?.trim();
    if (!title) continue;
    const link = node.querySelector('link')?.textContent?.trim() || '';
    const pubText = node.querySelector('pubDate')?.textContent?.trim();
    const pubDate = pubText ? Date.parse(pubText) : null;
    const description = node.querySelector('description')?.textContent?.trim() || '';
    items.push({
      id: link || (source + ':' + title),
      title: stripHtml(title),
      link,
      pubDate: pubDate || Date.now(),
      source,
      summary: stripHtml(description).slice(0, 280),
      matchedPlayerIds: new Set(),
    });
  }
  // Atom entries
  const atomEntries = doc.querySelectorAll('entry');
  for (const node of atomEntries) {
    const title = node.querySelector('title')?.textContent?.trim();
    if (!title) continue;
    const linkEl = node.querySelector('link');
    const link = linkEl?.getAttribute('href') || linkEl?.textContent?.trim() || '';
    const pubText = node.querySelector('updated')?.textContent || node.querySelector('published')?.textContent;
    const pubDate = pubText ? Date.parse(pubText) : null;
    const summary = node.querySelector('summary')?.textContent?.trim() || node.querySelector('content')?.textContent?.trim() || '';
    items.push({
      id: link || (source + ':' + title),
      title: stripHtml(title),
      link,
      pubDate: pubDate || Date.now(),
      source,
      summary: stripHtml(summary).slice(0, 280),
      matchedPlayerIds: new Set(),
    });
  }
  return items;
}

function stripHtml(s) {
  if (!s) return '';
  return s.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&')
          .replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>')
          .replace(/\s+/g, ' ').trim();
}

// Normalize a string for matching: lowercase, strip punctuation, collapse
// whitespace. "A.J. Brown" → "aj brown", "D'Andre Swift" → "dandre swift".
function normalizeForMatch(s) {
  if (!s) return '';
  return s.toLowerCase()
    .replace(/[.\u2018\u2019'`]/g, '')   // periods, smart quotes, apostrophes
    .replace(/[-_]/g, ' ')                // hyphens → spaces
    .replace(/\s+/g, ' ')
    .trim();
}

// Common last names that need first-name disambiguation (otherwise we'd match
// every "Smith" article to dozens of players). For these, full name required.
const COMMON_LAST_NAMES = new Set([
  'smith', 'brown', 'williams', 'johnson', 'jones', 'davis', 'miller',
  'wilson', 'moore', 'taylor', 'thomas', 'jackson', 'white', 'harris',
  'martin', 'thompson', 'garcia', 'martinez', 'robinson', 'clark', 'lewis',
  'walker', 'hall', 'allen', 'young', 'king', 'wright', 'scott', 'green',
  'baker', 'adams', 'nelson', 'hill', 'campbell', 'mitchell', 'carter',
  'roberts', 'gonzalez', 'phillips', 'evans', 'edwards', 'collins',
  'stewart', 'morris', 'rogers', 'reed', 'cook', 'morgan', 'bell',
  'murphy', 'bailey', 'rivera', 'cooper', 'richardson', 'cox', 'howard',
  'ward', 'torres', 'peterson', 'gray', 'ramirez', 'james', 'watson',
  'kelly', 'price', 'bennett', 'wood', 'barnes', 'ross', 'henderson',
  'coleman', 'jenkins', 'perry', 'powell', 'long', 'patterson', 'hughes',
  'flowers', 'sanders', 'foster', 'butler', 'simmons', 'gordon',
  'reynolds', 'fisher', 'ellis', 'palmer',
  // Phase: news false-positive expansion. These are real common dynasty names
  // that produced noise on the rotted-back build:
  'henry', 'love', 'hunt', 'mason', 'wells', 'higgins', 'andrews', 'davis',
  'pittman', 'hopkins', 'ford', 'pierce', 'thornton', 'tucker', 'graham',
  'cooks', 'metcalf', 'godwin', 'parker', 'fields', 'rice', 'ridder',
  'smith-schuster', 'harrison', 'mims', 'davis', 'meyers', 'olave',
]);

// Tag each news item with matched player IDs by string-searching the title +
// summary. Two-pass match strategy:
//   1. Try last-name-only for distinctive names (most NFL coverage uses last
//      names: "Mahomes throws 3 TDs", not "Patrick Mahomes throws 3 TDs")
//   2. Fall back to full-name match for common last names that need first
//      name disambiguation
//   3. Even with last-name-only, if the team abbreviation or first name
//      appears nearby, that's strong corroboration. If NEITHER does, the
//      match is suspicious — reject it. This eliminates "Brown" matching
//      a generic Browns recap, "Hill" matching off-topic articles, etc.
// Punctuation-tolerant on both sides (A.J. Brown matches AJ Brown).
function matchNewsToPlayers(items) {
  if (!STATE.playersDB) {
    console.warn('[news] no playersDB, skipping match');
    return;
  }

  const idx = [];
  let indexed = 0;
  for (const [pid, p] of Object.entries(STATE.playersDB)) {
    if (!p) continue;
    const pos = TacoCore.primaryFantasyPosition(p, undefined);
    if (!['QB', 'RB', 'WR', 'TE'].includes(pos)) continue;
    const status = p.status || '';
    if (status === 'Retired' || status === 'Practice Squad') continue;

    const firstRaw = (p.first_name || '').trim();
    const lastRaw = (p.last_name || '').trim();
    const fullRaw = (p.full_name || `${firstRaw} ${lastRaw}`).trim();
    if (!fullRaw) continue;

    const fullNorm = normalizeForMatch(fullRaw);
    const lastNorm = normalizeForMatch(lastRaw);
    const firstNorm = normalizeForMatch(firstRaw);
    const teamNorm = (p.team || '').toLowerCase();

    if (fullNorm.length < 5) continue;

    const useLastNameOnly = lastNorm.length >= 4 && !COMMON_LAST_NAMES.has(lastNorm);

    idx.push({
      pid,
      fullNorm,
      lastNorm,
      firstNorm,
      teamNorm,
      useLastNameOnly,
    });
    indexed++;
  }
  console.log(`[news] match index: ${indexed} active fantasy players`);

  STATE.newsByPlayerId = {};
  let totalMatches = 0;
  let rejectedNoContext = 0;

  for (const item of items) {
    const haystack = normalizeForMatch(item.title + ' ' + item.summary);
    for (const entry of idx) {
      let hit = false;

      if (entry.useLastNameOnly) {
        const re = new RegExp(`(^|[^a-z0-9])${escapeRegex(entry.lastNorm)}([^a-z0-9]|$)`);
        if (re.test(haystack)) hit = true;
      } else {
        if (entry.fullNorm.length >= 6) {
          const re = new RegExp(`(^|[^a-z0-9])${escapeRegex(entry.fullNorm)}([^a-z0-9]|$)`);
          if (re.test(haystack)) hit = true;
        }
      }

      // Corroboration for LAST-NAME-ONLY matches: the team abbreviation or the
      // first name must also appear. Without one of those the match is too
      // weakly grounded to keep.
      //
      // This used to require "&& entry.teamNorm && entry.firstNorm" before it
      // would check anything, so a player with NO team skipped the test
      // entirely and their bare surname matched any headline containing that
      // word. Teamless players -- retired, inactive, unsigned -- are precisely
      // the ones with the least claim on today's news, and they were getting
      // the loosest rule.
      //
      // Surnames that are ordinary English words did the damage. Measured on
      // the live feed, 2026-09-03:
      //
      //   "2026 NFL betting guide: Odds, tips and best bets"  -> Jahvid Best
      //   "SEC sues LSU, Lane Kiffin in federal court"        -> Jerome Lane
      //   "Cards WR Wilson gets 3-year extension"             -> Luke Deal
      //   "Travis Kelce buys $5.35M home"                     -> Ross Travis
      //
      // 386 item-player pairs across 164 items, of which 284 -- 74% -- were
      // this. Requiring corroboration unconditionally drops all 284 and costs
      // ZERO matches for any player who has a team; the only rostered player
      // affected was another teamless surname collision.
      if (hit && entry.useLastNameOnly) {
        const teamMatches = entry.teamNorm.length >= 2
          && new RegExp(`(^|[^a-z0-9])${escapeRegex(entry.teamNorm)}([^a-z0-9]|$)`).test(haystack);
        const firstMatches = entry.firstNorm.length >= 3
          && haystack.includes(entry.firstNorm);
        if (!teamMatches && !firstMatches) {
          hit = false;
          rejectedNoContext++;
        }
      }

      if (hit) {
        item.matchedPlayerIds.add(entry.pid);
        if (!STATE.newsByPlayerId[entry.pid]) STATE.newsByPlayerId[entry.pid] = [];
        STATE.newsByPlayerId[entry.pid].push(item);
        totalMatches++;
      }
    }
  }
  console.log(`[news] match complete: ${totalMatches} item-player pairs across ${Object.keys(STATE.newsByPlayerId).length} players (${rejectedNoContext} rejected by team-context filter)`);
}
window.fetchNewsFeeds = fetchNewsFeeds;

;
/*! ==== 03-rss-news-feed.js ==== */
// Pulls fantasy-relevant news from public RSS feeds via a CORS proxy
// (corsproxy.io is well-maintained and free). Items are tagged with player IDs
// by string-matching against playersDB names, so each player's drawer can
// surface news mentioning them, and a global news ticker can sit on the league
// overview.
//
// Source feeds (curated for fantasy-football relevance):
//   - NFL.com news
//   - ESPN NFL headlines
//   - RotoBaller NFL feed (player-focused fantasy news)
//   - FantasyPros NFL feed
// Each feed gets fetched, parsed, normalized into { id, title, link, pubDate,
// source, summary, matchedPlayerIds: Set<pid> }.
//
// Cache: STATE.newsItems (full list, sorted by recency)
//        STATE.newsByPlayerId[pid] = [items mentioning this player]
//        STATE.newsLastFetch = timestamp; we re-fetch at most every 15 min
// News sources, in order of attempt. Each source has a fetcher function that
// returns normalized items, so we don't have to lock everything into RSS.
//
// Reddit JSON endpoints are FIRST because they:
//   - Don't need a CORS proxy (Reddit sends CORS headers)
//   - Are highly fantasy-relevant (especially r/fantasyfootball)
//   - Return clean JSON, not RSS XML (more parser-resistant)
//   - Include posts that summarize player news from beat reporters
//
// RSS feeds via proxies follow as fallback. Our taco-proxy Worker handles
// these reliably with Cloudflare edge caching. Public CORS proxies kept as
// last-resort fallbacks if the Worker is ever down — they're flaky but
// occasionally working.
// Note: TACO_PROXY const is defined later in the file (line ~9921). It's
// referenced here as a string literal to avoid forward-reference issues.

// Escape regex special chars in a string so it can be used inside a RegExp literal.
function escapeRegex(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getNewsForPlayer(playerId) {
  return STATE.newsByPlayerId?.[playerId] || [];
}

// Format relative time (used in news rendering).
function formatNewsTime(ts) {
  if (!ts) return '';
  const diff = Date.now() - ts;
  const min = diff / 60000;
  if (min < 60) return `${Math.max(1, Math.floor(min))}m ago`;
  const hr = min / 60;
  if (hr < 24) return `${Math.floor(hr)}h ago`;
  const days = hr / 24;
  if (days < 30) return `${Math.floor(days)}d ago`;
  return new Date(ts).toLocaleDateString();
}

;
/*! ==== 04-ui-helpers.js ==== */
function setStatus(text, live = false) {
  document.getElementById('statusText').textContent = text;
  document.getElementById('statusDot').classList.toggle('live', live);
}
function setLoader(text) { document.getElementById('loaderText').textContent = text; }

// Inline "Key" — a small, collapsible legend that explains a page's own jargon
// right where it's used, instead of sending people to the global glossary.
// items: [{ term, def, cls? }] where cls draws a colour swatch (e.g. a heat
// state). Native <details> so it needs no JS and no CSP exception.
function renderKey(items, opts) {
  opts = opts || {};
  const rows = (items || []).map(function (it) {
    const swatch = it.cls ? '<span class="page-key-swatch ' + it.cls + '"></span>' : '';
    return '<div class="page-key-row">' + swatch +
      '<span class="page-key-term">' + escapeHtml(it.term) + '</span>' +
      '<span class="page-key-def">' + escapeHtml(it.def) + '</span></div>';
  }).join('');
  return '<details class="page-key"' + (opts.open ? ' open' : '') + '>' +
    '<summary class="page-key-summary">' + escapeHtml(opts.title || 'Key - what these mean') + '</summary>' +
    '<div class="page-key-body">' + rows + '</div></details>';
}
window.renderKey = renderKey;

// Device-local rank history — records this league's value rank for the current
// NFL week and returns the change vs the most recent PRIOR week, so a rank trend
// accrues over the season without a backend. Per-device by nature; cloud-synced
// history (Worker + D1) is the eventual upgrade. Returns { delta } where a
// positive delta means the team climbed (lower rank number), or null if there's
// no earlier week to compare yet.
function recordRankTrend(leagueId, season, week, valueRank) {
  if (!leagueId || !week || !valueRank || typeof TacoStorage === 'undefined') return null;
  const hist = TacoStorage.getNamespaced('rankhist', leagueId, {}) || {};
  hist[season + '-' + week] = valueRank;
  TacoStorage.setNamespaced('rankhist', leagueId, hist);
  let priorWeek = null;
  let priorRank = null;
  Object.keys(hist).forEach((k) => {
    const parts = k.split('-');
    const s = parts[0];
    const w = Number(parts[1]);
    if (String(s) === String(season) && w < week && (priorWeek == null || w > priorWeek)) {
      priorWeek = w;
      priorRank = hist[k];
    }
  });
  if (priorRank == null) return null;
  return { delta: priorRank - valueRank, priorWeek, priorRank };
}
window.recordRankTrend = recordRankTrend;
function setPageMode(mode) {
  document.body.classList.remove('page-landing', 'page-setup', 'page-app');
  if (mode) document.body.classList.add('page-' + mode);
  // The masthead follows the page mode everywhere it changes. showLoading set
  // page-app without it, so a /u/<name> boot kept "Enter the Office" in the
  // header of the app itself.
  if (typeof setSiteChromeMode === 'function') setSiteChromeMode(mode === 'app' ? 'app' : 'marketing');
}
function showLoading() {
  document.documentElement.classList.remove('route-connect');
  setPageMode('app');
  document.getElementById('landingView').style.display = 'none';
  document.getElementById('setupView').classList.remove('is-visible');
  document.getElementById('loadingView').classList.add('active');
  document.getElementById('appShell').classList.remove('active');
  if (typeof window.setFetchBtnLoading === 'function') window.setFetchBtnLoading(true);
}
function showApp() {
  document.documentElement.classList.remove('route-connect');
  setPageMode('app');
  document.getElementById('landingView').style.display = 'none';
  document.getElementById('setupView').classList.remove('is-visible');
  document.getElementById('loadingView').classList.remove('active');
  document.getElementById('appShell').classList.add('active');
  if (window.TacoAuth) TacoAuth.initAuth();
  if (typeof setSiteChromeMode === 'function') setSiteChromeMode('app');
}
function showError(msg) {
  const slot = document.getElementById('errorSlot');
  // Translate technical errors into something a user can act on. Falls back
  // to the raw message if no pattern matches.
  let friendly = msg;
  let hint = '';
  const userNotFoundMatch = msg.match(/Sleeper user not found: (.+)/i);
  if (userNotFoundMatch) {
    const attempted = userNotFoundMatch[1];
    friendly = `No Sleeper account matches '${attempted}'.`;
    // Launch day, 2026-09-12: 6 of 50 connect attempts 404'd, and one person
    // tried "Pitts & Giggles 1" three times before giving up. The hint already
    // said "not your team name" and they typed a team name anyway, because
    // knowing what it ISN'T does not tell you where to find what it IS.
    //
    // So this names the place. It also leads with the answer rather than the
    // diagnosis: a first draft opened with "that looks like a team name", which
    // tells someone they got it wrong before it tells them anything useful, and
    // nobody reads past being told they got it wrong.
    hint = 'Your Sleeper username is in the app: tap your avatar, then Account. It’s the @name at the top, and it never has spaces. Team names and emails won’t work here.';
  } else if (/No leagues found/i.test(msg)) {
    const seasonMatch = msg.match(/in (\d{4})/);
    const season = seasonMatch ? seasonMatch[1] : 'this season';
    friendly = `No leagues found in ${season}.`;
    hint = "Try switching the season dropdown. Sleeper doesn't show prior-year leagues by default.";
  } else if (/Sleeper API/i.test(msg)) {
    friendly = "Sleeper isn't responding right now.";
    hint = "This is usually transient - wait a minute and try again. Sleeper may be deploying or rate-limiting.";
  } else if (/composite|\[values\]/i.test(msg)) {
    friendly = "Values are taking a moment to load.";
    hint = "Refresh the page to try again.";
  } else if (/network|fetch|Failed to fetch/i.test(msg)) {
    friendly = "Network error.";
    hint = "Check your connection and try again. If you're on a corporate network, public APIs may be blocked.";
  }
  slot.innerHTML = `
    <div class="error" role="alert">
      <div class="error-title">${escapeHtml(friendly)}</div>
      ${hint ? `<div class="error-hint">${escapeHtml(hint)}</div>` : ''}
    </div>
  `;
  // On a phone the slot sits below the Load button, just under the fold: a
  // typo'd username looked like a button that did nothing (launch QA,
  // 2026-09-27). Bring the message into view when it is not already.
  const r = slot.getBoundingClientRect();
  if (r.top < 0 || r.bottom > window.innerHeight) scrollIntoViewSafely(slot, { behavior: 'smooth', block: 'center' });
}
function clearError() { document.getElementById('errorSlot').innerHTML = ''; }

// Single source of truth for which .nav-tab / .mobile-nav-tab element gets
// marked .active for a given view -- was computed independently (identical
// formula) in showView() AND syncToolsSidebar(), two places to keep in sync
// by hand. TACO overhaul Phase 1b. Sidebar-specific and league-subtab active
// states stay in syncToolsSidebar() -- those aren't duplicated anywhere else.
function syncNavActiveState(viewName) {
  const leagueScopedViews = ['team'];
  const isActiveFor = (tabView) => tabView === viewName || (tabView === 'team' && leagueScopedViews.includes(viewName));
  document.querySelectorAll('.nav-tab[data-view]').forEach((t) => {
    t.classList.toggle('active', isActiveFor(t.dataset.view));
  });
  // Mobile tabs are sections now: light the one that CONTAINS the view, or a
  // phone on Who You Need would show no tab lit at all.
  const group = window.TacoRoutes?.groupForView ? window.TacoRoutes.groupForView(viewName) : null;
  document.querySelectorAll('.mobile-nav-tab[data-view]').forEach((t) => {
    t.classList.toggle('active', group ? t.dataset.navGroup === group.key : isActiveFor(t.dataset.view));
  });
}
window.syncNavActiveState = syncNavActiveState;

async function showView(name) {
  const viewEl = document.getElementById(name + 'View');
  if (!viewEl) {
    console.error('[showView] unknown view:', name);
    return;
  }
  showApp();
  // Picks the first league when none is selected; stops only if none can open.
  if (name === 'team' && STATE.leagues.length > 0 && !hasSelectedLeague() && !requireLeagueSelection()) {
    return;
  }
  if (window.TacoAuth && TacoAuth.requiresAccount(name)) {
    await TacoAuth.ensureSession();
  }
  if (name === 'picks') {
    STATE.myAssetsFilter = 'PICK';
    name = 'myAssets';
  }
  // Trade History is its own standalone view under Trades now (Owen: it's not
  // part of Command Center and shouldn't act like it), so it falls through to
  // the normal view flow and renders into #tradeHistoryContent below.
  syncNavActiveState(name);
  if (typeof syncGroupSubNav === 'function') syncGroupSubNav(name);
  if (typeof renderToolBar === 'function') renderToolBar();
  if (typeof syncToolBarActive === 'function') syncToolBarActive(name);
  const wasAlreadyActive = viewEl.classList.contains('active');
  document.querySelectorAll('.view').forEach(v => v.classList.remove('active'));
  viewEl.classList.add('active');

  // Go to the top of the new view.
  //
  // Without this, switching views keeps the old scroll position. On desktop
  // that is a small annoyance; on a phone it reads as the app being broken --
  // the portfolio is thirty league cards tall, so tapping a bottom tab while
  // scrolled down swaps in a much shorter view and leaves the reader parked
  // below its end, looking at nothing. The tab highlights, the URL changes,
  // and the screen appears not to react. Reported from a real phone
  // 2026-09-13 as "nothing happens when you click the buttons".
  //
  // Only on an actual change of view: re-rendering the current one (a value
  // refresh, a filter) must not yank someone back to the top mid-read.
  if (!wasAlreadyActive) {
    try {
      window.scrollTo({ top: 0, behavior: 'auto' });
    } catch (_e) {
      window.scrollTo(0, 0);
    }
  }
  // Initialize on first visit
  if (name === 'leagueTeams') {
    if (!STATE.leagueTeamsInitialized) {
      initLeagueView();
      STATE.leagueTeamsInitialized = true;
    } else {
      // Same class of bug as Portfolio Overview above -- re-render on every
      // return visit so a background value rebuild isn't left showing stale
      // team totals here while every other view has already refreshed.
      renderLeagueView();
    }
  }
  if (name === 'leagueRosters') {
    if (!STATE.leagueRostersInitialized) {
      initLeagueRostersView();
      STATE.leagueRostersInitialized = true;
    } else {
      renderLeagueRostersView();
    }
  }
  if (name === 'trade') {
    // returnTradeCalcHome() used to run here because the calculator's DOM was
    // physically MOVED into a league page's trade tab and left there, which
    // rendered /tools/trade-calculator empty afterwards. Nothing lifts it any
    // more -- the trade tab inside League Overview is gone -- so the mover,
    // the mover's undo, and the whole module they lived in are gone too
    // (2026-10-18).
    if (!STATE.tradeInitialized) {
      initTradeCalculator();
      STATE.tradeInitialized = true;
    } else {
      applyTradePreload();
    }
  }
  if (name === 'rankings') initStandaloneRankings();
  if (name === 'myAssets') {
    if (window.TacoAuth && !TacoAuth.hasFreeAccount()) {
      const c = document.getElementById('myAssetsContent');
      if (c) c.innerHTML = TacoAuth.gateHtml('myAssets');
    } else {
      renderMyAssetsView();
    }
  }
  if (name === 'waiverWire') {
    if (window.TacoAuth && !TacoAuth.hasFreeAccount()) {
      const c = document.getElementById('waiverWireContent');
      if (c) c.innerHTML = TacoAuth.gateHtml('waiverWire');
    } else {
      renderWaiverWireView();
    }
  }
  if (name === 'tradeFinder') {
    if (window.TacoAuth && !TacoAuth.hasFreeAccount()) {
      const c = document.getElementById('tradeFinderContent');
      if (c) c.innerHTML = TacoAuth.gateHtml('tradeFinder');
    } else {
      renderTradeFinderView();
    }
  }
  if (name === 'marketRadar') renderMarketRadarView();
  if (name === 'advancedStats' && typeof renderAdvancedStatsView === 'function') renderAdvancedStatsView();
  if (name === 'investigator' && typeof renderInvestigatorView === 'function') renderInvestigatorView();
  if (name === 'dossier' && typeof renderDossierView === 'function') renderDossierView();
  if (name === 'leagueScout' && typeof renderLeagueScoutView === 'function') renderLeagueScoutView();
  if (name === 'commish' && typeof renderCommishView === 'function') renderCommishView();
  if (name === 'scoreboard') renderScoreboardView();
  if (name === 'rooting') renderRootingView();
  if (name === 'injuries') renderInjuryReportView();
  if (name === 'lineups' && typeof renderLineupSweepView === 'function') renderLineupSweepView();
  // Standalone Trade History view (its own identity under Trades). Render into
  // the page container explicitly so it never lands in the team-detail subtab.
  if (name === 'tradeHistory' && typeof renderTradeHistoryView === 'function') {
    renderTradeHistoryView(document.getElementById('tradeHistoryContent'));
  }
  if (name === 'drafts') renderDraftsView();
  // Was never re-rendered on repeat navigation -- showView only toggled the
  // .active CSS class, so returning to Portfolio Overview after a background
  // value rebuild (runBackgroundHydration) kept showing the pre-rebuild
  // snapshot next to freshly-rendered numbers on every other view for the
  // same league (e.g. "Team Value" disagreeing with Team Detail's header).
  if (name === 'overview' && typeof renderOverview === 'function') renderOverview();
  if (name === 'trade') {
    if (window.TacoAuth && !TacoAuth.hasFreeAccount()) {
      const tv = document.getElementById('tradeView');
      if (tv) tv.innerHTML = TacoAuth.gateHtml('trade');
    }
  }
  // League view — currentTeamIdx is guaranteed set by the early guard above.
  if (name === 'team') renderTeamDetail();
  // Render the league-context bar (breadcrumb-style) on the global views that
  // are now reached only via team detail subtabs, so users keep their bearings.
  renderLeagueContextBar(name);
  // Update the dynamic "League" tab label — show the current league name when
  // viewing the team detail, plain "League" otherwise.
  updateLeagueNavTab();
  syncUrlToView(name);
  syncToolsSidebar(name);
  updatePageBreadcrumb(name);
  // Re-dock/float the live draft room immediately on every navigation (not
  // just on the next 8s poll) -- leaving the Drafts page should un-dock it
  // back to floating (desktop) or hidden (mobile) right away, not laggily.
  if (typeof renderLiveDraftRoom === 'function') renderLiveDraftRoom();
}

// Render the breadcrumb bar at the top of league-scoped global views.
// Shows the current league name and a "← Back to league" link, plus quick
// pivots to other league-scoped views so the user isn't trapped in one.
//
// Only shown when the user explicitly entered from a league context
// (e.g. clicked "Trade History →" inside team detail). When they hit the
// top-level Trade Calc nav directly, the context bar stays hidden — they're
// using the calculator as a global tool, not a league-scoped pivot.
function renderLeagueContextBar(viewName) {
  const barId = {
    trade:        'tradeContextBar',
    tradeHistory: 'tradeHistoryContextBar',
  }[viewName];
  const bar = document.getElementById(barId);
  if (!bar) return;

  // Always clear first — switching views shouldn't leave stale breadcrumbs.
  bar.innerHTML = '';

  // Only show when the user came in via a league context jump.
  if (!STATE.fromLeagueContext) return;

  const lg = STATE.leagues[STATE.currentTeamIdx];
  if (!lg) return;
  const subviewLabels = {
    trade:        'Trade Calculator',
    tradeHistory: 'Trade History',
  };
  const currentLabel = subviewLabels[viewName];
  if (!currentLabel) return;

  // Quick pivots for the OTHER subviews — clicking them stays in the league context.
  const pivots = [
    { key: 'team',         label: 'Roster',         pivot: 'team' },
    { key: 'trade',        label: 'Trade Calc',     pivot: 'trade' },
    { key: 'tradeHistory', label: 'Trade History',  pivot: 'tradeHistory' },
  ];

  bar.innerHTML = `
    <div class="lcb-bar" data-lcb-league="${escapeHtml(lg.league_id)}">
    <div class="lcb-left">
      <span class="lcb-back" data-lcb-back data-tooltip="Back to ${escapeHtml(lg.name)}" aria-label="Back to ${escapeHtml(lg.name)}">←</span>
      <span class="lcb-league">${escapeHtml(lg.name)}</span>
      <span class="lcb-sep">›</span>
      <span class="lcb-current">${currentLabel}</span>
    </div>
    <div class="lcb-pivots">
      ${pivots.filter(p => p.key !== viewName).map(p => `
        <button class="lcb-pivot" data-lcb-pivot="${p.pivot}">${p.label}</button>
      `).join('')}
    </div>
  `;
}

/** Active app view id without the "View" suffix (e.g. overview, rankings, team). */
function getActiveView() {
  const active = document.querySelector('#appShell .view.active');
  if (!active || !active.id) return null;
  return active.id.replace(/View$/, '');
}

/**
 * Shared filter pill row. items: { key, label, count?, disabled?, tooltip?, onClick? }.
 * onClick overrides handlerName for one-off pills (e.g. rookies toggle).
 */
function renderFilterPills({ items, activeKey, handlerName, pillClass = 'th-pill', countClass = 'th-pill-count' }) {
  return items.map((item) => {
    const active = activeKey === item.key ? ' active' : '';
    const disabled = item.disabled ? ' disabled' : '';
    const tooltip = item.tooltip ? ` data-tooltip="${escapeHtml(item.tooltip)}"` : '';
    const click = item.disabled
      ? ''
      : item.onClick
        ? ` data-taco-pill-fn="${item.onClick.replace(/\(\)$/, '')}"`
        : ` data-taco-pill="${handlerName}|${escapeHtml(item.key)}"`;
    const countHtml = item.count != null
      ? ` <span class="${countClass}">${item.count}</span>`
      : '';
    return `<div class="${pillClass}${active}${disabled}"${tooltip}${click}>${escapeHtml(item.label)}${countHtml}</div>`;
  }).join('');
}

function renderSortSelect({ id, label, value, handlerName, options }) {
  const opts = (options || []).map((o) => `
    <option value="${escapeHtml(o.value)}" ${value === o.value ? 'selected' : ''}>${escapeHtml(o.label)}</option>
  `).join('');
  return `
    <div class="ma-sort-control">
      <label class="overview-sort-label" for="${escapeHtml(id)}">${escapeHtml(label)}</label>
      <select id="${escapeHtml(id)}" class="overview-select" data-taco-sort="${handlerName}">${opts}</select>
    </div>
  `;
}

const PORTFOLIO_SORT_OPTIONS = [
  { value: 'totalValue', label: 'Total team value' },
  { value: 'startersValue', label: 'Starter lineup value' },
  { value: 'avgValue', label: 'Avg value' },
  { value: 'avgAge', label: 'Average age' },
  { value: 'picksValue', label: 'Draft picks value' },
  { value: 'archetype', label: 'Team style' },
  { value: 'name', label: 'League name (A→Z)' },
  { value: 'leagueRank', label: 'Team value rank' },
  { value: 'starterRank', label: 'Starter lineup rank' },
];

function renderPortfolioSortControls() {
  const mount = document.getElementById('portfolioSortMount');
  if (!mount) return;
  const opts = PORTFOLIO_SORT_OPTIONS.map((o) => `
    <option value="${escapeHtml(o.value)}" ${STATE.portfolioSortKey === o.value ? 'selected' : ''}>${escapeHtml(o.label)}</option>
  `).join('');
  const isDesc = STATE.portfolioSortDir === 'desc';
  const dirLabel = typeof portfolioSortDirLabel === 'function'
    ? portfolioSortDirLabel(STATE.portfolioSortKey, STATE.portfolioSortDir)
    : (isDesc ? 'High to low' : 'Low to high');
  mount.innerHTML = `
    <label class="overview-sort-label" for="portfolioSortKey">Sort by</label>
    <div class="overview-sort-picker">
      <select id="portfolioSortKey" class="overview-select" data-taco-sort="setPortfolioSort">${opts}</select>
    </div>
    <button id="portfolioSortDir" class="overview-sort-dir" data-portfolio-sort-dir data-tooltip="Toggle sort direction" aria-label="Toggle sort direction">
      <span id="portfolioSortDirIcon">${isDesc ? '↓' : '↑'}</span>
      <span id="portfolioSortDirLabel">${escapeHtml(dirLabel)}</span>
    </button>
  `;
}

function ensurePortfolioSortControls() {
  if (!document.getElementById('portfolioSortKey')) {
    renderPortfolioSortControls();
  } else {
    syncPortfolioSortUI();
  }
}

function syncPortfolioSortUI() {
  const selectEl = document.getElementById('portfolioSortKey');
  if (selectEl) selectEl.value = STATE.portfolioSortKey;
  const dirIcon = document.getElementById('portfolioSortDirIcon');
  const dirLabel = document.getElementById('portfolioSortDirLabel');
  if (dirIcon && dirLabel && typeof portfolioSortDirLabel === 'function') {
    const isDesc = STATE.portfolioSortDir === 'desc';
    dirIcon.textContent = isDesc ? '↓' : '↑';
    dirLabel.textContent = portfolioSortDirLabel(STATE.portfolioSortKey, STATE.portfolioSortDir);
  }
}
window.PORTFOLIO_SORT_OPTIONS = PORTFOLIO_SORT_OPTIONS;
window.renderPortfolioSortControls = renderPortfolioSortControls;
window.ensurePortfolioSortControls = ensurePortfolioSortControls;
window.syncPortfolioSortUI = syncPortfolioSortUI;

window.renderFilterPills = renderFilterPills;
window.renderSortSelect = renderSortSelect;

/** Re-render rankings pills/table in standalone tool or team-detail subtab. */
function rerenderRankingsPanel() {
  if (getActiveView() === 'rankings') {
    renderStandaloneRankings();
    return;
  }
  renderTeamDetail();
}

function rerenderOverview() {
  if (getActiveView() === 'overview') renderOverview();
}

function rerenderMyAssets() {
  if (getActiveView() !== 'myAssets') return;
  const container = document.getElementById('myAssetsContent');
  if (container?.dataset.initialized) renderMyAssetsResults();
  else renderMyAssetsView();
}

function rerenderWaiverWire() {
  if (getActiveView() !== 'waiverWire') return;
  renderWaiverWireResults();
}

function rerenderTradeHistory() {
  const container = getTradeHistoryContainer();
  if (container) renderTradeHistoryView(container);
}

window.getActiveView = getActiveView;
window.rerenderRankingsPanel = rerenderRankingsPanel;
window.rerenderOverview = rerenderOverview;
window.rerenderMyAssets = rerenderMyAssets;
window.rerenderWaiverWire = rerenderWaiverWire;
window.rerenderTradeHistory = rerenderTradeHistory;
window.showView = showView;
window.showApp = showApp;
window.showLoading = showLoading;
window.setPageMode = setPageMode;
window.showError = showError;
window.clearError = clearError;

// Reflect the current league context in the top-nav "League" tab.

;
/*! ==== 05-league-picker-popover.js ==== */
// Searchable league picker — body-level modal (works on mobile when sidebar is hidden).

function hasSelectedLeague() {
  const lg = STATE.leagues?.[STATE.currentTeamIdx];
  return !!(lg && lg.startupComplete !== false);
}

/**
 * Select the first league in All Leagues order (the current sort), skipping any
 * still waiting on a startup draft. True when one was selected.
 *
 * Owen, 2026-09-27: "When you click on league overview it should just choose
 * your first league instead of making you choose." The picker stays one tap
 * away in the toolbar's "Viewing" switch for anyone who wants another.
 */
function selectFirstLeague() {
  const leagues = STATE.leagues || [];
  const ordered = typeof sortPortfolio === 'function'
    ? sortPortfolio(leagues, STATE.portfolioSortKey, STATE.portfolioSortDir)
    : leagues;
  const first = ordered.find((lg) => lg && lg.startupComplete !== false);
  if (!first) return false;
  STATE.currentTeamIdx = leagues.indexOf(first);
  return true;
}
window.selectFirstLeague = selectFirstLeague;

/** Returns true if a league is (now) selected -- picking the first one when
 * none is; opens the picker only if no league can be opened at all. */
function requireLeagueSelection(opts) {
  if (!STATE.leagues?.length) {
    if (typeof showSetup === 'function') showSetup();
    return false;
  }
  if (hasSelectedLeague()) return true;
  if (selectFirstLeague()) return true;
  openLeaguePicker({ force: true, ...(opts || {}) });
  return false;
}
window.requireLeagueSelection = requireLeagueSelection;
window.hasSelectedLeague = hasSelectedLeague;

function openLeaguePicker(opts) {
  const options = typeof opts === 'object' && opts ? opts : {};
  const force = options.force === true;
  const pop = document.getElementById('leaguePickerPopover');
  const input = document.getElementById('leaguePickerInput');
  const sub = document.getElementById('leaguePickerSub');
  const closeBtn = document.getElementById('leaguePickerClose');
  if (!pop || !input) return;

  STATE._leaguePickerForce = force;
  pop.hidden = false;
  document.body.classList.add('league-picker-open');
  if (sub) {
    sub.textContent = force
      ? 'Choose a league to continue - portfolio tools stay on All Leagues until you pick one.'
      : 'Pick which dynasty league you want to work in.';
  }
  if (closeBtn) closeBtn.hidden = force;

  if (!document.getElementById('leaguePickerBackdrop')) {
    const bd = document.createElement('div');
    bd.id = 'leaguePickerBackdrop';
    bd.className = 'league-picker-backdrop';
    bd.addEventListener('click', () => {
      if (!STATE._leaguePickerForce) closeLeaguePicker();
    });
    document.body.appendChild(bd);
  }

  input.value = '';
  renderLeaguePickerList('');
  setTimeout(() => input.focus(), 30);

  if (!STATE._leaguePickerWired) {
    document.addEventListener('keydown', (e) => {
      const popEl = document.getElementById('leaguePickerPopover');
      if (!popEl || popEl.hidden) return;
      if (e.key === 'Escape' && !STATE._leaguePickerForce) closeLeaguePicker();
    });
    input.addEventListener('input', (e) => renderLeaguePickerList(e.target.value));
    STATE._leaguePickerWired = true;
  }
}
window.openLeaguePicker = openLeaguePicker;

function closeLeaguePicker() {
  const pop = document.getElementById('leaguePickerPopover');
  if (pop) pop.hidden = true;
  document.body.classList.remove('league-picker-open');
  const bd = document.getElementById('leaguePickerBackdrop');
  if (bd) bd.remove();
  const wasForced = STATE._leaguePickerForce;
  STATE._leaguePickerForce = false;
  if (wasForced && !hasSelectedLeague()) {
    showView('overview');
  }
}
window.closeLeaguePicker = closeLeaguePicker;

function renderLeaguePickerList(query) {
  const listEl = document.getElementById('leaguePickerList');
  if (!listEl) return;
  const q = (query || '').trim().toLowerCase();
  const matches = STATE.leagues
    .map((lg, idx) => ({ lg, idx }))
    .filter(({ lg }) => lg.startupComplete !== false)
    .filter(({ lg }) => !q || lg.name.toLowerCase().includes(q));
  if (matches.length === 0) {
    listEl.innerHTML = `<div class="league-picker-empty">No leagues match "${escapeHtml(query)}"</div>`;
    return;
  }
  listEl.innerHTML = matches.map(({ lg, idx }) => `
    <button type="button" class="league-picker-item ${STATE.currentTeamIdx === idx ? 'active' : ''}" data-league-pick="${idx}">
      <span class="league-picker-item-name">${escapeHtml(lg.name)}</span>
      <span class="league-picker-item-tag" data-tooltip="${escapeHtml(typeof formatGloss === 'function' ? formatGloss(lg.scoringTab) : '')}">${escapeHtml(lg.scoringTab || '')}</span>
    </button>
  `).join('');
}
window.renderLeaguePickerList = renderLeaguePickerList;

function pickLeague(idx) {
  STATE.currentTeamIdx = idx;
  if (STATE.pendingLeagueTab) {
    STATE.teamDetailTab = STATE.pendingLeagueTab;
    STATE.pendingLeagueTab = null;
  } else {
    STATE.teamDetailTab = STATE.teamDetailTab || 'overview';
  }
  STATE._leaguePickerForce = false;
  closeLeaguePicker();
  showView('team');
}
window.pickLeague = pickLeague;

function updateLeagueNavTab() {
  const label = document.getElementById('sidebarLeagueLabel');
  const tab = document.getElementById('navTabLeague');
  const quick = document.getElementById('navTabLeagueQuick');
  const lg = STATE.leagues[STATE.currentTeamIdx];
  const leagueScopedViews = ['teamView', 'tradeView', 'tradeHistoryView'];
  const inLeagueContext = leagueScopedViews.some(v => document.getElementById(v)?.classList.contains('active'));
  if (lg && inLeagueContext) {
    const name = lg.name.length > 22 ? lg.name.slice(0, 20) + '…' : lg.name;
    if (label) label.textContent = lg.name;
    if (tab) tab.textContent = name;
    if (quick) quick.textContent = name.length > 18 ? name.slice(0, 16) + '…' : name;
  } else {
    if (label) label.textContent = 'Select league';
    if (tab) tab.textContent = 'League';
    if (quick) quick.textContent = 'League';
  }
}

// Rebuild every player's cached value across every league. Called when value
// data lands after initial enrichment (DD markets, ADP) so league views show
// the latest composite, not the FC+DP-only values from initial load.
function rebuildPickValues(lg) {
  const ctx = pickContextFor(lg);
  const refresh = (p) => {
    const { value, source } = lookupPickValue(
      { season: p.season, round: p.round, slot: p.slot, projectedSlot: p.projectedSlot },
      lg.scoringTab,
      ctx,
    );
    if (value > 0) {
      p.value = value;
      p.valueSource = source;
    }
  };
  for (const p of (lg.myPicks || [])) refresh(p);
  for (const picks of Object.values(lg.picksByRoster || {})) {
    for (const p of picks) refresh(p);
  }
}

function rebuildAllPlayerValues() {
  if (!STATE.leagues || STATE.leagues.length === 0) return;
  for (const lg of STATE.leagues) {
    rebuildPickValues(lg);
    for (const p of (lg.myPlayers || [])) {
      const match = lookupPlayerValue(p.playerId, p.name, p.position, lg.scoringTab);
      if (match) {
        p.value = match.value;
        p.dynastyValue = match.dynastyValue;
        p.trend30Day = match.trend30Day;
        // Rows prefer momentum over trend30Day (playerRowHtml), and this
        // rebuild never copied it -- so a row that had momentum from enrich
        // lost it the moment values were rebuilt.
        p.momentum30d = match.momentum30d ?? p.momentum30d ?? null;
        p.momentum7d = match.momentum7d ?? p.momentum7d ?? null;
        p.stdev = match.stdev;
        p.valueSource = match.source;
        p.marketFallback = match.marketFallback === true;
        p.leagueValue = match.value;
      }
    }
    for (const r of (lg.allRosters || [])) {
      for (const p of r.players) {
        const match = lookupPlayerValue(p.playerId, p.name, p.position, lg.scoringTab);
        if (match) {
          p.value = match.value;
          p.dynastyValue = match.dynastyValue;
          p.trend30Day = match.trend30Day;
          p.momentum30d = match.momentum30d ?? p.momentum30d ?? null;
          p.momentum7d = match.momentum7d ?? p.momentum7d ?? null;
          p.stdev = match.stdev;
          p.valueSource = match.source;
          p.marketFallback = match.marketFallback === true;
          p.leagueValue = match.value;
        }
      }
      // Flat market value -- same number everywhere (see 10-sleeper-api.js
      // playerLeagueValue). Was tilting via leagueTradeValue.
      r.totalValue = TacoCore.rosterPlayersValue(r.players);
      r.activeValue = TacoCore.rosterPlayersValue(r.players, { activeOnly: true });
    }
  }
  STATE._waiverCache = null;
  STATE._waiverServerCache = null;
  STATE._tradeSuggestions = {};
  STATE._draftBoardCache = {};
  STATE._startableThresholdCache = {};
  for (const lg of STATE.leagues) lg._warBaselines = null; // WAR baselines track values
}

function rerenderActiveView() {
  const activeView = document.querySelector('.view.active')?.id?.replace('View', '');
  if (activeView === 'overview') renderOverview();
  else if (activeView === 'team') {
    // The trade-history subtab used to take a branch that re-mounted the subtab
    // INSTEAD of re-rendering the team detail, so on that one tab the header
    // above it -- Team Value, Draft Capital, the Position Read chips -- kept
    // whatever it had rendered before hydration finished. Draft Capital showed
    // 19,376 against an actual 8,521, because the first render happened before
    // the drafts came back, when rookieDraftComplete was still false and this
    // season's already-used picks were counted.
    //
    // renderTeamDetail re-mounts the trade-history subtab itself, so there is
    // nothing the old branch did that this does not.
    if (!hasSelectedLeague()) requireLeagueSelection();
    else {
      // Player values just changed underneath us, and trade verdicts are
      // computed from them, so the cached history has to be rebuilt.
      if (STATE.teamDetailTab === 'tradeHistory') {
        STATE.tradeHistory = null;
        STATE.tradeHistoryByLeague = {};
      }
      renderTeamDetail();
    }
  }
  // The view id is leagueTeamsView; this compared against 'league' and so never
  // redrew League Rankings after a value refresh or league switch (2026-10-03).
  else if (activeView === 'leagueTeams') renderLeagueView();
  else if (activeView === 'leagueRosters') renderLeagueRostersView();
  else if (activeView === 'trade' && typeof renderTradeSides === 'function') {
    renderTradeSides();
    if (typeof renderTradeVerdict === 'function') renderTradeVerdict();
  }
  // renderStandaloneRankings, not renderRankingsView -- the latter has never
  // existed. Guarded by typeof, so it failed silently: switching league from the
  // Player Rankings page left the board on the previous league.
  else if (activeView === 'rankings' && typeof renderStandaloneRankings === 'function') {
    renderStandaloneRankings();
  }
  else if (activeView === 'myAssets' && typeof renderMyAssetsView === 'function') renderMyAssetsView();
  else if (activeView === 'waiverWire' && typeof renderWaiverWireResults === 'function') renderWaiverWireResults();
  else if (activeView === 'marketRadar' && typeof renderMarketRadarView === 'function') renderMarketRadarView();
  else if (activeView === 'drafts' && typeof renderDraftsView === 'function') renderDraftsView();
  else if (activeView === 'scout' && typeof renderScoutView === 'function') renderScoutView();
}

function showLanding() {
  document.documentElement.classList.remove('route-connect');
  setPageMode('landing');
  document.getElementById('landingView').style.display = 'block';
  document.getElementById('setupView').classList.remove('is-visible');
  document.getElementById('loadingView').classList.remove('active');
  document.getElementById('appShell').classList.remove('active');
  if (typeof setSiteChromeMode === 'function') setSiteChromeMode('marketing');

  window.scrollTo({ top: 0 });
}
function showSetup() {
  document.documentElement.classList.add('route-connect');
  setPageMode('setup');
  document.getElementById('landingView').style.display = 'none';
  document.getElementById('setupView').classList.add('is-visible');
  document.getElementById('loadingView').classList.remove('active');
  document.getElementById('appShell').classList.remove('active');
  if (typeof setSiteChromeMode === 'function') setSiteChromeMode('marketing');
  window.scrollTo({ top: 0 });
  const u = document.getElementById('usernameInput');
  if (u) setTimeout(() => u.focus(), 50);
}
window.showLanding = showLanding;
window.showSetup = showSetup;

function showAbout() { openInfoModal('aboutOverlay'); }
function showPrivacy() { openInfoModal('privacyOverlay'); }
function openInfoModal(id) {
  const el = document.getElementById(id);
  if (!el) return;
  el.classList.add('open');
  el.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}
function closeInfoModal(e) {
  if (e && e.target && !e.target.classList.contains('info-overlay')) return;
  document.querySelectorAll('.info-overlay.open').forEach(el => {
    el.classList.remove('open');
    el.setAttribute('aria-hidden', 'true');
  });
  document.body.style.overflow = '';
}
window.showAbout = showAbout;
window.showPrivacy = showPrivacy;
window.closeInfoModal = closeInfoModal;
;
/*! ==== 10-sleeper-api.js ==== */
const SLEEPER_API = 'https://api.sleeper.app/v1';

async function fetchPortfolioBootstrap(username, season) {
  try {
    const q = new URLSearchParams({ username, season, _: String(Date.now()) });
    const res = await fetch(BACKEND_URL + '/api/portfolio/bootstrap?' + q, { cache: 'no-store' });
    if (!res.ok) return null;
    const data = await res.json();
    if (!data || data.error) return null;
    return data;
  } catch (_err) {
    return null;
  }
}

async function api(path) {
  const backendPath = BACKEND_URL + '/api/sleeper/v1' + path;
  try {
    const res = await fetch(backendPath);
    if (res.ok) return res.json();
  } catch (_err) {
    /* fall through to direct Sleeper */
  }
  const direct = await fetch(SLEEPER_API + path);
  if (!direct.ok) throw new Error(`Sleeper API ${direct.status} on ${path}`);
  return direct.json();
}

/**
 * Sleeper's authoritative NFL week. One small request, fetched once a session.
 *
 * Everything that shows live scoring should prefer this over the local date
 * maths: a week number derived from a calendar anchor has been wrong twice,
 * and when it is wrong the Slate silently displays a week that has not been
 * played rather than failing. Resolves to null on any error so callers fall
 * back to the computed week instead of breaking.
 */
async function ensureNflState() {
  if (STATE.nflState) return STATE.nflState;
  if (!STATE._nflStatePromise) {
    STATE._nflStatePromise = api('/state/nfl')
      .then((s) => {
        // Only trust a sane regular-season week; anything else falls back.
        const wk = Number(s && s.week);
        STATE.nflState = (wk >= 1 && wk <= 18) ? s : null;
        return STATE.nflState;
      })
      .catch(() => {
        STATE._nflStatePromise = null;
        return null;
      });
  }
  return STATE._nflStatePromise;
}
window.ensureNflState = ensureNflState;

/** Lazy ~5MB Sleeper players DB — only fetched when a surface needs it. */
async function ensurePlayersDB() {
  if (STATE.playersDB) return STATE.playersDB;
  if (!STATE._playersDBPromise) {
    STATE._playersDBPromise = api('/players/nfl').then((db) => {
      STATE.playersDB = db;
      return db;
    }).catch((err) => {
      STATE._playersDBPromise = null;
      throw err;
    });
  }
  return STATE._playersDBPromise;
}

/** The four per-league Sleeper payloads enrichment reads. One definition, used by
 * enrichLeague and by Scout a League, which caches them so a scouted league can
 * be re-enriched as any of its managers without fetching it again. */
async function fetchLeaguePayload(lg) {
  const [rosters, users, tradedPicks, drafts] = await Promise.all([
    api(`/league/${lg.league_id}/rosters`),
    api(`/league/${lg.league_id}/users`),
    api(`/league/${lg.league_id}/traded_picks`).catch(() => []),
    api(`/league/${lg.league_id}/drafts`).catch(() => []),
  ]);
  return { league: lg, rosters, users, tradedPicks, drafts };
}

// Client-side enrich fallback — shared core in TacoCore (server does this by default).
async function enrichLeague(lg, opts = {}) {
  const cached = STATE._portfolioBootstrap?.leaguePayloads?.find(p => p.league.league_id === lg.league_id);
  const { rosters, users, tradedPicks, drafts } = cached || (await fetchLeaguePayload(lg));

  const scoringTab = detectScoringTab(lg);
  return TacoCore.enrichLeague(lg, {
    // Scouting passes an owner ID no roster can have, so no team becomes "me".
    userId: opts.userId !== undefined ? opts.userId : STATE.userId,
    season: STATE.season,
    rosters,
    users,
    tradedPicks,
    drafts,
    lookupPlayer(playerId, name, position) {
      return lookupPlayerValue(playerId, name, position, scoringTab);
    },
    lookupPick(pick) {
      // Enrichment has not computed rookieDraftComplete yet at this point, so
      // only the league size is available -- still better than defaulting to
      // 12 teams. Enrichment prices picks itself with the full context.
      return lookupPickValue(pick, scoringTab, { numTeams: (rosters || []).length || undefined });
    },
    getPlayerMeta(playerId) {
      const p = STATE.playersDB?.[playerId];
      if (!p) return null;
      const fullName = (p.full_name || `${p.first_name || ''} ${p.last_name || ''}`).trim();
      return {
        name: fullName,
        position: TacoCore.primaryFantasyPosition(p),
        team: p.team || 'FA',
        age: p.age ?? null,
        yearsExp: p.years_exp,
        rookie: p.years_exp === 0,
      };
    },
  });
}

function detectScoringTab(lg) {
  return TacoCore.detectScoringTab(lg);
}

function buildLeagueScoringFingerprint(lg) {
  return TacoCore.buildLeagueScoringFingerprint(lg);
}

function leaguePositionScaler(position, lg) {
  return TacoCore.leaguePositionScaler(position, lg);
}

function leagueTradeValue(rawValue, position, lg, playerId) {
  const opts = playerId ? { playerId: String(playerId) } : {};
  return TacoCore.leagueTradeValue(rawValue, position, lg, opts);
}

/** Lazy-load Sleeper season stats for return-yard value adjustments. */
async function ensureNflSeasonStats(season) {
  if (!STATE.nflSeasonStats) STATE.nflSeasonStats = {};
  if (STATE.nflSeasonStats[season]) return STATE.nflSeasonStats[season];
  const key = 'nflstats:' + season;
  if (STATE._statsFetches[key]) return STATE._statsFetches[key];
  STATE._statsFetches[key] = (async () => {
    try {
      const data = await api(`/stats/nfl/regular/${season}`);
      STATE.nflSeasonStats[season] = data;
      return data;
    } catch (err) {
      console.warn('[return-stats] failed', season, err.message);
      STATE.nflSeasonStats[season] = {};
      return {};
    } finally {
      delete STATE._statsFetches[key];
    }
  })();
  return STATE._statsFetches[key];
}

/** Flat market value -- same number shown on every page (My Assets, League
 * View, Team Detail, Portfolio, Rankings, etc). Used to return a position-
 * tilted value; that made a player's "value" disagree depending which page
 * you were on. leagueTradeValue is still used directly by a few internal
 * ranking signals (e.g. Team Waiver Panel's suggestion score) that
 * deliberately want the tilt for recommendation quality, not display. */
function playerLeagueValue(p, _lg) {
  return p?.value || 0;
}

/** Stamp leagueValue on roster rows -- flat market value, not tilted (see
 * playerLeagueValue). Kept as a field (not removed) since some call sites
 * still read p.leagueValue directly. */
function applyLeagueValuesToRosters(leagues) {
  if (!leagues?.length) return;
  for (const lg of leagues) {
    for (const p of (lg.myPlayers || [])) {
      if (p.value) p.leagueValue = p.value;
    }
    for (const r of (lg.allRosters || [])) {
      for (const p of (r.players || [])) {
        if (p.value) p.leagueValue = p.value;
      }
    }
  }
}

/** Attach returnStatsByPlayer to leagues that score KR/PR. */
async function hydrateReturnStatsForLeagues(leagues) {
  if (!leagues?.length || typeof TacoCore.hasReturnScoring !== 'function') return;
  const returnLeagues = leagues.filter((lg) => TacoCore.hasReturnScoring(lg.scoring_settings));
  if (!returnLeagues.length) return;

  const seasons = [...new Set(returnLeagues.map((lg) => TacoCore.statsSeasonForLeague(lg.season)))];
  await Promise.all(seasons.map((s) => ensureNflSeasonStats(s)));

  for (const lg of returnLeagues) {
    const statsSeason = TacoCore.statsSeasonForLeague(lg.season);
    const blob = STATE.nflSeasonStats?.[statsSeason];
    if (!blob) continue;
    lg.returnStatsByPlayer = TacoCore.buildReturnStatsByPlayer(blob, lg.scoring_settings);
    lg.returnStatsSeason = statsSeason;
    if (lg.scoringFingerprint) {
      lg.scoringFingerprint = buildLeagueScoringFingerprint(lg);
    }
  }
}

function renderLeagueScoringRulesHtml(rules) {
  if (!rules.length) {
    return '<div class="league-scoring-note">No custom point rules returned from Sleeper.</div>';
  }
  let html = '';
  let lastCat = '';
  rules.forEach(r => {
    if (r.category !== lastCat) {
      lastCat = r.category;
      html += `<div class="league-scoring-cat">${escapeHtml(r.category)}</div>`;
    }
    const signClass = r.val > 0 ? 'positive' : r.val < 0 ? 'negative' : '';
    html += `<div class="league-scoring-rule ${signClass}"><span>${escapeHtml(r.label)}</span><span>${escapeHtml(r.pointsLabel)}</span></div>`;
  });
  return `<div class="league-scoring-rules">${html}</div>`;
}

// withHead: the standalone panel (the Scout board) needs its own title, but
// League Overview renders this inside a <details> whose summary already says
// "How this league scores" and repeats the profile line -- so opening the pill
// showed the same two lines twice, one under the other (2026-10-16).
function renderLeagueScoringPanelHtml(lg, { withHead = true } = {}) {
  const fp = lg.scoringFingerprint || buildLeagueScoringFingerprint(lg);
  lg.scoringFingerprint = fp;
  const chipHtml = fp.chips.length
    ? fp.chips.map(c => `<span class="league-scoring-chip ${c.cls || ''}">${escapeHtml(c.text)}</span>`).join('')
    : '<span class="league-scoring-chip">Standard scoring</span>';
  return `
    <div class="league-scoring-panel">
      ${withHead ? `<div class="league-scoring-head">
        <span class="league-scoring-title">How this league scores</span>
        <span class="league-scoring-profile">${escapeHtml(fp.profileLine)}</span>
      </div>` : ''}
      <div class="league-scoring-chips">${chipHtml}</div>
      <div class="league-scoring-note">${escapeHtml(fp.note)}</div>
      ${renderLeagueScoringRulesHtml(fp.rules)}
    </div>
  `;
}

// ============================================================
// PORTFOLIO SORT
// Computes a sort key per league and orders the portfolio cards.
// Keys map to a numeric value per league; strings are sorted locale-aware.
// ============================================================

// Archetype sort order: contender-leaning first, rebuild last. Used when sort key is 'archetype'.
const ARCHETYPE_RANK = {
  'Dynasty Core': 1,
  'Contender': 2,
  'Ascending': 3,
  'Middle Tier': 4,
  'Rebuild': 5,
};

// ============================================================
// GLOSSARY — terms used throughout the app, with one-line explanations.
// Used both for inline tooltips (data-tooltip attribute on UI elements) and
// the dedicated Glossary view. Keep definitions short — these read as tooltips.
// ============================================================
const GLOSSARY = {
  // Archetypes (team styles). Judged against the rest of the league on three
  // things: strength now (roster value, this season's projected points, and
  // results as the season goes), future capital (picks + players 24 or under),
  // and starter age -- shared/archetypes.mjs. Reworked 2026-09-27; cut from
  // eight to five 2026-10-03. Each answers one question: when is the window?
  'Dynasty Core':    'Window: now and later. One of the strongest teams in the league with a young starting lineup.',
  'Contender':       'Window: now. One of the strongest teams in the league by roster, projections and results. Built to win this year.',
  'Ascending':       'Window: soon. A young roster with a top-half lineup that is not winning yet - often a good team having a slow start.',
  'Middle Tier':     'No clear window. Neither among the strongest now nor stocking up for later. Push up by adding stars, or commit to a rebuild.',
  'Rebuild':         'Window: later. The starters have been sold and the value sits in picks and young players. Built for later, not this year.',

  // Pick terms
  'Slot':            'The exact draft position (e.g., 1.03 = third pick of the first round). Known after league draft order is set.',
  'Bucket':          'A slot range - the early, middle or late third of a round. Shown as a label when the exact slot is not set yet.',
  'Pick value':      "A pick is priced from its draft class's round value, scaled by where it falls in the round. With no known slot it prices at the round average.",

  // Scoring formats
  '1QB':             'Single-quarterback league. QBs are scarcer than starters of other positions.',
  'SF':              'Superflex - leagues that allow 2 QBs in the starting lineup. Massively boosts QB value.',
  'TE+':             'Mild TE Premium (~+0.5 PPR for TEs). Tight ends get a small value bump.',
  'TE++':            'Moderate TE Premium (~+1.0 PPR). Tight ends become near-WR value.',
  'TE+++':           'Heavy TE Premium (~+1.5 PPR). Elite TEs become some of the most valuable assets.',
  'How this league scores': 'Every non-zero Sleeper scoring rule for this league - PPR, bonuses, big-play thresholds, kick/punt returns, team defense, IDP, and starter slots. Game logs and trade values use these settings, and trade math applies this league\'s scoring tilt.',

  // Trade calc terms
  'Tier premium':    'Elite assets are worth MORE than face value (a 9k WR1 is harder to replace than two 4.5k WR3s). The premium adjusts for this.',
  'Effective value': 'Raw trade value PLUS tier premium. The metric used for actual fairness verdicts.',
  'Fairness band':   'Trades within ±5% of effective value are considered fair. Outside that = clear winner.',

  // Other
  '30d momentum':    "How much this player's value has moved over the past 30 days in our own engine. ▲ = rising, ▼ = falling.",
  // 'Liquidity' lived here with a definition but no metric: the word appears
  // in no module, template or stylesheet, so the glossary was explaining
  // something the app never shows (2026-10-16). Removed rather than kept as
  // a promise.
  'Position rank':   'Where a player sits at his position - WR12 is the 12th-most-valuable WR.',
  // Named for the panel it describes: the heading, the nav entry and the route
  // all say League Rankings, and "archetype" is the internal word for what the
  // app calls a team style. It is also sortable by starters and picks, not
  // total alone, and the row carries rank chips rather than a strength /
  // weakness line against the league average.
  'League Rankings': 'Every team in the league ranked by value - total, starters, or picks. Each row carries the team\'s style and its rank at each position.',
};

// Compute the sort value for a league given a sort key.
// Returns a number for numeric sorts or a string for name/archetype.
function portfolioSortValue(lg, key) {
  const myPlayers = lg.myPlayers || [];
  const myPicks = lg.myPicks || [];
  switch (key) {
    case 'totalValue':
      // Matches the "Team" stat displayed on the card, which is players +
      // picks (see teamValue in 55-portfolio-overview.js). Players-only here
      // silently disagreed with the visible number whenever draft capital
      // differed between leagues — the sort order looked "wrong" even though
      // it was consistent, just consistent with a number nobody could see.
      return TacoCore.rosterPlayersValue(myPlayers) + TacoCore.picksValue(myPicks);
    case 'startersValue': {
      // Use the proposed-lineup builder to get true starters; fall back to isStarter flag.
      const starters = myPlayers.filter(p => p.isStarter);
      return starters.reduce((s, p) => s + (p.value || 0), 0);
    }
    case 'avgValue': {
      const valued = myPlayers.filter(p => p.value > 0);
      if (valued.length === 0) return 0;
      return valued.reduce((s, p) => s + p.value, 0) / valued.length;
    }
    case 'avgAge': {
      const ages = myPlayers.filter(p => p.age).map(p => p.age);
      return ages.length ? ages.reduce((a, b) => a + b, 0) / ages.length : 0;
    }
    case 'picksValue':
      return TacoCore.picksValue(myPicks);
    case 'archetype': {
      const myRosterObj = lg.allRosters.find(r => r.isMe);
      const arch = myRosterObj ? archetypeForRoster(lg, myRosterObj) : 'Middle Tier';
      return ARCHETYPE_RANK[arch] || 99;
    }
    case 'name':
      return lg.name.toLowerCase();
    case 'leagueRank': {
      // Lower rank number = better team (1 is best); so desc = worst first, asc = best first.
      // Must match the "VALUE X/Y" rank badge in the card corner (55-portfolio-overview.js),
      // which ranks players + picks per roster — players-only here put a
      // league's rank out of step with its own card's rank badge.
      const teamValue = TacoCore.rosterPlayersValue(myPlayers) + TacoCore.picksValue(myPicks);
      const allValues = TacoCore.leagueTeamValues(lg).map(v => v.value);
      return TacoCore.rankAmong(allValues, teamValue);
    }
    case 'starterRank': {
      // Rank by starting-lineup value. Computes a starter total for every
      // roster in the league (filtering by isStarter flag on each roster's
      // players) and ranks mine against them. Lower number = better.
      const myStarterValue = myPlayers.filter(p => p.isStarter).reduce((s, p) => s + (p.value || 0), 0);
      const allStarterValues = lg.allRosters.map(r =>
        // allow-inline-roster-sum: starters only, not a roster total
        (r.players || []).filter(p => p.isStarter).reduce((s, p) => s + (p.value || 0), 0)
      );
      return allStarterValues.filter(v => v > myStarterValue).length + 1;
    }
    default:
      return 0;
  }
}

// Sort the leagues array according to the user's sort key + direction.
function sortPortfolio(leagues, key, dir) {
  const copy = [...leagues];
  copy.sort((a, b) => {
    const va = portfolioSortValue(a, key);
    const vb = portfolioSortValue(b, key);
    if (typeof va === 'string' && typeof vb === 'string') {
      return dir === 'asc' ? va.localeCompare(vb) : vb.localeCompare(va);
    }
    return dir === 'asc' ? va - vb : vb - va;
  });
  return copy;
}

// Human label for the sort direction button. Some keys read more naturally
// as "oldest first" / "A→Z" rather than "high to low".
function portfolioSortDirLabel(key, dir) {
  if (key === 'name') return dir === 'desc' ? 'Z → A' : 'A → Z';
  if (key === 'avgAge') return dir === 'desc' ? 'Oldest first' : 'Youngest first';
  if (key === 'archetype') return dir === 'desc' ? 'Rebuild first' : 'Contender first';
  if (key === 'leagueRank') return dir === 'desc' ? 'Worst-ranked first' : 'Best-ranked first';
  return dir === 'desc' ? 'High to low' : 'Low to high';
}

// Handlers called from the sort UI. Persist to localStorage so it sticks.
function setPortfolioSort(key) {
  STATE.portfolioSortKey = key;
  try { localStorage.setItem('fo_portfolio_sort_key', key); } catch (_e) {}
  if (window.TacoCloud && TacoCloud.onPrefsChanged) TacoCloud.onPrefsChanged();
  renderOverview();
}
function togglePortfolioSortDir() {
  STATE.portfolioSortDir = STATE.portfolioSortDir === 'desc' ? 'asc' : 'desc';
  try { localStorage.setItem('fo_portfolio_sort_dir', STATE.portfolioSortDir); } catch (_e) {}
  if (window.TacoCloud && TacoCloud.onPrefsChanged) TacoCloud.onPrefsChanged();
  renderOverview();
}

window.setPortfolioSort = setPortfolioSort;
window.togglePortfolioSortDir = togglePortfolioSortDir;
window.sortPortfolio = sortPortfolio;
window.portfolioSortDirLabel = portfolioSortDirLabel;

;
/*! ==== 10-portfolio-load.js ==== */
// Portfolio load — server does enrichment; browser renders then hydrates lookups in background.

/** Enrich leagues in small parallel batches — avoids browser/worker stampedes on big portfolios. */
async function enrichLeaguesBatched(leagues, batchSize = 3) {
  const out = [];
  for (let i = 0; i < leagues.length; i += batchSize) {
    const batch = leagues.slice(i, i + batchSize);
    const enriched = await Promise.all(batch.map((lg) => enrichLeague(lg)));
    out.push(...enriched);
    const last = batch[batch.length - 1];
    setLoader(`Loaded ${out.length}/${leagues.length} leagues${last ? ` - last: ${last.name}` : ''}`);
  }
  return out;
}

async function loadEverything(opts = {}) {
  // silent: the background refresh after an instant resume (11-instant-resume).
  // No loading screen, no error screen, and the page re-renders only if the
  // fresh data differs from what is already on it.
  const silent = !!opts.silent;
  const before = silent && typeof resumeSignature === 'function' ? resumeSignature(STATE.leagues) : null;
  if (!silent) clearError();
  // Funnel visibility (TACO overhaul Phase 5): before this, the only custom
  // GA4 event anywhere was 'reached_value' (below, after a full successful
  // load) -- there was no way to tell a real connect attempt from someone
  // who never got past the username field, or how many attempts fail vs
  // succeed.
  if (!silent && typeof trackEvent === 'function') trackEvent('connect_started');
  try {
    // Strip a leading @ before anything else touches it.
    //
    // No Sleeper username begins with @, so one that arrives with it is always
    // somebody copying what the Sleeper app displays -- accepting it can never
    // be wrong, and refusing it costs a signup for no reason.
    //
    // This is partly self-inflicted: the connect error written on 2026-09-12
    // says "It's the @name at the top", and at 00:05 on 2026-09-13 someone read
    // that, went and looked, and typed "@BKeeves". They recovered in 28 seconds.
    // The copy is still right -- the @name IS what you want -- so the input
    // should just accept the form the app shows people.
    const username = (document.getElementById('usernameInput')?.value || '').trim().replace(/^@+/, '');
    // Same rule as the landing field: a pasted Sleeper league link scouts it.
    if (/sleeper\.(com|app)/i.test(username) && window.TacoRoutes?.scoutPath) {
      const scout = TacoRoutes.scoutPath(username);
      if (scout) {
        window.location.assign(scout);
        return;
      }
    }
    const season = document.getElementById('seasonInput').value;

    // Instant resume: this build saved this portfolio recently, so draw the
    // page from it now and refresh underneath.
    if (!silent && typeof resumeLoad === 'function') {
      const snap = await resumeLoad(username, season);
      if (snap) {
        STATE.username = username;
        STATE.season = season;
        STATE.userId = snap.userId;
        STATE.userAvatar = snap.userAvatar;
        STATE.userDisplayName = snap.userDisplayName;
        STATE.excludedLeagueCount = snap.excludedLeagueCount;
        STATE.excludedLeagueNames = snap.excludedLeagueNames;
        STATE.leagues = snap.leagues;
        setStatus(`@${username} · ${season}`, true);
        finishPortfolioLoad(username, snap.leagues.length, { resumedAt: snap.savedAt });
        runBackgroundHydration(snap.leagues, [...new Set(snap.leagues.map((lg) => detectScoringTab(lg)))]);
        setTimeout(() => loadEverything({ silent: true }), 0);
        return;
      }
    }

    if (!silent) showLoading();
    STATE.username = username;
    STATE.season = season;

    setLoader('Loading portfolio');
    const bootstrap = await fetchPortfolioBootstrap(username, season);

    if (bootstrap?.user?.user_id) {
      STATE.userId = bootstrap.user.user_id;
      STATE.userAvatar = bootstrap.user.avatar || null;
      STATE.userDisplayName = bootstrap.user.display_name || username;
    } else {
      setLoader('Resolving Sleeper user');
      const user = await api('/user/' + encodeURIComponent(username));
      if (!user || !user.user_id) throw new Error('Sleeper user not found: ' + username);
      STATE.userId = user.user_id;
      STATE.userAvatar = user.avatar || null;
      STATE.userDisplayName = user.display_name || username;
    }
    setStatus(`@${username} · ${season}`, true);

    let allLeagues;
    if (bootstrap?.leagues) {
      allLeagues = bootstrap.leagues;
      STATE._portfolioBootstrap = bootstrap;
      STATE.excludedLeagueCount = bootstrap.excludedLeagueCount || 0;
      STATE.excludedLeagueNames = bootstrap.excludedLeagueNames || [];
    } else {
      setLoader('Fetching leagues');
      allLeagues = await api(`/user/${STATE.userId}/leagues/nfl/${season}`);
    }

    if (!allLeagues || allLeagues.length === 0) {
      throw new Error(`No leagues found for ${username} in ${season}. Double-check the spelling - this is your Sleeper username, not your team name - or try a different season.`);
    }

    const leagues = bootstrap?.leagues || allLeagues.filter(isDynastyLeague);
    if (!bootstrap?.leagues) {
      const excludedLeagues = allLeagues.filter((lg) => !isDynastyLeague(lg));
      STATE.excludedLeagueCount = excludedLeagues.length;
      STATE.excludedLeagueNames = excludedLeagues.map((lg) => lg.name);
    }

    if (leagues.length === 0) {
      throw new Error(`We found ${allLeagues.length} league(s) for ${username}, but none are dynasty. The Armchair Office is built for dynasty leagues only - redraft and keeper leagues aren't supported.`);
    }

    const uniqueTabs = [...new Set(leagues.map((lg) => detectScoringTab(lg)))];

    // TACO-009: name the count now that we know it, before the (often slower)
    // enrichment step — "Loading your 8 Sleeper leagues…" beats a generic message.
    setLoader(`Loading your ${leagues.length} Sleeper league${leagues.length === 1 ? '' : 's'}…`);

    // Fast path: Worker already enriched rosters + values + scoring fingerprint.
    if (bootstrap?.enrichedLeagues?.length && bootstrap.enrichedLeagues.length === leagues.length) {
      STATE.leagues = bootstrap.enrichedLeagues;
      await hydrateReturnStatsForLeagues(STATE.leagues);
      applyLeagueValuesToRosters(STATE.leagues);
      if (silent) { finishSilentRefresh(before); return; }
      setLoader('Rendering portfolio');
      finishPortfolioLoad(username, leagues.length);
      runBackgroundHydration(leagues, uniqueTabs);
      if (typeof resumeSave === 'function') resumeSave();
      return;
    }

    // Slow path: no server enrichment — client does the heavy lifting.
    setLoader('Loading player database + values');
    await Promise.all([
      ensurePlayersDB(),
      fetchAllFcValues(leagues),
      loadDynastyProcess(),
    ]);

    setLoader(`Enriching ${leagues.length} leagues`);
    STATE.leagues = await enrichLeaguesBatched(leagues, 3);

    await hydrateReturnStatsForLeagues(STATE.leagues);
    applyLeagueValuesToRosters(STATE.leagues);

    if (silent) { finishSilentRefresh(before); return; }
    finishPortfolioLoad(username, leagues.length);
    runBackgroundHydration(leagues, uniqueTabs);
    if (typeof resumeSave === 'function') resumeSave();
  } catch (err) {
    if (silent) {
      // The resumed page stays up; the next load tries again.
      console.warn('[resume] background refresh failed:', err && err.message);
      return;
    }
    console.error(err);
    if (typeof trackEvent === 'function') trackEvent('connect_failed', { reason: err.message?.slice(0, 100) });
    if (typeof window.setFetchBtnLoading === 'function') window.setFetchBtnLoading(false);
    if (typeof showSetup === 'function') showSetup();
    const leagueHelp = await leagueIdHelp(err.message);
    if (leagueHelp) {
      showLeagueIdPicker(leagueHelp);
      return;
    }
    showError(err.message);
  }
}

// A league ID typed where a username goes.
//
// Launch day, 2026-09-12: someone entered 1352768002818342912. It looked like a
// raw Sleeper user ID, but Sleeper says it is a league ("im high again"), so it
// was copied out of a league URL -- the only long number Sleeper ever shows
// anyone. The league's member list is public, so instead of a dead end, show it
// and let them tap themselves. Only runs for an all-digit input that already
// failed as a username, so it costs nothing on a normal connect.
async function leagueIdHelp(message) {
  const m = String(message || '').match(/Sleeper user not found: (\d{15,20})\s*$/);
  if (!m) return null;
  try {
    const [league, users] = await Promise.all([api('/league/' + m[1]), api('/league/' + m[1] + '/users')]);
    if (!league || !Array.isArray(users)) return null;
    const members = users
      .filter((u) => u && u.user_id && !u.is_bot)
      .map((u) => ({
        userId: String(u.user_id),
        displayName: u.display_name || 'Unnamed manager',
        teamName: (u.metadata && u.metadata.team_name) || '',
      }))
      .sort((a, b) => a.displayName.localeCompare(b.displayName));
    return members.length ? { leagueId: m[1], leagueName: league.name || 'this league', members } : null;
  } catch (_err) {
    return null;
  }
}

function showLeagueIdPicker(help) {
  const slot = document.getElementById('errorSlot');
  if (!slot) return;
  if (typeof trackEvent === 'function') trackEvent('connect_league_id_shown');
  const buttons = help.members
    .map(
      (u) =>
        `<button type="button" class="league-id-member" data-league-member="${escapeHtml(u.userId)}">` +
        `<span class="lim-name">${escapeHtml(u.displayName)}</span>` +
        (u.teamName ? `<span class="lim-team">${escapeHtml(u.teamName)}</span>` : '') +
        '</button>',
    )
    .join('');
  slot.innerHTML = `
    <div class="error">
      <div class="error-title">That number is your league, “${escapeHtml(help.leagueName)}”. Tap your name to sign in.</div>
      <div class="error-hint">We'll look up your username from here. Next time, it's the @name on your Sleeper profile.</div>
      <div class="league-id-members">${buttons}</div>
      <a class="league-id-scout" href="/scout/${escapeHtml(help.leagueId)}">Not your league? Just scout it →</a>
    </div>
  `;
}

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-league-member]');
  if (!btn) return;
  btn.disabled = true;
  try {
    // /user/<id> returns the username, which is what the rest of the app keys on.
    const user = await api('/user/' + encodeURIComponent(btn.dataset.leagueMember));
    if (!user || !user.username) throw new Error('Sleeper API returned no username');
    const input = document.getElementById('usernameInput');
    if (input) input.value = user.username;
    try {
      localStorage.setItem('fo_username', user.username);
    } catch (_e) {
      /* private mode */
    }
    if (typeof trackEvent === 'function') trackEvent('connect_league_id_recovered');
    loadEverything();
  } catch (_err) {
    btn.disabled = false;
    showError('Sleeper API unavailable');
  }
});


/** End of a background refresh: re-render only if the data moved, then save. */
function finishSilentRefresh(before) {
  STATE.lastSyncAt = Date.now();
  if (typeof updateSyncIndicator === 'function') updateSyncIndicator();
  const after = typeof resumeSignature === 'function' ? resumeSignature(STATE.leagues) : null;
  if (after !== before && typeof rerenderActiveView === 'function') rerenderActiveView();
  if (typeof resumeSave === 'function') resumeSave();
}

function finishPortfolioLoad(username, leagueCount, opts = {}) {
  setLoader('Rendering');
  // showApp() BEFORE the first render: rendering the overview while the view is
  // still display:none left the snapshot stat-strip's flex layout computed at
  // zero on some mobile browsers, so it stayed blank until an orientation change
  // forced a reflow (Owen: only showed in landscape). Rendering once visible
  // fixes the initial layout.
  showApp();
  renderOverview();
  setStatus(`@${username} · ${leagueCount} leagues · live`, true);
  // Remember Me: persist the season alongside the username (saved elsewhere) so a
  // return visit prefills both and is one tap.
  try { if (STATE.season) localStorage.setItem('fo_season', STATE.season); } catch (_e) { /* ignore */ }
  // A resumed page shows when its data was actually fetched, not now.
  STATE.lastSyncAt = opts.resumedAt || Date.now();
  updateSyncIndicator();
  updateUserBadge();
  // TACO-031: if a shared trade link just set up the team/trade subtab, that's
  // the correct final view -- don't let the pendingRoute restore below (and the
  // applyRouteFromPath() call that follows) re-parse the original
  // /tools/trade-calculator path and switch to the standalone trade view,
  // which is empty because its DOM children were already lifted into the
  // subtab slot. That's what silently landed shared links on an empty tab.
  const tradeShareHandled = applyTradeShareLink();
  if (tradeShareHandled) STATE.pendingRoute = null;
  // TACO-009: "reached value" milestone — Portfolio Exposure is unconditionally
  // visible to every user right here, making this the most reliable single
  // instrumentation point without adding tracking hooks to every view render.
  if (!opts.resumedAt && typeof trackEvent === 'function') trackEvent('reached_value', { league_count: leagueCount });

  if (window.TacoCrawl && TacoCrawl.afterLeaguesLoaded) {
    TacoCrawl.afterLeaguesLoaded().then(function () {
      loadMarketRadar();
      loadMateActivity();
      if (typeof rerenderActiveView === 'function') rerenderActiveView();
    }).catch(function (e) { console.warn('[crawl] register', e.message); });
  }

  initLiveDraftRoom();
  loadMateActivity();
  if (typeof loadWeeklyProjections === 'function') loadWeeklyProjections();
  if (STATE.pendingLeagueTab && STATE.leagues.length) {
    STATE.currentTeamIdx = STATE.currentTeamIdx ?? 0;
    STATE.teamDetailTab = STATE.pendingLeagueTab;
    STATE.pendingLeagueTab = null;
    if (typeof viewToPath === 'function') {
      try { history.replaceState(null, '', viewToPath('team')); } catch (_e) { /* ignore */ }
    }
  } else if (STATE.pendingRoute) {
    const path = STATE.pendingRoute;
    STATE.pendingRoute = null;
    try { history.replaceState(null, '', path); } catch (_e) { /* ignore */ }
  } else if (!tradeShareHandled) {
    try { history.replaceState(null, '', '/portfolio'); } catch (_e) { /* ignore */ }
  }
  // Already on the right view when tradeShareHandled -- re-running the router
  // here would switch to the standalone trade view instead (see above).
  if (!tradeShareHandled) {
    if (typeof applyRouteFromPath === 'function') applyRouteFromPath();
    else showView('overview');
  }
}

/** Non-blocking: lookup tables, waivers DB, ADP/trending — never blocks first paint. */
function runBackgroundHydration(leagues, uniqueTabs) {
  const enriched = STATE.leagues || [];
  const sfCount = enriched.filter((lg) => lg.scoringTab && lg.scoringTab.startsWith('SF')).length;
  const dominantFormat = sfCount > enriched.length / 2 ? 'SF TE+' : '1QB';

  // Team styles judge "can this team win now" on projected points (34), which
  // needs the season projections -- load them after first paint and redraw
  // once, so every page's labels firm up together (2026-09-27).
  if (typeof loadSeasonProjections === 'function' && !STATE.seasonProjections) {
    Promise.resolve(loadSeasonProjections()).then(() => {
      if (STATE.seasonProjections && !STATE.seasonProjections.failed && typeof rerenderActiveView === 'function') rerenderActiveView();
    }).catch(() => {});
  }

  Promise.allSettled([
    hydrateBackendComposites(uniqueTabs),
    ensurePlayersDB(),
    computeRookieAdp(dominantFormat),
    loadDdMarkets(dominantFormat),
    loadSleeperTrending(),
  ]).then(async (results) => {
    const compositeResult = results[0];
    const compositesLoaded = uniqueTabs.some((tab) =>
      STATE.backendComposite[tab]?.players && Object.keys(STATE.backendComposite[tab].players).length > 0,
    );

    // Our composite is the only value source now, so this is a retry rather
    // than a fallback: fetchAllFcValues reads the same endpoint, per tab.
    // loadDynastyProcess rides along for Market Radar and the drawer's market
    // comparison, which are the only things left that read STATE.dpLookup.
    if (BACKEND_URL && compositeResult.status === 'fulfilled' && !compositesLoaded) {
      console.warn('[hydrate] composite dict missing - retrying per tab');
      await Promise.allSettled([fetchAllFcValues(leagues), loadDynastyProcess()]);
    } else if (!BACKEND_URL && !STATE.fcPlayerLookup[uniqueTabs[0]]?.size) {
      await Promise.allSettled([fetchAllFcValues(leagues), loadDynastyProcess()]);
    }

    hydrateReturnStatsForLeagues(STATE.leagues).then(() => {
      applyLeagueValuesToRosters(STATE.leagues);
      rebuildAllPlayerValues();
      rerenderActiveView();
    }).catch(() => {
      applyLeagueValuesToRosters(STATE.leagues);
      rebuildAllPlayerValues();
      rerenderActiveView();
    });
  }).catch((e) => console.warn('[hydrate] background', e.message));
}

async function hydrateBackendComposites(tabs) {
  await Promise.allSettled(tabs.map((tab) => loadBackendComposite(tab)));
  for (const tab of tabs) {
    const bundle = STATE.backendComposite[tab];
    if (bundle?.players && Object.keys(bundle.players).length > 0) {
      STATE.valueSource[tab] = 'taco';
    }
  }
}

function isDynastyLeague(lg) {
  const t = lg.settings?.type;
  if (t === 2) return true;
  if (t === 0 && lg.previous_league_id) return true;
  return false;
}

(function wirePortfolioLoadButton() {
  const btn = document.getElementById('fetchBtn');
  if (btn) btn.addEventListener('click', loadEverything);
})();

window.loadEverything = loadEverything;
;
/*! ==== 11-instant-resume.js ==== */
// Instant resume: a refresh reopens the page you were on, straight away.
//
// Owen, 2026-09-27: "When you refresh the site, the page doesnt just reload
// its like the entire site has to reset." Every load re-ran the first-visit
// sequence -- loading screen, bootstrap, all 30 leagues fetched and priced --
// to redraw data that had not changed in the seconds since the last load.
//
// Now each finished load is saved to IndexedDB (6MB for 30 leagues: too big for
// localStorage's ~5MB). On the next load for the same username and season, if
// the copy is from THIS build and under RESUME_MAX_AGE_MS old, the app draws
// from it at once and refreshes in the background (loadEverything's silent
// mode), re-rendering only if something actually changed. Any deploy changes
// the build id and so discards every saved copy: a snapshot written by old code
// is never read by new code.

const RESUME_DB = 'taco-resume';
const RESUME_STORE = 'portfolio';
const RESUME_MAX_AGE_MS = 12 * 60 * 60 * 1000;

/** The build this page is running: the bundle's ?v=, or 'dev' when unbundled. */
function resumeBuildId() {
  const s = document.querySelector('script[src*="taco-app.js"]');
  const m = s && /[?&]v=([^&]+)/.exec(s.getAttribute('src') || '');
  return m ? m[1] : 'dev';
}

function resumeDb() {
  return new Promise((resolve, reject) => {
    if (!window.indexedDB) { reject(new Error('no indexedDB')); return; }
    const req = indexedDB.open(RESUME_DB, 1);
    req.onupgradeneeded = () => { req.result.createObjectStore(RESUME_STORE); };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function resumeKey(username, season) {
  return String(username || '').toLowerCase() + '|' + String(season || '');
}

/** Save the portfolio just loaded. Never throws: resume is a convenience. */
async function resumeSave() {
  try {
    if (!STATE.username || !(STATE.leagues || []).length || STATE.scoutMode) return;
    const db = await resumeDb();
    const tx = db.transaction(RESUME_STORE, 'readwrite');
    // One snapshot per browser: the store is cleared first so switching
    // usernames does not leave another 6MB copy behind.
    tx.objectStore(RESUME_STORE).clear();
    tx.objectStore(RESUME_STORE).put({
      build: resumeBuildId(),
      savedAt: Date.now(),
      userId: STATE.userId,
      userAvatar: STATE.userAvatar,
      userDisplayName: STATE.userDisplayName,
      excludedLeagueCount: STATE.excludedLeagueCount || 0,
      excludedLeagueNames: STATE.excludedLeagueNames || [],
      leagues: STATE.leagues,
    }, resumeKey(STATE.username, STATE.season));
    await new Promise((res, rej) => { tx.oncomplete = res; tx.onerror = () => rej(tx.error); });
    db.close();
  } catch (e) {
    console.warn('[resume] save skipped:', e && e.message);
  }
}
window.resumeSave = resumeSave;

/** A usable snapshot for this username + season, or null. Never throws. */
async function resumeLoad(username, season) {
  try {
    const db = await resumeDb();
    const snap = await new Promise((res, rej) => {
      const req = db.transaction(RESUME_STORE, 'readonly').objectStore(RESUME_STORE).get(resumeKey(username, season));
      req.onsuccess = () => res(req.result || null);
      req.onerror = () => rej(req.error);
    });
    db.close();
    if (!snap || snap.build !== resumeBuildId()) return null;
    if (!(Date.now() - snap.savedAt < RESUME_MAX_AGE_MS)) return null;
    if (!Array.isArray(snap.leagues) || !snap.leagues.length) return null;
    return snap;
  } catch (e) {
    console.warn('[resume] load skipped:', e && e.message);
    return null;
  }
}
window.resumeLoad = resumeLoad;

/**
 * What a re-render would show differently: records, points, rosters and
 * values. The background refresh compares these and leaves the page alone
 * (an open drawer, a half-typed search) when nothing moved.
 */
function resumeSignature(leagues) {
  return JSON.stringify((leagues || []).map((lg) => [
    lg.league_id,
    (lg.allRosters || []).map((r) => [r.rosterId, r.ownerId, r.wins, r.losses, r.ties, r.pointsFor,
      (r.players || []).map((p) => p.playerId + ':' + Math.round(p.value || 0) + (p.isStarter ? 's' : '')).join(',')]),
  ]));
}
window.resumeSignature = resumeSignature;

;
/*! ==== 06-input-wiring.js ==== */
function getUsernameInput() {
  return document.getElementById('usernameInput');
}

function getFetchBtn() {
  return document.getElementById('fetchBtn');
}

function getReadyPill() {
  return document.getElementById('readyPill');
}

// Restore cached username + season for faster repeat visits (Remember Me).
// The prefilled fields alone are easy to miss, so a returning user also gets a
// visible "Welcome back" line that says the site remembered them and it is a
// single tap from here.
try {
  const savedUsername = localStorage.getItem('fo_username');
  const input = getUsernameInput();
  if (savedUsername && input) input.value = savedUsername;
  const savedSeason = localStorage.getItem('fo_season');
  const seasonSel = document.getElementById('seasonInput');
  if (savedSeason && seasonSel && Array.from(seasonSel.options).some((o) => o.value === savedSeason)) {
    seasonSel.value = savedSeason;
  }
  const welcome = document.getElementById('setupWelcomeBack');
  if (welcome && savedUsername) {
    const seasonBit = savedSeason ? ' · ' + savedSeason + ' season ready' : '';
    welcome.innerHTML =
      '<span class="swb-hi">Welcome back, ' +
      savedUsername.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])) +
      '</span>' +
      '<span class="swb-sub">We remembered your details' + seasonBit + ' - just tap Load below.</span>';
    welcome.hidden = false;
  }
} catch (_e) {}

function checkReady() {
  const usernameInput = getUsernameInput();
  const fetchBtn = getFetchBtn();
  const readyPill = getReadyPill();
  if (!usernameInput || !fetchBtn) return;

  const hasUsername = usernameInput.value.trim().length > 0;
  fetchBtn.disabled = !hasUsername;
  if (!readyPill) return;

  if (hasUsername) {
    readyPill.textContent = 'Ready · Live values';
    readyPill.classList.add('live');
    try { localStorage.setItem('fo_username', usernameInput.value.trim()); } catch (_e) {}
  } else {
    readyPill.textContent = 'Need Sleeper username';
    readyPill.classList.remove('live');
  }
}

(function wireSetupInputs() {
  const usernameInput = getUsernameInput();
  if (!usernameInput) return;

  usernameInput.addEventListener('input', checkReady);
  usernameInput.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const btn = getFetchBtn();
      if (btn && !btn.disabled && typeof loadEverything === 'function') loadEverything();
    }
  });
})();

function setFetchBtnLoading(loading) {
  const btn = getFetchBtn();
  if (!btn) return;
  if (loading) {
    btn.dataset.idleLabel = btn.dataset.idleLabel || btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Loading leagues…';
  } else {
    btn.textContent = btn.dataset.idleLabel || 'Load my leagues →';
    checkReady();
  }
}

window.checkReady = checkReady;
window.setFetchBtnLoading = setFetchBtnLoading;
checkReady();

function countTotalPlayers() {
  let n = 0;
  for (const arr of Object.values(STATE.ktcRaw)) n += arr.length;
  return n;
}

// ============================================================
// KTC PARSING
// Parse the community values .xlsx. The relevant tabs are:
// 1QB, 1QB TE+, 1QB TE++, 1QB TE+++, SF, SF TE+, SF TE++, SF TE+++
// The 'Patched Sleeper Database' tab is used for name-mapping.
// Each scoring tab structure (from inspection):
//   Row 0: header row. Col A = "Updated MM/DD/YY at HH:MM(am|pm)" then player-name column
//   Col A (rows 1+): player name
//   Col B: position rank
//   Col C: position
//   Col D: team
//   Col E: value
//   Col F: age
//   Col G: rookie (Yes/No)
// ============================================================
const KTC_TABS = ['1QB', '1QB TE+', '1QB TE++', '1QB TE+++', 'SF', 'SF TE+', 'SF TE++', 'SF TE+++'];

function normalizeName(n) {
  if (!n) return '';
  return n.toLowerCase()
    .replace(/\./g, '')
    .replace(/'/g, '')
    .replace(/'/g, '')
    .replace(/\s+jr\.?$/i, '')
    .replace(/\s+sr\.?$/i, '')
    .replace(/\s+ii+$/i, '')
    .replace(/\s+iv$/i, '')
    .replace(/[^a-z0-9 ]/g, '')
    .trim();
}

function parseKtcWorkbook(wb) {
  STATE.ktcRaw = {};
  STATE.ktcLookup = {};
  for (const tabName of KTC_TABS) {
    if (!wb.SheetNames.includes(tabName)) continue;
    const sheet = wb.Sheets[tabName];
    const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: null });
    // Row 0 is the header row. Data starts at row 1.
    const players = [];
    const lookup = new Map();
    for (let i = 1; i < rows.length; i++) {
      const row = rows[i];
      if (!row || !row[0]) continue;
      const name = String(row[0]).trim();
      // Skip section headers / pick labels (they won't have a position)
      const position = row[2] ? String(row[2]).trim() : null;
      if (!position) continue;
      const player = {
        name,
        posRank: row[1] ? String(row[1]).trim() : '',
        position,
        team: row[3] ? String(row[3]).trim() : '',
        value: row[4] != null ? Number(row[4]) : null,
        age: row[5] != null ? Number(row[5]) : null,
        rookie: row[6] === 'Yes',
      };
      if (player.value == null) continue;
      players.push(player);
      lookup.set(normalizeName(name) + '|' + position, player);
      // Secondary lookup without position (fallback)
      lookup.set(normalizeName(name), player);
    }
    STATE.ktcRaw[tabName] = players;
    STATE.ktcLookup[tabName] = lookup;
  }
}


// ============================================================
// VALUE SOURCE
// Our own composite at /api/composite/<format>, loaded per scoring format in
// module 74. This header used to describe api.fantasycalc.com, which nothing
// on the client has called since 2026-11-03.
// ============================================================

// Map a KTC-style scoring tab ('1QB', 'SF TE+', 'SF TE++', etc.) to FantasyCalc
// API query parameters. FC's dynasty API doesn't reliably support tePremium as
// a query param — passing one gets you a different value scale entirely that
// doesn't match their public website. We use just numQbs + ppr + numTeams,
// matching exactly what their own trade calculator uses.
// The landing hero asks for the username directly, so it needs somewhere to go.
//
// It navigates to /u/<name> rather than reproducing the connect flow inline.
// That route already boots a portfolio from a cold load -- it is the same path a
// shared link takes -- so there is one loading path to keep working instead of
// two, and the visitor lands on a URL they can bookmark or pass on.
//
// A full navigation, not a pushState: the router's boot handles /u/ and is
// verified to; re-entering it is worth more than saving one page load on the
// one click that matters most on this site.
(function wireHeroUsernameForm() {
  const form = document.getElementById('lpHeroForm');
  if (!form) return;
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const input = document.getElementById('lpHeroUser');
    const name = (input?.value || '').trim().replace(/^@+/, '');
    const R = window.TacoRoutes || {};
    // A pasted Sleeper league link asks to scout that league, not to sign in. A
    // bare number stays on the username path: it may be someone signing in, and
    // the league-ID picker there offers both.
    if (/sleeper\.(com|app)/i.test(name) && R.scoutPath) {
      const scout = R.scoutPath(name);
      if (scout) {
        window.location.assign(scout);
        return;
      }
    }
    const path = R.userPath ? R.userPath(name) : null;
    // Empty or implausible: hand them the full form, which explains what a
    // Sleeper username is and what it is not. Guessing on their behalf here
    // would just produce a "no leagues found" they cannot act on.
    if (!path) {
      window.location.assign('/connect');
      return;
    }
    try { localStorage.setItem('fo_username', name); } catch (_e) {}
    window.location.assign(path);
  });
})();

;
/*! ==== 07-dynastyprocess-expert-consensus-values-from-fant.js ==== */
// DP publishes their full ranking dataset as a CSV on GitHub, refreshed
// weekly via Github Actions.
//
// This is NOT a value source. Our own engine prices every player; DP is
// loaded for comparison only -- Market Radar, the drawer's Market panel, and
// the rookie tier breaks -- so a user can see where public expert rankings
// disagree with our real-trade price. It must never feed back into a value
// (that path was removed from lookupPlayerValue on 2026-11-03).
//
// Two files we need:
//   1. values.csv — columns: player, pos, team, age, draft_year, ecr_1qb,
//      ecr_2qb, ecr_pos, value_1qb, value_2qb, fp_id, ...
//   2. db_playerids.csv — maps fp_id (FantasyPros ID) → sleeper_id, so we
//      can join back to our roster data.
//
// Both files are cached in memory after first load, refreshed on every page
// reload (no need for TTL — they only update weekly anyway).
// Direct upstream fetch (the DynastyProcess GitHub CSVs). Values are loaded
// separately via loadBackendComposite().
async function fetchSourceData(_source, _format, directUrl) {
  return fetch(directUrl);
}

const DP_VALUES_URL = 'https://raw.githubusercontent.com/dynastyprocess/data/master/files/values.csv';
const DP_PLAYERIDS_URL = 'https://raw.githubusercontent.com/dynastyprocess/data/master/files/db_playerids.csv';

// Backend composite keys — 1QB/SF + TEP tiers (nightly FC+DP+KTC on Worker).
// Delegates. The local copy differed from the shared one only in quote style
// on one key, which is exactly how these drift: identical today, and the next
// format tier gets added to whichever copy the author happened to open.
function scoringTabToBackendKey(tab) {
  return TacoCore.scoringTabToBackendKey(tab);
}

const BACKEND_COMPOSITE_PROMISES = {};

async function loadBackendComposite(scoringTab) {
  if (!BACKEND_URL) return null;
  if (STATE.backendComposite[scoringTab]) return STATE.backendComposite[scoringTab];
  const formatKey = scoringTabToBackendKey(scoringTab);
  if (!formatKey) return null;

  if (!BACKEND_COMPOSITE_PROMISES[formatKey]) {
    BACKEND_COMPOSITE_PROMISES[formatKey] = (async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/api/composite/${formatKey}`);
        if (!res.ok) {
          console.warn(`[backend] composite ${formatKey} returned ${res.status}`);
          return null;
        }
        const data = await res.json();
        const playerMap = {};

        // composite-v2 carries no rank and its values array is not sorted, so
        // rank is ours to compute -- from the same numbers, in the same order,
        // as the per-tab lookups in module 74, so the board and the drawer
        // cannot disagree about who is RB3. position_rank used to read
        // v.fc?.posRank || v.ktc?.posRank, neither of which composite-v2 has
        // emitted since the 2026-07-11 cutover, so every row's rank was null.
        const overallRankById = {};
        const posRankById = {};
        const rankable = (data.values || [])
          .filter((v) => v.sleeperId && v.position !== 'PICK' && (v.composite?.weightedValue ?? 0) > 0)
          .sort((a, b) => (b.composite.weightedValue || 0) - (a.composite.weightedValue || 0));
        const seenAtPos = {};
        rankable.forEach((v, i) => {
          overallRankById[v.sleeperId] = i + 1;
          const pos = v.position || '?';
          seenAtPos[pos] = (seenAtPos[pos] || 0) + 1;
          posRankById[v.sleeperId] = `${pos}${seenAtPos[pos]}`;
        });

        for (const v of data.values || []) {
          if (!v.sleeperId) continue;
          // The sources shown to users are the first-party engine's own
          // sub-signals -- trailing production, draft market, real observed
          // trades -- because those are what actually determine the number.
          //
          // fc/dp/ktc used to be carried here as well. composite-v2 has never
          // emitted them, so they were null on every row, which left the
          // drawer's Value Sources section empty (its agreement strip needs
          // two entries) while resolveConsensusValue kept a live code path
          // that would have PREFERRED a third-party price over ours if one
          // ever appeared. Dropped, so neither can happen.
          const c = v.composite || {};
          const sources = {
            trade_implied: v.trade_implied || null,
            stats: c.stats_value > 0 ? { value: c.stats_value } : null,
            adp: c.adp_value > 0 ? { value: c.adp_value } : null,
          };
          const row = { sources, consensus_value: c.weightedValue ?? 0, position: v.position };
          const consensus_value = resolveBackendConsensusValue(row, scoringTab, v.position);
          playerMap[v.sleeperId] = {
            consensus_value,
            consensus_rank: overallRankById[v.sleeperId] ?? (c.medianRank ?? null),
            position_rank: posRankById[v.sleeperId] || null,
            agreement_score: v.composite?.agreement ?? null,
            position: v.position,
            team: v.team,
            age: v.age,
            rookie: false,
            sources,
            primary_blend: c.primary_blend || 'first_party',
            trade_implied: v.trade_implied || null,
            momentum_1d: v.composite?.momentum_1d ?? null,
            momentum_7d: v.composite?.momentum_7d ?? null,
            momentum_30d: v.composite?.momentum_30d ?? null,
            range_low: v.composite?.range_low ?? null,
            range_high: v.composite?.range_high ?? null,
            market_divergence_pct: v.composite?.market_divergence_pct ?? null,
            tags: v.tags || [],
            // First-party engine's real-trade sample size for this player/format
            // (taco-backend's buildCompositeShape) -- was being dropped here even
            // though the raw API response already carries it, silently zeroing
            // out the trade-confidence badge for every player.
            n_trades: v.composite?.n_trades ?? 0,
            n_leagues: v.composite?.n_leagues ?? 0,
          };
        }
        const bundle = { _meta: data._meta, players: playerMap, values: data.values || [] };
        console.log(`[backend] loaded composite ${formatKey}: ${Object.keys(playerMap).length} players`);
        return bundle;
      } catch (e) {
        console.warn(`[backend] composite ${formatKey} fetch failed:`, e.message);
        return null;
      }
    })();
  }

  const bundle = await BACKEND_COMPOSITE_PROMISES[formatKey];
  if (bundle) STATE.backendComposite[scoringTab] = bundle;
  return STATE.backendComposite[scoringTab] || null;
}

let DP_LOAD_PROMISE = null;

// Loads DP values + playerIds, joins them on fp_id, populates STATE.dpLookup
// keyed by sleeperId. Idempotent — multiple callers get the same in-flight
// promise, so we never fetch twice in one session.
async function loadDynastyProcess() {
  if (STATE.dpLookup && Object.keys(STATE.dpLookup).length > 0) return STATE.dpLookup;
  if (DP_LOAD_PROMISE) return DP_LOAD_PROMISE;

  DP_LOAD_PROMISE = (async () => {
    try {
      console.log('[DP] fetching values + player IDs from GitHub');
      const [valuesText, idsText] = await Promise.all([
        fetchCsvWithFallback(DP_VALUES_URL),
        fetchCsvWithFallback(DP_PLAYERIDS_URL),
      ]);
      if (!valuesText || !idsText) {
        console.warn('[DP] fetch failed for values or playerIds');
        STATE.dpLookup = {};
        return STATE.dpLookup;
      }

      // Parse playerIds first to build fp_id → sleeper_id map
      const idsRows = parseCsvSimple(idsText);
      const fpToSleeper = {};
      for (const row of idsRows) {
        const fpId = row.fantasypros_id;
        const sleeperId = row.sleeper_id;
        if (fpId && sleeperId) fpToSleeper[fpId] = sleeperId;
      }
      console.log(`[DP] mapped ${Object.keys(fpToSleeper).length} fantasypros→sleeper IDs`);

      // Parse values; key by sleeper_id when joinable
      const valueRows = parseCsvSimple(valuesText);
      const lookup = {};
      let joined = 0;
      for (const row of valueRows) {
        const fpId = row.fp_id;
        const sleeperId = fpToSleeper[fpId];
        if (!sleeperId) continue;  // can't join — skip
        lookup[sleeperId] = {
          name: row.player,
          position: row.pos,
          team: row.team,
          age: row.age ? parseFloat(row.age) : null,
          draftYear: row.draft_year ? parseInt(row.draft_year) : null,
          ecr1qb: row.ecr_1qb ? parseFloat(row.ecr_1qb) : null,
          ecr2qb: row.ecr_2qb ? parseFloat(row.ecr_2qb) : null,
          ecrPos: row.ecr_pos ? parseFloat(row.ecr_pos) : null,
          value1qb: row.value_1qb ? parseInt(row.value_1qb) : null,
          value2qb: row.value_2qb ? parseInt(row.value_2qb) : null,
        };
        joined++;
      }
      console.log(`[DP] loaded ${joined} player values (joined on sleeper_id)`);
      STATE.dpLookup = lookup;
      return lookup;
    } catch (e) {
      console.error('[DP] load failed:', e);
      STATE.dpLookup = {};
      return STATE.dpLookup;
    }
  })();
  return DP_LOAD_PROMISE;
}

// Fetches a CSV from a URL, trying direct first, then falling back through
// our CORS proxy chain. raw.githubusercontent.com sends `Access-Control-
// Allow-Origin: *` so direct works in most browsers — but if a user has an
// extension or corporate filter that breaks it, the proxies catch us.

;
/*! ==== 08-market-aggregation-via-dynasty-daddy-practice-in.js ==== */
// Dynasty Daddy aggregates ~10 fantasy markets daily into a Postgres DB
// served by an open-source Express API. We pull every market they expose,
// blend the ones we care about into our composite, and surface the per-
// source breakdown in the player drawer. PRACTICE INTEGRATION — long-term
// we'll run our own scraper Workers (one per source) and Dynasty Daddy
// drops out of the dependency chain.
//
// Endpoint confirmed via DevTools inspection:
//   GET https://dynasty-daddy.com/api/v1/player/all/today?market={N}
// Returns JSON array of player rows. Confirmed fields:
//   sleeper_id, mfl_id, full_name, first_name, last_name, position, team,
//   age, experience, injury_status, depth_chart, date,
//   trade_value, sf_trade_value, position_rank, sf_position_rank, ...
//
// We discover the available markets dynamically at runtime (their app
// loads a config endpoint that lists them with IDs + names). If discovery
// fails we fall back to probing a hardcoded list of likely IDs (1-15).
// Our Cloudflare Worker that proxies CORS-restricted APIs. Source code lives
// in the Cloudflare dashboard at workers.dev. Allowlist is enforced server-side
// (only dynasty-daddy.com, api.sleeper.com, api.sleeper.app, api.fantasycalc.com,
// raw.githubusercontent.com). Caches responses for 1 hour upstream.
//
// Usage pattern: TACO_PROXY + '/?url=' + encodeURIComponent(targetUrl)
const TACO_PROXY = 'https://taco-proxy.owenpodoll.workers.dev';

const DD_BASE_URL = 'https://dynasty-daddy.com/api/v1';
const DD_FETCH_TIMEOUT_MS = 10000;

// Hardcoded market IDs confirmed via DevTools inspection on dynasty-daddy.com.
// Each `today?market=N` returns the same player schema (sleeper_id, position,
// trade_value, sf_trade_value, etc.) — only the source of the trade value
// differs. We pull each market in parallel and blend them ourselves.
const DD_KNOWN_MARKETS = [
  { id: 14, key: 'dd_aggregate', label: 'Dynasty Daddy Aggregate' },
  { id: 0,  key: 'ktc',          label: 'KeepTradeCut' },
  { id: 2,  key: 'dp',           label: 'DynastyProcess' },
  { id: 3,  key: 'fn',           label: 'FantasyNavigator' },
  { id: 6,  key: 'adp_daddy',    label: 'ADP Daddy' },
  { id: 9,  key: 'pfn',          label: 'Pro Football Network' },
  { id: 12, key: 'draftsharks',  label: 'Draftsharks' },
  // FantasyCalc and DynastySuperflex IDs not yet confirmed — to be added
  // when Owen surfaces them via DevTools.
];

let DD_LOAD_PROMISE = null;

// Fetch a single Dynasty Daddy market's player values via our taco-proxy
// Worker. Dynasty Daddy doesn't send CORS headers, so we route through our
// own Worker which adds them. Worker also caches for 1 hour.
async function fetchDdMarket(marketId, isSF) {
  const targetUrl = `${DD_BASE_URL}/player/all/today?market=${marketId}`;
  const proxiedUrl = `${TACO_PROXY}/?url=${encodeURIComponent(targetUrl)}`;

  try {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), DD_FETCH_TIMEOUT_MS);
    const res = await fetch(proxiedUrl, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      signal: ctrl.signal,
    });
    clearTimeout(timer);
    if (!res.ok) {
      console.warn(`[DD] market=${marketId} returned ${res.status} via proxy`);
      return null;
    }
    const data = await res.json();
    const rows = Array.isArray(data) ? data : (data.data || data.values || data.players);
    if (!Array.isArray(rows) || rows.length < 50) return null;
    const lookup = {};
    for (const row of rows) {
      const sid = row.sleeper_id;
      if (!sid) continue;
      const v = isSF ? row.sf_trade_value : row.trade_value;
      if (v == null) continue;
      lookup[sid] = {
        value: parseInt(v),
        posRank: isSF ? row.sf_position_rank : row.position_rank,
        name: row.full_name,
        position: row.position,
        team: row.team,
      };
    }
    return Object.keys(lookup).length > 0 ? lookup : null;
  } catch (e) {
    console.warn(`[DD] market=${marketId} fetch failed:`, e.message);
    return null;
  }
}

async function loadDdMarkets(scoringTab) {
  const isSF = scoringTab && scoringTab.startsWith('SF');
  const formatKey = isSF ? 'sf' : '1qb';

  if (STATE.ddMarkets?.[formatKey]) return STATE.ddMarkets[formatKey];
  if (DD_LOAD_PROMISE) return DD_LOAD_PROMISE;

  STATE.ddMarkets = STATE.ddMarkets || {};

  DD_LOAD_PROMISE = (async () => {
    try {
      // Fetch each known market in parallel. Each market keyed by its `key`
      // (ktc, dd_aggregate, etc.) — the composite uses these keys directly.
      const results = await Promise.all(DD_KNOWN_MARKETS.map(async (m) => {
        const lookup = await fetchDdMarket(m.id, isSF);
        return { market: m, lookup };
      }));

      const byKey = {};
      let totalLoaded = 0;
      for (const { market, lookup } of results) {
        if (!lookup) {
          console.warn(`[DD] market="${market.label}" id=${market.id} returned no data`);
          continue;
        }
        byKey[market.key] = lookup;
        totalLoaded += Object.keys(lookup).length;
        console.log(`[DD] market="${market.label}" id=${market.id} → ${Object.keys(lookup).length} values`);
      }

      const result = { byKey };
      STATE.ddMarkets[formatKey] = result;
      // Composite values for all players just shifted; rebuild threshold cache
      STATE._startableThresholdCache = {};
      console.log(`[DD] loaded ${Object.keys(byKey).length}/${DD_KNOWN_MARKETS.length} markets, ${totalLoaded} total values (${formatKey})`);
      return result;
    } catch (e) {
      console.warn('[DD] load failed:', e.message);
      STATE.ddMarkets[formatKey] = { byKey: {} };
      return STATE.ddMarkets[formatKey];
    } finally {
      DD_LOAD_PROMISE = null;
    }
  })();
  return DD_LOAD_PROMISE;
}
window.loadDdMarkets = loadDdMarkets;

// Sleeper trending players (last 24h adds + drops, league-wide on Sleeper).
// Independent signal from FC's 30-day value trend — captures hour-scale
// breakouts (Monday night injury → backup adds spike) before dynasty rankings
// react. Drops complement adds: high adds + high drops on the same player =
// noise; high adds + low drops = real consensus pickup.
//   STATE.sleeperTrending = { [playerId]: { adds: 1234 } }
//   STATE.sleeperDropping = { [playerId]: { drops: 567 } }
async function loadSleeperTrending() {
  const fetchOne = async (kind) => {
    try {
      // Our own API, fetched directly: it allows the site's origin. Wrapping it
      // in TACO_PROXY (as this did from the June baseline to 2026-09-27) got a
      // 403 every time -- the proxy only forwards to its own allowlist -- so
      // trending adds/drops were silently empty for the waiver panel.
      const res = await fetch(BACKEND_URL + '/api/sleeper/v1/players/nfl/trending/' + kind + '?lookback_hours=24&limit=50');
      if (!res.ok) throw new Error(`Sleeper ${kind} HTTP ${res.status}`);
      const rows = await res.json();
      const arr = Array.isArray(rows) ? rows : Array.from(rows || []);
      const byId = {};
      for (const row of arr) {
        if (row.player_id) byId[row.player_id] = { count: row.count || 0 };
      }
      return byId;
    } catch (err) {
      console.warn(`[trending] ${kind} fetch failed, skipping:`, err.message);
      return {};
    }
  };
  const [addsRaw, dropsRaw] = await Promise.all([fetchOne('add'), fetchOne('drop')]);
  // Normalize to the shape downstream code expects
  STATE.sleeperTrending = {};
  for (const [pid, v] of Object.entries(addsRaw)) STATE.sleeperTrending[pid] = { adds: v.count };
  STATE.sleeperDropping = {};
  for (const [pid, v] of Object.entries(dropsRaw)) STATE.sleeperDropping[pid] = { drops: v.count };
  console.log(`[trending] loaded ${Object.keys(STATE.sleeperTrending).length} adds, ${Object.keys(STATE.sleeperDropping).length} drops (last 24h)`);
  STATE._waiverCache = null;
  STATE._waiverServerCache = null;
  return { adds: STATE.sleeperTrending, drops: STATE.sleeperDropping };
}
window.loadSleeperTrending = loadSleeperTrending;

// Look up a player's values across all DD markets we have.
function getDdValuesForPlayer(sleeperId, scoringTab) {
  const isSF = scoringTab && scoringTab.startsWith('SF');
  const formatKey = isSF ? 'sf' : '1qb';
  const byKey = STATE.ddMarkets?.[formatKey]?.byKey;
  if (!byKey) return {};
  const out = {};
  for (const [key, lookup] of Object.entries(byKey)) {
    const entry = lookup[sleeperId];
    if (entry?.value > 0) out[key] = entry;
  }
  return out;
}
window.getDdValuesForPlayer = getDdValuesForPlayer;

// Debug helper. Run from console: tacoDebug('11543') for Tucker Kraft etc.
// Dumps every value source's view of the player + the cached roster values.
window.tacoDebug = function tacoDebug(sleeperId) {
  console.group(`[tacoDebug] ${sleeperId}`);
  const p = STATE.playersDB?.[sleeperId];
  console.log('player:', p ? `${p.full_name} (${p.position} ${p.team})` : 'NOT IN playersDB');
  for (const lg of STATE.leagues) {
    const tab = lg.scoringTab;
    const dd = getDdValuesForPlayer(sleeperId, tab);
    const dp = lookupDpValue(sleeperId, tab);
    const fc = STATE.fcPlayerLookup?.[tab]?.get(sleeperId);
    const composite = computeCompositeValue(sleeperId, tab, fc?.value);
    const lookupResult = lookupPlayerValue(sleeperId, p?.full_name, p?.position, tab);
    // Find the player on every roster
    const onRosters = [];
    for (const r of (lg.allRosters || [])) {
      const found = r.players.find(rp => rp.playerId === sleeperId);
      if (found) onRosters.push({ ownerName: r.ownerName, value: found.value });
    }
    console.log(`league="${lg.name}" tab=${tab}:`);
    console.log('  FC raw:', fc?.value);
    console.log('  DP:', dp?.value);
    console.log('  DD markets:', dd);
    console.log('  composite output:', composite);
    console.log('  lookupPlayerValue output:', lookupResult);
    console.log('  cached on rosters:', onRosters);
  }
  console.groupEnd();
};

// Backward-compat shim. Returns the DD aggregate value if KTC isn't available.
function getKtcValue(sleeperId, scoringTab) {
  const isSF = scoringTab && scoringTab.startsWith('SF');
  const formatKey = isSF ? 'sf' : '1qb';
  const byKey = STATE.ddMarkets?.[formatKey]?.byKey;
  if (!byKey) return null;
  return byKey.ktc?.[sleeperId] || byKey.dd_aggregate?.[sleeperId] || null;
}
window.getKtcValue = getKtcValue;



async function fetchCsvWithFallback(url) {
  // Direct attempt
  try {
    const res = await fetch(url, { method: 'GET' });
    if (res.ok) return await res.text();
  } catch (_e) {
    console.warn('[csv] direct fetch failed for', url, '- trying proxies');
  }
  // Proxy fallbacks (reuse the news proxy chain)
  for (let i = 0; i < NEWS_PROXIES.length; i++) {
    try {
      const proxyUrl = NEWS_PROXIES[i](url);
      const res = await fetch(proxyUrl, { method: 'GET' });
      if (res.ok) {
        const text = await res.text();
        if (text && text.length > 100) return text;
      }
    } catch (_e) {
      console.warn('[csv] proxy', i + 1, 'failed for', url);
    }
  }
  return null;
}

// Tiny CSV parser — handles quoted fields with embedded commas. Returns array
// of objects keyed by header. NOT a full RFC 4180 parser — adequate for
// well-formed DP data, which is auto-generated and clean.
function parseCsvSimple(text) {
  const lines = text.split(/\r?\n/).filter(l => l.length > 0);
  if (lines.length === 0) return [];
  const headers = parseCsvLine(lines[0]);
  const rows = [];
  for (let i = 1; i < lines.length; i++) {
    const fields = parseCsvLine(lines[i]);
    const row = {};
    for (let j = 0; j < headers.length; j++) {
      row[headers[j]] = fields[j] || '';
    }
    rows.push(row);
  }
  return rows;
}

function parseCsvLine(line) {
  const fields = [];
  let cur = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const ch = line[i];
    if (ch === '"') {
      if (inQuotes && line[i + 1] === '"') { cur += '"'; i++; }
      else inQuotes = !inQuotes;
    } else if (ch === ',' && !inQuotes) {
      fields.push(cur);
      cur = '';
    } else {
      cur += ch;
    }
  }
  fields.push(cur);
  return fields;
}

// Look up DP value for a sleeperId, in the right format. Returns null if no
// data, or { value, ecr, ecrPos } if found.
function lookupDpValue(sleeperId, scoringTab) {
  const dp = STATE.dpLookup?.[sleeperId];
  if (!dp) return null;
  const isSF = scoringTab.startsWith('SF');
  const value = isSF ? dp.value2qb : dp.value1qb;
  const ecr = isSF ? dp.ecr2qb : dp.ecr1qb;
  if (value == null || value <= 0) return null;
  return { value, ecr, ecrPos: dp.ecrPos };
}

;
/*! ==== 74-fc-value-fetch.js ==== */
// Player and pick value lookups for every scoring format.
//
// The filename and the STATE.fc* keys are historical. This module used to
// fetch api.fantasycalc.com; it does not any more (Owen, 2026-11-03: "fix
// that, i have told you many times to fix that"). Every number here comes
// from our own composite -- /api/composite/<format>, written by the
// first-party value engine from real Sleeper trades blended with trailing
// stats and ADP. Renaming the STATE keys is a separate mechanical change:
// they are read in a dozen modules, and the data in them is ours either way.
//
// What the old shape actually did, since it is worth not re-introducing: it
// fetched FantasyCalc for the whole player universe, built the lookups from
// it, then overlaid the composite on top -- but only over the VALUE field,
// and only for players the composite priced. So names, positions, ages,
// teams, overall and position ranks and the 30-day trend were all
// FantasyCalc's, and any player the composite did not price kept
// FantasyCalc's number outright. "Our values are first-party" was true of the
// engine and not true of the page.

// TE premium: the engine prices each TE-premium format separately, so a TEP
// league loads the TEP composite and its values already carry the premium.
// Do NOT apply TacoCore.tePremiumMultiplier on top of a composite value --
// that double-counts. The multiplier exists for third-party market numbers
// (KTC publishes no TEP tabs), which we now show only for comparison.

// Our composite is a value table, not a board: it carries no per-player rank
// and its values array is not even sorted. So rank is ours to compute, from
// the same numbers the page displays, which is the only way the board and the
// drawer cannot disagree about who is RB3. Before this, overallRank came from
// FantasyCalc's `rank` and posRank from its `posRank` -- composite-v2 emits
// neither, so both were silently null on every player the composite priced.
function assignCompositeRanks(entries) {
  const ranked = entries.filter((e) => e.position !== 'PICK' && e.value > 0);
  ranked.sort((a, b) => b.value - a.value);
  const seenAtPos = {};
  ranked.forEach((e, i) => {
    e.overallRank = i + 1;
    const pos = e.position || '?';
    seenAtPos[pos] = (seenAtPos[pos] || 0) + 1;
    e.posRank = `${pos}${seenAtPos[pos]}`;
  });
}

// Momentum is a PERCENT move (taco-backend/src/momentum.js). trend30Day is a
// point delta: formatTrend() hides anything under 50 and prints the number
// with a thousands separator, so handing it a percent would render "+155" as
// 155 value points. The conversion is exact, not an estimate --
// value_now = value_then * (1 + m/100).
function pointDeltaFromMomentum(value, momentumPct) {
  if (!(value > 0)) return 0;
  if (typeof momentumPct !== 'number' || !isFinite(momentumPct)) return 0;
  const ratio = 1 + momentumPct / 100;
  if (ratio <= 0) return 0;
  return Math.round(value - value / ratio);
}
window.pointDeltaFromMomentum = pointDeltaFromMomentum;

// Build the player and pick lookups for one scoring tab from our composite.
function hydrateFcLookupsFromComposite(tab, data) {
  const playerLookup = new Map();
  const pickLookup = new Map();
  const rawEntries = [];
  let maxValue = 0;

  for (const v of data.values || []) {
    const parsed = TacoCore.parseFcPickName(v.name);
    const isPick = v.position === 'PICK' || parsed !== null;
    if (isPick && parsed) {
      const value = capDynastyValue(v.composite?.weightedValue ?? 0);
      if (value > maxValue) maxValue = value;
      const entry = {
        name: v.name,
        sleeperId: v.sleeperId || null,
        position: 'PICK',
        value,
        season: parsed.season,
        round: parsed.round,
        slot: parsed.slot,
        bucket: parsed.bucket,
      };
      rawEntries.push(entry);
      pickLookup.set(parsed.key, entry);
      continue;
    }
    if (!v.sleeperId) continue;

    const value = capDynastyValue(v.composite?.weightedValue ?? 0);
    if (value > maxValue) maxValue = value;
    const momentum30d = v.composite?.momentum_30d ?? null;

    const entry = {
      name: v.name,
      sleeperId: v.sleeperId,
      position: v.position,
      team: v.team ?? null,
      age: v.age ?? null,
      rookie: false,
      value,
      overallRank: null,
      posRank: null,
      momentum30d,
      momentum7d: v.composite?.momentum_7d ?? null,
      trend30Day: pointDeltaFromMomentum(value, momentum30d),
      stdev: 0,
    };
    rawEntries.push(entry);
    playerLookup.set(v.sleeperId, entry);
  }

  assignCompositeRanks(rawEntries);

  STATE.fcRaw[tab] = rawEntries;
  STATE.fcPlayerLookup[tab] = playerLookup;
  STATE.fcPickLookup[tab] = pickLookup;
  STATE.fcMaxValue[tab] = maxValue;
}

// Load values for a single scoring tab from our composite.
async function fetchFcValues(tab) {
  if (STATE.fcPlayerLookup[tab]?.size > 0) return;

  const backendKey = scoringTabToBackendKey(tab);
  if (!BACKEND_URL || !backendKey) {
    console.warn(`[values] no backend for ${tab}`);
    STATE.fcPlayerLookup[tab] = new Map();
    STATE.fcPickLookup[tab] = new Map();
    return;
  }

  try {
    const bundle = await loadBackendComposite(tab);
    if (!bundle?.values?.length) throw new Error('composite returned no values');
    hydrateFcLookupsFromComposite(tab, bundle);
    console.log(`[values] ${tab}: ${STATE.fcPlayerLookup[tab].size} players, ${STATE.fcPickLookup[tab].size} picks (first-party)`);
    snapshotValuesToHistory();
  } catch (err) {
    // No silent third-party fallback. A wrong number dressed as ours is worse
    // than an honest empty state, and showError() already tells the user to
    // refresh.
    console.error(`[values] failed for ${tab}:`, err);
    STATE.fcPlayerLookup[tab] = new Map();
    STATE.fcPickLookup[tab] = new Map();
  }
}

// Load values for every scoring format in play. One composite fetch per
// format key; a league's tab that maps to the same key reuses the lookup.
//
// The TE-premium formats each have their own composite, so they load their
// own. Non-TEP tabs share the base (1QB / SF) lookup by reference, which is
// safe only because nothing downstream mutates a lookup entry per tab -- the
// value already carries everything format-specific the engine applied.
async function fetchAllFcValues(leagues) {
  const uniqueTabs = [...new Set(leagues.map(lg => detectScoringTab(lg)))];
  const baseTabFor = (tab) => tab.startsWith('SF') ? 'SF' : '1QB';
  const uniqueBases = [...new Set(uniqueTabs.map(baseTabFor))];

  const results = await Promise.allSettled(uniqueBases.map(base => fetchFcValues(base)));
  const failures = results.filter(r => r.status === 'rejected');
  if (failures.length) {
    console.warn(`[values] ${failures.length}/${results.length} base loads failed`);
  }

  for (const tab of uniqueTabs) {
    const base = baseTabFor(tab);

    if (tab.includes('TE+')) {
      await fetchFcValues(tab);
    } else {
      STATE.fcRaw[tab] = STATE.fcRaw[base] || [];
      STATE.fcPlayerLookup[tab] = STATE.fcPlayerLookup[base] || new Map();
      STATE.fcPickLookup[tab] = STATE.fcPickLookup[base] || new Map();
      STATE.fcMaxValue[tab] = STATE.fcMaxValue[base] || 0;
      if (STATE.backendComposite[base] && !STATE.backendComposite[tab]) {
        STATE.backendComposite[tab] = STATE.backendComposite[base];
      }
    }

    // 'taco' means the number on screen came from our own engine. It used to
    // say 'fc' here, which is what put "FantasyCalc only" under the value in
    // the player drawer for every player on the site.
    const hasOurs = STATE.fcPlayerLookup[tab]?.size > 0
      || (STATE.backendComposite[tab]?.players
        && Object.keys(STATE.backendComposite[tab].players).length > 0);
    if (hasOurs) {
      STATE.valueSource[tab] = 'taco';
    } else if (STATE.ktcLookup[tab]?.size > 0) {
      STATE.valueSource[tab] = 'ktc';
    } else {
      STATE.valueSource[tab] = null;
    }
  }
}

;
/*! ==== 09-composite-ranking-blend-fc-dp-into-a-single-valu.js ==== */
// Why: FC alone is too dependent on one source's algorithm. If the public-
// Sleeper-trade market is irrational about a player (over-discounting after
// a coordinator change, late-year depth chart shift, etc.), FC carries that
// market irrationality directly into our app. DP is FantasyPros expert
// consensus — different methodology, different biases, smooths the weirdness.
//
// We ALWAYS prefer the composite when both sources are available. When only
// one is available (rookies that aren't yet in DP, deep-bench players FC
// hasn't priced, etc.), we fall back to the available source with a flag.
//
// The composite is a simple weighted average. Initial weights:
//   FC   = 0.50  (real-trade signal, fast-reacting)
//   DP   = 0.50  (expert consensus, slow-reacting, broader analyst input)
//
// We may tune later (e.g., weight FC more in-season when trades are happening,
// weight DP more in offseason) but this is a sane starting point.
// PRACTICE INTEGRATION POLICY: KTC-only when KTC is available.
//
// Originally we blended FC + DP + KTC + 5 other DD-sourced markets, weighted-
// averaging everything. Result: rookies (Tate, Kraft, Judkins) ended up with
// composite values pulled DOWN by sources that haven't priced them yet (DP
// expert consensus lags, ADP-derived values drift). Even with KTC weighted
// 1.5×, the average dragged rookies below startable.
//
// Decision: lock to KTC when present. KTC is the most popular crowd-trade
// signal in the dynasty community and what users compare against. FC and DP
// stay as fallbacks for players KTC doesn't cover (older retired players,
// edge cases). When the real backend ships with our own scrapers and trade
// crawl, we'll revisit the blend strategy with proper sample-size logic.
const COMPOSITE_WEIGHTS = {
  fc:           1.0,   // fallback only when KTC missing
  dp_direct:    1.0,   // fallback only when KTC missing
  // All other DD market weights kept defined so the lookup function works,
  // but the composite logic below ignores them entirely when KTC is present.
  dd_aggregate: 0,
  ktc:          0,     // weight unused — KTC is selected directly when present
  dp:           0,
  fn:           0,
  pfn:          0,
  draftsharks:  0,
  adp_daddy:    0,
};

function computeCompositeValue(sleeperId, scoringTab, fcValue) {
  const dpData = lookupDpValue(sleeperId, scoringTab);
  const dpValue = dpData?.value || null;
  const ddValues = getDdValuesForPlayer(sleeperId, scoringTab);
  const ktcEntry = ddValues?.ktc || null;

  // KTC IS the value when present. Skip the blend entirely.
  if (ktcEntry?.value > 0) {
    // TEP fix: Dynasty Daddy's KTC market doesn't expose per-TEP-tier values —
    // it serves one set per 1QB/SF, with no TE+ / TE++ / TE+++ variants.
    // So in TEP leagues, raw ktcEntry.value is the BASE-format TE value, which
    // is too low. Apply the same tePremiumMultiplier the FC path uses (15/30/45%
    // bump for TE+ / TE++ / TE+++). For non-TEs the multiplier is 1.00 and
    // this is a no-op. This matches what KTC's own TEP tabs publish.
    const tepMult = (ktcEntry.position === 'TE') ? TacoCore.tePremiumMultiplier(scoringTab, ktcEntry.value) : 1.00;
    const ktcAdjusted = Math.min(9999, Math.round(ktcEntry.value * tepMult));

    // Build a sources object for the drawer that still surfaces the other
    // sources we have for transparency, even though they don't influence the
    // primary value. Users can see "KTC says 5,600 vs FC says 1,800".
    // Surface raw KTC + the multiplier separately so the drawer can show
    // "KTC 4,500 → 5,850 (TE++)" if we want that affordance later.
    const sources = {
      ktc: { value: ktcAdjusted, posRank: ktcEntry.posRank, rawValue: ktcEntry.value, tepMult }
    };
    if (fcValue != null && fcValue > 0) sources.fc = { value: fcValue };
    if (dpValue != null && dpValue > 0) sources.dp_direct = { value: dpValue, ecr: dpData.ecr, ecrPos: dpData.ecrPos };
    for (const [k, entry] of Object.entries(ddValues)) {
      // Apply the same TEP bump to OTHER market values for TEs — same reasoning;
      // none of DD's markets break out TEP values, so all of them are
      // base-format for TEs.
      if (k === 'ktc') continue;
      if (entry?.value > 0) {
        const mult = (entry.position === 'TE') ? tepMult : 1.00;
        sources[k] = { value: Math.round(entry.value * mult), posRank: entry.posRank, rawValue: entry.value, tepMult: mult };
      }
    }
    return {
      value: ktcAdjusted,
      sources,
      confidence: 1.0,
      blend: 'ktc',
    };
  }

  // KTC missing — fall back to FC + DP blend (legacy two-source composite)
  const present = [];
  if (fcValue != null && fcValue > 0) {
    present.push({ k: 'fc', v: fcValue, w: COMPOSITE_WEIGHTS.fc });
  }
  if (dpValue != null && dpValue > 0) {
    present.push({ k: 'dp_direct', v: dpValue, w: COMPOSITE_WEIGHTS.dp_direct });
  }

  if (present.length === 0) return null;

  const totalWeight = present.reduce((s, p) => s + p.w, 0);
  const composite = Math.min(9999, Math.round(present.reduce((s, p) => s + p.v * (p.w / totalWeight), 0)));

  const sources = {};
  for (const p of present) {
    if (p.k === 'fc') sources.fc = { value: fcValue };
    else if (p.k === 'dp_direct') sources.dp_direct = { value: dpValue, ecr: dpData.ecr, ecrPos: dpData.ecrPos };
  }

  const confidence = present.length === 2 ? 0.7 : 0.5;
  const blend = present.map(p => p.k).join('+');
  return { value: composite, sources, confidence, blend };
}

;
/*! ==== 59-value-lookup.js ==== */
// Unified player/pick value lookup + trust UI helpers. Extracted from 09-composite-ranking.

/** Hard cap at 9999 to match other services (KTC etc. never show >9999 for top assets). */
function capDynastyValue(v) {
  if (!v || v <= 0) return 0;
  return Math.min(9999, Math.round(v));
}

function lookupPlayerValue(playerId, name, position, scoringTab) {
  const backendComp = STATE.backendComposite?.[scoringTab];
  if (backendComp && playerId) {
    const entry = backendComp.players?.[playerId];
    if (entry) {
      const consensus = capDynastyValue(resolveBackendConsensusValue(entry, scoringTab, position));
      // Market toggle (TACO-001): label the value with the ACTIVE source; when
      // the selected source lacks this player, the wrapper already fell back
      // to the composite — flag it so the trust chip can show the fallback.
      const marketSrc = STATE.marketSource && STATE.marketSource !== 'composite' ? STATE.marketSource : null;
      let sourceLabel = entry.primary_blend || (entry.sources?.ktc?.value > 0 ? 'ktc' : 'backend');
      let marketFallback = false;
      if (marketSrc) {
        const srcHasValue = TacoValues.resolveConsensusValue(entry, { scoringTab, position, source: marketSrc }) > 0;
        if (srcHasValue) sourceLabel = marketSrc;
        else marketFallback = true;
      }
      return {
        value: consensus,
        dynastyValue: consensus,
        posRank: entry.position_rank
          || (entry.consensus_rank ? `${entry.position}${entry.consensus_rank}` : null),
        age: entry.age,
        rookie: entry.rookie || false,
        source: sourceLabel,
        marketFallback,
        sources: entry.sources,
        trade_implied: entry.trade_implied || entry.sources?.trade_implied || null,
        agreementScore: entry.agreement_score,
        rangeLow: entry.range_low,
        rangeHigh: entry.range_high,
        momentum1d: entry.momentum_1d,
        momentum7d: entry.momentum_7d,
        momentum30d: entry.momentum_30d,
        confidence: entry.agreement_score != null ? entry.agreement_score / 100 : 0.85,
        // Momentum is a percent; trend30Day is a point delta. This was a
        // hard 0, so every player row fell through formatTrend() with nothing
        // to show and no row on the site has displayed a 30-day trend since
        // the composite-v2 cutover.
        trend30Day: pointDeltaFromMomentum(consensus, entry.momentum_30d),
        marketDivergencePct: entry.market_divergence_pct ?? null,
        tags: entry.tags || [],
        stdev: 0,
        // First-party engine's real-trade sample size for this player/format
        // (taco-backend's buildCompositeShape). Surfaces how much real
        // evidence backs this exact number -- was previously only visible
        // via a manual /api/debug/first-party-trace call.
        nTrades: entry.n_trades ?? 0,
        nLeagues: entry.n_leagues ?? 0,
      };
    }
  }

  // The same composite, reached through the per-tab lookup rather than the
  // players dict. Reached when the dict has not been built for this tab yet.
  //
  // This branch used to re-apply tePremiumMultiplier to a value the engine
  // had ALREADY priced for that TE-premium format, and then hand the result
  // to computeCompositeValue -- which returns Dynasty Daddy's KTC price
  // outright whenever it has one. Our own number went in and KTC's came out,
  // labelled 'ktc', for any player who reached this path.
  const ourLookup = STATE.fcPlayerLookup[scoringTab];
  if (ourLookup && ourLookup.size > 0 && playerId) {
    const match = ourLookup.get(playerId);
    if (match) {
      const dynastyValue = capDynastyValue(match.value);
      return {
        value: dynastyValue,
        dynastyValue,
        posRank: match.posRank,
        age: match.age,
        rookie: match.rookie,
        source: 'first_party',
        confidence: 0.85,
        momentum30d: match.momentum30d ?? null,
        momentum7d: match.momentum7d ?? null,
        trend30Day: match.trend30Day || 0,
        stdev: match.stdev || 0,
      };
    }
  }

  // There was a third branch here that priced a player from DynastyProcess
  // alone (computeCompositeValue with no value of ours to blend), which is a
  // pure third-party value path and the last one in this function. Gone.
  // DynastyProcess and Dynasty Daddy are still loaded, for Market Radar and
  // the drawer's "the market says X, we say Y" comparison -- as comparisons,
  // never as the price.

  const ktcLookup = STATE.ktcLookup[scoringTab];
  if (ktcLookup && ktcLookup.size > 0 && name && position) {
    const match = ktcLookup.get(normalizeName(name) + '|' + position) || ktcLookup.get(normalizeName(name));
    if (match) {
      return {
        value: capDynastyValue(match.value),
        dynastyValue: capDynastyValue(match.value),
        posRank: match.posRank,
        age: match.age,
        rookie: match.rookie,
        source: 'ktc',
        trend30Day: 0,
        stdev: 0,
      };
    }
  }
  return null;
}

// Cache composite-derived pick lookups per tab (rebuilt only when the source array
// reference changes). Surfaces the nightly composite's real KTC bucket pick values
// (e.g. 2027 early 1st = 7104) to the pick path, which otherwise only saw FantasyCalc.
const COMPOSITE_PICK_LOOKUPS = {};
// True once the composite pick anchors are loaded for this format.
//
// Pick prices are provisional until then -- they resolve from KTC first and
// settle onto the composite about a second later. Anything that SENDS pick
// values somewhere they will be cached (the trade-suggestions request) has to
// wait for this, or it caches a number the rest of the app will disagree with.
function compositePicksReady(scoringTab) {
  const l = compositePickLookupFor(scoringTab);
  return !!(l && l.size > 0);
}
window.compositePicksReady = compositePicksReady;

function compositePickLookupFor(scoringTab) {
  const comp = STATE.backendComposite[scoringTab];
  const values = comp && Array.isArray(comp.values) ? comp.values : null;
  if (!values || !values.length) return null;
  if (typeof TacoCore?.buildPickLookupsFromComposite !== 'function') return null;
  const cached = COMPOSITE_PICK_LOOKUPS[scoringTab];
  if (cached && cached.src === values) return cached.lookup;
  const lookup = TacoCore.buildPickLookupsFromComposite(values, scoringTab);
  COMPOSITE_PICK_LOOKUPS[scoringTab] = { src: values, lookup };
  return lookup;
}

// The league context pickValueFor needs beyond the format. Slot multipliers
// are league-size aware and the class discount depends on whether this year's
// rookie draft is done, so a caller that has the league must hand both over.
//
// Without it the rule prices every league as a 12-team one whose rookie draft
// status is guessed from today's date. That is not academic: rebuildPickValues
// runs on every portfolio load and overwrites enrichment's correct numbers, so
// a 10-team league's 2027 1.09 painted at 4,854 and then jumped to 5,159 a beat
// later (found 2026-10-16, in the very change that was meant to fix pick
// pricing). Derive it here rather than at each call site so it cannot drift.
function pickContextFor(lg) {
  if (!lg) return {};
  const numTeams = (lg.allRosters || []).length || Number(lg.total_rosters) || undefined;
  const season = Number(lg.season) || 0;
  return {
    numTeams,
    nextClass: season ? (lg.rookieDraftComplete ? season + 1 : season) : undefined,
  };
}
window.pickContextFor = pickContextFor;

function lookupPickValue(pick, scoringTab, ctx = {}) {
  if (!pick) return { value: 0, source: null };
  const { season, round, slot } = pick;
  // A current-season 1st with no published draft order has no slot, but
  // enrichment prices it off projectedSlot -- so a path that reads only .slot
  // collapses every such pick to the flat round mean, i.e. every team's 1st
  // priced identically. Match enrichment for the rule below. The FC/KTC
  // fallbacks further down keep using the KNOWN slot only: a projected slot is
  // an estimate, and their slot-keyed lookups would read it as fact.
  const ruleSlot = slot != null ? slot : (pick.projectedSlot != null ? pick.projectedSlot : null);

  // The one pick rule (shared/picks.mjs pickValueFor), the same League
  // Overview's draft capital uses, so a pick has one price everywhere and is
  // monotonic by slot (2026-10-03). The lookups below are only reached for a
  // pick the rule cannot read (no numeric season/round, or a bucket name).
  const numericSlot = ruleSlot == null || Number.isFinite(Number(ruleSlot));
  if (typeof TacoCore?.pickValueFor === 'function' && numericSlot) {
    const v = TacoCore.pickValueFor(
      { season: Number(season), round: Number(round), slot: ruleSlot == null ? null : Number(ruleSlot) },
      { scoringTab, numTeams: ctx.numTeams, nextClass: ctx.nextClass },
    );
    if (v > 0) return { value: v, source: ruleSlot ? 'slot' : 'round' };
  }

  // Prefer the nightly composite's KTC pick values (true KTC scale, per-season:
  // 2027 early 1st = 7104) over FantasyCalc's lower generic picks. Falls through to
  // the FC/KTC-name lookups below when the composite has no match for this pick.
  const compLookup = compositePickLookupFor(scoringTab);
  if (compLookup && compLookup.size > 0) {
    const res = TacoCore.lookupPickValue(pick, scoringTab, compLookup);
    if (res && res.value > 0) return res;
  }

  const fcPicks = STATE.fcPickLookup[scoringTab];
  const ktcLookup = STATE.ktcLookup[scoringTab];

  if (slot && fcPicks && fcPicks.size > 0) {
    const key = `${season}-${round}-${slot}`;
    const fcMatch = fcPicks.get(key)
      || fcPicks.get(`${season}-${round}-${String(slot).padStart(2, '0')}`);
    if (fcMatch) {
      return { value: capDynastyValue(fcMatch.value), source: 'fc-slot' };
    }
  }

  if (fcPicks && fcPicks.size > 0) {
    const preferredBucket = slot ? (slot <= 4 ? 'early' : slot <= 8 ? 'mid' : 'late') : 'mid';
    const bucketOrder = [preferredBucket, 'mid', 'early', 'late'];
    for (const b of bucketOrder) {
      const fcMatch = fcPicks.get(`${season}-${round}-${b}`);
      if (fcMatch) {
        const value = slot ? TacoCore.applyPickAdjustments(fcMatch.value, round, slot, 0, b) : fcMatch.value;
        return { value: capDynastyValue(value), source: slot ? 'fc-slot-adj' : 'fc-bucket' };
      }
    }
  }

  if (ktcLookup && ktcLookup.size > 0) {
    const bucket = slot ? (slot <= 4 ? 'Early' : slot <= 8 ? 'Mid' : 'Late') : 'Mid';
    const candidates = [
      { name: `${season} ${bucket} ${ordinal(round)}`, bucket },
      { name: `${season} Mid ${ordinal(round)}`, bucket: 'Mid' },
      { name: `${season} Early ${ordinal(round)}`, bucket: 'Early' },
      { name: `${season} Late ${ordinal(round)}`, bucket: 'Late' },
    ];
    for (const c of candidates) {
      const match = ktcLookup.get(normalizeName(c.name));
      if (match) {
        const value = slot ? TacoCore.applyPickAdjustments(match.value, round, slot, 0, c.bucket) : match.value;
        return { value: capDynastyValue(value), source: slot ? 'ktc-slot' : 'ktc-bucket' };
      }
    }
  }

  return { value: 0, source: null };
}

// Full player-pool builder for board/pool views (Live Draft, Trade Finder
// and Waiver Wire client fallbacks, WAR baselines, Trade Verdict ceiling).
// Was reading STATE.fcRaw/ktcRaw directly -- the live FantasyCalc/KTC pool,
// not the same first-party composite lookupPlayerValue uses for every other
// page. A player could be priced correctly everywhere else (via
// lookupPlayerValue -> STATE.backendComposite) and still show a stale FC/KTC
// number here (e.g. Live Draft board vs the player drawer for the same
// player), because the FC lookups were only patched with composite values
// where the sleeperId matched AND the overlay had already resolved by the
// time this pool was read -- a real timing/coverage gap, not just cosmetic.
// Both pools are first-party as of 2026-11-03, so they can no longer disagree
// about the source, only about how fresh the load is.
// Now reads STATE.backendComposite directly, same source + same
// resolveBackendConsensusValue resolution as lookupPlayerValue, joined with
// STATE.playersDB for name/rookie status (the composite blob doesn't carry
// either). Falls back to the raw FC/KTC pool only if backend composite
// hasn't loaded yet for this tab.
// The composite pool is rebuilt from ~3,300 entries on every call, and Trade
// Finder, Rankings, waivers and the trade card each call it many times per
// render. Remember it per loaded composite object, rebuilt whenever the
// players database, value source or market source changes (2026-09-28 lag
// work). Callers read it or copy before sorting; none write into it.
const valuePoolMemo = new WeakMap(); // composite object -> { db, vs, ms, pool }
function getValuePoolForTab(scoringTab) {
  const backendComp = STATE.backendComposite?.[scoringTab];
  if (backendComp?.players && typeof backendComp === 'object') {
    const hit = valuePoolMemo.get(backendComp);
    const vs = STATE.valueSource && STATE.valueSource[scoringTab];
    if (hit && hit.db === STATE.playersDB && hit.vs === vs && hit.ms === STATE.marketSource) return hit.pool;
    const pool = buildBackendValuePool(scoringTab, backendComp);
    if (pool) { valuePoolMemo.set(backendComp, { db: STATE.playersDB, vs, ms: STATE.marketSource, pool }); return pool; }
  }
  return buildFallbackValuePool(scoringTab);
}

function buildBackendValuePool(scoringTab, backendComp) {
  if (backendComp?.players && Object.keys(backendComp.players).length > 0) {
    const pool = [];
    for (const [sleeperId, entry] of Object.entries(backendComp.players)) {
      const value = resolveBackendConsensusValue(entry, scoringTab, entry.position);
      if (!(value > 0)) continue;
      const dbPlayer = STATE.playersDB?.[sleeperId];
      const name = dbPlayer
        ? (dbPlayer.full_name || `${dbPlayer.first_name || ''} ${dbPlayer.last_name || ''}`.trim())
        : (entry.position ? `${entry.position} ${sleeperId}` : sleeperId);
      pool.push({
        name,
        sleeperId,
        position: entry.position,
        team: entry.team ?? dbPlayer?.team ?? null,
        age: entry.age ?? dbPlayer?.age ?? null,
        rookie: dbPlayer ? dbPlayer.years_exp === 0 : false,
        value,
        posRank: entry.position_rank || null,
        trend30Day: pointDeltaFromMomentum(value, entry.momentum_30d),
        stdev: 0,
        momentum30d: entry.momentum_30d ?? null,
        // When Sleeper last had anything to say about this player.
        //
        // The obvious "is he still playing" fields cannot be trusted: Sleeper
        // still lists Ben Roethlisberger, retired since 2022, as team PIT,
        // active true, status Active, age 39. His news_updated is 2022-01-27.
        // A player who is actually in the league gets news -- signings,
        // injuries, depth-chart moves -- far more often than that.
        lastNewsAt: dbPlayer?.news_updated ?? null,
      });
    }
    // Pick assets ride along in the raw values array (composite-v2 includes
    // PICK rows), not in the players dict -- carry them through too, same
    // as the FC/KTC fallback pool below always has.
    for (const v of backendComp.values || []) {
      if (v.position !== 'PICK' || !v.sleeperId) continue;
      const value = v.composite?.weightedValue ?? 0;
      if (!(value > 0)) continue;
      pool.push({ name: v.name, sleeperId: v.sleeperId, position: 'PICK', value });
    }
    return pool;
  }
  return null;
}

function buildFallbackValuePool(scoringTab) {
  const source = STATE.valueSource[scoringTab];
  let pool = [];
  if (source === 'taco') {
    // STATE.fcRaw is our own composite for this tab now, already priced for
    // this exact TE-premium format by the engine. Return it untouched: the
    // premium below would double-count it.
    return STATE.fcRaw[scoringTab] || [];
  }
  if (source === 'ktc') {
    pool = STATE.ktcRaw[scoringTab] || [];
  }
  // KTC publishes no TE-premium tabs, so its TE values are base-format and do
  // need the bump. Probe with a mid-board value to decide whether this tab
  // carries any premium at all, then apply it per player -- the multiplier
  // depends on how good the tight end is, not just the tier.
  if (TacoCore.tePremiumMultiplier(scoringTab, 3000) === 1.00) return pool;
  return pool.map(p => {
    if (p.position === 'TE') {
      const v = p.value || 0;
      return { ...p, value: capDynastyValue(v * TacoCore.tePremiumMultiplier(scoringTab, v)) };
    }
    return p;
  });
}

// TACO-003: per-league WAR baselines — replacement value at each position's
// format threshold (shared/war.mjs), built from the same league-adjusted pool
// the rankings use so WAR is league-relative. Cached per league; invalidated
// on value rebuilds and market-source switches via the cache key.
function getLeagueWarBaselines(lg) {
  if (!lg || typeof TacoCore === 'undefined' || !TacoCore.computeWarBaselines) return null;
  const cacheKey = `${lg.scoringTab}|${STATE.marketSource || 'composite'}`;
  if (lg._warBaselines && lg._warBaselines.key === cacheKey) return lg._warBaselines.baselines;
  const tab = lg.scoringTab;
  const pool = [];
  const backend = STATE.backendComposite?.[tab]?.players;
  if (backend) {
    for (const [pid, entry] of Object.entries(backend)) {
      const pos = entry.position;
      if (pos !== 'QB' && pos !== 'RB' && pos !== 'WR' && pos !== 'TE') continue;
      const v = resolveBackendConsensusValue(entry, tab, pos);
      if (v > 0) pool.push({ position: pos, value: leagueTradeValue(v, pos, lg, pid) });
    }
  } else {
    for (const e of (getValuePoolForTab(tab) || [])) {
      const pos = e.position;
      if (pos !== 'QB' && pos !== 'RB' && pos !== 'WR' && pos !== 'TE') continue;
      if (e.value > 0) pool.push({ position: pos, value: leagueTradeValue(e.value, pos, lg, e.sleeperId || null) });
    }
  }
  const baselines = TacoCore.computeWarBaselines(pool, tab);
  lg._warBaselines = { key: cacheKey, baselines };
  return baselines;
}

function warTooltipText(scoringTab) {
  return `Wins Above Replacement - how much this player is worth above a freely-available replacement at their position in this specific format (${scoringTab}). 1W ≈ 2,000 league-adjusted value points above the replacement threshold.`;
}

function valueSourceShortLabel(source) {
  const s = (source || '').toLowerCase();
  const map = {
    ktc: 'KTC',
    fc: 'FC',
    dp: 'DP',
    backend: 'Composite',
    composite: 'Composite',
    taco: 'First-party',
    'fc+dp': 'FC+DP',
    'fc-slot': 'Pick',
    'fc-bucket': 'Pick',
    'fc-slot-adj': 'Pick',
    'composite-slot': 'Pick',
    'composite-bucket': 'Pick',
    'composite-slot-adj': 'Pick',
    'ktc-slot': 'Pick',
    'ktc-bucket': 'Pick',
    slot: 'Pick',
    round: 'Pick',
    // First-party engine seedType values (taco-backend's buildCompositeShape).
    first_party: 'First-party',
    pick_anchor: 'Pick anchor',
    blended: 'Trade + prior',
    trade_only: 'Real trades',
    prior_only: 'Stats/ADP',
    adp_only_prior: 'ADP',
  };
  // Never echo an internal id to users (ADP_ONLY_PRIOR once showed on every
  // roster row); an unmapped source reads as the blend it came from.
  return map[s] || 'Composite';
}

function displayedPlayerValue(p, lg) {
  if (!p) return 0;
  if (lg && typeof playerLeagueValue === 'function') return playerLeagueValue(p, lg) || 0;
  return p.leagueValue ?? p.value ?? 0;
}

function buildValueTrustTooltip(p, lg) {
  const tab = lg?.scoringTab || 'your format';
  const src = valueSourceShortLabel(p?.valueSource);
  const parts = [
    // Every 6 hours: crons = ["30 */6 * * *", ...] in taco-backend/wrangler.toml
    // (00:30/06:30/12:30/18:30 UTC). This said 3 and had since the 2026-08-02
    // cost fix halved the schedule -- the same drift audit-freshness-claim.mjs
    // was written to catch, which only reads methodology.html and so could not
    // see it. It sits on the value chip, i.e. on the number itself.
    `First-party value for ${tab} - real Sleeper trades blended with trailing stats/ADP, refreshed every 6 hours.`,
    `Shown tag: ${src}.`,
  ];
  if (lg && typeof TacoCore !== 'undefined' && TacoCore.hasReturnScoring?.(lg.scoring_settings)) {
    parts.push('Includes return-yard adjustment for this league.');
  }
  const raw = p?.value || 0;
  const adj = displayedPlayerValue(p, lg);
  if (adj && raw && adj !== raw) {
    parts.push(`League-adjusted ${Math.round(raw).toLocaleString()} → ${Math.round(adj).toLocaleString()}.`);
  }
  return parts.join(' ');
}

function renderValueTrustChip(p, lg) {
  if (!p?.value && !p?.leagueValue) return '';
  let label = valueSourceShortLabel(p.valueSource);
  let tip = buildValueTrustTooltip(p, lg);
  // Market toggle fallback indicator: selected source has no value for this
  // player, so the composite blend is shown instead (TACO-001 acceptance).
  if (p.marketFallback && STATE.marketSource && STATE.marketSource !== 'composite') {
    label = 'Composite*';
    tip = `${valueSourceShortLabel(STATE.marketSource)} has no value for this player - showing the composite blend instead. ` + tip;
  }
  return `<span class="value-trust-chip${p.marketFallback ? ' market-fallback' : ''}" data-tooltip="${escapeHtml(tip)}">${escapeHtml(label)}</span>`;
}

function buildDrawerValueWhyHtml(ctx) {
  if (!ctx || !ctx.bestValue) return '';
  // ctx.scoringTab is the one format the whole drawer is priced in
  // (see gatherPlayerContext) -- reading leagues[0] here made the copy claim a
  // format the headline number above it had not been computed in.
  const tab = ctx.scoringTab || STATE.leagues?.[0]?.scoringTab || '1QB / SF';
  const blend = ctx.valueSource || 'composite';
  // First-party engine seedType values (taco-backend's buildCompositeShape) --
  // pick_anchor/blended/trade_only/prior_only describe how THIS player's
  // number was actually built. 'ktc'/'fc'-ish values still occur when a
  // format falls back to the legacy public-source composite (no first-party
  // coverage yet for that format).
  const blendLabel = blend === 'pick_anchor' ? 'Seeded from real KeepTradeCut pick-tier data'
    : blend === 'trade_only' ? 'Priced almost entirely from real trade evidence'
      : blend === 'blended' ? 'Blended from real trade evidence and a trailing stats/ADP prior'
        : blend === 'prior_only' ? 'Priced from trailing stats and ADP - not enough real trade evidence yet'
          : 'Our first-party engine - real trades + trailing stats/ADP';
  let extra = '';
  const returnLeague = STATE.leagues?.find((lg) =>
    typeof TacoCore !== 'undefined' && TacoCore.hasReturnScoring?.(lg.scoring_settings),
  );
  if (returnLeague) {
    extra = ' Return specialists get a league-specific boost where KR/PR are scored.';
  }
  return `
    <div class="drawer-value-why">
      <div class="drawer-value-why-title">Why this number?</div>
      <p>${escapeHtml(blendLabel)} for ${escapeHtml(tab)}-style leagues.${extra} Values change by league scoring.</p>
    </div>
  `;
}
;
/*! ==== 63-player-drawer-gather-context.js ==== */
// Player drawer context — cross-league ownership, values, and similar-player comps.

// `scoringTab` is optional: pass it from any surface that already has a format
// on screen (the rankings board, a league view) so the drawer agrees with the
// row that was clicked. Without it the drawer picks its own primary tab.
function gatherPlayerContext(playerId, scoringTab) {
  const p = STATE.playersDB?.[playerId];
  if (!p) return null;

  const fullName = (p.full_name || `${p.first_name || ''} ${p.last_name || ''}`).trim();
  const position = TacoCore.primaryFantasyPosition(p);

  const ownedIn = [];
  const rosteredByOthers = [];
  const availableIn = [];

  for (const lg of STATE.leagues) {
    if (lg.startupComplete === false) continue;
    // Flat market value -- matches every other page (see 10-sleeper-api.js
    // playerLeagueValue). Was tilting via leagueTradeValue.
    const match = lookupPlayerValue(playerId, fullName, position, lg.scoringTab);
    const value = match?.value || 0;
    let found = false;
    for (const r of lg.allRosters) {
      if (r.playerIds.includes(playerId)) {
        if (r.isMe) {
          const rosterPlayer = r.players.find((rp) => rp.playerId === playerId);
          ownedIn.push({ league: lg, roster: r, value, rosterPlayer });
        } else {
          rosteredByOthers.push({ league: lg, roster: r, value });
        }
        found = true;
        break;
      }
    }
    if (!found) availableIn.push({ league: lg, value });
  }

  // ONE format for the whole drawer.
  //
  // This used to be three. The headline number was the MAX value across every
  // league the user is in, while the source breakdown, momentum, range and the
  // "Why this number?" copy all came from STATE.leagues[0], and the trend chart
  // came from a third tab. Josh Allen opened from an SF TE+ board read
  // "VALUE 8,925" -- his price in one SF league out of 29 -- above a source
  // range of 7,022-9,992 computed in SF TE+, where he is 8,736. The headline
  // disagreed with the row that was clicked AND with everything beneath it, and
  // the composite marker sat at the wrong point in its own range.
  //
  // Resolution order: the format the caller was showing, then the format of the
  // league this player actually matters to the user in, then leagues[0].
  const primaryScoringTab = ownedIn[0]?.league.scoringTab
    || rosteredByOthers[0]?.league.scoringTab
    || availableIn[0]?.league.scoringTab
    || STATE.leagues[0]?.scoringTab
    || null;
  const tab = scoringTab || STATE.drawerScoringTab || primaryScoringTab;
  const anyMatch = tab ? lookupPlayerValue(playerId, fullName, position, tab) : null;
  const bestValue = anyMatch?.value || 0;

  return {
    playerId,
    name: fullName,
    position,
    team: p.team || 'FA',
    age: p.age || null,
    yearsExp: p.years_exp,
    rookie: p.years_exp === 0,
    status: p.status || 'Active',
    injuryStatus: p.injury_status || null,
    bestValue,
    bestSources: anyMatch ? {
      ...(anyMatch.sources || {}),
      trade_implied: anyMatch.trade_implied || anyMatch.sources?.trade_implied || null,
    } : null,
    valueSource: anyMatch?.source || null,
    confidence: anyMatch?.confidence ?? null,
    trend30Day: anyMatch?.trend30Day || 0,
    momentum1d: anyMatch?.momentum1d ?? null,
    momentum7d: anyMatch?.momentum7d ?? null,
    momentum30d: anyMatch?.momentum30d ?? null,
    tags: anyMatch?.tags ?? [],
    agreementScore: anyMatch?.agreementScore ?? null,
    rangeLow: anyMatch?.rangeLow ?? null,
    rangeHigh: anyMatch?.rangeHigh ?? null,
    marketDivergencePct: anyMatch?.marketDivergencePct ?? null,
    stdev: anyMatch?.stdev || 0,
    posRank: anyMatch?.posRank || null,
    scoringTab: tab,
    primaryScoringTab: tab,
    ownedIn,
    rosteredByOthers,
    availableIn,
  };
}

function findSimilarPlayers(ctx, limit = 5) {
  if (!STATE.playersDB || ctx.bestValue <= 0) return [];
  // Same tab the headline value was priced in -- comparing a bestValue from one
  // format against a candidate pool priced in another produced bogus comps.
  const tab = ctx.scoringTab || STATE.leagues[0]?.scoringTab;
  if (!tab) return [];
  const targetValue = ctx.bestValue;
  const lowerBound = targetValue * 0.88;
  const upperBound = targetValue * 1.12;

  const candidates = [];
  for (const [pid, p] of Object.entries(STATE.playersDB)) {
    if (pid === ctx.playerId) continue;
    if (!TacoCore.SKILL_POSITIONS.includes(TacoCore.primaryFantasyPosition(p))) continue;
    const pos = TacoCore.primaryFantasyPosition(p);
    if (pos !== ctx.position) continue;
    if (!p.team) continue;
    if (p.status && p.status !== 'Active' && p.status !== 'Injured Reserve') continue;
    const name = (p.full_name || `${p.first_name || ''} ${p.last_name || ''}`).trim();
    const match = lookupPlayerValue(pid, name, pos, tab);
    const v = match?.value || 0;
    if (v < lowerBound || v > upperBound) continue;
    candidates.push({
      playerId: pid,
      name,
      position: pos,
      team: p.team,
      age: p.age,
      value: v,
      posRank: match?.posRank,
      dist: Math.abs(v - targetValue),
    });
  }
  candidates.sort((a, b) => a.dist - b.dist);
  return candidates.slice(0, limit);
}
;
/*! ==== 11-pick-simulator-handlers.js ==== */
// Save a rookie selection for a specific pick in a specific league.
// '' clears the selection.
function setPickSimSelection(leagueId, pickKey, playerId) {
  if (!STATE.pickSim[leagueId]) STATE.pickSim[leagueId] = {};
  if (!playerId) {
    delete STATE.pickSim[leagueId][pickKey];
  } else {
    STATE.pickSim[leagueId][pickKey] = playerId;
  }
  renderTeamDetail();
}
window.setPickSimSelection = setPickSimSelection;

function clearPickSim(leagueId) {
  STATE.pickSim[leagueId] = {};
  renderTeamDetail();
}
window.clearPickSim = clearPickSim;

// Renders a visual snapshot above the portfolio grid: three tiles showing
// (1) aggregate stats, (2) a bar chart of team values across leagues, and
// (3) an archetype distribution. Designed to make the Overview feel like a
// product dashboard rather than a bare table.
/** One win rate, formatted one way everywhere. Null is a dash, not 0%. */
function fmtWinPct(pct) {
  return pct == null ? '-' : `${pct.toFixed(1)}%`;
}
window.fmtWinPct = fmtWinPct;

/** .500 is the only neutral number in a head-to-head league. */
function winPctCls(pct) {
  const tone = TacoCore.winPctTone(pct);
  return tone === 'good' ? 'good' : tone === 'bad' ? 'bad' : '';
}
window.winPctCls = winPctCls;

function renderSnapshotPanel() {
  const el = document.getElementById('snapshotPanel');
  if (!el) return;
  let activeLeagues = STATE.leagues.filter(lg => lg.startupComplete !== false);
  // Never blank the whole All Leagues summary: if the startup-complete flag is
  // missing/off on every league (a bootstrap shape that didn't stamp it was
  // leaving this empty), fall back to the full set so portfolio stats always show.
  if (!activeLeagues.length) activeLeagues = STATE.leagues.slice();
  if (!activeLeagues.length) {
    el.innerHTML = '';
    return;
  }

  let sfCount = 0;
  let oneQbCount = 0;
  let tepCount = 0;
  const archetypeCounts = {};
  let contendCount = 0;
  let rebuildCount = 0;

  let bookValue = 0;
  let leadCount = 0;
  let topHalfCount = 0;
  let backHalfCount = 0;
  let rankSum = 0;
  let rankCount = 0;
  // This season's record, per league, straight off lg.allRosters -- no
  // requests. Until 2026-11-03 these counters read lg.seasonHistory, which
  // nothing in the codebase ever wrote, so the "Season record" group below
  // was coded and permanently invisible.
  const seasonSummaries = [];
  let seasonStandingSum = 0;
  let seasonStandingCount = 0;

  for (const lg of activeLeagues) {
    const tab = lg.scoringTab || '';
    if (tab.startsWith('SF')) sfCount += 1;
    else oneQbCount += 1;
    if (tab.includes('TE+')) tepCount += 1;

    const myRoster = lg.allRosters?.find(r => r.isMe);
    if (!myRoster) continue;
    {
      const arch = archetypeForRoster(lg, myRoster);
      archetypeCounts[arch] = (archetypeCounts[arch] || 0) + 1;
      if (CONTENDER_ARCHETYPES.has(arch)) contendCount += 1;
      if (arch === 'Rebuild') rebuildCount += 1;
    }

    // Rank on the SAME basis the league cards use: TacoCore.leagueTeamValues
    // defaults to includePicks, so this is Team Value in the documented sense
    // (roster + draft capital), which is what the label above claims.
    //
    // This used to sort on r.totalValue, which is players-only. The panel then
    // said "rank by team value in each" over a ranking that excluded draft
    // capital, so a team could read 2/12 on its league card and be counted in
    // a different bucket here. Same disease as the Team Value / Roster Value
    // label collision -- see shared/roster-value.mjs for the vocabulary.
    const teamValues = TacoCore.leagueTeamValues(lg);
    if (!teamValues.length) continue;
    const mine = teamValues.find((v) => v.isMe);
    if (!mine) continue;
    bookValue += mine.value || 0;
    const myRank = TacoCore.rankAmong(teamValues.map((v) => v.value), mine.value);
    const nTeams = teamValues.length;
    rankSum += myRank;
    rankCount += 1;
    if (myRank === 1) leadCount += 1;
    if (myRank <= Math.ceil(nTeams / 2)) topHalfCount += 1;
    else backHalfCount += 1;

    const seasonRec = typeof currentSeasonRecord === 'function' ? currentSeasonRecord(lg) : null;
    if (seasonRec && seasonRec.games > 0) {
      seasonSummaries.push(seasonRec);
      // Standing is the league's own order: wins first, points-for as the
      // tiebreak -- the same rule the league card and the league page use, so
      // a number here cannot disagree with the one on the card.
      const standing = lg.allRosters.filter((o) => {
        const ow = o.wins || 0; const mw = myRoster.wins || 0;
        return ow > mw || (ow === mw && (o.pointsFor || 0) > (myRoster.pointsFor || 0));
      }).length + 1;
      seasonStandingSum += standing;
      seasonStandingCount += 1;
    }
  }

  const seasonTotals = TacoCore.aggregatePortfolioRecord(seasonSummaries);
  // All-time needs one request per prior season, once ever (module 12 caches
  // completed seasons indefinitely -- they are final). Kick it off and redraw
  // when it lands; this season's numbers are already on screen by then.
  const allTime = STATE.allTimeRecords ? STATE.allTimeRecords.portfolio : null;
  if (!STATE.allTimeRecords && typeof loadAllTimeRecords === 'function' && activeLeagues.length) {
    // renderOverview, not renderSnapshotPanel: the league CARDS carry an
    // all-time line too, and redrawing only the strip left every one of them
    // showing this season alone. renderOverview calls the strip itself, and
    // the guard above stops it looping now that STATE.allTimeRecords is set.
    loadAllTimeRecords().then((r) => {
      if (!r) return;
      if (typeof renderOverview === 'function') renderOverview();
      else renderSnapshotPanel();
    });
  }

  const avgRank = rankCount > 0 ? (rankSum / rankCount).toFixed(1) : '-';
  const archetypeEntries = Object.entries(archetypeCounts)
    .sort(([a], [b]) => (ARCHETYPE_RANK[a] || 99) - (ARCHETYPE_RANK[b] || 99));
  const n = activeLeagues.length;

  // Single league: skip cross-league rank math — show standing in that league only.
  if (n === 1) {
    const lg = activeLeagues[0];
    // Same basis as the multi-league branch and the league cards: Team Value
    // includes draft capital. Ranking on players-only here would have this
    // panel disagree with the card for the very same league.
    const teamValues = TacoCore.leagueTeamValues(lg);
    const mine = teamValues.find((v) => v.isMe);
    const myRank = mine ? TacoCore.rankAmong(teamValues.map((v) => v.value), mine.value) : '-';
    const nTeams = teamValues.length || '-';
    const myRoster = lg.allRosters?.find(r => r.isMe);
    const arch = myRoster ? archetypeForRoster(lg, myRoster) : '-';
    const archCls = arch !== '-' ? 'arch-' + arch.toLowerCase().replace(/\s+/g, '-') : '';

    el.innerHTML = `
      <div class="stat-strip stat-strip-single">
        <div class="stat-strip-group">
          <div class="stat-strip-grouplabel">This league <span class="stat-strip-subnote">${escapeHtml(lg.name)} · ${lg.scoringTab || ''}</span></div>
          <div class="stat-strip-cells">
            <div class="stat-strip-cell">
              <div class="stat-strip-num accent">${myRank}</div>
              <div class="stat-strip-label">value rank</div>
              <div class="stat-strip-sub">of ${nTeams} teams</div>
            </div>
            <div class="stat-strip-cell">
              ${arch === '-' ? '<div class="stat-strip-num">-</div>' : !archetypesSettled() ? archetypePendingPill('snapshot-arch-pill') : `<span class="snapshot-arch-pill ${archCls}">${escapeHtml(arch)}</span>`}
              <div class="stat-strip-label">team style</div>
            </div>
          </div>
        </div>
      </div>
      <p class="stat-strip-footnote">Team value rank uses this league&apos;s scoring and format only. Add more dynasty leagues to see portfolio-wide standing.</p>
    `;
    if (typeof animateStatNumbers === 'function') animateStatNumbers(el);
    return;
  }

  el.innerHTML = `
    <div class="stat-strip">
      <div class="stat-strip-group">
        <div class="stat-strip-grouplabel">Portfolio <span class="stat-strip-subnote">team value across all leagues</span></div>
        <div class="stat-strip-cells">
          <div class="stat-strip-cell">
            <div class="stat-strip-num accent">${typeof formatCompactNumber === 'function' ? formatCompactNumber(bookValue) : Math.round(bookValue).toLocaleString()}</div>
            <div class="stat-strip-label">total value</div>
          </div>
          <div class="stat-strip-cell">
            <div class="stat-strip-num">${n}</div>
            <div class="stat-strip-label">leagues</div>
          </div>
        </div>
      </div>

      <div class="stat-strip-divider"></div>

      <div class="stat-strip-group">
        <div class="stat-strip-grouplabel">Where you stand <span class="stat-strip-subnote">${rankCount < n ? `${rankCount} of ${n} leagues · still syncing` : `${n} leagues`} · rank by team value in each</span></div>
        <div class="stat-strip-cells">
          <div class="stat-strip-cell">
            <div class="stat-strip-num accent">${leadCount}</div>
            <div class="stat-strip-label">#1 in league</div>
          </div>
          <div class="stat-strip-cell">
            <div class="stat-strip-num">${topHalfCount}</div>
            <div class="stat-strip-label">top half</div>
          </div>
          <div class="stat-strip-cell">
            <div class="stat-strip-num muted">${backHalfCount}</div>
            <div class="stat-strip-label">back half</div>
          </div>
          <div class="stat-strip-cell">
            <div class="stat-strip-num">${avgRank}</div>
            <div class="stat-strip-label">avg rank</div>
          </div>
        </div>
      </div>

      ${seasonTotals.games > 0 ? `
      <div class="stat-strip-divider"></div>
      <div class="stat-strip-group">
        <div class="stat-strip-grouplabel">Season record <span class="stat-strip-subnote">${STATE.season || ''} · ${seasonTotals.games} games across ${seasonTotals.leagues} ${seasonTotals.leagues === 1 ? 'league' : 'leagues'}</span></div>
        <div class="stat-strip-cells">
          <div class="stat-strip-cell">
            <div class="stat-strip-num accent">${seasonTotals.record}</div>
            <div class="stat-strip-label">combined W-L</div>
          </div>
          <div class="stat-strip-cell">
            <div class="stat-strip-num ${winPctCls(seasonTotals.winPct)}" data-tooltip="Every head-to-head game you have played this season, across every league. A tie counts as half a win.">${fmtWinPct(seasonTotals.winPct)}</div>
            <div class="stat-strip-label">win %</div>
          </div>
          <div class="stat-strip-cell">
            <div class="stat-strip-num" data-tooltip="Your points per game, over every game played this season in every league. Not per week and not per season - a manager who joined late has played fewer games.">${seasonTotals.pointsPerGame != null ? seasonTotals.pointsPerGame.toFixed(1) : '-'}</div>
            <div class="stat-strip-label">points / game</div>
          </div>
          <div class="stat-strip-cell">
            <div class="stat-strip-num">${seasonStandingCount > 0 ? (seasonStandingSum / seasonStandingCount).toFixed(1) : '-'}</div>
            <div class="stat-strip-label">avg standing</div>
          </div>
        </div>
      </div>
      ` : ''}
      ${allTime && allTime.games > seasonTotals.games ? `
      <div class="stat-strip-divider"></div>
      <div class="stat-strip-group">
        <div class="stat-strip-grouplabel">All time <span class="stat-strip-subnote">${allTime.seasonsPlayed} league-seasons · ${allTime.games} games</span></div>
        <div class="stat-strip-cells">
          <div class="stat-strip-cell">
            <div class="stat-strip-num accent">${allTime.record}</div>
            <div class="stat-strip-label">all-time W-L</div>
          </div>
          <div class="stat-strip-cell">
            <div class="stat-strip-num ${winPctCls(allTime.winPct)}" data-tooltip="Every game you have played in these leagues, back through every season Sleeper has a record of. Seasons before you joined a league are not counted.">${fmtWinPct(allTime.winPct)}</div>
            <div class="stat-strip-label">win %</div>
          </div>
          <div class="stat-strip-cell">
            <div class="stat-strip-num">${allTime.pointsPerGame != null ? allTime.pointsPerGame.toFixed(1) : '-'}</div>
            <div class="stat-strip-label">points / game</div>
          </div>
          <div class="stat-strip-cell">
            <div class="stat-strip-num ${allTime.winningLeagues > allTime.losingLeagues ? '' : 'muted'}">${allTime.winningLeagues}/${allTime.leagues}</div>
            <div class="stat-strip-label">winning records</div>
          </div>
        </div>
      </div>
      ` : ''}

      <div class="stat-strip-divider"></div>

      <div class="stat-strip-group">
        <div class="stat-strip-grouplabel">Contending vs rebuilding</div>
        <div class="stat-strip-cells">
          <div class="stat-strip-cell">
            <div class="stat-strip-num accent">${contendCount}</div>
            <div class="stat-strip-label">contending</div>
          </div>
          <div class="stat-strip-cell">
            <div class="stat-strip-num muted">${rebuildCount}</div>
            <div class="stat-strip-label">rebuild</div>
          </div>
        </div>
      </div>

      <div class="stat-strip-divider"></div>

      <div class="stat-strip-group">
        <div class="stat-strip-grouplabel">League formats</div>
        <div class="stat-strip-cells">
          <div class="stat-strip-cell">
            <div class="stat-strip-num">${sfCount}</div>
            <div class="stat-strip-label">superflex</div>
          </div>
          <div class="stat-strip-cell">
            <div class="stat-strip-num">${oneQbCount}</div>
            <div class="stat-strip-label">1qb</div>
          </div>
          <div class="stat-strip-cell">
            <div class="stat-strip-num">${tepCount}</div>
            <div class="stat-strip-label">te premium</div>
          </div>
        </div>
      </div>

      ${archetypeEntries.length ? `
        <div class="stat-strip-divider"></div>
        <div class="stat-strip-group">
          <div class="stat-strip-grouplabel">Team styles <span class="stat-strip-subnote">${archetypesSettled() ? 'tap to filter your leagues' : 'waiting on this season\'s projections…'}</span></div>
          ${!archetypesSettled() ? '' : `<div class="stat-strip-arch-row${(STATE.overviewArchetypeFilter || []).length ? ' is-filtering' : ''}">
            ${archetypeEntries.map(([arch, count]) => {
              const cls = 'arch-' + arch.toLowerCase().replace(/\s+/g, '-');
              const on = (STATE.overviewArchetypeFilter || []).includes(arch);
              // A button, not a span: these filter the league grid below, and
              // several can be on at once (Owen, 2026-09-27).
              return `
                <button type="button" class="stat-strip-arch-item${on ? ' active' : ''}" data-taco-arch-filter="${escapeHtml(arch)}" aria-pressed="${on}">
                  <span class="snapshot-arch-pill ${cls}" data-tooltip="${escapeHtml(GLOSSARY[arch] || '')}">${escapeHtml(arch)}</span>
                  <strong class="snapshot-arch-count">${count}</strong>
                </button>
              `;
            }).join('')}
            ${(STATE.overviewArchetypeFilter || []).length ? '<button type="button" class="stat-strip-arch-clear" data-taco-arch-filter-clear>Show all</button>' : ''}
          </div>`}
        </div>
      ` : ''}
    </div>
  `;
  if (typeof animateStatNumbers === 'function') animateStatNumbers(el);
}

// Toggle between full-roster value and starting-lineup-only value on the
// Portfolio Value snapshot card. Persists across renders.
function setPortfolioValueMode(mode) {
  STATE._portfolioValueMode = mode;
  renderSnapshotPanel();
}
window.setPortfolioValueMode = setPortfolioValueMode;

;
/*! ==== 12-league-age-chain-walker.js ==== */
// Walking a league's history.
//
// Sleeper mints a NEW league_id every season and chains them with
// previous_league_id, so anything historical -- how old a league is, what your
// all-time record in it is -- means walking that chain back. For most leagues
// it is 1-5 hops.
//
// There used to be two walks here in spirit: getLeagueAge counted the hops and
// threw the league objects away, and an all-time record would have had to walk
// the same chain again to get them back. One walk now, cached, and league age
// is read off its result.
//
// Caching has two shelf lives on purpose:
//   - the CHAIN (which league_ids make up this league's history) changes at
//     most once a year, so 24h.
//   - a COMPLETED season's record never changes again, so it is kept
//     indefinitely. Only the live season is recomputed, and that one is free:
//     it is already on lg.allRosters.
const LEAGUE_CHAIN_CACHE_NS = 'league_chain';
const LEAGUE_CHAIN_TTL_MS = 24 * 60 * 60 * 1000;

/** Every league_id in this league's history, newest first, with its season.
 * Returns [{ leagueId, season }]. */
async function getLeagueChain(leagueId) {
  const cached = TacoStorage.getNamespaced(LEAGUE_CHAIN_CACHE_NS, leagueId, null);
  if (cached && Array.isArray(cached.chain) && (Date.now() - cached.ts) < LEAGUE_CHAIN_TTL_MS) {
    return cached.chain;
  }
  const chain = [];
  let currentId = leagueId;
  const seen = new Set();
  // 30 hops is well past any real dynasty league and stops a malformed
  // previous_league_id loop from spinning forever.
  for (let hop = 0; hop < 30; hop++) {
    if (!currentId || currentId === '0' || seen.has(currentId)) break;
    seen.add(currentId);
    try {
      const res = await fetch(BACKEND_URL + '/api/sleeper/v1/league/' + currentId);
      if (!res.ok) break;
      const lg = await res.json();
      chain.push({ leagueId: String(currentId), season: String(lg.season || '') });
      currentId = lg.previous_league_id;
    } catch (_e) {
      break;
    }
  }
  if (chain.length) {
    TacoStorage.setNamespaced(LEAGUE_CHAIN_CACHE_NS, leagueId, { chain, ts: Date.now() });
  }
  return chain;
}
window.getLeagueChain = getLeagueChain;

// "League age" = number of seasons this league has run.
async function getLeagueAge(leagueId) {
  const chain = await getLeagueChain(leagueId);
  return chain.length || null;
}

async function computePortfolioAvgLeagueAge() {
  const active = STATE.leagues.filter(lg => lg.startupComplete !== false);
  if (active.length === 0) return null;
  // Sequential to keep API pressure low. Near-instant once the chain cache is
  // warm, which it is after the first load of the day.
  const ages = [];
  for (const lg of active) {
    const age = await getLeagueAge(lg.league_id);
    if (age != null) ages.push(age);
  }
  if (ages.length === 0) return null;
  return ages.reduce((a, b) => a + b, 0) / ages.length;
}

/** One past season of a league, as both features need it.
 *
 * This used to fetch only the signed-in user's own roster record. The orphan
 * history needs every roster's owner from the same request, so it fetches the
 * whole season once and both read off it -- rather than two features walking
 * the same chain and pulling the same rosters twice.
 *
 * Trimmed before caching: roster id, owner, co-owners, team name and the five
 * record fields. The raw Sleeper roster carries the full player list, and
 * ~40 of those would not fit in localStorage.
 *
 * Cached by league_id, not by user, because none of it is user-specific --
 * the user's own record is derived at read time. A completed season is final,
 * so the entry is kept indefinitely.
 */
const SEASON_SNAPSHOT_CACHE_NS = 'league_season_snap';

async function fetchSeasonSnapshot(leagueId, season) {
  const cached = TacoStorage.getNamespaced(SEASON_SNAPSHOT_CACHE_NS, leagueId, null);
  if (cached && cached.final) return cached.snap;

  try {
    const [rosterRes, userRes] = await Promise.all([
      fetch(BACKEND_URL + '/api/sleeper/v1/league/' + leagueId + '/rosters'),
      fetch(BACKEND_URL + '/api/sleeper/v1/league/' + leagueId + '/users'),
    ]);
    if (!rosterRes.ok) return null;
    const rosters = await rosterRes.json();
    if (!Array.isArray(rosters)) return null;
    const users = userRes.ok ? await userRes.json() : [];

    const names = {};
    const teamNames = {};
    for (const u of Array.isArray(users) ? users : []) {
      names[u.user_id] = u.display_name || u.username || '';
      const tn = u.metadata && u.metadata.team_name;
      if (tn) teamNames[u.user_id] = tn;
    }

    const snap = {
      season: String(season || ''),
      leagueId: String(leagueId),
      names,
      rosters: rosters.map((r) => ({
        rosterId: String(r.roster_id),
        ownerId: r.owner_id ? String(r.owner_id) : null,
        coOwners: Array.isArray(r.co_owners) ? r.co_owners.map(String) : [],
        teamName: (r.owner_id && teamNames[r.owner_id]) || names[r.owner_id] || null,
        wins: r.settings?.wins || 0,
        losses: r.settings?.losses || 0,
        ties: r.settings?.ties || 0,
        fpts: r.settings?.fpts || 0,
        fpts_decimal: r.settings?.fpts_decimal || 0,
        fpts_against: r.settings?.fpts_against || 0,
        fpts_against_decimal: r.settings?.fpts_against_decimal || 0,
        // Potential points: what the roster WOULD have scored with a perfect
        // lineup. Lineup efficiency for any past season comes from this.
        ppts: r.settings?.ppts || 0,
        ppts_decimal: r.settings?.ppts_decimal || 0,
      })),
    };

    // Only a season that is over is safe to keep forever. A past league_id in
    // the chain is over by definition, but guard on the season string anyway
    // in case a caller passes the live one.
    if (String(season) !== String(STATE.season)) {
      TacoStorage.setNamespaced(SEASON_SNAPSHOT_CACHE_NS, leagueId, { final: true, snap });
    }
    return snap;
  } catch (_e) {
    return null;
  }
}

window.fetchSeasonSnapshot = fetchSeasonSnapshot;

/** The signed-in user's record in one cached season snapshot.
 *
 * Matched by owner_id, which is what keeps an orphan takeover honest: take a
 * team over in 2026 and you do not own 2025's roster, so this returns null
 * for that season rather than inheriting the last owner's losses. Co-owners
 * count -- Sleeper lists them apart from owner_id. */
function myRecordFromSnapshot(snap) {
  if (!snap) return null;
  const me = String(STATE.userId || '');
  const mine = snap.rosters.find((r) => r.ownerId === me || (r.coOwners || []).includes(me));
  if (!mine) return null;
  return { season: snap.season, leagueId: snap.leagueId, ...TacoCore.seasonRecordFromRoster(mine) };
}

/** Every season of one league, newest first, as summarizeLeagueRecord wants
 * it. The live season is read off lg.allRosters (free, and always current);
 * only prior seasons cost a request, and only once ever. */
async function loadLeagueSeasonHistory(lg) {
  if (!lg?.league_id) return [];
  if (Array.isArray(lg.seasonHistory)) return lg.seasonHistory;

  const seasons = [];
  const mine = (lg.allRosters || []).find((r) => r.isMe);
  if (mine) {
    seasons.push({
      season: String(lg.season || STATE.season || ''),
      leagueId: String(lg.league_id),
      wins: mine.wins || 0,
      losses: mine.losses || 0,
      ties: mine.ties || 0,
      pointsFor: mine.pointsFor || 0,
      pointsAgainst: mine.pointsAgainst || 0,
    });
  }

  const chain = await getLeagueChain(lg.league_id);
  // Skip the head of the chain: that is this season, already added above.
  for (const link of chain.slice(1)) {
    const snap = await fetchSeasonSnapshot(link.leagueId, link.season);
    const rec = myRecordFromSnapshot(snap);
    if (rec) seasons.push(rec);
  }

  lg.seasonHistory = seasons;
  return seasons;
}
window.loadLeagueSeasonHistory = loadLeagueSeasonHistory;

/** Ownership turnover for one league chain: who left a team, who took one on.
 *
 * Reuses the very same cached season snapshots the all-time record walks, so
 * once either feature has loaded a league, the other costs nothing. */
async function loadLeagueTurnover(lg) {
  if (!lg?.league_id) return null;
  const chain = await getLeagueChain(lg.league_id);
  if (chain.length < 2) return null;

  const seasons = [{
    season: String(lg.season || STATE.season || ''),
    leagueId: String(lg.league_id),
    leagueName: lg.name,
    rosters: (lg.allRosters || []).map((r) => ({
      rosterId: String(r.rosterId),
      ownerId: r.ownerId ? String(r.ownerId) : null,
      coOwners: r.coOwners || [],
      teamName: r.teamName || r.ownerName || null,
    })),
  }];
  const names = {};
  for (const r of lg.allRosters || []) {
    if (r.ownerId && r.ownerName) names[String(r.ownerId)] = r.ownerName;
  }

  for (const link of chain.slice(1)) {
    const snap = await fetchSeasonSnapshot(link.leagueId, link.season);
    if (!snap) continue;
    Object.assign(names, snap.names);
    seasons.push({
      season: snap.season,
      leagueId: snap.leagueId,
      leagueName: lg.name,
      rosters: snap.rosters,
    });
  }
  if (seasons.length < 2) return null;

  // Keep the assembled seasons under the CURRENT league id. The snapshots
  // themselves are cached under their own (past) league ids, which is the
  // wrong key for anything asking "this league's history" -- and the manager
  // profile reads every owner's past seasons out of exactly this.
  STATE.seasonSnapshots[lg.league_id] = seasons;

  const result = TacoCore.buildLeagueTurnover({ seasons });
  result.leagueId = lg.league_id;
  result.leagueName = lg.name;
  result.names = names;
  result.seasons = seasons;
  return result;
}
window.loadLeagueTurnover = loadLeagueTurnover;

/** Turnover across every league the user is in that has run more than one
 * season. Lazy, cached in STATE, and essentially free once the all-time
 * record has loaded -- they share the season snapshots. */
let turnoverInFlight = null;
function loadOwnerTurnover() {
  if (STATE.ownerTurnover) return Promise.resolve(STATE.ownerTurnover);
  if (turnoverInFlight) return turnoverInFlight;

  turnoverInFlight = (async () => {
    const perLeague = [];
    const names = {};
    for (const lg of STATE.leagues) {
      if (lg.startupComplete === false) continue;
      const r = await loadLeagueTurnover(lg);
      if (!r) continue;
      Object.assign(names, r.names);
      perLeague.push(r);
    }
    const agg = TacoCore.aggregateOwnerTurnover(perLeague, names);
    agg.byLeague = perLeague;
    agg.leaguesWithHistory = perLeague.length;
    STATE.ownerTurnover = agg;
    return agg;
  })()
    .catch((e) => {
      console.warn('[turnover] load failed', e && e.message);
      return null;
    })
    .finally(() => { turnoverInFlight = null; });

  return turnoverInFlight;
}
window.loadOwnerTurnover = loadOwnerTurnover;

// How far back to ask. Sleeper's dynasty era starts around 2018 and an empty
// season costs one cheap request, so walking back until two consecutive
// seasons come up empty is both complete and bounded.
const CAREER_FIRST_SEASON = 2017;

/** Every league-season a manager actually played, newest season first.
 *
 * This exists because every career number in the app used to be built by
 * walking the leagues somebody is in THIS season and following each one's
 * previous_league_id backwards -- which cannot see a league they played and
 * then left, because it is not in their current list at all.
 *
 * Measured on Owen: 32 leagues in 2026, 53 in 2025, 26 in 2024, 3 in 2023.
 * 114 league-seasons; the old walk found 54.
 *
 * One request per season for the list, then one per league for its rosters --
 * and that second one is free for any league an earlier feature already
 * cached, because it goes through fetchSeasonSnapshot.
 */
async function loadCareer(userId, { onProgress } = {}) {
  const uid = String(userId || '');
  if (!uid) return null;
  if (STATE.careers[uid]) return STATE.careers[uid];

  const ctx = (typeof TacoCore !== 'undefined' && TacoCore.resolveNflWeekContext)
    ? TacoCore.resolveNflWeekContext() : {};
  const thisSeason = Number(ctx.season || STATE.season || new Date().getFullYear());

  const rows = [];
  const seasonsSeen = [];
  let emptyRun = 0;
  for (let season = thisSeason; season >= CAREER_FIRST_SEASON; season -= 1) {
    let leagues = [];
    try {
      leagues = await api('/user/' + uid + '/leagues/nfl/' + season) || [];
    } catch (_e) { leagues = []; }
    if (!Array.isArray(leagues) || !leagues.length) {
      // Two blank seasons in a row means we are past the start of their
      // Sleeper history, not looking at a year they happened to sit out.
      emptyRun += 1;
      if (emptyRun >= 2) break;
      continue;
    }
    emptyRun = 0;
    seasonsSeen.push(String(season));

    let next = 0;
    const worker = async () => {
      while (next < leagues.length) {
        const lg = leagues[next++];
        try {
          const snap = await fetchSeasonSnapshot(lg.league_id, season);
          if (!snap) continue;
          const mine = snap.rosters.find((r) => r.ownerId === uid || (r.coOwners || []).includes(uid));
          if (!mine) continue;
          const games = (mine.wins || 0) + (mine.losses || 0) + (mine.ties || 0);
          if (!games) continue;
          rows.push({
            season: String(season),
            leagueId: String(lg.league_id),
            leagueName: lg.name,
            dynasty: lg.settings?.type === 2,
            ...TacoCore.seasonRecordFromRoster(mine),
            maxPointsFor: (Number(mine.ppts) || 0) + (Number(mine.ppts_decimal) || 0) / 100,
          });
        } catch (_e) { /* one unreadable league is not the career */ }
      }
    };
    await Promise.all(Array.from({ length: 6 }, worker));
    if (onProgress) onProgress({ season: String(season), rows: rows.length });
  }

  const career = TacoCore.buildCareer(rows);
  career.rows = rows;
  career.seasonsFetched = seasonsSeen.length;
  STATE.careers[uid] = career;
  return career;
}
window.loadCareer = loadCareer;

/** Fill in every league's history, then hand back the portfolio roll-up.
 *
 * Lazy and cached: cold, this is roughly one request per prior season across
 * the whole portfolio (~60 for 31 leagues with 2 seasons each), and after that
 * essentially nothing, because completed seasons never change. Callers render
 * the current-season numbers immediately -- those need no requests at all --
 * and re-render when this lands.
 */
let allTimeRecordsInFlight = null;
function loadAllTimeRecords() {
  if (STATE.allTimeRecords) return Promise.resolve(STATE.allTimeRecords);
  if (allTimeRecordsInFlight) return allTimeRecordsInFlight;

  allTimeRecordsInFlight = (async () => {
    const byLeague = {};
    const summaries = [];
    for (const lg of STATE.leagues) {
      if (lg.startupComplete === false) continue;
      const seasons = await loadLeagueSeasonHistory(lg);
      const summary = TacoCore.summarizeLeagueRecord(seasons);
      summary.leagueId = lg.league_id;
      summary.name = lg.name;
      byLeague[lg.league_id] = summary;
      summaries.push(summary);
    }
    const result = { byLeague, portfolio: TacoCore.aggregatePortfolioRecord(summaries) };
    STATE.allTimeRecords = result;
    return result;
  })()
    .catch((e) => {
      console.warn('[all-time] load failed', e && e.message);
      return null;
    })
    .finally(() => { allTimeRecordsInFlight = null; });

  return allTimeRecordsInFlight;
}
window.loadAllTimeRecords = loadAllTimeRecords;

/** This season's record for one league, with no requests at all -- it is
 * already on the roster. Every surface that wants a record shows this
 * immediately and upgrades to all-time when loadAllTimeRecords lands. */
function currentSeasonRecord(lg) {
  const mine = (lg?.allRosters || []).find((r) => r.isMe);
  if (!mine) return null;
  return TacoCore.summarizeLeagueRecord([{
    season: String(lg.season || STATE.season || ''),
    wins: mine.wins || 0,
    losses: mine.losses || 0,
    ties: mine.ties || 0,
    pointsFor: mine.pointsFor || 0,
    pointsAgainst: mine.pointsAgainst || 0,
  }]);
}
window.currentSeasonRecord = currentSeasonRecord;

;
/*! ==== 55-portfolio-overview.js ==== */
// All Leagues overview grid, exposure hero, and league search. Extracted from 13-cross-league-injury-strip.

// Key for the team-style badge on each league card. Lists only the styles your
// leagues actually have (Owen, 2026-09-30: the full list of eight showed styles
// he never sees), each drawn as the same coloured pill the cards use.
// Definitions come straight from GLOSSARY so they cannot drift.
const ARCHETYPE_TERMS = ['Dynasty Core', 'Contender', 'Ascending', 'Middle Tier', 'Rebuild'];
function renderArchetypeKey() {
  const slot = document.getElementById('archetypeKeySlot');
  if (!slot) return;
  if (!(STATE.leagues || []).length || typeof GLOSSARY === 'undefined' || typeof archetypeForRoster !== 'function') {
    slot.innerHTML = '';
    return;
  }
  const inUse = new Set();
  for (const lg of STATE.leagues) {
    const me = (lg.allRosters || []).find((r) => r.isMe);
    if (me) inUse.add(archetypeForRoster(lg, me));
  }
  const rows = ARCHETYPE_TERMS
    .filter((t) => inUse.has(t) && GLOSSARY[t])
    .map((t) => '<div class="page-key-row arch-key-row"><span class="league-archetype arch-' + t.toLowerCase().replace(/\s+/g, '-') + '">' +
      escapeHtml(t) + '</span><span class="page-key-def">' + escapeHtml(GLOSSARY[t]) + '</span></div>')
    .join('');
  slot.innerHTML = rows
    ? '<details class="page-key"><summary class="page-key-summary">Key - what the team styles mean</summary><div class="page-key-body">' + rows + '</div></details>'
    : '';
}
window.renderArchetypeKey = renderArchetypeKey;

// The cross-league "League settings - where your leagues differ" section is
// gone (Owen, 2026-10-18: "this whole thing can go. i have decided the
// information is not that important to see across all leagues"). The
// standalone League Rules view it was folded in from had already lost its
// route and its nav entry, so the feature went with it rather than being left
// half-reachable. Per-league scoring is unaffected: "How this league scores"
// on League Overview is a different, per-league thing.

// --- rank-trend snapshots (backend) ------------------------------------------
// Records each league's standings for the current NFL week to the backend
// (SNAP_DB, sandbox-only), so a value-rank / standing-rank trend accrues over the
// season. One POST per league per week (throttled); the upsert dedupes.
const _snapshotPosted = new Set();
function postStandingsSnapshotAll() {
  if (typeof BACKEND_URL === 'undefined' || !BACKEND_URL || !(STATE.leagues || []).length) return;
  const ctx = window.TacoCore && TacoCore.resolveNflWeekContext ? TacoCore.resolveNflWeekContext() : {};
  const season = ctx.season || STATE.season;
  const week = Math.max(1, Math.min(18, Number(ctx.week) || 1));
  if (!season) return;
  STATE.leagues.forEach((lg) => {
    if (!lg.allRosters || !lg.allRosters.length) return;
    const myR = lg.allRosters.find((r) => r.isMe);
    const gp = myR ? (myR.wins || 0) + (myR.losses || 0) + (myR.ties || 0) : 0;
    if (gp <= 0) return; // nothing to record before the season starts
    const key = lg.league_id + ':' + season + ':' + week;
    if (_snapshotPosted.has(key)) return;
    _snapshotPosted.add(key);

    const vals = window.TacoCore && TacoCore.leagueTeamValues ? TacoCore.leagueTeamValues(lg) : [];
    const valByRoster = {};
    vals.forEach((v) => { valByRoster[v.rosterId] = v.value || 0; });
    const rosters = lg.allRosters.map((r) => ({
      rosterId: r.rosterId,
      valueRank: lg.allRosters.filter((o) => (valByRoster[o.rosterId] || 0) > (valByRoster[r.rosterId] || 0)).length + 1,
      standingRank: lg.allRosters.filter((o) => {
        const ow = o.wins || 0; const rw = r.wins || 0;
        return ow > rw || (ow === rw && (o.pointsFor || 0) > (r.pointsFor || 0));
      }).length + 1,
      pointsFor: r.pointsFor || 0,
      pointsAgainst: r.pointsAgainst || 0,
      wins: r.wins || 0, losses: r.losses || 0, ties: r.ties || 0,
    }));

    fetch(BACKEND_URL + '/api/standings/snapshot', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ leagueId: lg.league_id, season, week, rosters }),
    }).catch((e) => console.warn('[standings-snapshot] post failed', e && e.message));
  });
}
window.postStandingsSnapshotAll = postStandingsSnapshotAll;

// Fetch one league's rank history for the current user's roster; cache in STATE
// and re-render the team view when it lands. Where SNAP_DB is unbound the
// backend returns an empty week list, so this degrades to no trend rather than
// erroring. Production has been bound since 2026-09-20 and accrues from then --
// nothing is retroactive, so a trend needs two weeks before it says anything.
function loadStandingsTrend(lg) {
  if (typeof BACKEND_URL === 'undefined' || !BACKEND_URL || !lg) return;
  STATE.standingsTrend = STATE.standingsTrend || {};
  if (STATE.standingsTrend[lg.league_id] !== undefined) return; // cached (incl. in-flight null)
  const myR = (lg.allRosters || []).find((r) => r.isMe);
  const ctx = window.TacoCore && TacoCore.resolveNflWeekContext ? TacoCore.resolveNflWeekContext() : {};
  const season = ctx.season || STATE.season;
  if (!myR || !season) return;
  STATE.standingsTrend[lg.league_id] = null; // in-flight
  fetch(`${BACKEND_URL}/api/standings/trend?leagueId=${encodeURIComponent(lg.league_id)}&rosterId=${myR.rosterId}&season=${encodeURIComponent(season)}`)
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => {
      STATE.standingsTrend[lg.league_id] = d && Array.isArray(d.weeks) ? d.weeks : [];
      const cur = STATE.leagues[STATE.currentTeamIdx];
      const teamActive = document.getElementById('teamView') && document.getElementById('teamView').classList.contains('active');
      if (cur && cur.league_id === lg.league_id && teamActive && typeof renderTeamDetail === 'function') renderTeamDetail();
    })
    .catch(() => { STATE.standingsTrend[lg.league_id] = []; });
}
window.loadStandingsTrend = loadStandingsTrend;

// ===== Action Queue: cross-league "fix these now" triage =====
// The highest-leverage weekly view -- broken lineups, empty starting slots, and
// injured / bye / IR-taxi starters across the whole book, ranked, leading the
// home page so the real problems are the first thing you see (Owen).
//
// It GROUPS BY PLAYER. A flat list emitted one row per league per problem, so a
// receiver who is Out in eight of your lineups was eight identical rows with no
// way to tell them apart -- the page advertised cross-league reach and then
// punished the people who have it. One player is one decision.
//
// The maths lives in shared/action-queue.mjs, which the Injury Report also reads
// its statuses from, so the two pages cannot disagree about the same starter.

// Groups the user has expanded, by group key, so a re-render restores them.
const aqOpen = new Set();

const AQ_ICON = { injured: '\u271A', mistake: '\u26A0', bye: '\u263E', empty: '\u25A2', questionable: '?', noteam: '\u2205' };

/** The headline under "Fix these now": unique problems, raw alerts, leagues. */
function aqCountsLine(counts) {
  const n = (v, one, many) => v + ' ' + (v === 1 ? one : many);
  return [
    n(counts.issues, 'issue', 'issues'),
    n(counts.alerts, 'alert', 'alerts'),
    n(counts.leagues, 'league', 'leagues'),
  ].join(' \u00B7 ');
}

/** What one group is called: the problem, and how wide it is. */
function aqGroupTitle(g) {
  if (g.kind === 'empty') {
    return g.slots + ' empty starting slot' + (g.slots === 1 ? '' : 's');
  }
  const where = g.count === 1 ? '1 lineup' : g.count + ' lineups';
  if (g.kind === 'injured') return TacoCore.injuryLabel(g.status) + ' in ' + where;
  if (g.kind === 'questionable') return 'Questionable in ' + where;
  if (g.kind === 'mistake') return 'On ' + g.status + ', started in ' + where;
  if (g.kind === 'bye') return 'On bye in ' + where;
  if (g.kind === 'noteam') return 'No NFL team, taking a roster spot in ' + (g.count === 1 ? '1 league' : g.count + ' leagues');
  return where;
}

// This week's lineups, one Sleeper matchups call per league, six at a time
// (the Slate's limit). The roster's own `starters` follow whichever week was
// edited last: Owen's week-3 lineup was full while his roster carried week 4's,
// which had a bye-week hole, and the queue told him to fill it (2026-09-27).
// Refetched when the leagues reload, so a lineup fixed in Sleeper clears here.
// A second caller while a fetch is in flight gets that same promise, never an
// instant undefined: Lineup Sweep awaited the instant return, re-rendered,
// asked again, and looped in microtasks until the tab froze (2026-09-29).
let weekLineupsPromise = null;
function ensureWeekLineups() {
  if (weekLineupsPromise) return weekLineupsPromise;
  const leagues = STATE.leagues || [];
  const week = typeof slateCurrentWeek === 'function' ? slateCurrentWeek() : null;
  if (!week || !leagues.length) return Promise.resolve();
  const cache = STATE.weekLineups;
  if (cache && cache.week === week && cache.leaguesRef === leagues) return Promise.resolve();
  weekLineupsPromise = fetchWeekLineups(leagues, week).finally(() => { weekLineupsPromise = null; });
  return weekLineupsPromise;
}
async function fetchWeekLineups(leagues, week) {
  const byLeague = {};
  try {
    let next = 0;
    const worker = async () => {
      while (next < leagues.length) {
        const lg = leagues[next++];
        const mine = (lg.allRosters || []).find((r) => r.isMe);
        if (!mine) continue;
        try {
          const rows = await api(`/league/${lg.league_id}/matchups/${week}`);
          const row = Array.isArray(rows) && rows.find((m) => String(m.roster_id) === String(mine.rosterId));
          if (row && Array.isArray(row.starters)) byLeague[String(lg.league_id)] = row.starters;
        } catch (_e) { /* that league skips the empty-slot check rather than guessing */ }
      }
    };
    await Promise.all(Array.from({ length: 6 }, worker));
  } catch (_e) { /* per-league failures are caught above */ }
  STATE.weekLineups = { week, leaguesRef: leagues, byLeague };
  renderActionQueue();
  if (typeof lineupSweepDataLanded === 'function') lineupSweepDataLanded();
}

function renderActionQueue() {
  const slot = document.getElementById('actionQueueSlot');
  if (!slot) return;
  if (!(STATE.leagues || []).length) { slot.innerHTML = ''; return; }
  // Bye detection needs The Slate's weekly schedule map; load it once if absent
  // (this re-renders the injuries/overview when it lands).
  if ((!STATE.weeklyScheduleMap || !Object.keys(STATE.weeklyScheduleMap).length) && typeof ensureInjurySchedule === 'function') {
    ensureInjurySchedule();
  }
  if (!window.TacoCore || typeof TacoCore.buildActionQueue !== 'function') { slot.innerHTML = ''; return; }

  ensureWeekLineups();
  // Until this week's lineups land, show a skeleton rather than rows.
  //
  // Passing an empty map used to let the queue render provisionally, and the
  // provisional answer is not just incomplete, it is WRONG: without real
  // matchup data the empty-slot check falls back to the roster's own
  // `starters`, which follow whichever week was edited last -- the exact bug
  // the fetch above exists to fix (2026-09-27). Measured on Owen's 30 leagues
  // (2026-10-16): the panel rendered at 441px, then collapsed to 167px 1.5s
  // later once the real lineups disproved the extra rows. So for a second and
  // a half the home page listed lineup problems he had already fixed in
  // Sleeper, and the collapse was 0.26 of the page's 0.317 layout shift.
  //
  // ensureWeekLineups always resolves -- fetchWeekLineups sets STATE.weekLineups
  // and re-renders even when every league's fetch throws -- so this cannot
  // stick on the skeleton.
  const wl = STATE.weekLineups;
  const lineupsReady = !!(wl && wl.leaguesRef === STATE.leagues);
  if (!lineupsReady) {
    slot.innerHTML =
      '<div class="aq-panel aq-pending" aria-busy="true" aria-label="Checking this week\'s lineups">' +
      '<div class="aq-pending-head"><span class="skeleton-line skeleton-line-wide"></span></div>' +
      '<div class="aq-pending-rows">' +
      '<span class="skeleton-line"></span><span class="skeleton-line"></span><span class="skeleton-line"></span>' +
      '</div></div>';
    return;
  }
  const lineups = wl.byLeague;
  const { groups, counts } = TacoCore.buildActionQueue({
    leagues: STATE.leagues,
    playersDB: STATE.playersDB,
    schedule: STATE.weeklyScheduleMap,
    lineups,
  });

  if (!groups.length) {
    slot.innerHTML = '<div class="aq-panel aq-clear"><span class="aq-clear-check">\u2713</span><span>No lineup problems across your book \u2014 you are set for the week.</span></div>';
    return;
  }

  // The roster tab, not the league overview: a lineup problem is fixed on the
  // lineup. Every row used to land on the overview and leave you hunting.
  const path = (id) => (window.TacoRoutes && TacoRoutes.leaguePath)
    ? TacoRoutes.leaguePath(id, 'roster')
    : '/portfolio';

  // Two ways out of a problem row: our own roster page, and Sleeper itself.
  // The second is the one that actually fixes it -- Sleeper has no write API,
  // so the honest move is to hand the manager to the screen where the change
  // is made rather than pretend we can make it for them. On mobile the link
  // is a universal link, so it opens the app when it is installed.
  // The fix, not just the problem (Command Center brief, 2026-09-27): the
  // swap Lineup Sweep (96) would make in that league, so the two pages cannot
  // disagree. Only when a real bench option exists and the game has not
  // started; computed once per league per render.
  const sweeps = {};
  const sweepFor = (leagueId) => {
    if (leagueId in sweeps) return sweeps[leagueId];
    const lg = (STATE.leagues || []).find((x) => String(x.league_id) === String(leagueId));
    sweeps[leagueId] = lg && typeof lineupSweepForLeague === 'function' && STATE.weeklyProjections
      ? lineupSweepForLeague(lg, new Date(), lineups) : null;
    return sweeps[leagueId];
  };
  const swapFor = (g, leagueId) => {
    const sw = sweepFor(leagueId);
    if (!sw || !sw.moves) return null;
    if (g.kind === 'empty') return sw.moves.find((m) => !m.sit) || null;
    if (!g.playerId) return null;
    return sw.moves.find((m) => m.sit && String(m.sit.playerId) === String(g.playerId)) || null;
  };

  const leagueRow = (l, g) => {
    const fix = (window.TacoCore && TacoCore.sleeperLineupUrl)
      ? TacoCore.sleeperLineupUrl(l.leagueId)
      : null;
    // Land on the problem: the roster row of that player (or the lineup for an
    // empty slot), scrolled to and highlighted -- see applyLeagueFocus (14).
    const focus = g && g.playerId ? '?focus=' + encodeURIComponent(g.playerId) : '?focus=lineup';
    const swap = g ? swapFor(g, l.leagueId) : null;
    return '<div class="aq-league-row">' +
      '<a class="aq-league-link" href="' + escapeHtml(path(l.leagueId) + focus) + '" data-router>' +
      '<span class="aq-league-name">' + escapeHtml(l.leagueName) + '</span>' +
      (swap ? '<span class="aq-swap">Swap in <b>' + escapeHtml(swap.start.name || '') + '</b> · ' + swap.start.points.toFixed(1) + ' pts projected</span>' : '') +
      '<span class="aq-league-go">Open lineup</span>' +
      '<span class="aq-chev" aria-hidden="true">\u203A</span>' +
      '</a>' +
      (fix
        ? '<a class="aq-league-fix" href="' + escapeHtml(fix) + '" target="_blank" rel="noopener noreferrer">Fix in Sleeper \u2197</a>'
        : '') +
      '</div>';
  };

  const groupHtml = (g) => {
    const open = aqOpen.has(g.key);
    const photo = (g.playerId && typeof playerAvatarHtml === 'function')
      ? playerAvatarHtml(g.playerId, g.name, g.position) : '';
    const who = g.name
      ? '<span class="aq-player">' + escapeHtml(g.name) + '</span>' +
        (g.position ? '<span class="aq-pos">' + escapeHtml(g.position) + (g.team ? ' \u00B7 ' + escapeHtml(g.team) : '') + '</span>' : '')
      : '<span class="aq-player">' + escapeHtml(g.leagues[0].leagueName) + '</span>';
    return (
      '<div class="aq-group aq-' + g.kind + (open ? ' aq-group-open' : '') + '">' +
      '<button type="button" class="aq-group-head" data-aq-group="' + escapeHtml(g.key) + '"' +
        ' aria-expanded="' + (open ? 'true' : 'false') + '" aria-controls="aq-body-' + escapeHtml(g.key) + '">' +
      '<span class="aq-icon" aria-hidden="true">' + (AQ_ICON[g.kind] || '\u2022') + '</span>' +
      photo +
      '<span class="aq-text">' + who +
      '<span class="aq-detail">' + escapeHtml(aqGroupTitle(g)) + '</span></span>' +
      // The count is the point of the grouping, so it is the number on the row.
      '<span class="aq-count-pill">' + g.count + '</span>' +
      '<span class="aq-chev" aria-hidden="true">\u203A</span>' +
      '</button>' +
      '<div class="aq-group-body" id="aq-body-' + escapeHtml(g.key) + '"' + (open ? '' : ' hidden') + '>' +
      g.leagues.map((l) => leagueRow(l, g)).join('') +
      '</div>' +
      '</div>'
    );
  };

  const cap = 25;
  const shown = groups.slice(0, cap);
  const more = groups.length > cap ? '<div class="aq-more">+' + (groups.length - cap) + ' more</div>' : '';
  slot.innerHTML =
    '<div class="aq-panel">' +
    '<div class="aq-head"><span class="aq-title">Fix these now</span>' +
    '<span class="aq-count">' + counts.issues + '</span>' +
    '<span class="aq-sub">' + aqCountsLine(counts) + '</span></div>' +
    shown.map(groupHtml).join('') + more +
    '</div>';
}
window.renderActionQueue = renderActionQueue;

document.addEventListener('click', function (e) {
  const head = e.target.closest ? e.target.closest('[data-aq-group]') : null;
  if (!head) return;
  const key = head.dataset.aqGroup;
  const body = document.getElementById('aq-body-' + key);
  if (!body) return;
  const open = body.hidden;
  body.hidden = !open;
  head.setAttribute('aria-expanded', open ? 'true' : 'false');
  head.closest('.aq-group').classList.toggle('aq-group-open', open);
  if (open) aqOpen.add(key); else aqOpen.delete(key);
});

function renderOverview() {
  const grid = document.getElementById('leagueGrid');
  if (!grid) return;
  grid.innerHTML = '';
  const leagueCount = STATE.leagues.length;

  const emptyState = document.getElementById('portfolioEmptyState');
  const overviewControls = document.querySelector('#overviewView .overview-controls');
  if (leagueCount === 0) {
    if (emptyState) emptyState.style.display = 'flex';
    if (overviewControls) overviewControls.style.display = 'none';
    const titleEl = document.getElementById('overviewTitle');
    const subEl = document.getElementById('overviewSub');
    if (titleEl) titleEl.innerHTML = 'Your <em>Portfolio</em>';
    if (subEl) subEl.style.display = 'none';
    return;
  }
  if (emptyState) emptyState.style.display = 'none';
  if (overviewControls) overviewControls.style.display = '';
  const subEl2 = document.getElementById('overviewSub');
  if (subEl2) subEl2.style.display = '';

  const leagueNoun = leagueCount === 1 ? 'league' : 'leagues';
  // Match the nav label ("All Leagues") so the header doesn't rename the same
  // page to "Your leagues" (Owen: keep it consistent).
  document.getElementById('overviewTitle').innerHTML = 'All <em>Leagues</em>';
  document.getElementById('overviewSub').textContent = leagueCount === 1
    ? `${STATE.leagues[0]?.name || 'Your league'} · value rank & archetype on the card below`
    : `${leagueCount} dynasty ${leagueNoun} · one card each - ranks are per league, not combined`;

  const oneLeagueNote = document.getElementById('oneLeagueNote');
  if (oneLeagueNote) {
    if (leagueCount === 1) {
      oneLeagueNote.style.display = 'flex';
      oneLeagueNote.innerHTML = `
        <span class="one-league-icon">★</span>
        <span class="one-league-text">
          <strong>You're in one dynasty league.</strong> The Armchair Office is built for managing multiple leagues as one portfolio,
          but features like archetype analysis, position-aware league rankings, trade calc, owner profiles,
          and waiver scanning still work on single-league setups. Cross-league features
          (player exposure, portfolio totals) light up automatically when you add another dynasty league.
        </span>
      `;
    } else {
      oneLeagueNote.style.display = 'none';
    }
  }

  const note = document.getElementById('excludedLeaguesNote');
  if (note) note.style.display = 'none';

  renderActionQueue();
  renderSnapshotPanel();
  renderArchetypeKey();
  if (typeof postStandingsSnapshotAll === 'function') postStandingsSnapshotAll();

  ensurePortfolioSortControls();

  const ranked = sortPortfolio(STATE.leagues, STATE.portfolioSortKey, STATE.portfolioSortDir);

  const q = (STATE.leagueSearchQuery || '').trim().toLowerCase();
  // Team-style chips (snapshot panel) filter too; several selected = any of them.
  const styles = archetypesSettled() ? (STATE.overviewArchetypeFilter || []) : [];
  const filtered = ranked.filter(lg => {
    const myRoster = lg.allRosters.find(r => r.isMe);
    if (q) {
      const teamName = myRoster?.teamName || '';
      if (!lg.name.toLowerCase().includes(q) && !teamName.toLowerCase().includes(q)) return false;
    }
    if (styles.length) {
      const arch = myRoster ? archetypeForRoster(lg, myRoster) : 'Middle Tier';
      if (!styles.includes(arch)) return false;
    }
    return true;
  });

  if (filtered.length === 0) {
    const what = [q ? `"${escapeHtml(q)}"` : '', styles.length ? escapeHtml(styles.join(' or ')) : ''].filter(Boolean).join(' and ');
    grid.innerHTML = `<div class="league-list-empty">No leagues match ${what}</div>`;
    return;
  }
  if (styles.length) {
    // Say what is hidden, and give the way back, right where the cards start.
    const note = document.createElement('div');
    note.className = 'league-filter-note';
    note.innerHTML = `Showing <strong>${filtered.length}</strong> of ${ranked.length} leagues · ${escapeHtml(styles.join(', '))} ` +
      '<button type="button" class="league-filter-clear" data-taco-arch-filter-clear>Show all</button>';
    grid.appendChild(note);
  }

  filtered.forEach((lg) => {
    // Flat market value via playerLeagueValue -- must match the Roster/
    // Team-detail page's own teamValue calc (14-render-team-detail.js) and
    // allTeamValues below (r.totalValue, same source), or "team total value"
    // shows a different number on this page vs the league page for the
    // exact same roster.
    const playersValue = TacoCore.rosterPlayersValue(lg.myPlayers);
    const ages = lg.myPlayers.filter(p => p.age).map(p => p.age);
    const avgAge = ages.length ? (ages.reduce((a, b) => a + b, 0) / ages.length).toFixed(1) : '-';
    const valued = lg.myPlayers.filter(p => p.value > 0);
    const avgValue = valued.length ? Math.round(valued.reduce((s, p) => s + (playerLeagueValue(p, lg) || 0), 0) / valued.length) : 0;
    const startersValue = Math.round(lg.myPlayers.filter(p => p.isStarter).reduce((s, p) => s + (playerLeagueValue(p, lg) || 0), 0));
    const picksValue = Math.round(TacoCore.picksValue(lg.myPicks));
    // Team value includes draft capital, not just players.
    const teamValue = playersValue + picksValue;

    const byPos = { QB: 0, RB: 0, WR: 0, TE: 0 };
    lg.myPlayers.forEach(p => { if (byPos[p.position] != null) byPos[p.position]++; });

    const allTeamValues = TacoCore.leagueTeamValues(lg).map(v => v.value);
    const myTeamValue = teamValue;
    const rank = TacoCore.rankAmong(allTeamValues, myTeamValue);
    const totalTeams = lg.allRosters.length;

    const allStarterValues = lg.allRosters.map(r =>
      (r.players || []).filter(p => p.isStarter).reduce((s, p) => s + (playerLeagueValue(p, lg) || 0), 0),
    );
    const starterRank = allStarterValues.filter(v => v > startersValue).length + 1;

    const myRosterObj = lg.allRosters.find(r => r.isMe);
    const archetype = myRosterObj ? archetypeForRoster(lg, myRosterObj) : 'Middle Tier';
    const archetypeClass = 'arch-' + archetype.toLowerCase().replace(/\s+/g, '-');

    const card = document.createElement('div');
    card.className = 'league-card';
    const rankClass = rank <= 3 ? 'top' : '';
    const starterRankClass = starterRank <= 3 ? 'top' : '';
    const teamAvatar = teamAvatarHtml(myRosterObj, myRosterObj?.teamName || lg.name);
    // Record comes off the roster first, season history second (Owen,
    // 2026-10-18: "record should be shown on all leagues league cards
    // obviously a big miss"). It was season-history only, and that is a
    // separate lazy fetch -- when it had not landed, or carried no row for
    // this season, the card simply showed no record at all. The roster has
    // wins/losses/ties as soon as the league loads, and standing is the same
    // wins-then-points-for rank the league page uses.
    const rosterGames = myRosterObj
      ? (myRosterObj.wins || 0) + (myRosterObj.losses || 0) + (myRosterObj.ties || 0)
      : 0;
    let recordLine = '';
    if (rosterGames > 0) {
      const standRank = lg.allRosters.filter((r) => {
        const rw = r.wins || 0; const mw = myRosterObj.wins || 0;
        return rw > mw || (rw === mw && (r.pointsFor || 0) > (myRosterObj.pointsFor || 0));
      }).length + 1;
      const rec = TacoCore.recordString(myRosterObj.wins || 0, myRosterObj.losses || 0, myRosterObj.ties || 0);
      recordLine = `${rec} · ${typeof ordinal === 'function' ? ordinal(standRank) : standRank} of ${lg.allRosters.length || lg.total_rosters}`;
    }
    // Win rate and points per game, from the same roster the record came
    // from, so the card needs no fetch to show them. The all-time line below
    // does need one per prior season -- it fills in when module 12's walk
    // lands, and the card is complete without it until then.
    const seasonSummary = typeof currentSeasonRecord === 'function' ? currentSeasonRecord(lg) : null;
    const allTimeForLeague = STATE.allTimeRecords?.byLeague?.[lg.league_id] || null;
    // Only worth a line of its own once there is history the season line does
    // not already cover -- otherwise it would just repeat the record above it.
    const showAllTime = allTimeForLeague
      && allTimeForLeague.games > (seasonSummary?.games || 0)
      && allTimeForLeague.seasonsPlayed > 1;
    const recordStatsLine = seasonSummary && seasonSummary.games > 0
      ? `<div class="league-record-stats">
          <span class="lrs-item ${winPctCls(seasonSummary.winPct)}" data-tooltip="Win rate this season in this league. A tie counts as half a win.">${fmtWinPct(seasonSummary.winPct)}</span>
          <span class="lrs-item" data-tooltip="Your points per game this season in this league">${seasonSummary.pointsPerGame != null ? seasonSummary.pointsPerGame.toFixed(1) : '-'} <span class="lrs-unit">pts/g</span></span>
          ${showAllTime ? `<span class="lrs-item lrs-alltime" data-tooltip="All-time in this league, across ${allTimeForLeague.seasonsPlayed} seasons (${allTimeForLeague.seasons.join(', ')}). Seasons before you joined are not counted.">${escapeHtml(allTimeForLeague.record)} <span class="lrs-unit">all-time</span> ${fmtWinPct(allTimeForLeague.winPct)}</span>` : ''}
        </div>`
      : '';
    const isPreStartup = lg.startupComplete === false;
    const rankCorner = isPreStartup
      ? `<div class="league-card-prestartup" data-tooltip="Startup draft hasn't happened yet - rosters are empty">PRE-DRAFT</div>`
      : `<div class="league-card-rankbox">
          <div class="league-card-rank ${rankClass}" data-tooltip="Rank within league by total team value (all rostered players combined)"><span class="rank-basis">VALUE</span><strong>${rank}</strong>/${totalTeams}</div>
          <div class="league-card-rank ${starterRankClass}" data-tooltip="Rank within league by starting-lineup value (current starters only)"><span class="rank-basis">START</span><strong>${starterRank}</strong>/${totalTeams}</div>
        </div>`;
    // Where you stand — real season standing context: record + points-for and
    // points-against ranks among the league. Shown once the season has games.
    const myR = myRosterObj;
    const gamesPlayed = myR ? (myR.wins || 0) + (myR.losses || 0) + (myR.ties || 0) : 0;
    // ordinal(8) is "8th"; uses below are `${rank}${ord(rank)}`, so ord must
    // return the SUFFIX only or rank 8 renders "88th".
    const ord = (n) => (typeof ordinal === 'function' ? ordinal(n).slice(String(n).length) : '');
    let standStrip = '';
    if (myR && gamesPlayed > 0) {
      const pfRank = lg.allRosters.filter((r) => (r.pointsFor || 0) > (myR.pointsFor || 0)).length + 1;
      const paRank = lg.allRosters.filter((r) => (r.pointsAgainst || 0) < (myR.pointsAgainst || 0)).length + 1;
      const maxPfRank = lg.allRosters.filter((r) => (r.maxPointsFor || 0) > (myR.maxPointsFor || 0)).length + 1;
      const maxPfVal = (myR.maxPointsFor || 0).toFixed(1);
      // Record + standing already show in the card subtitle (recordLine); the
      // strip carries the points-for/against + max-PF (ceiling) ranks so nothing
      // is doubled.
      standStrip =
        '<div class="lc-stand">' +
        `<span class="lc-stand-item" data-tooltip="Points for - rank in league">PF <b>${pfRank}${ord(pfRank)}</b></span>` +
        `<span class="lc-stand-item" data-tooltip="Max PF - potential points with optimal lineups (${maxPfVal} pts), rank in league">Max PF <b>${maxPfRank}${ord(maxPfRank)}</b></span>` +
        `<span class="lc-stand-item" data-tooltip="Points against - rank in league (1st = fewest allowed)">PA <b>${paRank}${ord(paRank)}</b></span>` +
        '</div>';
    }
    card.innerHTML = `
      <div class="league-card-top">
        ${rankCorner}
        <div class="league-format">${lg.scoringTab.toUpperCase()}</div>
      </div>
      <div class="league-card-identity">
        ${teamAvatar}
        <div class="league-card-identity-text">
          <div class="league-name">${escapeHtml(lg.name)}</div>
          <div class="league-teams-line">${lg.total_rosters} teams · ${escapeHtml(myRosterObj?.teamName || 'Your team')}${recordLine ? ` · <span class="league-record">${escapeHtml(recordLine)}</span>` : ''}</div>
        ${recordStatsLine}
        </div>
      </div>
      ${archetypesSettled() ? `<div class="league-archetype ${archetypeClass}" data-tooltip="${escapeHtml(GLOSSARY[archetype] || '')}">${archetype}</div>` : archetypePendingPill('league-archetype').replace(/<span/, '<div').replace(/span>$/, 'div>')}
      <div class="league-card-hero">
        <div class="lc-hero-value">${formatCompactNumber(teamValue)}</div>
        <div class="lc-hero-label">Team value</div>
      </div>
      <div class="league-posbar" aria-hidden="true">
        ${byPos.QB ? `<span class="pos-qb" style="flex:${byPos.QB}"></span>` : ''}
        ${byPos.RB ? `<span class="pos-rb" style="flex:${byPos.RB}"></span>` : ''}
        ${byPos.WR ? `<span class="pos-wr" style="flex:${byPos.WR}"></span>` : ''}
        ${byPos.TE ? `<span class="pos-te" style="flex:${byPos.TE}"></span>` : ''}
      </div>
      <div class="league-card-stats">
        <div class="lc-stat"><span class="lc-stat-n">${formatCompactNumber(startersValue)}</span><span class="lc-stat-l">Starters</span></div>
        <div class="lc-stat"><span class="lc-stat-n">${formatCompactNumber(avgValue)}</span><span class="lc-stat-l">Avg val</span></div>
        <div class="lc-stat"><span class="lc-stat-n">${avgAge}</span><span class="lc-stat-l">Avg age</span></div>
        <div class="lc-stat"><span class="lc-stat-n">${formatCompactNumber(picksValue)}</span><span class="lc-stat-l">Picks</span></div>
      </div>
      ${standStrip}
    `;
    card.addEventListener('click', () => {
      STATE.currentTeamIdx = STATE.leagues.indexOf(lg);
      STATE.teamDetailTab = 'overview';
      renderTeamDetail();
      showView('team');
    });
    grid.appendChild(card);
  });
}

/** Team-style chip tapped: add or remove that style from the league filter. */
function toggleOverviewArchetype(arch) {
  const cur = STATE.overviewArchetypeFilter || [];
  STATE.overviewArchetypeFilter = cur.includes(arch) ? cur.filter((a) => a !== arch) : [...cur, arch];
  renderOverview();
}
window.toggleOverviewArchetype = toggleOverviewArchetype;

function clearOverviewArchetypes() {
  STATE.overviewArchetypeFilter = [];
  renderOverview();
}
window.clearOverviewArchetypes = clearOverviewArchetypes;

function onLeagueSearchInput(value) {
  STATE.leagueSearchQuery = value;
  renderOverview();
}
window.onLeagueSearchInput = onLeagueSearchInput;

function onUnifiedSearchInput(value) {
  STATE.leagueSearchQuery = value;
  renderOverview();
  renderUnifiedSearchResults(value);
}
window.onUnifiedSearchInput = onUnifiedSearchInput;

function renderUnifiedSearchResults(query) {
  const el = document.getElementById('unifiedSearchResults');
  if (!el) return;
  const q = (query || '').trim().toLowerCase();
  if (q.length < 2) { el.style.display = 'none'; el.innerHTML = ''; return; }

  const leagueMatches = STATE.leagues
    .filter(lg => lg.startupComplete !== false)
    .filter(lg => (lg.name || '').toLowerCase().includes(q))
    .slice(0, 10);

  // Managers too (Owen, 2026-11-03: "I want the option to also search for
  // managers and see all this information about them"). Matched on display
  // name AND team name, because people search for whichever they remember,
  // and rolled up one row per person rather than one per roster -- somebody
  // in six of your leagues is one result, not six.
  const managerMatches = (typeof TacoCore !== 'undefined' && TacoCore.searchManagers)
    ? TacoCore.searchManagers(STATE.leagues, q, { limit: 8 })
    : [];

  if (leagueMatches.length === 0 && managerMatches.length === 0) {
    el.innerHTML = `<div class="usr-section-head">Nothing matches "${escapeHtml(query)}"</div>`;
    el.style.display = 'block';
    return;
  }

  const managersHtml = managerMatches.length ? `
    <div class="usr-section-head">Managers matching "${escapeHtml(query)}"</div>
    ${managerMatches.map((m) => `
      <div class="usr-row" data-taco-manager="${escapeHtml(m.ownerId)}" data-taco-clear-search>
        <div class="usr-row-main">
          <span class="usr-row-name">${escapeHtml(m.name)}${m.isYou ? ' <span class="pr-mine-tag">you</span>' : ''}</span>
          <span class="usr-row-meta">${m.leagueCount} of your leagues${m.teamNames.length ? ' · ' + escapeHtml(m.teamNames.slice(0, 2).join(', ')) : ''}</span>
        </div>
        <div class="usr-row-value"><span class="usr-row-num">→</span></div>
      </div>`).join('')}` : '';

  if (leagueMatches.length === 0) {
    el.innerHTML = managersHtml;
    el.style.display = 'block';
    return;
  }

  el.innerHTML = managersHtml + `
    <div class="usr-section-head">Leagues matching "${escapeHtml(query)}"</div>
    ${leagueMatches.map(lg => {
      const myRoster = lg.allRosters?.find(r => r.isMe);
      const teamName = myRoster?.teamName || '';
      const rosterValue = (myRoster?.totalValue || 0)
        + (lg.picksByRoster?.[myRoster?.rosterId] || []).reduce((s, p) => s + (p.value || 0), 0);
      return `
        <div class="usr-row" data-taco-jump-league="${escapeHtml(lg.league_id)}" data-taco-clear-search>
          <div class="usr-row-main">
            <span class="usr-row-name">${escapeHtml(lg.name)}</span>
            <span class="usr-row-meta">${escapeHtml(lg.scoringTab || '')}${teamName ? ' · ' + escapeHtml(teamName) : ''}</span>
          </div>
          <div class="usr-row-value">
            <span class="usr-row-num">${rosterValue ? Math.round(rosterValue).toLocaleString() : ''}</span>
          </div>
        </div>
      `;
    }).join('')}
  `;
  el.style.display = 'block';
}
window.renderUnifiedSearchResults = renderUnifiedSearchResults;
window.renderOverview = renderOverview;

document.addEventListener('click', (e) => {
  const el = document.getElementById('unifiedSearchResults');
  const input = document.getElementById('leagueSearchInput');
  if (!el || !input) return;
  if (el.style.display === 'none') return;
  if (e.target === input || el.contains(e.target)) return;
  el.style.display = 'none';
});
;
/*! ==== 56-market-radar.js ==== */
// The Market — one board of players the market is moving on. It fuses two
// signals per player and shows them on the same row:
//   • momentum   — how the blended CONSENSUS value is trending (7d/30d), read
//                  from the already-loaded backend composite (via module 67's
//                  marketMomentumList, so the relevance guards live in one place)
//   • trade gap  — how real observed trades price him vs consensus, from
//                  /api/market/radar
// Together they say what neither list could alone: confirmation (both moving the
// same way = heating/cooling) vs divergence. Replaces the old separate Market
// Radar page and Risers & Fallers panel.

function marketRadarFormatTab() {
  if (STATE.marketRadarFormat) return STATE.marketRadarFormat;
  const sfCount = (STATE.leagues || []).filter(function (lg) {
    return lg.scoringTab && lg.scoringTab.indexOf('SF') === 0;
  }).length;
  return sfCount >= (STATE.leagues || []).length / 2 ? 'SF' : '1QB';
}

function marketWindow() { return STATE.risersFallersPeriod === '30d' ? '30d' : '7d'; }
function marketPosition() { return STATE.risersFallersFilter || 'ALL'; }
function marketSortMode() { return STATE.marketSort || 'heat'; }

// The loaded composite tab that best matches the chosen SF/1QB format, for the
// momentum signal. Composite is keyed by scoringTab ('SF', '1QB', '1QB TE+'…).
function marketMomentumTab(format) {
  const comp = STATE.backendComposite || {};
  const loaded = Object.keys(comp).filter(function (t) {
    return comp[t] && comp[t].players && Object.keys(comp[t].players).length > 0;
  });
  if (!loaded.length) return null;
  const wantSF = format === 'SF';
  const match = loaded.find(function (t) {
    return wantSF ? t.indexOf('SF') === 0 : t.indexOf('SF') !== 0;
  });
  if (match) return match;
  return (window.rfDominantTab ? window.rfDominantTab() : null) || loaded[0];
}

let marketRadarLoading = false;

async function loadMarketRadar() {
  if (marketRadarLoading) return;
  if (!BACKEND_URL || !STATE.leagues || !STATE.leagues.length) return;
  const formatKey = scoringTabToBackendKey(marketRadarFormatTab());
  if (!formatKey) return;
  marketRadarLoading = true;
  try {
    // A wider pull than the old radar page (12) so more of the movers on the
    // board also carry a trade signal.
    const res = await fetch(BACKEND_URL + '/api/market/radar?format=' + encodeURIComponent(formatKey) + '&limit=60');
    if (!res.ok) throw new Error('HTTP ' + res.status);
    STATE.marketRadar = await res.json();
  } catch (e) {
    console.warn('[market] radar fetch failed', e.message);
    STATE.marketRadar = { items: [], failed: true };
  } finally {
    marketRadarLoading = false;
  }
  const active = document.querySelector('.view.active');
  if (active && active.id === 'marketRadarView') renderMarketRadarView();
}

// Merge momentum + trade signals into one row per player.
function buildMarketRows() {
  const format = marketRadarFormatTab();
  const period = marketWindow();
  const pos = marketPosition();
  const tab = marketMomentumTab(format);
  const momentum = (tab && typeof marketMomentumList === 'function')
    ? marketMomentumList(tab, period, pos)
    : [];

  const items = (STATE.marketRadar && STATE.marketRadar.items) || [];
  const tradeById = {};
  items.forEach(function (it) { tradeById[String(it.sleeper_id)] = it; });

  const seen = {};
  const rows = [];
  momentum.forEach(function (m) {
    const t = tradeById[m.playerId];
    seen[m.playerId] = true;
    rows.push({
      playerId: m.playerId, name: m.name, position: m.position, team: m.team,
      value: m.value, momentum: m.momentum,
      tradeDelta: t ? t.delta_vs_consensus_pct : null,
      nTrades: t ? t.n_trades : 0,
    });
  });

  // Trade-only outliers: players the market is moving on whose consensus hasn't
  // budged (so they're not in the momentum list). Keeping them is half the point
  // of the radar signal.
  const POSITIONS = ['QB', 'RB', 'WR', 'TE'];
  items.forEach(function (it) {
    const id = String(it.sleeper_id);
    if (seen[id]) return;
    const p = STATE.playersDB && STATE.playersDB[id];
    if (!p) return;
    const position = TacoCore.primaryFantasyPosition(p, '');
    if (!POSITIONS.includes(position)) return;
    if (pos !== 'ALL' && position !== pos) return;
    seen[id] = true;
    const full = (p.full_name || ((p.first_name || '') + ' ' + (p.last_name || '')).trim()) || ('Player ' + id);
    const parts = full.trim().split(' ');
    const displayName = parts.length > 1 ? parts[0][0] + '. ' + parts.slice(1).join(' ') : full;
    const consensus = it.delta_vs_consensus_pct != null
      ? it.implied_value / (1 + it.delta_vs_consensus_pct / 100)
      : it.implied_value;
    rows.push({
      playerId: id, name: displayName, position: position, team: p.team || '',
      value: Math.round(consensus || 0), momentum: null,
      tradeDelta: it.delta_vs_consensus_pct, nTrades: it.n_trades,
    });
  });
  return rows;
}

const MARKET_MOM_THRESH = 0.5;

// One word for a row: do the two signals agree, disagree, or is only one present?
const MARKET_THIN_TRADES = 6;
function marketIsThin(row) { return !!(row.nTrades && row.nTrades < MARKET_THIN_TRADES && row.tradeDelta != null); }
/** The row as the board ranks it: a thin trade gap counts as no trade signal. */
function marketSignalRow(row) {
  return !STATE.marketIncludeThin && marketIsThin(row) ? Object.assign({}, row, { tradeDelta: null }) : row;
}

function marketHeat(row) {
  const momUp = row.momentum != null && row.momentum > MARKET_MOM_THRESH;
  const momDown = row.momentum != null && row.momentum < -MARKET_MOM_THRESH;
  const trUp = row.tradeDelta != null && row.tradeDelta > 0;
  const trDown = row.tradeDelta != null && row.tradeDelta < 0;
  if (row.momentum != null && row.tradeDelta != null) {
    if (momUp && trUp) return 'heating';
    if (momDown && trDown) return 'cooling';
    if ((momUp && trDown) || (momDown && trUp)) return 'diverging';
  }
  if (momUp || trUp) return 'up';
  if (momDown || trDown) return 'down';
  return 'flat';
}
function marketHeatScore(row) {
  return (row.momentum || 0) + (row.tradeDelta || 0);
}

function marketRowHtml(r) {
  const esc = escapeHtml;
  const heat = marketHeat(marketSignalRow(r));
  const posCls = 'pos-' + (r.position || '').toLowerCase();

  let mom;
  if (r.momentum != null) {
    const up = r.momentum > 0;
    mom = '<span class="mkt-sig mkt-mom ' + (up ? 'up' : 'down') + '">' +
      (up ? '▲' : '▼') + ' ' + (up ? '+' : '') + r.momentum.toFixed(1) + '% consensus</span>';
  } else {
    mom = '<span class="mkt-sig mkt-mom flat">consensus flat</span>';
  }

  let trade;
  if (r.tradeDelta != null) {
    const up = r.tradeDelta > 0;
    const thin = marketIsThin(r)
      ? '<span class="market-radar-thin" data-tooltip="Only ' + r.nTrades + ' observed trade' + (r.nTrades === 1 ? '' : 's') + ' - this gap is as likely to be sampling noise as a real market disagreement.">THIN</span>'
      : '';
    trade = '<span class="mkt-sig mkt-trade ' + (up ? 'up' : 'down') + '">trades ' +
      (up ? '+' : '') + r.tradeDelta + '% · ' + (r.nTrades || 0) + ' trade' + (r.nTrades === 1 ? '' : 's') + '</span>' + thin;
  } else {
    // Most consensus movers have no recent trades; repeating "no trade signal
    // yet" on nearly every row made the board read as empty. Absent says it.
    trade = '';
  }

  const tagLabel = { heating: 'HEATING UP', cooling: 'COOLING', diverging: 'DIVERGING', up: 'RISING', down: 'FALLING', flat: '' }[heat];
  const tag = tagLabel ? '<span class="mkt-tag heat-' + heat + '">' + tagLabel + '</span>' : '';
  const photo = typeof playerAvatarHtml === 'function' ? playerAvatarHtml(r.playerId, r.name, r.position) : '';
  const logo = typeof teamLogoHtml === 'function' ? teamLogoHtml(r.team, 'mkt-team-logo') : '';

  return (
    '<button type="button" class="mkt-row heat-' + heat + '" data-taco-player="' + esc(r.playerId) + '">' +
    photo +
    '<div class="mkt-row-main">' +
    '<div class="mkt-row-top">' +
    '<span class="mkt-name">' + esc(r.name) + '</span>' +
    '<span class="mkt-pos ' + posCls + '">' + esc(r.position || '') + '</span>' +
    (r.team ? '<span class="mkt-team">' + logo + esc(r.team) + '</span>' : '') +
    '</div>' +
    '<div class="mkt-signals">' + mom + trade + '</div>' +
    '</div>' +
    '<div class="mkt-row-right">' +
    '<span class="mkt-val">' + (r.value ? r.value.toLocaleString() : '-') + '</span>' +
    tag +
    '</div>' +
    '</button>'
  );
}

function renderMarketRadarView() {
  const container = document.getElementById('marketRadarContent');
  if (!container) return;

  const format = marketRadarFormatTab();
  const period = marketWindow();
  const pos = marketPosition();
  const sort = marketSortMode();

  // Trade side is fetched once and cached; the momentum side is already in STATE.
  if (!STATE.marketRadar) loadMarketRadar();

  const allRows = buildMarketRows();
  const heatCounts = { heating: 0, cooling: 0, diverging: 0 };
  allRows.forEach(function (r) { const h = marketHeat(marketSignalRow(r)); if (heatCounts[h] != null) heatCounts[h] += 1; });

  // Lens: which signal ranks the board. Movers = momentum only; Market = trade
  // only; Heat = the combined signed move, biggest magnitude first.
  // Players who matter only (shared/movers.mjs): the momentum list is already
  // floored, but trade-only rows came from any player with a trade, down to
  // deep backups. Same bar for both.
  const compPlayers = (STATE.backendComposite && STATE.backendComposite[marketMomentumTab(format)] || {}).players;
  const floor = compPlayers && TacoCore.relevanceFloor
    ? TacoCore.relevanceFloor(Object.values(compPlayers), function (x) { return x.consensus_value || 0; }, function (x) { return x.position; })
    : 0;
  let rows = allRows.filter(function (r) { return (r.value || 0) >= floor; });
  if (sort === 'movers') {
    // Biggest move in value POINTS, not percent: a 1,200-point drop by a
    // starter is news, a backup doubling from 130 is not.
    const pts = function (r) { return Math.abs(TacoCore.pointsMoved ? (TacoCore.pointsMoved(r.value, r.momentum) || 0) : r.momentum); };
    rows = rows.filter(function (r) { return r.momentum != null; })
      .sort(function (a, b) { return pts(b) - pts(a); });
  } else if (sort === 'market') {
    rows = rows.filter(function (r) { return marketSignalRow(r).tradeDelta != null; })
      .sort(function (a, b) { return Math.abs(b.tradeDelta) - Math.abs(a.tradeDelta); });
  } else {
    // A row whose only signal was a thin trade gap has nothing left to rank on.
    rows = rows.filter(function (r) { return marketHeatScore(marketSignalRow(r)) !== 0; })
      .sort(function (a, b) { return Math.abs(marketHeatScore(marketSignalRow(b))) - Math.abs(marketHeatScore(marketSignalRow(a))); });
  }
  const thinCount = allRows.filter(function (r) { return (r.value || 0) >= floor && marketIsThin(r); }).length;
  rows = rows.slice(0, 40);

  const pill = function (value, label, current, fn) {
    return '<div class="th-pill' + (value === current ? ' active' : '') +
      '" data-taco-pill="' + fn + '|' + value + '">' + label + '</div>';
  };
  const positionPills = ['ALL', 'QB', 'RB', 'WR', 'TE']
    .map(function (p) { return pill(p, p, pos, 'setMarketPosition'); }).join('');

  const header =
    '<div class="ma-head">' +
    '<div>' +
    '<h2 class="ma-title">Market Radar</h2>' +
    '<div class="ma-sub">What is moving on real trades, against where consensus values are heading. Player values for a format live in Rankings.</div>' +
    '</div>' +
    '<div class="market-radar-format-picker">' +
    '<label class="overview-sort-label" for="marketRadarFormat">Format</label>' +
    '<select id="marketRadarFormat" class="overview-select" data-taco-sort="setMarketRadarFormat">' +
    '<option value="SF"' + (format === 'SF' ? ' selected' : '') + '>Superflex</option>' +
    '<option value="1QB"' + (format === '1QB' ? ' selected' : '') + '>1QB</option>' +
    '</select>' +
    '</div>' +
    '</div>';

  const controls =
    '<div class="mkt-controls">' +
    '<div class="ma-filters-row">' + positionPills + '</div>' +
    '<div class="mkt-controls-right">' +
    '<div class="mkt-window">' +
    '<button class="mkt-window-btn' + (period === '7d' ? ' active' : '') + '" data-taco-pill="setMarketWindow|7d">7d</button>' +
    '<button class="mkt-window-btn' + (period === '30d' ? ' active' : '') + '" data-taco-pill="setMarketWindow|30d">30d</button>' +
    '</div>' +
    '<select class="overview-select mkt-sort" data-taco-sort="setMarketSort" aria-label="Sort">' +
    '<option value="heat"' + (sort === 'heat' ? ' selected' : '') + '>Sort: Heat</option>' +
    '<option value="movers"' + (sort === 'movers' ? ' selected' : '') + '>Sort: Movers</option>' +
    '<option value="market"' + (sort === 'market' ? ' selected' : '') + '>Sort: Trade market</option>' +
    '</select>' +
    '<button type="button" class="mkt-window-btn mkt-thin-toggle' + (STATE.marketIncludeThin ? ' active' : '') + '" data-taco-pill="setMarketIncludeThin|' + (STATE.marketIncludeThin ? 'off' : 'on') + '" aria-pressed="' + !!STATE.marketIncludeThin + '"' +
    ' data-tooltip="Trade gaps from fewer than ' + MARKET_THIN_TRADES + ' trades are left out of the ranking by default">Include thin samples</button>' +
    '</div>' +
    '</div>';

  // Zero counts read as a dead board ("0 heating up · 0 cooling"); show only
  // the signals that are actually present.
  const summary =
    '<div class="mkt-summary">' +
    (heatCounts.heating ? '<span class="mkt-sum heat-heating">▲ ' + heatCounts.heating + ' heating up</span>' : '') +
    (heatCounts.cooling ? '<span class="mkt-sum heat-cooling">▼ ' + heatCounts.cooling + ' cooling</span>' : '') +
    (heatCounts.diverging ? '<span class="mkt-sum heat-diverging">⇄ ' + heatCounts.diverging + ' diverging</span>' : '') +
    (thinCount ? '<span class="mkt-sum mkt-thin-note">' + (STATE.marketIncludeThin
      ? thinCount + ' thin-sample trade gap' + (thinCount === 1 ? '' : 's') + ' included'
      : thinCount + ' thin-sample trade gap' + (thinCount === 1 ? '' : 's') + ' left out') + '</span>' : '') +
    '</div>';

  const key = typeof renderKey === 'function' ? renderKey([
    { term: 'Momentum', def: 'How the blended consensus value is trending over the window (7d / 30d).' },
    { term: 'Trade gap', def: 'How real observed trades price him versus consensus right now.' },
    { term: 'Heating up', def: 'Consensus rising and trades paying up - both signals agree he’s climbing.', cls: 'heat-heating' },
    { term: 'Cooling', def: 'Consensus falling and trades paying less - both signals agree he’s sliding.', cls: 'heat-cooling' },
    { term: 'Diverging', def: 'The two signals disagree - one points up, the other down. The interesting case.', cls: 'heat-diverging' },
    { term: 'THIN', def: 'The trade gap comes from fewer than ' + MARKET_THIN_TRADES + ' trades - as likely to be noise as a real signal. Left out of Heat, the counts and the tags unless you turn on Include thin samples.' },
  ]) : '';

  let body;
  if (!rows.length) {
    body = STATE.marketRadar
      ? '<div class="empty-state">' + (thinCount && !STATE.marketIncludeThin
        ? 'Nothing is moving on well-traded players here right now. ' + thinCount + ' thin-sample move' + (thinCount === 1 ? ' is' : 's are') + ' left out - turn on Include thin samples to see ' + (thinCount === 1 ? 'it' : 'them') + '.'
        : 'No market movement to show in this format yet.') + '</div>'
      : '<div class="empty-state">Reading the market…</div>';
  } else {
    body = '<div class="mkt-rows">' + rows.map(marketRowHtml).join('') + '</div>';
  }

  container.innerHTML = header + controls + summary + key + body;
}
window.renderMarketRadarView = renderMarketRadarView;

function setMarketRadarFormat(tab) {
  STATE.marketRadarFormat = tab;
  STATE.marketRadar = null; // refetch trades for the new format
  renderMarketRadarView();  // triggers loadMarketRadar (marketRadar is null)
}
window.setMarketRadarFormat = setMarketRadarFormat;

function setMarketWindow(period) {
  STATE.risersFallersPeriod = period === '30d' ? '30d' : '7d';
  renderMarketRadarView();
}
window.setMarketWindow = setMarketWindow;

function setMarketPosition(pos) {
  STATE.risersFallersFilter = pos;
  renderMarketRadarView();
}
window.setMarketPosition = setMarketPosition;

function setMarketSort(sort) {
  STATE.marketSort = sort;
  renderMarketRadarView();
}
window.setMarketSort = setMarketSort;

function setMarketIncludeThin(v) {
  STATE.marketIncludeThin = v === 'on';
  renderMarketRadarView();
}
window.setMarketIncludeThin = setMarketIncludeThin;

;
/*! ==== 67-risers-fallers.js ==== */
// Momentum data source for the unified Market tool (module 56).
// Reads momentum_7d / momentum_30d from the backend composite (already loaded
// for all user formats) and exposes marketMomentumList()/rfDominantTab().
// The old Risers & Fallers portfolio panel this began as was removed when the
// data moved into the Market tool; only the data helpers remain.

// Pick the format most representative of the user's leagues, preferring one
// that actually has composite data loaded.
//
// This used to derive a 'sf' / '1qb' string and look that up directly in
// STATE.backendComposite -- but that map is keyed by the league's scoringTab
// verbatim ('SF', '1QB', '1QB TE+', ...), so a lowercase key never matched
// anything and the choice always fell through to "whichever format happened to
// load first". Harmless-looking and completely untestable while the panel
// itself rendered for nobody (momentum was null for every player until the v2
// aggregator started emitting it), so it survived unnoticed.
// Minimum value for a player to count as "on this board" at all. Applied to
// both ends of the momentum window -- see the filter in the render function.
const RF_RELEVANCE_VALUE = 1500;

function _rfLoaded(tab) {
  const p = STATE.backendComposite?.[tab]?.players;
  return !!p && Object.keys(p).length > 0;
}

function _rfDominantTab() {
  const counts = {};
  for (const lg of STATE.leagues || []) {
    if (lg.scoringTab) counts[lg.scoringTab] = (counts[lg.scoringTab] || 0) + 1;
  }
  const ranked = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; });
  for (const tab of ranked) {
    if (_rfLoaded(tab)) return tab;
  }
  return Object.keys(STATE.backendComposite || {}).find(_rfLoaded) || null;
}

// Shared momentum universe — the risers/fallers list with its relevance guards,
// factored out so the unified Market tool (module 56) reads the SAME data the
// old Risers & Fallers panel did. Returns [{playerId, name, position, team,
// value, momentum}] unsorted, or [] when the tab has no composite loaded.
function marketMomentumList(tab, period, filter) {
  const playersMap = STATE.backendComposite?.[tab]?.players;
  if (!playersMap) return [];
  const momKey = period === '30d' ? 'momentum_30d' : 'momentum_7d';
  const activeFilter = filter || 'ALL';
  const POSITIONS = ['QB', 'RB', 'WR', 'TE'];
  // The bar is the shared relevance floor (shared/movers.mjs): the value of the
  // 200th-best offensive player, today ~2,300. It was a fixed 1,500 (~#320),
  // which let backups through (Owen, 2026-09-27). Never below the old bar.
  const floor = (window.TacoCore && TacoCore.relevanceFloor)
    ? Math.max(RF_RELEVANCE_VALUE, TacoCore.relevanceFloor(Object.values(playersMap), function (x) { return x.consensus_value || 0; }, function (x) { return x.position; }))
    : RF_RELEVANCE_VALUE;

  return Object.entries(playersMap)
    .filter(function (entry) { return POSITIONS.includes(entry[1].position); })
    .filter(function (entry) {
      const p = entry[1];
      return p[momKey] != null && Math.abs(p[momKey]) > 0.1;
    })
    .filter(function (entry) { return (entry[1].consensus_value || 0) >= floor; })
    // The relevance bar has to apply at BOTH ends of the window, not just
    // today. A player who was below it a week ago was not on this board, so
    // his arrival on it is not a market move -- and because the percentage is
    // computed off that small baseline, he lands at the very top of the
    // risers list and pushes real movers out of it.
    //
    // Live case (2026-09-01): the top two risers were Carter Bradley at
    // +1481.3% and Garrett Greene at +940.5%. Neither had moved. Both sat at
    // the engine's floor (112 and 185) until crawled ADP data first gave them
    // a real price on 08-31. Same for Miller Moss (325), Nathan Carter (313)
    // and Gage Larvadain (284) -- five players, zero observed trades between
    // them, all of them artifacts of data arriving rather than a market.
    //
    // The past value is derivable, so this needs no payload change:
    // past = current / (1 + pct/100). Verified against rank_history -- it
    // reproduces all five stored values exactly.
    .filter(function (entry) {
      const p = entry[1];
      const pct = p[momKey];
      const past = (p.consensus_value || 0) / (1 + pct / 100);
      return past >= floor;
    })
    .filter(function (entry) {
      return activeFilter === 'ALL' || entry[1].position === activeFilter;
    })
    .map(function (entry) {
      const id = entry[0];
      const p = entry[1];
      const dbPlayer = STATE.playersDB && STATE.playersDB[id];
      let displayName;
      if (dbPlayer) {
        const full = (dbPlayer.full_name ||
          ((dbPlayer.first_name || '') + ' ' + (dbPlayer.last_name || '')).trim());
        const parts = full.trim().split(' ');
        displayName = parts.length > 1
          ? parts[0][0] + '. ' + parts.slice(1).join(' ')
          : full;
      } else {
        displayName = '#' + id.slice(-4);
      }
      return {
        playerId: id,
        name: displayName,
        position: p.position,
        team: p.team || '',
        value: Math.round(p.consensus_value || 0),
        momentum: p[momKey],
      };
    });
}
window.marketMomentumList = marketMomentumList;
window.rfDominantTab = _rfDominantTab;

;
/*! ==== 57-league-mate-activity.js ==== */
// Per-league leaguemate trade activity strip on team overview. Extracted from 13-cross-league-injury-strip.

function computeMateActivityItems(limit, leagueId) {
  const trades = STATE.tradeHistory || [];
  const cutoff = Date.now() - 14 * 864e5;
  const items = [];
  for (const t of trades) {
    if (leagueId && String(t.leagueId) !== String(leagueId)) continue;
    if (!t.statusUpdated || t.statusUpdated < cutoff) continue;
    const parties = t.sides.map((s) => {
      const assets = [
        ...s.players.slice(0, 2).map((p) => p.name),
        ...s.picks.slice(0, 1).map((p) => p.label),
      ].filter(Boolean);
      return {
        name: s.teamName || s.ownerName || 'Team',
        isMe: s.isMe,
        assets: assets.join(', '),
        total: s.totalValue,
      };
    });
    const summary = parties.map((p) => p.name + (p.assets ? ': ' + p.assets : '')).join(' ↔ ');
    items.push({
      tradeId: t.tradeId,
      leagueId: t.leagueId,
      leagueName: t.leagueName,
      includesMe: t.includesMe,
      ts: t.statusUpdated,
      summary,
      week: t.week,
      // The trade itself, so a row can open into its priced sides without
      // going anywhere. Same object Trade History renders.
      trade: t,
    });
  }
  return items.slice(0, limit || 8);
}

async function loadMateActivity() {
  if (!STATE.leagues || !STATE.leagues.length) return;
  try {
    await fetchTradeHistory();
    STATE.mateActivity = computeMateActivityItems(8);
    const lg = STATE.leagues[STATE.currentTeamIdx];
    if (lg && document.getElementById('teamView')?.classList.contains('active')) {
      renderLeagueMateActivity(lg);
    }
  } catch (e) {
    console.warn('[mates] activity load failed', e.message);
  }
}
window.loadMateActivity = loadMateActivity;

function renderLeagueMateActivity(lg) {
  const el = document.getElementById('leagueMateActivity-' + lg.league_id);
  if (!el) return;
  const items = computeMateActivityItems(8, lg.league_id);
  if (!items.length) {
    el.style.display = 'none';
    el.innerHTML = '';
    return;
  }
  const rows = items.map((item) => {
    const ago = formatRelativeTime(item.ts);
    const mineCls = item.includesMe ? ' mine' : '';
    const mineTag = item.includesMe ? ' · includes you' : '';
    return (
      // Opens in place, and goes nowhere (Owen, 2026-10-18: "you should still
      // be able to click open the trade to see what the values would be but no
      // need to swap to the whole other page"). It used to be a button that
      // jumped to Trade History, which is how League Overview kept turning
      // into a trade screen. The body is 71's own row renderer, so the prices
      // and the verdict here are the same ones Trade History shows -- one
      // renderer, not a second opinion.
      '<details class="mate-activity-row' + mineCls + '">' +
      '<summary class="mate-activity-sum">' +
      '<div class="mate-activity-text">' +
      '<div class="mate-activity-summary">' + escapeHtml(item.summary) + '</div>' +
      '<div class="mate-activity-meta">Week ' + (item.week || '?') + mineTag + (ago ? ' · ' + escapeHtml(ago) : '') + '</div>' +
      '</div>' +
      '<span class="mate-activity-chev" aria-hidden="true">▾</span>' +
      '</summary>' +
      '<div class="mate-activity-body">' +
      (item.trade && typeof renderTradeHistoryRow === 'function'
        ? renderTradeHistoryRow(item.trade, { withHead: false })
        : '<div class="tab-empty">This trade could not be priced.</div>') +
      '</div>' +
      '</details>'
    );
  }).join('');
  el.style.display = '';
  el.innerHTML =
    '<div class="section-card-head">' +
    '<h3 class="section-card-title">Leaguemate <em>activity</em></h3>' +
    '<div class="section-card-sub">Completed trades in this league · last 14 days</div>' +
    '</div>' +
    '<div class="mate-activity-rows">' + rows + '</div>';
}
window.renderLeagueMateActivity = renderLeagueMateActivity;
;
/*! ==== 13-cross-league-injury-strip.js ==== */
// Surfaces every injured player on YOUR rosters across ALL leagues, in one
// place. Portfolio managers shouldn't have to dive into each league's
// roster individually to find the lineup problems for the week. Renders
// above the league grid on the All Leagues view; hidden entirely when
// nobody's hurt.
//
// Sleeper exposes injury_status per player (e.g. "Questionable", "Doubtful",
// "Out", "IR"). Portfolio view aggregates across leagues; each league overview
// shows the same starter-only list for that roster. Click a row → player drawer.

// Ranks off shared/action-queue.mjs so this page and "Fix these now" bucket the
// same starter the same way. The hand-rolled version this replaces tested
// `includes('out')` BEFORE 'ir'/'sus', so "Out" and "IR" were different ranks
// for what is the same decision, and it ordered IR below Doubtful.
const IR_RANK = { out: 0, doubt: 1, quest: 2, other: 3 };
function injurySeverityRank(status) {
  const key = window.TacoCore && TacoCore.injurySeverityKey
    ? TacoCore.injurySeverityKey(status)
    : null;
  return key == null ? 4 : (IR_RANK[key] ?? 4);
}

// Starters only — bench/taxi/IR-stash injuries are noise for lineup decisions.
function collectInjuredStarters(league) {
  const leagues = league ? [league] : (STATE.leagues || []);
  const byPlayer = new Map();
  for (const lg of leagues) {
    for (const p of lg.myPlayers) {
      if (!p.isStarter) continue;
      const dbPlayer = STATE.playersDB?.[p.playerId];
      // Same resolution the Action Queue uses: the roster row can carry a
      // status the shared players database has not caught up to. Reading only
      // the database here is why the two pages could disagree about a starter.
      const status = (window.TacoCore && TacoCore.injuryStatusOf)
        ? TacoCore.injuryStatusOf(p, dbPlayer)
        : (dbPlayer?.injury_status || null);
      if (!status) continue;
      if (!byPlayer.has(p.playerId)) {
        byPlayer.set(p.playerId, {
          playerId: p.playerId,
          name: p.name,
          position: p.position,
          team: p.team,
          status,
          bodyPart: dbPlayer?.injury_body_part || null,
          leagues: [],
        });
      }
      if (!league) byPlayer.get(p.playerId).leagues.push(lg.name);
    }
  }
  return Array.from(byPlayer.values()).sort((a, b) => {
    const sa = injurySeverityRank(a.status);
    const sb = injurySeverityRank(b.status);
    if (sa !== sb) return sa - sb;
    if (!league && b.leagues.length !== a.leagues.length) return b.leagues.length - a.leagues.length;
    return a.name.localeCompare(b.name);
  });
}

;
/*! ==== 47-team-detail-news-per-league-news-tab-and-overview.js ==== */
// Per-league news tab + overview news strip. Extracted from 14-render-team-detail.

function buildTeamNewsTab(lg) {
  if (!STATE.newsByPlayerId) {
    return `
      <div class="empty-state">
        <span class="empty-state-icon">📰</span>
        <div class="empty-state-title">No news loaded yet</div>
        <div class="empty-state-sub">News feeds load in the background. Check back in a few seconds.</div>
      </div>
    `;
  }
  const myPlayerIds = new Set((lg.myPlayers || []).map(p => p.playerId));
  const matchedItems = [];
  const seenLinks = new Set();
  for (const pid of myPlayerIds) {
    const items = STATE.newsByPlayerId[pid] || [];
    const player = (lg.myPlayers || []).find(p => p.playerId === pid);
    for (const item of items) {
      const dedup = `${item.link || item.title}_${pid}`;
      if (seenLinks.has(dedup)) continue;
      seenLinks.add(dedup);
      matchedItems.push({ item, player });
    }
  }
  const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
  const cutoff = Date.now() - SEVEN_DAYS_MS;
  const recent = matchedItems.filter(({ item }) => {
    const ts = item.timestamp || item.pubDate;
    if (!ts) return true;
    return ts >= cutoff;
  });
  recent.sort((a, b) => ((b.item.timestamp || b.item.pubDate || 0) - (a.item.timestamp || a.item.pubDate || 0)));
  if (recent.length === 0) {
    return `
      <div class="empty-state">
        <span class="empty-state-icon">📰</span>
        <div class="empty-state-title">No news in the last week</div>
        <div class="empty-state-sub">Pulling from ESPN, RotoBaller, PFT, CBS, Yahoo, and RotoWire. When something hits about a player on this roster, it'll show up here.</div>
      </div>
    `;
  }
  return `
    <div class="section-card">
      <div class="section-card-head">
        <h3 class="section-card-title">Roster <em>news</em></h3>
        <div class="section-card-sub">${recent.length} item${recent.length === 1 ? '' : 's'} · last 7 days</div>
      </div>
      <div class="news-tab-list">
        ${recent.slice(0, 50).map(({ item, player }) => {
          const ts = item.timestamp || item.pubDate;
          const ago = ts ? formatRelativeTime(ts) : '';
          const posCls = (player?.position || '').toLowerCase();
          return `
            <a class="news-tab-row" href="${escapeHtml(item.link || '#')}" target="_blank" rel="noopener">
              <div class="news-tab-pill ${posCls}" data-taco-player="${escapeHtml(player.playerId)}" data-tooltip="Open ${escapeHtml(player.name)}">
                <span class="news-tab-pill-pos">${player?.position || '?'}</span>
                <span class="news-tab-pill-name">${escapeHtml(player?.name || 'Unknown')}</span>
              </div>
              <div class="news-tab-body">
                <div class="news-tab-title">${escapeHtml(item.title || '(untitled)')}</div>
                <div class="news-tab-meta">${escapeHtml(item.source || '')}${ago ? ' · ' + ago : ''}</div>
              </div>
            </a>
          `;
        }).join('')}
      </div>
    </div>
  `;
}

async function loadOverviewNewsStrip(lg) {
  const container = document.getElementById('newsStripOverview-' + lg.league_id);
  if (!container) return;
  await fetchNewsFeeds();

  const allItems = STATE.newsItems || [];
  const myPlayerIds = new Set(lg.myPlayers.map(p => p.sleeperId).filter(Boolean));
  const rosterItems = [];
  const seen = new Set();
  for (const item of allItems) {
    if (seen.has(item.id)) continue;
    let mentionedPid = null;
    for (const pid of item.matchedPlayerIds) {
      if (myPlayerIds.has(pid)) { mentionedPid = pid; break; }
    }
    if (!mentionedPid) continue;
    seen.add(item.id);
    rosterItems.push({ ...item, primaryPid: mentionedPid });
  }

  if (allItems.length === 0) {
    container.innerHTML = `
      <div class="news-strip news-strip-error">
        <div class="news-strip-head">
          <span class="news-strip-label">News</span>
          <button class="ghost small" data-news-refresh>Retry</button>
        </div>
        <div class="news-strip-empty-msg">
          Couldn't reach news feeds right now. Open the console for proxy details, or click Retry.
        </div>
      </div>
    `;
    return;
  }

  if (rosterItems.length === 0) {
    container.innerHTML = `
      <div class="news-strip news-strip-quiet">
        <div class="news-strip-head">
          <span class="news-strip-label">News on your roster</span>
          <span class="news-strip-count">${allItems.length} feed items scanned</span>
        </div>
        <div class="news-strip-empty-msg">
          No recent news mentions any of your players. Quiet day for your roster.
        </div>
      </div>
    `;
    return;
  }

  const top = rosterItems.slice(0, 5);
  container.innerHTML = `
    <div class="news-strip">
      <div class="news-strip-head">
        <span class="news-strip-label">News on your roster</span>
        <span class="news-strip-count">${rosterItems.length} item${rosterItems.length === 1 ? '' : 's'}</span>
      </div>
      <div class="news-strip-items">
        ${top.map(item => {
          const player = STATE.playersDB?.[item.primaryPid];
          const playerName = player
            ? (player.full_name || `${player.first_name || ''} ${player.last_name || ''}`).trim()
            : '';
          return `
            <div class="news-strip-item news-strip-item-clickable news-strip-item-roster"
                 data-taco-player="${escapeHtml(item.primaryPid)}">
              <div class="news-strip-meta">
                <span class="news-strip-source">${escapeHtml(item.source)}</span>
                <span class="news-strip-time">${formatNewsTime(item.pubDate)}</span>
                ${playerName ? `<span class="news-strip-player">${escapeHtml(playerName)}</span>` : ''}
              </div>
              <div class="news-strip-title">${escapeHtml(item.title)}</div>
            </div>
          `;
        }).join('')}
      </div>
    </div>
  `;
}

async function refreshNews() {
  STATE.newsLastFetch = 0;
  await fetchNewsFeeds(true);
  if (STATE.currentTeamIdx != null) renderTeamDetail();
}

window.buildTeamNewsTab = buildTeamNewsTab;
window.loadOverviewNewsStrip = loadOverviewNewsStrip;
window.refreshNews = refreshNews;
;
/*! ==== 53-team-detail-picks-draft-capital.js ==== */
// Draft capital summary, pick simulator, and Picks & Draft tab HTML. Extracted from 14-render-team-detail.

function buildPickRowHtml(p) {
  const pickSlotSources = new Set(['slot', 'ktc-slot', 'fc-slot', 'fc-slot-adj', 'ktc-pr']);
  const isSlot = pickSlotSources.has(p.valueSource);
  const sourceTag = isSlot
    ? ` <span class="pick-source-tag" data-tooltip="${escapeHtml(GLOSSARY['Slot'])}">slot</span>`
    : '';
  const assetKey = `D:${p.season}-${p.round}-${p.originalRosterId || ''}`;
  return `
      <div class="player-row player-row-pick" data-tc-asset="${assetKey}" style="cursor:pointer" data-tooltip="Click to use in trade calculator (projected value)">
        <div class="avatar avatar-pick"><span class="avatar-initials">${p.round}·${p.slot ? String(p.slot).padStart(2, '0') : '??'}</span></div>
        <div class="player-id-block">
          <span class="player-name"><span class="player-name-text">${p.label}</span>${sourceTag}</span>
          <span class="player-meta">${p.ownerNote}</span>
        </div>
        <div class="player-value ${p.value ? '' : 'none'}">${p.value ? Math.round(p.value).toLocaleString() : '-'}</div>
      </div>
    `;
}

function buildPicksSimulatorHtml(lg) {
  const myPicks = lg.myPicks || [];
  const currentSeasonPicks = myPicks.filter(p => p.season === +STATE.season);
  if (!currentSeasonPicks.length) return '';

  const leagueSim = STATE.pickSim[lg.league_id] || {};
  const pickKey = (p) => `${p.season}-${p.round}-${p.slot || 'x'}`;
  const rookiePool = getRookieBoard(lg).slice(0, 50);
  const simulatedPicks = currentSeasonPicks.map(p => {
    const selectedRookieId = leagueSim[pickKey(p)];
    const selectedRookie = selectedRookieId
      ? rookiePool.find(r => r.sleeperId === selectedRookieId || r.playerId === selectedRookieId)
      : null;
    return { pick: p, selectedRookie };
  });
  const simulatedRookies = simulatedPicks.filter(s => s.selectedRookie).map(s => s.selectedRookie);
  const simulationActive = simulatedRookies.length > 0;

  let simImpactHtml = '';
  if (simulationActive) {
    const rookiesValueAdded = simulatedRookies.reduce((s, r) => s + (r.value || 0), 0);
    const picksValueRemoved = simulatedPicks
      .filter(s => s.selectedRookie)
      .reduce((s, p) => s + (p.pick.value || 0), 0);
    const netDelta = rookiesValueAdded - picksValueRemoved;
    const deltaClass = netDelta > 0 ? 'sim-delta-pos' : netDelta < 0 ? 'sim-delta-neg' : 'sim-delta-zero';
    const deltaSign = netDelta > 0 ? '+' : '';
    const myRosterObj = lg.allRosters.find(r => r.isMe) || lg.allRosters[0];
    const projectedPlayers = [...myRosterObj.players, ...simulatedRookies.map(r => ({
      playerId: r.sleeperId || r.playerId,
      name: r.name,
      position: r.position,
      value: r.value,
      age: r.age,
      rookie: true,
      isStarter: false,
      isActive: true,
    }))];
    const projectedRoster = {
      ...myRosterObj,
      players: projectedPlayers,
      totalValue: projectedPlayers.reduce((s, p) => s + (p.value || 0), 0),
    };
    const projectedArchetype = archetypeForRoster(lg, projectedRoster);
    const currentArchetype = archetypeForRoster(lg, myRosterObj);
    const archetypeChanged = projectedArchetype !== currentArchetype;

    simImpactHtml = `
      <div class="sim-impact">
        <div class="sim-impact-row">
          <div class="sim-stat">
            <div class="sim-stat-label">Rookies added</div>
            <div class="sim-stat-value">+${Math.round(rookiesValueAdded).toLocaleString()}</div>
          </div>
          <div class="sim-stat">
            <div class="sim-stat-label">Picks spent</div>
            <div class="sim-stat-value">−${Math.round(picksValueRemoved).toLocaleString()}</div>
          </div>
          <div class="sim-stat sim-stat-hero">
            <div class="sim-stat-label">Net value change</div>
            <div class="sim-stat-value ${deltaClass}">${deltaSign}${Math.round(netDelta).toLocaleString()}</div>
          </div>
          <div class="sim-stat">
            <div class="sim-stat-label">Projected archetype</div>
            <div class="sim-stat-value ${archetypeChanged ? 'sim-arch-change' : ''}">
              ${projectedArchetype}
              ${archetypeChanged ? `<span class="sim-arch-from">(was ${currentArchetype})</span>` : ''}
            </div>
          </div>
        </div>
        <div class="sim-reset-wrap">
          <button class="sim-reset-btn" data-pick-sim-clear="${escapeHtml(lg.league_id)}">Clear simulation</button>
        </div>
      </div>
    `;
  }

  return `
    <div class="pick-sim-panel">
      <div class="pick-sim-head">
        <div>
          <div class="pick-sim-title">Draft Simulator</div>
          <div class="pick-sim-sub">Pick a rookie for each of your ${STATE.season} picks to see roster impact</div>
        </div>
      </div>
      ${simImpactHtml}
      <div class="pick-sim-rows">
        ${simulatedPicks.sort((a, b) => (a.pick.round - b.pick.round) || ((a.pick.slot || 99) - (b.pick.slot || 99))).map(({ pick, selectedRookie }) => {
          const assignedElsewhere = new Set(
            Object.entries(leagueSim)
              .filter(([k]) => k !== pickKey(pick))
              .map(([, pid]) => pid),
          );
          const availableRookies = rookiePool.filter(r => {
            const rid = r.sleeperId || r.playerId;
            return !assignedElsewhere.has(rid);
          });
          const overallPos = pickOverallPosition(pick, lg.total_rosters);
          const suggestedHint = overallPos
            ? `Realistic pool around pick ${overallPos}`
            : `${pick.bucket || 'Mid'} ${ordinal(pick.round)}`;
          const selectedId = selectedRookie ? (selectedRookie.sleeperId || selectedRookie.playerId) : '';
          return `
            <div class="pick-sim-row">
              <div class="pick-sim-pick">
                <div class="pick-sim-pick-label">${pick.label}</div>
                <div class="pick-sim-pick-meta">${Math.round(pick.value || 0).toLocaleString()} · ${suggestedHint}</div>
              </div>
              <div class="pick-sim-select-wrap">
                <select class="pick-sim-select" aria-label="Simulate this pick" data-pick-sim="${escapeHtml(lg.league_id)}|${escapeHtml(pickKey(pick))}">
                  <option value="">- select a rookie -</option>
                  ${availableRookies.map(r => {
                    const rid = r.sleeperId || r.playerId;
                    return `<option value="${rid}" ${selectedId === rid ? 'selected' : ''}>${escapeHtml(r.name)} · ${r.position} · ${Math.round(r.value).toLocaleString()}</option>`;
                  }).join('')}
                </select>
                ${selectedRookie ? `
                  <div class="pick-sim-selected-card">
                    <span class="pick-sim-selected-name">${escapeHtml(selectedRookie.name)}</span>
                    <span class="pick-sim-selected-meta">${selectedRookie.position} · ${Math.round(selectedRookie.value).toLocaleString()}</span>
                  </div>
                ` : ''}
              </div>
            </div>
          `;
        }).join('')}
      </div>
    </div>
  `;
}

// picks defaults to yours; Rosters passes any team's (Owen, 2026-10-03).
function buildDraftCapitalListHtml(lg, picks) {
  const isMine = !picks;
  const myPicks = (isMine ? lg.myPicks : picks) || [];
  if (!myPicks.length) {
    return isMine
      ? '<div class="tab-empty">You have no draft picks in this league. Sleeper pulls picks from traded_picks and drafts - if you expected picks, they may not be assigned yet by the commissioner.</div>'
      : '<div class="tab-empty">This team has no draft picks in this league.</div>';
  }
  const totalPickValue = myPicks.reduce((s, p) => s + (p.value || 0), 0);
  const picksByYear = myPicks.reduce((acc, p) => {
    if (!acc[p.season]) acc[p.season] = { count: 0, value: 0 };
    acc[p.season].count++;
    acc[p.season].value += (p.value || 0);
    return acc;
  }, {});
  return `
      <div class="picks-panel">
        <div class="picks-panel-head">
          <div>
            <div class="picks-panel-title">Draft Capital · ${myPicks.length} picks · ${Math.round(totalPickValue).toLocaleString()} total</div>
          </div>
        </div>
        ${Object.entries(picksByYear).sort(([a], [b]) => +a - +b).map(([year, info]) => `
          <div class="picks-year-section">
            <div class="picks-year-head">
              <span class="picks-year-name">${year} Rookie Draft</span>
              <span class="picks-year-meta">${info.count} pick${info.count !== 1 ? 's' : ''} · ${Math.round(info.value).toLocaleString()}</span>
            </div>
            ${myPicks
              .filter(p => p.season === +year)
              .sort((a, b) => (a.round - b.round) || ((a.slot || 99) - (b.slot || 99)))
              .map(p => {
                let displayNote = p.ownerNote || '';
                if (p.originalRosterId && lg.allRosters) {
                  const origR = lg.allRosters.find(r => (r.roster_id || r.rosterId) == p.originalRosterId);
                  if (origR) {
                    const nice = origR.teamName || origR.ownerName || origR.settings?.name || `R${p.originalRosterId}`;
                    displayNote = displayNote.replace(/R\d+/, nice);
                  }
                }
                const p2 = { ...p, ownerNote: displayNote };
                return buildPickRowHtml(p2);
              }).join('')}
          </div>
        `).join('')}
      </div>
    `;
}

function buildPicksAndDraftTab(lg, needsAnalysis) {
  const rookieDraftSection = safePanelRender('Rookie Draft', () => renderRookieDraftPanel(lg, needsAnalysis)) || '';
  const draftRoomSection = safePanelRender('Draft Room', () => renderLeagueDraftRoomPanel(lg)) || '';
  const picksSimulatorHtml = buildPicksSimulatorHtml(lg);
  const draftCapitalListHtml = buildDraftCapitalListHtml(lg);
  const picksAndDraftSections = [];
  if (rookieDraftSection) picksAndDraftSections.push(rookieDraftSection);
  if (draftRoomSection) picksAndDraftSections.push(draftRoomSection);
  if (picksSimulatorHtml) picksAndDraftSections.push(picksSimulatorHtml);
  picksAndDraftSections.push(draftCapitalListHtml);
  return picksAndDraftSections.join('<div class="picks-rookies-divider"></div>');
}

window.buildPicksAndDraftTab = buildPicksAndDraftTab;
;
/*! ==== 54-team-detail-roster-tab.js ==== */
// Roster tab positional sections. Extracted from 14-render-team-detail.

// League Overview pills remember which ones are open, so a data refresh
// re-render does not snap them shut. <details> "toggle" does not bubble, hence
// the capture listener.
const LO_OPEN = new Set();
function loOpenAttr(key) { return LO_OPEN.has(key) ? ' open' : ''; }
window.loOpenAttr = loOpenAttr;
document.addEventListener('toggle', function (e) {
  const d = e.target;
  if (!d || !d.matches || !d.matches('details[data-lo-key]')) return;
  const key = d.getAttribute('data-lo-key');
  if (d.open) LO_OPEN.add(key); else LO_OPEN.delete(key);
}, true);

// The position pills for any roster: yours on League Overview, anyone's on
// Rosters (Owen, 2026-10-03). keyPrefix keeps each team's open pills apart.
function buildRosterPillsHtml(lg, players, keyPrefix) {
  const groupActive = (pos) => players
    .filter(p => p.position === pos && p.isActive)
    .sort((a, b) => (playerLeagueValue(b, lg) || 0) - (playerLeagueValue(a, lg) || 0));
  const groupBench = (type) => players
    .filter(p => p[type])
    .sort((a, b) => (playerLeagueValue(b, lg) || 0) - (playerLeagueValue(a, lg) || 0));

  const qbs = groupActive('QB');
  const rbs = groupActive('RB');
  const wrs = groupActive('WR');
  const tes = groupActive('TE');
  const ir = groupBench('isIR');
  const taxi = groupBench('isTaxi');

  const posSection = (letter, name, players, cls) => {
    const total = players.reduce((s, p) => s + (playerLeagueValue(p, lg) || 0), 0);
    const ages = players.filter(p => p.age && p.age > 0).map(p => p.age);
    const avgAge = ages.length ? (ages.reduce((a, b) => a + b, 0) / ages.length).toFixed(1) : '-';
    const top = players.length > 0 ? players[0] : null;
    const rows = players.map(p => renderPlayerRow(p, lg)).join('');
    // A large closed pill (Owen, 2026-09-30): the summary carries the room at a
    // glance -- count, the top three faces, value, age -- and opens to the
    // players. Open state survives re-renders (loOpenAttr, below).
    const key = keyPrefix + '-' + cls + '-' + name;
    const faces = players.slice(0, 3)
      .map(p => (typeof playerAvatarHtml === 'function' ? playerAvatarHtml(p.playerId, p.name, p.position) : ''))
      .join('');
    return `
      <details class="lo-pill pos-pill"${loOpenAttr(key)} data-lo-key="${escapeHtml(key)}">
        <summary class="lo-pill-sum">
          <span class="pos-letter ${cls}">${letter}</span>
          <span class="lo-pill-main">
            <span class="lo-pill-title">${name}</span>
            <span class="lo-pill-sub">${players.length} player${players.length === 1 ? '' : 's'}${top ? ' · top: ' + escapeHtml(top.name) : ''}</span>
          </span>
          <span class="lo-pill-faces">${faces}</span>
          <span class="lo-pill-stat"><b>${Math.round(total).toLocaleString()}</b><i>value</i></span>
          <span class="lo-pill-stat"><b>${avgAge}</b><i>avg age</i></span>
          <span class="lo-pill-chev" aria-hidden="true">▾</span>
        </summary>
        <div class="lo-pill-body">
          ${rows || '<div class="empty-state" style="padding:24px;"><div class="empty-state-title">No players at this position</div></div>'}
        </div>
      </details>
    `;
  };

  return `
    <div class="roster-grid lo-pill-grid">
      ${posSection('Q', 'Quarterbacks', qbs, 'qb')}
      ${posSection('R', 'Running Backs', rbs, 'rb')}
      ${posSection('W', 'Wide Receivers', wrs, 'wr')}
      ${posSection('T', 'Tight Ends', tes, 'te')}
      ${ir.length > 0 ? posSection('I', 'Injured Reserve', ir, 'pick') : ''}
      ${taxi.length > 0 ? posSection('X', 'Taxi Squad', taxi, 'pick') : ''}
    </div>
  `;
}

function buildRosterTab(lg) {
  const myRosterForLineup = lg.allRosters.find(r => r.isMe) || lg.allRosters[0];
  return `
    ${safePanelRender('Start/Sit', () => renderStartSitPanel(lg, myRosterForLineup))}
    ${safePanelRender('Proposed Lineup', () => renderProposedLineup(lg, myRosterForLineup))}
    ${buildRosterPillsHtml(lg, lg.myPlayers, 'pos-' + lg.league_id)}
  `;
}

window.buildRosterTab = buildRosterTab;
window.buildRosterPillsHtml = buildRosterPillsHtml;
;
/*! ==== 14-render-team-detail.js ==== */
// Which top-level tab each sub-tab pill belongs to. Every sub-tab MUST be
// listed here: an unlisted key resolves to itself, matches no real tab, and
// the view silently falls back to Overview -- which is exactly what "Projected
// Finish" did when it was added to the League group without an entry.
//
// This lived as two identical literals, one in renderTeamDetail and one in
// setTeamTab, which is how the omission slipped through: adding a sub-tab
// meant remembering both. One definition now.
const SUB_TAB_PARENT = {
  news: 'scout',
  rankings: 'scout',
  picks: 'roster',
  waivers: 'league',
  powerRankings: 'league',
  projectedFinish: 'league',
};

/**
 * Arriving from the Action Queue with ?focus=<playerId> (or ?focus=lineup):
 * scroll to that player's roster row and highlight it, instead of leaving the
 * manager at the top of a 9,000px page (Command Center brief, 2026-09-27).
 * The query is dropped afterwards so a later re-render does not scroll again.
 */
// The highlight outlives a re-render: projections and lineups land a moment
// after the page opens and rebuild the rows, which wiped the flash off the
// old node before the smooth scroll had even arrived.
let leagueFocusFlash = null; // { focus, until }

function leagueFocusTarget(root, focus) {
  return focus === 'lineup'
    ? root.querySelector('.lineup-panel')
    : root.querySelector('.player-row[data-taco-player="' + CSS.escape(focus) + '"]');
}

function applyLeagueFocus() {
  const root = document.getElementById('teamDetailContent');
  if (!root) return;
  const focus = STATE.leagueFocus;
  if (!focus) {
    // A re-render inside the flash window: put the highlight back, no scroll.
    if (leagueFocusFlash && Date.now() < leagueFocusFlash.until) {
      const again = leagueFocusTarget(root, leagueFocusFlash.focus);
      if (again) again.classList.add('taco-focus-flash');
    }
    return;
  }
  STATE.leagueFocus = null; // once: a later re-render must not scroll again
  const target = leagueFocusTarget(root, focus);
  if (!target) return;
  leagueFocusFlash = { focus, until: Date.now() + 3200 };
  requestAnimationFrame(() => {
    scrollIntoViewSafely(target, { behavior: 'smooth', block: 'center' });
    target.classList.add('taco-focus-flash');
    setTimeout(() => {
      leagueFocusFlash = null;
      root.querySelectorAll('.taco-focus-flash').forEach((el) => el.classList.remove('taco-focus-flash'));
    }, 3200);
  });
}
window.applyLeagueFocus = applyLeagueFocus;

// One line at the top of the league page that says why you might be here
// (Command Center brief, 2026-09-27): team style, value against lineup
// strength, standing, this week's lineup fixes, and the one position to act on.
// Everything is read from what the page already computes -- no new fetches
// beyond the two the Action Queue already makes.
let leagueDiagLoading = false;

function leagueDiagnosisHtml(lg, needs, me) {
  if (!me) return '';
  const ord = (n) => (typeof ordinal === 'function' ? ordinal(n) : String(n));
  const parts = [];

  const arch = needs.archetype && needs.archetype !== 'Unknown' ? needs.archetype : null;
  if (arch && !archetypesSettled()) parts.push(archetypePendingPill('snapshot-arch-pill'));
  else if (arch) {
    const cls = 'arch-' + arch.toLowerCase().replace(/\s+/g, '-');
    const tip = (typeof GLOSSARY !== 'undefined' && GLOSSARY[arch]) || '';
    parts.push('<span class="snapshot-arch-pill ' + cls + '"' + (tip ? ' data-tooltip="' + escapeHtml(tip) + '"' : '') + '>' + escapeHtml(arch) + '</span>');
  }

  if (needs.valueRank && needs.starterValueRank) {
    parts.push('<span class="lgd-item" data-tooltip="Roster value rank, then the rank of your best possible starting lineup by value">' +
      'Value ' + ord(needs.valueRank) + ' · Starters ' + ord(needs.starterValueRank) + '</span>');
  }

  const gp = (me.wins || 0) + (me.losses || 0) + (me.ties || 0);
  if (gp > 0) {
    const stand = lg.allRosters.filter((r) => {
      const rw = r.wins || 0; const mw = me.wins || 0;
      return rw > mw || (rw === mw && (r.pointsFor || 0) > (me.pointsFor || 0));
    }).length + 1;
    parts.push('<span class="lgd-item">' + (me.wins || 0) + '-' + (me.losses || 0) + (me.ties ? '-' + me.ties : '') +
      ' · ' + ord(stand) + ' of ' + lg.allRosters.length + '</span>');
  }

  // This week's lineup, by the same sweep as the Action Queue and /tools/lineups.
  const lineups = typeof lineupSweepLineups === 'function' ? lineupSweepLineups() : null;
  if (lineups && STATE.weeklyProjections && typeof lineupSweepForLeague === 'function') {
    // Problems are the Action Queue's (hurt, bye, empty -- fixable or not);
    // the points are the sweep's. A slot with no bench answer is still an issue.
    const sw = lineupSweepForLeague(lg, new Date(), lineups);
    const issues = TacoCore.buildActionQueue
      ? TacoCore.buildActionQueue({ leagues: [lg], playersDB: STATE.playersDB, schedule: STATE.weeklyScheduleMap, lineups }).groups.length
      : 0;
    const gain = sw && sw.moves.length ? ' · +' + sw.gain.toFixed(1) + ' pts' : '';
    const chip = (cls, txt) => '<button type="button" class="lgd-item lgd-lineup ' + cls + '" data-league-focus="lineup">' + txt + '</button>';
    if (issues) parts.push(chip('lgd-bad', issues + ' lineup issue' + (issues === 1 ? '' : 's') + gain));
    else if (gain) parts.push(chip('lgd-warn', 'Better lineup on the bench' + gain));
    else if (sw) parts.push('<span class="lgd-item lgd-good">Lineup set</span>');
  } else if (!leagueDiagLoading && (typeof ensureWeekLineups === 'function' || typeof loadWeeklyProjections === 'function')) {
    // Opened straight onto a league page: fetch what the queue would have.
    leagueDiagLoading = true;
    Promise.all([
      !STATE.weeklyProjections && typeof loadWeeklyProjections === 'function' ? loadWeeklyProjections() : null,
      !lineups && typeof ensureWeekLineups === 'function' ? ensureWeekLineups() : null,
    ]).catch(() => null).then(() => {
      const v = document.querySelector('.view.active');
      if (v && v.contains(document.getElementById('teamDetailContent')) && STATE.leagues[STATE.currentTeamIdx] === lg) renderTeamDetail();
    });
  }

  // The one position to act on: an urgent gap, else the weakest target
  // position, else the deepest one to trade from.
  const pos = needs.positions || [];
  const urgent = pos.find((r) => r.recClass === 'critical');
  const target = pos.filter((r) => r.recLabel === 'Target Position').sort((a, b) => b.myRank - a.myRank)[0];
  const surplus = pos.filter((r) => r.recLabel === 'Strength - Trade From').sort((a, b) => a.myRank - b.myRank)[0];
  const need = urgent
    ? { txt: (urgent.depthCount ? 'Only ' + urgent.depthCount + ' ' + urgent.pos + (lg.scoringTab.startsWith('SF') && urgent.pos === 'QB' ? ' in Superflex' : '') : 'No ' + urgent.pos) + ' - get one', cls: 'lgd-bad', r: urgent }
    : target
      ? { txt: target.pos + ' ' + ord(target.myRank) + ' of ' + target.totalTeams + ' - trade for', cls: 'lgd-warn', r: target }
      : surplus
        ? { txt: surplus.pos + ' deep - trade from', cls: 'lgd-good', r: surplus }
        : null;
  if (need) parts.push('<span class="lgd-item ' + need.cls + '" data-tooltip="' + escapeHtml(need.r.recText) + '">' + escapeHtml(need.txt) + '</span>');

  if (!parts.length) return '';
  return '<div class="league-diag" aria-label="This league at a glance">' + parts.join('') + '</div>';
}

function renderTeamDetail() {
  const lg = STATE.leagues[STATE.currentTeamIdx];
  const container = document.getElementById('teamDetailContent');
  if (!lg || lg.startupComplete === false) {
    if (container) {
      container.innerHTML = `
        <div class="empty-state">
          <div class="empty-state-title">Select a league</div>
          <div class="empty-state-sub">Choose which dynasty league you want to open.</div>
          <button type="button" class="cta-primary" style="margin-top:12px;" data-require-league>Select league →</button>
        </div>`;
    }
    return;
  }

  // League-adjusted (playerLeagueValue), not raw p.value -- must match
  // 55-portfolio-overview.js's playersValue calc and r.totalValue
  // (already league-adjusted, see 10-sleeper-api.js applyLeagueValuesToRosters)
  // for the exact same roster.
  //
  // That comment said "must match r.totalValue" while the line under it added
  // draft capital, which r.totalValue does not carry. So this header read
  // 114,027 for a roster All Teams ranked at 105,518 -- same team, same league,
  // two numbers both labelled team value, 8,509 apart.
  //
  // r.totalValue is players-only and about ten ranking surfaces sort by it, so
  // the header is what moves. Draft capital is not dropped: it gets its own
  // stat beside this one, which also explains the gap rather than hiding it.
  const rosterValue = TacoCore.rosterPlayersValue(lg.myPlayers);
  const draftCapital = TacoCore.picksValue(lg.myPicks);
  const ages = lg.myPlayers.filter(p => p.age).map(p => p.age);
  const avgAge = ages.length ? (ages.reduce((a, b) => a + b, 0) / ages.length).toFixed(1) : '-';

  const groupBench = (type) => lg.myPlayers
    .filter(p => p[type])
    .sort((a, b) => (playerLeagueValue(b, lg) || 0) - (playerLeagueValue(a, lg) || 0));
  const ir = groupBench('isIR');
  const taxi = groupBench('isTaxi');

  const needsAnalysis = computeTeamNeeds(lg);

  // Roster (and the legacy Picks tab) is merged into the League Overview now,
  // so /league/<id>/roster and /picks deep links resolve to the same page.
  let activeTab = SUB_TAB_PARENT[STATE.teamDetailTab] || STATE.teamDetailTab || 'overview';
  if (activeTab === 'roster') activeTab = 'overview';

  // Every tab below is BUILT ON DEMAND (2026-09-28). This used to build all of
  // them -- trade suggestions, waivers, power rankings, format rankings,
  // Projected Finish's Monte Carlo -- on every render and then show one. A
  // league page open cost ~350ms of simulation for a panel nobody was looking
  // at, while the page ignored taps ("things kept freezing as you loaded
  // pages", Owen). Only the active tab's function runs now.
  const rosterTab = () => buildRosterTab(lg);

  const accountLocked = window.TacoAuth && TacoAuth.requiresAccountTeamTab && !TacoAuth.hasFreeAccount();

  const waiversTab = () => (accountLocked
    ? TacoAuth.gateHtml('waivers')
    : (safePanelRender('Waivers', () => renderWaiverPanel(lg, needsAnalysis)) ||
    '<div class="tab-empty">No waiver targets meet the value threshold in this league. Either your league is very deep, or trade values haven\'t loaded yet.</div>'));

  const powerRankingsTab = () => safePanelRender('League Rankings', () => renderPowerRankingsPanel(lg));
  const rankingsSubtab = () => safePanelRender('Format Rankings', () => renderRankingsPanel(lg));

  const picksAndDraftTab = () => buildPicksAndDraftTab(lg, needsAnalysis);
  const newsTab = () => buildTeamNewsTab(lg);

  function subTabBar(tabs, activeKey) {
    return `<div class="sub-tab-bar">${tabs.map(([key, label]) =>
      `<button class="sub-tab${activeKey === key ? ' active' : ''}" data-team-tab="${key}">${label}</button>`
    ).join('')}</div>`;
  }

  // League Overview now IS the whole team on one page (Owen: "combine them into
  // one thing, the roster option should be gone"): the read (team stats +
  // positional needs), then the roster and lineup, then draft capital, then the
  // league scoring reference. picksAndDraftTab replaces the compact Draft
  // Capital card that used to ride the top row, so it isn't shown twice.
  // League Overview leads with the team header (identity, value stats, and the
  // advanced "Where you stand" read) as the single team summary. The old "Team
  // this season" card duplicated the header's record/standing/points and made
  // the two disagree, so it's gone. Positional Needs runs full width in its
  // native five-column layout -- squeezing it beside a card was what broke both
  // the design and the numbers (values collided with the rank column).
  const overviewTab = () => `
    ${safePanelRender('Positional Needs', () => renderNeedsPanel(needsAnalysis))}
    ${rosterTab()}
    ${(() => {
      // Draft capital as one large pill that opens (Owen, 2026-09-30).
      const picks = lg.myPicks || [];
      const key = 'picks-' + lg.league_id;
      return '<details class="lo-pill picks-pill"' + loOpenAttr(key) + ' data-lo-key="' + escapeHtml(key) + '">' +
        '<summary class="lo-pill-sum"><span class="pos-letter pick">$</span>' +
        '<span class="lo-pill-main"><span class="lo-pill-title">Draft capital</span>' +
        '<span class="lo-pill-sub">' + picks.length + ' pick' + (picks.length === 1 ? '' : 's') + ' you own</span></span>' +
        '<span class="lo-pill-faces"></span>' +
        '<span class="lo-pill-stat"><b>' + Math.round(draftCapital).toLocaleString() + '</b><i>value</i></span>' +
        '<span class="lo-pill-chev" aria-hidden="true">▾</span></summary>' +
        '<div class="lo-pill-body">' + picksAndDraftTab() + '</div></details>';
    })()}
    <div class="section-card mate-activity-panel league-mate-activity" id="leagueMateActivity-${lg.league_id}" style="display:none;" aria-label="Leaguemate activity in this league"></div>
  `;


  const leagueSubKey = STATE.teamDetailTab === 'waivers' ? 'waivers'
    : STATE.teamDetailTab === 'projectedFinish' ? 'projectedFinish'
    : 'powerRankings';
  const projectedFinishTab = () => safePanelRender('Projected Finish', () => renderSeasonProjectionPanel(lg));
  const leagueCombined = () => subTabBar(
    [['powerRankings','League Rankings'],['projectedFinish','Projected Finish'],['waivers','Waivers']],
    leagueSubKey,
  ) + (leagueSubKey === 'powerRankings' ? powerRankingsTab()
    : leagueSubKey === 'projectedFinish' ? projectedFinishTab()
    : waiversTab());

  const scoutSubKey = STATE.teamDetailTab === 'news' ? 'news' : 'rankings';
  const scoutCombined = () => subTabBar([['rankings','Player Rankings'],['news','News']], scoutSubKey)
    + (scoutSubKey === 'rankings' ? rankingsSubtab() : newsTab());

  // No trade or trade-history mode here (Owen, 2026-10-18: "not a remake of
  // our already existing trade tab"). Both already had their own top-level
  // views; keeping second copies inside League Overview meant one visit left
  // STATE.teamDetailTab sitting on a trade screen, and the page stopped being
  // an overview from then on. /league/<id>/trade and /league/<id>/trade-history
  // now route to the real tabs with this league selected -- see 43-router.js.
  const tabContent = ({
    overview: overviewTab,
    league: leagueCombined,
    scout: scoutCombined,
  }[activeTab] || overviewTab)();

  const myRosterObj = lg.allRosters.find(r => r.isMe);
  const teamAvatarHtmlStr = teamAvatarHtml(myRosterObj, myRosterObj?.teamName || lg.name);

  container.innerHTML = (STATE.scoutMode && typeof scoutTeamBarHtml === 'function' ? scoutTeamBarHtml(lg) : '') + `
    <div class="team-head">
      <div class="team-head-row">
        <div class="team-head-identity">
          ${teamAvatarHtmlStr.replace('avatar-team', 'avatar-team avatar-lg')}
          <div>
            <h2 class="team-title">${escapeHtml(myRosterObj?.teamName || lg.name)}</h2>
            <div class="team-subtitle">${escapeHtml(lg.name)} · ${lg.total_rosters} teams · ${lg.scoringTab}</div>
          </div>
        </div>
        <div class="team-actions">
          <select class="league-switcher" aria-label="Switch league" data-taco-sort="switchToLeague" data-tooltip="Switch to a different league">
            ${STATE.leagues.map((l, i) => `<option value="${i}" ${i === STATE.currentTeamIdx ? 'selected' : ''}>${escapeHtml(l.name)}</option>`).join('')}
          </select>
          <button class="ghost small" data-sleeper-league-open="${escapeHtml(lg.league_id)}" data-tooltip="Open in Sleeper">Sleeper ↗</button>
          ${STATE.scoutMode ? '' : '<button class="ghost small" data-taco-share="myReportCard" data-tooltip="Copy a public link to your team report card - rank, team style, position grades">Share card</button>'}
        </div>
      </div>
      ${leagueDiagnosisHtml(lg, needsAnalysis, myRosterObj)}
      ${(() => {
        // How this league scores, as a small pill that opens (Owen, 2026-09-30).
        const fp = lg.scoringFingerprint || (typeof buildLeagueScoringFingerprint === 'function' ? buildLeagueScoringFingerprint(lg) : null);
        const key = 'scoring-' + lg.league_id;
        return '<details class="lo-scoring"' + loOpenAttr(key) + ' data-lo-key="' + escapeHtml(key) + '">' +
          '<summary><span class="lo-scoring-k">How this league scores</span>' +
          (fp && fp.profileLine ? '<span class="lo-scoring-v">' + escapeHtml(fp.profileLine) + '</span>' : '') +
          '<span class="lo-pill-chev" aria-hidden="true">▾</span></summary>' +
          '<div class="lo-scoring-body">' + renderLeagueScoringPanelHtml(lg, { withHead: false }) + '</div></details>';
      })()}
      <div class="team-summary">
        <div class="summary-stat">
          <div class="summary-label">Roster Value</div>
          <div class="summary-value accent" data-tooltip="Every player you roster, priced in this league's format. Add Draft Capital beside this to get the Team Value shown on Portfolio.">${Math.round(rosterValue).toLocaleString()}</div>
        </div>
        <div class="summary-stat">
          <div class="summary-label">Draft Capital</div>
          <div class="summary-value" data-tooltip="${(lg.myPicks || []).length} pick${(lg.myPicks || []).length === 1 ? '' : 's'} you own. Next year's firsts follow each team's projected finish; picks further out use roster strength.">${Math.round(draftCapital).toLocaleString()}</div>
        </div>
        <div class="summary-stat">
          <div class="summary-label">Avg Age</div>
          <div class="summary-value">${avgAge}</div>
        </div>
        <div class="summary-stat">
          <div class="summary-label">Active</div>
          <div class="summary-value">${lg.myPlayers.filter(p => p.isActive).length}</div>
        </div>
        <div class="summary-stat">
          <div class="summary-label">IR / Taxi</div>
          <div class="summary-value">${ir.length} / ${taxi.length}</div>
        </div>
      </div>
      ${(() => {
        // Where you stand - record + points-for / points-against ranks, mirroring
        // the league card. Playoff odds live below in Projected Finish.
        if (!myRosterObj) return '';
        const gp = (myRosterObj.wins || 0) + (myRosterObj.losses || 0) + (myRosterObj.ties || 0);
        if (gp <= 0) return '';
        // ordinal(8) is "8th" (number + suffix). Every use below is
        // `${rank}${ord(rank)}`, so ord must return the SUFFIX only -- otherwise
        // rank 8 renders "88th", 12 -> "1212th", 1 -> "11st".
        const ord = (n) => (typeof ordinal === 'function' ? ordinal(n).slice(String(n).length) : '');
        const nT = lg.allRosters.length;
        const pfRank = lg.allRosters.filter((r) => (r.pointsFor || 0) > (myRosterObj.pointsFor || 0)).length + 1;
        const paRank = lg.allRosters.filter((r) => (r.pointsAgainst || 0) < (myRosterObj.pointsAgainst || 0)).length + 1;
        const maxPfRank = lg.allRosters.filter((r) => (r.maxPointsFor || 0) > (myRosterObj.maxPointsFor || 0)).length + 1;
        const maxPfVal = (myRosterObj.maxPointsFor || 0).toFixed(1);
        const rec = `${myRosterObj.wins || 0}-${myRosterObj.losses || 0}${myRosterObj.ties ? '-' + myRosterObj.ties : ''}`;
        // Standing rank (wins, then points-for as tiebreak) vs scoring rank - a
        // schedule/luck read: standing well below your scoring means a tough
        // schedule or rough luck, and vice versa. A true opponent-strength SOS
        // needs the full schedule; this is the sharper signal from data on hand.
        const standRank = lg.allRosters.filter((r) => {
          const rw = r.wins || 0; const mw = myRosterObj.wins || 0;
          return rw > mw || (rw === mw && (r.pointsFor || 0) > (myRosterObj.pointsFor || 0));
        }).length + 1;
        // True strength-of-schedule (opponents faced) - loaded lazily; shows once
        // the played-weeks matchups are fetched and ranked.
        const sosState = STATE.leagueSOS && STATE.leagueSOS[lg.league_id];
        if ((!sosState || !sosState.ready) && typeof loadLeagueSOS === 'function') {
          setTimeout(() => loadLeagueSOS(lg), 0);
        }
        const sosRank = sosState && sosState.ready && sosState.ranks ? sosState.ranks[myRosterObj.rosterId] : null;
        // Value-rank trend from the backend snapshot store - accrues week over
        // week; shows once at least two weeks are recorded.
        const trend = STATE.standingsTrend && STATE.standingsTrend[lg.league_id];
        if (trend === undefined && typeof loadStandingsTrend === 'function') setTimeout(() => loadStandingsTrend(lg), 0);
        let trendVal = null, trendTone = '';
        if (Array.isArray(trend)) {
          const withVR = trend.filter((w) => w.value_rank != null);
          if (withVR.length >= 2) {
            const d = withVR[withVR.length - 2].value_rank - withVR[withVR.length - 1].value_rank;
            trendVal = d === 0 ? 'Flat' : `${d > 0 ? '▲' : '▼'}${Math.abs(d)}`;
            trendTone = d === 0 ? '' : (d > 0 ? 'hot' : 'cold');
          }
        }
        // Schedule/luck read: standing well below your scoring means a tough
        // schedule or rough luck, and vice versa.
        let readTxt, readTone = '';
        if (standRank - pfRank >= 2) {
          readTxt = `Standing ${standRank}${ord(standRank)} on ${pfRank}${ord(pfRank)}-ranked scoring - tough schedule or unlucky`; readTone = 'cold';
        } else if (pfRank - standRank >= 2) {
          readTxt = `Standing ${standRank}${ord(standRank)} on ${pfRank}${ord(pfRank)}-ranked scoring - favorable schedule`; readTone = 'hot';
        } else {
          readTxt = `Standing ${standRank}${ord(standRank)} - in line with your scoring`;
        }
        const stat = (label, value, sub, tone, tip) =>
          `<div class="team-stand-stat${tone ? ' team-stand-' + tone : ''}"${tip ? ` data-tooltip="${tip}"` : ''}>` +
          `<div class="team-stand-lbl">${label}</div>` +
          `<div class="team-stand-val">${value}${sub ? `<span class="team-stand-of">${sub}</span>` : ''}</div>` +
          '</div>';
        return '<div class="team-stand">' +
          '<div class="team-stand-head">Where you stand</div>' +
          '<div class="team-stand-grid">' +
            stat('Record', rec) +
            stat('Standing', `${standRank}${ord(standRank)}`, `of ${nT}`, '', 'Standing by wins, then points-for') +
            stat('Points for', `${pfRank}${ord(pfRank)}`, `of ${nT}`, '', 'Points for - rank in league') +
            stat('Max PF', `${maxPfRank}${ord(maxPfRank)}`, `of ${nT}`, '', `Max PF - potential points with optimal lineups (${maxPfVal} pts), rank in league`) +
            stat('Points against', `${paRank}${ord(paRank)}`, `of ${nT}`, '', 'Points against - rank in league (1st = fewest allowed)') +
            (sosRank ? stat('Schedule faced', `${sosRank}${ord(sosRank)}`, `of ${nT}`, '', 'Strength of schedule faced - average scoring of opponents played (1st = toughest)') : '') +
            (trendVal ? stat('Value rank', trendVal, trendVal === 'Flat' ? '' : 'wk/wk', trendTone, 'Value-rank change since the previous recorded week') : '') +
          '</div>' +
          `<div class="team-stand-read${readTone ? ' team-stand-' + readTone : ''}">${readTxt}</div>` +
          '</div>';
      })()}
      ${needsAnalysis.flagsStrip ? `
        <div class="team-needs-strip">
          <span class="team-needs-label">Position read</span>
          <div class="needs-flags-row">${needsAnalysis.flagsStrip}</div>
        </div>
      ` : ''}
    </div>

    <!-- No league-view tab bar (Owen): the league view IS the whole team on one
         page -- overview read, roster, lineup and draft capital merged together.
         Trade/Scout/League moved to their own sections, so a tab bar is redundant. -->
    <div class="team-tab-content">
      ${tabContent}
    </div>
  `;

  if (activeTab === 'overview') {
    loadOverviewNewsStrip(lg);
    if (typeof renderLeagueMateActivity === 'function') {
      if (STATE.tradeHistory) renderLeagueMateActivity(lg);
      else if (typeof loadMateActivity === 'function') loadMateActivity();
    }
  }
  applyLeagueFocus();
}

async function setTeamTab(tabName) {
  const resolvedTab = SUB_TAB_PARENT[tabName] || tabName;
  if (window.TacoAuth && TacoAuth.requiresAccountTeamTab(tabName)) {
    await TacoAuth.ensureSession();
  }
  // Store the RAW key — renderTeamDetail derives the parent tab itself via
  // SUB_TAB_PARENT, and the sub-tab bars (Roster|Picks, Calculator|Suggestions,
  // Power Rankings|Waivers, Rankings|News) read the sub key from here.
  // Storing the resolved parent broke every second sub-tab pill.
  STATE.teamDetailTab = tabName;
  renderTeamDetail();
  const tabsEl = document.querySelector('.team-tabs');
  if (tabsEl) {
    const rect = tabsEl.getBoundingClientRect();
    if (rect.top < 0) scrollIntoViewSafely(tabsEl, { behavior: 'smooth', block: 'start' });
  }
  // 'trade' and 'tradeHistory' are no longer tabs of this view -- they have
  // their own, and the deep links route there (2026-10-18).
  if (tabName === 'trade' && typeof jumpToTrade === 'function') {
    jumpToTrade(STATE.currentTeamIdx);
    return;
  }
  if (resolvedTab === 'tradeHistory') {
    const lg = STATE.leagues[STATE.currentTeamIdx];
    if (lg && (STATE.tradeHistoryFilter === 'all' || !STATE.tradeHistoryFilter)) {
      STATE.tradeHistoryFilter = lg.league_id;
    }
    showView('tradeHistory');
    return;
  }
  if (resolvedTab === 'scout' && typeof fetchNewsFeeds === 'function') {
    fetchNewsFeeds().then(() => {
      const cur = STATE.teamDetailTab;
      if (cur === 'scout' || SUB_TAB_PARENT[cur] === 'scout') renderTeamDetail();
    }).catch(err => console.warn('[news] fetch failed', err));
  }
  if (typeof syncUrlToView === 'function') syncUrlToView('team');
  if (typeof syncToolsSidebar === 'function') syncToolsSidebar('team');
}
window.setTeamTab = setTeamTab;

window.renderTeamDetail = renderTeamDetail;

(function wireTeamTabDelegation() {
  if (wireTeamTabDelegation._wired) return;
  wireTeamTabDelegation._wired = true;
  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-team-tab]');
    if (tab?.dataset.teamTab) {
      // Only the view's own sub-tab pills. The `.mate-activity-row` exception
      // that used to live here existed so a completed-trade row could jump to
      // Trade History; those rows are plain rows now (2026-10-18).
      if (e.target.closest('#teamDetailContent')) {
        setTeamTab(tab.dataset.teamTab);
        return;
      }
    }
    const root = e.target.closest('#teamDetailContent');
    if (!root) return;
    // No prev/next league arrows (Owen, 2026-10-18: "no need to be able to
    // switch to the next league. we already have the drop down"). The
    // switcher beside them does the same job without asking you to count.

  });
})();
;
/*! ==== 52-player-drawer-sources-value-source-breakdown.js ==== */
﻿// Player drawer value sources panel (FC / DP / KTC / trade-implied).
// Extracted from 46-player-drawer.

// Build the Sources panel for the player drawer.
//
// This panel handles two shapes:
//   1. v1 (current): client-side blend of FC + DP, showing each source's value
//      and a divergence callout when they disagree.
//   2. v2 (post-backend): backend-supplied rich data — per-source RANKS (not
//      just values), trade_implied value from real Sleeper trades, agreement
//      score, momentum, value range, and tags like "market_cold" / "contested".
//
// The frontend gracefully degrades — anything the backend hasn't sent yet
// just doesn't render. So we ship the v2 UI scaffolding now, and the moment
// the backend turns on, the new fields populate without further frontend work.
function normalizeDrawerSources(sources) {
  if (!sources) return {};
  const out = { ...sources };
  if (out.dp_direct && !out.dp) out.dp = out.dp_direct;
  return out;
}

function computeSourceQuad(sources, _consensusValue) {
  const entries = [];
  const push = (key, label, val, cls) => {
    if (val != null && val > 0) entries.push({ key, label, value: val, cls: cls || '' });
  };
  // The first-party engine's own signals -- the only ones anything emits.
  // fc/dp/ktc pushes used to sit above these "in case the legacy blend is
  // served again"; nothing produces them now, so the spread is a spread of
  // our own estimates, which is what the "sources agree/disagree" line in
  // the drawer has actually been measuring since the composite-v2 cutover.
  push('stats', 'Prod', sources.stats?.value);
  push('adp', 'Draft', sources.adp?.value);
  const ti = sources.trade_implied;
  if (ti?.value > 0 && (ti.n_trades || 0) >= 2) {
    push('implied', 'Trades', ti.value, 'implied');
  }
  if (entries.length < 2) return null;
  const vals = entries.map((e) => e.value);
  const min = Math.min(...vals);
  const max = Math.max(...vals);
  const spreadPct = min > 0 ? Math.round(((max - min) / min) * 1000) / 10 : 0;
  const agreement = Math.max(0, Math.min(100, Math.round(100 - spreadPct * 1.15)));
  return { entries, min, max, spreadPct, agreement };
}

function renderSourceQuadHtml(quad) {
  if (!quad) return '';
  const max = quad.max || 1;
  const rows = quad.entries.map((e) => {
    const pct = Math.round((e.value / max) * 100);
    return (
      `<div class="src-quad-row">` +
      `<span class="src-quad-label">${escapeHtml(e.label)}</span>` +
      `<div class="src-quad-bar-wrap"><div class="src-quad-bar ${e.cls}" style="width:${pct}%"></div></div>` +
      `<span class="src-quad-val">${Math.round(e.value).toLocaleString()}</span>` +
      `</div>`
    );
  }).join('');
  return (
    `<div class="src-quad">` +
    `<div class="src-quad-head"><span>Source spread</span><span class="src-quad-spread">${quad.spreadPct}% · agree ${quad.agreement}</span></div>` +
    rows +
    `</div>`
  );
}

function buildSourcesPanel(ctx) {
  const sources = normalizeDrawerSources(ctx.bestSources);
  if (!sources || ctx.bestValue === 0) return '';

  // bestSources is the composite's own sources object (63 -> lookupPlayerValue),
  // which carries the first-party signals and nothing else. The FantasyCalc,
  // DynastyProcess and KeepTradeCut rows that used to read sources.fc/.dp/.ktc
  // here could not render after the 2026-07-11 composite-v2 cutover stopped
  // emitting them, and as of 2026-11-03 nothing produces them at all. The
  // market comparison users actually see is the drawer's Market panel
  // (module 78, Dynasty Daddy), which is live and unaffected.
  // The proprietary signal: trade-implied value from real public-league trades
  const tradeImplied = sources.trade_implied;
  const tradeVal = tradeImplied?.value;
  const tradeN = tradeImplied?.n_trades;
  const tradeLeagues = tradeImplied?.n_leagues;

  // Per-source rows. Backend will fill rank when available; gracefully omit when not.
  const rows = [];
  const renderSourceRow = (label, meta, value, rank, extra) => {
    if (value == null) return '';
    const rankBadge = rank != null
      ? `<span class="src-rank">#${rank}</span>`
      : '';
    return `
      <div class="src-row">
        <div class="src-label">
          ${escapeHtml(label)}
          <span class="src-meta">${escapeHtml(meta)}</span>
          ${extra || ''}
        </div>
        <div class="src-value-cell">
          ${rankBadge}
          <span class="src-value">${Math.round(value).toLocaleString()}</span>
        </div>
      </div>
    `;
  };

  // First-party rows first -- these explain the number the user is looking at.
  // renderSourceRow returns '' for a null value, so a player missing either
  // signal (a rookie with no production, say) simply shows fewer rows.
  rows.push(renderSourceRow('Production', 'trailing season', sources.stats?.value, null));
  rows.push(renderSourceRow('Draft market', 'ADP + rookie/startup picks', sources.adp?.value, null));
  // Trade-implied row gets special treatment — it's the proprietary signal,
  // distinct from the consensus sources above. Highlighted with an accent border.
  if (tradeVal != null && tradeN != null) {
    const leaguesNote = tradeLeagues != null ? ` · ${tradeLeagues} leagues` : '';
    rows.push(`
      <div class="src-row src-row-market">
        <div class="src-label">
          Real trades
          <span class="src-meta src-meta-market">market signal</span>
          <span class="src-ecr">${tradeN} trades${leaguesNote} · 90d</span>
        </div>
        <div class="src-value-cell">
          <span class="src-value">${Math.round(tradeVal).toLocaleString()}</span>
        </div>
      </div>
    `);
  }

  // ---- Tags from the backend (market_cold, contested, rising, etc.) ----
  const tags = ctx.tags?.length ? ctx.tags : (ctx.bestSources?.tags || []);
  const tagPalette = {
    market_hot:   { label: 'Market hot',   cls: 'tag-hot' },
    market_cold:  { label: 'Market cold',  cls: 'tag-cold' },
    contested:    { label: 'Contested',    cls: 'tag-contested' },
    rising:       { label: 'Rising',       cls: 'tag-rising' },
    falling:      { label: 'Falling',      cls: 'tag-falling' },
    stable:       { label: 'Stable',       cls: 'tag-stable' },
    low_data:     { label: 'Low data',     cls: 'tag-lowdata' },
  };
  const tagsHtml = Array.isArray(tags) && tags.length > 0
    ? `<div class="src-tags">${
        tags.slice(0, 3).map(t => {
          const def = tagPalette[t] || { label: t, cls: 'tag-default' };
          return `<span class="src-tag ${def.cls}">${escapeHtml(def.label)}</span>`;
        }).join('')
      }</div>`
    : '';

  const quad = computeSourceQuad(sources, ctx.bestValue);
  const quadHtml = renderSourceQuadHtml(quad);

  // ---- Agreement score badge (backend-supplied or quad-computed) ----
  const agreement = ctx.agreementScore ?? ctx.bestSources?.agreement_score ?? quad?.agreement ?? null;
  let agreementHtml = '';
  if (agreement != null) {
    let cls = 'agree-mid';
    if (agreement >= 85) cls = 'agree-high';
    else if (agreement < 70) cls = 'agree-low';
    agreementHtml = `
      <div class="src-meta-row">
        <span class="src-meta-label">Source agreement</span>
        <span class="src-agreement ${cls}">${Math.round(agreement)}/100</span>
      </div>
    `;
  }

  // ---- Range (low–high across sources) ----
  const rangeLow = ctx.rangeLow ?? ctx.bestSources?.range_low ?? quad?.min ?? null;
  const rangeHigh = ctx.rangeHigh ?? ctx.bestSources?.range_high ?? quad?.max ?? null;
  let rangeHtml = '';
  if (rangeLow != null && rangeHigh != null && rangeLow !== rangeHigh) {
    rangeHtml = `
      <div class="src-meta-row">
        <span class="src-meta-label">Source range</span>
        <span class="src-range">${Math.round(rangeLow).toLocaleString()} - ${Math.round(rangeHigh).toLocaleString()}</span>
      </div>
    `;
  }

  // ---- Momentum (7d / 30d) ----
  const momentum1d = ctx.momentum1d ?? ctx.bestSources?.momentum_1d;
  const momentum7d = ctx.momentum7d ?? ctx.bestSources?.momentum_7d;
  const momentum30d = ctx.momentum30d ?? ctx.bestSources?.momentum_30d;
  const fmtMomentum = (m) => {
    if (m == null) return null;
    const sign = m > 0 ? '+' : '';
    const cls = m > 0.5 ? 'mom-up' : m < -0.5 ? 'mom-down' : 'mom-flat';
    return `<span class="src-momentum ${cls}">${sign}${m.toFixed(1)}%</span>`;
  };
  let momentumHtml = '';
  if (momentum1d != null || momentum7d != null || momentum30d != null) {
    momentumHtml = `
      <div class="src-meta-row">
        <span class="src-meta-label">Momentum</span>
        <span>
          ${momentum1d != null ? `1d ${fmtMomentum(momentum1d)}` : ''}
          ${momentum1d != null && (momentum7d != null || momentum30d != null) ? ' &nbsp;·&nbsp; ' : ''}
          ${momentum7d != null ? `7d ${fmtMomentum(momentum7d)}` : ''}
          ${momentum7d != null && momentum30d != null ? ' &nbsp;·&nbsp; ' : ''}
          ${momentum30d != null ? `30d ${fmtMomentum(momentum30d)}` : ''}
        </span>
      </div>
    `;
  }

  // ---- Market divergence callout ----
  // The engine supplies market_divergence_pct directly. A fallback that
  // computed an FC-vs-DP gap used to live below; neither value exists here
  // any more, so it was dead and is gone.
  let divergenceHtml = '';
  const backendDivergence = ctx.marketDivergencePct ?? ctx.bestSources?.market_divergence_pct;
  if (backendDivergence != null && Math.abs(backendDivergence) >= 5) {
    const sign = backendDivergence > 0 ? '+' : '';
    const direction = backendDivergence > 0
      ? 'Market is paying MORE than rankings suggest'
      : 'Market is paying LESS than rankings suggest';
    const cls = Math.abs(backendDivergence) >= 10 ? 'src-div-strong' : 'src-div-mild';
    divergenceHtml = `
      <div class="src-divergence ${cls}">
        <strong>${sign}${backendDivergence.toFixed(1)}%</strong> - ${direction}
      </div>
    `;
  }

  // ---- Bottom: blended/consensus value line ----
  // These labels sit directly under the number, so they have to describe
  // where it actually came from. 'fc' used to read "FantasyCalc only" and
  // 'backend' "Consensus (FC + DP + KTC)" -- both described the pre-2026-07-11
  // blend, and 'fc' was what every player on the site was tagged.
  const FP_BLENDS = {
    first_party: 'TACO value',
    blended: 'Real trades + stats/ADP',
    trade_only: 'Real trades',
    prior_only: 'Trailing stats + ADP',
    adp_only_prior: 'Draft market',
    pick_anchor: 'Pick market',
  };
  const blendLabel = FP_BLENDS[ctx.valueSource]
                  || (ctx.valueSource === 'backend' || ctx.valueSource === 'taco' ? 'TACO value'
                  : ctx.valueSource === 'dp' ? 'DynastyProcess only'
                  : ctx.valueSource === 'ktc' ? 'KTC only'
                  : 'Value');

  // Confidence label varies based on whether we have backend agreement info
  const confidenceLabel = agreement != null
    ? (agreement >= 85 ? 'sources agree' : agreement < 70 ? 'sources disagree' : 'mixed signal')
    : (ctx.confidence >= 0.9 ? 'high confidence' : 'one source');
  const confidenceCls = agreement != null
    ? (agreement >= 85 ? 'src-confidence-high' : agreement < 70 ? 'src-confidence-low' : '')
    : (ctx.confidence >= 0.9 ? 'src-confidence-high' : '');

  return `
    <div class="drawer-section drawer-sources-section">
      <div class="drawer-section-head">
        <span>Sources</span>
        <span class="src-confidence ${confidenceCls}">${confidenceLabel}</span>
      </div>
      ${tagsHtml}
      <div class="src-rows">${rows.filter(Boolean).join('')}</div>
      ${quadHtml}
      ${(() => {
        // TACO-003: league-relative WAR for the currently-open league
        const warLg = STATE.currentTeamIdx != null ? STATE.leagues?.[STATE.currentTeamIdx] : null;
        if (!warLg || typeof getLeagueWarBaselines !== 'function' || !TacoCore.playerWar) return '';
        const b = getLeagueWarBaselines(warLg);
        if (!b) return '';
        const adj = leagueTradeValue(ctx.bestValue, ctx.position, warLg, ctx.playerId);
        const w = TacoCore.playerWar(adj, ctx.position, b);
        if (w == null) return '';
        return `
          <div class="src-meta-row" data-tooltip="${escapeHtml(warTooltipText(warLg.scoringTab))}">
            <span class="src-meta-label">WAR · ${escapeHtml(warLg.name)}</span>
            <span class="src-war-value">${w > 0 ? w.toFixed(1) + 'W' : 'replacement level'}</span>
          </div>
        `;
      })()}
      ${agreementHtml}
      ${rangeHtml}
      ${momentumHtml}
      ${divergenceHtml}
      <div class="src-composite">
        <span class="src-composite-label">${blendLabel}</span>
        <span class="src-composite-value">${Math.round(ctx.bestValue).toLocaleString()}</span>
      </div>
    </div>
  `;
}

;
/*! ==== 46-player-drawer-cross-league-player-context.js ==== */
// Player drawer chrome — context → 63; stats → 17.

function buildPlayerDrawerContent(playerId) {
  const ctx = gatherPlayerContext(playerId);
  if (!ctx) {
    return `
      <button class="drawer-close" data-pd-close>${icon('close', 14)}</button>
      <div style="padding: 80px 24px; text-align: center; color: var(--text-muted);">
        Player not found in Sleeper database.
      </div>
    `;
  }

  // similar player computation left in place (findSimilarPlayers call) for potential reuse;
  // the similarHtml block was removed as it is no longer rendered.

  const tags = [];
  if (ctx.rookie) tags.push('<span class="drawer-tag rookie">Rookie</span>');
  if (ctx.injuryStatus && ctx.injuryStatus !== 'Active') tags.push(`<span class="drawer-tag injured">${escapeHtml(ctx.injuryStatus)}</span>`);
  if (ctx.yearsExp != null && !ctx.rookie) tags.push(`<span class="drawer-tag">Yr ${ctx.yearsExp}</span>`);

  const momHero = drawerMomentumLabel(ctx.momentum30d, ctx.momentum7d, ctx.momentum1d);
  let trendLabel = '-';
  let trendCls = '';
  let trendCaption = '30d Trend';
  if (momHero) {
    trendLabel = momHero.label;
    trendCls = momHero.cls;
    trendCaption = momHero.caption;
  } else {
    const trendValue = ctx.trend30Day;
    trendLabel = trendValue > 0
      ? `+${Math.round(trendValue).toLocaleString()}`
      : trendValue < 0
        ? `−${Math.round(Math.abs(trendValue)).toLocaleString()}`
        : '-';
    trendCls = trendValue > 50 ? 'trend-up' : trendValue < -50 ? 'trend-down' : '';
  }

  const ownedTotal = ctx.ownedIn.reduce((s, e) => s + (e.value || 0), 0);
  const leagueCount = STATE.leagues.length || 1;
  const exposurePct = ctx.ownedIn.length > 0
    ? Math.round((ctx.ownedIn.length / leagueCount) * 100)
    : 0;
  const exposureHtml = ctx.ownedIn.length > 1 ? `
    <div class="drawer-exposure-summary">
      <span class="drawer-exposure-pill" data-tooltip="Share of your dynasty leagues where you roster this player">
        ${ctx.ownedIn.length}/${leagueCount} leagues · ${exposurePct}% exposure
      </span>
      ${exposurePct >= 50 ? '<span class="drawer-exposure-risk">High concentration</span>' : ''}
    </div>
  ` : '';

  // Exposure section: leagues where I own them
  const ownedHtml = ctx.ownedIn.length === 0 ? '' : `
    <div class="drawer-section">
      <div class="drawer-section-head">
        <span>You own in</span>
        <span class="drawer-section-count">${ctx.ownedIn.length}/${STATE.leagues.length}${ownedTotal > 0 ? ' · ' + Math.round(ownedTotal).toLocaleString() + ' combined' : ''}</span>
      </div>
      ${ctx.ownedIn.map(e => {
        const tag = e.rosterPlayer?.isStarter ? 'START' : e.rosterPlayer?.isIR ? 'IR' : e.rosterPlayer?.isTaxi ? 'TAXI' : '';
        return `
          <div class="drawer-exposure-row" data-pd-jump-league="${escapeHtml(e.league.league_id)}">
            <div>
              <div class="drawer-exposure-name">${escapeHtml(e.league.name)}</div>
              <div class="drawer-exposure-sub">${e.league.scoringTab}${tag ? ' · ' + tag : ''}</div>
            </div>
            <span class="drawer-exposure-tag mine">Your team</span>
            <span class="drawer-exposure-val">${Math.round(e.value).toLocaleString()}</span>
          </div>
        `;
      }).join('')}
    </div>
  `;

  // Where this player sits in YOUR portfolio. Owen feedback: the long list
  // of "owned by opponents" in other leagues is too much info for a drawer
  // — popular players generate 20+ rows. Replaced with a one-line summary.
  // The acquire-trade button still uses ctx.rosteredByOthers internally to
  // pick a target league; the data is gathered, just not displayed as a wall.
  // (dead opponentSummary / othersHtml removed — data still available via ctx for trade targets)

  // Waiver availability
  const availHtml = ctx.availableIn.length === 0 ? '' : `
    <div class="drawer-section">
      <div class="drawer-section-head">
        <span>Available on waivers</span>
        <span class="drawer-section-count">${ctx.availableIn.length}/${STATE.leagues.filter(l => l.startupComplete !== false).length}</span>
      </div>
      ${ctx.availableIn.map(e => `
        <div class="drawer-exposure-row" data-pd-jump-league="${escapeHtml(e.league.league_id)}">
          <div>
            <div class="drawer-exposure-name">${escapeHtml(e.league.name)}</div>
            <div class="drawer-exposure-sub">${e.league.scoringTab}</div>
          </div>
          <span class="drawer-exposure-tag available">Available</span>
          <span class="drawer-exposure-val">${Math.round(e.value).toLocaleString()}</span>
        </div>
      `).join('')}
    </div>
  `;

  // Similar value players (construction removed — no longer rendered in drawer;
  // findSimilarPlayers still called for potential future use or other panels)

  // Actions: "Build a trade" opens the trade calc pre-loaded
  // For players I own: put them on my side. For opponents/FAs: put them on the target side.
  const rankLeague = ctx.ownedIn.length ? ctx.ownedIn[0].league : STATE.leagues[STATE.currentTeamIdx];
  const actionsHtml = `
    <div class="drawer-actions">
      ${ctx.ownedIn.length > 0 ? `
        <button class="drawer-action primary" data-pd-trade="${escapeHtml(ctx.playerId)}" data-pd-trade-side="A">
          Build a trade sending ${escapeHtml(ctx.name.split(' ').pop())}
        </button>
      ` : ''}
      ${ctx.rosteredByOthers.length > 0 ? `
        <button class="drawer-action ${ctx.ownedIn.length === 0 ? 'primary' : ''}" data-pd-trade="${escapeHtml(ctx.playerId)}" data-pd-trade-side="B">
          Build a trade acquiring ${escapeHtml(ctx.name.split(' ').pop())}
        </button>
      ` : ''}
      <button class="drawer-action" data-pd-rankings="${escapeHtml(ctx.playerId)}" data-pd-rankings-league="${escapeHtml(rankLeague ? rankLeague.league_id : '')}">
        See in Rankings${rankLeague ? ' · ' + escapeHtml(rankLeague.scoringTab) : ''}
      </button>
      ${ctx.ownedIn.length ? `<button class="drawer-action" data-pd-exposure="${escapeHtml(ctx.name)}">Assets &amp; Exposure</button>` : ''}
      ${TacoCore.playerPagePath ? `<a class="drawer-action" href="https://thearmchairoffice.com${TacoCore.playerPagePath(ctx.playerId, ctx.name)}" target="_blank" rel="noopener" data-tooltip="His public page: values by format and what real trades pay. Shareable, no username needed.">Player page ↗</a>` : ''}
    </div>
  `;

  // Profile section: synchronous data straight from playersDB (height, weight,
  // college, depth chart, injury). Skipped entirely if no fields populated.
  const p = STATE.playersDB?.[playerId];
  const profileBits = [];
  // Sleeper stores height as bare inches in a string ("71"), so pushing it
  // straight through rendered "71 · 215 lbs · Texas" -- an unlabelled number
  // sitting next to a properly-united one, which reads as a bug. Some records
  // already carry a formatted value (6'2"); pass those through untouched.
  if (p?.height) {
    const raw = String(p.height).trim();
    const inches = /^\d+$/.test(raw) ? parseInt(raw, 10) : null;
    profileBits.push(escapeHtml(inches ? `${Math.floor(inches / 12)}'${inches % 12}"` : raw));
  }
  if (p?.weight) profileBits.push(`${escapeHtml(String(p.weight))} lbs`);
  if (p?.college) profileBits.push(escapeHtml(p.college));
  if (p?.depth_chart_position && p?.depth_chart_order != null) {
    profileBits.push(`${escapeHtml(p.depth_chart_position)}${p.depth_chart_order}`);
  } else if (p?.depth_chart_position) {
    profileBits.push(`Depth: ${escapeHtml(p.depth_chart_position)}`);
  }
  const injuryHtml = (p?.injury_status && p.injury_status !== 'Active') ? `
    <div class="drawer-injury">
      <div class="drawer-injury-status">${escapeHtml(p.injury_status)}</div>
      ${p.injury_body_part ? `<div class="drawer-injury-body">${escapeHtml(p.injury_body_part)}</div>` : ''}
      ${p.practice_participation ? `<div class="drawer-injury-practice">Practice: ${escapeHtml(p.practice_participation)}</div>` : ''}
      ${p.injury_notes ? `<div class="drawer-injury-notes">${escapeHtml(p.injury_notes)}</div>` : ''}
    </div>
  ` : '';

  // Last status update timestamp from Sleeper. Sleeper doesn't expose a public
  // news endpoint, but `news_updated` (ms since epoch) IS in the player object —
  // it's a recency signal for "when did Sleeper last get fresh info on this guy".
  // Render as relative time so users can spot stale vs fresh data at a glance.
  let newsMetaHtml = '';
  if (p?.news_updated) {
    const ts = Number(p.news_updated);
    if (!isNaN(ts) && ts > 0) {
      const ageDays = (Date.now() - ts) / (1000 * 60 * 60 * 24);
      let label;
      let cls = '';
      if (ageDays < 1) { label = 'Status updated today'; cls = 'fresh'; }
      else if (ageDays < 3) { label = `Status updated ${Math.floor(ageDays)}d ago`; cls = 'fresh'; }
      else if (ageDays < 14) { label = `Status updated ${Math.floor(ageDays)}d ago`; }
      else if (ageDays < 60) { label = `Status updated ${Math.floor(ageDays / 7)}w ago`; cls = 'stale'; }
      else { label = `Status update >${Math.floor(ageDays / 30)} months ago`; cls = 'stale'; }
      newsMetaHtml = `<div class="drawer-news-meta ${cls}">${label}</div>`;
    }
  }

  const profileHtml = (profileBits.length > 0 || injuryHtml || newsMetaHtml) ? `
    <div class="drawer-section">
      <div class="drawer-section-head"><span>Profile</span></div>
      ${profileBits.length > 0 ? `<div class="drawer-profile-bits">${profileBits.join(' · ')}</div>` : ''}
      ${injuryHtml}
      ${newsMetaHtml}
    </div>
  ` : '';

  // Stats section: placeholder filled in async by loadStatsSection() after
  // the drawer renders. We pass the stable ID into openPlayerDrawer's hook.
  const statsContainerId = 'drawerStats-' + playerId;
  const statsHtml = `
    <div class="drawer-section">
      <div class="drawer-section-head"><span>Stats</span></div>
      <div id="${statsContainerId}" class="drawer-stats-loading">
        <div class="drawer-skel-row">
          <div class="skeleton-line skeleton-line-short"></div>
          <div class="skeleton-line skeleton-line-wide"></div>
        </div>
        <div class="drawer-skel-grid">
          <div class="skeleton-stat"></div>
          <div class="skeleton-stat"></div>
          <div class="skeleton-stat"></div>
          <div class="skeleton-stat"></div>
        </div>
      </div>
    </div>
  `;

  // Advanced stats section: placeholder filled async by loadAdvancedStatsSection()
  // -- usage, role and efficiency for this player, ranked vs his position.
  const advContainerId = 'drawerAdv-' + playerId;
  const advHtml = `
    <div class="drawer-section">
      <div class="drawer-section-head"><span>Advanced stats</span></div>
      <div id="${advContainerId}" class="drawer-stats-loading">
        <div class="drawer-skel-grid">
          <div class="skeleton-stat"></div>
          <div class="skeleton-stat"></div>
          <div class="skeleton-stat"></div>
          <div class="skeleton-stat"></div>
        </div>
      </div>
    </div>
  `;

  // News section: placeholder filled in async by loadNewsSection() after the
  // drawer renders. Pulls from cached RSS items matched to this player's name.
  const newsContainerId = 'drawerNews-' + playerId;
  const newsHtml = `
    <div class="drawer-section">
      <div class="drawer-section-head">
        <span>News</span>
        <span class="drawer-section-meta-light">RSS feeds</span>
      </div>
      <div id="${newsContainerId}" class="drawer-news-loading">
        <div class="skeleton-line skeleton-line-wide"></div>
        <div class="skeleton-line"></div>
        <div class="skeleton-line skeleton-line-wide"></div>
      </div>
    </div>
  `;

  return `
    <button class="drawer-close" data-pd-close>${icon('close', 14)}</button>
    <div class="drawer-hero">
      <div class="drawer-hero-row">
        ${playerAvatarHtml(ctx.playerId, ctx.name, ctx.position)
          .replace('class="avatar', 'class="avatar avatar-lg')}
        <div class="drawer-hero-ident">
          <div class="drawer-hero-name">${escapeHtml(ctx.name)}</div>
          <div class="drawer-hero-meta">
            ${ctx.position}${ctx.posRank ? ' · ' + ctx.posRank : ''} · ${ctx.team}${ctx.age ? ' · ' + ctx.age + 'y' : ''}
          </div>
          ${tags.length > 0 ? `<div class="drawer-hero-tags">${tags.join('')}</div>` : ''}
        </div>
      </div>
    </div>
    <div class="drawer-value-row">
      <div class="drawer-value-cell">
        <div class="drawer-value-label">Value</div>
        <div class="drawer-value-num accent">${Math.round(ctx.bestValue).toLocaleString()}</div>
      </div>
      <div class="drawer-value-cell">
        <div class="drawer-value-label">${trendCaption}</div>
        <div class="drawer-value-num ${trendCls} small">${trendLabel}</div>
      </div>
      <div class="drawer-value-cell">
        <div class="drawer-value-label">Position</div>
        <div class="drawer-value-num small">${ctx.posRank || ctx.position}</div>
      </div>
    </div>
    ${typeof buildDrawerValueWhyHtml === 'function' ? buildDrawerValueWhyHtml(ctx) : ''}
    ${typeof buildDrawerValueTrendSection === 'function' ? buildDrawerValueTrendSection(ctx.playerId, ctx.primaryScoringTab) : ''}
    ${exposureHtml}
    ${ownedHtml}
    ${buildSourcesPanel(ctx)}
    ${newsHtml}
    ${profileHtml}
    ${statsHtml}
    ${advHtml}
    ${availHtml}
    ${actionsHtml}
  `;
}

// Opens the trade calculator preloaded with a specific player on the given side.
// For owned players → put on MY side (A). For targets → put on opposing side (B).
// Picks a reasonable default opposing roster (the first league where the player
// exists and I participate, with the opponent who owns them if applicable).
function openTradeWithPlayer(playerId, side) {
  const ctx = gatherPlayerContext(playerId);
  if (!ctx) return;

  // Find the best league to open in: prefer a league where I both own the player
  // (if side='A') OR where the player is rostered by an opponent (if side='B').
  let targetLeague = null;
  let targetRosterA = null;
  let targetRosterB = null;

  if (side === 'A' && ctx.ownedIn.length > 0) {
    const entry = ctx.ownedIn[0];
    targetLeague = entry.league;
    targetRosterA = entry.roster.rosterId;
    // Pick any opponent roster as B default
    const opponent = entry.league.allRosters.find(r => !r.isMe);
    targetRosterB = opponent?.rosterId;
  } else if (side === 'B' && ctx.rosteredByOthers.length > 0) {
    const entry = ctx.rosteredByOthers[0];
    targetLeague = entry.league;
    targetRosterB = entry.roster.rosterId;
    const me = entry.league.allRosters.find(r => r.isMe);
    targetRosterA = me?.rosterId;
  } else {
    // Fallback: first league where player exists
    const fallback = ctx.ownedIn[0] || ctx.rosteredByOthers[0] || ctx.availableIn[0];
    if (!fallback) return;
    targetLeague = fallback.league;
    const me = fallback.league.allRosters.find(r => r.isMe);
    targetRosterA = me?.rosterId;
    const opp = fallback.league.allRosters.find(r => !r.isMe);
    targetRosterB = opp?.rosterId;
  }

  if (!targetLeague || !targetRosterA || !targetRosterB) return;

  // Stash the "preload" request. Trade calc initializer will consume it.
  STATE.tradePreload = {
    leagueIdx: STATE.leagues.indexOf(targetLeague),
    sideARosterId: targetRosterA,
    sideBRosterId: targetRosterB,
    assetKey: 'P:' + playerId,
    assetSide: side,
  };
  // The Trades tab, not a calculator inside League Overview (2026-10-18).
  // teamDetailTab is deliberately left alone: setting it to 'trade' is what
  // left League Overview showing a trade screen on every later visit.
  STATE.currentTeamIdx = STATE.leagues.indexOf(targetLeague);
  if (!STATE.tradeInitialized && typeof initTradeCalculator === 'function') {
    initTradeCalculator();
    STATE.tradeInitialized = true;
  }
  showView('trade');
  applyTradePreload();
}
window.openTradeWithPlayer = openTradeWithPlayer;

(function wirePlayerDrawerDelegation() {
  if (wirePlayerDrawerDelegation._wired) return;
  wirePlayerDrawerDelegation._wired = true;
  document.addEventListener('click', (e) => {
    const root = e.target.closest('#drawerContent');
    if (!root) return;
    if (e.target.closest('[data-pd-close]')) {
      closePlayerDrawer();
      return;
    }
    const jump = e.target.closest('[data-pd-jump-league]');
    if (jump?.dataset.pdJumpLeague) {
      jumpToTeamByLeagueId(jump.dataset.pdJumpLeague);
      closePlayerDrawer();
      return;
    }
    const player = e.target.closest('[data-pd-player]');
    if (player?.dataset.pdPlayer) {
      openPlayerDrawer(player.dataset.pdPlayer);
      return;
    }

    const odTrade = e.target.closest('[data-od-trade]');
    if (odTrade?.dataset.odTrade) {
      const parts = odTrade.dataset.odTrade.split('|');
      closePlayerDrawer();
      jumpToTradeWith(Number(parts[0]), Number(parts[1]));
      return;
    }
    const toRankings = e.target.closest('[data-pd-rankings]');
    if (toRankings) {
      closePlayerDrawer();
      if (typeof openPlayerInRankings === 'function') openPlayerInRankings(toRankings.dataset.pdRankings, toRankings.dataset.pdRankingsLeague);
      return;
    }
    const toExposure = e.target.closest('[data-pd-exposure]');
    if (toExposure) {
      // Assets & Exposure's own search, across every roster in every league.
      closePlayerDrawer();
      STATE.assetsSearchQuery = toExposure.dataset.pdExposure;
      if (typeof navigateFromLink === 'function') navigateFromLink(null, '/tools/assets');
      return;
    }
    const trade = e.target.closest('[data-pd-trade]');
    if (trade?.dataset.pdTrade) {
      openTradeWithPlayer(trade.dataset.pdTrade, trade.dataset.pdTradeSide || 'A');
      closePlayerDrawer();
    }
  });
})();

;
/*! ==== 15-visual-helpers-avatars-icons-charts.js ==== */
// Sleeper CDN serves player headshots and team avatars. Not every player has
// a photo (especially new rookies or fringe players), so we lazy-load with a
// silent fallback — if the image 404s, we hide it and show initials.
// Primary colour per NFL team, brightened where the official shade vanishes on
// near-black (navy, dark green). Drives the ring round every player photo.
const NFL_TEAM_COLORS = {
  ARI: '#e3224f', ATL: '#e3223a', BAL: '#8a6cff', BUF: '#2f6bff', CAR: '#00a3e0', CHI: '#ff5a1f',
  CIN: '#ff5a14', CLE: '#ff5a1f', DAL: '#5b8cff', DEN: '#fb4f14', DET: '#0a8fe0', GB: '#ffb612',
  HOU: '#e3224f', IND: '#2f7dff', JAX: '#00a3b8', KC: '#ff2a3d', LV: '#c4c9cc', LAC: '#0a9cf0',
  LAR: '#ffd100', MIA: '#00b3bd', MIN: '#9b6bff', NE: '#e11d48', NO: '#d3bc8d', NYG: '#3d6bff',
  NYJ: '#18a86b', PHI: '#00a39a', PIT: '#ffb612', SF: '#e3224f', SEA: '#69be28', TB: '#ff2a2a',
  TEN: '#4b92db', WAS: '#e03a3e',
};
function playerTeamColor(playerId) {
  const team = STATE.playersDB?.[playerId]?.team;
  return (team && NFL_TEAM_COLORS[team]) || null;
}

function playerAvatarHtml(playerId, name, position) {
  if (!playerId) return fallbackInitialsHtml(name, position);
  const url = `https://sleepercdn.com/content/nfl/players/thumb/${playerId}.jpg`;
  const initials = fallbackInitialsHtml(name, position);
  const tc = playerTeamColor(playerId);
  return `
    <div class="avatar avatar-player pos-${(position || '').toLowerCase()}"${tc ? ` style="--tc:${tc}"` : ''}>
      <img src="${url}" alt="" loading="lazy" data-img-fallback="avatar">
      ${initials}
    </div>
  `;
}

// Team avatars come from Sleeper. Two sources:
//   - per-league avatar (user.metadata.avatar) — can be a hash OR a full URL
//   - account-level avatar (user.avatar) — always a hash
// We try the league one first (more specific), fall back to account.
// If hash, build the URL; if already-URL, use as-is.
function teamAvatarHtml(rosterOrAvatarId, teamName) {
  // Backward compatibility: if a string was passed, treat as a single avatar
  // hash and use account-style URL building.
  let leagueAvatar = null;
  let accountAvatar = null;
  if (typeof rosterOrAvatarId === 'string' || rosterOrAvatarId == null) {
    accountAvatar = rosterOrAvatarId;
  } else {
    // roster-shaped object passed
    leagueAvatar = rosterOrAvatarId.leagueAvatar || null;
    accountAvatar = rosterOrAvatarId.accountAvatar || rosterOrAvatarId.avatar || null;
  }

  const url = resolveAvatarUrl(leagueAvatar) || resolveAvatarUrl(accountAvatar);
  const initials = fallbackTeamInitialsHtml(teamName);
  if (!url) return `<div class="avatar avatar-team avatar-fallback">${initials}</div>`;
  return `
    <div class="avatar avatar-team">
      <img src="${url}" alt="" loading="lazy" data-img-fallback="avatar">
      ${initials}
    </div>
  `;
}

// NFL team logo from Sleeper's CDN — lowercase team abbreviation → PNG
// (verified: /images/team_logos/nfl/kc.png). Returns '' for free agents or a
// missing team; if the abbreviation has no logo the <img> hides itself via the
// data-img-fallback="hide" handler (module 69), so a bad code degrades to
// nothing rather than a broken-image icon. `extraCls` lets callers size it per
// surface (e.g. 'ry-team-logo', 'injury-team-logo').
function teamLogoHtml(team, extraCls) {
  const abbr = String(team || '').trim().toLowerCase();
  if (!abbr || abbr === 'fa') return '';
  const cls = 'team-logo' + (extraCls ? ' ' + extraCls : '');
  const url = `https://sleepercdn.com/images/team_logos/nfl/${encodeURIComponent(abbr)}.png`;
  return `<img class="${cls}" src="${url}" alt="" loading="lazy" data-img-fallback="hide">`;
}

// Convert an avatar reference (hash or URL) to a usable URL, or return null
// if there's nothing usable.
function resolveAvatarUrl(ref) {
  if (!ref) return null;
  // Already a URL
  if (/^https?:\/\//i.test(ref)) return ref;
  // Full size, not /thumbs/ (Owen, 2026-11-01: avatars looked blurry).
  // Sleeper's thumb is 80x80. These render at 24-44px, which on a phone at
  // dpr 3 needs 72-132 device pixels, so the thumb was being UPSCALED and
  // every manager and team badge came out soft. The full avatar is 400x400
  // and crisp at every size we draw. Measured: thumb 3.2KB vs full 31KB.
  //
  // Player headshots are a different endpoint and are NOT changed: there,
  // /thumb/ and the full path return byte-identical 350x254 files, so there
  // is nothing sharper to ask for.
  return `https://sleepercdn.com/avatars/${ref}`;
}

function fallbackInitialsHtml(name, _position) {
  const parts = (name || '').trim().split(/\s+/);
  const initials = parts.length >= 2
    ? parts[0][0] + parts[parts.length - 1][0]
    : (parts[0] || '?').slice(0, 2);
  return `<span class="avatar-initials">${escapeHtml(initials.toUpperCase())}</span>`;
}

function fallbackTeamInitialsHtml(teamName) {
  const parts = (teamName || '?').trim().split(/\s+/);
  const initials = parts.slice(0, 2).map(p => p[0] || '').join('').toUpperCase() || '?';
  return `<span class="avatar-initials">${escapeHtml(initials)}</span>`;
}

// Inline SVG icons. Using a small curated set keeps weight tiny while giving us
// consistent stroke-based glyphs across the whole app. Pattern: icon(name, size?)
const ICONS = {
  arrowUp:    '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 13V3m0 0l-4 4m4-4l4 4"/></svg>',
  arrowDown:  '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3v10m0 0l-4-4m4 4l4-4"/></svg>',
  trendUp:    '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12l4-5 3 3 5-6"/><path d="M10 4h4v4"/></svg>',
  trendDown:  '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M2 4l4 5 3-3 5 6"/><path d="M10 12h4v-4"/></svg>',
  search:     '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="7" cy="7" r="5"/><path d="M14 14l-3-3"/></svg>',
  flame:      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M8 2c1 3 4 4 4 7a4 4 0 11-8 0c0-2 1-3 2-4 0 1 1 1 1 0 0-1-1-2 1-3z"/></svg>',
  caret:      '<svg viewBox="0 0 16 16" fill="currentColor"><path d="M4 6l4 4 4-4z"/></svg>',
  close:      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 4l8 8M12 4l-8 8"/></svg>',
  check:      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8l3 3 7-7"/></svg>',
  external:   '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M10 3h3v3M13 3l-6 6M7 3H3v10h10V9"/></svg>',
  chevronR:   '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 3l5 5-5 5"/></svg>',
  clock:      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="8" cy="8" r="6"/><path d="M8 4v4l2 2"/></svg>',
  users:      '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="6" cy="5" r="3"/><path d="M1 14c0-3 3-5 5-5s5 2 5 5"/><path d="M11 6a2.5 2.5 0 000-5M13 14c0-2-1-4-3-4"/></svg>',
  trophy:     '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 3h6v4a3 3 0 01-6 0V3zM4 5H2v1a2 2 0 002 2M12 5h2v1a2 2 0 01-2 2M8 10v3M5 14h6"/></svg>',
};
function icon(name, size = 14) {
  const svg = ICONS[name];
  if (!svg) return '';
  return svg.replace('<svg ', `<svg width="${size}" height="${size}" class="icon icon-${name}" `);
}

// Simple inline SVG bar chart. Renders a single row of bars sized to the value
// with optional reference line overlay. Designed for small multiples on cards.
// Stretches via preserveAspectRatio to fill its container width — viewBox is
// virtual so width/height props are sizing hints, not hard pixel constraints.
// Time-series line chart for value history. Points are {ts, value}.
// Auto-scales y-axis with 10% padding. Latest-point dot. Color encodes trend
// (green up, red down, gold flat). Returns empty if <2 points (no trend).
function renderLineChart(points, opts = {}) {
  const { width = 320, height = 80 } = opts;
  if (!points || points.length < 2) return '';
  const values = points.map(p => p.value);
  const max = Math.max(...values);
  const min = Math.min(...values);
  const range = Math.max(1, max - min);
  const yMax = max + range * 0.1;
  const yMin = Math.max(0, min - range * 0.1);
  const yRange = Math.max(1, yMax - yMin);

  const xs = points.map((_, i) => (i / (points.length - 1)) * (width - 4) + 2);
  const ys = points.map(p => height - 6 - ((p.value - yMin) / yRange) * (height - 12));

  const d = points.map((_, i) => `${i === 0 ? 'M' : 'L'} ${xs[i].toFixed(2)} ${ys[i].toFixed(2)}`).join(' ');
  const area = `${d} L ${xs[xs.length - 1].toFixed(2)} ${height} L ${xs[0].toFixed(2)} ${height} Z`;

  const lastY = ys[ys.length - 1];
  const firstY = ys[0];
  const trendUp = lastY < firstY;  // y is inverted
  const flat = Math.abs(lastY - firstY) < 4;
  const lineColor = flat ? 'var(--accent)' : (trendUp ? '#7fa878' : '#c24a5a');

  return `
    <svg class="sparkline" width="100%" height="${height}" viewBox="0 0 ${width} ${height}" preserveAspectRatio="none">
      <path d="${area}" fill="${lineColor}" fill-opacity="0.10"/>
      <path d="${d}" stroke="${lineColor}" stroke-width="1.5" fill="none" stroke-linejoin="round" stroke-linecap="round"/>
      <circle cx="${xs[xs.length - 1].toFixed(2)}" cy="${lastY.toFixed(2)}" r="2.5" fill="${lineColor}"/>
    </svg>
  `;
}

function renderBarChart(values, opts = {}) {
  const { width = 320, height = 80, highlight = null, refLine = null } = opts;
  if (!values.length) return '';
  const max = Math.max(...values, refLine || 0) * 1.05;
  const gap = 2;
  const barW = (width - (values.length - 1) * gap) / values.length;
  const sortedDesc = [...values].sort((a, b) => b - a);
  const topThreshold = sortedDesc[Math.min(2, sortedDesc.length - 1)] || 0;
  const bottomThreshold = sortedDesc[Math.max(sortedDesc.length - 3, 0)] || 0;

  const bars = values.map((v, i) => {
    const h = Math.max(2, (v / max) * (height - 8));
    const x = i * (barW + gap);
    const y = height - h;
    // Color: highlight idx → solid accent; top 3 → bright accent; bottom 3 → dim;
    // middle → mid-strength accent. This makes the distribution visible.
    let fill;
    if (highlight === i) fill = 'var(--accent)';
    else if (v >= topThreshold) fill = 'rgba(166, 125, 61, 0.95)';
    else if (v <= bottomThreshold) fill = 'rgba(140, 118, 84, 0.35)';
    else fill = 'rgba(166, 125, 61, 0.65)';
    return `<rect x="${x.toFixed(2)}" y="${y.toFixed(2)}" width="${barW.toFixed(2)}" height="${h.toFixed(2)}" fill="${fill}" rx="1"><title>${Math.round(v).toLocaleString()}</title></rect>`;
  }).join('');

  let ref = '';
  if (refLine != null) {
    const y = height - (refLine / max) * (height - 8);
    ref = `<line x1="0" y1="${y.toFixed(2)}" x2="${width}" y2="${y.toFixed(2)}" stroke="rgba(255,255,255,0.35)" stroke-width="1" stroke-dasharray="4 3"/>`;
  }
  return `<svg class="sparkbar" width="100%" height="${height}" viewBox="0 0 ${width} ${height}" preserveAspectRatio="none">${bars}${ref}</svg>`;
}

function renderPlayerRow(p, lg) {
  const league = lg || (STATE.currentTeamIdx != null ? STATE.leagues[STATE.currentTeamIdx] : null);
  const displayValue = typeof displayedPlayerValue === 'function'
    ? displayedPlayerValue(p, league)
    : (p.leagueValue ?? p.value);
  const valueClass = displayValue && displayValue > 6500 ? 'hi' : (displayValue ? '' : 'none');
  const rookieTag = p.rookie ? '<span class="rookie-mark">ROOK</span>' : '';
  const starterTag = p.isStarter ? '<span class="starter-mark">START</span>' : '';
  // Page 3 + Page 1 carryover: roster-row injury indicator. The All Leagues
  // injury strip shows the cross-league summary; this surfaces it on the
  // actual roster pages where users spend the most time. Pull canonical
  // status from playersDB — player row may not carry it depending on
  // enrichment timing.
  const injuryBadge = (() => {
    const dbPlayer = STATE.playersDB?.[p.playerId];
    const status = dbPlayer?.injury_status || null;
    if (!status || status === 'Active' || status === 'Healthy') return '';
    const s = status.toLowerCase();
    let cls = 'injury-mark-other';
    if (s.includes('out')) cls = 'injury-mark-out';
    else if (s.includes('doubtful')) cls = 'injury-mark-doubtful';
    else if (s.includes('ir') || s.includes('reserve')) cls = 'injury-mark-ir';
    else if (s.includes('questionable')) cls = 'injury-mark-questionable';
    const bodyPart = dbPlayer?.injury_body_part ? ' · ' + dbPlayer.injury_body_part : '';
    const tooltip = escapeHtml(status + bodyPart);
    // Show short label — first 3 chars in caps to keep row dense.
    const short = status.slice(0, 3).toUpperCase();
    return `<span class="injury-mark ${cls}" data-tooltip="${tooltip}">${short}</span>`;
  })();
  const trendHtml = (p.momentum30d != null || p.momentum7d != null)
    ? formatMomentumTrend(p.momentum30d, p.momentum7d, true)
    : formatTrend(p.trend30Day, true);
  const avatar = playerAvatarHtml(p.playerId, p.name, p.position);
  const safePid = escapeHtml(p.playerId || '');
  const posCls = `pos-${(p.position || '').toLowerCase()}`;
  return `
    <div class="player-row ${posCls}" data-sleeper-id="${safePid}" data-taco-player="${safePid}">
      ${avatar}
      <div class="player-id-block">
        <span class="player-name"><span class="player-name-text">${escapeHtml(p.name)}</span>${rookieTag}${starterTag}${injuryBadge}</span>
        <span class="player-meta">${typeof teamLogoHtml === 'function' ? teamLogoHtml(p.team, 'row-team-logo') : ''}<span class="player-meta-team">${p.team || 'FA'}</span> · ${p.posRank || p.position}${p.age ? ' · ' + p.age + 'y' : ''}</span>
      </div>
      <div class="player-value-wrap">
        <div class="player-value ${valueClass}">
          ${displayValue ? Math.round(displayValue).toLocaleString() : '-'}
          ${trendHtml}
        </div>
        ${''/* No pick-equivalent ("~ E 1st") and no WAR ("1.8W") here any more
             (Owen, 2026-10-18: "the numbers at the end do not make sense.
             nobody would understand them"). Four stacked figures on one row,
             two of them abbreviations whose only explanation was a tooltip --
             which a dense list cannot show and a phone cannot open. The value
             and its trend stay, because those read on sight. The maths is
             untouched (TacoCore.playerWar, pickEquivLabel) if either is ever
             re-homed somewhere with room to label it properly. */}
      </div>
    </div>
  `;
}

// ============================================================
// PLAYER DRAWER
// Slides in from right with full player context across all your leagues.
// ============================================================
// `scoringTab` is the format the surface that was clicked is displaying.
// Parked on STATE rather than threaded because one drawer open fans out into
// four separate gatherPlayerContext calls (here, the content builder, the stats
// loader, the trade handoff) and they must all price in the same format.
function openPlayerDrawer(playerId, scoringTab) {
  if (!playerId) return;
  STATE.drawerScoringTab = scoringTab || null;
  const drawer = document.getElementById('playerDrawer');
  const overlay = document.getElementById('drawerOverlay');
  const content = document.getElementById('drawerContent');
  if (!drawer || !overlay || !content) return;

  content.innerHTML = buildPlayerDrawerContent(playerId);
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  overlay.classList.add('open');
  // Lock page scroll behind drawer
  document.body.style.overflow = 'hidden';
  if (window.TacoFocus) TacoFocus.capture(drawer, { focus: '.drawer-close' });

  // Lazy-load stats into the placeholder we put in the drawer markup.
  // Pull position from the player ctx so the per-game stat line is curated.
  const ctx = gatherPlayerContext(playerId);
  if (ctx) {
    loadStatsSection(playerId, ctx.position, 'drawerStats-' + playerId);
    loadNewsSection(playerId, 'drawerNews-' + playerId);
    if (typeof loadAdvancedStatsSection === 'function') {
      loadAdvancedStatsSection(playerId, ctx.position, 'drawerAdv-' + playerId);
    }
  }
}

function closePlayerDrawer() {
  const drawer = document.getElementById('playerDrawer');
  const overlay = document.getElementById('drawerOverlay');
  if (!drawer || !overlay) return;
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  overlay.classList.remove('open');
  document.body.style.overflow = '';
  if (window.TacoFocus) TacoFocus.release(drawer);
}
window.openPlayerDrawer = openPlayerDrawer;
window.closePlayerDrawer = closePlayerDrawer;

// Count-up animation for stat-strip hero numerals. Runs once per element
// (data-counted guard), skips non-numeric text ("—", pills), respects
// prefers-reduced-motion. Handles ints, one-decimal values, and W-L pairs.
function animateStatNumbers(rootEl) {
  if (!rootEl) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  rootEl.querySelectorAll('.stat-strip-num').forEach((el) => {
    if (el.dataset.counted) return;
    const raw = el.textContent.trim();
    const m = raw.match(/^(\d+(?:\.\d+)?)(?:-(\d+(?:\.\d+)?))?$/);
    if (!m) return;
    el.dataset.counted = '1';
    const a = parseFloat(m[1]);
    const b = m[2] !== undefined ? parseFloat(m[2]) : null;
    const dpA = (m[1].split('.')[1] || '').length;
    const dpB = b !== null ? ((m[2].split('.')[1] || '').length) : 0;
    const dur = 700;
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - t0) / dur);
      const e = 1 - Math.pow(1 - p, 3);
      el.textContent = b === null
        ? (a * e).toFixed(dpA)
        : `${(a * e).toFixed(dpA)}-${(b * e).toFixed(dpB)}`;
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = raw;
    };
    requestAnimationFrame(tick);
  });
}
window.animateStatNumbers = animateStatNumbers;

;
/*! ==== 66-glossary-modal.js ==== */
// Glossary modal — term definitions from GLOSSARY (10-sleeper-api).

// ============================================================
// GLOSSARY MODAL
// Centered modal listing every term defined in GLOSSARY, organized by category.
// Same overlay pattern as the drawer; closes on outside-click or Escape.
// ============================================================
function openGlossary() {
  const modal = document.getElementById('glossaryModal');
  const overlay = document.getElementById('glossaryOverlay');
  const inner = document.getElementById('glossaryInner');
  if (!modal || !overlay || !inner) return;
  inner.innerHTML = buildGlossaryContent();
  modal.classList.add('open');
  modal.setAttribute('aria-hidden', 'false');
  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  if (window.TacoFocus) TacoFocus.capture(modal, { focus: '[data-glossary-close]' });
}

function closeGlossary() {
  const modal = document.getElementById('glossaryModal');
  const overlay = document.getElementById('glossaryOverlay');
  if (!modal || !overlay) return;
  modal.classList.remove('open');
  modal.setAttribute('aria-hidden', 'true');
  overlay.classList.remove('open');
  if (window.TacoFocus) TacoFocus.release(modal);
  // Only release scroll lock if the player drawer isn't ALSO open
  const playerDrawer = document.getElementById('playerDrawer');
  if (!playerDrawer || !playerDrawer.classList.contains('open')) {
    document.body.style.overflow = '';
  }
}

// Group GLOSSARY entries into named sections so the modal is scannable
// rather than one giant unordered list. Order matches the categories
// users encounter in the UI from outside-in.
function buildGlossaryContent() {
  const sections = [
    {
      title: 'Team Styles',
      terms: ['Dynasty Core', 'Contender', 'Ascending', 'Middle Tier', 'Rebuild'],
    },
    {
      title: 'Pick Terms',
      terms: ['Slot', 'Bucket', 'Pick value'],
    },
    {
      title: 'Scoring Formats',
      terms: ['1QB', 'SF', 'TE+', 'TE++', 'TE+++'],
    },
    {
      title: 'Trade Calculator',
      terms: ['Tier premium', 'Effective value', 'Fairness band'],
    },
    {
      title: 'Other',
      terms: ['30d momentum', 'Position rank', 'League Rankings'],
    },
  ];
  const sectionsHtml = sections.map(s => `
    <div class="glossary-section">
      <div class="glossary-section-head">${s.title}</div>
      ${s.terms.filter(t => GLOSSARY[t]).map(t => `
        <div class="glossary-row">
          <div class="glossary-term">${escapeHtml(t)}</div>
          <div class="glossary-def">${escapeHtml(GLOSSARY[t])}</div>
        </div>
      `).join('')}
    </div>
  `).join('');
  return `
    <div class="glossary-head">
      <div>
        <div class="glossary-title">Glossary</div>
        <div class="glossary-subtitle">Definitions for every metric, team style and tag used in The Armchair Office.</div>
      </div>
      <button class="drawer-close" style="position:relative;top:auto;right:auto;" data-glossary-close>${icon('close', 14)}</button>
    </div>
    ${sectionsHtml}
  `;
}

window.openGlossary = openGlossary;
window.closeGlossary = closeGlossary;

(function wireGlossaryDelegation() {
  if (wireGlossaryDelegation._wired) return;
  wireGlossaryDelegation._wired = true;
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-glossary-close]')) closeGlossary();
  });
})();

;
/*! ==== 81-owner-roster-snapshot.js ==== */
// Owner drawer roster snapshot tiles — extracted from 16.

function buildOwnerRosterSnapshotHtml(lg, r, rosterId) {
  if (!r) return '';
    const players = r.players || [];
    const totalValue = TacoCore.rosterPlayersValue(players);
    const startersValue = players.filter(p => p.isStarter).reduce((s, p) => s + (p.value || 0), 0);
    const benchValue = totalValue - startersValue;
    const ages = players.filter(p => p.age && p.age > 0 && !p.isIR && !p.isTaxi).map(p => p.age);
    const avgAge = ages.length ? (ages.reduce((a, b) => a + b, 0) / ages.length).toFixed(1) : '-';

    // Power rank in this league
    // Players-only, matching the totalValue tile right above it. Deliberately
    // NOT teamValue(): this drawer shows a roster snapshot with no pick column,
    // so ranking it on picks-inclusive totals would put a team's rank out of
    // step with the only number the drawer actually displays.
    const allTotals = TacoCore.leagueTeamValues(lg, { includePicks: false })
      .map(x => ({ rid: x.rosterId, total: x.value }))
      .sort((a, b) => b.total - a.total);
    const powerRank = allTotals.findIndex(x => x.rid === rosterId) + 1;

    // Position breakdown (sum of all rostered players by position)
    const byPos = { QB: 0, RB: 0, WR: 0, TE: 0 };
    for (const p of players) {
      if (byPos[p.position] != null) byPos[p.position] += (p.value || 0);
    }

    // Archetype — use existing computer if available
    let archetypeLabel = '';
    if (typeof archetypeForRoster === 'function') {
      try {
        archetypeLabel = archetypeForRoster(lg, r) || '';
      } catch (_e) { /* harmless if computation fails */ }
    }

    return `
      <div class="drawer-section">
        <div class="drawer-section-head">
          <span>Roster</span>
          <span class="drawer-section-count">#${powerRank}/${lg.allRosters.length} in ${escapeHtml(lg.scoringTab)}</span>
        </div>
        <div class="owner-roster-stats">
          <div class="owner-roster-row">
            <div class="owner-roster-stat">
              <div class="owner-roster-num accent">${formatCompactNumber(totalValue)}</div>
              <div class="owner-roster-lbl">Roster value</div>
            </div>
            <div class="owner-roster-stat">
              <div class="owner-roster-num">${formatCompactNumber(startersValue)}</div>
              <div class="owner-roster-lbl">Starters</div>
            </div>
            <div class="owner-roster-stat">
              <div class="owner-roster-num">${formatCompactNumber(benchValue)}</div>
              <div class="owner-roster-lbl">Bench</div>
            </div>
            <div class="owner-roster-stat">
              <div class="owner-roster-num">${avgAge}</div>
              <div class="owner-roster-lbl">Avg age</div>
            </div>
          </div>
          <div class="owner-roster-pos">
            ${['QB', 'RB', 'WR', 'TE'].map(pos => {
              const v = byPos[pos];
              // Position rank in this league
              const allPosTotals = lg.allRosters.map(x => ({
                rid: x.rosterId,
                // allow-inline-roster-sum: single-position subtotal, not a roster total
                v: (x.players || []).filter(p => p.position === pos).reduce((s, p) => s + (p.value || 0), 0),
              })).sort((a, b) => b.v - a.v);
              const posRank = allPosTotals.findIndex(x => x.rid === rosterId) + 1;
              return `
                <div class="owner-roster-pos-cell">
                  <div class="owner-roster-pos-letter ${pos.toLowerCase()}">${pos}</div>
                  <div class="owner-roster-pos-val">${formatCompactNumber(v)}</div>
                  <div class="owner-roster-pos-rank">#${posRank}</div>
                </div>
              `;
            }).join('')}
          </div>
          ${archetypeLabel ? `
            <div class="owner-roster-archetype">
              <span class="owner-roster-archetype-lbl">Archetype</span>
              <span class="owner-roster-archetype-val">${escapeHtml(archetypeLabel)}</span>
            </div>
          ` : ''}
        </div>
      </div>
    `;
}
window.buildOwnerRosterSnapshotHtml = buildOwnerRosterSnapshotHtml;

;
/*! ==== 16-owner-drawer-same-drawer-chrome-different-conten.js ==== */
// Owner drawer shell — roster snapshot → 81.
// Reuses the player drawer's slide-in surface to render an owner profile.
// Triggered from any clickable owner name (League Rankings rows, Trade
// History sides, etc.). One drawer at a time — opening one closes the other.
function openOwnerDrawer(leagueId, rosterId) {
  if (!leagueId || rosterId == null) return;
  const drawer = document.getElementById('playerDrawer');
  const overlay = document.getElementById('drawerOverlay');
  const content = document.getElementById('drawerContent');
  if (!drawer || !overlay || !content) return;

  // Stamp identity so an async re-render (e.g., after lazy trade-history
  // load completes) can confirm it's targeting the same drawer state.
  drawer.dataset.ownerLeagueId = leagueId;
  drawer.dataset.ownerRosterId = String(rosterId);

  content.innerHTML = buildOwnerDrawerContent(leagueId, rosterId);
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}
window.openOwnerDrawer = openOwnerDrawer;

// One manager, across every league of yours they are in.
//
// The drawer above answers "who is this, in THIS league". This answers the
// question you actually ask before offering someone a trade or handing them a
// vacant team: who is this person everywhere I can see them. Owen,
// 2026-11-03: "I want the option to also search for managers and see all this
// information about them."
//
// Costs no requests. Everything is already loaded or cached for other
// features -- the enriched leagues, the season snapshots the all-time record
// walks, the turnover walk, and trade history. The parts that need a walk
// (all-time, turnover) fill in when it finishes and the drawer redraws.
function openManagerDrawer(ownerId) {
  if (!ownerId) return;
  const drawer = document.getElementById('playerDrawer');
  const overlay = document.getElementById('drawerOverlay');
  const content = document.getElementById('drawerContent');
  if (!drawer || !overlay || !content) return;

  STATE.managerDrawerId = String(ownerId);
  delete drawer.dataset.ownerLeagueId;
  delete drawer.dataset.ownerRosterId;
  drawer.dataset.managerId = String(ownerId);

  // The turnover walk also fills STATE.seasonSnapshots, which is what gives
  // this drawer all-time records for other people. Kick it off if it has not
  // run, and redraw once it lands rather than blocking on it.
  if (!STATE.ownerTurnover && typeof loadOwnerTurnover === 'function') {
    loadOwnerTurnover().then(() => {
      if (document.getElementById('playerDrawer')?.dataset.managerId === String(ownerId)) {
        renderManagerDrawer(ownerId);
      }
    });
  }

  renderManagerDrawer(ownerId);
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
}
window.openManagerDrawer = openManagerDrawer;

function renderManagerDrawer(ownerId) {
  const content = document.getElementById('drawerContent');
  if (!content) return;
  content.innerHTML = buildManagerDrawerContent(ownerId);
}
window.renderManagerDrawer = renderManagerDrawer;

function buildManagerDrawerContent(ownerId) {
  const close = '<button class="drawer-close" data-pd-close>' + icon('close', 14) + '</button>';
  const p = TacoCore.buildManagerProfile({
    ownerId,
    leagues: STATE.leagues || [],
    seasonsByLeague: STATE.seasonSnapshots || {},
    turnover: STATE.ownerTurnover,
    trades: STATE.tradeHistory || [],
    meUserId: STATE.userId,
  });
  if (!p) {
    return close + '<div class="drawer-section"><div class="drawer-empty">That manager is not in any of your leagues.</div></div>';
  }

  const pct = (v) => (v == null ? '-' : v.toFixed(1) + '%');
  const toneCls = (v) => {
    const t = TacoCore.winPctTone(v);
    return t === 'good' ? 'mgr-good' : t === 'bad' ? 'mgr-bad' : '';
  };
  const avatar = p.avatar
    ? '<img class="avatar avatar-lg" src="https://sleepercdn.com/avatars/' + escapeHtml(p.avatar) + '" alt="" loading="lazy">'
    : '<div class="avatar avatar-lg avatar-fallback">' + escapeHtml((p.name || '?').slice(0, 2).toUpperCase()) + '</div>';

  const hero =
    '<div class="drawer-hero"><div class="drawer-hero-row">' + avatar +
    '<div class="drawer-hero-ident">' +
    '<div class="drawer-hero-name">' + escapeHtml(p.name || 'Manager') + '</div>' +
    '<div class="drawer-hero-meta">In ' + p.leagueCount + ' of your leagues</div>' +
    '</div></div></div>';

  // This season, then all-time once the walk has filled the snapshots in.
  const statRow = (label, s) =>
    '<div class="mgr-statline"><div class="mgr-statline-head">' + label +
    '<span class="mgr-statline-sub">' + s.games + ' games' +
    (s.seasonsPlayed > p.leagueCount ? ' · ' + s.seasonsPlayed + ' league-seasons' : '') + '</span></div>' +
    '<div class="mgr-stats">' +
    '<div class="mgr-stat"><b>' + escapeHtml(s.record) + '</b><span>record</span></div>' +
    '<div class="mgr-stat"><b class="' + toneCls(s.winPct) + '">' + pct(s.winPct) + '</b><span>win %</span></div>' +
    '<div class="mgr-stat"><b>' + (s.pointsPerGame != null ? s.pointsPerGame.toFixed(1) : '-') + '</b><span>pts / game</span></div>' +
    '<div class="mgr-stat"><b>' + (s.pointDiffPerGame != null ? (s.pointDiffPerGame > 0 ? '+' : '') + s.pointDiffPerGame.toFixed(1) : '-') + '</b><span>pt diff / g</span></div>' +
    '</div></div>';

  let recordHtml = p.season.games > 0 ? statRow('This season', p.season) : '<div class="drawer-empty">No games played yet.</div>';
  if (p.allTime.games > p.season.games) recordHtml += statRow('All time', p.allTime);
  else if (!STATE.ownerTurnover) recordHtml += '<div class="mgr-pending">Reading past seasons…</div>';

  // Turnover. Zero is worth stating plainly -- "never left one" is the answer
  // somebody is looking for as often as the opposite.
  const t = p.turnover;
  let turnHtml;
  if (!STATE.ownerTurnover) {
    turnHtml = '<div class="mgr-pending">Reading past seasons…</div>';
  } else {
    const bits = [];
    bits.push('<div class="mgr-stat"><b class="' + (t.left > 1 ? 'mgr-bad' : '') + '">' + t.left + '</b><span>teams left</span></div>');
    bits.push('<div class="mgr-stat"><b class="' + (t.tookOver > 0 ? 'mgr-good' : '') + '">' + t.tookOver + '</b><span>orphans taken</span></div>');
    const where = [
      ...t.leftIn.map((x) => '<span class="mgr-where mgr-bad">left ' + escapeHtml(x.season + ' ' + x.league) + '</span>'),
      ...t.tookOverIn.map((x) => '<span class="mgr-where mgr-good">took over ' + escapeHtml(x.season + ' ' + x.league) + '</span>'),
    ].join('');
    turnHtml = '<div class="mgr-stats">' + bits.join('') + '</div>' +
      (where ? '<div class="mgr-wheres">' + where + '</div>' : '') +
      '<p class="inv-note">A team changing hands is a handover, not a verdict - somebody may have quit, been removed, or simply had a year. ' +
      escapeHtml(TacoCore.turnoverScopeNote(STATE.ownerTurnover.leaguesWithHistory || 0)) + '</p>';
  }

  // Your own trade record against them, by the calculator's verdict -- the
  // same rule Trade History judges every other trade by.
  const w = p.withYou;
  const withYouHtml = w.trades
    ? '<div class="mgr-stats">' +
      '<div class="mgr-stat"><b>' + w.trades + '</b><span>trades</span></div>' +
      '<div class="mgr-stat"><b class="mgr-good">' + w.youWon + '</b><span>you won</span></div>' +
      '<div class="mgr-stat"><b class="mgr-bad">' + w.theyWon + '</b><span>they won</span></div>' +
      '<div class="mgr-stat"><b>' + w.fair + '</b><span>fair</span></div>' +
      '</div>'
    : '<div class="drawer-empty">' + (STATE.tradeHistory ? 'You have never traded with them.' : 'Open Trade History to load your trades with them.') + '</div>';

  const leagueRows = p.perLeague.map((l) =>
    '<div class="mgr-league" data-taco-owner="' + escapeHtml(l.leagueId) + '|' + l.rosterId + '">' +
    '<div class="mgr-league-main"><span class="mgr-league-name">' + escapeHtml(l.leagueName) + '</span>' +
    '<span class="mgr-league-team">' + escapeHtml(l.teamName || '') + (l.scoringTab ? ' · ' + escapeHtml(l.scoringTab) : '') + '</span></div>' +
    '<div class="mgr-league-rec"><b>' + escapeHtml(l.season.record) + '</b>' +
    '<span>' + (typeof ordinal === 'function' ? ordinal(l.standing) : l.standing) + ' of ' + (l.teams || '-') + '</span></div>' +
    '</div>').join('');

  const sec = (title, body) => '<div class="drawer-section"><div class="drawer-section-head"><span>' + title + '</span></div>' + body + '</div>';
  return close + hero +
    sec('Record', recordHtml) +
    sec('Teams given up', turnHtml) +
    sec('With you', withYouHtml) +
    sec('Leagues you share', leagueRows);
}
window.buildManagerDrawerContent = buildManagerDrawerContent;

function buildOwnerDrawerContent(leagueId, rosterId) {
  const profile = buildOwnerProfile(leagueId, rosterId);
  if (!profile) {
    return `
      <button class="drawer-close" data-pd-close>×</button>
      <div class="drawer-section">
        <div class="drawer-empty">Owner not found.</div>
      </div>
    `;
  }

  const { lg, ownerName, teamName, isMe, tradeCount } = profile;

  // Avatar (reuse roster lookup from the league)
  const r = lg.allRosters.find(x => x.rosterId === rosterId);
  const avatarHtml = r ? teamAvatarHtml(r, teamName) : '';

  // ============================================================
  // ROSTER SNAPSHOT — independent of trade history
  // ============================================================
  // The owner drawer used to be entirely trade-based, which made it feel
  // wrong when opened from League Rankings (where you care about who's
  // good, not how they trade). This block surfaces the team-level facts
  // that exist regardless of trade activity: total value, position-by-
  // position breakdown, archetype, age, power rank in the league.
  const rosterSnapshotHtml = buildOwnerRosterSnapshotHtml(lg, r, rosterId);

  if (profile.empty) {
    const emptyMsg = profile.historyLoading
      ? 'Loading trade history… this drawer will populate when ready.'
      : 'No completed trades found for this owner yet. Profile will populate once they make trades.';
    return `
      <button class="drawer-close" data-pd-close>${icon('close', 14)}</button>
      <div class="drawer-hero">
        <div class="drawer-hero-row">
          ${avatarHtml.replace('class="avatar', 'class="avatar avatar-lg')}
          <div class="drawer-hero-ident">
            <div class="drawer-hero-name">${escapeHtml(teamName)}${isMe ? ' <span class="pr-mine-tag">you</span>' : ''}</div>
            <div class="drawer-hero-meta">${escapeHtml(ownerName)} · ${escapeHtml(lg.name)}</div>
          </div>
        </div>
      </div>
      ${rosterSnapshotHtml}
      <div class="drawer-section">
        <div class="drawer-empty">${emptyMsg}</div>
      </div>
    `;
  }

  // Build the verdict tally chart (wins/fair/losses bar)
  const decided = profile.wins + profile.losses + profile.fair;
  const winsPct = decided > 0 ? (profile.wins / decided) * 100 : 0;
  const fairPct = decided > 0 ? (profile.fair / decided) * 100 : 0;
  const lossPct = decided > 0 ? (profile.losses / decided) * 100 : 0;

  // Position bias bars — incoming vs outgoing per position
  const posBars = ['QB', 'RB', 'WR', 'TE'].map(pos => {
    const inV = profile.incomingByPos[pos];
    const outV = profile.outgoingByPos[pos];
    const max = Math.max(inV, outV, 1);
    const inWidth = (inV / max) * 100;
    const outWidth = (outV / max) * 100;
    const net = inV - outV;
    const netLabel = net === 0 ? '-' : (net > 0 ? `+${formatCompactNumber(net)}` : `${formatCompactNumber(net)}`);
    const netCls = net > 500 ? 'pos-net-pos' : net < -500 ? 'pos-net-neg' : 'pos-net-flat';
    return `
      <div class="owner-pos-row">
        <div class="owner-pos-label">${pos}</div>
        <div class="owner-pos-bars">
          <div class="owner-pos-bar owner-pos-in"  style="width: ${inWidth.toFixed(1)}%"  data-tooltip="In: ${Math.round(inV).toLocaleString()}"></div>
          <div class="owner-pos-bar owner-pos-out" style="width: ${outWidth.toFixed(1)}%" data-tooltip="Out: ${Math.round(outV).toLocaleString()}"></div>
        </div>
        <div class="owner-pos-net ${netCls}">${netLabel}</div>
      </div>
    `;
  }).join('');

  // Vs-me block — only if not me and we've traded
  let vsMeHtml = '';
  if (!isMe && profile.vsMeCount > 0) {
    const sign = profile.vsMeNetForMe >= 0 ? '+' : '';
    const cls = profile.vsMeNetForMe > 200 ? 'pos-net-pos' : profile.vsMeNetForMe < -200 ? 'pos-net-neg' : 'pos-net-flat';
    vsMeHtml = `
      <div class="drawer-section">
        <div class="drawer-section-head"><span>History with you</span></div>
        <div class="owner-vsme">
          <div class="owner-vsme-stat">
            <div class="owner-vsme-num">${profile.vsMeCount}</div>
            <div class="owner-vsme-lbl">trade${profile.vsMeCount === 1 ? '' : 's'}</div>
          </div>
          <div class="owner-vsme-stat">
            <div class="owner-vsme-num win">${profile.vsMeMyWins}</div>
            <div class="owner-vsme-lbl">you won</div>
          </div>
          <div class="owner-vsme-stat">
            <div class="owner-vsme-num">${profile.vsMeFair}</div>
            <div class="owner-vsme-lbl">fair</div>
          </div>
          <div class="owner-vsme-stat">
            <div class="owner-vsme-num loss">${profile.vsMeTheirWins}</div>
            <div class="owner-vsme-lbl">they won</div>
          </div>
        </div>
        <div class="owner-vsme-foot">
          Net value to you: <span class="${cls}">${sign}${formatCompactNumber(profile.vsMeNetForMe)}</span>
        </div>
      </div>
    `;
  } else if (!isMe) {
    vsMeHtml = `
      <div class="drawer-section">
        <div class="drawer-section-head"><span>History with you</span></div>
        <div class="owner-empty-mini">No completed trades between you yet.</div>
      </div>
    `;
  }

  // Top accumulated players — who they've trade-acquired most often
  const topPlayersHtml = profile.topIncomingPlayers.length > 0
    ? `<div class="owner-top-players">
        ${profile.topIncomingPlayers.map(([name, count]) => `
          <div class="owner-top-player">
            <span class="owner-top-name">${escapeHtml(name)}</span>
            ${count > 1 ? `<span class="owner-top-count">acquired ${count}×</span>` : ''}
          </div>
        `).join('')}
      </div>`
    : '<div class="owner-empty-mini">No notable accumulations.</div>';

  // Pick CTA: build trade with this owner (only if not me)
  const lgIdx = STATE.leagues.findIndex(l => l.league_id === leagueId);
  const tradeCta = !isMe && lgIdx !== -1
    ? `<div class="drawer-section">
        <button class="drawer-action-btn" data-od-trade="${lgIdx}|${rosterId}">
          Build trade with ${escapeHtml(teamName)} →
        </button>
      </div>`
    : '';

  return `
    <button class="drawer-close" data-pd-close>${icon('close', 14)}</button>
    <div class="drawer-hero">
      <div class="drawer-hero-row">
        ${avatarHtml.replace('class="avatar', 'class="avatar avatar-lg')}
        <div class="drawer-hero-ident">
          <div class="drawer-hero-name">${escapeHtml(teamName)}${isMe ? ' <span class="pr-mine-tag">you</span>' : ''}</div>
          <div class="drawer-hero-meta">${escapeHtml(ownerName)} · ${escapeHtml(lg.name)}${(() => {
            // Phase E2: surface league record + points-for in the hero.
            const r = lg.allRosters.find(x => x.rosterId === rosterId);
            if (!r) return '';
            const games = (r.wins || 0) + (r.losses || 0) + (r.ties || 0);
            if (games === 0) return '';
            const recordStr = `${r.wins}-${r.losses}${r.ties ? '-' + r.ties : ''}`;
            const pf = r.pointsFor ? r.pointsFor.toFixed(1) : null;
            return ` · ${recordStr}${pf ? ' · ' + pf + ' PF' : ''}`;
          })()}</div>
          <div class="drawer-hero-tags">
            <span class="drawer-tag">${escapeHtml(profile.activity)}</span>
            <span class="drawer-tag">${escapeHtml(profile.style)}</span>
            ${profile.withMeLabel ? `<span class="drawer-tag">${escapeHtml(profile.withMeLabel)}</span>` : ''}
          </div>
        </div>
      </div>
    </div>

    ${rosterSnapshotHtml}

    <div class="drawer-value-row">
      <div class="drawer-value-cell">
        <div class="drawer-value-label">Trades</div>
        <div class="drawer-value-num accent">${tradeCount}</div>
      </div>
      <div class="drawer-value-cell">
        <div class="drawer-value-label">Avg verdict</div>
        <div class="drawer-value-num small ${profile.avgNetDelta > 0 ? 'good' : profile.avgNetDelta < 0 ? 'bad' : ''}">
          ${profile.avgNetDelta > 0 ? '+' : ''}${formatCompactNumber(profile.avgNetDelta)}
        </div>
      </div>
      <div class="drawer-value-cell">
        <div class="drawer-value-label">Style</div>
        <div class="drawer-value-num small">${escapeHtml(profile.raterTier.split(' - ')[0])}</div>
      </div>
    </div>

    <div class="drawer-section">
      <div class="drawer-section-head"><span>Trade verdicts</span></div>
      <div class="owner-verdict-bar">
        ${profile.wins > 0   ? `<div class="owner-verdict-seg vd-win"   style="width: ${winsPct.toFixed(1)}%" data-tooltip="${profile.wins} won"></div>` : ''}
        ${profile.fair > 0   ? `<div class="owner-verdict-seg vd-fair"  style="width: ${fairPct.toFixed(1)}%" data-tooltip="${profile.fair} fair"></div>` : ''}
        ${profile.losses > 0 ? `<div class="owner-verdict-seg vd-loss"  style="width: ${lossPct.toFixed(1)}%" data-tooltip="${profile.losses} lost"></div>` : ''}
      </div>
      <div class="owner-verdict-legend">
        <span><span class="vd-dot vd-win"></span>${profile.wins} won</span>
        <span><span class="vd-dot vd-fair"></span>${profile.fair} fair</span>
        <span><span class="vd-dot vd-loss"></span>${profile.losses} lost</span>
        ${profile.multi > 0 ? `<span><span class="vd-dot vd-multi"></span>${profile.multi} multi</span>` : ''}
      </div>
    </div>

    <div class="drawer-section">
      <div class="drawer-section-head">
        <span>Position activity</span>
        <span class="drawer-trend-meta">in vs out, net</span>
      </div>
      <div class="owner-pos-grid">${posBars}</div>
      <div class="owner-pos-foot">${escapeHtml(profile.posLeanLabel)}</div>
    </div>

    <div class="drawer-section">
      <div class="drawer-section-head"><span>Pick activity</span></div>
      <div class="owner-pick-row">
        <div>Acquired: <strong>${formatCompactNumber(profile.incomingPicks)}</strong></div>
        <div>Sent: <strong>${formatCompactNumber(profile.outgoingPicks)}</strong></div>
        <div>Net: <strong class="${profile.incomingPicks - profile.outgoingPicks > 500 ? 'pos-net-pos' : profile.incomingPicks - profile.outgoingPicks < -500 ? 'pos-net-neg' : ''}">
          ${profile.incomingPicks - profile.outgoingPicks > 0 ? '+' : ''}${formatCompactNumber(profile.incomingPicks - profile.outgoingPicks)}
        </strong></div>
      </div>
    </div>

    ${profile.topIncomingPlayers.length > 0 ? `
      <div class="drawer-section">
        <div class="drawer-section-head"><span>Often acquires</span></div>
        ${topPlayersHtml}
      </div>
    ` : ''}

    ${(() => {
      // Phase E2: Trade Block. Sleeper users can mark players on their roster
      // as "on the trade block" through the Sleeper app. When set, the value
      // arrives in r.metadata.trade_block as a comma-separated list of player
      // IDs. Resolve to names from the players DB and surface here. Owen
      // wanted: "list who they have on the trade block" instead of the old
      // "often acquires" inference.
      const r = lg.allRosters.find(x => x.rosterId === rosterId);
      const meta = r?.rosterMetadata || {};
      // Sleeper has used different keys in different formats. Check the most
      // common ones; harmless when nothing is set.
      const blockRaw = meta.trade_block || meta.tradeblock || meta.player_block || '';
      if (!blockRaw) {
        return `
          <div class="drawer-section">
            <div class="drawer-section-head"><span>Trade block</span></div>
            <div class="owner-empty-mini">${isMe ? "You haven't" : ownerName + " hasn't"} set a trade block in Sleeper.</div>
          </div>
        `;
      }
      const blockIds = String(blockRaw).split(',').map(s => s.trim()).filter(Boolean);
      const blockPlayers = blockIds.map(pid => {
        const p = (r?.players || []).find(pp => pp.playerId === pid || pp.sleeperId === pid);
        return p ? { name: p.name, position: p.position, value: p.value || 0, playerId: pid } : { name: pid, position: '?', value: 0, playerId: pid };
      });
      return `
        <div class="drawer-section">
          <div class="drawer-section-head">
            <span>Trade block</span>
            <span class="drawer-section-count">${blockPlayers.length}</span>
          </div>
          <div class="owner-top-players">
            ${blockPlayers.map(p => `
              <div class="owner-top-player owner-block-player" data-taco-player="${escapeHtml(p.playerId)}">
                <span class="owner-top-id">${typeof playerAvatarHtml === 'function' ? playerAvatarHtml(p.playerId, p.name, p.position) : ''}<span class="owner-top-name">${escapeHtml(p.name)}</span></span>
                <span class="owner-top-count">${p.position}${p.value ? ' · ' + Math.round(p.value).toLocaleString() : ''}</span>
              </div>
            `).join('')}
          </div>
        </div>
      `;
    })()}

    ${vsMeHtml}
    ${tradeCta}
  `;
}
window.buildOwnerDrawerContent = buildOwnerDrawerContent;

;
/*! ==== 75-stats-game-log.js ==== */
// Sleeper stats fetch + game log HTML — extracted from 17.

// Single endpoint per (player, season) — way leaner than the old approach
// of pulling every player's stats for 18 weeks just to find one player's lines.
//
//   GET api.sleeper.com/stats/nfl/player/{pid}?season={year}&season_type=regular&grouping=week
//     → array of weekly objects: [{ week, opponent, stats: {...} }, ...]
//
//   GET api.sleeper.com/stats/nfl/player/{pid}?season={year}&season_type=regular&grouping=season
//     → single object with season totals: { stats: {...}, gp, ... }
//
// We compute fantasy points by multiplying raw stats × the league's
// scoring_settings. This guarantees the points reflect THE USER'S league
// scoring (SF / TE+ / TE++ / etc.) — not Sleeper's generic PPR fallback.
//
// Cache lives in STATE.playerStats[`${pid}-${season}`]:
//   { weeks: [...], season: {...}, fetchedAt: timestamp }
const STATS_BASE = 'https://api.sleeper.com';

async function fetchPlayerSeasonStats(playerId, season) {
  const key = `${playerId}-${season}`;
  if (!STATE.playerStats) STATE.playerStats = {};
  if (STATE.playerStats[key]) return STATE.playerStats[key];
  const fetchKey = 'pstats:' + key;
  if (STATE._statsFetches[fetchKey]) return STATE._statsFetches[fetchKey];

  STATE._statsFetches[fetchKey] = (async () => {
    try {
      // Pull weekly + season totals in parallel — both are fast (one player only)
      const [weekRes, seasonRes] = await Promise.all([
        fetch(`${STATS_BASE}/stats/nfl/player/${playerId}?season=${season}&season_type=regular&grouping=week`),
        fetch(`${STATS_BASE}/stats/nfl/player/${playerId}?season=${season}&season_type=regular&grouping=season`),
      ]);
      const weeksRaw = weekRes.ok ? await weekRes.json() : null;
      const seasonRaw = seasonRes.ok ? await seasonRes.json() : null;

      // Weekly response is an OBJECT keyed by week number: { "1": {...}, "2": {...} }
      // OR an array depending on which Sleeper variant. Normalize to an array
      // sorted by week ascending.
      const weeks = [];
      if (weeksRaw && typeof weeksRaw === 'object') {
        if (Array.isArray(weeksRaw)) {
          for (const w of weeksRaw) {
            if (w && (w.stats || w.opponent != null)) weeks.push(w);
          }
        } else {
          for (const [wkKey, w] of Object.entries(weeksRaw)) {
            if (!w) continue;
            if (w.stats || w.opponent != null || w.pts_ppr != null) {
              const wkNum = parseInt(wkKey, 10);
              weeks.push({ ...w, week: w.week || wkNum });
            }
          }
        }
      }
      weeks.sort((a, b) => (a.week || 0) - (b.week || 0));

      const result = {
        weeks,
        season: seasonRaw || null,
        fetchedAt: Date.now(),
      };
      STATE.playerStats[key] = result;
      return result;
    } catch (e) {
      console.warn('Failed to fetch player stats:', e);
      const empty = { weeks: [], season: null, fetchedAt: Date.now() };
      STATE.playerStats[key] = empty;
      return empty;
    } finally {
      delete STATE._statsFetches[fetchKey];
    }
  })();
  return STATE._statsFetches[fetchKey];
}

// Multiply each raw stat by its scoring weight, sum, round to 0.1.
// Stat keys present on the player line but not in scoring contribute zero,
// and vice versa. Works because Sleeper's raw stat keys match scoring keys
// (pass_yd, rec, rec_td, bonus_rec_te, etc.).
// The (key, weight) list is built once per scoring object and reused: this runs
// hundreds of thousands of times on a 30-league load, and Object.entries() of a
// ~100-key scoring object on every call was most of its cost. Same keys, same
// order, so the same float sum -- results are identical.
const scoringEntriesMemo = new WeakMap();
function scoringEntriesOf(scoringSettings) {
  let list = scoringEntriesMemo.get(scoringSettings);
  if (!list) {
    list = Object.entries(scoringSettings).filter(([, w]) => typeof w === 'number');
    scoringEntriesMemo.set(scoringSettings, list);
  }
  return list;
}
function computeFantasyPoints(stats, scoringSettings) {
  if (!stats || !scoringSettings) return 0;
  let total = 0;
  const list = scoringEntriesOf(scoringSettings);
  for (let i = 0; i < list.length; i++) {
    const raw = stats[list[i][0]];
    if (raw == null) continue;
    total += raw * list[i][1];
  }
  return Math.round(total * 10) / 10;
}

// Curate a short stat line for the per-game row, position-specific.
function statLineForDisplay(position, stats) {
  if (!stats) return '';
  const parts = [];
  switch (position) {
    case 'QB':
      if (stats.pass_yd) parts.push(`${stats.pass_yd} pa yd`);
      if (stats.pass_td) parts.push(`${stats.pass_td} pa TD`);
      if (stats.pass_int) parts.push(`${stats.pass_int} INT`);
      if (stats.rush_yd) parts.push(`${stats.rush_yd} ru`);
      if (stats.rush_td) parts.push(`${stats.rush_td} ru TD`);
      break;
    case 'RB':
      if (stats.rush_att) parts.push(`${stats.rush_att} ca`);
      if (stats.rush_yd) parts.push(`${stats.rush_yd} ru`);
      if (stats.rush_td) parts.push(`${stats.rush_td} ru TD`);
      if (stats.rec) parts.push(`${stats.rec} rec`);
      if (stats.rec_yd) parts.push(`${stats.rec_yd} re`);
      if (stats.rec_td) parts.push(`${stats.rec_td} re TD`);
      break;
    case 'WR':
    case 'TE':
      if (stats.rec) parts.push(`${stats.rec} rec`);
      if (stats.rec_yd) parts.push(`${stats.rec_yd} yd`);
      if (stats.rec_td) parts.push(`${stats.rec_td} TD`);
      if (stats.rush_yd) parts.push(`${stats.rush_yd} ru`);
      break;
  }
  return parts.join(' · ') || '-';
}

// Pick the active league for stats display:
// 1. Currently-viewed team detail league (most relevant context)
// 2. League where the player is on a roster
// 3. First league overall
function getActiveLeagueForStats(playerCtx) {
  if (STATE.currentTeamIdx != null && STATE.leagues[STATE.currentTeamIdx]) {
    return STATE.leagues[STATE.currentTeamIdx];
  }
  if (playerCtx?.ownedIn?.length) return playerCtx.ownedIn[0].league;
  if (playerCtx?.rosteredByOthers?.length) return playerCtx.rosteredByOthers[0].league;
  return STATE.leagues[0] || null;
}

// Color tier for fantasy point output relative to position averages.
// Used for the green/yellow/red coloring on the game log à la Sleeper.
// Cutoffs are deliberately broad: above 1σ over position avg = great, below
// avg = poor. Falls back to neutral if cohort data is missing.
function pointsTierClass(points, positionAvg, positionStd) {
  if (positionAvg == null || positionStd == null || positionStd === 0) return '';
  const z = (points - positionAvg) / positionStd;
  if (z >= 0.6) return 'tier-great';
  if (z >= -0.2) return 'tier-good';
  if (z >= -0.8) return 'tier-mid';
  return 'tier-poor';
}

// Build the game-log table for one season. Pulled out as a helper so the
// season-tab switcher can re-render this section without refetching.
function buildGameLogHtml(seasonResults, seasonsToShow, selectedSeason, position, lg, opts = {}) {
  const idx = seasonsToShow.indexOf(selectedSeason);
  const data = seasonResults[idx];
  const allWeeks = (data?.weeks || [])
    .filter(w => w?.stats && Object.keys(w.stats).length > 0);

  if (allWeeks.length === 0) {
    return `
      <div class="drawer-stats-subhead">
        Game log
        <span class="drawer-stats-subhead-meta">${selectedSeason}</span>
      </div>
      <div class="drawer-stats-empty">No game logs found for ${selectedSeason}.</div>
    `;
  }

  // Most-recent first. For prior seasons, show ALL games (per-game season log).
  // For current season, default to last 8 unless explicitly expanded.
  const showAll = opts.showAll || selectedSeason !== +STATE.season;
  const weeks = showAll
    ? [...allWeeks].reverse()
    : [...allWeeks].slice(-8).reverse();

  const games = weeks.map(w => {
    // Surface usage data when it's in the payload. Sleeper varies what it
    // includes per season — off_pct (snap %) is sometimes present, sometimes
    // absent. Fall back to opportunity counts (targets/carries/attempts).
    let usage = '';
    const s = w.stats;
    const snapPct = s.off_pct != null ? Math.round(s.off_pct) : null;
    if (snapPct != null) {
      usage = `${snapPct}%`;
    } else if (position === 'WR' || position === 'TE') {
      if (s.rec_tgt != null) usage = `${s.rec_tgt} tgt`;
    } else if (position === 'RB') {
      const tgt = s.rec_tgt || 0;
      const car = s.rush_att || 0;
      if (tgt + car > 0) usage = `${car + tgt} tch`;
    } else if (position === 'QB') {
      if (s.pass_att != null) usage = `${s.pass_att} att`;
    }
    return {
      week: w.week,
      opponent: w.opponent || '',
      points: computeFantasyPoints(s, lg.scoring_settings),
      statLine: statLineForDisplay(position, s),
      usage,
    };
  });

  // Per-game tier color: rank by points within the displayed games (relative
  // signal — what's a good vs bad week for THIS player in THIS scoring).
  if (games.length > 1) {
    const sorted = [...games].map(g => g.points).sort((a, b) => a - b);
    const median = sorted[Math.floor(sorted.length / 2)];
    const max = sorted[sorted.length - 1];
    const min = sorted[0];
    for (const g of games) {
      if (g.points >= median + (max - median) * 0.5) g.tierCls = 'tier-great';
      else if (g.points >= median) g.tierCls = 'tier-good';
      else if (g.points >= min + (median - min) * 0.5) g.tierCls = 'tier-mid';
      else g.tierCls = 'tier-poor';
    }
  }

  const totalPts = games.reduce((s, g) => s + g.points, 0);
  const ppg = games.length > 0 ? totalPts / games.length : 0;

  return `
    <div class="drawer-stats-subhead">
      Game log
      <span class="drawer-stats-subhead-meta">${selectedSeason} · ${games.length} gm · ${ppg.toFixed(1)} ppg</span>
    </div>
    <div class="drawer-stats-table">
      ${games.map(g => `
        <div class="drawer-stats-row">
          <div class="drawer-stats-week">Wk ${g.week}${g.opponent ? ' · ' + escapeHtml(g.opponent) : ''}</div>
          <div class="drawer-stats-line">${escapeHtml(g.statLine)}</div>
          ${g.usage ? `<div class="drawer-stats-usage">${escapeHtml(g.usage)}</div>` : '<div class="drawer-stats-usage"></div>'}
          <div class="drawer-stats-pts ${g.tierCls || ''}">${g.points.toFixed(1)}</div>
        </div>
      `).join('')}
    </div>
  `;
}

;
/*! ==== 17-sleeper-stats-per-player-per-season-stats-with-l.js ==== */
// Player drawer stats section shell — game log → 75.

// Async render: writes hero (4-season summary tiles + season-switching game log).
// Single fetch per (player, season), all 4 seasons in parallel, cached.
async function loadStatsSection(playerId, position, containerId) {
  const ctx = gatherPlayerContext(playerId);
  const lg = getActiveLeagueForStats(ctx);
  const container = document.getElementById(containerId);
  if (!container) return;
  if (!lg || !lg.scoring_settings) {
    container.innerHTML = '<div class="drawer-stats-empty">League scoring not loaded - stats unavailable.</div>';
    return;
  }

  const currentSeason = +STATE.season;
  const seasonsToShow = [currentSeason, currentSeason - 1, currentSeason - 2, currentSeason - 3];

  // Fetch all 4 seasons in parallel — each is one (or two) lightweight requests.
  const seasonResults = await Promise.all(seasonsToShow.map(s => fetchPlayerSeasonStats(playerId, s)));

  // Build per-season summary using the league's exact scoring.
  const seasonRows = seasonsToShow.map((season, i) => {
    const data = seasonResults[i];
    if (!data || (!data.season && data.weeks.length === 0)) {
      return { season, points: 0, games: 0, ppg: 0, hasData: false };
    }
    let points = 0;
    let games = 0;
    if (data.season?.stats) {
      points = computeFantasyPoints(data.season.stats, lg.scoring_settings);
      games = data.season.stats.gp || data.season.stats.games_played || 0;
    }
    // Fallback: sum weeks if season totals missing
    if ((!points || !games) && data.weeks.length > 0) {
      let weekPts = 0;
      let weekGames = 0;
      for (const w of data.weeks) {
        if (w?.stats && Object.keys(w.stats).length > 0) {
          weekPts += computeFantasyPoints(w.stats, lg.scoring_settings);
          weekGames++;
        }
      }
      if (!points) points = Math.round(weekPts * 10) / 10;
      if (!games) games = weekGames;
    }
    const ppg = games > 0 ? Math.round((points / games) * 10) / 10 : 0;
    return { season, points, games, ppg, hasData: points > 0 || games > 0 };
  });

  // Default selected season: most recent one with data.
  const defaultSeason = seasonRows.find(s => s.hasData)?.season || currentSeason;

  // Stash the data in a per-container scope so the season switcher handler
  // can re-render the game log without refetching. Use playerId as the key.
  if (!STATE._statsRenderState) STATE._statsRenderState = {};
  STATE._statsRenderState[playerId] = { seasonResults, seasonsToShow, position, lg, selectedSeason: defaultSeason, containerId };

  renderStatsContainer(playerId);
}
window.loadStatsSection = loadStatsSection;

// Lazy-load news for one player. Triggers an RSS fetch (or pulls from cache),
// matches news items to this player, renders them with source/time meta.
async function loadNewsSection(playerId, containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;

  // Trigger fetch (returns immediately if cached + fresh)
  await fetchNewsFeeds();

  // After fetch, the matcher has populated newsByPlayerId
  const items = getNewsForPlayer(playerId);
  if (items.length === 0) {
    container.innerHTML = `
      <div class="drawer-news-empty">
        No recent news mentioning this player.
      </div>
    `;
    return;
  }

  // Render up to 6 most-recent items
  const top = items.slice(0, 6);
  container.innerHTML = `
    <div class="drawer-news-list">
      ${top.map(item => `
        <a class="drawer-news-item" href="${escapeHtml(item.link)}" target="_blank" rel="noopener noreferrer">
          <div class="drawer-news-head">
            <span class="drawer-news-source">${escapeHtml(item.source)}</span>
            <span class="drawer-news-time">${formatNewsTime(item.pubDate)}</span>
          </div>
          <div class="drawer-news-title">${escapeHtml(item.title)}</div>
          ${item.summary ? `<div class="drawer-news-summary">${escapeHtml(item.summary)}</div>` : ''}
        </a>
      `).join('')}
    </div>
    ${items.length > 6 ? `<div class="drawer-news-foot">+${items.length - 6} more</div>` : ''}
  `;
}
window.loadNewsSection = loadNewsSection;

// Re-render the stats section using whatever's in STATE._statsRenderState[playerId].
// Called both on initial load and when the user clicks a season tab.
function renderStatsContainer(playerId) {
  const s = STATE._statsRenderState?.[playerId];
  if (!s) return;
  const { seasonResults, seasonsToShow, position, lg, selectedSeason, containerId } = s;
  const container = document.getElementById(containerId);
  if (!container) return;

  // Season summary tiles (4 seasons)
  const tilesHtml = seasonsToShow.map((season, i) => {
    const data = seasonResults[i];
    let points = 0, games = 0, ppg = 0, hasData = false;
    if (data?.season?.stats) {
      points = computeFantasyPoints(data.season.stats, lg.scoring_settings);
      games = data.season.stats.gp || data.season.stats.games_played || 0;
      hasData = points > 0 || games > 0;
    }
    if (!hasData && data?.weeks?.length > 0) {
      let weekPts = 0, weekGames = 0;
      for (const w of data.weeks) {
        if (w?.stats && Object.keys(w.stats).length > 0) {
          weekPts += computeFantasyPoints(w.stats, lg.scoring_settings);
          weekGames++;
        }
      }
      points = Math.round(weekPts * 10) / 10;
      games = weekGames;
      hasData = points > 0;
    }
    ppg = games > 0 ? Math.round((points / games) * 10) / 10 : 0;
    return { season, points, games, ppg, hasData };
  });

  const tabsHtml = seasonsToShow
    .filter((season, i) => tilesHtml[i].hasData)
    .map(season => `
      <button class="drawer-stats-tab ${season === selectedSeason ? 'active' : ''}"
              data-stats-season="${escapeHtml(playerId)}|${season}">
        ${season}
      </button>
    `).join('');

  const gameLogHtml = buildGameLogHtml(seasonResults, seasonsToShow, selectedSeason, position, lg);

  container.innerHTML = `
    <div class="drawer-stats-head">
      <div class="drawer-stats-label">Stats in <strong>${escapeHtml(lg.scoringTab)}</strong> scoring</div>
      <div class="drawer-stats-league" data-tooltip="Points are computed using ${escapeHtml(lg.name)}'s exact scoring settings.">${escapeHtml(lg.name)}</div>
    </div>
    <div class="drawer-stats-seasons">
      ${tilesHtml.map(t => `
        <div class="drawer-stat-season ${!t.hasData ? 'no-data' : ''} ${t.season === selectedSeason ? 'active' : ''}"
             ${t.hasData ? `data-stats-season="${escapeHtml(playerId)}|${t.season}"` : ''}>
          <div class="drawer-stat-season-year">${t.season}</div>
          ${t.hasData ? `
            <div class="drawer-stat-season-pts">${t.points.toFixed(1)}</div>
            <div class="drawer-stat-season-meta">${t.games} gm · ${t.ppg.toFixed(1)} ppg</div>
          ` : `
            <div class="drawer-stat-season-pts">-</div>
            <div class="drawer-stat-season-meta">no data</div>
          `}
        </div>
      `).join('')}
    </div>
    ${tabsHtml ? `<div class="drawer-stats-tabs">${tabsHtml}</div>` : ''}
    ${gameLogHtml}
  `;
}

// Switch which season's game log is shown; tile + tab UI updates as well.
function setStatsSeason(playerId, season) {
  const s = STATE._statsRenderState?.[playerId];
  if (!s) return;
  s.selectedSeason = season;
  renderStatsContainer(playerId);
}
window.setStatsSeason = setStatsSeason;

;
/*! ==== 18-team-needs-analysis-league-relative.js ==== */
// Team needs analysis — league-relative ranks and recommendation flags.

function computeTeamNeeds(lg) {
  const me = lg.allRosters.find(r => r.isMe);
  if (!me) return { positions: [], archetype: 'Unknown', flagsStrip: '' };

  const isSF = lg.scoringTab.startsWith('SF');
  const core = typeof TacoCore.computePositionNeeds === 'function'
    ? TacoCore.computePositionNeeds(lg)
    : { positions: [] };
  const results = [];

  for (const row of core.positions) {
    const pos = row.pos;
    const tier = row.tier;
    const tierClass = row.tierClass;
    const myRank = row.myRank;
    const totalTeams = row.totalTeams;
    const myTopNValue = row.myTopNValue;
    const myTotal = row.myTotal;
    const myAvgAge = row.myAvgAge;
    const depthCount = row.depthCount;
    const n = row.startersNeeded;

    let recLabel, recText, recClass;
    const ageWord = myAvgAge != null
      ? (myAvgAge < 24.5 ? 'young' : myAvgAge > 28 ? 'old' : 'average')
      : null;

    if (tier === 'top') {
      if (ageWord === 'old') {
        recClass = 'warn';
        recLabel = 'Asset / Age Trap';
        recText = `Strong ${pos} corps but top-${n} avg age is ${myAvgAge.toFixed(1)}. Consider selling high on older pieces.`;
      } else {
        recClass = 'good';
        recLabel = 'Strength - Trade From';
        recText = `Elite ${pos} group relative to league. This is a position to package from when acquiring needs elsewhere.`;
      }
    } else if (tier === 'middle') {
      if (ageWord === 'old') {
        recClass = 'warn';
        recLabel = 'Retool Candidate';
        recText = `Middling ${pos} group that's trending old. Pivot to younger assets before value drops.`;
      } else if (ageWord === 'young') {
        recClass = 'good';
        recLabel = 'Ascending - Hold';
        recText = `Middle-of-pack ${pos} with youth. Let them develop or add another young piece.`;
      } else {
        recClass = 'warn';
        recLabel = 'Fine, Not Special';
        recText = `Average ${pos} group. Not a priority - address elsewhere unless a deal finds you.`;
      }
    } else {
      if (depthCount <= 1 && pos === 'QB' && isSF) {
        recClass = 'critical';
        recLabel = 'Urgent - SF QB Gap';
        recText = `You have ${depthCount} QB${depthCount === 1 ? '' : 's'} in a Superflex league. This is the #1 priority.`;
      } else if (depthCount === 0) {
        recClass = 'critical';
        recLabel = 'Urgent - No Depth';
        recText = `No active ${pos}s. Must acquire immediately.`;
      } else {
        recClass = 'warn';
        recLabel = 'Target Position';
        recText = `${pos}s rank ${myRank}/${totalTeams} in league. Trade from surplus elsewhere to upgrade here.`;
      }
    }

    results.push({
      pos,
      myRank, totalTeams, tierClass,
      myTopNValue, myTotal,
      myAvgAge,
      depthCount,
      startersNeeded: n,
      recLabel, recText, recClass,
    });
  }

  // Archetype: uses the new starter-based calculation (NOT total KTC value).
  const archetype = archetypeForRoster(lg, me);
  // Also pull the underlying starter-quality data for display/diagnostics
  const starterData = computeArchetypeForRoster(lg, me);
  const starterValueRanks = computeStarterValueRanks(lg);
  const starterValueRank = starterValueRanks[me.rosterId];
  // Keep myValueRank for UI display (it's the team's overall value rank, still informative)
  const allValues = lg.allRosters.map(r => r.totalValue).sort((a, b) => b - a);
  const myValueRank = allValues.indexOf(me.totalValue) + 1;

  // Build the flags strip — always in QB → RB → WR → TE order so users build
  // a habit of reading them left-to-right, with consistent position coloring.
  // Each chip uses the position's accent color so the strip visually reinforces
  // where the user's attention goes (no need to read the position label first
  // to find your QB status). Color-by-severity is layered on top via opacity
  // and a small severity dot — "Target Position" reads as the same QB chip
  // visually, just dimmer.
  const POS_ORDER = ['QB', 'RB', 'WR', 'TE'];
  const flagItems = POS_ORDER
    .map(pos => results.find(r => r.pos === pos))
    .filter(Boolean)
    .map(r => {
      const posCls = r.pos.toLowerCase();
      // Severity → visual treatment. Critical = solid + dot, warn = solid no
      // dot, ok/good = dimmed. Keeps position color consistent across all states.
      const sev = r.recClass === 'critical' ? 'sev-critical'
                : r.recClass === 'warn' ? 'sev-warn'
                : r.recClass === 'good' ? 'sev-good'
                : 'sev-ok';
      const dot = r.recClass === 'critical' ? '<span class="need-flag-dot"></span>' : '';
      return `<span class="need-flag pos-${posCls} ${sev}" data-tooltip="${escapeHtml(r.recText)}">${dot}<span class="need-flag-pos">${r.pos}</span> <span class="need-flag-label">${r.recLabel}</span></span>`;
    });

  return {
    positions: results,
    archetype,
    valueRank: myValueRank,
    starterValueRank,
    totalTeams: allValues.length,
    holes: starterData.holes,
    starterAvgAge: starterData.starterAvgAge,
    flagsStrip: flagItems.join(''),
  };
}

function renderNeedsPanel(analysis) {
  if (!analysis.positions || analysis.positions.length === 0) return '';
  const rowsHtml = analysis.positions.map(r => {
    const posCls = r.pos.toLowerCase();
    const ageValDisplay = r.myAvgAge != null ? r.myAvgAge.toFixed(1) : '-';
    let ageCls = '';
    if (r.myAvgAge != null) {
      if (r.myAvgAge < 24.5) ageCls = 'young';
      else if (r.myAvgAge > 28) ageCls = 'very-old';
      else if (r.myAvgAge > 26.5) ageCls = 'old';
    }
    return `
      <div class="needs-row">
        <div><span class="needs-pos-letter ${posCls}">${r.pos.charAt(0)}</span></div>
        <div class="needs-value-cell">
          <div class="needs-value-num">${Math.round(r.myTopNValue).toLocaleString()}</div>
          <div class="needs-sub">TOP ${r.startersNeeded} · TOTAL ${Math.round(r.myTotal).toLocaleString()}</div>
        </div>
        <div>
          <span class="needs-rank ${r.tierClass}">${r.myRank}<span class="needs-rank-of">/${r.totalTeams}</span></span>
          <div class="needs-sub">IN LEAGUE</div>
        </div>
        <div class="needs-age">
          <span class="needs-age-val ${ageCls}">${ageValDisplay}</span>
          <div class="needs-sub">TOP ${r.startersNeeded} AVG AGE</div>
        </div>
        <div class="needs-recommendation ${r.recClass}">
          <strong>${r.recLabel}</strong>${r.recText}
        </div>
      </div>
    `;
  }).join('');

  // Phase C: Structural Holes block removed. The hole detection still drives
  // the archetype label downgrade (Middle Tier override when 35%+ of starter
  // slots have major holes), but listing the players individually was noisy
  // without being actionable — they're already shown on the roster page in
  // their position group, with their values clearly visible.

  return `
    <div class="needs-panel">
      <div class="needs-panel-head">Positional Needs · vs the rest of your league</div>
      ${rowsHtml}
      <div class="team-archetype">
        <div class="archetype-pair">
          <span class="archetype-label">Team style</span>
          <span class="archetype-value" data-tooltip="${escapeHtml((typeof GLOSSARY !== 'undefined' && GLOSSARY[analysis.archetype]) || '')}">${analysis.archetype}</span>
        </div>
        <div class="archetype-pair">
          <span class="archetype-label">Starters rank</span>
          <span class="archetype-value">${analysis.starterValueRank || '-'}/${analysis.totalTeams}</span>
        </div>
        <div class="archetype-pair">
          <span class="archetype-label">Total value rank</span>
          <span class="archetype-value">${analysis.valueRank}/${analysis.totalTeams}</span>
        </div>
      </div>
    </div>
  `;
}

// ============================================================
// TRADE SUGGESTIONS
// Archetype-based — flags players on my roster that don't fit my build direction,
// and surfaces players on OTHER rosters that match what my build needs.
// ============================================================

function computeAllArchetypes(lg) {
  return TacoCore.computeAllArchetypes(lg);
}

const CONTENDER_ARCHETYPES = TacoCore.CONTENDER_ARCHETYPES || new Set(['Dynasty Core', 'Contender']);
const REBUILD_ARCHETYPES = TacoCore.REBUILD_ARCHETYPES || new Set(['Rebuild']);

function computeTradeAwaySuggestions(lg, myArchetype) {
  return TacoCore.computeTradeAwaySuggestions(lg, myArchetype);
}

function computeTradeTargetSuggestions(lg, myArchetype, allArchetypes) {
  return TacoCore.computeTradeTargetSuggestions(lg, myArchetype, allArchetypes);
}



;
/*! ==== 19-suggested-trades-full-two-sided-trade-proposals.js ==== */
// Trade suggestion panel — client + optional server proposals for team overview.

/** FAIR / FAVORS YOU / FAVORS THEM for a suggestion card.
 *
 * One implementation, used by both the single-league suggestions panel and the
 * cross-league Trade Finder, which each carried their own copy of this ternary.
 *
 * Judged on myEffective vs theirEffective -- the consolidation-aware numbers
 * (shared/trades.mjs) -- and on the trade calculator's own 5% fairness band, so
 * a trade cannot read FAIR on a suggestion card and "good for you" one click
 * later in the calculator. The old test was p.imbalance < 0.025: a different
 * quantity, on a different scale, that ignored the consolidation discount
 * entirely. */
/**
 * A proposal priced exactly as the Trade Calculator prices it once opened: the
 * calculator's own asset values (assetValueIn, 31) and its verdict
 * (shared/trade-verdict.mjs, tier premium + consolidation + 5% band).
 *
 * The proposal engine (shared/trades.mjs) searches with its own view -- your
 * picks marked down 28% if you are contending, a bare sum discounted at
 * n^-0.605 -- and that view used to decide the badge too. On 2026-09-27 a card
 * sending the 2027 1.01 + a 2028 2nd for 38-year-old Stafford read FAIR; the
 * calculator it opened said the other side won by 76.6%. The engine still
 * chooses what to look at; the numbers and the verdict on the card are now the
 * calculator's, so opening a card can never change its answer.
 */
const PROPOSAL_MAX_IMBALANCE = 0.16; // the engine's own suggestion band, now on the calculator's numbers
const proposalPoolMaxMemo = new WeakMap(); // composite object -> most valuable asset
function proposalCalc(p, lg) {
  if (!lg || !p || !p.theirAsset || typeof assetValueIn !== 'function' || !TacoCore.tradeVerdict) return null;
  const me = (lg.allRosters || []).find((r) => r.isMe);
  const ids = [me && me.rosterId, p.partnerRosterId];
  const mine = p.myAssets.map((a) => assetValueIn(a.id, lg, ids));
  const theirs = assetValueIn('P:' + p.theirAsset.playerId, lg, ids);
  if (!mine.length || mine.some((v) => !(v > 0)) || !(theirs > 0)) return null;
  // getValuePoolForTab rebuilds the whole pool on every call, and Trade Finder
  // prices ~90 cards: remember the top value per loaded composite object.
  const comp = STATE.backendComposite && STATE.backendComposite[lg.scoringTab];
  let poolMax = comp && typeof comp === 'object' ? proposalPoolMaxMemo.get(comp) : undefined;
  if (poolMax === undefined) {
    const pool = typeof getValuePoolForTab === 'function' ? getValuePoolForTab(lg.scoringTab) : [];
    poolMax = pool.reduce((m, x) => Math.max(m, x.value || 0), 0) || null;
    if (comp && typeof comp === 'object') proposalPoolMaxMemo.set(comp, poolMax);
  }
  poolMax = poolMax || undefined;
  const r = TacoCore.tradeVerdict(mine, [theirs], poolMax);
  const sum = r.aReceives.effective + r.bReceives.effective;
  return {
    mine,
    theirs,
    myTotal: mine.reduce((s, v) => s + v, 0),
    myEffective: r.bReceives.effective,     // what I give, as they receive it
    theirEffective: r.aReceives.effective,  // what I get
    verdict: r,
    imbalance: sum > 0 ? r.effectiveDiff / sum : 0,
  };
}
window.proposalCalc = proposalCalc;

/** Keep a proposal only if the calculator would also call it close. One that
 * cannot be priced (a value not loaded yet) is kept on the engine's word. */
function proposalWithinBand(p, lg) {
  const c = proposalCalc(p, lg);
  return !c || c.imbalance <= PROPOSAL_MAX_IMBALANCE;
}
window.proposalWithinBand = proposalWithinBand;

function tradeProposalBadge(p, lg) {
  const c = lg ? proposalCalc(p, lg) : null;
  if (c) {
    const r = c.verdict;
    if (r.fair) return '<span class="proposal-badge fair" data-tooltip="Within 5% in effective value - the same verdict the calculator gives">FAIR</span>';
    const pct = r.gapPct != null ? ' +' + Math.round(r.gapPct) + '%' : '';
    return r.winner === 'a'
      ? '<span class="proposal-badge favors-me" data-tooltip="You come out ahead by this much in effective value, as the calculator measures it">FAVORS YOU' + pct + '</span>'
      : '<span class="proposal-badge favors-them" data-tooltip="They come out ahead by this much in effective value, as the calculator measures it">FAVORS THEM' + pct + '</span>';
  }
  const mine = p.myEffective || 0;
  const theirs = p.theirEffective || 0;
  const sum = mine + theirs;
  if (sum <= 0 || Math.abs(mine - theirs) <= 0.05 * sum) {
    return '<span class="proposal-badge fair">FAIR</span>';
  }
  return mine > theirs
    ? '<span class="proposal-badge favors-them">FAVORS THEM</span>'
    : '<span class="proposal-badge favors-me">FAVORS YOU</span>';
}
window.tradeProposalBadge = tradeProposalBadge;

/** "Total: 9,721 (eff. 5,255)" -- effective is what the verdict judges on:
 * tier premium for stars, discount for extra pieces. */
function proposalTotalHtml(total, effective) {
  const eff = Number.isFinite(effective) && Math.round(effective) !== Math.round(total)
    ? ' <span class="proposal-eff" data-tooltip="Effective value: what the verdict judges on. Stars get a tier premium; a side with more pieces is discounted, because extra pieces are closer to throw-ins in real trades.">(eff. ' + Math.round(effective).toLocaleString() + ')</span>'
    : '';
  return 'Total: <strong>' + Math.round(total).toLocaleString() + '</strong>' + eff;
}
window.proposalTotalHtml = proposalTotalHtml;

function slimLeagueForTradeSuggestions(lg) {
  return {
    league_id: lg.league_id,
    name: lg.name,
    season: lg.season,
    scoringTab: lg.scoringTab,
    roster_positions: lg.roster_positions,
    scoring_settings: lg.scoring_settings,
    scoringFingerprint: lg.scoringFingerprint,
    total_rosters: lg.total_rosters,
    myPicks: lg.myPicks || [],
    allRosters: (lg.allRosters || []).map((r) => ({
      rosterId: r.rosterId,
      ownerId: r.ownerId,
      ownerName: r.ownerName,
      teamName: r.teamName,
      isMe: r.isMe,
      players: (r.players || []).map((p) => ({
        playerId: p.playerId,
        name: p.name,
        position: p.position,
        team: p.team,
        age: p.age,
        value: p.value,
        rookie: p.rookie,
        isActive: p.isActive !== false && !p.isIR && !p.isTaxi,
      })),
    })),
  };
}

function tradeSuggestionsCacheKey(lg) {
  const rosterSig = (lg.allRosters || [])
    .map((r) => `${r.rosterId}:${(r.players || []).length}`)
    .join('|');
  // Pick VALUES belong in the key, not just roster shape.
  //
  // Pick prices settle after the composite loads -- measured on a real load,
  // a 2028 late 1st reads 8,200 at t=3.5s and 4,541 at t=4.5s. The server
  // request fires in that window, and because the old key only covered roster
  // ids and player counts, the response computed from the pre-settle values
  // was cached forever. That is why Trade Finder showed 7,708 for a pick the
  // trade calculator priced correctly: not a different pricing philosophy,
  // just a stale snapshot that nothing could invalidate.
  const pickSig = (lg.myPicks || [])
    .map((p) => `${p.season}-${p.round}-${p.slot || p.bucket || ''}:${Math.round(p.value || 0)}`)
    .sort()
    .join('|');
  return `${lg.league_id}:${rosterSig}:${pickSig}`;
}

// Bound how many suggestion requests are in flight at once.
//
// Trade Finder asks for every league in one pass. Measured on 2026-09-12, a
// 30-league portfolio fired 30 simultaneous POSTs and took 31s to settle; the
// leaguemate with 209 leagues fires 209. Each one is a Worker invocation that
// runs the full builder (p99 CPU 427ms), so an unbounded fan-out is both a slow
// first paint and a burst indistinguishable from abuse at the edge -- which
// matters now that a rate limit sits in front of this endpoint.
//
// Six at a time keeps the pipe full without letting one person's page load
// resemble a denial-of-service. Total request count is unchanged; only their
// arrival rate is. Every league still loads, so there is no behaviour change
// beyond ordering, and results still land in place as each resolves.
const SUGGESTION_CONCURRENCY = 6;
let suggestionsInFlight = 0;
const suggestionSlotQueue = [];

function acquireSuggestionSlot() {
  if (suggestionsInFlight < SUGGESTION_CONCURRENCY) {
    suggestionsInFlight += 1;
    return Promise.resolve();
  }
  return new Promise((resolve) => { suggestionSlotQueue.push(resolve); });
}

function releaseSuggestionSlot() {
  // Hand the slot straight to the next waiter rather than decrementing and
  // re-incrementing, so the count can never drift above the cap.
  const next = suggestionSlotQueue.shift();
  if (next) { next(); return; }
  suggestionsInFlight -= 1;
}

async function refreshTradeSuggestionsFromServer(lg) {
  // Do not ship provisional pick prices to the server.
  //
  // The response is cached, and pick values only settle once the composite
  // loads (~1s after first paint). Requesting before then bakes a pre-settle
  // number into Trade Finder that nothing later corrects -- measured, a 2028
  // late 1st went out at 8,200 and came back 7,708 while every other surface
  // settled at 4,541.
  //
  // A bounded wait, not an early return: returning immediately would resolve
  // straight into the caller's re-render, which calls this again, which spins.
  // Six tries at 400ms, then proceed regardless so a format whose composite
  // never arrives still gets suggestions rather than none.
  if ((lg.myPicks || []).length && typeof compositePicksReady === 'function') {
    for (let i = 0; i < 6 && !compositePicksReady(lg.scoringTab); i += 1) {
      await new Promise((r) => setTimeout(r, 400));
    }
  }
  const key = tradeSuggestionsCacheKey(lg);
  const existing = STATE._tradeSuggestions?.[lg.league_id];
  if (existing?.key === key && (existing.data || existing.failed)) return existing;

  STATE._tradeSuggestions = STATE._tradeSuggestions || {};
  STATE._tradeSuggestions[lg.league_id] = { key, loading: true };

  // Gate only the network call, not the compositePicksReady wait above it --
  // queueing that wait would serialise 209 leagues behind each other's 2.4s
  // timeout instead of overlapping them.
  await acquireSuggestionSlot();
  try {
    const res = await fetch(BACKEND_URL + '/api/trades/suggestions', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ league: slimLeagueForTradeSuggestions(lg) }),
    });
    if (!res.ok) throw new Error(`trade suggestions ${res.status}`);
    const payload = await res.json();
    if (!payload?.ok) throw new Error('invalid trade suggestions payload');
    STATE._tradeSuggestions[lg.league_id] = { key, data: payload, source: 'server' };
  } catch (e) {
    console.warn('[trades] server suggestions failed, using client fallback', e.message);
    const pool = typeof getValuePoolForTab === 'function' ? getValuePoolForTab(lg.scoringTab) : [];
    const valuePoolMax = pool.length ? Math.max(...pool.map((p) => p.value || 0)) : 9999;
    const data = TacoCore.buildLeagueTradeSuggestions(lg, { valuePoolMax });
    STATE._tradeSuggestions[lg.league_id] = { key, data, source: 'client', failed: true };
  } finally {
    releaseSuggestionSlot();
  }

  return STATE._tradeSuggestions[lg.league_id];
}

function getTradeSuggestionsForLeague(lg, myArchetype) {
  const cached = STATE._tradeSuggestions?.[lg.league_id];
  if (cached?.data) return cached.data;

  if (!cached?.loading) {
    refreshTradeSuggestionsFromServer(lg).then(() => {
      if (STATE.teamDetailTab === 'trade') renderTeamDetail();
    });
  }

  const allArchetypes = computeAllArchetypes(lg);
  const archetype = myArchetype || archetypeForRoster(lg, lg.allRosters.find((r) => r.isMe));
  const pool = typeof getValuePoolForTab === 'function' ? getValuePoolForTab(lg.scoringTab) : [];
  const valuePoolMax = pool.length ? Math.max(...pool.map((p) => p.value || 0)) : 9999;
  if (typeof TacoCore.buildLeagueTradeSuggestions === 'function') {
    return TacoCore.buildLeagueTradeSuggestions(lg, { valuePoolMax });
  }
  return {
    myArchetype: archetype,
    allArchetypes,
    away: computeTradeAwaySuggestions(lg, archetype),
    targets: computeTradeTargetSuggestions(lg, archetype, allArchetypes),
    proposals: computeSuggestedTrades(lg, archetype, allArchetypes),
  };
}

function computeSuggestedTrades(lg, myArchetype, allArchetypes) {
  const pool = typeof getValuePoolForTab === 'function' ? getValuePoolForTab(lg.scoringTab) : [];
  const valuePoolMax = pool.length ? Math.max(...pool.map((p) => p.value || 0)) : 9999;
  if (typeof TacoCore.computeSuggestedTrades === 'function') {
    return TacoCore.computeSuggestedTrades(lg, myArchetype, allArchetypes, { valuePoolMax });
  }
  return [];
}

function impliedTradeHint(playerId, scoringTab) {
  if (!playerId || typeof lookupPlayerValue !== 'function') return '';
  const match = lookupPlayerValue(playerId, null, null, scoringTab);
  const ti = match?.trade_implied || match?.sources?.trade_implied;
  if (!ti?.value || !match?.value) return '';
  const n = ti.n_trades || 0;
  if (n < 2) return '';
  const delta = Math.round(((ti.value - match.value) / match.value) * 100);
  if (Math.abs(delta) < 8) return '';
  return `Trades imply ${Math.round(ti.value).toLocaleString()} (${delta > 0 ? '+' : ''}${delta}% vs consensus · ${n} trade${n === 1 ? '' : 's'})`;
}

function ownerNegotiationHint(leagueId, rosterId) {
  if (!STATE.tradeHistory) return '';
  const prof = buildOwnerProfile(leagueId, rosterId);
  if (!prof || prof.empty || prof.historyLoading) return '';
  if (prof.vsMeCount >= 2 && prof.vsMeTheirWins > prof.vsMeMyWins) {
    return `H2H: they've won ${prof.vsMeTheirWins} of ${prof.vsMeCount} with you - start lighter.`;
  }
  if (prof.raterTier && prof.raterTier.includes('Shrewd')) {
    return `${prof.raterTier} · ${prof.tradeCount} trades - lead with a tight package.`;
  }
  if (prof.raterTier && prof.raterTier.includes('Easy mark')) {
    return `${prof.raterTier} - room to ask for more than the minimum.`;
  }
  if (prof.losses > prof.wins + 1) {
    return `League pattern: ${prof.losses}L-${prof.wins}W on value - they often overpay.`;
  }
  return prof.activity ? `${prof.activity} · ${prof.style}` : '';
}

function groupNegotiationPacks(proposals) {
  const byTarget = new Map();
  for (const p of proposals) {
    const key = p.theirAsset?.playerId;
    if (!key) continue;
    if (!byTarget.has(key)) byTarget.set(key, []);
    byTarget.get(key).push(p);
  }
  const packs = [];
  for (const list of byTarget.values()) {
    list.sort((a, b) => (a.imbalance || 0) - (b.imbalance || 0));
    packs.push(list);
  }
  packs.sort((a, b) => (a[0]?.imbalance || 0) - (b[0]?.imbalance || 0));
  return packs.slice(0, 5);
}

function formatProposalPackage(p) {
  return p.myAssets.map((a) => {
    if (a.kind === 'pick') return a.name || 'Pick';
    return a.name || 'Player';
  }).join(' + ');
}

function renderNegotiationPacksHtml(packs, lg) {
  if (!packs.length) return '';
  const packLabels = ['A', 'B', 'C'];
  return packs.map((variants) => {
    const head = variants[0];
    const hint = ownerNegotiationHint(lg.league_id, head.partnerRosterId);
    const variantHtml = variants.slice(0, 3).map((p, i) => {
      const dataAttr = JSON.stringify({
        partnerRosterId: p.partnerRosterId,
        myAssets: p.myAssets.map((a) => a.id),
        theirAssets: [`P:${p.theirAsset.playerId}`],
      }).replace(/"/g, '&quot;');
      return (
        `<div class="negotiation-variant">` +
        `<div class="negotiation-variant-label">Pack ${packLabels[i] || i + 1}</div>` +
        `<div class="negotiation-variant-body">Send <strong>${escapeHtml(formatProposalPackage(p))}</strong> → get <strong>${escapeHtml(p.theirAsset.name)}</strong> · ${Math.round(p.myTotal).toLocaleString()} for ${Math.round(p.theirTotal).toLocaleString()}</div>` +
        `<button class="ghost small" style="margin-top:8px;" data-proposal="${dataAttr}" data-taco-proposal="${dataAttr}">Open in calculator →</button>` +
        `</div>`
      );
    }).join('');
    return (
      `<div class="negotiation-pack-card">` +
      `<div class="negotiation-pack-target">Target ${escapeHtml(head.theirAsset.name)} <span class="suggest-player-meta">from ${escapeHtml(head.partnerName)}</span></div>` +
      `${hint ? `<div class="negotiation-pack-hint">${escapeHtml(hint)}</div>` : ''}` +
      variantHtml +
      `</div>`
    );
  }).join('');
}

function renderTradeSuggestionsPanel(lg, myArchetype) {
  if (!STATE.tradeHistory && !STATE.tradeHistoryLoading && typeof fetchTradeHistory === 'function') {
    fetchTradeHistory().then(() => {
      if (STATE.teamDetailTab === 'trade') renderTeamDetail();
    }).catch(() => {});
  }

  const cachedEntry = STATE._tradeSuggestions?.[lg.league_id];
  const bundle = getTradeSuggestionsForLeague(lg, myArchetype);
  const archetype = bundle.myArchetype || myArchetype;
  const away = bundle.away || [];
  const targets = bundle.targets || [];
  const proposals = bundle.proposals || [];
  const sourceNote = cachedEntry?.source === 'server'
    ? ' · server-ranked with roster needs'
    : (cachedEntry?.loading ? ' · loading server suggestions…' : '');
  const negotiationPacks = groupNegotiationPacks(proposals);
  const packsHtml = renderNegotiationPacksHtml(negotiationPacks, lg);

  const awayHtml = away.length > 0 ? away.map(s => {
    if (s.kind === 'pick') {
      const p = s.asset;
      return `
        <div class="suggest-item">
          <div class="suggest-item-main">
            <span class="suggest-player-name">${escapeHtml(p.label)} <span class="suggest-pick-tag">PICK</span></span>
            <span class="suggest-player-meta">${escapeHtml(p.ownerNote || '')}${p.bucket && p.slot ? ' · ' + p.bucket : ''}</span>
          </div>
          <div class="suggest-item-value">${Math.round(p.value).toLocaleString()}</div>
          <div class="suggest-item-reason">${escapeHtml(s.reason)}</div>
        </div>
      `;
    }
    const p = s.asset;
    return `
      <div class="suggest-item ${p.playerId ? 'suggest-clickable' : ''}"
           ${p.playerId ? `data-taco-player="${escapeHtml(p.playerId)}"` : ''}>
        <div class="suggest-item-main">
          <span class="suggest-player-name">${escapeHtml(p.name)}</span>
          <span class="suggest-player-meta">${p.position} · ${p.team || 'FA'} · age ${p.age || '?'}</span>
        </div>
        <div class="suggest-item-value">${Math.round(p.value).toLocaleString()}</div>
        <div class="suggest-item-reason">${escapeHtml(s.reason)}</div>
      </div>
    `;
  }).join('') : `<div class="suggest-empty">No strong trade-away signals for a <strong>${myArchetype}</strong> roster.</div>`;

  const targetHtml = targets.length > 0 ? targets.map(s => {
    const implied = impliedTradeHint(s.player.playerId, lg.scoringTab);
    return `
    <div class="suggest-item ${s.player.playerId ? 'suggest-clickable' : ''}"
         ${s.player.playerId ? `data-taco-player="${escapeHtml(s.player.playerId)}"` : ''}>
      <div class="suggest-item-main">
        <span class="suggest-player-name">${escapeHtml(s.player.name)}</span>
        <span class="suggest-player-meta">${s.player.position} · ${s.player.team || 'FA'} · age ${s.player.age || '?'} · on ${escapeHtml(s.ownerName)} (${s.ownerArchetype})</span>
      </div>
      <div class="suggest-item-value">${Math.round(s.player.value).toLocaleString()}</div>
      <div class="suggest-item-reason">${escapeHtml(s.reason)}${implied ? `<div class="suggest-implied-hint">${escapeHtml(implied)}</div>` : ''}</div>
    </div>
  `;
  }).join('') : `<div class="suggest-empty">No clear targets for your team style in this league right now. Build a trade yourself in the calculator.</div>`;

  // Proposed trades section - concrete two-sided proposals
  const proposalsShown = proposals.filter((p) => proposalWithinBand(p, lg));
  const proposalsHtml = proposalsShown.length > 0 ? proposalsShown.map((p, _idx) => {
    const calc = proposalCalc(p, lg);
    // Build asset key arrays for the "Open in calculator" handler
    const myAssetKeys = p.myAssets.map(a => a.id);
    const theirAssetKey = `P:${p.theirAsset.playerId}`;

    const myAssetsLines = p.myAssets.map(a => {
      if (a.kind === 'pick') {
        return `<div class="proposal-asset"><span class="proposal-asset-name">${escapeHtml(a.name)} <span class="suggest-pick-tag">PICK</span></span><span class="proposal-asset-value">${Math.round(calc ? calc.mine[p.myAssets.indexOf(a)] : a.value).toLocaleString()}</span></div>`;
      }
      const pid = a.ref?.playerId;
      return `<div class="proposal-asset ${pid ? 'proposal-asset-clickable' : ''}"
                   ${pid ? `data-taco-player="${escapeHtml(pid)}"` : ''}>
        <span class="proposal-asset-name">${escapeHtml(a.name)} <span class="proposal-asset-meta">${a.ref.position} · age ${a.ref.age || '?'}</span></span>
        <span class="proposal-asset-value">${Math.round(calc ? calc.mine[p.myAssets.indexOf(a)] : a.value).toLocaleString()}</span>
      </div>`;
    }).join('');

    const theirP = p.theirAsset;
    const theirLine = `<div class="proposal-asset ${theirP.playerId ? 'proposal-asset-clickable' : ''}"
                            ${theirP.playerId ? `data-taco-player="${escapeHtml(theirP.playerId)}"` : ''}>
      <span class="proposal-asset-name">${escapeHtml(theirP.name)} <span class="proposal-asset-meta">${theirP.position} · age ${theirP.age || '?'}</span></span>
      <span class="proposal-asset-value">${Math.round(calc ? calc.theirs : theirP.value).toLocaleString()}</span>
    </div>`;

    const balanceBadge = tradeProposalBadge(p, lg);

    // Encode the trade setup for the button handler
    const dataAttr = JSON.stringify({
      partnerRosterId: p.partnerRosterId,
      myAssets: myAssetKeys,
      theirAssets: [theirAssetKey],
    }).replace(/"/g, '&quot;');

    return `
      <div class="proposal-card">
        <div class="proposal-head">
          <div>
            <div class="proposal-partner">Trade with <strong>${escapeHtml(p.partnerName)}</strong></div>
            <div class="proposal-partner-arch">${p.partnerArchetype}</div>
          </div>
          ${balanceBadge}
        </div>
        <div class="proposal-sides">
          <div class="proposal-side">
            <div class="proposal-side-label">You send</div>
            ${myAssetsLines}
            <div class="proposal-side-total">${proposalTotalHtml(calc ? calc.myTotal : p.myTotal, calc ? calc.myEffective : p.myEffective)}</div>
          </div>
          <div class="proposal-arrow">↔</div>
          <div class="proposal-side">
            <div class="proposal-side-label">You get</div>
            ${theirLine}
            <div class="proposal-side-total">${proposalTotalHtml(calc ? calc.theirs : p.theirTotal, calc ? calc.theirEffective : p.theirEffective)}</div>
          </div>
        </div>
        <div class="proposal-why">${escapeHtml(p.fitReason)}${(() => {
          const implied = impliedTradeHint(p.theirAsset.playerId, lg.scoringTab);
          return implied ? `<div class="suggest-implied-hint">${escapeHtml(implied)}</div>` : '';
        })()}</div>
        <div class="proposal-actions">
          <button class="ghost small" data-proposal="${dataAttr}" data-taco-proposal="${dataAttr}">Open in calculator →</button>
        </div>
      </div>
    `;
  }).join('') : `<div class="suggest-empty">No balanced trade proposals found. Either your trade-away assets don't match available targets, or the league doesn't have natural partners right now.</div>`;

  return `
    <div class="suggest-panel">
      <div class="suggest-panel-head">Trade Suggestions · based on <strong>${escapeHtml(archetype)}</strong><span class="suggest-source-note">${sourceNote}</span></div>
      <div class="suggest-grid">
        <div class="suggest-col">
          <div class="suggest-col-head">
            <span class="suggest-col-label">Consider Trading</span>
            <span class="suggest-col-hint">Pieces that don't fit your build</span>
          </div>
          ${awayHtml}
        </div>
        <div class="suggest-col">
          <div class="suggest-col-head">
            <span class="suggest-col-label">Consider Targeting</span>
            <span class="suggest-col-hint">Players on logical trade-partner rosters</span>
          </div>
          ${targetHtml}
        </div>
      </div>
      ${packsHtml ? `
      <div class="proposals-section">
        <div class="proposals-head">
          <span class="proposals-label">Negotiation packs</span>
          <span class="proposals-hint">Up to 3 counter-packages per target · owner tendencies from trade history</span>
        </div>
        ${packsHtml}
      </div>` : ''}
      <div class="proposals-section">
        <div class="proposals-head">
          <span class="proposals-label">Proposed Trades</span>
          <span class="proposals-hint">Concrete two-sided deals balanced within fairness band · tap to open in calculator</span>
        </div>
        ${proposalsHtml}
      </div>
    </div>
  `;
}

;
/*! ==== 20-proposed-starting-lineup.js ==== */
// Start/sit + proposed lineup panels (roster tab). Rookie helpers → 68.

// TACO-032: weekly matchup-aware start/sit. Sleeper's projections feed
// doesn't expose a season/week back in its own response, so we resolve
// "which week" from the real calendar instead. Deliberately rough (games
// don't kick off at a fixed UTC anchor every year) -- it only decides which
// week's projections to request, and computeStartSitMoves already falls
// back to value-only ranking whenever the requested week's projection
// coverage is too thin (e.g. the deep offseason, before Sleeper has
// published real numbers for the upcoming season), so an off-by-one week
// resolution degrades gracefully rather than showing wrong data.
function resolveNflWeekContext() {
  // Single source of truth in shared/nfl-week.mjs (bundled into TacoCore) --
  // the cron that writes weekly_projections/nfl_schedule resolves the same
  // (season, week) from the same code. When these drift, start/sit silently
  // finds no projections and falls back to value-only ranking.
  return TacoCore.resolveNflWeekContext();
}

async function loadWeeklyProjections() {
  if (!BACKEND_URL) return;
  const { season, week } = resolveNflWeekContext();
  if (STATE.weeklyProjections?.season === season && STATE.weeklyProjections?.week === week) return;
  try {
    const res = await fetch(`${BACKEND_URL}/api/projections?season=${season}&week=${week}`);
    if (!res.ok) throw new Error('HTTP ' + res.status);
    const data = await res.json();
    STATE.weeklyProjections = { season, week, projections: data.projections || {}, schedule: data.schedule || {} };
    const lg = STATE.leagues?.[STATE.currentTeamIdx];
    if (lg) rerenderStartSitPanel(lg);
    if (typeof lineupSweepDataLanded === 'function') lineupSweepDataLanded();
  } catch (e) {
    console.warn('[start-sit] weekly projections fetch failed', e.message);
  }
}
window.loadWeeklyProjections = loadWeeklyProjections;

function rerenderStartSitPanel(lg) {
  const roster = lg.allRosters?.find(r => r.isMe) || lg.allRosters?.[0];
  const el = document.getElementById('startSitPanel-' + lg.league_id);
  if (!el || !roster) return;
  el.outerHTML = renderStartSitPanel(lg, roster);
}

// Sleeper's feed is raw stat projections (rec, rush_yd, bonus_rec_te, ...),
// not a single points number -- score each player against THIS league's
// real scoring_settings (same computeFantasyPoints already used for real
// game logs, 75-stats-game-log.js) instead of a generic PPR number every
// league would otherwise get regardless of its actual rules.
// Scoring projections is the single most expensive thing the page does. On
// 2026-09-28 a CPU profile of Owen's 30-league load showed the page frozen for
// 8.4 seconds, 7.4 of them in computeFantasyPoints: every projected player in
// the NFL, every week, re-scored for every league, the moment the season
// projections landed (the team-style rework needs them). Every caller only
// ever reads players on a roster in that league, and most leagues share one
// scoring set. So: score rostered players only, and remember each stat line's
// points per scoring set, shared by every league that uses it.
const scoringKeyMemo = new WeakMap(); // scoring_settings object -> stable key
function scoringKeyOf(settings) {
  let k = scoringKeyMemo.get(settings);
  if (k === undefined) { k = JSON.stringify(settings); scoringKeyMemo.set(settings, k); }
  return k;
}
const fantasyPointsMemo = new WeakMap(); // stats object -> Map(scoring key -> points)
function memoFantasyPoints(stats, settings) {
  const key = scoringKeyOf(settings);
  let byScoring = fantasyPointsMemo.get(stats);
  if (!byScoring) { byScoring = new Map(); fantasyPointsMemo.set(stats, byScoring); }
  let v = byScoring.get(key);
  if (v === undefined) { v = computeFantasyPoints(stats, settings); byScoring.set(key, v); }
  return v;
}
window.memoFantasyPoints = memoFantasyPoints;

const rosteredIdsMemo = new WeakMap(); // lg.allRosters array -> Set of player ids
/** Every player on any roster in this league (both id spellings rosters use). */
function leagueRosteredIds(lg) {
  const rosters = lg.allRosters || [];
  let ids = rosteredIdsMemo.get(rosters);
  if (!ids) {
    ids = new Set();
    for (const r of rosters) for (const p of r.players || []) {
      if (p.playerId != null) ids.add(String(p.playerId));
      if (p.sleeperId != null) ids.add(String(p.sleeperId));
    }
    rosteredIdsMemo.set(rosters, ids);
  }
  return ids;
}
window.leagueRosteredIds = leagueRosteredIds;

const weekContextMemo = new WeakMap(); // weeklyProjections -> Map(league_id -> { rosters, ctx })
function currentWeekContext(lg) {
  const wp = STATE.weeklyProjections;
  if (!wp || !lg?.scoring_settings || typeof computeFantasyPoints !== 'function') return null;
  let perLeague = weekContextMemo.get(wp);
  if (!perLeague) { perLeague = new Map(); weekContextMemo.set(wp, perLeague); }
  const hit = perLeague.get(lg.league_id);
  if (hit && hit.rosters === lg.allRosters && hit.settings === lg.scoring_settings) return hit.ctx;
  const projections = {};
  for (const playerId of leagueRosteredIds(lg)) {
    const stats = wp.projections[playerId];
    if (stats) projections[playerId] = memoFantasyPoints(stats, lg.scoring_settings);
  }
  const ctx = { projections, schedule: wp.schedule };
  perLeague.set(lg.league_id, { rosters: lg.allRosters, settings: lg.scoring_settings, ctx });
  return ctx;
}

function renderStartSitPanel(lg, roster) {
  if (!roster || !lg || typeof TacoCore === 'undefined' || !TacoCore.computeStartSitMoves) return '';
  if (!STATE.weeklyProjections && typeof loadWeeklyProjections === 'function') loadWeeklyProjections();
  const result = TacoCore.computeStartSitMoves(lg, roster, buildProposedLineup, currentWeekContext(lg));
  const usePoints = result?.mode === 'points';
  const panelId = 'startSitPanel-' + lg.league_id;
  if (!result || (!result.moves?.length && !result.benchUpgrades?.length)) {
    return `
      <div class="section-card start-sit-panel" id="${panelId}">
        <div class="section-card-head">
          <div>
            <h3 class="section-card-title">Start / <em>sit</em></h3>
            <div class="section-card-sub">${usePoints ? 'This week’s projections match your current starters' : 'Value-optimal lineup matches your current starters'}</div>
          </div>
        </div>
      </div>
    `;
  }

  const formatDelta = (m) => usePoints ? `+${m.delta.toFixed(1)} pts` : `+${Math.round(m.delta).toLocaleString()}`;

  const moveRows = (result.moves || []).map((m) => {
    const sit = m.sit;
    const start = m.start;
    return `
      <div class="start-sit-row">
        <span class="start-sit-slot">${slotTypeLabel(m.slotType)}</span>
        <div class="start-sit-swap">
          <span class="start-sit-sit">${escapeHtml(sit.name)}</span>
          <span class="start-sit-arrow">→</span>
          <span class="start-sit-start">${escapeHtml(start.name)}</span>
        </div>
        <span class="start-sit-delta">${formatDelta(m)}</span>
        <span class="start-sit-reason">${escapeHtml(m.reason)}</span>
      </div>
    `;
  }).join('');

  const benchRows = (result.benchUpgrades || []).slice(0, 3).map((b) => `
    <div class="start-sit-bench">
      <span>${escapeHtml(b.player.name)}</span>
      <span class="start-sit-bench-val">${usePoints ? b.player.effectiveValue.toFixed(1) + ' pts' : Math.round(b.player.effectiveValue || b.player.value || 0).toLocaleString()}</span>
    </div>
  `).join('');

  return `
    <div class="section-card start-sit-panel" id="${panelId}">
      <div class="section-card-head">
        <div>
          <h3 class="section-card-title">Start / <em>sit</em></h3>
          <div class="section-card-sub">${usePoints ? `Week ${STATE.weeklyProjections.week} projected-points swaps vs your current lineup · matchup + injury-adjusted` : 'Value-based swaps vs your current lineup · injury-adjusted'}</div>
        </div>
      </div>
      ${moveRows ? `<div class="start-sit-moves">${moveRows}</div>` : ''}
      ${benchRows ? `
        <div class="start-sit-bench-block">
          <div class="start-sit-bench-label">Bench watch</div>
          ${benchRows}
        </div>
      ` : ''}
      ${usePoints ? `
        <div class="value-trust-footnote">
          Weekly projections and matchups via <strong>Sleeper</strong>, scored to your league's real rules.
        </div>
      ` : ''}
    </div>
  `;
}

function renderProposedLineup(lg, roster) {
  const lineup = buildProposedLineup(lg, roster);
  if (lineup.length === 0) return '';

  const lineupValue = lineup.reduce((s, slot) => s + (playerLeagueValue(slot.player, lg) || 0), 0);
  const lineupAges = lineup.filter(s => s.player?.age && s.player.age > 0).map(s => s.player.age);
  const lineupAvgAge = lineupAges.length ? (lineupAges.reduce((a, b) => a + b, 0) / lineupAges.length).toFixed(1) : '-';

  // Phase C3: position-aware startability check. If a player is filling a
  // slot but their value is below the league-relative threshold for that
  // position, flag the slot - even though they're starting (best option),
  // they're functionally a hole the user should plan to upgrade.
  const positionThresholds = (typeof getPositionStartableThresholds === 'function')
    ? getPositionStartableThresholds(lg.scoringTab)
    : null;
  let belowStartableCount = 0;

  const rowsHtml = lineup.map(slot => {
    if (!slot.player) {
      return `
        <div class="lineup-row empty">
          <span class="lineup-slot ${slot.slotType.toLowerCase()}">${slotTypeLabel(slot.slotType)}</span>
          <span class="lineup-player-name">- empty -</span>
          <span class="lineup-player-meta"></span>
          <span class="lineup-player-age"></span>
          <span class="lineup-player-value none">-</span>
        </div>
      `;
    }
    const p = slot.player;
    const isFlex = ['FLEX', 'REC_FLEX', 'WRRB_FLEX', 'SUPER_FLEX'].includes(slot.slotType);
    // Flat market value via playerLeagueValue -- must match what the Roster
    // tab shows for the same player (see 10-sleeper-api.js).
    const displayValue = playerLeagueValue(p, lg);
    const valueClass = displayValue > 6500 ? 'hi' : '';
    // Below-startable check: only meaningful for non-flex slots (flex is
    // by definition slotting whoever's best regardless of position).
    const threshold = positionThresholds ? (positionThresholds[p.position] || 0) : 0;
    const isBelowStartable = !isFlex && threshold > 0 && (p.value || 0) < threshold;
    if (isBelowStartable) belowStartableCount += 1;
    const flagBadge = isBelowStartable
      ? `<span class="lineup-flag" data-tooltip="Best option you have at this slot, but value sits below league-relative startable floor for ${p.position}. Plan to upgrade.">below startable</span>`
      : '';
    // Page 3: injury indicator on lineup rows. Same logic as renderPlayerRow.
    // Critical here because a hurt starter is exactly the actionable thing
    // the user comes to this page to see.
    const injuryBadge = (() => {
      const dbPlayer = STATE.playersDB?.[p.playerId];
      const status = dbPlayer?.injury_status || null;
      if (!status || status === 'Active' || status === 'Healthy') return '';
      const s = status.toLowerCase();
      let cls = 'injury-mark-other';
      if (s.includes('out')) cls = 'injury-mark-out';
      else if (s.includes('doubtful')) cls = 'injury-mark-doubtful';
      else if (s.includes('ir') || s.includes('reserve')) cls = 'injury-mark-ir';
      else if (s.includes('questionable')) cls = 'injury-mark-questionable';
      const bodyPart = dbPlayer?.injury_body_part ? ' · ' + dbPlayer.injury_body_part : '';
      const tooltip = escapeHtml(status + bodyPart);
      const short = status.slice(0, 3).toUpperCase();
      return `<span class="injury-mark ${cls}" data-tooltip="${tooltip}">${short}</span>`;
    })();
    return `
      <div class="lineup-row${isBelowStartable ? ' below-startable' : ''}">
        <span class="lineup-slot ${slot.slotType.toLowerCase()}">${slotTypeLabel(slot.slotType)}</span>
        <span class="lineup-player-name">${escapeHtml(p.name)}${isFlex ? ` <span class="lineup-true-pos">${p.position}</span>` : ''}${flagBadge}${injuryBadge}</span>
        <span class="lineup-player-meta">${p.team || 'FA'}${p.posRank ? ' · ' + p.posRank : ''}</span>
        <span class="lineup-player-age">${p.age ? p.age.toFixed(1) + 'y' : '-'}</span>
        <span class="lineup-player-value ${valueClass}">${displayValue ? Math.round(displayValue).toLocaleString() : '-'}</span>
      </div>
    `;
  }).join('');

  const subText = belowStartableCount > 0
    ? `${lineup.length} slots · <strong style="color:var(--warn)">${belowStartableCount} below startable</strong> · upgrade target${belowStartableCount === 1 ? '' : 's'}`
    : `${lineup.length} slots · ranked by trade value`;

  return `
    <div class="section-card lineup-panel">
      <div class="section-card-head">
        <div>
          <h3 class="section-card-title">Proposed <em>starting lineup</em></h3>
          <div class="section-card-sub">${subText}</div>
        </div>
        <div class="stat-grid" style="grid-template-columns: auto auto; gap: 24px;">
          <div class="stat-block">
            <div class="stat-block-num accent">${Math.round(lineupValue).toLocaleString()}</div>
            <div class="stat-block-label">Lineup value</div>
          </div>
          <div class="stat-block">
            <div class="stat-block-num">${lineupAvgAge}</div>
            <div class="stat-block-label">Avg age</div>
          </div>
        </div>
      </div>
      <div class="lineup-rows">
        ${rowsHtml}
      </div>
    </div>
  `;
}

;
/*! ==== 68-rookie-board-helpers.js ==== */
// Rookie value board + fit scoring — shared by draft room, waiver, picks tabs.

// ============================================================
// ROOKIE DRAFT SUGGESTIONS
// For each pick I own in an upcoming rookie draft, estimate what rookies
// will be available at that slot and recommend the best fit for my roster.
// ============================================================

// Get the rookie pool for this league's scoring tab, ranked by trade value.
// TEP adjustment is already applied by getValuePoolForTab, so the TE values
// here will reflect the league's TE premium if applicable. Excludes pick
// assets explicitly (never true today incidentally, since a pick entry
// never has p.rookie===true, but stated directly rather than relying on
// that side effect -- see getFullDraftBoard for why this matters).
function getRookieBoard(lg) {
  const players = getValuePoolForTab(lg.scoringTab);
  return players
    .filter(p => p.rookie && p.value > 0 && p.position !== 'PICK')
    .sort((a, b) => b.value - a.value);
}

// Same pool, no rookie filter -- for a startup/full draft's best-available
// board, where every undrafted PLAYER (rookie or established) is in play.
// The FC-sourced value pool includes pick assets (position 'PICK')
// alongside real players -- without this filter they'd show up as
// "draftable players" in a startup draft, which makes no sense.
function getFullDraftBoard(lg) {
  const players = getValuePoolForTab(lg.scoringTab);
  return players
    .filter(p => p.value > 0 && p.position !== 'PICK')
    .sort((a, b) => b.value - a.value);
}

// For a given pick, estimate the overall draft position (1-based) this pick will make.
// Uses round + slot. Slot is the pick within the round.
function pickOverallPosition(pick, numTeams) {
  if (!pick.slot || !pick.round) return null;
  return (pick.round - 1) * numTeams + pick.slot;
}

// Estimate which rookies are likely available at a given overall draft position.
// Assumes rookies are drafted roughly in order of KTC value, with some slippage
// (people sometimes reach for need, skip a risky prospect, etc.).
function rookiesLikelyAvailable(rookieBoard, overallPosition) {
  if (!overallPosition) return rookieBoard; // pick slot unknown — show the full board
  // Allow a slippage window: rookies ranked from (position - slippage) onward might still be there
  const slippage = 2; // 2 spots of slippage — someone may pass on a guy you think is gone
  const startIdx = Math.max(0, overallPosition - 1 - slippage);
  return rookieBoard.slice(startIdx);
}

// Fit score for a rookie given my roster's needs.
// Uses the existing needs analysis (positional ranks) to boost rookies at positions I'm weak at.
function rookieFitScore(rookie, needsAnalysis) {
  const pos = rookie.position;
  if (!needsAnalysis || !needsAnalysis.positions) return 1.0;
  const posNeed = needsAnalysis.positions.find(p => p.pos === pos);
  if (!posNeed) return 1.0;
  // posNeed.myRank vs totalTeams — lower myRank = better (rank 1 = best, N = worst)
  const relativeRank = posNeed.myRank / posNeed.totalTeams;
  // Fit multiplier: strong need → high multiplier, strong position → low multiplier
  if (relativeRank >= 0.75) return 1.35;  // bottom quartile — big need
  if (relativeRank >= 0.55) return 1.18;  // below average — moderate need
  if (relativeRank >= 0.35) return 1.05;  // slightly below — mild need
  if (relativeRank >= 0.2) return 0.95;   // slightly above average — stocked
  return 0.85;                            // top of league at this position — don't need
}
;
/*! ==== 21-rookie-tier-detection.js ==== */
// Tier breaks are detected algorithmically from gaps in our own values,
// cross-validated against DynastyProcess rank gaps. When our price and DP's
// ranking agree that two consecutive rookies have a meaningful gap, a tier
// ends. DP is the cross-check here, never the value.
//
// Why this hybrid: FC is the consensus anchor everywhere else in the app.
// DP is slower-moving expert consensus. When they BOTH show a break at the
// same point, it's a real tier boundary. When only one does, we use FC's
// value gap as the tiebreaker (FC drives the rest of the app's valuations).
//
// Output: array of tier objects, top tier first.
//   [{ tier: 1, rookies: [r1, r2, ...], minValue, maxValue }, ...]
function detectRookieTiers(rookieBoard) {
  if (!rookieBoard || rookieBoard.length === 0) return [];

  // Settings tuned for dynasty rookie classes — FC values for top rookies are
  // typically 8-9k, mid-tier 3-5k, late 1-2k. A 12% gap between consecutive
  // rookies usually marks a real tier change. DP rank gap of 3+ is a soft
  // confirm (DP can rank rookies at integer positions; gaps of 3 imply a
  // distinct cohort).
  const VALUE_GAP_THRESHOLD = 0.12;  // 12% gap of upper rookie's value
  const DP_RANK_GAP_CONFIRM = 3;

  const tiers = [];
  let currentTier = [];

  for (let i = 0; i < rookieBoard.length; i++) {
    const r = rookieBoard[i];
    currentTier.push(r);

    if (i === rookieBoard.length - 1) break;

    const next = rookieBoard[i + 1];
    const valueGap = (r.value - next.value) / r.value;

    // Pull DP ECR for both rookies (positional ECR is what DP exposes per position)
    const dp1 = STATE.dpLookup?.[r.sleeperId];
    const dp2 = STATE.dpLookup?.[next.sleeperId];
    const dpRankGap = (dp1?.ecrPos != null && dp2?.ecrPos != null)
      ? Math.abs((dp2.ecrPos || 0) - (dp1.ecrPos || 0))
      : null;

    // Tier break conditions:
    //   (a) FC value gap above threshold AND DP rank gap above confirm (strong)
    //   (b) FC value gap is large (>20%) on its own (FC fallback when DP missing)
    const fcStrong = valueGap >= VALUE_GAP_THRESHOLD;
    const dpConfirms = dpRankGap == null ? false : dpRankGap >= DP_RANK_GAP_CONFIRM;
    const fcOnlyOverride = valueGap >= 0.20;  // big gap, no need for DP confirm

    if ((fcStrong && dpConfirms) || fcOnlyOverride) {
      tiers.push({
        tier: tiers.length + 1,
        rookies: currentTier,
        minValue: currentTier[currentTier.length - 1].value,
        maxValue: currentTier[0].value,
      });
      currentTier = [];
    }
  }
  if (currentTier.length > 0) {
    tiers.push({
      tier: tiers.length + 1,
      rookies: currentTier,
      minValue: currentTier[currentTier.length - 1].value,
      maxValue: currentTier[0].value,
    });
  }
  return tiers;
}

// Find which tier a given pick value belongs in. Returns the tier object, or
// the closest tier if the value falls between tiers. Never returns null
// when tiers exist — even for picks worth more than the top tier or less
// than the bottom, we map to the nearest cohort.
function tierForPickValue(tiers, pickValue) {
  if (!tiers || tiers.length === 0) return null;
  // Direct hit: pick value falls within a tier's range.
  for (const t of tiers) {
    if (pickValue <= t.maxValue && pickValue >= t.minValue) return t;
  }
  // Otherwise: find nearest by midpoint distance.
  let best = tiers[0];
  let bestDist = Infinity;
  for (const t of tiers) {
    const mid = (t.minValue + t.maxValue) / 2;
    const dist = Math.abs(mid - pickValue);
    if (dist < bestDist) { bestDist = dist; best = t; }
  }
  return best;
}

;
/*! ==== 64-live-draft-bpa-board.js ==== */
// Live draft BPA board — exposure, server/client ranking, needs strip.

function getPlayerExposureCount(playerId) {
  if (!playerId || !STATE.leagues) return 0;
  let count = 0;
  for (const lg of STATE.leagues) {
    if ((lg.myPlayers || []).some((p) => p.playerId === playerId)) count++;
  }
  return count;
}

// Same "% exposure" metric as My Assets (pctExposure in
// 62-my-assets-results.js) -- percentage of YOUR tracked leagues where YOU
// own this player, not whether anyone else has rostered them.
function getPlayerOwnershipPct(playerId) {
  if (!playerId || !STATE.leagues?.length) return null;
  const ownedInCount = getPlayerExposureCount(playerId);
  return {
    ownedInCount,
    totalLeagues: STATE.leagues.length,
    pct: Math.round((ownedInCount / STATE.leagues.length) * 100),
  };
}

function getNflTeamExposure(nflTeam) {
  if (!nflTeam || nflTeam === 'FA' || !STATE.leagues) return 0;
  let count = 0;
  for (const lg of STATE.leagues) {
    for (const p of lg.myPlayers || []) {
      if (p.team === nflTeam) count++;
    }
  }
  return count;
}

function getCurrentSeasonDraft(lg) {
  const drafts = (lg.drafts || []).filter((d) => String(d.season) === String(STATE.season));
  if (!drafts.length) return null;
  const priority = { drafting: 0, paused: 1, pre_draft: 2, complete: 3 };
  drafts.sort((a, b) => (priority[a.status] ?? 9) - (priority[b.status] ?? 9));
  return drafts[0];
}

function buildDraftSessionForLeague(lg) {
  const draft = getCurrentSeasonDraft(lg) || { status: 'pre_draft', season: STATE.season };
  return { league: lg, draft, picks: [], draftMeta: null };
}

function discoverActiveDraftSessions() {
  const sessions = [];
  for (const lg of STATE.leagues || []) {
    for (const d of lg.drafts || []) {
      if (d.status === 'drafting' || d.status === 'paused') {
        sessions.push({ league: lg, draft: d, picks: [], draftMeta: null });
      }
    }
  }
  return sessions;
}

function draftRoomStatusLabel(status) {
  if (status === 'drafting') return { text: 'Live', cls: 'live' };
  if (status === 'paused') return { text: 'Paused', cls: 'live' };
  if (status === 'pre_draft') return { text: 'Pre-draft', cls: 'prep' };
  if (status === 'complete') return { text: 'Complete', cls: '' };
  return { text: 'Prep', cls: 'prep' };
}

async function refreshLiveDraftSession(session) {
  const draftId = session.draft.draft_id;
  if (!draftId) return session;
  try {
    const [picks, meta] = await Promise.all([
      api(`/draft/${draftId}/picks`).catch(() => []),
      api(`/draft/${draftId}`).catch(() => null),
    ]);
    session.picks = Array.isArray(picks) ? picks : [];
    session.draftMeta = meta || session.draft;
    // Time the clock while we are here. Sleeper puts no timestamp on a pick,
    // so the only way to know how long one took is to watch last_picked move
    // between two looks -- which this poll already does every 8 seconds.
    recordDraftClock(session);
  } catch (e) {
    console.warn('[live-draft] refresh failed', draftId, e.message);
  }
  return session;
}

// How long each manager sat on the clock.
//
// Sleeper does not timestamp picks (verified against a completed 336-pick
// draft, 2026-11-03: a pick carries no time field at all), so a draft that
// already happened can never be timed. What CAN be timed is a draft somebody
// is watching: the draft object's last_picked moves as picks land, and the
// gap between two observations is the pick in between.
//
// Kept in localStorage per draft so closing the tab does not throw away an
// evening of observations, and so a draft watched across two sittings adds up.
// Small: one entry per timed pick, a few numbers each.
const DRAFT_CLOCK_NS = 'draft_clock';

function loadDraftClock(draftId) {
  if (STATE.draftClocks[draftId]) return STATE.draftClocks[draftId];
  const stored = TacoStorage.getNamespaced(DRAFT_CLOCK_NS, draftId, null);
  if (stored) STATE.draftClocks[draftId] = stored;
  return STATE.draftClocks[draftId] || null;
}
window.loadDraftClock = loadDraftClock;

function recordDraftClock(session) {
  const draftId = session?.draft?.draft_id;
  if (!draftId || typeof TacoCore === 'undefined' || !TacoCore.observeDraft) return;
  const meta = session.draftMeta || session.draft || {};
  const status = meta.status;
  // Only a live draft can be observed. A completed one has a fixed
  // last_picked, so polling it would attribute the final gap forever.
  if (status !== 'drafting' && status !== 'paused') return;

  const next = TacoCore.observeDraft(loadDraftClock(draftId), {
    lastPicked: meta.last_picked,
    picks: session.picks || [],
    status,
    pickTimer: meta.settings?.pick_timer,
    now: Date.now(),
  });
  STATE.draftClocks[draftId] = next;
  TacoStorage.setNamespaced(DRAFT_CLOCK_NS, draftId, next);
}
window.recordDraftClock = recordDraftClock;

// A rookie-only draft runs short (typically 3-5 rounds); a startup/full
// draft runs 15-25+ rounds. Sleeper's real draft object (session.draftMeta,
// falling back to session.draft before the first live-session fetch
// resolves) carries the real round count -- use it instead of assuming
// every live draft is a rookie draft.
const MAX_ROOKIE_DRAFT_ROUNDS = 6;

function draftRounds(session) {
  return session.draftMeta?.settings?.rounds ?? session.draft?.settings?.rounds ?? null;
}

function isRookieDraftSession(session) {
  const rounds = draftRounds(session);
  return rounds == null ? true : rounds <= MAX_ROOKIE_DRAFT_ROUNDS;
}

function draftBoardCacheKey(lg, session, opts) {
  const drafted = (session.picks || []).map((p) => p.player_id).filter(Boolean).join(',');
  return `${lg.league_id}:${opts.posFilter || 'ALL'}:${opts.sortKey || 'need'}:${isRookieDraftSession(session)}:${drafted}`;
}

async function refreshDraftBoardFromServer(lg, session) {
  const posFilter = STATE.liveDraftPosFilter || 'ALL';
  const sortKey = STATE.liveDraftSortKey || 'need';
  const key = draftBoardCacheKey(lg, session, { posFilter, sortKey });
  if (STATE._draftBoardCache?.[lg.league_id]?.key === key) return;

  try {
    const res = await fetch(BACKEND_URL + '/api/draft/board', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        season: STATE.season,
        league: {
          league_id: lg.league_id,
          scoringTab: lg.scoringTab,
          roster_positions: lg.roster_positions,
          scoring_settings: lg.scoring_settings,
          scoringFingerprint: lg.scoringFingerprint,
          allRosters: (lg.allRosters || []).map((r) => ({
            rosterId: r.rosterId,
            isMe: r.isMe,
            players: (r.players || []).map((p) => ({
              playerId: p.playerId,
              position: p.position,
              value: p.value,
              isActive: p.isActive !== false && !p.isIR && !p.isTaxi,
              age: p.age,
            })),
          })),
        },
        draftedIds: (session.picks || []).map((p) => p.player_id).filter(Boolean),
        posFilter,
        sortKey,
        limit: 80,
        isRookieDraft: isRookieDraftSession(session),
        draftRounds: draftRounds(session),
      }),
    });
    if (!res.ok) throw new Error(`draft board ${res.status}`);
    const payload = await res.json();
    if (!payload?.ok) throw new Error('invalid draft board payload');
    STATE._draftBoardCache = STATE._draftBoardCache || {};
    STATE._draftBoardCache[lg.league_id] = { key, rows: payload.rows, needs: payload.needs, source: 'server' };
    renderLiveDraftRoom();
  } catch (e) {
    console.warn('[live-draft] server board failed, using client board', e.message);
  }
}

function computeLiveDraftBpa(lg, session, options) {
  const opts = options || {};
  const posFilter = opts.posFilter || STATE.liveDraftPosFilter || 'ALL';
  const sortKey = opts.sortKey || STATE.liveDraftSortKey || 'need';
  const limit = opts.limit || 80;

  const cacheKey = draftBoardCacheKey(lg, session, { posFilter, sortKey });
  const serverCache = STATE._draftBoardCache?.[lg.league_id];
  if (serverCache?.key === cacheKey && serverCache.rows?.length) {
    return {
      rows: serverCache.rows.slice(0, limit),
      needs: serverCache.needs || (TacoCore.computePositionNeeds ? TacoCore.computePositionNeeds(lg) : computeTeamNeeds(lg)),
    };
  }
  if (!STATE._draftBoardLoading?.[lg.league_id]) {
    STATE._draftBoardLoading = STATE._draftBoardLoading || {};
    STATE._draftBoardLoading[lg.league_id] = true;
    refreshDraftBoardFromServer(lg, session).finally(() => {
      STATE._draftBoardLoading[lg.league_id] = false;
    });
  }

  const drafted = new Set(
    (session.picks || []).map((p) => p.player_id).filter(Boolean)
  );
  // Was rookies-only unconditionally -- a startup draft needs every
  // undrafted player shown, not just rookies.
  const fullBoard = isRookieDraftSession(session) ? getRookieBoard(lg) : getFullDraftBoard(lg);
  let board = fullBoard.filter((r) => !drafted.has(r.sleeperId || r.playerId));
  if (posFilter !== 'ALL') {
    board = board.filter((r) => r.position === posFilter);
  }
  const valueRankById = {};
  fullBoard.forEach((r, i) => { valueRankById[r.sleeperId || r.playerId] = i + 1; });
  const needs = typeof TacoCore.computePositionNeeds === 'function'
    ? TacoCore.computePositionNeeds(lg)
    : computeTeamNeeds(lg);
  const adp = STATE.adpByPlayer || STATE.rookieAdp || {};
  const scored = board.map((rookie) => {
    const pid = rookie.sleeperId || rookie.playerId;
    const fit = rookieFitScore(rookie, needs);
    const exposure = getPlayerExposureCount(pid);
    const nflTeam = STATE.playersDB?.[pid]?.team || rookie.team || '';
    const teamExposure = getNflTeamExposure(nflTeam);
    const valueRank = valueRankById[pid] || 0;
    const adpEntry = adp[pid];
    const adpPick = adpEntry?.avgPick ?? null;
    let adpDelta = null;
    let adpLabel = '';
    if (adpPick != null) {
      adpDelta = Math.round(valueRank - adpPick);
      adpLabel = formatAdpAsPick(adpPick, lg.total_rosters);
    }
    const fitTag = TacoCore.fitTagForScore(fit);
    return {
      rookie,
      pid,
      score: (rookie.value || 0) * fit,
      fit,
      fitTag,
      exposure,
      teamExposure,
      nflTeam,
      valueRank,
      adpPick,
      adpDelta,
      adpLabel,
    };
  });

  if (sortKey === 'value') scored.sort((a, b) => (b.rookie.value || 0) - (a.rookie.value || 0));
  else if (sortKey === 'adp') scored.sort((a, b) => (a.adpPick ?? 9999) - (b.adpPick ?? 9999));
  else if (sortKey === 'name') scored.sort((a, b) => a.rookie.name.localeCompare(b.rookie.name));
  else if (sortKey === 'position') scored.sort((a, b) => a.rookie.position.localeCompare(b.rookie.position) || (b.rookie.value || 0) - (a.rookie.value || 0));
  else scored.sort((a, b) => b.score - a.score);

  return { rows: scored.slice(0, limit), needs };
}

function renderLiveDraftNeedsStrip(needs) {
  if (!needs?.positions?.length) return '';
  const POS_ORDER = ['QB', 'RB', 'WR', 'TE'];
  const chips = POS_ORDER.map((pos) => needs.positions.find((p) => p.pos === pos)).filter(Boolean)
    .map((r) => {
      const sev = r.tierClass === 'critical' || r.tierClass === 'bot' ? 'need-hot'
        : r.tierClass === 'mid' ? 'need-mid' : 'need-ok';
      return `<span class="live-draft-need-chip ${sev}" data-tooltip="Rank ${r.myRank}/${r.totalTeams} at ${r.pos}">${r.pos} ${r.myRank}/${r.totalTeams}</span>`;
    }).join('');
  return `<div class="live-draft-needs">${chips}</div>`;
}

;
/*! ==== 65-live-draft-league-panel.js ==== */
// Per-league draft room preview panel (team Picks tab).

function renderLeagueDraftRoomPanel(lg) {
  const currentSeason = parseInt(STATE.season, 10);
  const draft = getCurrentSeasonDraft(lg);
  const hasPicks = (lg.myPicks || []).some((p) => p.season === currentSeason);
  if (!draft && !hasPicks) return '';
  if (lg.rookieDraftComplete && draft?.status === 'complete') return '';

  const statusInfo = draftRoomStatusLabel(draft?.status || 'pre_draft');
  const session = buildDraftSessionForLeague(lg);
  const { rows: bpa } = computeLiveDraftBpa(lg, session, { limit: 5 });
  const isLive = draft?.status === 'drafting' || draft?.status === 'paused';
  const btnLabel = isLive ? 'Open live draft room' : 'Open draft room';

  const slotsHtml = (lg.myPicks || [])
    .filter((p) => p.season === currentSeason)
    .sort((a, b) => (a.round - b.round) || ((a.slot || 99) - (b.slot || 99)))
    .slice(0, 6)
    .map((p) => `<span class="draft-room-slot-chip">${escapeHtml(p.label)}</span>`)
    .join('');

  const previewHtml = bpa.map((row, i) => {
    const ownership = getPlayerOwnershipPct(row.pid);
    const ownershipPill = ownership
      ? `<span class="live-draft-warn exposure" data-tooltip="You own this player in ${ownership.ownedInCount} of your ${ownership.totalLeagues} tracked leagues">${ownership.ownedInCount}/${ownership.totalLeagues} leagues · ${ownership.pct}%</span>`
      : '';
    return (
      `<button type="button" class="draft-room-preview-row" data-ld-player="${escapeHtml(row.pid)}" >` +
      (typeof playerAvatarHtml === 'function' ? playerAvatarHtml(row.pid, row.rookie.name, row.rookie.position) : '') +
      `<div><div class="draft-room-preview-name">${i + 1}. ${escapeHtml(row.rookie.name)}</div>` +
      `<div class="draft-room-preview-meta">${escapeHtml(row.rookie.position)}${row.nflTeam ? ' · ' + (typeof teamLogoHtml === 'function' ? teamLogoHtml(row.nflTeam, 'ld-team-logo') : '') + escapeHtml(row.nflTeam) : ''}${row.adpLabel ? ' · ADP ' + escapeHtml(row.adpLabel) : ''}</div>` +
      `${ownershipPill}</div>` +
      `<span class="draft-room-preview-val">${Math.round(row.rookie.value || 0).toLocaleString()}</span>` +
      `</button>`
    );
  }).join('');

  return `
    <div class="draft-room-panel">
      <div class="draft-room-panel-head">
        <div>
          <div class="pick-sim-title">Draft room</div>
          <div class="pick-sim-sub">Need-weighted board, value vs ADP, cross-league exposure - ${isLive ? 'updates live' : 'prep until draft day'}</div>
        </div>
        <span class="draft-room-status ${statusInfo.cls}">${statusInfo.text}</span>
      </div>
      <div class="draft-room-preview">
        ${slotsHtml ? `<div><div class="draft-room-preview-label">Your picks</div><div class="draft-room-slots">${slotsHtml}</div></div>` : ''}
        <div class="draft-room-preview-label">Top available now</div>
        <div class="draft-room-preview-rows">${previewHtml || '<div class="tab-empty">Values still loading…</div>'}</div>
        <button type="button" class="draft-room-open-btn" data-ld-open-room="${escapeHtml(lg.league_id)}">${btnLabel} →</button>
      </div>
    </div>
  `;
}

;
/*! ==== 22-rookie-adp-aggregated-from-user-s-own-dynasty-ro.js ==== */
// Sleeper exposes /league/{id}/drafts → /draft/{id}/picks. We pull from every
// dynasty rookie draft in the user's leagues for the current season, both
// completed and in-progress (real-time-ish). Average pick number per rookie
// across drafts becomes the ADP signal.
//
// Why user-only drafts in v1: we don't have a backend crawler yet. Once the
// backend ships, ADP gets aggregated across crawled public dynasty leagues for
// real volume. v1 trade-off is honest: ADP is from drafts the user can see.

;
/*! ==== 23-rookie-adp-pulled-from-sleeper-s-public-values-e.js ==== */
// Sleeper publishes ADP data per league format at:
//   https://api.sleeper.com/players/nfl/values/{season_type}/{season}/{format}
// Format strings: '1qb' (standard) or '2qb' (superflex). Discovered from
// inspecting Sleeper app network requests during a live draft. Not officially
// documented but stable — used by Sleeper's own draft UI.
//
// Response shape: array of { player_id, adp_2qb (or adp_1qb), adp_ppr, ... }
// Aggregated across ALL Sleeper drafts (mock + real), so it's a real ADP
// signal, not just the user's own draft history.
async function computeRookieAdp(scoringTab) {
  // Cache key includes the format because SF and 1QB ADP differ significantly
  const format = (scoringTab && scoringTab.startsWith('SF')) ? '2qb' : '1qb';
  const cacheKey = `${STATE.season}:${format}`;

  if (STATE._rookieAdpCache && STATE._rookieAdpCache.key === cacheKey) {
    return STATE._rookieAdpCache.data;
  }
  if (STATE.rookieAdpLoading) return null;
  STATE.rookieAdpLoading = true;

  try {
    const res = await fetch(
      `${BACKEND_URL}/api/adp/${STATE.season}/${format}`,
      { headers: { Accept: 'application/json' } },
    );
    if (!res.ok) {
      console.warn(`[rookie-adp] Sleeper values endpoint returned ${res.status} via proxy`);
      STATE.rookieAdp = {};
      STATE.adpByPlayer = {};
      STATE._rookieAdpCache = { key: cacheKey, data: {} };
      return {};
    }
    const payload = await res.json();
    let arr = payload.rows || payload;
    if (!Array.isArray(arr)) {
      // Try common envelopes
      arr = payload.values || payload.data || payload.players;
    }
    if (!Array.isArray(arr) && arr && typeof arr.length === 'number') {
      // Array-like but not Array — coerce
      arr = Array.from(arr);
    }
    if (!Array.isArray(arr)) {
      console.warn('[rookie-adp] unexpected response shape:', typeof payload, payload && Object.keys(payload).slice(0, 5));
      STATE.rookieAdp = {};
      STATE.adpByPlayer = {};
      STATE._rookieAdpCache = { key: cacheKey, data: {} };
      return {};
    }
    // Sleeper returns rows like { player_id, adp_2qb, adp_1qb, adp_ppr, ... }
    // Pick the right ADP field for this format. Falls back to "adp" if the
    // format-specific field is missing.
    const adpField = `adp_${format}`;
    const rookieAdp = {};
    const allAdp = {};
    for (const row of arr) {
      if (!row.player_id) continue;
      const adpValue = row[adpField] ?? row.adp ?? null;
      if (adpValue == null) continue;
      const player = STATE.playersDB?.[row.player_id];
      if (!player) continue;
      // Store ADP for ALL players — used as a consensus signal for startability,
      // not just rookie draft suggestions. Veteran players going early (e.g.
      // Quinshon Judkins, Bucky Irving) signal community confidence that pure
      // value rankings sometimes underweight.
      allAdp[row.player_id] = { avgPick: adpValue };
      if (player.years_exp === 0) {
        rookieAdp[row.player_id] = { avgPick: adpValue };
      }
    }
    console.log(`[rookie-adp] loaded ${Object.keys(allAdp).length} total ADP entries, ${Object.keys(rookieAdp).length} rookies (${format})`);
    STATE.rookieAdp = rookieAdp;
    STATE.adpByPlayer = allAdp;
    STATE._rookieAdpCache = { key: cacheKey, data: rookieAdp };
    return rookieAdp;
  } catch (e) {
    console.warn('[rookie-adp] fetch failed:', e.message);
    STATE.rookieAdp = {};
    STATE.adpByPlayer = {};
    return {};
  } finally {
    STATE.rookieAdpLoading = false;
  }
}
window.computeRookieAdp = computeRookieAdp;

;
/*! ==== 48-team-waiver-panel-per-league-waiver-targets.js ==== */
// Per-league waiver / free-agent suggestions (team-detail Waivers tab).
// Extracted from live-draft-room (24).

const WAIVER_MIN_VALUE = 200;

function getWaiverNetAdds(playerId, sleeperAdds, sleeperDrops) {
  const adds = sleeperAdds ?? STATE.sleeperTrending?.[playerId]?.adds ?? 0;
  const drops = sleeperDrops ?? STATE.sleeperDropping?.[playerId]?.drops ?? 0;
  return adds - 0.8 * drops;
}

function buildLeagueWaiverRationale(c, lg, needsAnalysis) {
  const parts = [];
  if (c.netAdds > 100) {
    parts.push(`Sleeper hot (+${Math.round(c.netAdds).toLocaleString()} net adds, 24h)`);
  }
  if (c.trend > 200) {
    parts.push(`Value up +${Math.round(c.trend).toLocaleString()} (30d)`);
  } else if (c.momentum30d != null && c.momentum30d > 5) {
    parts.push(`Momentum +${c.momentum30d.toFixed(1)}% (30d)`);
  }
  const posNeed = needsAnalysis?.positions?.find(p => p.pos === c.position);
  if (c.fit >= 1.3 && posNeed) {
    parts.push(`Strong ${c.position} need - you rank ${posNeed.myRank}/${posNeed.totalTeams}`);
  } else if (c.fit >= 1.15 && posNeed) {
    parts.push(`Helps thin ${c.position} group (${posNeed.myRank}/${posNeed.totalTeams})`);
  } else if (c.fit < 1.0 && posNeed) {
    parts.push(`Good player but you're stacked at ${c.position} (${posNeed.myRank}/${posNeed.totalTeams})`);
  } else if (parts.length === 0) {
    parts.push('Best player available - depth / BPA pickup');
  }
  const fp = lg.scoringFingerprint || buildLeagueScoringFingerprint(lg);
  if ((fp.emphasis?.[c.position] || 0) >= 18) {
    parts.push(`${c.position} premium in this scoring format`);
  }
  return parts.join(' · ');
}

function computeWaiverSuggestions(lg, needsAnalysis) {
  if (!STATE.playersDB) return [];

  const rostered = new Set();
  for (const r of lg.allRosters) {
    for (const pid of r.playerIds) rostered.add(pid);
  }

  const scoringTab = lg.scoringTab;
  const source = STATE.valueSource[scoringTab];
  if (!source) return [];

  const candidates = [];
  for (const [pid, p] of Object.entries(STATE.playersDB)) {
    if (rostered.has(pid)) continue;
    const position = TacoCore.primaryFantasyPosition(p, undefined);
    if (!['QB', 'RB', 'WR', 'TE'].includes(position)) continue;
    if (!p.team) continue;
    if (p.status && p.status !== 'Active' && p.status !== 'Injured Reserve') continue;
    // team and status are not enough. Sleeper never retires a record: Ben
    // Roethlisberger, retired since 2022, still reads team PIT / status
    // Active / age 39, and this board recommended him as a waiver target.
    // news_updated is the field that actually knows -- his is 2022-01-27.
    if (TacoCore.isOutOfLeague({ lastNewsAt: p.news_updated })) continue;

    const fullName = (p.full_name || `${p.first_name || ''} ${p.last_name || ''}`).trim();
    const match = lookupPlayerValue(pid, fullName, position, scoringTab);
    if (!match || !match.value) continue;
    if (match.value < WAIVER_MIN_VALUE) continue;
    if (match.rookie || p.years_exp === 0) continue;

    const rawValue = match.value;
    const leagueValue = leagueTradeValue(rawValue, position, lg, pid);
    const trend = match.trend30Day || 0;
    const momentum30d = match.momentum30d ?? null;
    const netAdds = getWaiverNetAdds(pid);
    candidates.push({
      playerId: pid,
      name: fullName,
      position,
      team: p.team,
      age: p.age || null,
      yearsExp: p.years_exp,
      value: rawValue,
      leagueValue,
      posRank: match.posRank || '',
      status: p.status || 'Active',
      trend,
      momentum30d,
      netAdds,
    });
  }

  const scored = candidates.map(c => {
    const fit = rookieFitScore(c, needsAnalysis);
    // Ranking score intentionally uses the position-tilted value (accounts
    // for YOUR team's needs) -- the flat market value is what's shown on screen.
    const v = c.leagueValue || c.value;
    const hotBoost = c.netAdds > 100 ? Math.min(c.netAdds * 0.6, 5000) : (c.netAdds > 50 ? c.netAdds * 0.3 : 0);
    const trendBoost = c.trend > 200 ? Math.min(c.trend * 0.35, 2000)
      : (c.momentum30d != null && c.momentum30d > 5 ? c.momentum30d * 60 : 0);
    const rationale = buildLeagueWaiverRationale({ ...c, fit }, lg, needsAnalysis);
    return { ...c, fit, rationale, score: v * fit + hotBoost + trendBoost };
  });

  scored.sort((a, b) => b.score - a.score);
  return scored.slice(0, 12);
}

function renderWaiverPanel(lg, needsAnalysis) {
  const suggestions = computeWaiverSuggestions(lg, needsAnalysis);
  if (suggestions.length === 0) return '';

  const totalVal = suggestions.reduce((s, c) => s + (c.value || 0), 0);
  const avgVal = suggestions.length > 0 ? Math.round(totalVal / suggestions.length) : 0;
  const strongFitCount = suggestions.filter(c => c.fit >= 1.15).length;
  const fp = lg.scoringFingerprint || buildLeagueScoringFingerprint(lg);
  const topEmphasis = ['QB', 'RB', 'WR', 'TE']
    .map((p) => [p, fp.emphasis?.[p] || 0])
    .sort((a, b) => b[1] - a[1])[0];

  const rowsHtml = suggestions.map((c, idx) => {
    const badge = idx === 0 ? '<span class="waiver-badge">TOP TARGET</span>' : '';
    const hotTag = c.netAdds > 100 ? '<span class="waiver-signal waiver-signal-hot">Hot</span>' : '';
    const trendTag = (c.trend > 200 || (c.momentum30d != null && c.momentum30d > 5))
      ? '<span class="waiver-signal waiver-signal-trend">Trending</span>' : '';
    const irTag = c.status === 'Injured Reserve' ? '<span class="waiver-ir-tag">IR</span>' : '';
    return `
      <div class="waiver-row ${idx === 0 ? 'top' : ''}">
        <div class="waiver-rank mono">${idx + 1}</div>
        <div class="waiver-main">
          <div class="waiver-name">${escapeHtml(c.name)} ${badge}${hotTag}${trendTag} ${irTag}</div>
          <div class="waiver-meta">${c.position} · ${c.team} · ${c.posRank} · age ${c.age || '?'} · ${Math.round(c.value).toLocaleString()}</div>
          <div class="waiver-rationale">${escapeHtml(c.rationale)}</div>
        </div>
        <div class="waiver-value mono">${Math.round(c.value).toLocaleString()}</div>
      </div>
    `;
  }).join('');

  return `
    <div class="section-card waiver-panel">
      <div class="section-card-head">
        <div>
          <h3 class="section-card-title">Top waiver <em>targets</em></h3>
          <div class="section-card-sub">Ranked by value, roster fit, Sleeper activity, and 30d trend${topEmphasis?.[1] >= 18 ? ` · ${topEmphasis[0]} premium in this league` : ''}</div>
        </div>
      </div>
      <div class="stat-grid" style="margin-bottom: 14px;">
        <div class="stat-block">
          <div class="stat-block-num accent">${suggestions.length}</div>
          <div class="stat-block-label">Targets</div>
        </div>
        <div class="stat-block">
          <div class="stat-block-num">${Math.round(totalVal).toLocaleString()}</div>
          <div class="stat-block-label">Total value</div>
        </div>
        <div class="stat-block">
          <div class="stat-block-num">${avgVal.toLocaleString()}</div>
          <div class="stat-block-label">Avg value</div>
        </div>
        <div class="stat-block">
          <div class="stat-block-num">${strongFitCount}</div>
          <div class="stat-block-label">Strong fits</div>
        </div>
      </div>
      <div class="waiver-rows">
        ${rowsHtml}
      </div>
    </div>
  `;
}
;
/*! ==== 49-rookie-draft-panel-picks-and-draft-prep.js ==== */
// Rookie draft prep panel (team-detail Picks & Draft tab).
// Extracted from live-draft-room (24).

function computeRookieDraftSuggestions(lg, needsAnalysis) {
  const currentSeason = parseInt(lg.season);
  const relevantPicks = (lg.myPicks || [])
    .filter(p => p.season === currentSeason && p.value > 0)
    .sort((a, b) => (a.round - b.round) || ((a.slot || 99) - (b.slot || 99)));

  if (relevantPicks.length === 0) return null;

  const rookieBoard = getRookieBoard(lg);
  if (rookieBoard.length === 0) return null;

  const tiers = detectRookieTiers(rookieBoard);
  const adp = STATE.rookieAdp || {};

  const suggestions = [];
  for (const pick of relevantPicks) {
    const overall = pickOverallPosition(pick, lg.total_rosters);

    let candidates = [];
    if (overall != null) {
      const startIdx = Math.max(0, overall - 3);
      const endIdx = Math.min(rookieBoard.length, overall + 1);
      candidates = rookieBoard.slice(startIdx, endIdx);
    } else {
      const guessSlot = Math.max(1, Math.round(lg.total_rosters / 2));
      const guessOverall = (pick.round - 1) * lg.total_rosters + guessSlot;
      const startIdx = Math.max(0, guessOverall - 3);
      const endIdx = Math.min(rookieBoard.length, guessOverall + 1);
      candidates = rookieBoard.slice(startIdx, endIdx);
    }

    if (candidates.length < 3) {
      for (const r of rookieBoard) {
        if (candidates.length >= 3) break;
        if (!candidates.includes(r)) candidates.push(r);
      }
    }
    candidates = candidates.slice(0, 3);

    const topCandidate = candidates[0];
    let pickTier = null;
    if (topCandidate && tiers.length > 0) {
      pickTier = tiers.find(t => t.rookies.includes(topCandidate)) || null;
    }
    if (!pickTier) pickTier = tierForPickValue(tiers, pick.value || 0);

    const scored = candidates.map(rookie => {
      const fit = rookieFitScore(rookie, needsAnalysis);
      const valueGap = (rookie.value - (pick.value || 0));
      const valueGapPct = pick.value ? (valueGap / pick.value) * 100 : 0;
      const adpEntry = adp[rookie.sleeperId];
      return {
        rookie,
        fit,
        valueGap,
        valueGapPct,
        adpAvg: adpEntry?.avgPick ?? null,
        adpN: adpEntry?.n ?? 0,
        adpDraftCount: adpEntry?.draftCount ?? 0,
      };
    });

    suggestions.push({
      pick,
      overallPosition: overall,
      tier: pickTier ? pickTier.tier : null,
      tierRookieCount: pickTier ? pickTier.rookies.length : 0,
      topCandidates: scored,
    });
  }

  return { suggestions, rookieBoardSize: rookieBoard.length, tierCount: tiers.length };
}

function renderRookieDraftPanel(lg, needsAnalysis) {
  const result = computeRookieDraftSuggestions(lg, needsAnalysis);
  if (!result || result.suggestions.length === 0) return '';

  if (!STATE._rookieAdpCache && !STATE.rookieAdpLoading) {
    computeRookieAdp(lg.scoringTab).then(() => {
      // The rookie draft panel now lives on the merged League Overview, so
      // re-render whenever the current tab resolves to that combined view.
      const t = STATE.teamDetailTab;
      if (t === 'overview' || t === 'roster' || t === 'picks') {
        renderTeamDetail();
      }
    });
  }

  const { suggestions, tierCount } = result;

  const sectionsHtml = suggestions.map(s => {
    const { pick, overallPosition, tier, topCandidates } = s;
    const pickLabel = pick.label;
    const tierLabel = tier ? `Tier ${tier}` : 'Tier -';
    const pickMeta = overallPosition
      ? `overall #${overallPosition} · ${pick.bucket || 'Mid'} · ${Math.round(pick.value).toLocaleString()} FC · ${tierLabel}`
      : `slot TBD · ${Math.round(pick.value).toLocaleString()} FC · ${tierLabel}`;

    const candidatesHtml = topCandidates.map((c, idx) => {
      const r = c.rookie;
      const gapPct = c.valueGapPct;
      const gapBadge = Math.abs(gapPct) < 5
        ? `<span class="rookie-gap-badge gap-on">on value</span>`
        : gapPct > 0
          ? `<span class="rookie-gap-badge gap-up">+${Math.round(gapPct)}% value</span>`
          : `<span class="rookie-gap-badge gap-down">${Math.round(gapPct)}% value</span>`;
      let fitTag = null, fitTagClass = null, fitTooltip = null;
      if (c.fit >= 1.3) {
        fitTag = 'Need';
        fitTagClass = 'fit-need';
        fitTooltip = 'Strong positional need on your roster';
      } else if (c.fit >= 1.15) {
        fitTag = 'Depth';
        fitTagClass = 'fit-depth';
        fitTooltip = 'Fills a depth gap at this position';
      }
      const fitTagHtml = fitTag
        ? `<span class="rookie-fit-tag ${fitTagClass}" data-tooltip="${escapeHtml(fitTooltip)}">${fitTag}</span>`
        : '';
      return `
        <div class="rookie-row ${idx === 0 ? 'top' : ''} ${r.sleeperId ? 'rookie-row-clickable' : ''}"
             ${r.sleeperId ? `data-taco-player="${escapeHtml(r.sleeperId)}"` : ''}>
          <div class="rookie-rank mono">${idx + 1}</div>
          <div class="rookie-avatar${r.sleeperId ? '' : ' silhouette'}">
            ${r.sleeperId ? `<img src="https://sleepercdn.com/content/nfl/players/thumb/${escapeHtml(r.sleeperId)}.jpg" alt="" data-img-fallback="silhouette">` : ''}
          </div>
          <div class="rookie-main">
            <div class="rookie-name">${escapeHtml(r.name)} ${gapBadge}</div>
            <div class="rookie-meta">
              <span class="rookie-meta-pos">${r.position}</span>
              <span class="rookie-meta-team">${typeof teamLogoHtml === 'function' ? teamLogoHtml(r.team, 'rookie-team-logo') : ''}${r.team || 'FA'}</span>
              ${c.adpAvg != null ? `<span class="rookie-meta-adp">ADP ${formatAdpAsPick(c.adpAvg, lg.total_rosters)}</span>` : ''}
              ${fitTagHtml}
            </div>
          </div>
          <div class="rookie-value mono">${Math.round(r.value).toLocaleString()}</div>
        </div>
      `;
    }).join('');

    return `
      <div class="rookie-pick-block">
        <div class="rookie-pick-head">
          <div>
            <div class="rookie-pick-label">${pickLabel}</div>
            <div class="rookie-pick-meta mono">${pickMeta}</div>
          </div>
          ${!overallPosition ? '<span class="rookie-pick-tbd mono">Slot not set in Sleeper - priced at the round average</span>' : ''}
        </div>
        <div class="rookie-rows">
          ${candidatesHtml}
        </div>
      </div>
    `;
  }).join('');

  const methodologyNote = `Suggestions are rookies priced at or near your pick's overall draft position on our own value board. ADP is pulled live from Sleeper drafts, format by format. Tier breaks come from the gaps in that board.`;

  return `
    <div class="rookie-panel">
      <div class="rookie-panel-head">
        <div>
          <div class="rookie-panel-title">Rookie Draft · ${lg.season} Prep</div>
          <div class="rookie-panel-sub mono">3 candidates per pick · ${tierCount} tier${tierCount !== 1 ? 's' : ''} detected</div>
        </div>
      </div>
      ${sectionsHtml}
      <div class="rookie-panel-foot mono">
        ${methodologyNote}
      </div>
    </div>
  `;
}
;
/*! ==== 24-live-draft-room-in-draft-sidebar-bpa-value-vs-ad.js ==== */
// Live draft room shell — sidebar UI, polling, session refresh. BPA → 64; league panel → 65.

// Was a floating position:fixed overlay on EVERY page whenever a draft was
// active -- on mobile this covered up to 52% of the viewport with no way to
// permanently dismiss it (STATE.liveDraftCollapsed resets on reload), which
// is what made the whole site feel broken during a live draft. Fixed by
// docking this same shell into the dedicated Active Drafts page
// (draftsView/#draftsViewMount) whenever that page is open, and hiding it
// entirely on mobile everywhere else (app.css .live-draft-room:not(.docked)
// under the mobile media query) -- desktop keeps the original floating
// behavior since that wasn't reported as broken.
function syncLiveDraftRoomDocking() {
  const shell = document.getElementById('liveDraftRoom');
  const mount = document.getElementById('draftsViewMount');
  if (!shell || !mount) return;
  const onDraftsView = document.getElementById('draftsView')?.classList.contains('active');
  if (onDraftsView) {
    if (shell.parentElement !== mount) mount.appendChild(shell);
    shell.classList.add('docked');
    shell.classList.remove('collapsed'); // the dedicated page IS the expanded view -- no reason to collapse it
  } else if (shell.classList.contains('docked')) {
    document.body.appendChild(shell);
    shell.classList.remove('docked');
  }
}

function updateDraftsNavDot() {
  const isLive = (STATE.liveDraftSessions || []).some((s) => {
    const st = (s.draftMeta || s.draft)?.status;
    return st === 'drafting' || st === 'paused';
  });
  ['draftsNavDot', 'draftsNavDotMobile'].forEach((id) => {
    const dot = document.getElementById(id);
    if (dot) dot.hidden = !isLive;
  });
}

function renderDraftsView() {
  const empty = document.getElementById('draftsEmptyState');
  const sessions = STATE.liveDraftSessions || [];
  if (empty) empty.hidden = sessions.length > 0;
  renderLiveDraftRoom();
  if (typeof renderDraftRosterShape === 'function') renderDraftRosterShape();
  if (typeof renderDraftClock === 'function') renderDraftClock();
  if (typeof renderRookieOdds === 'function') renderRookieOdds();
}

function renderLiveDraftRoom() {
  const shell = document.getElementById('liveDraftRoom');
  const head = document.getElementById('liveDraftRoomHead');
  const body = document.getElementById('liveDraftRoomBody');
  const rail = document.getElementById('liveDraftRail');
  if (!shell || !head || !body) return;

  updateDraftsNavDot();
  syncLiveDraftRoomDocking();

  const sessions = STATE.liveDraftSessions || [];
  if (!sessions.length) {
    shell.style.display = 'none';
    shell.classList.remove('collapsed');
    // 2026-08-02 redesign: clear the reserve-space hook when no draft is active.
    document.body.classList.remove('has-live-draft', 'live-draft-collapsed');
    return;
  }

  shell.style.display = '';
  const collapsed = !shell.classList.contains('docked') && !!STATE.liveDraftCollapsed;
  shell.classList.toggle('collapsed', collapsed);
  // Reserve room for the floating panel so it never overlaps page content
  // (e.g. the Assets summary rail). Only when floating — docked (mobile) is
  // inline and needs no reserve. CSS keys off body.has-live-draft.
  const floating = !shell.classList.contains('docked');
  document.body.classList.toggle('has-live-draft', floating);
  document.body.classList.toggle('live-draft-collapsed', floating && collapsed);
  if (rail) {
    rail.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    rail.title = collapsed ? 'Open draft room' : 'Draft room open';
  }

  const idx = Math.min(STATE.liveDraftActiveIdx || 0, sessions.length - 1);
  const session = sessions[idx];
  const lg = session.league;
  const draft = session.draftMeta || session.draft;
  const picks = session.picks || [];
  const numTeams = lg.total_rosters || 12;
  const myRoster = lg.allRosters?.find((r) => r.isMe);
  const myRosterId = myRoster?.rosterId;

  const draftStatus = draft.status || 'pre_draft';
  const isLive = draftStatus === 'drafting' || draftStatus === 'paused';
  const statusInfo = draftRoomStatusLabel(draftStatus);
  const statusLabel = statusInfo.text;
  const pickCount = picks.length;
  const nextOverall = pickCount + 1;
  const nextRound = Math.ceil(nextOverall / numTeams);
  const nextSlot = nextOverall - (nextRound - 1) * numTeams;

  const myRecentPicks = picks
    .filter((p) => String(p.roster_id) === String(myRosterId))
    .slice(-3)
    .map((p) => {
      const pl = STATE.playersDB?.[p.player_id];
      const name = pl ? (pl.full_name || pl.first_name || 'Pick') : 'Pick';
      return `${p.round}.${String(p.draft_slot || p.pick_no || '?').toString().padStart(2, '0')} · ${name}`;
    });

  const myUpcomingSlots = (lg.myPicks || [])
    .filter((p) => p.season === parseInt(STATE.season, 10))
    .sort((a, b) => (a.round - b.round) || ((a.slot || 99) - (b.slot || 99)))
    .map((p) => `${p.label} · ${Math.round(p.value || 0).toLocaleString()}`);

  const { rows: bpa, needs } = computeLiveDraftBpa(lg, session);
  const posFilter = STATE.liveDraftPosFilter || 'ALL';
  const sortKey = STATE.liveDraftSortKey || 'need';

  const tabsHtml = sessions.length > 1
    ? `<div class="live-draft-tabs">${sessions.map((s, i) =>
        `<button type="button" class="live-draft-tab ${i === idx ? 'active' : ''}" data-ld-tab="${i}" title="${escapeHtml(s.league.name)}">${escapeHtml(s.league.name.length > 22 ? s.league.name.slice(0, 22) + '…' : s.league.name)}</button>`
      ).join('')}</div>`
    : '';

  const posFilters = ['ALL', 'QB', 'RB', 'WR', 'TE'];
  const sortOptions = [
    ['need', 'Need fit'],
    ['value', 'Value'],
    ['adp', 'ADP'],
    ['position', 'Position'],
    ['name', 'Name'],
  ];
  const toolbarHtml =
    `<div class="live-draft-toolbar">` +
    `<div class="live-draft-filter-row">${posFilters.map((p) =>
      `<button type="button" class="live-draft-filter-btn ${posFilter === p ? 'active' : ''}" data-ld-pos="${p}">${p}</button>`
    ).join('')}</div>` +
    `<select class="live-draft-sort" data-ld-sort aria-label="Sort board">` +
    sortOptions.map(([k, label]) =>
      `<option value="${k}" ${sortKey === k ? 'selected' : ''}>${label}</option>`
    ).join('') +
    `</select></div>`;

  const bpaHtml = bpa.map((row, i) => {
    const warns = [];
    const ownership = getPlayerOwnershipPct(row.pid);
    if (ownership) {
      warns.push(`<span class="live-draft-warn exposure" data-tooltip="You own this player in ${ownership.ownedInCount} of your ${ownership.totalLeagues} tracked leagues">${ownership.ownedInCount}/${ownership.totalLeagues} leagues · ${ownership.pct}%</span>`);
    }
    if (row.teamExposure >= 4 && row.nflTeam) warns.push(`<span class="live-draft-warn exposure">${row.nflTeam} stack</span>`);
    if (row.adpDelta != null && row.adpDelta <= -4) warns.push(`<span class="live-draft-warn steal">Value vs ADP</span>`);
    if (row.adpDelta != null && row.adpDelta >= 6) warns.push(`<span class="live-draft-warn reach">ADP reach</span>`);
    const adpBit = row.adpLabel ? ` · ADP ${row.adpLabel}` : '';
    const fitHtml = row.fitTag
      ? `<span class="live-draft-fit-tag ${row.fitTag.cls}">${row.fitTag.label}</span>`
      : '';
    return (
      `<button type="button" class="live-draft-bpa-row pos-${(row.rookie.position || '').toLowerCase()}" data-ld-player="${escapeHtml(row.pid)}">` +
      `<span class="live-draft-bpa-rank">${i + 1}</span>` +
      (typeof playerAvatarHtml === 'function' ? playerAvatarHtml(row.pid, row.rookie.name, row.rookie.position) : '') +
      `<div><div class="live-draft-bpa-name">${escapeHtml(row.rookie.name)} ${fitHtml}</div>` +
      `<div class="live-draft-bpa-meta">${escapeHtml(row.rookie.position)}${row.nflTeam ? ' · ' + (typeof teamLogoHtml === 'function' ? teamLogoHtml(row.nflTeam, 'ld-team-logo') : '') + escapeHtml(row.nflTeam) : ''}${adpBit}</div>` +
      `${warns.join('')}</div>` +
      `<span class="live-draft-bpa-val">${Math.round(row.rookie.value || 0).toLocaleString()}</span>` +
      `</button>`
    );
  }).join('') || '<div class="tab-empty">No rookies match this filter.</div>';

  let picksSectionHtml = '';
  if (isLive) {
    picksSectionHtml =
      `<div class="live-draft-section-label">Your recent picks</div>` +
      (myRecentPicks.length
        ? myRecentPicks.map((t) => `<div class="live-draft-pick-chip mine">${escapeHtml(t)}</div>`).join('')
        : `<div class="live-draft-pick-chip">On the board: ${nextRound}.${String(nextSlot).padStart(2, '0')} overall</div>`);
  } else if (myUpcomingSlots.length) {
    picksSectionHtml =
      `<div class="live-draft-section-label">Your ${STATE.season} picks</div>` +
      myUpcomingSlots.map((t) => `<div class="live-draft-pick-chip mine">${escapeHtml(t)}</div>`).join('');
  } else {
    picksSectionHtml =
      `<div class="live-draft-section-label">Draft board</div>` +
      `<div class="live-draft-pick-chip">Full rookie board · need-weighted ranking</div>`;
  }

  const statusMeta = isLive
    ? `${pickCount} picks made · ${nextRound}.${String(nextSlot).padStart(2, '0')} up`
    : draftStatus === 'complete'
      ? `${pickCount} picks recorded`
      : 'Opens live when Sleeper draft starts';

  // Minimize/open-league only make sense for the floating widget shown on
  // OTHER pages -- when docked (already the Active Drafts tab's own inline
  // content), both are dead weight: you can't "minimize" content that's
  // already the whole page, and you're already looking at this league.
  const actionsHtml = shell.classList.contains('docked') ? '' : (
    `<div class="live-draft-room-actions">` +
    `<button type="button" class="live-draft-room-btn" data-ld-toggle="1" data-tooltip="Minimize draft room" aria-label="Minimize draft room">▶</button>` +
    `<button type="button" class="live-draft-room-btn" data-ld-jump-league="${escapeHtml(lg.league_id)}" title="Open league">⌂</button>` +
    `</div>`
  );
  head.innerHTML =
    `<div><div class="live-draft-room-title">Draft room</div>` +
    `<div class="live-draft-room-sub">${escapeHtml(lg.name)} · ${escapeHtml(lg.scoringTab)}</div></div>` +
    actionsHtml;

  body.innerHTML =
    `<div class="live-draft-body-scroll">` +
    `<div class="live-draft-status">${isLive ? '<span class="live-draft-pulse"></span>' : ''}${statusLabel} · ${statusMeta}</div>` +
    tabsHtml +
    renderLiveDraftNeedsStrip(needs) +
    picksSectionHtml +
    `<div class="live-draft-section-label">Best available</div>` +
    toolbarHtml +
    `<div class="live-draft-bpa-list">${bpaHtml}</div>` +
    `</div>` +
    `<div class="live-draft-footnote">Ranked by roster need vs league · exposure warnings from your full portfolio</div>`;

  const railLabel = document.getElementById('liveDraftRailLabel');
  const railStatus = document.getElementById('liveDraftRailStatus');
  if (railLabel) {
    const shortName = lg.name.length > 14 ? lg.name.slice(0, 14) + '…' : lg.name;
    railLabel.textContent = collapsed ? shortName : 'Draft';
  }
  if (railStatus) {
    railStatus.className = 'live-draft-rail-status' + (isLive ? ' live' : '');
    railStatus.title = isLive ? 'Draft live' : statusLabel;
  }
}

async function refreshLiveDraftRoom() {
  let sessions = discoverActiveDraftSessions();
  const pinnedId = STATE.liveDraftPinnedLeagueId;
  if (pinnedId) {
    const lg = (STATE.leagues || []).find((l) => l.league_id === pinnedId);
    if (lg && !sessions.some((s) => s.league.league_id === pinnedId)) {
      sessions.push(buildDraftSessionForLeague(lg));
    }
  }
  if (!sessions.length) {
    STATE.liveDraftSessions = [];
    stopLiveDraftPolling();
    renderLiveDraftRoom();
    return;
  }
  sessions = await Promise.all(sessions.map((s) => refreshLiveDraftSession(s)));
  STATE.liveDraftSessions = sessions;
  if (STATE.liveDraftActiveIdx >= sessions.length) STATE.liveDraftActiveIdx = 0;
  const lg = sessions[STATE.liveDraftActiveIdx || 0]?.league;
  if (lg && !STATE._rookieAdpCache) {
    computeRookieAdp(lg.scoringTab).then(() => renderLiveDraftRoom());
  }
  const anyLive = sessions.some((s) => {
    const st = (s.draftMeta || s.draft)?.status;
    return st === 'drafting' || st === 'paused';
  });
  if (anyLive) startLiveDraftPolling();
  else stopLiveDraftPolling();
  renderLiveDraftRoom();
  if (typeof renderDraftRosterShape === 'function') renderDraftRosterShape();
  if (typeof renderDraftClock === 'function') renderDraftClock();
  if (typeof renderRookieOdds === 'function') renderRookieOdds();
}

function startLiveDraftPolling() {
  if (STATE.liveDraftPollTimer) return;
  STATE.liveDraftPollTimer = setInterval(() => {
    refreshLiveDraftRoom().catch((e) => console.warn('[live-draft] poll', e.message));
  }, 8000);
}

function stopLiveDraftPolling() {
  if (!STATE.liveDraftPollTimer) return;
  clearInterval(STATE.liveDraftPollTimer);
  STATE.liveDraftPollTimer = null;
}

async function initLiveDraftRoom() {
  await refreshLiveDraftRoom();
}

async function openLeagueDraftRoom(leagueId) {
  const lg = (STATE.leagues || []).find((l) => l.league_id === leagueId);
  if (!lg) return;
  STATE.liveDraftPinnedLeagueId = leagueId;
  STATE.liveDraftCollapsed = false;
  if (!STATE._rookieAdpCache && !STATE.rookieAdpLoading) {
    await computeRookieAdp(lg.scoringTab);
  }
  await refreshLiveDraftRoom();
  const idx = (STATE.liveDraftSessions || []).findIndex((s) => s.league.league_id === leagueId);
  if (idx >= 0) STATE.liveDraftActiveIdx = idx;
  renderLiveDraftRoom();
  if (typeof renderRookieOdds === 'function') renderRookieOdds();
  const shell = document.getElementById('liveDraftRoom');
  if (shell) scrollIntoViewSafely(shell, { behavior: 'smooth', block: 'nearest' });
}

function setLiveDraftTab(idx) {
  STATE.liveDraftActiveIdx = idx;
  renderLiveDraftRoom();
  if (typeof renderRookieOdds === 'function') renderRookieOdds();
}

function setLiveDraftPosFilter(pos) {
  STATE.liveDraftPosFilter = pos;
  renderLiveDraftRoom();
  if (typeof renderRookieOdds === 'function') renderRookieOdds();
}

function setLiveDraftSortKey(key) {
  STATE.liveDraftSortKey = key;
  renderLiveDraftRoom();
  if (typeof renderRookieOdds === 'function') renderRookieOdds();
}

function collapseLiveDraftRoom() {
  STATE.liveDraftCollapsed = true;
  renderLiveDraftRoom();
  if (typeof renderRookieOdds === 'function') renderRookieOdds();
}

function expandLiveDraftRoom() {
  STATE.liveDraftCollapsed = false;
  renderLiveDraftRoom();
  if (typeof renderRookieOdds === 'function') renderRookieOdds();
}

function toggleLiveDraftRoom() {
  STATE.liveDraftCollapsed = !STATE.liveDraftCollapsed;
  renderLiveDraftRoom();
  if (typeof renderRookieOdds === 'function') renderRookieOdds();
}

window.setLiveDraftTab = setLiveDraftTab;
window.setLiveDraftPosFilter = setLiveDraftPosFilter;
window.setLiveDraftSortKey = setLiveDraftSortKey;
window.collapseLiveDraftRoom = collapseLiveDraftRoom;
window.expandLiveDraftRoom = expandLiveDraftRoom;
window.toggleLiveDraftRoom = toggleLiveDraftRoom;
window.initLiveDraftRoom = initLiveDraftRoom;
window.openLeagueDraftRoom = openLeagueDraftRoom;

(function wireLiveDraftDelegation() {
  if (wireLiveDraftDelegation._wired) return;
  wireLiveDraftDelegation._wired = true;
  document.addEventListener('change', (e) => {
    if (e.target.matches?.('.live-draft-sort[data-ld-sort]')) {
      setLiveDraftSortKey(e.target.value);
    }
  });
  document.addEventListener('click', (e) => {
    const root = e.target.closest('#liveDraftRoom, .draft-room-panel');
    if (!root) return;
    const tab = e.target.closest('[data-ld-tab]');
    if (tab?.dataset.ldTab != null) {
      setLiveDraftTab(Number(tab.dataset.ldTab));
      return;
    }
    const pos = e.target.closest('[data-ld-pos]');
    if (pos?.dataset.ldPos) {
      setLiveDraftPosFilter(pos.dataset.ldPos);
      return;
    }
    const player = e.target.closest('[data-ld-player]');
    if (player?.dataset.ldPlayer) {
      openPlayerDrawer(player.dataset.ldPlayer);
      return;
    }
    const jump = e.target.closest('[data-ld-jump-league]');
    if (jump?.dataset.ldJumpLeague) {
      jumpToTeamByLeagueId(jump.dataset.ldJumpLeague);
      return;
    }
    const toggle = e.target.closest('[data-ld-toggle]');
    if (toggle) {
      toggleLiveDraftRoom();
      return;
    }
    const openRoom = e.target.closest('[data-ld-open-room]');
    if (openRoom?.dataset.ldOpenRoom) {
      openLeagueDraftRoom(openRoom.dataset.ldOpenRoom);
    }
  });
})();


// ============================================================
// Your roster, as the draft builds it (Owen, 2026-10-18: "active draft should
// mimic the draft by showing what your lineup looks like, along with the
// amount of bench spots. Then show where each person you drafted fits in so
// far along with where you drafted them.")
//
// The best-available board answers "who is left". This answers "what have I
// built" -- the question you are actually on the clock for. The shape comes
// from shared/draft-roster.mjs, which fills offensive slots through the same
// tested rule as Lineup Sweep, so the two cannot disagree about one roster.
// ============================================================
function draftRosterShapeHtml(session) {
  if (!session || !window.TacoCore || typeof TacoCore.buildDraftRosterShape !== 'function') return '';
  const lg = session.league;
  const picks = session.picks || [];
  const myRosterId = lg?.allRosters?.find((r) => r.isMe)?.rosterId;
  if (!lg || myRosterId == null) return '';

  // My picks, oldest first, each carrying where it was taken.
  const mine = picks
    .filter((p) => String(p.roster_id) === String(myRosterId))
    .map((p) => {
      const db = STATE.playersDB?.[p.player_id] || null;
      const name = db
        ? (db.full_name || [db.first_name, db.last_name].filter(Boolean).join(' ') || 'Pick')
        : 'Pick';
      const position = db ? (TacoCore.primaryFantasyPosition ? TacoCore.primaryFantasyPosition(db) : db.position) : '';
      const slot = p.draft_slot || p.pick_no;
      return {
        playerId: String(p.player_id),
        name,
        position: position || '',
        team: db?.team || '',
        pickLabel: p.round && slot ? `${p.round}.${String(slot).padStart(2, '0')}` : '',
      };
    });

  const shape = TacoCore.buildDraftRosterShape({
    rosterPositions: lg.roster_positions || [],
    players: mine,
  });
  if (!shape.starters.length) return '';

  const label = (t) => (TacoCore.draftSlotLabel ? TacoCore.draftSlotLabel(t) : t);
  const posCls = (pos) => 'pos-' + String(pos || '').toLowerCase();

  const slotRow = (s) => {
    const open = !s.player;
    const accepts = open && TacoCore.draftSlotAccepts
      ? TacoCore.draftSlotAccepts(s.slotType).join(' / ')
      : '';
    return '<div class="drs-row' + (open ? ' open' : '') + '">' +
      '<span class="drs-slot ' + posCls(s.slotType) + '">' + escapeHtml(label(s.slotType)) + '</span>' +
      (open
        ? '<span class="drs-open">Still need ' + escapeHtml(accepts) + '</span>'
        : '<span class="drs-who">' +
            (typeof playerAvatarHtml === 'function' ? playerAvatarHtml(s.player.playerId, s.player.name, s.player.position) : '') +
            '<span class="drs-txt"><b>' + escapeHtml(s.player.name) + '</b>' +
            '<i>' + escapeHtml([s.player.position, s.player.team].filter(Boolean).join(' · ')) + '</i></span></span>' +
          (s.player.pickLabel ? '<span class="drs-pick">' + escapeHtml(s.player.pickLabel) + '</span>' : '')) +
      '</div>';
  };

  const benchHtml = shape.benchSlots
    ? '<div class="drs-bench">' +
      '<div class="drs-bench-head">Bench <b>' + shape.bench.length + '</b> of ' + shape.benchSlots +
      (shape.reserveSlots ? ' <span class="drs-reserve">+ ' + shape.reserveSlots + ' IR/taxi</span>' : '') + '</div>' +
      (shape.bench.length
        ? '<div class="drs-bench-list">' + shape.bench.map((b) =>
          '<span class="drs-chip"><b>' + escapeHtml(b.name) + '</b>' +
          (b.pickLabel ? '<i>' + escapeHtml(b.pickLabel) + '</i>' : '') + '</span>').join('') + '</div>'
        : '<div class="drs-bench-empty">Nothing on the bench yet.</div>') +
      '</div>'
    : '';

  const needLine = shape.needs.length
    ? shape.needs.length + ' starting spot' + (shape.needs.length === 1 ? '' : 's') + ' still open'
    : 'Starting lineup complete';

  return '<section class="drs-panel">' +
    '<div class="drs-head">' +
    '<h3 class="section-card-title">Your roster <em>so far</em></h3>' +
    '<div class="drs-sub">' + escapeHtml(lg.name) + ' · ' + shape.filled + ' of ' + shape.starters.length +
    ' starters · ' + escapeHtml(needLine) + '</div>' +
    '</div>' +
    '<div class="drs-lineup">' + shape.starters.map(slotRow).join('') + '</div>' +
    benchHtml +
    '</section>';
}
window.draftRosterShapeHtml = draftRosterShapeHtml;

/** Mount it on the Active Drafts page, under the draft room. */
/** Who is on the clock, and how long everyone has been taking.
 *
 * Owen asked for this off a competitor: "it was either this site or another
 * that actually showed how long people sit on the clock during an active
 * draft."
 *
 * The limit is structural and stated on the panel rather than glossed:
 * Sleeper puts NO timestamp on a pick, so the only way to time one is to
 * watch last_picked move between two looks. Picks made before this page was
 * open cannot be recovered, and never will be. What is here was measured.
 */
function draftClockHtml(session) {
  if (!session || typeof TacoCore === 'undefined' || !TacoCore.clockSummary) return '';
  const draftId = session.draft?.draft_id;
  if (!draftId) return '';
  const meta = session.draftMeta || session.draft || {};
  const status = meta.status;
  const live = status === 'drafting' || status === 'paused';
  const rec = (typeof loadDraftClock === 'function' ? loadDraftClock(draftId) : null)
    || STATE.draftClocks[draftId];
  const summary = TacoCore.clockSummary(rec);
  if (!live && !summary.timedPicks) return '';

  const fmt = TacoCore.formatClock;
  const nameFor = (ownerId, rosterId) => {
    const rosters = session.league?.allRosters || [];
    const r = rosters.find((x) => (ownerId && String(x.ownerId) === String(ownerId))
      || (rosterId && String(x.rosterId) === String(rosterId)));
    return r ? (r.teamName || r.ownerName || 'Unknown') : 'Unknown';
  };

  // On the clock right now.
  let nowHtml = '';
  if (status === 'drafting') {
    // Always off the LIVE draft object, never the stored record. The record's
    // lastPicked is whatever the last observation saw, and a record restored
    // from localStorage at the start of a session is behind the draft until
    // the next poll -- which would show a clock minutes out of date, or a
    // negative one. The freshest fetch is the only honest source for a
    // running timer.
    const t = TacoCore.timeOnClock({
      lastPicked: meta.last_picked,
      pickTimer: meta.settings?.pick_timer || rec?.pickTimer,
    }, Date.now());
    if (t) {
      // Whose turn it is: the next slot after the last pick made.
      const picks = session.picks || [];
      const next = picks.length + 1;
      const order = meta.draft_order || null;
      const slotCount = meta.settings?.teams || (session.league?.allRosters || []).length || 12;
      const round = Math.floor((next - 1) / slotCount) + 1;
      const inRound = ((next - 1) % slotCount) + 1;
      const snakeBack = meta.type === 'snake' && round % 2 === 0;
      const slot = snakeBack ? (slotCount - inRound + 1) : inRound;
      let who = 'Next pick';
      if (order) {
        const uid = Object.keys(order).find((k) => Number(order[k]) === slot);
        if (uid) who = nameFor(uid, null);
      }
      nowHtml = '<div class="dc-now' + (t.overtime ? ' dc-over' : '') + '">' +
        '<div class="dc-now-head"><span class="dc-now-who">' + escapeHtml(who) + '</span>' +
        '<span class="dc-now-time">' + escapeHtml(fmt(t.ms)) + (t.overtime ? ' · over' : '') + '</span></div>' +
        (t.pct != null ? '<div class="dc-bar"><span style="width:' + Math.min(100, t.pct) + '%"></span></div>' : '') +
        '<div class="dc-now-sub">on the clock' + (summary.pickTimer ? ' · ' + summary.pickTimer + 's timer' : '') + '</div>' +
        '</div>';
    }
  } else if (status === 'paused') {
    nowHtml = '<div class="dc-now"><div class="dc-now-head"><span class="dc-now-who">Draft paused</span></div>' +
      '<div class="dc-now-sub">nothing is being timed while it is paused</div></div>';
  }

  const rows = TacoCore.clockByManager(rec, { nameFor });
  const table = rows.length
    ? '<div class="dc-rows">' + rows.map((r) =>
      '<div class="dc-row">' +
      '<span class="dc-name">' + escapeHtml(r.name || 'Unknown') + '</span>' +
      '<span class="dc-med">' + escapeHtml(fmt(r.medianMs)) + '</span>' +
      '<span class="dc-sub">' + r.picks + ' pick' + (r.picks === 1 ? '' : 's') +
      (r.timedPicks !== r.picks ? ' (' + r.timedPicks + ' timed)' : '') +
      ' · slowest ' + escapeHtml(fmt(r.slowestMs)) +
      (r.expired ? ' · <b class="dc-expired">ran out ' + r.expired + 'x</b>' : '') +
      '</span></div>').join('') + '</div>'
    : '<div class="dc-empty">No picks timed yet. Leave this open and they will fill in.</div>';

  return '<section class="dc-panel">' +
    '<div class="dc-head"><span class="dc-title">On the clock</span>' +
    (summary.timedPicks
      ? '<span class="dc-med-all">median ' + escapeHtml(fmt(summary.medianMs)) + '</span>'
      : '') + '</div>' +
    nowHtml +
    (rows.length ? '<div class="dc-rows-head"><span>Manager</span><span>Median</span><span></span></div>' : '') +
    table +
    '<p class="inv-note">' + escapeHtml(TacoCore.clockScopeNote(summary)) + '</p>' +
    '</section>';
}
window.draftClockHtml = draftClockHtml;

function renderDraftClock() {
  const mount = document.getElementById('draftClockMount');
  if (!mount) return;
  const sessions = STATE.liveDraftSessions || [];
  if (!sessions.length) { mount.innerHTML = ''; return; }
  const idx = Math.min(STATE.liveDraftActiveIdx || 0, sessions.length - 1);
  mount.innerHTML = draftClockHtml(sessions[idx]);
}
window.renderDraftClock = renderDraftClock;

function renderDraftRosterShape() {
  const mount = document.getElementById('draftRosterShapeMount');
  if (!mount) return;
  const sessions = STATE.liveDraftSessions || [];
  if (!sessions.length) { mount.innerHTML = ''; return; }
  const idx = Math.min(STATE.liveDraftActiveIdx || 0, sessions.length - 1);
  mount.innerHTML = draftRosterShapeHtml(sessions[idx]);
}
window.renderDraftRosterShape = renderDraftRosterShape;

;
/*! ==== 25-power-rankings-rank-all-teams-within-a-single-le.js ==== */
﻿// Combines the strategic overview (rank + archetype + strength/weakness +
// vs-you) with the tactical roster detail (per-position heatmap grid).
// Each row is expandable: collapsed shows the ranking summary; expanded
// reveals the team's full position-by-position roster with the same coloring
// the legacy "All Teams" view used. One unified surface for evaluating the
// league.
function renderPowerRankingsPanel(lg) {
  if (!lg.allRosters || lg.allRosters.length === 0) {
    return '<div class="tab-empty">No roster data available for this league.</div>';
  }

  // Rank on the roster alone, or on the roster plus draft capital.
  //
  // These answer different questions and a contender needs the first one. A
  // team stacking future firsts can out-total a team that is better on the
  // field right now, which is the correct read for a rebuild and the wrong one
  // when you are deciding whether you can win this year. Picks were always
  // counted and there was no way to take them out.
  //
  // Everything downstream -- the sort, the header stats, the row value, the
  // vs-you delta, the starters percentage, the share snapshot -- reads
  // totalValue, so switching what totalValue means switches the whole board.
  const includePicks = STATE.powerRankingsIncludePicks !== false;

  // Build per-roster summary: total value, starters value, position group totals.
  const summaries = lg.allRosters.map(r => {
    // playersValue counts IR and taxi now (TacoCore.rosterPlayersValue), so
    // "Roster only" here is the same number Team Detail calls Team Value and
    // "Roster + picks" is the same number the Portfolio card calls Team. It
    // used to be active-only, which made this board disagree with both of them
    // about the same roster by the value of the IR stash.
    //
    // startersValue / benchValue / activeCount stay active-only on purpose:
    // they describe who plays this week, not what the team is worth, and the
    // starters percentage on each row is exactly that distinction.
    const playersValue = TacoCore.rosterPlayersValue(r.players);
    let startersValue = 0;
    let benchValue = 0;
    let activeCount = 0;
    for (const p of r.players) {
      const v = p.value || 0;
      if (!p.isIR && !p.isTaxi) {
        activeCount++;
        if (p.isStarter) startersValue += v;
        else benchValue += v;
      }
    }
    // Team value = active players, plus draft capital when the board is
    // counting it. Picks were previously tracked only as a separate column, so
    // team totals never moved with pick values.
    const picksValue = TacoCore.rosterPicksValue(lg, r.rosterId);
    return {
      roster: r,
      totalValue: playersValue + (includePicks ? picksValue : 0),
      playersValue,
      startersValue,
      benchValue,
      picksValue,
      activeCount,
      archetype: archetypeForRoster(lg, r),
    };
  });

  const playoffByRoster = {};
  if (typeof TacoCore !== 'undefined' && TacoCore.computePlayoffPicture) {
    for (const row of TacoCore.computePlayoffPicture(lg)) {
      playoffByRoster[row.rosterId] = row;
    }
  }

  // Sort descending by total value
  summaries.sort((a, b) => b.totalValue - a.totalValue);

  // Compute positional terciles (shared with the position grid renderer for
  // consistent strong/weak coloring)
  const sortedRosters = summaries.map(s => s.roster);
  const positionalTerciles = computePositionalTerciles(sortedRosters, lg.roster_positions, lg.scoringTab);

  // Per-team positional summaries (top-N starters value at each position)
  // and total picks value, used both for league-mean comparison and to compute
  // each team's RANK within the league at every dimension.
  const posTotalsByTeam = summaries.map(s => {
    const ps = computePositionalSummary(s.roster, positionalTerciles);
    return { roster: s.roster, ps, picksValue: TacoCore.rosterPicksValue(lg, s.roster.rosterId) };
  });

  // Compute rank (1-based, ascending = 1 is best) for each team at each
  // dimension. We rank descending by value, then assign 1..N. Ties get the
  // same rank, next gets +1 (standard competition ranking).
  const dimensionKeys = ['QB', 'RB', 'WR', 'TE', 'Picks', 'Starters'];
  const ranks = {};   // ranks[rosterId] = { QB: 3, RB: 7, ... }
  for (const dim of dimensionKeys) {
    const valued = posTotalsByTeam.map(t => ({
      rosterId: t.roster.rosterId,
      value: dim === 'Picks' ? t.picksValue
           : dim === 'Starters' ? (summaries.find(s => s.roster.rosterId === t.roster.rosterId)?.startersValue || 0)
           : t.ps[dim].value,
    }));
    valued.sort((a, b) => b.value - a.value);
    let lastVal = null, lastRank = 0;
    valued.forEach((v, i) => {
      const rank = (v.value === lastVal) ? lastRank : i + 1;
      lastVal = v.value;
      lastRank = rank;
      if (!ranks[v.rosterId]) ranks[v.rosterId] = {};
      ranks[v.rosterId][dim] = rank;
    });
  }

  // League means per position — kept around for legacy strength/weakness
  // tooltip context, even though the rank chips are the new primary signal.
  const leagueMeans = { QB: 0, RB: 0, WR: 0, TE: 0 };
  for (const pos of ['QB', 'RB', 'WR', 'TE']) {
    leagueMeans[pos] = posTotalsByTeam.reduce((s, x) => s + x.ps[pos].value, 0) / posTotalsByTeam.length;
  }

  // My team's value for the comparison column
  const myEntry = summaries.find(s => s.roster.isMe);
  const myValue = myEntry?.totalValue || 0;

  // For each team, capture the ranks + values they'll need at render time.
  const enriched = summaries.map(s => {
    const ps = computePositionalSummary(s.roster, positionalTerciles);
    const teamRanks = ranks[s.roster.rosterId] || {};
    return {
      ...s,
      ps,
      teamRanks,
      vsMe: s.totalValue - myValue,
    };
  });

  // Snapshot for the share endpoints — captured here because enriched is
  // still in canonical total-value order (the user-sort below re-sorts it in
  // place, but this map has already materialized independent row objects).
  // Used by shareLeagueRankings() and shareMyReportCard(), which POST to
  // /api/share for a public /s/{id} page.
  STATE._prShareSnapshot = {
    kind: 'rankings',
    // basis travels with the snapshot: a shared board that excluded picks must
    // not render under the "players + picks" caption the /s/ page used to
    // hardcode for every board.
    league: {
      name: lg.name,
      format: lg.scoringTab || '',
      season: String(lg.season || ''),
      teams: summaries.length,
      basis: includePicks ? 'roster+picks' : 'roster',
    },
    rows: enriched.map(s => ({
      team: s.roster.teamName || s.roster.ownerName || 'Team',
      owner: s.roster.ownerName || '',
      value: Math.round(s.totalValue),
      archetype: s.archetype || '',
      record: `${s.roster.wins || 0}-${s.roster.losses || 0}${s.roster.ties ? '-' + s.roster.ties : ''}`,
      ranks: s.teamRanks,
      me: !!s.roster.isMe,
    })),
  };

  // Sort the row order by the user's chosen dimension. Per-position ranks
  // (the chips) are absolute league standings and DO NOT change with sort —
  // they're computed once above against the full league.
  const sortKey = STATE.powerRankingsSort || 'totalValue';
  const sortFns = {
    totalValue:    (a, b) => b.totalValue - a.totalValue,
    startersValue: (a, b) => b.startersValue - a.startersValue,
    QB:            (a, b) => b.ps.QB.value - a.ps.QB.value,
    RB:            (a, b) => b.ps.RB.value - a.ps.RB.value,
    WR:            (a, b) => b.ps.WR.value - a.ps.WR.value,
    TE:            (a, b) => b.ps.TE.value - a.ps.TE.value,
    Picks:         (a, b) =>
      TacoCore.rosterPicksValue(lg, b.roster.rosterId) - TacoCore.rosterPicksValue(lg, a.roster.rosterId),
  };
  enriched.sort(sortFns[sortKey] || sortFns.totalValue);

  // Header summary
  const totalLeagueValue = summaries.reduce((s, x) => s + x.totalValue, 0);
  const leagueAvg = Math.round(totalLeagueValue / summaries.length);
  const myRank = enriched.findIndex(s => s.roster.isMe) + 1;
  // Scouting a league as one of its managers: that team plays the "you" role,
  // so the board names it rather than telling the reader the team is theirs.
  const prViewed = STATE.scoutMode ? enriched.find((x) => x.roster.isMe)?.roster || null : null;
  const prVsLabel = prViewed ? String(prViewed.teamName || 'this team').slice(0, 18) : 'you';
  const topGap = enriched[0].totalValue - enriched[enriched.length - 1].totalValue;

  // Render rows
  const totalTeams = summaries.length;
  const rowsHtml = enriched.map((s, i) => {
    const rank = i + 1;
    const r = s.roster;
    const isMe = r.isMe;
    const avatar = teamAvatarHtml(r, r.teamName);
    const archetypeClass = 'arch-' + s.archetype.toLowerCase().replace(/\s+/g, '-');
    const startersPct = s.totalValue > 0 ? Math.round(s.startersValue / s.totalValue * 100) : 0;
    const playoff = playoffByRoster[r.rosterId];
    const playoffHtml = playoff && (r.wins + r.losses + r.ties) > 0
      ? `<span class="pr-playoff pr-playoff-${playoff.status}" data-tooltip="Playoff odds · record + power rank">${playoff.playoffPct}%</span>`
      : '';

    // Build the rank chip row: one chip per dimension, color-coded by tercile
    // of league size (top third green, middle yellow, bottom red).
    // Mirrors the visual treatment from Sleeper's Team Rank chips (Image 3).
    const chipDimensions = ['QB', 'RB', 'WR', 'TE', 'Picks'];
    const rankChips = chipDimensions.map(dim => {
      const dimRank = s.teamRanks[dim] || totalTeams;
      const tier = dimRank <= Math.ceil(totalTeams / 3) ? 'good'
                 : dimRank > Math.ceil(totalTeams * 2 / 3) ? 'poor'
                 : 'mid';
      const ordinal = dimRank + (
        dimRank === 1 ? 'st' :
        dimRank === 2 ? 'nd' :
        dimRank === 3 ? 'rd' :
        dimRank > 20 && dimRank % 10 === 1 ? 'st' :
        dimRank > 20 && dimRank % 10 === 2 ? 'nd' :
        dimRank > 20 && dimRank % 10 === 3 ? 'rd' :
        'th'
      );
      // Tooltip explains: "Ranked Nth of 12 at QB by total value"
      const tip = `${dim} value: ranked ${ordinal} of ${totalTeams}`;
      return `<span class="pr-chip pr-chip-${tier}" data-tooltip="${escapeHtml(tip)}">
        <span class="pr-chip-label">${dim}</span>
        <span class="pr-chip-rank">${ordinal}</span>
      </span>`;
    }).join('');

    let vsMeHtml = '';
    if (!isMe && myValue > 0) {
      const sign = s.vsMe > 0 ? '+' : '';
      const cls = s.vsMe > 0 ? 'pr-vs-pos' : 'pr-vs-neg';
      vsMeHtml = `<span class="pr-vs ${cls}">${sign}${formatCompactNumber(s.vsMe)} vs ${escapeHtml(prVsLabel)}</span>`;
    } else if (isMe) {
      vsMeHtml = '<span class="pr-vs pr-vs-self">' + (prViewed ? 'Viewing' : 'You') + '</span>';
    }

    // Build the expandable body — full roster grid + a "build trade" CTA
    const positionGrid = renderTeamPositionGrid(r, positionalTerciles);
    const tradeBtn = !isMe
      ? `<div class="pr-expand-actions">
          <button class="ghost small" data-taco-trade="${STATE.currentTeamIdx}|${r.rosterId}">Build trade with ${escapeHtml(r.teamName)} →</button>
        </div>`
      : '';

    return `
      <div class="pr-row-wrap" data-roster="${r.rosterId}">
        <div class="pr-row ${isMe ? 'pr-row-mine' : ''}" data-pr-toggle="${r.rosterId}">
          <div class="pr-rank">${rank}</div>
          <div class="pr-team">
            ${avatar}
            <div class="pr-team-text">
              <div class="pr-team-name">${escapeHtml(r.teamName || r.ownerName)}${isMe ? ' <span class="pr-mine-tag">' + (prViewed ? 'viewing' : 'you') + '</span>' : ''}
                <button class="pr-owner-btn"
                        data-taco-owner="${escapeHtml(lg.league_id)}|${r.rosterId}"
                        data-tooltip="See trade profile + history for this owner">ⓘ</button>
              </div>
              <div class="pr-team-meta">
                ${escapeHtml(r.ownerName)}${r.wins != null && (r.wins + r.losses + r.ties) > 0 ? ' · ' + r.wins + '-' + r.losses + (r.ties ? '-' + r.ties : '') : ''}
                ${playoffHtml ? ' · ' + playoffHtml : ''} ·
                ${archetypesSettled() ? `<span class="pr-archetype-pill ${archetypeClass}" data-tooltip="${escapeHtml(GLOSSARY[s.archetype] || '')}">${s.archetype}</span>` : archetypePendingPill('pr-archetype-pill')}
              </div>
            </div>
          </div>
          <div class="pr-chips">${rankChips}</div>
          <div class="pr-values">
            <div class="pr-value-main" data-tooltip="${includePicks ? 'Players plus draft picks' : 'Players only'}, priced in this league's format">${formatCompactNumber(s.totalValue)}</div>
            <div class="pr-value-sub" data-tooltip="Value of this team's best starting lineup, and its share of the total">${formatCompactNumber(s.startersValue)} starters · ${startersPct}%</div>
          </div>
          <div class="pr-vs-cell">${vsMeHtml}</div>
          <div class="pr-expand-icon">▾</div>
        </div>
        <div class="pr-row-body">
          ${positionGrid}
          ${tradeBtn}
        </div>
      </div>
    `;
  }).join('');

  return `
    <div class="pr-panel">
      <div class="pr-head">
        <div>
          <div class="pr-title">League Rankings</div>
          <div class="pr-sub">${summaries.length} teams · ${includePicks ? 'roster + picks' : 'roster only'} · sorted by ${
            sortKey === 'totalValue' ? 'total value'
            : sortKey === 'startersValue' ? 'starters value'
            : sortKey === 'Picks' ? 'picks value'
            : sortKey + ' value'
          }</div>
        </div>
        <div class="pr-stats">
          ${myRank ? `<button type="button" class="pr-stat pr-stat-jump" data-pr-jump-me data-tooltip="Scroll to ${prViewed ? 'this team' : 'your team'}"><div class="pr-stat-label">${prViewed ? 'Viewing' : 'You'} ↓</div><div class="pr-stat-val accent">#${myRank}/${summaries.length}</div></button>` : ''}
          <div class="pr-stat"><div class="pr-stat-label">League avg</div><div class="pr-stat-val">${formatCompactNumber(leagueAvg)}</div></div>
          <div class="pr-stat"><div class="pr-stat-label">Top vs bottom</div><div class="pr-stat-val">${formatCompactNumber(topGap)}</div></div>
          <div class="pr-stat"><div class="pr-stat-label">League total</div><div class="pr-stat-val">${formatCompactNumber(summaries.reduce((s, x) => s + x.totalValue, 0))}</div></div>
          <div class="pr-stat"><div class="pr-stat-label">Avg age</div><div class="pr-stat-val">${(() => {
            const ages = lg.allRosters.flatMap(r => (r.players || []).filter(p => p.age && !p.isIR && !p.isTaxi).map(p => p.age));
            return ages.length ? Math.round(ages.reduce((a, b) => a + b, 0) / ages.length) : '-';
          })()}</div></div>
        </div>
      </div>
      <div class="pr-toolbar">
        <div class="pr-sort-group">
          <span class="pr-sort-label">Counting:</span>
          ${[
            { on: true,  label: 'Roster + picks', tip: 'Rank on active players plus draft capital - the long-view total.' },
            { on: false, label: 'Roster only',    tip: 'Rank on active players alone. If you are contending, this is whether you are ahead on the field right now - a rival stacking future firsts stops flattering their total.' },
          ].map(opt => `
            <button class="pr-sort-btn ${includePicks === opt.on ? 'active' : ''}"
                    data-pr-basis="${opt.on ? 'roster+picks' : 'roster'}"
                    data-tooltip="${escapeHtml(opt.tip)}">
              ${opt.label}
            </button>
          `).join('')}
        </div>
        <span class="pr-toolbar-divider"></span>
        <div class="pr-sort-group">
          <span class="pr-sort-label">Sort by:</span>
          ${[
            { k: 'totalValue',    label: 'Total' },
            { k: 'startersValue', label: 'Starters' },
            { k: 'QB',            label: 'QB' },
            { k: 'RB',            label: 'RB' },
            { k: 'WR',            label: 'WR' },
            { k: 'TE',            label: 'TE' },
            { k: 'Picks',         label: 'Picks' },
          ].map(opt => `
            <button class="pr-sort-btn ${sortKey === opt.k ? 'active' : ''}"
                    data-pr-sort="${opt.k}"
                    data-tooltip="Reorder rows by ${opt.label.toLowerCase()} value">
              ${opt.label}
            </button>
          `).join('')}
        </div>
        <div class="pr-toolbar-spacer"></div>
        ${STATE.scoutMode ? '' : '<button class="ghost small" data-taco-share="leagueRankings" data-tooltip="Copy a public link to this board - leaguemates can view it without logging in">Share board</button>'}
        ${STATE.scoutMode ? '' : '<button class="ghost small" data-taco-share="weekRecap" data-tooltip="Copy a link to last week\'s recap - every score, the best and worst of the week, and what people left on their bench. No login needed to read it.">Share week</button>'}
        <button class="ghost small" data-pr-expand-all>Expand all</button>
        <button class="ghost small" data-pr-collapse-all>Collapse all</button>
      </div>
      <div class="pr-toolbar-legend-bar">
        <span class="pr-toolbar-legend">
          League rank chips: <span class="pr-chip pr-chip-good pr-chip-mini">top ⅓</span>
          <span class="pr-chip pr-chip-mid pr-chip-mini">mid</span>
          <span class="pr-chip pr-chip-poor pr-chip-mini">bottom ⅓</span>
          · sort changes row order, not chip ranks
        </span>
        <span class="pr-toolbar-legend">
          Value: every player${includePicks ? ' plus draft picks' : ''}, priced for this league's scoring · Starters: the best lineup this team can set, by value
        </span>
      </div>
      <div class="pr-list">${rowsHtml}</div>
    </div>
  `;
}

function togglePowerRankingRow(rosterId) {
  const wrap = document.querySelector(`.pr-row-wrap[data-roster="${rosterId}"]`);
  if (wrap) wrap.classList.toggle('expanded');
}
function expandAllPowerRankings() {
  document.querySelectorAll('.pr-row-wrap').forEach(el => el.classList.add('expanded'));
}
function collapseAllPowerRankings() {
  document.querySelectorAll('.pr-row-wrap').forEach(el => el.classList.remove('expanded'));
}
// The board is mounted in two places: the league page's rankings subtab and the
// scout page. Redraw the one on screen. Redrawing the league page while scouting
// would put a second, hidden copy of every row in the DOM, and the row toggles
// (document.querySelector) would then expand the hidden copy instead.
function rerenderPowerRankingsHost() {
  if (STATE.scoutMode && typeof renderScoutView === 'function') renderScoutView();
  else if (typeof renderTeamDetail === 'function') renderTeamDetail();
}
// Re-sort the league rankings rows by the chosen dimension. Per-position
// rank chips remain absolute league standings (computed against the full
// league); only row order changes. Persists choice across reloads.
//
// The sort buttons live inside the team-detail view's "League Rankings"
// subtab, so the correct re-render entry is renderTeamDetail (NOT
// renderLeagueView, which is the unrelated global League sub-nav tab).
function setPowerRankingsSort(key) {
  STATE.powerRankingsSort = key;
  try { localStorage.setItem('fo_power_rankings_sort', key); } catch (_e) {}
  if (window.TacoCloud && TacoCloud.onPrefsChanged) TacoCloud.onPrefsChanged();
  rerenderPowerRankingsHost();
}
// Switch the board between ranking on the roster alone and roster plus draft
// capital. Same persistence path as the sort key: localStorage for this device,
// TacoCloud for the account.
function setPowerRankingsBasis(mode) {
  STATE.powerRankingsIncludePicks = mode !== 'roster';
  try { localStorage.setItem('fo_power_rankings_basis', mode); } catch (_e) {}
  if (window.TacoCloud && TacoCloud.onPrefsChanged) TacoCloud.onPrefsChanged();
  rerenderPowerRankingsHost();
}

// POST a share payload to the API, copy the returned public link, and flash
// feedback on the button. The /s/{id} pages are server-rendered with OG meta,
// so they unfurl in Sleeper chat / Discord and open instantly — no login.
async function postShareAndCopy(payload, btnEl) {
  const orig = btnEl ? btnEl.textContent : '';
  if (btnEl) btnEl.textContent = 'Creating link…';
  try {
    const res = await fetch(`${BACKEND_URL}/api/share`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error(`share API ${res.status}`);
    const data = await res.json();
    await navigator.clipboard.writeText(data.url);
    if (btnEl) { btnEl.textContent = 'Link copied'; setTimeout(() => { btnEl.textContent = orig; }, 2000); }
  } catch (e) {
    console.warn('[share] failed:', e.message);
    if (btnEl) { btnEl.textContent = 'Share failed'; setTimeout(() => { btnEl.textContent = orig; }, 2000); }
  }
}

async function shareLeagueRankings(btnEl) {
  if (STATE._prShareSnapshot) await postShareAndCopy(STATE._prShareSnapshot, btnEl);
}
window.shareLeagueRankings = shareLeagueRankings;

/** Share last week's league recap.
 *
 * Owen: "sends a link to show a card that breaks down the whole league for
 * the previous week." A LINK, so this copies one rather than drawing an
 * image -- the recipient opens a real page with every score on it.
 *
 * Needs no snapshot POST, unlike the other two shares: a played week never
 * changes, so /w/<leagueId>/<week> renders live from Sleeper. Nothing is
 * written anywhere, which also means a sandbox test cannot touch production
 * data (docs/handoff.md). */
async function shareWeekRecap(btnEl) {
  const lg = STATE.leagues?.[STATE.currentTeamIdx];
  if (!lg) return;
  // Last COMPLETED week: the current one is still being played, and a recap
  // of a week in progress is a scoreboard, which the Slate already is.
  const ctx = (typeof TacoCore !== 'undefined' && TacoCore.resolveNflWeekContext)
    ? TacoCore.resolveNflWeekContext() : {};
  const nflWeek = Number(ctx.week) || 1;
  const leg = Number(lg.settings?.leg) || nflWeek;
  const week = Math.max(1, Math.min(18, Math.min(leg, nflWeek) - 1));
  const url = `https://thearmchairoffice.com/w/${lg.league_id}/${week}`;
  const title = `Week ${week} recap - ${lg.name}`;

  if (navigator.share) {
    try {
      await navigator.share({ title, url });
      return;
    } catch (_e) { /* cancelled, or unsupported: fall through to the copy */ }
  }
  try {
    await navigator.clipboard.writeText(url);
    if (btnEl) {
      const was = btnEl.textContent;
      btnEl.textContent = 'Link copied';
      setTimeout(() => { btnEl.textContent = was; }, 1800);
    }
  } catch (_e) {
    if (typeof showToast === 'function') showToast(url);
  }
}
window.shareWeekRecap = shareWeekRecap;

// Share MY team's report card from the current league — rank, archetype,
// record, and per-position league standings. The snapshot is refreshed by
// rendering the rankings board off-DOM if the user hasn't opened that tab.
async function shareMyReportCard(btnEl) {
  const lg = STATE.leagues?.[STATE.currentTeamIdx];
  if (!lg) return;
  if (!STATE._prShareSnapshot || STATE._prShareSnapshot.league?.name !== lg.name) {
    try { renderPowerRankingsPanel(lg); } catch (_e) { /* snapshot stays unset */ }
  }
  const snap = STATE._prShareSnapshot;
  const idx = (snap?.rows || []).findIndex(r => r.me);
  if (idx < 0) return;
  // The whole board goes with it (Owen, 2026-10-18: the card "doesnt show
  // much ... it should honestly show more about the whole league"). One
  // roster's ranks mean nothing to a stranger without the league to measure
  // them against, and the league is the part that makes the link worth
  // opening. The rows are already built above for the rankings share.
  await postShareAndCopy({
    kind: 'team',
    league: snap.league,
    rank: idx + 1,
    team: snap.rows[idx],
    rows: snap.rows,
  }, btnEl);
}
window.shareMyReportCard = shareMyReportCard;

window.togglePowerRankingRow = togglePowerRankingRow;
window.expandAllPowerRankings = expandAllPowerRankings;
window.collapseAllPowerRankings = collapseAllPowerRankings;
window.setPowerRankingsSort = setPowerRankingsSort;
window.setPowerRankingsBasis = setPowerRankingsBasis;
window.renderPowerRankingsPanel = renderPowerRankingsPanel;

;
/*! ==== 58-format-rankings-panel.js ==== */
// Per-league format rankings (Player Rankings subtab + standalone /rankings).
// Extracted from 25-power-rankings.

function buildOwnershipMap(lg) {
  const map = new Map();
  for (const roster of lg.allRosters) {
    for (const p of roster.players) {
      const ownerInfo = {
        rosterId: roster.rosterId,
        ownerName: roster.ownerName,
        teamName: roster.teamName,
        isMe: roster.isMe,
        isStarter: p.isStarter,
        isIR: p.isIR,
        isTaxi: p.isTaxi,
      };
      map.set(normalizeName(p.name) + '|' + p.position, ownerInfo);
      if (p.playerId) map.set('sid:' + p.playerId, ownerInfo);
    }
  }
  return map;
}

function renderRankingsPanel(lg) {
  // Same pool as everywhere else (see 59-value-lookup.js getValuePoolForTab)
  // -- was hand-rolling this from STATE.ktcRaw/fcRaw directly, which (a)
  // silently dropped any player present in the backend composite but
  // missing from the raw FC/KTC list, and (b) never capped at 9999 like
  // lookupPlayerValue/getValuePoolForTab do, so a resolved value could
  // exceed the cap and show a different (higher) number than every other page.
  const ktcPool = (typeof getValuePoolForTab === 'function' ? getValuePoolForTab(lg.scoringTab) : [])
    .map(p => ({ ...p, isPick: p.position === 'PI' || p.position === 'PICK' }));

  if (ktcPool.length === 0) {
    return '<div class="tab-empty">Values for this format have not loaded yet. Refresh to try again.</div>';
  }

  const ownership = buildOwnershipMap(lg);
  const myLeagueCount = {};
  for (const l of STATE.leagues || []) {
    const seen = new Set();
    for (const p of l.myPlayers || []) {
      const id = String(p.playerId);
      if (!seen.has(id)) { seen.add(id); myLeagueCount[id] = (myLeagueCount[id] || 0) + 1; }
    }
  }
  const nLeagues = (STATE.leagues || []).length;
  const activeFilter = STATE.rankingsFilter || 'ALL';

  const allEntries = ktcPool
    .filter(p => p.value > 0)
    .map(p => {
      let owner = null;
      if (!p.isPick) {
        if (p.sleeperId && ownership.has('sid:' + p.sleeperId)) {
          owner = ownership.get('sid:' + p.sleeperId);
        } else {
          owner = ownership.get(normalizeName(p.name) + '|' + p.position);
        }
      }
      // Flat market value -- matches every other page (see 10-sleeper-api.js
      // playerLeagueValue). Was tilting via leagueTradeValue.
      return {
        ...p,
        owner,
      };
    });

  // Position rank, derived here rather than read from the payload.
  //
  // The row template reads e.posRank, but composite-v2 has never emitted such a
  // field -- the payload carries sleeperId/name/position/team/age/composite and
  // nothing rank-shaped -- so the "Pos Rank" column rendered blank on every row
  // and left a wide empty gutter under its own header. It is trivially
  // derivable from data already here: rank every real player by value and count
  // within position.
  //
  // Computed over allEntries, not the filtered view, so RB3 means the third
  // best RB overall rather than the third one that survived a filter. Keyed by
  // object identity because picks have no sleeperId and must not get a
  // position rank at all.
  const posRankByEntry = new Map();
  {
    const seenInPos = {};
    allEntries
      .filter((e) => !e.isPick && e.position)
      .slice()
      .sort((a, b) => b.value - a.value)
      .forEach((e) => {
        seenInPos[e.position] = (seenInPos[e.position] || 0) + 1;
        posRankByEntry.set(e, `${e.position}${seenInPos[e.position]}`);
      });
  }

  let filtered = allEntries;
  if (activeFilter === 'PICK') {
    filtered = allEntries.filter(e => e.isPick);
  } else if (activeFilter !== 'ALL') {
    filtered = allEntries.filter(e => !e.isPick && e.position === activeFilter);
  } else {
    filtered = allEntries.filter(e => !e.isPick);
  }

  const rookiesOnly = STATE.rankingsRookiesOnly === true;
  if (rookiesOnly && activeFilter !== 'PICK') {
    filtered = filtered.filter(e => e.rookie === true);
  }

  // Movers sort surfaces the biggest 30-day moves (either direction) so the
  // board reads as live, not stagnant. Only meaningful for players, so picks
  // always sort by season. Zero/no-momentum entries fall to the bottom.
  const sortMode = ['movers', 'split'].includes(STATE.rankingsSort) ? STATE.rankingsSort : 'value';
  // Split needs the outside markets (08, via Dynasty Daddy). Loaded on demand;
  // the panel says so while they arrive and re-renders when they land.
  const ddKey = lg.scoringTab && lg.scoringTab.startsWith('SF') ? 'sf' : '1qb';
  const dd = STATE.ddMarkets && STATE.ddMarkets[ddKey];
  let splitNote = '';
  if (sortMode === 'split' && !dd && typeof loadDdMarkets === 'function') {
    loadDdMarkets(lg.scoringTab).then(() => { if (typeof rerenderRankingsPanel === 'function') rerenderRankingsPanel(); });
    splitNote = 'Loading the other markets…';
  }
  if (activeFilter === 'PICK') {
    filtered.sort((a, b) => {
      const seasonA = parseInt((a.name.match(/^(\d{4})/) || [])[1]) || 9999;
      const seasonB = parseInt((b.name.match(/^(\d{4})/) || [])[1]) || 9999;
      if (seasonA !== seasonB) return seasonA - seasonB;
      return b.value - a.value;
    });
  } else if (sortMode === 'split' && dd && Object.keys(dd.byKey || {}).length) {
    // Where the markets disagree (shared/market-split.mjs): each market's RANK,
    // since their value scales differ. TACO's own rank rides along.
    const ranks = TacoCore.marketRanks(dd.byKey);
    const tacoRank = new Map(allEntries.filter((e) => !e.isPick).sort((a, b) => b.value - a.value).map((e, i) => [e.sleeperId, i + 1]));
    filtered = TacoCore.rankBySplit(filtered.filter((e) => !e.isPick && e.sleeperId), {
      getSid: (e) => e.sleeperId,
      ranks,
      getTacoRank: (e) => tacoRank.get(e.sleeperId) || null,
    });
  } else if (sortMode === 'split') {
    filtered = [];
    splitNote = splitNote || 'The other markets are unavailable right now, so there is nothing to compare.';
  } else if (sortMode === 'movers') {
    // Players who matter, biggest 30-day move in value POINTS first -- the
    // shared rule (shared/movers.mjs). By percent, the top was a #390 QB, a
    // linebacker and two backs valued 102 (Owen, 2026-09-27). The floor is
    // taken over every player, so the WR filter shows relevant WRs, not the
    // top 200 WRs.
    const inView = new Set(filtered);
    filtered = TacoCore.rankMovers(allEntries.filter(e => !e.isPick), {
      getValue: (e) => e.value,
      getPct: (e) => e.momentum30d,
      getPosition: (e) => e.position,
    }).filter((e) => inView.has(e));
  } else {
    filtered.sort((a, b) => b.value - a.value);
  }

  const counts = {
    ALL: allEntries.filter(e => !e.isPick).length,
    QB: allEntries.filter(e => !e.isPick && e.position === 'QB').length,
    RB: allEntries.filter(e => !e.isPick && e.position === 'RB').length,
    WR: allEntries.filter(e => !e.isPick && e.position === 'WR').length,
    TE: allEntries.filter(e => !e.isPick && e.position === 'TE').length,
    PICK: allEntries.filter(e => e.isPick).length,
    ROOKIES: (() => {
      const positionsScope = activeFilter === 'ALL' || activeFilter === 'PICK'
        ? allEntries.filter(e => !e.isPick)
        : allEntries.filter(e => !e.isPick && e.position === activeFilter);
      return positionsScope.filter(e => e.rookie === true).length;
    })(),
  };

  const shownCap = STATE.rankingsShown || 50;
  const display = filtered.slice(0, shownCap);

  const rowsHtml = display.map((e, idx) => {
    const rank = idx + 1;
    let ownerCell;
    let rowClass = '';
    if (e.isPick) {
      ownerCell = `<span class="rankings-owner-fa">-</span>`;
    } else if (!e.owner) {
      ownerCell = `<span class="rankings-owner-fa">Free Agent</span>`;
      rowClass = 'is-fa';
    } else if (e.owner.isMe) {
      const tags = [];
      if (e.owner.isStarter) tags.push('<span class="rankings-tag start">START</span>');
      if (e.owner.isIR) tags.push('<span class="rankings-tag ir">IR</span>');
      if (e.owner.isTaxi) tags.push('<span class="rankings-tag taxi">TAXI</span>');
      ownerCell = `<span class="rankings-owner-me">You ${tags.join(' ')}</span>`;
      rowClass = 'is-me';
    } else {
      ownerCell = `<span class="rankings-owner-other">${escapeHtml(e.owner.teamName || e.owner.ownerName)}</span>`;
    }

    const rookieTag = e.rookie && !e.isPick ? ' <span class="rookie-mark">ROOK</span>' : '';
    const posRankCell = e.posRank || posRankByEntry.get(e) || '';
    const photo = !e.isPick && typeof playerAvatarHtml === 'function'
      ? playerAvatarHtml(e.sleeperId, e.name, e.position)
      : '';
    const logo = !e.isPick && typeof teamLogoHtml === 'function'
      ? teamLogoHtml(e.team, 'rankings-team-logo')
      : '';
    const metaHtml = e.isPick
      ? `Pick · ${escapeHtml(e.team || '')}`
      : `${escapeHtml(e.position)} · <span class="rankings-team">${logo}${escapeHtml(e.team || 'FA')}</span>${e.age && e.age > 0 ? ' · age ' + e.age : ''}${!e.isPick && e.sleeperId && myLeagueCount[String(e.sleeperId)] && nLeagues > 1
              ? ' · <span class="rankings-mine" data-tooltip="You roster him in ' + myLeagueCount[String(e.sleeperId)] + ' of your ' + nLeagues + ' leagues -- Assets &amp; Exposure has the list">×' + myLeagueCount[String(e.sleeperId)] + '</span>'
              : ''}`;
    const momHtml = formatMomentumRankings(e.momentum30d);
    // Split view: every market's rank, TACO's, and the spread between them.
    const sp = e.split;
    const splitHtml = sp
      ? '<div class="rankings-split">' +
        sp.markets.map((m) => '<span class="rs-m' + (m.label === sp.highest ? ' rs-hi' : m.label === sp.lowest ? ' rs-lo' : '') + '">' + m.label + ' <b>' + m.rank + '</b></span>').join('') +
        (sp.tacoRank ? '<span class="rs-m rs-taco">TACO <b>' + sp.tacoRank + '</b></span>' : '') +
        '</div>'
      : '';

    return `
      <div class="rankings-row ${rowClass} ${e.isPick ? '' : 'pos-' + (e.position || '').toLowerCase()} ${e.sleeperId ? 'rankings-row-clickable' : ''}"
           ${e.sleeperId ? `data-sleeper-id="${escapeHtml(e.sleeperId)}" data-taco-player="${escapeHtml(e.sleeperId)}" data-taco-tab="${escapeHtml(lg.scoringTab)}"` : ''}>
        <div class="rankings-rank">${rank}</div>
        <div class="rankings-main">
          ${photo}
          <div class="rankings-main-text">
            <div class="rankings-name">${escapeHtml(e.name)}${rookieTag}</div>
            <div class="rankings-meta">${metaHtml}</div>
            ${splitHtml}
          </div>
        </div>
        <div class="rankings-posrank">${escapeHtml(posRankCell)}</div>
        <div class="rankings-owner">${ownerCell}</div>
        <div class="rankings-value">
          <span${e.value >= 9999 ? ' class="rankings-value-top" data-tooltip="Top of the 0-9,999 scale: the most valuable asset in this format. The order below it is what matters, not the round number."' : ''}>${Math.round(e.value).toLocaleString()}</span>
          ${sp ? '<span class="rs-range" data-tooltip="Spread between the highest and lowest market rank">spread ' + sp.range + '</span>' : momHtml}
        </div>
      </div>
    `;
  }).join('');

  const filterLabels = [
    ['ALL', 'All'],
    ['QB', 'QB'],
    ['RB', 'RB'],
    ['WR', 'WR'],
    ['TE', 'TE'],
    ['PICK', 'Picks'],
  ];
  const pillsHtml = renderFilterPills({
    items: filterLabels.map(([key, label]) => ({ key, label, count: counts[key] })),
    activeKey: activeFilter,
    handlerName: 'setRankingsFilter',
    pillClass: 'rankings-pill',
    countClass: 'rankings-pill-count',
  });

  const rookiesDisabled = activeFilter === 'PICK';
  const rookiesPillHtml = renderFilterPills({
    items: [{
      key: 'ROOKIES',
      label: 'Rookies',
      count: counts.ROOKIES,
      disabled: rookiesDisabled,
      tooltip: rookiesDisabled ? 'Picks are not rookies' : 'Show only rookies' + (activeFilter !== 'ALL' ? ' at ' + activeFilter : ''),
      onClick: rookiesDisabled ? null : 'toggleRankingsRookiesOnly()',
    }],
    activeKey: rookiesOnly && !rookiesDisabled ? 'ROOKIES' : '',
    handlerName: 'toggleRankingsRookiesOnly',
    pillClass: 'rankings-pill rankings-pill-toggle',
    countClass: 'rankings-pill-count',
  });

  const remaining = filtered.length - display.length;
  const truncatedNote = remaining > 0
    ? `<div class="ma-show-row"><button class="show-more-btn" data-taco-pill-fn="showMoreRankings">Show ${Math.min(50, remaining)} more<span class="show-more-count">${remaining} remaining</span></button>` +
      (remaining > 50 ? '<button class="ghost small" data-taco-pill-fn="showAllRankings">Show all ' + filtered.length + '</button>' : '') + '</div>'
    : '';

  // Freshness stamp from the composite's generation time, so the board visibly
  // shows how recently values updated (Owen: "feels stagnant").
  const gen = STATE.backendComposite?.[lg.scoringTab]?._meta?.fetched_at;
  let updatedStr = '';
  if (gen) {
    const mins = Math.max(0, Math.round((Date.now() - new Date(gen).getTime()) / 60000));
    updatedStr = ` · updated ${mins < 60 ? mins + 'm' : Math.round(mins / 60) + 'h'} ago`;
  }
  const sortToggle =
    '<div class="rankings-sort-toggle" role="group" aria-label="Sort rankings">' +
    `<button type="button" class="rankings-sort-btn${sortMode === 'value' ? ' active' : ''}" data-taco-pill="setRankingsSort|value">Value</button>` +
    `<button type="button" class="rankings-sort-btn${sortMode === 'movers' ? ' active' : ''}" data-taco-pill="setRankingsSort|movers">Movers</button>` +
    `<button type="button" class="rankings-sort-btn${sortMode === 'split' ? ' active' : ''}" data-taco-pill="setRankingsSort|split" data-tooltip="Where KTC, DynastyProcess, DraftSharks and others disagree most">Split</button>` +
    '</div>';

  return `
    <div class="rankings-panel">
      <div class="rankings-panel-head">
        <div>
          <h3 class="rankings-panel-title">Player rankings</h3>
          <div class="rankings-panel-sub"><span class="rankings-format-chip">${lg.scoringTab}</span> values for this league's scoring${updatedStr}</div>
          <div class="rankings-panel-legend">${counts.ALL.toLocaleString()} players + ${counts.PICK.toLocaleString()} draft picks = ${(counts.ALL + counts.PICK).toLocaleString()} assets. "All" is players only; picks have their own tab. Owner column is ${escapeHtml(lg.name)}; ×N is how many of your leagues you roster him in.</div>
        </div>
      </div>
      <div class="rankings-filters">
        ${pillsHtml}
        <span class="rankings-filter-divider"></span>
        ${rookiesPillHtml}
        <span class="rankings-filter-divider"></span>
        ${sortToggle}
      </div>
      <div class="rankings-table">
        <div class="rankings-header">
          <div class="rankings-rank">#</div>
          <div class="rankings-main">Player</div>
          <div class="rankings-posrank">Pos Rank</div>
          <div class="rankings-owner">Owner</div>
          <div class="rankings-value" data-tooltip="0-9,999 scale, priced for this league's scoring">Value</div>
        </div>
        ${splitNote ? '<div class="tab-empty">' + escapeHtml(splitNote) + '</div>' : ''}
        ${sortMode === 'split' && !splitNote ? '<p class="rankings-split-note">Where KTC, DynastyProcess, DraftSharks, FantasyNavigator, PFN and ADP Daddy disagree most, relative to how high the player sits. Each number is the overall rank in that market; green likes him most, red least.</p>' : ''}
        ${rowsHtml}
      </div>
      ${truncatedNote}
    </div>
  `;
}

function setRankingsFilter(filter) {
  STATE.rankingsFilter = filter;
  STATE.rankingsShown = 50; // new filter, fresh page
  if (typeof rerenderRankingsPanel === 'function') rerenderRankingsPanel();
}

function setRankingsSort(sort) {
  STATE.rankingsSort = ['movers', 'split'].includes(sort) ? sort : 'value';
  STATE.rankingsShown = 50;
  if (typeof rerenderRankingsPanel === 'function') rerenderRankingsPanel();
}
window.setRankingsSort = setRankingsSort;

function toggleRankingsRookiesOnly() {
  STATE.rankingsRookiesOnly = !STATE.rankingsRookiesOnly;
  STATE.rankingsShown = 50;
  if (typeof rerenderRankingsPanel === 'function') rerenderRankingsPanel();
}

function showMoreRankings() {
  STATE.rankingsShown = (STATE.rankingsShown || 50) + 50;
  if (typeof rerenderRankingsPanel === 'function') rerenderRankingsPanel();
}

window.setRankingsFilter = setRankingsFilter;
window.toggleRankingsRookiesOnly = toggleRankingsRookiesOnly;
window.showMoreRankings = showMoreRankings;

function showAllRankings() {
  STATE.rankingsShown = 100000;
  if (typeof rerenderRankingsPanel === 'function') rerenderRankingsPanel();
}
window.showAllRankings = showAllRankings;
window.renderRankingsPanel = renderRankingsPanel;
;
/*! ==== 26-owner-profiling-derive-trader-tendencies-from-tr.js ==== */
// Aggregates everything we know about one owner across one league: how often
// they trade, what they accumulate, fairness pattern, history with you.
// This is unique to multi-league users — KTC/FC don't have it because they
// don't have your trade history. Pure analysis on STATE.tradeHistory.
function buildOwnerProfile(leagueId, rosterId) {
  const lg = STATE.leagues.find(l => l.league_id === leagueId);
  if (!lg) return null;

  // Trade history loads lazily on first visit to that view. If the user
  // clicks an owner profile ⓘ before that, STATE.tradeHistory is null —
  // we used to return null here, which collapsed the entire drawer to
  // "Owner not found." Now: surface the basic owner profile with whatever
  // we have (name, team, league record), and async-trigger trade history
  // load so the drawer can re-render with full pattern stats once ready.
  if (!STATE.tradeHistory) {
    if (typeof fetchTradeHistory === 'function') {
      // Fire-and-forget load. When it resolves, re-render the drawer if
      // it's still open and pointed at the same owner.
      fetchTradeHistory().then(() => {
        const drawer = document.getElementById('playerDrawer');
        if (drawer?.classList.contains('open') && drawer.dataset.ownerLeagueId === leagueId
            && drawer.dataset.ownerRosterId === String(rosterId)) {
          const content = document.getElementById('drawerContent');
          if (content) content.innerHTML = buildOwnerDrawerContent(leagueId, rosterId);
        }
      }).catch(err => console.warn('[owner-drawer] trade history load failed', err));
    }
    const r = lg.allRosters.find(x => x.rosterId === rosterId);
    return r ? {
      rosterId,
      ownerName: r.ownerName || 'Unknown',
      teamName: r.teamName || 'Unknown',
      isMe: r.isMe || false,
      tradeCount: 0,
      empty: true,
      lg,
      historyLoading: true,  // tells the drawer to show a "loading trades..." note
    } : null;
  }

  // All trades in this league involving this roster
  const leagueTrades = STATE.tradeHistory.filter(t => t.leagueId === leagueId);
  const myTrades = leagueTrades.filter(t => t.sides.some(s => s.rosterId === rosterId));
  if (myTrades.length === 0) {
    // Owner exists but has no trade history — still surface their basic info
    const r = lg.allRosters.find(x => x.rosterId === rosterId);
    return {
      rosterId,
      ownerName: r?.ownerName || 'Unknown',
      teamName: r?.teamName || 'Unknown',
      isMe: r?.isMe || false,
      tradeCount: 0,
      empty: true,
      lg,
    };
  }

  const r = lg.allRosters.find(x => x.rosterId === rosterId);
  const isMe = r?.isMe || false;

  // Compute fairness pattern from this owner's perspective.
  // wins = trades where this side won the verdict; losses = lost; fair = fair
  let wins = 0, losses = 0, fair = 0, multi = 0;
  let totalNetValueDelta = 0;  // sum of (this side - other side) across 2-team trades

  // Position bias: count of incoming + outgoing player values per position
  const incomingByPos = { QB: 0, RB: 0, WR: 0, TE: 0, OTHER: 0 };
  const outgoingByPos = { QB: 0, RB: 0, WR: 0, TE: 0, OTHER: 0 };
  let incomingPicks = 0, outgoingPicks = 0;

  // Specifically vs me: count, my wins, their wins, value delta from my perspective
  let vsMeCount = 0;
  let vsMeMyWins = 0, vsMeTheirWins = 0, vsMeFair = 0;
  let vsMeNetForMe = 0;

  // Most-traded players (incoming side)
  const incomingPlayerCounts = {};

  for (const t of myTrades) {
    // Startup-draft-era trades are priced as rookie picks (nonsense value);
    // skip them so owner tendencies + net-value read from real dynasty trades.
    if (t.isStartup) continue;
    const mySide = t.sides.find(s => s.rosterId === rosterId);
    if (!mySide) continue;

    // Tally incoming values
    for (const p of mySide.players) {
      const pos = ['QB', 'RB', 'WR', 'TE'].includes(p.position) ? p.position : 'OTHER';
      incomingByPos[pos] += p.value || 0;
      incomingPlayerCounts[p.name] = (incomingPlayerCounts[p.name] || 0) + 1;
    }
    // allow-inline-roster-sum: one side of a trade, not a roster
    incomingPicks += mySide.picks.reduce((s, p) => s + (p.value || 0), 0);

    // Outgoing = sum of the OTHER sides' incoming
    const otherSides = t.sides.filter(s => s.rosterId !== rosterId);
    for (const os of otherSides) {
      for (const p of os.players) {
        const pos = ['QB', 'RB', 'WR', 'TE'].includes(p.position) ? p.position : 'OTHER';
        outgoingByPos[pos] += p.value || 0;
      }
      // allow-inline-roster-sum: one side of a trade, not a roster
      outgoingPicks += os.picks.reduce((s, p) => s + (p.value || 0), 0);
    }

    // Verdict tally
    if (t.verdict === 'multi') multi++;
    else if (t.verdict === 'fair') fair++;
    else if (t.winnerRosterId === rosterId) wins++;
    else if (t.winnerRosterId != null) losses++;

    // Net delta for 2-team trades only
    if (t.sides.length === 2) {
      const other = t.sides.find(s => s.rosterId !== rosterId);
      if (other) totalNetValueDelta += tradeSideScore(mySide) - tradeSideScore(other);
    }

    // Vs-me analysis (skip if THIS owner IS me)
    if (!isMe) {
      const meSide = t.sides.find(s => s.isMe);
      if (meSide && t.sides.length === 2) {
        vsMeCount++;
        if (t.verdict === 'fair') vsMeFair++;
        else if (t.winnerRosterId === meSide.rosterId) vsMeMyWins++;
        else if (t.winnerRosterId === rosterId) vsMeTheirWins++;
        vsMeNetForMe += tradeSideScore(meSide) - tradeSideScore(mySide);
      }
    }
  }

  // Derive labels.
  // Style: pick vs player bias + position skew
  const pickRatio = (incomingPicks + outgoingPicks) > 0
    ? incomingPicks / (incomingPicks + outgoingPicks) : 0.5;
  let style;
  if (pickRatio > 0.65) style = 'Pick collector';
  else if (pickRatio < 0.35) style = 'Pick spender';
  else style = 'Balanced';

  // Position lean: which position do they net-acquire most?
  const posDelta = {
    QB: incomingByPos.QB - outgoingByPos.QB,
    RB: incomingByPos.RB - outgoingByPos.RB,
    WR: incomingByPos.WR - outgoingByPos.WR,
    TE: incomingByPos.TE - outgoingByPos.TE,
  };
  const posLean = Object.entries(posDelta).sort((a, b) => b[1] - a[1])[0];
  const posLeanLabel = posLean[1] > 1000 ? `accumulates ${posLean[0]}` : 'no clear position lean';

  // Trader rating: avg net value delta per trade (positive = wins trades)
  const avgNetDelta = myTrades.length > 0 ? totalNetValueDelta / myTrades.length : 0;
  let raterTier;
  if (avgNetDelta > 800) raterTier = 'Shrewd - wins trades';
  else if (avgNetDelta > 200) raterTier = 'Slight edge';
  else if (avgNetDelta < -800) raterTier = 'Easy mark - loses trades';
  else if (avgNetDelta < -200) raterTier = 'Slight underwater';
  else raterTier = 'Even trader';

  // Activity rating
  let activity;
  if (myTrades.length >= 12) activity = 'Highly active';
  else if (myTrades.length >= 6) activity = 'Active';
  else if (myTrades.length >= 3) activity = 'Occasional';
  else activity = 'Rare trader';

  // Most-traded incoming players (who have they accumulated)
  const topIncomingPlayers = Object.entries(incomingPlayerCounts)
    .sort((a, b) => b[1] - a[1])
    .slice(0, 5)
    .filter(([, c]) => c >= 1);

  // Trade likelihood with YOU: combination of activity + vs-me history
  let withMeLabel = null;
  if (!isMe) {
    if (vsMeCount === 0) withMeLabel = 'No history yet';
    else if (vsMeCount >= 4) withMeLabel = 'Frequent partner';
    else if (vsMeCount >= 2) withMeLabel = 'Past partner';
    else withMeLabel = 'One prior trade';
  }

  return {
    rosterId,
    ownerName: r?.ownerName || 'Unknown',
    teamName: r?.teamName || 'Unknown',
    isMe,
    lg,
    tradeCount: myTrades.length,
    wins, losses, fair, multi,
    avgNetDelta,
    style,
    posLeanLabel,
    raterTier,
    activity,
    incomingByPos,
    outgoingByPos,
    incomingPicks,
    outgoingPicks,
    topIncomingPlayers,
    vsMeCount, vsMeMyWins, vsMeTheirWins, vsMeFair, vsMeNetForMe,
    withMeLabel,
    trades: myTrades,
  };
}

;
/*! ==== 27-trader-card-global-verdict-on-your-trading-skill.js ==== */
// Aggregates every 2-team trade you've made across every league, computes a
// verdict-style "you are a [tier] trader" panel. Distinct from the per-league
// leaderboards (which compare you to leaguemates) — this is your personal
// score across your entire footprint.
//
// Tiering uses two signals:
//   1. avgNetDelta — your average value gap per trade (positive = wins)
//   2. winRate     — % of decided trades you "won" by fairness verdict
// Both are needed: high winRate with low avgNetDelta means you grind out
// fair-but-favorable wins; low winRate with high avgNetDelta means you take
// big swings that connect occasionally.
/**
 * Your trade record, one definition for every number on Trade History.
 *
 * Scored = your 2-team trades made after the startup draft. Startup-era trades
 * price picks as rookie picks, which is nonsense for a startup; 3+ team trades
 * have no clean winner. The header used to count those too (38-42-22 over 102
 * trades, won-LOST-fair order) beside this card's 23 / 18 / 30 over 71, with
 * nothing saying why (Trades brief, 2026-09-27).
 */
function myTradeRecord(allTrades) {
  const mine = (allTrades || []).filter((t) => t.includesMe);
  const scored = mine.filter((t) => t.sides.length === 2 && !t.isStartup);
  let wins = 0, losses = 0, fair = 0;
  for (const t of scored) {
    const me = t.sides.find((s) => s.isMe);
    if (!me) continue;
    if (t.verdict === 'fair') fair++;
    else if (t.winnerRosterId === me.rosterId) wins++;
    else if (t.winnerRosterId != null) losses++;
  }
  return {
    mine: mine.length,
    scored,
    wins,
    fair,
    losses,
    multi: mine.filter((t) => t.sides.length >= 3).length,
    startup: mine.filter((t) => t.sides.length === 2 && t.isStartup).length,
  };
}
window.myTradeRecord = myTradeRecord;

/** The rule every won / fair / lost on the page follows, said once. */
const TRADE_RECORD_RULE = 'Won or lost: one side came out more than 5% ahead in effective value at today\'s prices - the Trade Calculator\'s own verdict (stars carry a premium, extra pieces are discounted). Fair: within 5%. Scored: your 2-team trades after your startup draft; startup-draft trades (picks priced as rookie picks) and 3+ team trades are listed but not scored.';
window.TRADE_RECORD_RULE = TRADE_RECORD_RULE;

function buildTraderCardPanel(allTrades, scopeLabel) {
  // Only my 2-team trades (multi-team trades have ambiguous attribution).
  // scopeLabel describes whether this is a global (all leagues) or per-league
  // rating — passed in by the caller based on the active filter pill/picker.
  // Exclude startup-draft-era trades: their pick values are nonsense (priced as
  // rookie picks), which skews the verdict and drags the average toward zero.
  const rec = myTradeRecord(allTrades);
  const myTrades = rec.scored;
  if (myTrades.length === 0) return '';
  const { wins, losses, fair } = rec;

  let netDelta = 0;
  for (const t of myTrades) {
    const me = t.sides.find(s => s.isMe);
    const them = t.sides.find(s => !s.isMe);
    if (!me || !them) continue;
    netDelta += tradeSideScore(me) - tradeSideScore(them);
  }

  const totalDecidedTrades = wins + losses + fair;
  // Volume reads off everything you did; the record reads off what was scored.
  const totalAllMine = rec.mine;
  if (totalDecidedTrades === 0) return '';

  const avgNetDelta = netDelta / myTrades.length;
  const winRate = (wins + fair * 0.5) / totalDecidedTrades;  // fair = half-credit

  // Determine tier. Composite score weights both delta and rate, since both matter.
  // The cutoffs are calibrated so most users land in middle tiers — only consistent
  // outliers earn the top/bottom labels.
  let tier, tierCls, blurb;
  if (avgNetDelta > 600 && winRate > 0.55) {
    tier = 'Sharp';
    tierCls = 'sharp';
    blurb = "You're winning trades. Leaguemates should think twice before opening a chat with you.";
  } else if (avgNetDelta > 250 && winRate > 0.50) {
    tier = 'Edge';
    tierCls = 'edge';
    blurb = 'Slight but consistent edge. You quietly accumulate value over time.';
  } else if (Math.abs(avgNetDelta) <= 250) {
    tier = 'Even';
    tierCls = 'even';
    blurb = 'Balanced trader - you give as good as you get. Trades are fair on both sides.';
  } else if (avgNetDelta < -600 && winRate < 0.45) {
    tier = 'Soft';
    tierCls = 'soft';
    blurb = "Your trades have skewed unfavorable. Worth a closer look at what you're paying for assets.";
  } else if (avgNetDelta < -250) {
    tier = 'Slight L';
    tierCls = 'slight-l';
    blurb = "You've been trading slightly underwater. Tightening up on overpays would flip this fast.";
  } else {
    // High volatility — wins big or loses big
    tier = 'Swingy';
    tierCls = 'swingy';
    blurb = "You take big swings. Some land hard, others miss - but you're not playing it safe.";
  }

  // Volume label
  let volumeLabel;
  if (totalAllMine >= 30) volumeLabel = 'Heavy volume';
  else if (totalAllMine >= 15) volumeLabel = 'Active';
  else if (totalAllMine >= 6) volumeLabel = 'Moderate';
  else volumeLabel = 'Light volume';

  // Best & worst single trade for flavor
  let bestTrade = null, worstTrade = null;
  let bestDelta = -Infinity, worstDelta = Infinity;
  for (const t of myTrades) {
    const me = t.sides.find(s => s.isMe);
    const them = t.sides.find(s => !s.isMe);
    if (!me || !them) continue;
    const d = tradeSideScore(me) - tradeSideScore(them);
    if (d > bestDelta) { bestDelta = d; bestTrade = t; }
    if (d < worstDelta) { worstDelta = d; worstTrade = t; }
  }

  const sign = avgNetDelta > 0 ? '+' : '';
  const totalSign = netDelta > 0 ? '+' : '';

  return `
    <div class="trader-card trader-card-${tierCls}">
      <div class="trader-card-head">
        <div class="trader-card-tier-label">Your Trader Rating</div>
        <div class="trader-card-tier">${tier}</div>
        ${scopeLabel ? `<div class="trader-card-scope">${escapeHtml(scopeLabel)}</div>` : ''}
        <div class="trader-card-blurb">${blurb}</div>
      </div>
      <div class="trader-card-stats">
        <div class="trader-card-stat">
          <div class="trader-card-stat-num">${myTrades.length}</div>
          <div class="trader-card-stat-lbl" data-tooltip="${escapeHtml(TRADE_RECORD_RULE)}">scored trades · ${volumeLabel.toLowerCase()}</div>
        </div>
        <div class="trader-card-stat">
          <div class="trader-card-stat-num win">${wins}</div>
          <div class="trader-card-stat-lbl">won</div>
        </div>
        <div class="trader-card-stat">
          <div class="trader-card-stat-num">${fair}</div>
          <div class="trader-card-stat-lbl">fair</div>
        </div>
        <div class="trader-card-stat">
          <div class="trader-card-stat-num loss">${losses}</div>
          <div class="trader-card-stat-lbl">lost</div>
        </div>
        <div class="trader-card-stat">
          <div class="trader-card-stat-num ${avgNetDelta > 0 ? 'win' : avgNetDelta < 0 ? 'loss' : ''}">${sign}${formatCompactNumber(avgNetDelta)}</div>
          <div class="trader-card-stat-lbl" data-tooltip="Average value you came out ahead (+) or behind (-) per scored trade, at today's prices">avg per trade</div>
        </div>
        <div class="trader-card-stat">
          <div class="trader-card-stat-num ${netDelta > 0 ? 'win' : netDelta < 0 ? 'loss' : ''}">${totalSign}${formatCompactNumber(netDelta)}</div>
          <div class="trader-card-stat-lbl" data-tooltip="All scored trades added up: value received minus value sent, at today's prices">net value</div>
        </div>
      </div>
      <div class="trader-card-rule">${myTrades.length} scored of your ${rec.mine} trade${rec.mine === 1 ? '' : 's'}${rec.startup ? ' · ' + rec.startup + ' startup-draft' : ''}${rec.multi ? ' · ' + rec.multi + ' with 3+ teams' : ''} not scored. ${escapeHtml(TRADE_RECORD_RULE.split('. Scored')[0])}.</div>
      ${(bestTrade || worstTrade) ? `
        <div class="trader-card-foot">
          ${bestTrade && bestDelta > 200 ? `
            <div class="trader-card-fact">
              <span class="trader-card-fact-lbl">Best heist:</span>
              <span class="trader-card-fact-val">+${formatCompactNumber(bestDelta)}</span>
              <span class="trader-card-fact-meta">in ${escapeHtml(bestTrade.leagueName)}</span>
            </div>
          ` : ''}
          ${worstTrade && worstDelta < -200 ? `
            <div class="trader-card-fact">
              <span class="trader-card-fact-lbl">Roughest L:</span>
              <span class="trader-card-fact-val loss">${formatCompactNumber(worstDelta)}</span>
              <span class="trader-card-fact-meta">in ${escapeHtml(worstTrade.leagueName)}</span>
            </div>
          ` : ''}
        </div>
      ` : ''}
    </div>
  `;
}

;
/*! ==== 72-trade-pattern-panel.js ==== */
// Trade pattern intelligence panel — extracted from 28.

// The trade log is data; the pattern panel is intelligence. Things like
// "your league trades 40% more QBs than your cross-league baseline" or
// "you've been involved in 12 trades, averaging +180 net value" — these
// answers don't show up in any individual trade row.
//
// Computes against:
//   - filtered: the currently-visible subset (respects filter pill)
//   - global:   ALL trades across all leagues (for baseline comparison)
//   - filter:   the active filter ('all', 'mine', or a leagueId)
function buildTradePatternsPanel(filtered, global, filter) {
  if (filtered.length === 0) return '';

  // Position breakdown of every player traded in the filtered set.
  // Uses player.position (already enriched on each trade side).
  const tally = (trades) => {
    const posCount = { QB: 0, RB: 0, WR: 0, TE: 0 };
    let pickCount = 0;
    let myInvolved = 0;
    let totalSides = 0;
    for (const t of trades) {
      if (t.includesMe) myInvolved++;
      for (const s of t.sides) {
        totalSides++;
        for (const p of s.players) {
          if (posCount[p.position] != null) posCount[p.position]++;
        }
        pickCount += s.picks.length;
      }
    }
    const total = posCount.QB + posCount.RB + posCount.WR + posCount.TE;
    return { posCount, pickCount, myInvolved, totalSides, totalPlayers: total };
  };
  const f = tally(filtered);
  const g = tally(global);

  // Position skew: filtered's mix vs global mix. Flagged when delta > 5pp.
  const skews = [];
  for (const pos of ['QB', 'RB', 'WR', 'TE']) {
    const fPct = f.totalPlayers > 0 ? (f.posCount[pos] / f.totalPlayers) * 100 : 0;
    const gPct = g.totalPlayers > 0 ? (g.posCount[pos] / g.totalPlayers) * 100 : 0;
    skews.push({ pos, fPct, gPct, delta: fPct - gPct });
  }
  // Only call out the most extreme skew if it's meaningful
  const sortedSkew = [...skews].sort((a, b) => Math.abs(b.delta) - Math.abs(a.delta));
  const topSkew = sortedSkew[0];

  // Most-traded players in this filtered scope.
  // Two flavors:
  //   - 'all' filter (every trade across leagues, including ones I'm not in):
  //     no me-centric direction available, so we show a single "Most traded"
  //     list as before.
  //   - 'mine' filter or a specific league (where most/all visible trades are
  //     mine): split into "Acquired by me" and "Sent away by me" using the
  //     isMe side. Cleaner read of what you're moving toward and away from.
  const playerCounts = {};
  const acquiredCounts = {};
  const sentAwayCounts = {};
  for (const t of filtered) {
    for (const s of t.sides) {
      for (const p of s.players) {
        const key = p.playerId || p.name;
        if (!playerCounts[key]) playerCounts[key] = { name: p.name, position: p.position, count: 0, playerId: p.playerId };
        playerCounts[key].count++;
      }
    }
    if (t.includesMe && t.sides.length === 2) {
      const me = t.sides.find(s => s.isMe);
      const them = t.sides.find(s => !s.isMe);
      if (me) {
        for (const p of me.players) {
          const key = p.playerId || p.name;
          if (!acquiredCounts[key]) acquiredCounts[key] = { name: p.name, position: p.position, count: 0, playerId: p.playerId };
          acquiredCounts[key].count++;
        }
      }
      if (them) {
        for (const p of them.players) {
          const key = p.playerId || p.name;
          if (!sentAwayCounts[key]) sentAwayCounts[key] = { name: p.name, position: p.position, count: 0, playerId: p.playerId };
          sentAwayCounts[key].count++;
        }
      }
    }
  }
  const hotPlayers = Object.values(playerCounts)
    .filter(p => p.count >= 2)
    .sort((a, b) => b.count - a.count)
    .slice(0, 5);
  const topAcquired = Object.values(acquiredCounts)
    .filter(p => p.count >= 1)
    .sort((a, b) => b.count - a.count)
    .slice(0, 5);
  const topSentAway = Object.values(sentAwayCounts)
    .filter(p => p.count >= 1)
    .sort((a, b) => b.count - a.count)
    .slice(0, 5);
  // Decide which list shape to render: directional split when the user is
  // looking at their own trades, single "most traded" otherwise.
  const useDirectionalLists = (filter === 'mine' || filter !== 'all') && (topAcquired.length > 0 || topSentAway.length > 0);

  // My personal performance metrics (only if filter shows my trades)
  let mineHtml = '';
  // Startup-draft-era trades are priced as rookie picks (nonsense value), so
  // they're excluded from the verdict average.
  const myTrades = filtered.filter(t => t.includesMe && t.sides.length === 2 && !t.isStartup);
  if (myTrades.length > 0 && (filter === 'all' || filter === 'mine' || true)) {
    let netDelta = 0;
    let traded = 0;
    for (const t of myTrades) {
      const me = t.sides.find(s => s.isMe);
      const them = t.sides.find(s => !s.isMe);
      if (me && them) {
        netDelta += tradeSideScore(me) - tradeSideScore(them);
        traded++;
      }
    }
    const avgDelta = traded > 0 ? netDelta / traded : 0;
    const cls = avgDelta > 200 ? 'pos-net-pos' : avgDelta < -200 ? 'pos-net-neg' : 'pos-net-flat';
    const sign = avgDelta > 0 ? '+' : '';
    mineHtml = `
      <div class="tp-tile">
        <div class="tp-tile-label">Your avg per trade</div>
        <div class="tp-tile-num ${cls}">${sign}${formatCompactNumber(avgDelta)}</div>
        <div class="tp-tile-meta">across ${traded} scored trade${traded === 1 ? "" : "s"}</div>
      </div>
    `;
  }

  // Position skew tile (only when filter is a single league — comparing scoped vs cross-league)
  let skewHtml = '';
  if (filter !== 'all' && filter !== 'mine' && Math.abs(topSkew.delta) > 5) {
    const sign = topSkew.delta > 0 ? '+' : '';
    const cls = Math.abs(topSkew.delta) > 10 ? 'pos-net-pos' : 'pos-net-flat';
    skewHtml = `
      <div class="tp-tile">
        <div class="tp-tile-label">${topSkew.pos} trade rate</div>
        <div class="tp-tile-num ${cls}">${sign}${topSkew.delta.toFixed(0)}pp</div>
        <div class="tp-tile-meta">${topSkew.fPct.toFixed(0)}% of trades vs ${topSkew.gPct.toFixed(0)}% baseline</div>
      </div>
    `;
  }

  // Pick density tile
  const filteredPickPct = f.totalSides > 0 ? (f.pickCount / f.totalSides) : 0;
  const globalPickPct = g.totalSides > 0 ? (g.pickCount / g.totalSides) : 0;
  let pickHtml = '';
  if (filter !== 'all' && Math.abs(filteredPickPct - globalPickPct) > 0.2) {
    const delta = filteredPickPct - globalPickPct;
    const sign = delta > 0 ? '+' : '';
    pickHtml = `
      <div class="tp-tile">
        <div class="tp-tile-label">Pick density</div>
        <div class="tp-tile-num">${filteredPickPct.toFixed(1)}/side</div>
        <div class="tp-tile-meta">${sign}${delta.toFixed(2)} vs baseline</div>
      </div>
    `;
  }

  // Hot players list — single or two-column based on filter scope.
  let hotHtml = '';
  if (useDirectionalLists) {
    const renderChip = (p) => `
      <span class="tp-hot-chip ${p.playerId ? 'tp-hot-chip-clickable' : ''}"
            ${p.playerId ? `data-taco-player="${escapeHtml(p.playerId)}"` : ''}>
        ${escapeHtml(p.name)} <span class="tp-hot-count">${p.count}×</span>
      </span>
    `;
    hotHtml = `
      <div class="tp-hot-grid">
        <div class="tp-hot tp-hot-col">
          <div class="tp-hot-label tp-hot-label-acquired">Most traded <em>for</em></div>
          <div class="tp-hot-list">
            ${topAcquired.length > 0 ? topAcquired.map(renderChip).join('') : '<span class="tp-hot-empty">No repeat acquisitions yet</span>'}
          </div>
        </div>
        <div class="tp-hot tp-hot-col">
          <div class="tp-hot-label tp-hot-label-sent">Most traded <em>away</em></div>
          <div class="tp-hot-list">
            ${topSentAway.length > 0 ? topSentAway.map(renderChip).join('') : '<span class="tp-hot-empty">No repeat sends yet</span>'}
          </div>
        </div>
      </div>
    `;
  } else if (hotPlayers.length > 0) {
    hotHtml = `
      <div class="tp-hot">
        <div class="tp-hot-label">Most traded</div>
        <div class="tp-hot-list">
          ${hotPlayers.map(p => `
            <span class="tp-hot-chip ${p.playerId ? 'tp-hot-chip-clickable' : ''}"
                  ${p.playerId ? `data-taco-player="${escapeHtml(p.playerId)}"` : ''}>
              ${escapeHtml(p.name)} <span class="tp-hot-count">${p.count}×</span>
            </span>
          `).join('')}
        </div>
      </div>
    `;
  }

  // Always show the position mix bar — visual context for the rest of the panel
  const totalForBar = Math.max(1, skews.reduce((s, x) => s + x.fPct, 0));
  const mixBar = `
    <div class="tp-mix">
      <div class="tp-mix-label">Position mix in this view</div>
      <div class="tp-mix-bar">
        ${skews.map(s => s.fPct > 0 ? `
          <div class="tp-mix-seg tp-mix-${s.pos.toLowerCase()}"
               style="width: ${(s.fPct / totalForBar * 100).toFixed(1)}%"
               data-tooltip="${s.pos}: ${s.fPct.toFixed(0)}% of players traded">
            ${s.fPct >= 12 ? s.pos : ''}
          </div>
        ` : '').join('')}
      </div>
    </div>
  `;

  // Don't render the panel if nothing to show
  const hasContent = mineHtml || skewHtml || pickHtml || hotHtml;
  if (!hasContent && filtered.length < 3) return '';

  return `
    <div class="tp-panel">
      <div class="tp-panel-head">
        <span>Patterns</span>
        <span class="tp-panel-meta">${filtered.length} trade${filtered.length === 1 ? '' : 's'} analyzed</span>
      </div>
      ${(mineHtml || skewHtml || pickHtml) ? `
        <div class="tp-tiles">${mineHtml}${skewHtml}${pickHtml}</div>
      ` : ''}
      ${mixBar}
      ${hotHtml}
    </div>
  `;
}

;
/*! ==== 28-trade-pattern-analysis-surfaces-signals-from-you.js ==== */
// Trade patterns — panel → 72, leaderboards → 73.

;
/*! ==== 70-trade-history-fetch.js ==== */
// Trade history Sleeper fetch — extracted from 51.

// The single in-flight load, shared by every concurrent caller.
//
// This used to return null when a load was already running, and that froze the
// browser. renderTradeHistoryView answers a null by calling ITSELF again; it
// then sees tradeHistory still null, awaits fetchTradeHistory, gets an
// immediate null back, and recurses. Nothing in that loop ever waits on real
// work, so it spins as a microtask chain that never yields to the event loop --
// no paint, no input, no script injection. Two concurrent callers were enough,
// and this page has several (the view itself, the embedded league subtab, owner
// profiling, league-mate activity).
//
// Concurrent callers now await the same promise and all resolve together.
let tradeHistoryInFlight = null;

// Fetch completed trades across all leagues (Sleeper transactions API).
async function fetchTradeHistory() {
  if (STATE.tradeHistory !== null) return STATE.tradeHistory;
  if (tradeHistoryInFlight) return tradeHistoryInFlight;
  tradeHistoryInFlight = loadTradeHistory().finally(() => { tradeHistoryInFlight = null; });
  return tradeHistoryInFlight;
}

// One league's completed trades, priced and verdicted.
//
// This is the only implementation. The cross-league load below calls it once
// per league and the per-league fast path calls it directly, so the verdict
// math cannot drift between "the trades on this league's tab" and "the same
// trades inside the all-leagues board".
async function loadLeagueTrades(lg, opts = {}) {
  // Most valuable asset in this format: the verdict's tier-premium scale.
  const pool = typeof getValuePoolForTab === 'function' ? getValuePoolForTab(lg.scoringTab) : [];
  const poolMax = pool.reduce((m, x) => Math.max(m, x.value || 0), 0) || undefined;
  // `cache: false` for a league enriched as somebody else (the manager
  // dossier): the same league may be one of yours, and caching its trades
  // under that league id would hand your own Trade History someone else's
  // "me" flags.
  const useCache = opts.cache !== false;
  const cached = useCache && STATE.tradeHistoryByLeague[lg.league_id];
  if (cached) return cached;
  const allTrades = [];
  {
    const rosterLookup = {};
    for (const r of lg.allRosters) {
      rosterLookup[r.rosterId] = {
        // ownerId rides along so a manager can be followed ACROSS leagues.
        // Inside your own leagues Sleeper names every roster owner, not just
        // yours, so per-manager trade records here need no inference at all.
        ownerId: r.ownerId,
        ownerName: r.ownerName,
        teamName: r.teamName,
        isMe: r.isMe,
      };
    }

    // Startup-draft-era trades are pick-slot maneuvering during the initial
    // draft; their picks get priced as rookie picks (lookupPickValue), so the
    // "value" of these trades is nonsense and pollutes the win/loss verdicts.
    // Flag them so the stats can exclude them. The startup draft is the
    // high-round draft (25-32 rounds vs a rookie draft's ~4-5); a trade at or
    // before its last pick happened during/before the startup.
    const drafts = Array.isArray(lg.drafts) ? lg.drafts : [];
    const startupDraft = drafts
      .filter((d) => (d && d.settings && d.settings.rounds || 0) >= 10)
      .sort((a, b) => (b.settings.rounds || 0) - (a.settings.rounds || 0))[0] || null;
    const startupEndMs = startupDraft ? (startupDraft.last_picked || startupDraft.start_time || 0) : 0;

    try {
      // Only ask for weeks that could contain a transaction.
      //
      // This asked all 18, every league, unconditionally. With 29 leagues that
      // is 522 requests against a browser that opens 6 connections per host,
      // and the view awaits every one of them before it renders a single row.
      // Measured on 2026-09-01, one week before kickoff: all 1,382 transactions
      // across a sampled 8 leagues sat in week 1, and weeks 2-18 came back
      // empty every time. 94% of the requests could not have returned anything,
      // because a transaction cannot be recorded in a week that has not been
      // played.
      //
      // The bound is the league's own leg (Sleeper's current week) rather than
      // a global NFL week, since leagues can disagree, cross-checked against
      // the calendar in case one is stale, plus one week of slack. Preseason
      // that is 2 requests per league instead of 18; in week 10 it is 11.
      const nflWeek = (typeof TacoCore !== 'undefined' && TacoCore.resolveNflWeekContext)
        ? TacoCore.resolveNflWeekContext().week
        : 1;
      const currentWeek = Math.max(1, lg.settings?.leg || 1, nflWeek);
      const lastWeek = Math.min(18, currentWeek + 1);
      const weekPromises = [];
      for (let week = 1; week <= lastWeek; week++) {
        weekPromises.push(
          api(`/league/${lg.league_id}/transactions/${week}`)
            .catch(() => []),
        );
      }
      const weeklyTxns = await Promise.all(weekPromises);

      for (const weekTxns of weeklyTxns) {
        if (!Array.isArray(weekTxns)) continue;
        for (const txn of weekTxns) {
          if (txn.type !== 'trade') continue;
          if (txn.status !== 'complete') continue;

          const rosterIds = txn.roster_ids || [];
          if (rosterIds.length < 2) continue;

          const sides = {};
          for (const rid of rosterIds) {
            sides[rid] = { rosterId: rid, players: [], picks: [], faab: 0, ...rosterLookup[rid] };
          }

          for (const [playerId, receivingRid] of Object.entries(txn.adds || {})) {
            if (!sides[receivingRid]) sides[receivingRid] = { rosterId: receivingRid, players: [], picks: [], faab: 0, ...rosterLookup[receivingRid] };
            const p = STATE.playersDB?.[playerId];
            if (!p) continue;
            const fullName = (p.full_name || `${p.first_name || ''} ${p.last_name || ''}`).trim();
            const position = TacoCore.primaryFantasyPosition(p);
            const match = lookupPlayerValue(playerId, fullName, position, lg.scoringTab);
            sides[receivingRid].players.push({
              playerId,
              name: fullName,
              position,
              value: match?.value || 0,
            });
          }

          for (const pk of (txn.draft_picks || [])) {
            const receivingRid = pk.owner_id;
            if (!sides[receivingRid]) sides[receivingRid] = { rosterId: receivingRid, players: [], picks: [], faab: 0, ...rosterLookup[receivingRid] };
            const originalOwnerName = rosterLookup[pk.roster_id]?.teamName || rosterLookup[pk.roster_id]?.ownerName || 'Unknown';
            const slotInfo = lg.slotsBySeason?.[pk.season]?.[pk.roster_id];
            const slot = slotInfo?.slot || null;
            const baseLabel = slot
              ? `${pk.season} ${pk.round}.${String(slot).padStart(2, '0')}`
              : `${pk.season} ${ordinal(pk.round)}`;
            const label = pk.roster_id !== pk.owner_id
              ? `${baseLabel} (from ${originalOwnerName})`
              : baseLabel;
            const { value: pickValue } = lookupPickValue({ season: pk.season, round: pk.round, slot }, lg.scoringTab, pickContextFor(lg));
            sides[receivingRid].picks.push({
              season: pk.season,
              round: pk.round,
              slot,
              originalOwnerName,
              label,
              value: pickValue || 0,
            });
          }

          for (const wb of (txn.waiver_budget || [])) {
            if (sides[wb.receiver]) sides[wb.receiver].faab += wb.amount;
          }

          const sideList = Object.values(sides).filter(s => s.players.length + s.picks.length + s.faab > 0);
          if (sideList.length < 2) continue;

          for (const s of sideList) {
            // allow-inline-roster-sum: one side of a trade, not a roster
            s.totalValue = s.players.reduce((x, p) => x + (p.value || 0), 0) +
                           // allow-inline-roster-sum: continuation of the trade-side sum above
                           s.picks.reduce((x, p) => x + (p.value || 0), 0);
          }

          let verdict = null;
          let winnerRosterId = null;
          if (sideList.length === 2) {
            // The Trade Calculator's verdict, not a rule of its own (Owen,
            // 2026-09-27: "yes" to moving History onto the calculator's rule).
            // This used raw value with a 6% band; the calculator judges
            // effective value -- stars carry a tier premium, extra pieces are
            // discounted -- with a 5% band. tradeVerdict takes what each side
            // GIVES, which is what the other side received.
            const [a, b] = sideList;
            const recv = (s) => [...s.players, ...s.picks].map((x) => x.value || 0).filter((v) => v > 0);
            if (a.totalValue + b.totalValue > 0 && TacoCore.tradeVerdict) {
              const r = TacoCore.tradeVerdict(recv(b), recv(a), poolMax);
              a.effectiveValue = r.aReceives.effective;
              b.effectiveValue = r.bReceives.effective;
              if (r.fair) verdict = 'fair';
              else if (r.winner === 'a') { verdict = 'a-wins'; winnerRosterId = a.rosterId; }
              else { verdict = 'b-wins'; winnerRosterId = b.rosterId; }
            }
          } else if (sideList.length >= 3) {
            verdict = 'multi';
          }

          allTrades.push({
            tradeId: txn.transaction_id,
            leagueId: lg.league_id,
            leagueName: lg.name,
            scoringTab: lg.scoringTab,
            season: lg.season,
            week: txn.leg,
            statusUpdated: txn.status_updated,
            rawTxn: txn,
            sides: sideList,
            verdict,
            winnerRosterId,
            includesMe: sideList.some(s => s.isMe),
            // Trade happened during/before the startup draft -> its values are
            // startup-pick nonsense; excluded from verdict stats, flagged in list.
            isStartup: !!(startupEndMs && txn.status_updated && txn.status_updated <= startupEndMs),
          });
        }
      }
    } catch (e) {
      console.error(`Failed to load trades for ${lg.name}:`, e);
    }
  }

  allTrades.sort((a, b) => (b.statusUpdated || 0) - (a.statusUpdated || 0));
  if (useCache) STATE.tradeHistoryByLeague[lg.league_id] = allTrades;
  return allTrades;
}

// One league on its own, for the tab that only needs that league. Same
// in-flight dedupe as the cross-league load, keyed per league, so a second
// caller waits on the real work instead of getting a null back.
const leagueTradesInFlight = {};
function fetchLeagueTradeHistory(lg) {
  if (!lg?.league_id) return Promise.resolve([]);
  const id = lg.league_id;
  if (STATE.tradeHistoryByLeague[id]) return Promise.resolve(STATE.tradeHistoryByLeague[id]);
  if (leagueTradesInFlight[id]) return leagueTradesInFlight[id];
  leagueTradesInFlight[id] = loadLeagueTrades(lg)
    .catch((e) => { console.error(`Failed to load trades for ${lg.name}:`, e); return []; })
    .finally(() => { delete leagueTradesInFlight[id]; });
  return leagueTradesInFlight[id];
}
window.fetchLeagueTradeHistory = fetchLeagueTradeHistory;

async function loadTradeHistory() {
  STATE.tradeHistoryLoading = true;
  const allTrades = [];
  for (const lg of STATE.leagues) {
    allTrades.push(...await loadLeagueTrades(lg));
  }

  allTrades.sort((a, b) => (b.statusUpdated || 0) - (a.statusUpdated || 0));
  STATE.tradeHistory = allTrades;
  STATE.tradeHistoryLoading = false;
  if (window.TacoCrawl && TacoCrawl.pushFromTradeHistory) {
    TacoCrawl.pushFromTradeHistory(allTrades).catch(function (e) {
      console.warn('[crawl] history push', e.message);
    });
  }
  return allTrades;
}
window.fetchTradeHistory = fetchTradeHistory;



/** A side's value as the verdict judges it: effective (tier premium, piece
 * discount) when scored, raw otherwise. Every "who came out ahead, by how
 * much" on Trade History reads this, so a margin can never disagree with the
 * won/lost badge next to it. Raw totalValue stays for "value moved". */
function tradeSideScore(s) {
  if (!s) return 0;
  return s.effectiveValue != null ? s.effectiveValue : (s.totalValue || 0);
}
window.tradeSideScore = tradeSideScore;

// ---------------------------------------------------------------------------
// Realized-points grade: how a completed trade ACTUALLY played out.
//
// Every other verdict in this app prices a trade. That is the right question
// the day it is made and the wrong one in November, when the league already
// knows who won. This counts the points each side's acquisitions scored IN
// THAT SIDE'S STARTING LINEUP after the trade -- bench points helped nobody
// win anything -- and resolves a traded pick into the player taken with it.
//
// The math is `shared/trade-realized.mjs` (18 tests). This file only fetches.
//
// Cost: one Sleeper matchups call per played week, per league, once, cached.
// For a league in week 9 that is at most 8 calls, and it is lazy -- nothing
// loads until a trade's grade is actually wanted. Doing this for all 31
// leagues up front would be ~250 requests against a browser that opens 6 per
// host, which is the mistake the weekly-transactions bound already documents
// above.
const realizedCtxInFlight = {};

/** Normalise a Sleeper matchup row to what the grader reads. Keeping this
 * narrow means the tested module never has to know Sleeper's shape. */
function normalizeMatchupRow(row) {
  return {
    starters: (row.starters || []).map(String),
    points: row.players_points || {},
    players: (row.players || []).map(String),
    startersPoints: row.starters_points || [],
  };
}

/** Load every played week's lineups for one league, plus the drafts any
 * traded pick would resolve through. Cached per league; concurrent callers
 * share one load. */
function loadRealizedTradeContext(lg) {
  if (!lg?.league_id) return Promise.resolve(null);
  const id = lg.league_id;
  const cached = STATE.tradeRealizedByLeague[id];
  if (cached) return Promise.resolve(cached);
  if (realizedCtxInFlight[id]) return realizedCtxInFlight[id];

  realizedCtxInFlight[id] = (async () => {
    // The last week with real results. Sleeper's own leg leads the calendar
    // during a week in progress, so take the lower of the two and never count
    // a week that is still being played.
    const nflWeek = (typeof TacoCore !== 'undefined' && TacoCore.resolveNflWeekContext)
      ? (TacoCore.resolveNflWeekContext().week || 1)
      : 1;
    const leg = Number(lg.settings?.leg) || nflWeek;
    const throughWeek = Math.max(0, Math.min(18, Math.min(leg, nflWeek) - 1));
    if (throughWeek < 1) {
      const empty = { weeks: {}, throughWeek: 0, resolvePick: () => null, ready: true };
      STATE.tradeRealizedByLeague[id] = empty;
      return empty;
    }

    const weekNums = [];
    for (let w = 1; w <= throughWeek; w += 1) weekNums.push(w);
    const rows = await Promise.all(weekNums.map(async (w) => {
      try {
        const r = await api(`/league/${id}/matchups/${w}`);
        return { week: w, rows: Array.isArray(r) ? r : [] };
      } catch (_e) {
        return { week: w, rows: [] };
      }
    }));

    const weeks = {};
    for (const { week, rows: wk } of rows) {
      if (!wk.length) continue;
      const byRoster = {};
      for (const r of wk) {
        if (r?.roster_id == null) continue;
        byRoster[r.roster_id] = normalizeMatchupRow(r);
      }
      weeks[week] = byRoster;
    }

    // Drafts, for picks that have already turned into players. Only the
    // completed ones are worth fetching -- a draft still in progress resolves
    // to nothing useful and the grade reports the pick as outstanding.
    const draftsBySeason = {};
    const completed = (Array.isArray(lg.drafts) ? lg.drafts : [])
      .filter((d) => d && d.draft_id && d.status === 'complete');
    await Promise.all(completed.map(async (d) => {
      try {
        const picks = await api(`/draft/${d.draft_id}/picks`);
        if (!Array.isArray(picks) || !picks.length) return;
        draftsBySeason[String(d.season)] = {
          picks,
          slotToRosterId: d.slot_to_roster_id || null,
          draftOrder: d.draft_order || null,
        };
      } catch (_e) { /* a draft we cannot read just leaves its picks pending */ }
    }));

    const rosterOwnerIds = {};
    for (const r of lg.allRosters || []) rosterOwnerIds[r.rosterId] = r.ownerId;

    const ctx = {
      weeks,
      throughWeek,
      ready: true,
      resolvePick: TacoCore.buildPickResolver({ draftsBySeason, rosterOwnerIds }),
    };
    STATE.tradeRealizedByLeague[id] = ctx;
    return ctx;
  })()
    .catch((e) => {
      console.warn(`[realized] ${lg.name}: ${e.message}`);
      const failed = { weeks: {}, throughWeek: 0, resolvePick: () => null, ready: true, error: true };
      STATE.tradeRealizedByLeague[id] = failed;
      return failed;
    })
    .finally(() => { delete realizedCtxInFlight[id]; });

  return realizedCtxInFlight[id];
}
window.loadRealizedTradeContext = loadRealizedTradeContext;

/** The grade for one trade, or null when this league's weeks are not loaded.
 * Synchronous on purpose: render paths call it freely and get null until the
 * context lands, exactly like the SOS and season-projection panels. */
function realizedGradeFor(trade) {
  if (!trade || trade.isStartup) return null;
  const ctx = STATE.tradeRealizedByLeague[trade.leagueId];
  if (!ctx?.ready || ctx.error) return null;
  const key = trade.tradeId;
  const hit = STATE.tradeRealizedGrades[key];
  if (hit !== undefined) return hit;
  const grade = TacoCore.gradeTradeByRealizedPoints({
    sides: trade.sides,
    tradeWeek: Number(trade.week) || 0,
    throughWeek: ctx.throughWeek,
    weeks: ctx.weeks,
    resolvePick: ctx.resolvePick,
  });
  STATE.tradeRealizedGrades[key] = grade;
  return grade;
}
window.realizedGradeFor = realizedGradeFor;

;
/*! ==== 73-trade-league-leaderboards.js ==== */
// Per-league trade leaderboards + fleecerboard — extracted from 28.

// ============================================================
// LEAGUE LEADERBOARDS — per-manager value-gain and ROI over time, plus
// a "Fleecerboard" of the most lopsided individual trades in a league.
// ============================================================
function renderLeagueLeaderboards(lg, trades) {
  // Aggregate per-manager stats: total value gained (sum of deltas),
  // # trades, investment (sum of absolute losses), ROI (gain / investment).
  const managers = new Map(); // rosterId → stats
  for (const r of lg.allRosters) {
    managers.set(r.rosterId, {
      rosterId: r.rosterId,
      ownerName: r.ownerName,
      teamName: r.teamName,
      isMe: r.isMe,
      trades: 0,
      totalGain: 0,       // sum of value gained across all trades (winner gains, loser loses)
      totalGiven: 0,      // sum of value given away (i.e., what you put at risk / invested)
      wins: 0,
      losses: 0,
      fairs: 0,
    });
  }

  // Score each 2-sided trade into each manager's stats
  const lopsided = []; // for fleecerboard
  for (const t of trades) {
    if (t.sides.length !== 2) continue; // skip 3-team trades from leaderboard math
    if (t.isStartup) continue; // startup-draft-era trades are priced wrong (rookie-pick values)
    const [a, b] = t.sides;
    const aStats = managers.get(a.rosterId);
    const bStats = managers.get(b.rosterId);
    if (!aStats || !bStats) continue;

    aStats.trades++;
    bStats.trades++;
    aStats.totalGiven += a.totalValue;
    bStats.totalGiven += b.totalValue;

    const delta = tradeSideScore(a) - tradeSideScore(b);
    aStats.totalGain += delta;  // positive = a gained value
    bStats.totalGain -= delta;  // negated for b

    if (t.verdict === 'fair') {
      aStats.fairs++;
      bStats.fairs++;
    } else if (t.verdict === 'a-wins') {
      aStats.wins++;
      bStats.losses++;
    } else if (t.verdict === 'b-wins') {
      bStats.wins++;
      aStats.losses++;
    }

    // Fleecerboard: capture every non-fair trade with its advantage
    if (t.verdict === 'a-wins' || t.verdict === 'b-wins') {
      const winnerSide = t.verdict === 'a-wins' ? a : b;
      const loserSide = t.verdict === 'a-wins' ? b : a;
      const advantage = tradeSideScore(winnerSide) - tradeSideScore(loserSide);
      const pct = tradeSideScore(loserSide) > 0 ? advantage / tradeSideScore(loserSide) : 0;
      lopsided.push({
        trade: t,
        winner: winnerSide,
        loser: loserSide,
        advantage,
        pct,
      });
    }
  }

  // Compute ROI for each manager: totalGain / totalGiven
  for (const m of managers.values()) {
    m.roi = m.totalGiven > 0 ? m.totalGain / m.totalGiven : 0;
    m.avgInvestment = m.trades > 0 ? m.totalGiven / m.trades : 0;
  }

  // Rank managers by total value gain desc
  const ranked = [...managers.values()]
    .filter(m => m.trades > 0)
    .sort((a, b) => b.totalGain - a.totalGain);

  // Rank fleecerboard by advantage desc, top 10
  lopsided.sort((a, b) => b.advantage - a.advantage);
  const topFleeces = lopsided.slice(0, 10);

  if (ranked.length === 0) {
    return `<div class="tab-empty">No completed trades in ${escapeHtml(lg.name)} yet.</div>`;
  }

  // Render leaderboard
  const leaderboardRows = ranked.map((m, idx) => {
    const rank = idx + 1;
    const gainClass = m.totalGain > 0 ? 'lb-gain-pos' : m.totalGain < 0 ? 'lb-gain-neg' : '';
    const roiPct = (m.roi * 100).toFixed(1);
    const roiClass = m.roi > 0 ? 'lb-gain-pos' : m.roi < 0 ? 'lb-gain-neg' : '';
    return `
      <div class="lb-row ${m.isMe ? 'mine' : ''}">
        <div class="lb-rank">${rank}</div>
        <div class="lb-team">
          <div class="lb-team-name">${m.isMe ? '<strong>You</strong>' : escapeHtml(m.teamName || m.ownerName || 'Unknown')}</div>
          <div class="lb-team-meta">${m.wins}W · ${m.losses}L · ${m.fairs} fair · ${m.trades} total</div>
        </div>
        <div class="lb-stat ${gainClass}">
          ${m.totalGain >= 0 ? '+' : ''}${Math.round(m.totalGain).toLocaleString()}
          <span class="lb-stat-label">value gain</span>
        </div>
        <div class="lb-stat ${roiClass}">
          ${m.roi >= 0 ? '+' : ''}${roiPct}%
          <span class="lb-stat-label">ROI</span>
        </div>
        <div class="lb-stat">
          ${Math.round(m.avgInvestment).toLocaleString()}
          <span class="lb-stat-label">avg stake</span>
        </div>
      </div>
    `;
  }).join('');

  // Render fleecerboard
  const fleeceRows = topFleeces.length === 0
    ? '<div class="lb-empty">No lopsided trades recorded yet.</div>'
    : topFleeces.map((f, idx) => {
      const rank = idx + 1;
      const winnerName = f.winner.isMe ? 'You' : (f.winner.teamName || f.winner.ownerName || 'Unknown');
      const loserName = f.loser.isMe ? 'You' : (f.loser.teamName || f.loser.ownerName || 'Unknown');
      const winnerAssets = [
        ...f.winner.players.slice(0, 3).map(p => escapeHtml(p.name)),
        ...f.winner.picks.slice(0, 2).map(p => escapeHtml(p.label)),
      ].join(', ') + (f.winner.players.length + f.winner.picks.length > 5 ? '…' : '');
      const loserAssets = [
        ...f.loser.players.slice(0, 3).map(p => escapeHtml(p.name)),
        ...f.loser.picks.slice(0, 2).map(p => escapeHtml(p.label)),
      ].join(', ') + (f.loser.players.length + f.loser.picks.length > 5 ? '…' : '');
      const mineClass = f.winner.isMe || f.loser.isMe ? 'mine' : '';
      return `
        <div class="fb-row ${mineClass}">
          <div class="fb-rank">${rank}</div>
          <div class="fb-body">
            <div class="fb-headline">
              <strong class="fb-winner">${escapeHtml(winnerName)}</strong> fleeced
              <strong class="fb-loser">${escapeHtml(loserName)}</strong>
              <span class="fb-advantage">+${Math.round(f.advantage).toLocaleString()} (${(f.pct * 100).toFixed(0)}%)</span>
            </div>
            <div class="fb-detail">
              <span class="fb-gain">Got: ${winnerAssets} <span class="fb-val">(${Math.round(f.winner.totalValue).toLocaleString()})</span></span>
              <span class="fb-gave">Gave: ${loserAssets} <span class="fb-val">(${Math.round(f.loser.totalValue).toLocaleString()})</span></span>
            </div>
          </div>
        </div>
      `;
    }).join('');

  return `
    <div class="lb-panel">
      <div class="lb-panel-head">
        <div class="lb-panel-title">${escapeHtml(lg.name)} - Trade Leaderboard</div>
        <div class="lb-panel-sub">Cumulative value gained in completed trades · ${ranked.length} active traders · ${trades.length} trades</div>
      </div>
      <div class="lb-rows">${leaderboardRows}</div>
    </div>
    <div class="fb-panel">
      <div class="fb-panel-head">
        <div class="fb-panel-title">Fleecerboard - Top ${topFleeces.length} most lopsided trades</div>
        <div class="fb-panel-sub">Trades with the largest value imbalance at the time</div>
      </div>
      <div class="fb-rows">${fleeceRows}</div>
    </div>
  `;
}

;
/*! ==== 71-trade-history-render.js ==== */
// Trade history filters + view render — extracted from 51.

// Trade history fetch, filters, and view rendering.
// Extracted from trade-pattern (28) — patterns/leaderboards stay in 28.

/** One completed trade: both sides, every asset priced, and the verdict.
 *
 * withHead=false drops the league name and date, for callers that already sit
 * inside one league and have just shown the date themselves -- Leaguemate
 * activity on League Overview expands into this rather than sending anyone to
 * the Trade History page (Owen, 2026-10-18: "you should still be able to click
 * open the trade to see what the values would be but no need to swap to the
 * whole other page"). The verdict badge is kept either way: it is the answer
 * people open the row for. */
/** How a completed trade actually played out: the points each side's
 * acquisitions scored IN THAT SIDE'S STARTING LINEUP since the trade.
 *
 * The verdict above this strip prices the trade. This one grades it. They
 * disagree often, and that is the whole point -- the value verdict is what
 * the market thought, this is what the field did. Bench points are excluded
 * on purpose: a 24-point day on your bench won nothing.
 *
 * Returns '' for startup-draft trades (their assets are slot maneuvering) and
 * a load button when this league's weeks have not been fetched yet, because
 * that is 8 Sleeper calls and nobody should pay them for a row they scrolled
 * past. */
function renderRealizedStrip(t, meLabel = 'You') {
  if (!t || t.isStartup) return '';
  const grade = typeof realizedGradeFor === 'function' ? realizedGradeFor(t) : null;
  if (!grade) {
    return `<div class="thr-strip thr-idle">
      <button class="ghost small" data-taco-realized="${escapeHtml(t.leagueId)}">How it played out</button>
      <span class="thr-idle-note">Counts the points each side actually started since the trade</span>
    </div>`;
  }

  const conf = TacoCore.realizedGradeConfidence(grade.weeksCounted, grade.anyPending);
  if (grade.verdict === 'too-early') {
    return `<div class="thr-strip">
      <div class="thr-head"><span class="thr-label">On the field</span>
      <span class="thr-conf">${escapeHtml(conf.label)}</span></div>
    </div>`;
  }

  const sideHtml = grade.sides.map((s) => {
    const who = s.isMe ? escapeHtml(meLabel) : escapeHtml((s.teamName || s.ownerName || 'Side').split(' ')[0]);
    const assets = s.assets.map((a) => {
      if (a.pending) {
        return `<span class="thr-asset pending">${escapeHtml(a.label)} <em>not drafted yet</em></span>`;
      }
      // "Started 0 of 7" is the story on an acquisition that got benched, and
      // it is invisible if only the points are shown.
      const starts = a.startedWeeks === 1 ? '1 start' : `${a.startedWeeks} starts`;
      const benched = a.benchedWeeks > 0
        ? ` · <span class="thr-benched">benched ${a.benchedWeeks}\u00d7</span>`
        : '';
      return `<span class="thr-asset"${a.playerId ? ` data-taco-player="${escapeHtml(a.playerId)}"` : ''}>${escapeHtml(a.label)} <strong>${a.points.toFixed(1)}</strong> <span class="thr-starts">\u00b7 ${starts}${benched}</span></span>`;
    }).join('');
    const won = grade.winnerRosterId != null && s.rosterId === grade.winnerRosterId;
    return `<div class="thr-side ${won ? 'won' : ''}">
      <div class="thr-side-head"><span class="thr-who">${who}</span><span class="thr-pts">${s.realizedPoints.toFixed(1)}</span></div>
      <div class="thr-assets">${assets || '<span class="thr-asset pending">nothing</span>'}</div>
    </div>`;
  }).join('');

  let badge;
  if (grade.verdict === 'even') {
    badge = '<span class="thr-verdict even">Even so far</span>';
  } else if (grade.verdict === 'multi') {
    badge = '<span class="thr-verdict even">3-team</span>';
  } else {
    const w = grade.sides.find((s) => s.rosterId === grade.winnerRosterId);
    const cls = t.includesMe ? (w?.isMe ? 'me-won' : 'me-lost') : 'other';
    const name = w?.isMe ? escapeHtml(meLabel) : escapeHtml((w?.teamName || w?.ownerName || 'Side').split(' ')[0]);
    badge = `<span class="thr-verdict ${cls}">${name} +${Math.abs(grade.differential).toFixed(1)} pts</span>`;
  }

  return `
    <div class="thr-strip">
      <div class="thr-head">
        <span class="thr-label" data-tooltip="Fantasy points each side's acquisitions scored in that side's STARTING lineup, from the week after the trade. Bench points are excluded. A traded pick counts as the player drafted with it.">On the field</span>
        <span class="thr-conf">${escapeHtml(conf.label)}</span>
        ${badge}
      </div>
      <div class="thr-sides">${sideHtml}</div>
    </div>
  `;
}
window.renderRealizedStrip = renderRealizedStrip;

function renderTradeHistoryRow(t, { withHead = true, meLabel = 'You' } = {}) {
  const dateStr = formatTradeDate(t.statusUpdated);

  const sidesHtml = t.sides.map(s => {
    const isWinner = s.rosterId === t.winnerRosterId;
    const teamLabel = s.isMe
      ? `<strong class="th-side-me">${escapeHtml(meLabel)}</strong>`
      : `<strong class="th-side-name th-side-clickable"
                 data-taco-owner="${escapeHtml(t.leagueId)}|${s.rosterId}"
                 data-tooltip="See trade profile">${escapeHtml(s.teamName || s.ownerName || 'Unknown')}</strong>`;

    const items = [
      ...s.players.map(p => {
        const pid = p.playerId;
        return `<span class="th-asset ${pid ? 'th-asset-clickable' : ''}"
                      ${pid ? `data-taco-player="${escapeHtml(pid)}"` : ''}>${escapeHtml(p.name)} <span class="th-asset-val">${p.value ? Math.round(p.value).toLocaleString() : '-'}</span></span>`;
      }),
      ...s.picks.map(p => `<span class="th-asset th-pick">${escapeHtml(p.label)} <span class="th-asset-val">${p.value ? Math.round(p.value).toLocaleString() : '-'}</span></span>`),
      ...(s.faab > 0 ? [`<span class="th-asset">$${s.faab} FAAB</span>`] : []),
    ].join('');

    return `
      <div class="th-side ${isWinner ? 'won' : ''}">
        <div class="th-side-head">
          ${teamLabel}
          <span class="th-side-total">${Math.round(s.totalValue).toLocaleString()}${s.effectiveValue != null && Math.round(s.effectiveValue) !== Math.round(s.totalValue) ? ` <span class="proposal-eff" data-tooltip="Effective value: what the verdict judges on - stars carry a premium, extra pieces are discounted">eff. ${Math.round(s.effectiveValue).toLocaleString()}</span>` : ''}</span>
        </div>
        <div class="th-assets">${items || '<span class="th-asset empty">nothing</span>'}</div>
      </div>
    `;
  }).join('<div class="th-arrow">↔</div>');

  let verdictBadge = '';
  if (t.verdict === 'fair') {
    verdictBadge = '<span class="th-verdict fair">Fair</span>';
  } else if (t.verdict === 'a-wins' || t.verdict === 'b-wins') {
    const winner = t.sides.find(s => s.rosterId === t.winnerRosterId);
    const loser = t.sides.find(s => s.rosterId !== t.winnerRosterId);
    // Same measure as the calculator's "wins by N (P% in effective value)".
    const diff = tradeSideScore(winner) - tradeSideScore(loser);
    const pct = tradeSideScore(loser) > 0 ? ((diff / tradeSideScore(loser)) * 100).toFixed(1) : '100.0';
    verdictBadge = `<span class="th-verdict ${t.includesMe && winner.isMe ? 'me-won' : t.includesMe ? 'me-lost' : 'other'}">${winner.isMe ? escapeHtml(meLabel) + ' won' : escapeHtml((winner.teamName || winner.ownerName || 'Side').split(' ')[0]) + ' won'} +${Math.round(diff).toLocaleString()} (${pct}%)</span>`;
  } else if (t.verdict === 'multi') {
    verdictBadge = '<span class="th-verdict other">3-team</span>';
  } else {
    verdictBadge = '<span class="th-verdict other">-</span>';
  }
  // Startup-draft-era trade: its pick values are priced as rookie picks, so the
  // win/loss verdict is meaningless. Flag it and drop the bogus verdict (it's
  // already excluded from the aggregate stats).
  if (t.isStartup) {
    verdictBadge = '<span class="th-verdict startup" data-tooltip="Trade during the startup draft - pick values are draft-slot maneuvering, so it is left out of your trade verdicts">Startup draft</span>';
  }

  const headHtml = withHead
    ? `<div class="th-row-head">
        <div>
          <div class="th-row-league">${escapeHtml(t.leagueName)}</div>
          <div class="th-row-meta">${dateStr} · ${t.scoringTab}</div>
        </div>
        ${verdictBadge}
      </div>`
    : `<div class="th-row-head th-row-head-bare">${verdictBadge}</div>`;

  return `
    <div class="th-row ${t.includesMe ? 'mine' : ''}">
      ${headHtml}
      <div class="th-sides">${sidesHtml}</div>
      ${renderRealizedStrip(t, meLabel)}
    </div>
  `;
}
window.renderTradeHistoryRow = renderTradeHistoryRow;

function setTradeHistoryFilter(filter) {
  // The league picker shows a "Filter by league" placeholder while the My
  // trades pill is active, so the dropdown does not claim "All leagues" over a
  // filtered board. Selecting the placeholder itself is not a filter.
  if (filter === '_placeholder') return;
  STATE.tradeHistoryFilter = filter;
  STATE.tradeHistoryShown = 25; // new filter, fresh page
  rerenderTradeHistory();
}
window.setTradeHistoryFilter = setTradeHistoryFilter;

function showMoreTradeHistory() {
  STATE.tradeHistoryShown = (STATE.tradeHistoryShown || 25) + 25;
  rerenderTradeHistory();
}
window.showMoreTradeHistory = showMoreTradeHistory;

function showAllTradeHistory() {
  STATE.tradeHistoryShown = 100000;
  rerenderTradeHistory();
}
window.showAllTradeHistory = showAllTradeHistory;

function refreshTradeHistory() {
  STATE.tradeHistory = null;
  STATE.tradeHistoryByLeague = {};
  rerenderTradeHistory();
}
window.refreshTradeHistory = refreshTradeHistory;

// --- trade history view (moved from owner-profiling 26) ---

function formatTradeDate(ms) {
  if (!ms) return '';
  const d = new Date(ms);
  const now = new Date();
  const opts = d.getFullYear() === now.getFullYear()
    ? { month: 'short', day: 'numeric' }
    : { month: 'short', day: 'numeric', year: 'numeric' };
  return d.toLocaleDateString('en-US', opts);
}

function getTradeHistoryContainer() {
  // Only use the team-detail subtab slot when the TEAM view is actually the one
  // on screen (deep link to a league's /trade-history). When the standalone
  // Trade History view is active, always target its own container, even if
  // teamDetailTab is left over as 'tradeHistory' from an earlier visit.
  const teamActive = document.getElementById('teamView')?.classList.contains('active');
  if (teamActive && STATE.teamDetailTab === 'tradeHistory') {
    const slot = document.getElementById('tradeHistorySubtabSlot');
    if (slot) return slot;
  }
  return document.getElementById('tradeHistoryContent');
}

async function initTradeHistoryInSubtab() {
  const slot = document.getElementById('tradeHistorySubtabSlot');
  if (!slot) return;
  if (window.TacoAuth && !TacoAuth.hasFreeAccount()) {
    slot.innerHTML = TacoAuth.gateHtml('tradeHistory');
    return;
  }
  await renderTradeHistoryView(slot);
}
window.initTradeHistoryInSubtab = initTradeHistoryInSubtab;

async function renderTradeHistoryView(container) {
  container = container || getTradeHistoryContainer();
  if (!container) return;
  const embedded = container.id === 'tradeHistorySubtabSlot';
  if (window.TacoAuth && !TacoAuth.hasFreeAccount()) {
    container.innerHTML = TacoAuth.gateHtml('tradeHistory');
    return;
  }

  // Per-league fast path.
  //
  // On a league's own Trade History tab the filter is already pinned to that
  // league, so waiting for all 30 leagues before drawing anything is waiting
  // for ~28 leagues of data that this screen will not show. One league is two
  // requests. The rest still loads, in the background, and the view re-renders
  // once when it arrives to fill in the cross-league numbers.
  const selectedLeague = (STATE.tradeHistoryFilter
    && STATE.tradeHistoryFilter !== 'all'
    && STATE.tradeHistoryFilter !== 'mine')
    ? STATE.leagues.find((l) => l.league_id === STATE.tradeHistoryFilter)
    : null;

  if (STATE.tradeHistory === null && selectedLeague && typeof fetchLeagueTradeHistory === 'function') {
    if (!STATE.tradeHistoryByLeague[selectedLeague.league_id]) {
      container.innerHTML = `
        <div class="loader">
          <div class="loader-bar"></div>
          <div class="loader-text">Pulling trades from ${escapeHtml(selectedLeague.name)}…</div>
        </div>
      `;
      await fetchLeagueTradeHistory(selectedLeague);
    }
    // One league in view: fetch its played weeks too, so the realized grade is
    // just there rather than behind a button. Scoped to this league only --
    // doing it for all 31 would be ~250 requests, which is the mistake the
    // weekly-transactions bound in module 70 already documents.
    if (typeof loadRealizedTradeContext === 'function'
      && !STATE.tradeRealizedByLeague[selectedLeague.league_id]) {
      loadRealizedTradeContext(selectedLeague)
        .then(() => renderTradeHistoryView())
        .catch((e) => console.warn('[realized] background load', e.message));
    }
    // Backfill the other leagues without blocking this render. fetchTradeHistory
    // dedupes its own in-flight load, so calling it again on a later render is
    // free rather than a second sweep.
    fetchTradeHistory()
      .then((all) => { if (all) renderTradeHistoryView(); })
      .catch((e) => console.warn('[trade-history] background load', e.message));
  }

  if (STATE.tradeHistory === null && !STATE.tradeHistoryByLeague[selectedLeague?.league_id]) {
    container.innerHTML = `
      <div class="loader">
        <div class="loader-bar"></div>
        <div class="loader-text">Pulling trades from ${STATE.leagues.length} leagues…</div>
      </div>
    `;
    const loaded = await fetchTradeHistory();
    // Re-render only once the data is actually here. Recursing on a null
    // result is what spun the microtask loop that froze the tab; if the load
    // genuinely failed, say so rather than trying again forever.
    if (loaded === null && STATE.tradeHistory === null) {
      container.innerHTML = '<div class="tab-empty">Could not load trade history from Sleeper. Refresh to try again.</div>';
      return;
    }
    renderTradeHistoryView();
    return;
  }

  // `partial` means we are drawing from one league's cache while the rest is
  // still loading. Everything scoped to the selected league is correct in that
  // state; anything cross-league is not yet known, and below it is withheld
  // rather than guessed.
  const partial = STATE.tradeHistory === null;
  const trades = STATE.tradeHistory || STATE.tradeHistoryByLeague[selectedLeague.league_id];
  const filter = STATE.tradeHistoryFilter;

  let filtered = trades;
  if (filter === 'mine') {
    filtered = trades.filter(t => t.includesMe);
  } else if (filter !== 'all') {
    filtered = trades.filter(t => t.leagueId === filter);
  }

  const rec = myTradeRecord(filtered);
  const recordText = rec.scored.length
    ? 'your record ' + rec.wins + ' won · ' + rec.fair + ' fair · ' + rec.losses + ' lost over ' + rec.scored.length + ' scored trade' + (rec.scored.length === 1 ? '' : 's')
    : 'no scored trades of yours here';

  // Null, not zero: these count every league and we have one. renderFilterPills
  // drops the badge entirely for a null count, so the pills read "All trades"
  // and "My trades" until the real numbers land a moment later.
  const allCount = partial ? null : trades.length;
  const mineCount = partial ? null : trades.filter(t => t.includesMe).length;

  const leaguesWithTrades = {};
  trades.forEach(t => {
    if (!leaguesWithTrades[t.leagueId]) leaguesWithTrades[t.leagueId] = { name: t.leagueName, count: 0 };
    leaguesWithTrades[t.leagueId].count++;
  });
  // While partial, leaguesWithTrades only knows the one league we loaded, which
  // would leave the picker with a single option and no way out. List them all
  // and drop the counts we do not have yet; picking one loads that league the
  // same fast way.
  const leagueEntries = (partial
    ? STATE.leagues.map((l) => [l.league_id, { name: l.name, count: null }])
    : Object.entries(leaguesWithTrades))
    .sort(([, a], [, b]) => a.name.localeCompare(b.name));

  const isLeagueSelected = filter !== 'all' && filter !== 'mine';

  const pillsHtml = renderFilterPills({
    items: [
      { key: 'all', label: 'All trades', count: allCount },
      { key: 'mine', label: 'My trades', count: mineCount },
    ],
    activeKey: filter,
    handlerName: 'setTradeHistoryFilter',
  }) + `
    <div class="th-league-picker">
      <select class="th-league-select ${isLeagueSelected ? 'active' : ''}" aria-label="Filter trade history by league" data-taco-sort="setTradeHistoryFilter">
        ${filter === 'mine' ? '<option value="_placeholder" selected>Filter by league</option>' : ''}
        <option value="all" ${!isLeagueSelected && filter !== 'mine' ? 'selected' : ''}>${isLeagueSelected ? '↩ All leagues' : 'All leagues'}</option>
        ${leagueEntries.map(([id, v]) => `
          <option value="${escapeHtml(id)}" ${filter === id ? 'selected' : ''}>
            ${escapeHtml(v.name)}${v.count == null ? '' : ` (${v.count})`}
          </option>
        `).join('')}
      </select>
    </div>
  `;

  const shownCap = STATE.tradeHistoryShown || 25;
  const visibleTrades = filtered.slice(0, shownCap);
  const remaining = filtered.length - visibleTrades.length;
  const tradesHtml = filtered.length === 0
    ? '<div class="tab-empty">No trades found in this filter.</div>'
    : visibleTrades.map(t => renderTradeHistoryRow(t)).join('')
      + (remaining > 0
        ? `<div class="ma-show-row"><button class="th-show-more" data-th-show-more>Show ${Math.min(25, remaining)} more<span class="th-show-more-count">${remaining} remaining</span></button>` +
          (remaining > 25 ? '<button class="ghost small" data-taco-pill-fn="showAllTradeHistory">Show all ' + filtered.length + '</button>' : '') + '</div>'
        : '');

  let leaderboardsHtml = '';
  if (filter !== 'all' && filter !== 'mine') {
    const lg = STATE.leagues.find(l => l.league_id === filter);
    if (lg) {
      leaderboardsHtml = renderLeagueLeaderboards(lg, filtered);
    }
  }

  let traderScopeLabel = null;
  if (filter === 'all' || filter === 'mine') {
    traderScopeLabel = 'across all leagues';
  } else {
    const leagueName = leaguesWithTrades[filter]?.name || 'this league';
    traderScopeLabel = `in ${leagueName}`;
  }

  const totalValueMoved = filtered.reduce((sum, t) => {
    return sum + t.sides.reduce((s, side) => {
      // allow-inline-roster-sum: one side of a trade, not a roster
      return s + (side.players || []).reduce((sv, p) => sv + (p.value || 0), 0)
        // allow-inline-roster-sum: continuation of the trade-side sum above
        + (side.picks || []).reduce((sp, p) => sp + (p.value || 0), 0);
    }, 0);
  }, 0);
  const biggestTrade = filtered.reduce((max, t) => {
    const tradeVal = t.sides.reduce((s, side) => {
      // allow-inline-roster-sum: one side of a trade, not a roster
      return s + (side.players || []).reduce((sv, p) => sv + (p.value || 0), 0)
        // allow-inline-roster-sum: continuation of the trade-side sum above
        + (side.picks || []).reduce((sp, p) => sp + (p.value || 0), 0);
    }, 0);
    return tradeVal > max ? tradeVal : max;
  }, 0);
  const multiTradeCount = filtered.filter(t => (t.sides?.length || 0) > 2).length;

  const currentLg = STATE.leagues[STATE.currentTeamIdx];
  const leagueScopeName = (filter !== 'all' && filter !== 'mine')
    ? (leaguesWithTrades[filter]?.name || currentLg?.name || 'this league')
    : null;
  const subLine = (embedded || partial) && leagueScopeName
    ? `${filtered.length} in ${leagueScopeName} · ${recordText}`
    : `${trades.length} trades across ${STATE.leagues.length} leagues · ${recordText}`;

  container.innerHTML = `
    <div class="th-head">
      <div>
        <div class="th-title">${embedded ? 'Completed trades' : 'Trade History'}</div>
        <div class="th-sub" data-tooltip="${escapeHtml(TRADE_RECORD_RULE)}">${subLine}</div>
      </div>
      <button class="ghost small" data-th-refresh>Refresh</button>
    </div>
    <div class="section-card" style="margin: 0 0 16px;">
      <div class="stat-grid">
        <div class="stat-block">
          <div class="stat-block-num accent">${filtered.length}</div>
          <div class="stat-block-label">Trades shown</div>
        </div>
        <div class="stat-block">
          <div class="stat-block-num">${formatCompactNumber(totalValueMoved)}</div>
          <div class="stat-block-label">Total value moved</div>
        </div>
        <div class="stat-block">
          <div class="stat-block-num">${formatCompactNumber(biggestTrade)}</div>
          <div class="stat-block-label">Biggest trade</div>
        </div>
        <div class="stat-block">
          <div class="stat-block-num muted">${multiTradeCount}</div>
          <div class="stat-block-label">Multi-team</div>
        </div>
      </div>
    </div>
    <div class="th-filters">${pillsHtml}</div>
    ${buildTraderCardPanel(filtered, traderScopeLabel)}
    ${partial ? '' : buildTradePatternsPanel(filtered, trades, filter)}
    ${leaderboardsHtml}
    <div class="th-list">${tradesHtml}</div>
  `;
}
window.renderTradeHistoryView = renderTradeHistoryView;


;
/*! ==== 29-waiver-wire-cross-league-free-agent-scanner.js ==== */
// Cross-league waiver glance — elite names available somewhere in your portfolio.
// Per-league waiver boards and the player drawer cover depth adds; this is just
// "did a big name slip through anywhere?"

const BIG_WIRE_MIN_VALUE = 1200;
// Players whose league list is expanded, by playerId. The board rerenders on
// every search keystroke, so this has to live outside the markup.
const wwAvailOpen = new Set();
const BIG_WIRE_LIMIT = 40;

function waiverWireCacheKey() {
  return (STATE.leagues || [])
    .filter((lg) => lg.startupComplete !== false)
    .map((lg) => `${lg.league_id}:${lg.allRosters?.length || 0}`)
    .join('|');
}

function poolsByTabFromState() {
  const tabs = [...new Set((STATE.leagues || []).map((lg) => lg.scoringTab).filter(Boolean))];
  const map = new Map();
  for (const tab of tabs) {
    const pool = typeof getValuePoolForTab === 'function' ? getValuePoolForTab(tab) : [];
    map.set(tab, pool || []);
  }
  return map;
}

function slimLeagueForWaiverScan(lg) {
  return {
    league_id: lg.league_id,
    name: lg.name,
    scoringTab: lg.scoringTab,
    roster_positions: lg.roster_positions,
    scoring_settings: lg.scoring_settings,
    scoringFingerprint: lg.scoringFingerprint,
    startupComplete: lg.startupComplete,
    rookieDraftComplete: lg.rookieDraftComplete,
    allRosters: (lg.allRosters || []).map((r) => ({
      rosterId: r.rosterId,
      ownerId: r.ownerId,
      ownerName: r.ownerName,
      teamName: r.teamName,
      isMe: r.isMe,
      playerIds: r.playerIds || (r.players || []).map((p) => p.playerId),
    })),
  };
}

async function refreshWaiverWireFromServer() {
  if (!STATE.leagues?.length || STATE._waiverServerLoading) return;
  const cacheKey = waiverWireCacheKey();
  if (STATE._waiverServerCache?.key === cacheKey) return;

  STATE._waiverServerLoading = true;
  try {
    const res = await fetch(BACKEND_URL + '/api/waivers/scan', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ leagues: STATE.leagues.map(slimLeagueForWaiverScan) }),
    });
    if (!res.ok) throw new Error(`waiver scan ${res.status}`);
    const payload = await res.json();
    if (!payload?.ok || !Array.isArray(payload.candidates)) throw new Error('invalid waiver scan payload');
    STATE._waiverServerCache = {
      key: cacheKey,
      names: payload.candidates,
      scannedAt: payload.scannedAt,
      source: 'server',
    };
    STATE._waiverCache = null;
  } catch (e) {
    console.warn('[waivers] server scan failed, using client pools', e.message);
    STATE._waiverServerCache = { key: cacheKey, names: null, failed: true };
  } finally {
    STATE._waiverServerLoading = false;
  }
  // One render after the flag is actually false, success or failure --
  // rendering from inside try/catch left _waiverServerLoading still true at
  // that point (finally hadn't run yet), which would have re-triggered the
  // first-paint skeleton (TACO overhaul Phase 2) instead of clearing it.
  if (typeof renderWaiverWireResults === 'function') renderWaiverWireResults();
}

function totalLeagues() {
  return STATE.leagues.filter((lg) => lg.startupComplete !== false).length;
}

function buildBigWireNames() {
  const cacheKey = waiverWireCacheKey();
  if (STATE._waiverServerCache?.key === cacheKey && STATE._waiverServerCache.names) {
    return STATE._waiverServerCache.names;
  }
  if (!STATE._waiverServerCache?.failed && !STATE._waiverServerLoading) {
    refreshWaiverWireFromServer();
  }
  if (STATE._waiverCache?.key === cacheKey) {
    return STATE._waiverCache.names;
  }

  let names = [];
  if (typeof TacoCore.buildBigWireFromPools === 'function') {
    names = TacoCore.buildBigWireFromPools(STATE.leagues, poolsByTabFromState(), {
      limit: BIG_WIRE_LIMIT,
      minValue: BIG_WIRE_MIN_VALUE,
    });
  }
  STATE._waiverCache = { key: cacheKey, names };
  return names;
}

// Flat market value -- matches every other page. availableIn entries also
// carry a position-tilted a.leagueValue, intentionally unused here now.
function bestWireValue(c) {
  return Math.max(...c.availableIn.map((a) => a.value || 0), 0);
}

function sortBigWireNames(names, sortKey) {
  const sorted = [...names];
  if (sortKey === 'availability') {
    sorted.sort((a, b) => a.availableIn.length - b.availableIn.length || bestWireValue(b) - bestWireValue(a));
  } else if (sortKey === 'name') {
    sorted.sort((a, b) => a.name.localeCompare(b.name));
  } else {
    sorted.sort((a, b) => bestWireValue(b) - bestWireValue(a) || b.availableIn.length - a.availableIn.length);
  }
  return sorted;
}

function renderWaiverWireView() {
  const container = document.getElementById('waiverWireContent');
  if (!container) return;
  refreshWaiverWireFromServer();
  if (window.TacoAuth && !TacoAuth.hasFreeAccount()) {
    container.innerHTML = TacoAuth.gateHtml('waiverWire');
    container.dataset.initialized = '';
    return;
  }

  if (!container.dataset.initialized) {
    container.innerHTML = `
      <div class="ma-head">
        <div>
          <h2 class="ma-title">Big names on waivers</h2>
          <div class="ma-sub" id="wwSub">High-value free agents across your leagues…</div>
        </div>
      </div>
      <div class="assets-search-wrap">
        <input
          type="text"
          class="assets-search-input"
          id="wwSearchInput"
          placeholder="Search any free agent across your leagues…"
          autocomplete="off"
          autocorrect="off"
          autocapitalize="off"
          spellcheck="false"
        >
        <button class="assets-search-clear" id="wwSearchClear" data-tooltip="Clear search" aria-label="Clear search" style="display: none;">×</button>
      </div>
      <div class="ma-filters" id="wwFilters"></div>
      <div class="ma-list" id="wwList"></div>
    `;
    const input = document.getElementById('wwSearchInput');
    const clearBtn = document.getElementById('wwSearchClear');
    input.addEventListener('input', (e) => {
      STATE.waiverWireSearchQuery = e.target.value;
      clearBtn.style.display = e.target.value.length > 0 ? 'flex' : 'none';
      renderWaiverWireResults();
    });
    clearBtn.addEventListener('click', () => {
      input.value = '';
      STATE.waiverWireSearchQuery = '';
      clearBtn.style.display = 'none';
      input.focus();
      renderWaiverWireResults();
    });
    container.dataset.initialized = 'true';
  }

  // Restore the box after a rerender that rebuilt the shell.
  const input = document.getElementById('wwSearchInput');
  const clearBtn = document.getElementById('wwSearchClear');
  if (input && document.activeElement !== input) {
    input.value = STATE.waiverWireSearchQuery || '';
    if (clearBtn) clearBtn.style.display = input.value.length > 0 ? 'flex' : 'none';
  }

  renderWaiverWireResults();
}

function renderWaiverWireResults() {
  const subEl = document.getElementById('wwSub');
  const filtersEl = document.getElementById('wwFilters');
  const listEl = document.getElementById('wwList');
  if (!subEl || !filtersEl || !listEl) return;

  const filter = STATE.waiverWireFilter || 'ALL';
  const sortKey = STATE.waiverWireSortKey || 'value';
  const totalLg = totalLeagues();
  const names = buildBigWireNames();
  const query = String(STATE.waiverWireSearchQuery || '').trim();

  // A search runs against every free agent in the book, NOT against the board.
  // The board is the top 40 names over a value floor, so filtering it would
  // answer "no results" for almost anyone worth looking up -- and "is he
  // available?" is the question people come to this page with.
  const searching = query.length >= 2 && typeof TacoCore.searchFreeAgents === 'function';
  let candidates = searching
    ? TacoCore.searchFreeAgents(STATE.leagues, poolsByTabFromState(), query)
    : [...names];
  if (filter !== 'ALL') {
    candidates = candidates.filter((c) => c.position === filter);
  }
  candidates = sortBigWireNames(candidates, sortKey);

  // Count the set being shown, so the pills never advertise 12 RBs while a
  // search has narrowed the board to one.
  const counted = searching
    ? TacoCore.searchFreeAgents(STATE.leagues, poolsByTabFromState(), query)
    : names;
  const byPos = { ALL: counted.length, QB: 0, RB: 0, WR: 0, TE: 0 };
  for (const c of counted) {
    if (byPos[c.position] != null) byPos[c.position]++;
  }

  const loadingNote = STATE._waiverServerLoading ? ' · syncing…' : '';
  subEl.textContent = searching
    ? `${candidates.length} free agent${candidates.length === 1 ? '' : 's'} matching "${query}" across your ${totalLg} leagues${loadingNote}`
    : `${names.length} free agent${names.length === 1 ? '' : 's'} worth a look across your ${totalLg} leagues${loadingNote}`;

  const pillsHtml = renderFilterPills({
    items: ['ALL', 'QB', 'RB', 'WR', 'TE'].map((key) => ({
      key,
      label: key === 'ALL' ? 'All' : key,
      count: byPos[key],
    })),
    activeKey: filter,
    handlerName: 'setWaiverWireFilter',
  });
  filtersEl.innerHTML = `
    <div class="ma-filters-row">
      ${pillsHtml}
      ${renderSortSelect({
        id: 'wwSortSelect',
        label: 'Sort by',
        value: sortKey,
        handlerName: 'setWaiverWireSort',
        options: [
          { value: 'value', label: 'Value' },
          { value: 'availability', label: 'Fewest leagues' },
          { value: 'name', label: 'Name (A-Z)' },
        ],
      })}
    </div>
  `;

  if (searching && candidates.length === 0) {
    // Distinct from the board's own empty state: nothing matched the query,
    // which is a different fact from the wire having no big names on it.
    listEl.innerHTML =
      '<div class="tab-empty">No free agent matching “' + escapeHtml(query) + '”' +
      (filter === 'ALL' ? '' : ' at ' + escapeHtml(filter)) +
      '. He may be rostered in every league, or try fewer letters.</div>';
    return;
  }

  if (candidates.length === 0) {
    // First paint, real server scan still in flight and has never completed
    // (success or failure) for this cache key -- distinguish this from a
    // genuinely empty result (was previously indistinguishable: both showed
    // "No elite waiver names right now," which is actively misleading during
    // a real load, not just missing polish). Deliberately does NOT check
    // STATE._waiverCache -- buildBigWireNames() (called above) unconditionally
    // populates that as a memoization side effect, even when it computes zero
    // candidates, so it's never a reliable "nothing loaded yet" signal. A
    // stale STATE._waiverServerCache from a prior cache key is fine to treat
    // as "not first paint" here -- real stale-while-revalidate: show the old
    // results immediately, update seamlessly when the fresh scan lands,
    // rather than flashing a skeleton over data that's already on screen.
    // TACO overhaul Phase 2.
    const stillLoadingFirstPaint = STATE._waiverServerLoading && !STATE._waiverServerCache;
    if (stillLoadingFirstPaint) {
      listEl.innerHTML = `
        <div class="skeleton-grid">
          ${Array.from({ length: 6 }).map(() => `
            <div class="skeleton-card">
              <div class="skeleton-line skeleton-line-wide"></div>
              <div class="skeleton-line skeleton-line-short"></div>
              <div class="skeleton-line"></div>
            </div>
          `).join('')}
        </div>
      `;
      return;
    }
    listEl.innerHTML = '<div class="tab-empty">No elite waiver names right now. That&apos;s usually good - or check a specific league&apos;s waivers for depth adds.</div>';
    return;
  }

  const wwShownCap = STATE.waiverWireShown || 25;
  const wwRemaining = Math.max(0, candidates.length - wwShownCap);
  const rowsHtml = candidates.slice(0, wwShownCap).map((c) => {
    const bestValue = bestWireValue(c);
    const p = STATE.playersDB?.[c.playerId];
    const injuryTag = p?.injury_status && p.injury_status !== 'Active'
      ? ` <span class="ww-injury-tag">${escapeHtml(p.injury_status)}</span>`
      : '';
    const availableList = c.availableIn
      .sort((a, b) => (b.value || 0) - (a.value || 0))
      .map((a) => `
        <div class="ww-avail-row ww-avail-free" data-taco-jump-league="${escapeHtml(a.leagueId)}" title="Open ${escapeHtml(a.leagueName)}">
          <div class="ww-avail-league">${escapeHtml(a.leagueName)}</div>
          <div class="ww-avail-meta">${a.scoringTab} · <span class="ww-avail-tag available">FREE</span></div>
          <div class="ww-avail-value">${Math.round(a.value || 0).toLocaleString()}</div>
        </div>
      `).join('');

    const avatar = playerAvatarHtml(c.playerId, c.name, c.position);
    const openAvail = wwAvailOpen.has(String(c.playerId));
    return `
      <div class="ww-row pos-${(c.position || '').toLowerCase()}${openAvail ? ' ww-row-open' : ''}" data-player-id="${c.playerId}">
        <div class="ww-row-head" data-taco-player="${escapeHtml(c.playerId)}">
          <div class="ww-row-avatar">${avatar}</div>
          <div class="ww-row-main">
            <div class="ww-row-name">${escapeHtml(c.name)}${injuryTag}</div>
            <div class="ww-row-meta">${c.position} · ${c.team || p?.team || 'FA'}</div>
          </div>
          <div class="ww-row-stats">
            <div class="ww-row-count">
              <strong>${c.availableIn.length}/${totalLg}</strong>
              <span>free</span>
            </div>
            <div class="ww-row-value">${Math.round(bestValue).toLocaleString()}</div>
          </div>
        </div>
        <button type="button" class="ww-avail-toggle" data-ww-avail="${escapeHtml(c.playerId)}"
          aria-expanded="${openAvail ? 'true' : 'false'}" aria-controls="ww-avail-${escapeHtml(c.playerId)}">
          <span>Available in ${c.availableIn.length} league${c.availableIn.length === 1 ? '' : 's'}</span>
          <span class="ww-avail-chev" aria-hidden="true">›</span>
        </button>
        <div class="ww-row-leagues" id="ww-avail-${escapeHtml(c.playerId)}"${openAvail ? '' : ' hidden'}>${availableList}</div>
      </div>
    `;
  }).join('');

  listEl.innerHTML = rowsHtml + (wwRemaining > 0
    ? `<button class="show-more-btn" data-taco-pill-fn="showMoreWaiverWire">Show ${Math.min(25, wwRemaining)} more<span class="show-more-count">${wwRemaining} remaining</span></button>`
    : '');
}

// Expand one player's leagues. Delegated: the list is rebuilt on every search
// keystroke, so a bound listener would not survive.
document.addEventListener('click', function (e) {
  const btn = e.target.closest ? e.target.closest('[data-ww-avail]') : null;
  if (!btn) return;
  const pid = String(btn.dataset.wwAvail);
  const body = document.getElementById('ww-avail-' + pid);
  if (!body) return;
  const open = body.hidden;
  body.hidden = !open;
  btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  const row = btn.closest('.ww-row');
  if (row) row.classList.toggle('ww-row-open', open);
  if (open) wwAvailOpen.add(pid); else wwAvailOpen.delete(pid);
});

/** Set the waiver search from outside the input (deep link, clear button). */
function setWaiverWireSearch(query) {
  STATE.waiverWireSearchQuery = String(query || '');
  const input = document.getElementById('wwSearchInput');
  const clearBtn = document.getElementById('wwSearchClear');
  if (input) input.value = STATE.waiverWireSearchQuery;
  if (clearBtn) clearBtn.style.display = STATE.waiverWireSearchQuery.length > 0 ? 'flex' : 'none';
  renderWaiverWireResults();
}
window.setWaiverWireSearch = setWaiverWireSearch;

function setWaiverWireFilter(filter) {
  STATE.waiverWireFilter = filter;
  STATE.waiverWireShown = 25; // new filter, fresh page
  renderWaiverWireResults();
}
window.setWaiverWireFilter = setWaiverWireFilter;

function setWaiverWireSort(key) {
  STATE.waiverWireSortKey = key;
  STATE.waiverWireShown = 25;
  renderWaiverWireResults();
}
window.setWaiverWireSort = setWaiverWireSort;

function showMoreWaiverWire() {
  STATE.waiverWireShown = (STATE.waiverWireShown || 25) + 25;
  renderWaiverWireResults();
}
window.showMoreWaiverWire = showMoreWaiverWire;

function jumpToWaiverPlayer(playerId) {
  if (typeof openPlayerDrawer === 'function') openPlayerDrawer(playerId);
}
window.jumpToWaiverPlayer = jumpToWaiverPlayer;
window.renderWaiverWireView = renderWaiverWireView;
window.renderWaiverWireResults = renderWaiverWireResults;
;
/*! ==== 30-league-view-all-rosters-in-one-league-compact-ex.js ==== */
function initLeagueView() {
  const picker = document.getElementById('leagueTeamsPicker');
  picker.innerHTML = STATE.leagues.map((lg, i) => `
    <option value="${i}">${escapeHtml(lg.name)} - ${lg.scoringTab}</option>
  `).join('');
  // One selected league across League Overview and League Rankings: changing
  // it here changes it there, and vice versa.
  picker.addEventListener('change', () => {
    STATE.currentTeamIdx = parseInt(picker.value) || 0;
    renderLeagueView();
  });
  renderLeagueView();
}

// Tabs to rank the league by (Owen): Total now includes draft capital, plus
// per-position, starters, and picks. Value shown in the right column follows the
// tab; the per-position cells always show their own values (highlighted when
// that tab is active).
const LEAGUE_RANK_TABS = [
  ['total', 'Total value'],
  ['record', 'Record'],
  ['pf', 'PF'],
  ['maxpf', 'Max PF'],
  ['starters', 'Starters'],
  ['QB', 'QB'], ['RB', 'RB'], ['WR', 'WR'], ['TE', 'TE'],
  ['picks', 'Picks'],
];

function setLeagueRankSort(key) {
  if (!LEAGUE_RANK_TABS.some(([k]) => k === key)) return;
  STATE.leagueRankSort = key;
  renderLeagueView();
}
window.setLeagueRankSort = setLeagueRankSort;

function renderLeagueView() {
  const picker = document.getElementById('leagueTeamsPicker');
  // Follow the selected league, choosing the first one (All Leagues order) when
  // none is -- the dropdown used to default to whichever league Sleeper listed
  // first, unrelated to anything on screen (Owen, 2026-09-27).
  if (typeof hasSelectedLeague === 'function' && !hasSelectedLeague() && typeof selectFirstLeague === 'function') {
    selectFirstLeague();
  }
  if (STATE.currentTeamIdx != null && STATE.leagues[STATE.currentTeamIdx]) picker.value = String(STATE.currentTeamIdx);
  const lg = STATE.leagues[parseInt(picker.value) || 0];
  if (!lg) return;

  // For each position, compute league-wide tercile thresholds (top/mid/bot coloring)
  const positionalTerciles = computePositionalTerciles(lg.allRosters, lg.roster_positions, lg.scoringTab);

  // Per-roster metrics for every rankable dimension. Total value now includes
  // draft capital (players + picks), not just players.
  const metricsById = {};
  lg.allRosters.forEach((r) => {
    const ps = computePositionalSummary(r, positionalTerciles);
    const playersValue = (window.TacoCore && typeof TacoCore.rosterPlayersValue === 'function')
      ? TacoCore.rosterPlayersValue(r.players) : (r.totalValue || 0);
    const picksValue = (window.TacoCore && typeof TacoCore.rosterPicksValue === 'function')
      ? TacoCore.rosterPicksValue(lg, r.rosterId) : 0;
    const startersValue = r.players.reduce((s, p) =>
      s + ((p.isStarter && !p.isIR && !p.isTaxi) ? (p.value || 0) : 0), 0);
    metricsById[r.rosterId] = {
      ps,
      total: playersValue + picksValue,
      starters: startersValue,
      picks: picksValue,
      QB: ps.QB.value, RB: ps.RB.value, WR: ps.WR.value, TE: ps.TE.value,
      pf: r.pointsFor || 0,
      maxpf: r.maxPointsFor || 0,
      // Record ranks by wins, then points-for as the tiebreak, in one number.
      record: (r.wins || 0) * 1e6 + (r.pointsFor || 0),
    };
  });

  const sortKey = LEAGUE_RANK_TABS.some(([k]) => k === STATE.leagueRankSort) ? STATE.leagueRankSort : 'total';
  const metricOf = (r) => (metricsById[r.rosterId] ? metricsById[r.rosterId][sortKey] : 0) || 0;
  const rosters = [...lg.allRosters].sort((a, b) => metricOf(b) - metricOf(a));

  // The page's name, like every other page ("All Leagues"); which league it is
  // showing is in the subtitle and the dropdown right below.
  document.getElementById('leagueTeamsTitle').innerHTML = 'League <em>Rankings</em>';
  document.getElementById('leagueTeamsSub').textContent = `${lg.name} · ${lg.total_rosters} teams · ${lg.scoringTab} · ${lg.season}`;

  const tabBar = '<div class="lr-tabs">' + LEAGUE_RANK_TABS.map(([k, label]) =>
    `<button type="button" class="lr-tab${sortKey === k ? ' active' : ''}" data-taco-pill="setLeagueRankSort|${k}">${label}</button>`
  ).join('') + '</div>';

  const pickerIdx = parseInt(picker.value) || 0;
  const content = document.getElementById('leagueTeamsContent');
  // Contention window per team (roadmap #5, shared/team-window.mjs): value
  // rank now, plus how much of each roster is past prime or 24-and-under.
  const windows = TacoCore.leagueWindows
    ? TacoCore.leagueWindows(lg.allRosters.map((r) => ({ rosterId: r.rosterId, teamValue: metricsById[r.rosterId].total, players: r.players })))
    : {};
  const windowChip = (w) => (w
    ? '<span class="lr-window lr-window-' + w.key + '">' + w.label + '</span>' +
      (w.flag ? '<span class="lr-window-flag lr-flag-' + (w.flag === 'Rising' ? 'rising' : 'closing') + '">' + w.flag + '</span>' : '')
    : '');
  content.innerHTML = tabBar + rosters.map((r, idx) => {
    const rank = idx + 1;
    const meClass = r.isMe ? 'me' : '';
    const m = metricsById[r.rosterId];
    const ps = m.ps;
    const bodyHtml = renderTeamPositionGrid(r, positionalTerciles);
    // Right-hand value column follows the tab for whole-team metrics; for the
    // per-position/picks tabs it stays on Total (their own cells carry the sort).
    // The value column shows whatever you're ranking by (Owen), not always total.
    let headlineStr;
    if (sortKey === 'record') headlineStr = `${r.wins || 0}-${r.losses || 0}${r.ties ? '-' + r.ties : ''}`;
    else if (sortKey === 'pf') headlineStr = (r.pointsFor || 0).toFixed(1);
    else if (sortKey === 'maxpf') headlineStr = (r.maxPointsFor || 0).toFixed(1);
    else headlineStr = Math.round(m[sortKey] || 0).toLocaleString();
    const posCell = (pos) =>
      `<div class="team-strip-pos ${ps[pos].cls}${sortKey === pos ? ' lr-sorted' : ''}"><strong>${Math.round(m[pos]).toLocaleString()}</strong>${pos}</div>`;

    return `
      <div class="team-strip ${meClass}" data-roster="${r.rosterId}">
        <div class="team-strip-head" data-strip-toggle="${r.rosterId}">
          <div class="strip-rank ${meClass}">${rank}</div>
          <div class="strip-owner">
            ${typeof teamAvatarHtml === 'function' ? teamAvatarHtml(r, r.teamName || r.ownerName) : ''}
            <div class="strip-owner-text">
              <div class="strip-owner-name ${r.isMe ? 'me' : ''}">${escapeHtml(r.teamName)}${r.isMe ? ' (you)' : ''}</div>
              <div class="strip-owner-team">${escapeHtml(r.ownerName)} · ${r.wins}-${r.losses}${r.ties ? '-' + r.ties : ''} ${windowChip(windows[r.rosterId])}</div>
            </div>
          </div>
          ${posCell('QB')}
          ${posCell('RB')}
          ${posCell('WR')}
          ${posCell('TE')}
          <div class="team-strip-pos${sortKey === 'picks' ? ' lr-sorted' : ''}"><strong>${Math.round(m.picks).toLocaleString()}</strong>PICKS</div>
          <div class="team-strip-value lr-sorted">${headlineStr}</div>
          <div class="team-strip-expand">▾</div>
        </div>
        <div class="team-strip-body">
          ${windows[r.rosterId] ? `<div class="lr-window-line"><strong>${windows[r.rosterId].label}</strong>${windows[r.rosterId].flag ? ' · ' + windows[r.rosterId].flag : ''} · ${windows[r.rosterId].pastPrimeShare}% of player value past prime · ${windows[r.rosterId].youngShare}% age 24 or under <span class="lr-window-note">(prime ends: QB 32, RB 26, WR 28, TE 29)</span></div>` : ''}
          ${bodyHtml}
          ${!r.isMe ? `
            <div style="margin-top: 16px; padding-top: 14px; border-top: 1px solid var(--border-soft); display: flex; justify-content: flex-end; gap: 8px;">
              <button class="ghost small" data-taco-trade="${pickerIdx}|${r.rosterId}">Build trade with ${escapeHtml(r.teamName)} →</button>
            </div>
          ` : ''}
        </div>
      </div>
    `;
  }).join('');
}

// Compute per-position value summary for a roster, plus a 'cls' (strong/weak/'')
// based on positional terciles. Reused by both league-view strips and power
// rankings rows so the strength signal is consistent across views.
function computePositionalSummary(roster, terciles) {
  const result = {};
  ['QB', 'RB', 'WR', 'TE'].forEach(pos => {
    const players = roster.players
      .filter(p => p.position === pos && p.isActive)
      .sort((a, b) => (b.value || 0) - (a.value || 0));
    const starterN = terciles[pos].n;
    // Starters: top-N at full weight (where N = how many of this position you
    // need to start each week, accounting for SF/flex). These are what wins
    // games week to week.
    const starters = players.slice(0, starterN);
    const startersValue = starters.reduce((s, p) => s + (p.value || 0), 0);
    const { depthN, depthWeight } = depthWeighting(pos, starterN);
    const depth = players.slice(starterN, starterN + depthN);
    const depthValue = depth.reduce((s, p) => s + (p.value || 0), 0) * depthWeight;
    const totalValue = startersValue + depthValue;
    let cls = '';
    if (totalValue >= terciles[pos].hi) cls = 'strong';
    else if (totalValue < terciles[pos].lo) cls = 'weak';
    result[pos] = { value: totalValue, startersValue, depthValue, cls, players };
  });
  return result;
}

// Render the 4-column position grid (QB/RB/WR/TE) for a roster, with the top-N
// starters bolded. This is the expanded body content shared between the legacy
// League View strips and the new combined Power Rankings rows.
function renderTeamPositionGrid(roster, terciles) {
  const posStats = computePositionalSummary(roster, terciles);
  const cols = ['QB', 'RB', 'WR', 'TE'].map(pos => {
    const players = posStats[pos].players;
    const topNCount = terciles[pos].n;
    return `
      <div class="strip-pos-col">
        <div class="strip-pos-col-head">
          <strong>${pos}</strong>
          <span>${Math.round(posStats[pos].value).toLocaleString()}</span>
        </div>
        ${players.slice(0, 10).map((p, i) => `
          <div class="strip-player ${p.playerId ? 'strip-player-clickable' : ''}"
               ${p.playerId ? `data-taco-player="${escapeHtml(p.playerId)}"` : ''}>
            <span class="strip-player-name">${i < topNCount ? '<b>' : ''}${escapeHtml(p.name)}${i < topNCount ? '</b>' : ''}</span>
            <span class="strip-player-val">${p.value ? Math.round(p.value).toLocaleString() : '-'}</span>
          </div>
        `).join('')}
        ${players.length === 0 ? '<div style="color:var(--text-dim); font-size:11px; padding: 4px 0;">-</div>' : ''}
      </div>
    `;
  }).join('');
  return `<div class="strip-pos-grid">${cols}</div>`;
}

function computePositionalTerciles(rosters, rosterPositions, _scoringTab) {
  const rp = rosterPositions || [];
  const isSF = rp.includes('SUPER_FLEX');
  const startersNeeded = {
    QB: rp.filter(p => p === 'QB').length + (isSF ? 1 : 0),
    RB: rp.filter(p => p === 'RB').length,
    WR: rp.filter(p => p === 'WR').length,
    TE: rp.filter(p => p === 'TE').length,
  };
  const flexCount = rp.filter(p => p === 'FLEX' || p === 'REC_FLEX' || p === 'WRRB_FLEX').length;
  startersNeeded.RB += Math.ceil(flexCount / 2);
  startersNeeded.WR += Math.ceil(flexCount / 2);

  const result = {};
  ['QB', 'RB', 'WR', 'TE'].forEach(pos => {
    const n = Math.max(startersNeeded[pos] || 1, 1);
    // Same formula as computePositionalSummary — keeps strong/weak coloring
    // aligned with actual rank.
    const { depthN, depthWeight } = depthWeighting(pos, n);
    const vals = rosters.map(r => {
      const sorted = r.players.filter(p => p.position === pos && p.isActive)
        .sort((a, b) => (b.value || 0) - (a.value || 0));
      const startersV = sorted.slice(0, n).reduce((s, p) => s + (p.value || 0), 0);
      const depthV = sorted.slice(n, n + depthN).reduce((s, p) => s + (p.value || 0), 0) * depthWeight;
      return startersV + depthV;
    }).sort((a, b) => b - a);
    const hi = vals[Math.floor(vals.length / 3)];
    const lo = vals[Math.floor(vals.length * 2 / 3)];
    result[pos] = { n, hi, lo };
  });
  return result;
}

function toggleStrip(rosterId) {
  const el = document.querySelector(`.team-strip[data-roster="${rosterId}"]`);
  if (el) el.classList.toggle('expanded');
}
function expandAllStrips() { document.querySelectorAll('.team-strip').forEach(el => el.classList.add('expanded')); }
function collapseAllStrips() { document.querySelectorAll('.team-strip').forEach(el => el.classList.remove('expanded')); }
window.toggleStrip = toggleStrip;
window.expandAllStrips = expandAllStrips;
window.collapseAllStrips = collapseAllStrips;
window.initLeagueView = initLeagueView;

;
/*! ==== 30-league-rosters-any-team-roster-and-picks.js ==== */
// Rosters: any team's roster and draft picks in one league (Owen, 2026-10-03:
// "we have no way to look at rosters and picks anymore"). League Rankings only
// opened a team's players and showed its picks as one total; League Overview
// is yours alone. This is the same pill layout as yours, for whichever team is
// picked, with the pick list shown rather than hidden behind a pill.
//
// The league follows STATE.currentTeamIdx, shared with League Overview and
// League Rankings, so changing it on one changes it on all three.

function initLeagueRostersView() {
  const picker = document.getElementById('leagueRostersPicker');
  picker.addEventListener('change', () => {
    STATE.currentTeamIdx = parseInt(picker.value) || 0;
    STATE.rostersRosterId = null; // a new league starts on your own team
    renderLeagueRostersView();
  });
  renderLeagueRostersView();
}

function setRostersTeam(rosterId) {
  STATE.rostersRosterId = String(rosterId);
  const lg = STATE.leagues && STATE.leagues[STATE.currentTeamIdx];
  STATE.rostersLeagueId = lg ? String(lg.league_id) : null;
  renderLeagueRostersView();
}
window.setRostersTeam = setRostersTeam;

function renderLeagueRostersView() {
  const picker = document.getElementById('leagueRostersPicker');
  const content = document.getElementById('leagueRostersContent');
  if (!picker || !content) return;
  if (!STATE.leagues || !STATE.leagues.length) { content.innerHTML = ''; return; }
  if (typeof hasSelectedLeague === 'function' && !hasSelectedLeague() && typeof selectFirstLeague === 'function') {
    selectFirstLeague();
  }
  picker.innerHTML = STATE.leagues.map((l, i) =>
    `<option value="${i}">${escapeHtml(l.name)} - ${l.scoringTab}</option>`).join('');
  const idx = STATE.currentTeamIdx != null && STATE.leagues[STATE.currentTeamIdx] ? STATE.currentTeamIdx : 0;
  picker.value = String(idx);
  const lg = STATE.leagues[idx];
  const rosters = lg.allRosters || [];
  if (!rosters.length) { content.innerHTML = '<div class="tab-empty">This league has no rosters yet. They appear once the startup draft runs.</div>'; return; }

  // Your team first, then the rest by team value -- the order you scan in.
  const ordered = [...rosters].sort((a, b) => ((b.isMe ? 1 : 0) - (a.isMe ? 1 : 0)) || ((b.totalValue || 0) - (a.totalValue || 0)));
  // The selection is only meaningful in the league it was made in: roster ids
  // are per-league, so a remembered id silently matched a DIFFERENT manager
  // after the league changed anywhere else -- the masthead picker, prev/next,
  // an All Leagues card, the router, the player drawer (2026-10-16). Only this
  // page's own dropdown used to clear it.
  const sameLeague = STATE.rostersLeagueId === String(lg.league_id);
  let team = sameLeague ? ordered.find((r) => String(r.rosterId) === STATE.rostersRosterId) : null;
  if (!team) {
    team = ordered[0];
    STATE.rostersRosterId = team ? String(team.rosterId) : null;
    STATE.rostersLeagueId = String(lg.league_id);
  }

  document.getElementById('leagueRostersSub').textContent =
    `${lg.name} · ${rosters.length} teams · ${lg.scoringTab} · ${lg.season}`;

  const chips = ordered.map((r) => `
    <button type="button" class="rosters-team-chip${r === team ? ' active' : ''}${r.isMe ? ' me' : ''}"
      data-taco-pill="setRostersTeam|${escapeHtml(String(r.rosterId))}">
      ${typeof teamAvatarHtml === 'function' ? teamAvatarHtml(r, r.teamName || r.ownerName) : ''}
      <span>${escapeHtml(r.teamName || r.ownerName || 'Team')}${r.isMe ? ' (you)' : ''}</span>
    </button>`).join('');

  const players = rostersPlayers(team);
  // Enrichment already stamps "Own" / "via X" on EVERY roster's picks, not
  // just yours (shared/enrich.mjs buildAllPicks), so the local re-derivation
  // that used to sit here was a no-op third copy of the rule (2026-10-16).
  const picks = (lg.picksByRoster && lg.picksByRoster[team.rosterId]) || [];
  // The shared accessors, not a hand-rolled reduce: two pick builders once
  // disagreed on first-round values, and routing every reader through one
  // accessor is what makes a repeat of that visible (shared/roster-value.mjs).
  const playerValue = TacoCore.rosterPlayersValue(players);
  const pickValue = TacoCore.picksValue(picks);
  const style = typeof archetypeForRoster === 'function' ? archetypeForRoster(lg, team) : null;
  const stylePill = !style ? ''
    : (typeof archetypesSettled === 'function' && !archetypesSettled() && typeof archetypePendingPill === 'function')
      ? archetypePendingPill('league-archetype')
      : `<span class="league-archetype arch-${style.toLowerCase().replace(/\s+/g, '-')}">${escapeHtml(style)}</span>`;
  const record = `${team.wins || 0}-${team.losses || 0}${team.ties ? '-' + team.ties : ''}`;

  content.innerHTML = `
    <div class="rosters-team-row" role="group" aria-label="Choose a team">${chips}</div>
    <div class="rosters-team-head">
      <div class="rosters-team-id">
        ${typeof teamAvatarHtml === 'function' ? teamAvatarHtml(team, team.teamName || team.ownerName) : ''}
        <div>
          <div class="rosters-team-name">${escapeHtml(team.teamName || team.ownerName || 'Team')}${team.isMe ? ' (you)' : ''}</div>
          <div class="rosters-team-meta">${escapeHtml(team.ownerName || '')} · ${record} ${stylePill}</div>
        </div>
      </div>
      <div class="rosters-team-stats">
        <span class="lo-pill-stat"><b>${Math.round(playerValue).toLocaleString()}</b><i>players</i></span>
        <span class="lo-pill-stat"><b>${Math.round(pickValue).toLocaleString()}</b><i>picks</i></span>
        <span class="lo-pill-stat"><b>${players.length}</b><i>rostered</i></span>
      </div>
    </div>
    ${buildRosterPillsHtml(lg, players, 'rosters-' + lg.league_id + '-' + team.rosterId)}
    <div class="section-card rosters-picks">${buildDraftCapitalListHtml(lg, picks)}</div>
    ${!team.isMe ? `<div class="rosters-actions"><button class="ghost small" data-taco-trade="${idx}|${escapeHtml(String(team.rosterId))}">Build trade with ${escapeHtml(team.teamName || team.ownerName || 'this team')} →</button></div>` : ''}
  `;
}
window.renderLeagueRostersView = renderLeagueRostersView;

/** Your roster's rows are lg.myPlayers (they carry starter flags); everyone
 * else's are the roster's own players, which enrichment gives the same
 * isIR / isTaxi / isActive fields. */
function rostersPlayers(roster) {
  if (roster.isMe) {
    const lg = STATE.leagues[STATE.currentTeamIdx != null ? STATE.currentTeamIdx : 0];
    if (lg && lg.myPlayers) return lg.myPlayers;
  }
  return roster.players || [];
}

;
/*! ==== 31-trade-calculator-single-league-two-side-asset-pi.js ==== */
var TRADE = {
  leagueIdx: 0,
  sideARosterId: null,
  sideBRosterId: null,
  sideAAssets: new Set(), // 'P:playerId' or 'D:season-round-origRosterId'
  sideBAssets: new Set(),
  // Phase C7: per-side player search filter. Lets users type a player name
  // to narrow the asset chip list to that roster's matching players.
  sideAFilter: '',
  sideBFilter: '',
  // Position sections the user has opened, as 'A|QB', 'B|Picks' ... All start
  // closed: two full rosters as open lists were a 4,800px wall on a phone
  // (Owen, 2026-09-27). Kept across re-renders so picking a player does not
  // snap the section shut.
  openGroups: new Set(),
};
window.TRADE = TRADE;

/** Open or close one position section on one side. */
function toggleTradeGroup(groupKey) {
  if (TRADE.openGroups.has(groupKey)) TRADE.openGroups.delete(groupKey);
  else TRADE.openGroups.add(groupKey);
  renderTradeSides();
}
window.toggleTradeGroup = toggleTradeGroup;

/**
 * One collapsible position section. Closed, it is a one-line header with the
 * count -- plus any of its players already in the trade, so a selection never
 * hides. A search opens every section that has a match.
 *
 * @param {Array<{key: string, html: string}>} items chips, best first
 */
function tradeGroupHtml(side, pos, label, cls, items, forceOpen) {
  if (!items.length) return '';
  const groupKey = side + '|' + pos;
  const open = forceOpen || TRADE.openGroups.has(groupKey);
  const sideAssets = side === 'A' ? TRADE.sideAAssets : TRADE.sideBAssets;
  const shown = open ? items : items.filter((it) => sideAssets.has(it.key));
  return `<button type="button" class="tc-pos-label tc-pos-toggle ${cls}" data-tc-pos-toggle="${groupKey}" aria-expanded="${open}">` +
    `<span class="tc-pos-caret" aria-hidden="true">${open ? '▾' : '▸'}</span>${label}<span class="tc-pos-count">${items.length}</span></button>` +
    (shown.length ? '<div class="asset-pool">' + shown.map((it) => it.html).join('') + '</div>' : '');
}

// Filter handler — updates the search state and re-renders both sides
// (only the matching one will visibly change). Preserves focus on the input
// after re-render so user can continue typing.
function filterTradeSide(side, value) {
  if (side === 'A') TRADE.sideAFilter = value;
  else TRADE.sideBFilter = value;
  renderTradeSides();
  // Restore focus to the input that triggered the change
  const inputs = document.querySelectorAll('.trade-side-search');
  const idx = side === 'A' ? 0 : 1;
  if (inputs[idx]) {
    inputs[idx].focus();
    // Move cursor to end
    const v = inputs[idx].value;
    inputs[idx].setSelectionRange(v.length, v.length);
  }
}
window.filterTradeSide = filterTradeSide;

function initTradeCalculator() {
  const leaguePicker = document.getElementById('tradeLeaguePicker');
  leaguePicker.innerHTML = STATE.leagues.map((lg, i) => `
    <option value="${i}">${escapeHtml(lg.name)} - ${lg.scoringTab}</option>
  `).join('');
  leaguePicker.addEventListener('change', onTradeLeagueChange);
  document.getElementById('tradeSideAPicker').addEventListener('change', onTradeSideChange);
  document.getElementById('tradeSideBPicker').addEventListener('change', onTradeSideChange);
  onTradeLeagueChange();
  applyTradePreload();
}
window.initTradeCalculator = initTradeCalculator;

function applyTradePreload() {
  const pre = STATE.tradePreload;
  if (!pre) return;
  STATE.tradePreload = null;

  const leaguePicker = document.getElementById('tradeLeaguePicker');
  if (leaguePicker && pre.leagueIdx != null && pre.leagueIdx >= 0) {
    leaguePicker.value = String(pre.leagueIdx);
    TRADE.leagueIdx = pre.leagueIdx;
    const lg = STATE.leagues[TRADE.leagueIdx];
    const optionsHtml = lg.allRosters.map(r =>
      `<option value="${r.rosterId}">${escapeHtml(r.teamName)} - ${escapeHtml(r.ownerName)}${r.isMe ? ' (you)' : ''}</option>`,
    ).join('');
    document.getElementById('tradeSideAPicker').innerHTML = optionsHtml;
    document.getElementById('tradeSideBPicker').innerHTML = optionsHtml;
  }
  const sideA = document.getElementById('tradeSideAPicker');
  const sideB = document.getElementById('tradeSideBPicker');
  if (sideA && pre.sideARosterId) sideA.value = String(pre.sideARosterId);
  if (sideB && pre.sideBRosterId) sideB.value = String(pre.sideBRosterId);
  TRADE.sideARosterId = pre.sideARosterId;
  TRADE.sideBRosterId = pre.sideBRosterId;
  TRADE.sideAAssets.clear();
  TRADE.sideBAssets.clear();
  if (pre.assetKey) {
    if (pre.assetSide === 'A') TRADE.sideAAssets.add(pre.assetKey);
    else TRADE.sideBAssets.add(pre.assetKey);
  }
  if (Array.isArray(pre.sideAAssets)) {
    for (const k of pre.sideAAssets) if (k) TRADE.sideAAssets.add(k);
  }
  if (Array.isArray(pre.sideBAssets)) {
    for (const k of pre.sideBAssets) if (k) TRADE.sideBAssets.add(k);
  }
  renderTradeSides();
  renderTradeVerdict();
  renderDealSummary();
  renderFitPanel();
}
window.applyTradePreload = applyTradePreload;

function onTradeLeagueChange() {
  TRADE.leagueIdx = parseInt(document.getElementById('tradeLeaguePicker').value) || 0;
  const lg = STATE.leagues[TRADE.leagueIdx];
  const optionsHtml = lg.allRosters.map(r =>
    `<option value="${r.rosterId}">${escapeHtml(r.teamName)} - ${escapeHtml(r.ownerName)}${r.isMe ? ' (you)' : ''}</option>`,
  ).join('');
  const sideA = document.getElementById('tradeSideAPicker');
  const sideB = document.getElementById('tradeSideBPicker');
  sideA.innerHTML = optionsHtml;
  sideB.innerHTML = optionsHtml;
  const me = lg.allRosters.find(r => r.isMe);
  const other = lg.allRosters.find(r => !r.isMe);
  sideA.value = me ? me.rosterId : lg.allRosters[0].rosterId;
  sideB.value = other ? other.rosterId : lg.allRosters[1]?.rosterId;
  TRADE.sideAAssets.clear();
  TRADE.sideBAssets.clear();
  onTradeSideChange();
}
window.onTradeLeagueChange = onTradeLeagueChange;

/** Keep this tab's copy of the deal in step with your edits (toggleAsset, and
 * loadProposedTrade), so a refresh
 * of /league/<id>/trade brings it back (restoreOpenedTrade, 50). Only a deal
 * with you on side A is kept -- that is the shape a restore rebuilds -- and an
 * emptied calculator forgets it. */
function syncOpenedTrade() {
  try {
    const lg = STATE.leagues[TRADE.leagueIdx];
    const me = lg && lg.allRosters.find((r) => r.isMe);
    const empty = !TRADE.sideAAssets.size && !TRADE.sideBAssets.size;
    if (!lg || empty || !me || me.rosterId !== TRADE.sideARosterId) { sessionStorage.removeItem('taco.openedTrade'); return; }
    sessionStorage.setItem('taco.openedTrade', JSON.stringify({
      leagueId: lg.league_id, partnerRosterId: TRADE.sideBRosterId,
      myAssets: [...TRADE.sideAAssets], theirAssets: [...TRADE.sideBAssets],
    }));
  } catch (_e) { /* storage blocked: nothing survives a refresh, nothing breaks */ }
}
window.syncOpenedTrade = syncOpenedTrade;

function onTradeSideChange() {
  TRADE.sideARosterId = parseInt(document.getElementById('tradeSideAPicker').value);
  TRADE.sideBRosterId = parseInt(document.getElementById('tradeSideBPicker').value);
  TRADE.sideAAssets.clear();
  TRADE.sideBAssets.clear();
  renderTradeSides();
  renderTradeVerdict();
  renderDealSummary();
  renderFitPanel();
}
window.onTradeSideChange = onTradeSideChange;

function renderTradeSides() {
  const lg = STATE.leagues[TRADE.leagueIdx];
  const roster = (rosterId, sideAssets) => {
    const r = lg.allRosters.find(x => x.rosterId === rosterId);
    if (!r) return '<div>-</div>';
    const players = [...r.players].sort((a, b) => (b.value || 0) - (a.value || 0));
    const picks = lg.picksByRoster[rosterId] || [];

    const playersByPos = {};
    ['QB', 'RB', 'WR', 'TE'].forEach(pos => { playersByPos[pos] = []; });
    players.forEach(p => {
      if (playersByPos[p.position]) playersByPos[p.position].push(p);
    });

    const selectedSum = [...sideAssets].reduce((s, key) => s + assetValue(key, lg), 0);

    let html = `
      <div class="trade-side-head">
        <div>
          <div class="trade-side-label ${sideAssets === TRADE.sideAAssets ? 'tc-side-give' : 'tc-side-get'}">${sideAssets === TRADE.sideAAssets ? 'You give' : 'You get'} · ${r.isMe ? 'You' : r.teamName}${!r.isMe ? `
            <button class="pr-owner-btn"
                    data-taco-owner="${escapeHtml(lg.league_id)}|${r.rosterId}"
                    data-tooltip="See ${escapeHtml(r.ownerName)}'s trade pattern + history with you">ⓘ</button>` : ''}</div>
          <div class="trade-side-owner">${escapeHtml(r.teamName)}</div>
        </div>
        <div class="trade-side-total">${Math.round(selectedSum).toLocaleString()}</div>
      </div>
      <input type="text" class="trade-side-search" placeholder="Search this roster…"
             data-taco-trade-search="${sideAssets === TRADE.sideAAssets ? 'A' : 'B'}"
             autocomplete="off"
             value="${escapeHtml(sideAssets === TRADE.sideAAssets ? (TRADE.sideAFilter || '') : (TRADE.sideBFilter || ''))}">
    `;

    const filterText = sideAssets === TRADE.sideAAssets ? (TRADE.sideAFilter || '') : (TRADE.sideBFilter || '');
    const q = filterText.trim().toLowerCase();
    const matchesFilter = (p) => !q || (p.name || '').toLowerCase().includes(q);

    const side = sideAssets === TRADE.sideAAssets ? 'A' : 'B';
    ['QB', 'RB', 'WR', 'TE'].forEach(pos => {
      const visible = playersByPos[pos].filter(p => matchesFilter(p) || sideAssets.has(`P:${p.playerId}`));
      const items = visible.map(p => {
        const key = `P:${p.playerId}`;
        const selected = sideAssets.has(key) ? 'selected' : '';
        const chipVal = p.value || 0;
        return { key, html: `<div class="asset-chip pos-${pos.toLowerCase()} ${selected}" data-sleeper-id="${escapeHtml(p.playerId)}" data-tc-asset="${side}|${key}">${escapeHtml(p.name)} <span class="val">${chipVal ? Math.round(chipVal).toLocaleString() : '-'}</span></div>` };
      });
      html += tradeGroupHtml(side, pos, pos, `pos-${pos.toLowerCase()}`, items, !!q);
    });

    // Picks are not searched by name, so a search leaves them as they were.
    const pickItems = picks.map(p => {
      const key = `D:${p.season}-${p.round}-${p.originalRosterId}`;
      const selected = sideAssets.has(key) ? 'selected' : '';
      const pickVal = p.value || 0;
      return { key, html: `<div class="asset-chip pos-pick ${selected}" data-tc-asset="${side}|${key}">${p.label}${p.ownerNote !== 'Own' ? ' ' + p.ownerNote : ''} <span class="val">${pickVal ? Math.round(pickVal).toLocaleString() : '-'}</span></div>` };
    });
    html += tradeGroupHtml(side, 'Picks', 'Draft Picks', 'pos-pick', pickItems, false);
    return html;
  };

  document.getElementById('tradeSideA').innerHTML = roster(TRADE.sideARosterId, TRADE.sideAAssets);
  document.getElementById('tradeSideB').innerHTML = roster(TRADE.sideBRosterId, TRADE.sideBAssets);
}
window.renderTradeSides = renderTradeSides;

// Deal summary — the pieces actually in the trade, with photos + values and a
// running per-side total, so the give/get is concrete rather than just
// highlighted chips down in the roster pools.
function tradeDealPieceHtml(key, lg) {
  const [type, ...rest] = key.split(':');
  const id = rest.join(':');
  const val = assetValue(key, lg);
  if (type === 'P') {
    let name = id;
    let pos = '';
    for (const r of lg.allRosters) {
      const p = r.players.find((pp) => pp.playerId === id);
      if (p) { name = p.name; pos = p.position; break; }
    }
    const photo = typeof playerAvatarHtml === 'function' ? playerAvatarHtml(id, name, pos) : '';
    return `<div class="tc-deal-piece" data-taco-player="${escapeHtml(id)}">${photo}<span class="tc-deal-name">${escapeHtml(name)}</span><span class="tc-deal-val">${Math.round(val).toLocaleString()}</span></div>`;
  }
  const [season, round, orig] = id.split('-').map(Number);
  const picks = (lg.picksByRoster[TRADE.sideARosterId] || []).concat(lg.picksByRoster[TRADE.sideBRosterId] || []);
  const match = picks.find((p) => p.season === season && p.round === round && p.originalRosterId === orig);
  const label = match ? match.label : 'Pick';
  return `<div class="tc-deal-piece tc-deal-pick"><span class="tc-deal-pickicon" aria-hidden="true">◆</span><span class="tc-deal-name">${escapeHtml(label)}</span><span class="tc-deal-val">${Math.round(val).toLocaleString()}</span></div>`;
}

function renderDealSummary() {
  const el = document.getElementById('tradeDeal');
  if (!el) return;
  const lg = STATE.leagues[TRADE.leagueIdx];
  if (!lg || (!TRADE.sideAAssets.size && !TRADE.sideBAssets.size)) {
    // Not a blank 0-0: say how to start (Trades brief, 2026-09-27).
    el.style.display = lg ? '' : 'none';
    el.innerHTML = lg
      ? '<div class="tc-empty"><div class="tc-empty-title">Build a deal</div>' +
        '<ol class="tc-empty-steps"><li>Pick the league and the team you are trading with.</li>' +
        '<li>Tap players or picks on each side below.</li>' +
        '<li>The verdict appears here as soon as both sides have something, priced for this league\'s scoring.</li></ol>' +
        '<div class="tc-empty-hint">Short of ideas? <a data-router href="/tools/trade-finder">Trade Finder</a> lists fair deals across all your leagues, priced exactly the way this calculator prices them.</div></div>'
      : '';
    return;
  }
  const col = (assets, cls, label) => {
    const items = [...assets];
    const total = items.reduce((s, k) => s + assetValue(k, lg), 0);
    const pieces = items.length
      ? items.map((k) => tradeDealPieceHtml(k, lg)).join('')
      : '<div class="tc-deal-empty">Nothing yet - click players below</div>';
    return `<div class="tc-deal-col ${cls}">
      <div class="tc-deal-head"><span class="tc-deal-label">${label}</span><span class="tc-deal-total">${Math.round(total).toLocaleString()}</span></div>
      <div class="tc-deal-pieces">${pieces}</div>
    </div>`;
  };
  el.style.display = '';
  el.innerHTML = col(TRADE.sideAAssets, 'tc-deal-give', 'You give') +
    '<div class="tc-deal-arrow" aria-hidden="true">⇄</div>' +
    col(TRADE.sideBAssets, 'tc-deal-get', 'You get');
}
window.renderDealSummary = renderDealSummary;

// Flat market value -- matches the per-chip display above and every other
// page's totals (see 10-sleeper-api.js playerLeagueValue).
function assetValue(key, lg) {
  return assetValueIn(key, lg, [TRADE.sideARosterId, TRADE.sideBRosterId]);
}

/** The calculator's value for one asset key, with the two rosters named rather
 * than read from the open calculator -- so a Trade Finder card can be priced
 * exactly as the calculator will price it once opened (proposalCalc, 19). */
function assetValueIn(key, lg, rosterIds) {
  const [type, ...rest] = key.split(':');
  const id = rest.join(':');
  if (type === 'P') {
    for (const r of lg.allRosters) {
      const p = r.players.find(pp => pp.playerId === id);
      if (p) return p.value || 0;
    }
    return 0;
  }
  if (type === 'D') {
    const [season, round, origRosterId] = id.split('-').map(Number);
    const picks = (rosterIds || []).flatMap((rid) => (lg.picksByRoster && lg.picksByRoster[rid]) || []);
    const match = picks.find(p => p.season === season && p.round === round && p.originalRosterId === origRosterId);
    return match?.value || 0;
  }
  return 0;
}

window.assetValueIn = assetValueIn;

function toggleAsset(side, key) {
  const target = side === 'A' ? TRADE.sideAAssets : TRADE.sideBAssets;
  if (target.has(key)) {
    target.delete(key);
  } else {
    target.add(key);
    // Real engagement signal (TACO overhaul Phase 5), not just "opened the
    // view" -- fired once per session on the first real asset add, not
    // every toggle (that would just be event noise).
    if (!STATE.tradeCalculatorUsedTracked && typeof trackEvent === 'function') {
      STATE.tradeCalculatorUsedTracked = true;
      trackEvent('trade_calculator_used');
    }
  }
  renderTradeSides();
  renderTradeVerdict();
  renderDealSummary();
  renderFitPanel();
  syncOpenedTrade();
}
window.toggleAsset = toggleAsset;

;
/*! ==== 32-standalone-player-rankings-top-level-tool-format.js ==== */
// Standalone Format Rankings tool (/rankings). League picker selects scoring format.
function initStandaloneRankings() {
  const picker = document.getElementById('rankingsLeaguePicker');
  if (!picker) return;
  if (picker.options.length !== STATE.leagues.length) {
    picker.innerHTML = STATE.leagues.map((lg, i) => `
      <option value="${i}">${escapeHtml(lg.name)} - ${lg.scoringTab}</option>
    `).join('');
    picker.addEventListener('change', renderStandaloneRankings);
    picker.value = STATE.standaloneRankingsLeagueIdx ?? 0;
  }
  renderStandaloneRankings();
}
window.initStandaloneRankings = initStandaloneRankings;

function renderStandaloneRankings() {
  const picker = document.getElementById('rankingsLeaguePicker');
  const container = document.getElementById('rankingsContent');
  if (!picker || !container) return;
  const idx = parseInt(picker.value || '0');
  STATE.standaloneRankingsLeagueIdx = idx;
  const lg = STATE.leagues[idx];
  if (!lg) {
    container.innerHTML = '<div class="empty-state">Pick a league above to see values in its format.</div>';
    return;
  }
  container.innerHTML = renderRankingsPanel(lg);
  pinRankingsBars(container);
}

/** The pinned column header sits under the pinned filter bar on wide screens;
 * the bar's height depends on its contents, so measure it (CSS: #rankingsContent). */
function pinRankingsBars(container) {
  const panel = container.querySelector('.rankings-panel');
  const bar = container.querySelector('.rankings-filters');
  if (!panel || !bar) return;
  const pinned = getComputedStyle(bar).position === 'sticky';
  panel.style.setProperty('--rk-bar-h', pinned ? bar.offsetHeight + 'px' : '0px');
}
window.renderStandaloneRankings = renderStandaloneRankings;

/**
 * Rankings, opened on one player (Scouting brief cross-links, 2026-09-27): the
 * format of a league you own him in (else the league you are looking at),
 * filtered to his position, scrolled to his row and flashed. Reached from the
 * player drawer, which Market Radar, Advanced Stats and Trade Finder all open.
 */
function openPlayerInRankings(playerId, leagueId) {
  const pid = String(playerId);
  let idx = (STATE.leagues || []).findIndex((l) => l.league_id === leagueId);
  if (idx < 0) idx = STATE.currentTeamIdx != null && STATE.leagues[STATE.currentTeamIdx] ? STATE.currentTeamIdx : 0;
  const pos = TacoCore.primaryFantasyPosition ? TacoCore.primaryFantasyPosition(STATE.playersDB && STATE.playersDB[pid]) : null;
  STATE.standaloneRankingsLeagueIdx = idx;
  STATE.rankingsFilter = ['QB', 'RB', 'WR', 'TE'].includes(pos) ? pos : 'ALL';
  STATE.rankingsRookiesOnly = false;
  STATE.rankingsSort = 'value';
  STATE.rankingsShown = 100000; // his row must be on the page to scroll to it
  const picker = document.getElementById('rankingsLeaguePicker');
  if (picker && picker.options.length) picker.value = String(idx);
  if (typeof navigateFromLink === 'function') navigateFromLink(null, '/tools/rankings');
  // The view renders its own board as it opens; wait for his row, then land on it.
  let tries = 0;
  const land = () => {
    const view = document.getElementById('rankingsView');
    const row = view && view.classList.contains('active')
      ? document.querySelector('#rankingsContent .rankings-row[data-taco-player="' + CSS.escape(pid) + '"]')
      : null;
    if (!row) {
      if (tries === 5) renderStandaloneRankings();
      if (++tries < 30) setTimeout(land, 100);
      return;
    }
    scrollIntoViewSafely(row, { behavior: 'smooth', block: 'center' });
    row.classList.add('taco-focus-flash');
    setTimeout(() => row.classList.remove('taco-focus-flash'), 3200);
  };
  setTimeout(land, 60);
}
window.openPlayerInRankings = openPlayerInRankings;
// The filter bar re-wraps as the window resizes; keep the header under it.
let pinRankingsResizeTimer = null;
window.addEventListener('resize', () => {
  clearTimeout(pinRankingsResizeTimer);
  pinRankingsResizeTimer = setTimeout(() => {
    const c = document.getElementById('rankingsContent');
    if (c) pinRankingsBars(c);
  }, 150);
});

;
/*! ==== 33-trade-finder-cross-league-scanner.js ==== */
// Trade Finder — cross-league aggregation of the existing single-league
// trade-suggestion engine (19-suggested-trades...js / shared/trades.mjs).
// TACO-006. Aggregation/ranking math lives in shared/trade-finder.mjs.

function tradeFinderCacheKey() {
  return (STATE.leagues || [])
    .map((lg) => `${lg.league_id}:${(lg.allRosters || []).length}`)
    .join('|');
}

/** League display label used on each card's league chip. */
function tradeFinderLeagueLabel(name, scoringTab) {
  return `${name} · ${scoringTab}`;
}

function renderTradeFinderView() {
  const container = document.getElementById('tradeFinderContent');
  if (!container) return;

  if (window.TacoAuth && !TacoAuth.hasFreeAccount()) {
    container.innerHTML = TacoAuth.gateHtml('tradeFinder');
    container.dataset.initialized = '';
    return;
  }

  if (!container.dataset.initialized) {
    container.innerHTML = `
      <div class="ma-head">
        <div>
          <h2 class="ma-title">Trade Finder</h2>
          <div class="ma-sub" id="tfSub">Scanning your leagues for trade opportunities…</div>
        </div>
      </div>
      <div class="ma-filters" id="tfGoals"></div>
      <div class="ma-filters" id="tfFilters"></div>
      <div class="ma-list" id="tfList"></div>
    `;
    container.dataset.initialized = 'true';
  }

  renderTradeFinderResults();

  // One deferred re-render, so settled pick prices actually reach the screen.
  //
  // Pick values are provisional at first paint and settle onto the composite
  // anchors about a second later. renderTradeFinderResults now treats a
  // changed cache key as stale and re-requests -- but only when it runs, and
  // on a direct load of this view it runs exactly once, before the settle. So
  // nothing ever corrected the first answer, and Trade Finder sat on 7,708 for
  // a pick every other surface had settled at 4,541.
  //
  // One shot, not a poll: the stale check is idempotent and the second render
  // is a no-op when nothing changed.
  if (!STATE._tradeFinderSettleRerun) {
    STATE._tradeFinderSettleRerun = true;
    setTimeout(() => {
      if (typeof getActiveView === 'function' && getActiveView() === 'tradeFinder') {
        renderTradeFinderResults();
      }
    }, 3500);
  }
}
window.renderTradeFinderView = renderTradeFinderView;

function renderTradeFinderResults() {
  const subEl = document.getElementById('tfSub');
  const filtersEl = document.getElementById('tfFilters');
  const listEl = document.getElementById('tfList');
  if (!subEl || !filtersEl || !listEl) return;

  const leagues = STATE.leagues || [];
  if (leagues.length === 0) {
    subEl.textContent = 'No leagues loaded yet.';
    filtersEl.innerHTML = '';
    listEl.innerHTML = '<div class="tab-empty">Connect your Sleeper leagues to scan for trade opportunities.</div>';
    return;
  }

  // Per-league proposals: immediate (possibly client-fallback) data now,
  // server-ranked data replaces it in place once refreshTradeSuggestionsFromServer
  // resolves (idempotent — safe to call even if getTradeSuggestionsForLeague
  // already triggered the same fetch).
  const goalByLeague = {};
  const leagueProposals = leagues.map((lg, idx) => {
    const archetype = (typeof archetypeForRoster === 'function' && lg.allRosters)
      ? archetypeForRoster(lg, lg.allRosters.find((r) => r.isMe))
      : null;
    const bundle = typeof getTradeSuggestionsForLeague === 'function'
      ? getTradeSuggestionsForLeague(lg, archetype)
      : { proposals: [] };

    // Refresh when the cache is EMPTY or STALE, not just when it is empty.
    //
    // Pick prices settle after the composite loads, so the first request goes
    // out with pre-settle values and its response is cached. The old condition
    // only fired when there was no data at all, so that first, wrong answer
    // was never replaced -- Trade Finder went on showing 7,708 for a pick the
    // rest of the app had since settled at 4,541. tradeSuggestionsCacheKey now
    // covers pick values, so a changed key IS the signal that the cached
    // answer was computed from stale inputs.
    const cached = STATE._tradeSuggestions?.[lg.league_id];
    const freshKey = typeof tradeSuggestionsCacheKey === 'function'
      ? tradeSuggestionsCacheKey(lg)
      : null;
    const stale = !!cached?.data && !!freshKey && cached.key !== freshKey;
    if ((!cached?.data || stale) && !cached?.loading && typeof refreshTradeSuggestionsFromServer === 'function') {
      refreshTradeSuggestionsFromServer(lg).then(() => {
        if (typeof getActiveView === 'function' && getActiveView() === 'tradeFinder') {
          renderTradeFinderResults();
        }
      });
    }

    goalByLeague[lg.league_id] = TacoCore.goalForArchetype ? TacoCore.goalForArchetype(archetype) : 'balanced';
    return {
      leagueId: lg.league_id,
      leagueName: lg.name,
      leagueIdx: idx,
      scoringTab: lg.scoringTab,
      proposals: bundle.proposals || [],
    };
  });

  // Goals and locks (roadmap #4, shared/trade-goals.mjs): never offer a locked
  // player, and rank for the goal -- each league's own style on Auto.
  const goal = STATE.tradeFinderGoal || 'auto';
  const locked = tradeFinderLocks();
  const allTagged = TacoCore.rankForGoal(
    TacoCore.withoutLocked(TacoCore.aggregateTradeFinderProposals(leagueProposals), locked),
    goal,
    (p) => goalByLeague[p.leagueId] || 'balanced',
  );
  const goalsEl = document.getElementById('tfGoals');
  if (goalsEl) {
    goalsEl.innerHTML = renderFilterPills({
      items: Object.keys(TacoCore.GOALS).map((key) => ({ key, label: TacoCore.GOALS[key] })),
      activeKey: goal,
      handlerName: 'setTradeFinderGoal',
    }) + (locked.size
      ? '<span class="tf-locked-list">Never offer: ' + [...locked].map((pid) =>
          '<button type="button" class="tf-unlock" data-taco-pill="toggleTradeFinderLock|' + escapeHtml(pid) + '">' +
          escapeHtml(tradeFinderPlayerName(pid)) + ' ×</button>').join('') + '</span>'
      : '');
  }

  const dismissed = tradeFinderDismissedSet();
  const filter = STATE.tradeFinderFilter || 'ALL';
  // Fair deals first, in the goal's order; then the rest from closest to
  // least close -- by the calculator's numbers. Win-now used to sort purely by
  // how much older you come out, which put a "+37% to them" overpay second.
  const closeness = (p) => {
    const c = proposalCalc(p, STATE.leagues[p.leagueIdx]);
    return c ? (c.verdict.fair ? -1 : c.imbalance) : 0;
  };
  const notDismissed = allTagged
    .filter((p) => !dismissed.has(p.key) && proposalWithinBand(p, STATE.leagues[p.leagueIdx]))
    .map((p, i) => ({ p, i, k: closeness(p) }))
    .sort((x, y) => (x.k < 0 && y.k < 0 ? x.i - y.i : x.k - y.k || x.i - y.i))
    .map((x) => x.p);

  const byPos = { ALL: notDismissed.length, QB: 0, RB: 0, WR: 0, TE: 0 };
  for (const p of notDismissed) {
    const pos = p.theirAsset?.position;
    if (byPos[pos] != null) byPos[pos]++;
  }

  const filtered = filter === 'ALL' ? notDismissed : notDismissed.filter((p) => p.theirAsset?.position === filter);

  const rankedBy = goal === 'contend' ? 'win-now first' : goal === 'rebuild' ? 'building value first' : goal === 'auto' ? 'each league\'s own goal' : 'fairness';
  subEl.textContent = `${filtered.length} opportunit${filtered.length === 1 ? 'y' : 'ies'} across ${leagues.length} league${leagues.length === 1 ? '' : 's'} · fair deals first, then ${rankedBy}`;

  filtersEl.innerHTML = renderFilterPills({
    items: ['ALL', 'QB', 'RB', 'WR', 'TE'].map((key) => ({
      key,
      label: key === 'ALL' ? 'All' : key,
      count: byPos[key],
    })),
    activeKey: filter,
    handlerName: 'setTradeFinderFilter',
  });

  const hiddenHere = allTagged.filter((p) => dismissed.has(p.key)).length;
  if (subEl && hiddenHere) {
    subEl.innerHTML = escapeHtml(subEl.textContent) + ' · <button type="button" class="tf-restore" data-taco-pill="restoreTradeFinderDismissed|all">' +
      hiddenHere + ' hidden as not interested - bring back</button>';
  }

  if (filtered.length === 0) {
    const anyEverFound = allTagged.length > 0;
    listEl.innerHTML = anyEverFound
      ? '<div class="tab-empty">You\'ve dismissed every opportunity found so far. Check back after your leagues update.</div>'
      : '<div class="tab-empty">No balanced trade opportunities found across your leagues right now - either rosters are well-matched, or there\'s not enough data yet. Check back later.</div>';
    return;
  }

  const shownCap = STATE.tradeFinderShown || 25;
  const visible = filtered.slice(0, shownCap);
  const remaining = filtered.length - visible.length;

  listEl.innerHTML = visible.map((p) => renderTradeFinderCard(p)).join('')
    + (remaining > 0
      ? `<div class="ma-show-row"><button class="show-more-btn" data-taco-pill-fn="showMoreTradeFinder">Show ${Math.min(25, remaining)} more<span class="show-more-count">${remaining} remaining</span></button>` +
        (remaining > 25 ? '<button class="ghost small" data-taco-pill-fn="showAllTradeFinder">Show all ' + filtered.length + '</button>' : '') + '</div>'
      : '');
}
window.renderTradeFinderResults = renderTradeFinderResults;

function renderTradeFinderCard(p) {
  const lg = STATE.leagues[p.leagueIdx];
  const calc = proposalCalc(p, lg);
  const valOf = (a) => (calc ? calc.mine[p.myAssets.indexOf(a)] : a.value);
  const myAssetsLines = p.myAssets.map((a) => {
    if (a.kind === 'pick') {
      return `<div class="proposal-asset"><span class="proposal-asset-name">${escapeHtml(a.name)} <span class="suggest-pick-tag">PICK</span></span><span class="proposal-asset-value">${Math.round(valOf(a)).toLocaleString()}</span></div>`;
    }
    const pid = a.ref?.playerId;
    return `<div class="proposal-asset ${pid ? 'proposal-asset-clickable' : ''}"
                 ${pid ? `data-taco-player="${escapeHtml(pid)}"` : ''}>
      <span class="proposal-asset-name">${typeof teamLogoHtml === 'function' ? teamLogoHtml(a.ref.team, 'proposal-team-logo') : ''}${escapeHtml(a.name)} <span class="proposal-asset-meta">${a.ref.position} · age ${a.ref.age || '?'}</span></span>
      <span class="proposal-asset-value">${Math.round(valOf(a)).toLocaleString()}</span>
      ${pid ? `<button type="button" class="tf-lock" data-taco-pill="toggleTradeFinderLock|${escapeHtml(pid)}" data-tooltip="Never offer ${escapeHtml(a.name)}" aria-label="Never offer ${escapeHtml(a.name)}">🔒</button>` : ''}
    </div>`;
  }).join('');

  const theirP = p.theirAsset;
  const theirLine = `<div class="proposal-asset ${theirP.playerId ? 'proposal-asset-clickable' : ''}"
                          ${theirP.playerId ? `data-taco-player="${escapeHtml(theirP.playerId)}"` : ''}>
    <span class="proposal-asset-name">${typeof teamLogoHtml === 'function' ? teamLogoHtml(theirP.team, 'proposal-team-logo') : ''}${escapeHtml(theirP.name)} <span class="proposal-asset-meta">${theirP.position} · age ${theirP.age || '?'}</span></span>
    <span class="proposal-asset-value">${Math.round(calc ? calc.theirs : theirP.value).toLocaleString()}</span>
  </div>`;

  const balanceBadge = tradeProposalBadge(p, lg);

  const dataAttr = JSON.stringify({
    leagueIdx: p.leagueIdx,
    partnerRosterId: p.partnerRosterId,
    myAssets: p.myAssets.map((a) => a.id),
    theirAssets: [`P:${p.theirAsset.playerId}`],
  }).replace(/"/g, '&quot;');

  return `
    <div class="proposal-card">
      <div class="tf-league-chip">${escapeHtml(tradeFinderLeagueLabel(p.leagueName, p.scoringTab))}</div>
      <div class="proposal-head">
        <div>
          <div class="proposal-partner">Trade with <strong>${escapeHtml(p.partnerName)}</strong></div>
          <div class="proposal-partner-arch">${escapeHtml(p.partnerArchetype || '')}</div>
        </div>
        ${balanceBadge}
      </div>
      <div class="proposal-sides">
        <div class="proposal-side">
          <div class="proposal-side-label">You send</div>
          ${myAssetsLines}
          <div class="proposal-side-total">${proposalTotalHtml(calc ? calc.myTotal : p.myTotal, calc ? calc.myEffective : p.myEffective)}</div>
        </div>
        <div class="proposal-arrow">↔</div>
        <div class="proposal-side">
          <div class="proposal-side-label">You get</div>
          ${theirLine}
          <div class="proposal-side-total">${proposalTotalHtml(calc ? calc.theirs : p.theirTotal, calc ? calc.theirEffective : p.theirEffective)}</div>
        </div>
      </div>
      <div class="proposal-why">${escapeHtml(p.fitReason || '')}${p.ageShift ? ` <span class="tf-age">You come out ${Math.abs(p.ageShift)} yr${Math.abs(p.ageShift) === 1 ? '' : 's'} ${p.ageShift > 0 ? 'older' : 'younger'}.</span>` : ''}</div>
      <div class="proposal-actions">
        <button class="ghost small" data-proposal="${dataAttr}" data-taco-proposal="${dataAttr}">Open in calculator →</button>
        <button class="ghost small" data-taco-pill="dismissTradeFinderProposal|${escapeHtml(p.key)}">Not interested</button>
      </div>
    </div>
  `;
}

/** Players the finder must never offer (roadmap #4). Remembered on this device. */
function tradeFinderLocks() {
  const arr = typeof TacoStorage !== 'undefined' ? TacoStorage.get('tradeFinderLocks', []) : [];
  return new Set(Array.isArray(arr) ? arr.map(String) : []);
}

function toggleTradeFinderLock(pid) {
  const locks = tradeFinderLocks();
  if (locks.has(String(pid))) locks.delete(String(pid)); else locks.add(String(pid));
  if (typeof TacoStorage !== 'undefined') TacoStorage.set('tradeFinderLocks', [...locks]);
  renderTradeFinderResults();
}
window.toggleTradeFinderLock = toggleTradeFinderLock;

function tradeFinderPlayerName(pid) {
  const p = STATE.playersDB && STATE.playersDB[pid];
  return p ? (p.full_name || ((p.first_name || '') + ' ' + (p.last_name || '')).trim()) : pid;
}

function setTradeFinderGoal(goal) {
  STATE.tradeFinderGoal = goal;
  STATE.tradeFinderShown = 25;
  renderTradeFinderResults();
}
window.setTradeFinderGoal = setTradeFinderGoal;

function setTradeFinderFilter(filter) {
  STATE.tradeFinderFilter = filter;
  STATE.tradeFinderShown = 25;
  renderTradeFinderResults();
}
window.setTradeFinderFilter = setTradeFinderFilter;

function showMoreTradeFinder() {
  STATE.tradeFinderShown = (STATE.tradeFinderShown || 25) + 25;
  renderTradeFinderResults();
}
window.showMoreTradeFinder = showMoreTradeFinder;

function showAllTradeFinder() {
  STATE.tradeFinderShown = 100000;
  renderTradeFinderResults();
}
window.showAllTradeFinder = showAllTradeFinder;

// "Not interested" is remembered on this device (it used to reset on every
// refresh), capped so a season of dismissals cannot grow without bound.
const TF_DISMISSED_KEY = 'tradeFinderDismissed';
const TF_DISMISSED_CAP = 400;
function tradeFinderDismissedSet() {
  if (!STATE.tradeFinderDismissedLoaded) {
    STATE.tradeFinderDismissedLoaded = true;
    const saved = typeof TacoStorage !== 'undefined' ? TacoStorage.get(TF_DISMISSED_KEY, []) : [];
    for (const k of Array.isArray(saved) ? saved : []) STATE.tradeFinderDismissed.add(String(k));
  }
  return STATE.tradeFinderDismissed;
}
function saveTradeFinderDismissed() {
  if (typeof TacoStorage === 'undefined') return;
  TacoStorage.set(TF_DISMISSED_KEY, [...STATE.tradeFinderDismissed].slice(-TF_DISMISSED_CAP));
}

function dismissTradeFinderProposal(key) {
  tradeFinderDismissedSet().add(key);
  saveTradeFinderDismissed();
  renderTradeFinderResults();
  if (typeof showToast === 'function') {
    showToast('Hidden from Trade Finder.', { action: { label: 'Undo', onClick: () => restoreTradeFinderDismissed(key) } });
  }
}

/** Undo one dismissal, or bring every hidden card back ('all'). */
function restoreTradeFinderDismissed(key) {
  const set = tradeFinderDismissedSet();
  if (key === 'all') set.clear(); else set.delete(key);
  saveTradeFinderDismissed();
  renderTradeFinderResults();
}
window.restoreTradeFinderDismissed = restoreTradeFinderDismissed;
window.dismissTradeFinderProposal = dismissTradeFinderProposal;

;
/*! ==== 45-team-navigation-jumps-between-league-views.js ==== */
// Cross-view navigation: league deep-dive, trade calc, league view.
// Extracted from sleeper-stats (17) — navigation is not stats logic.
//
// The prev/next team pager went with the ← → buttons on 2026-10-18; the
// league switcher does that job without asking you to count.

function jumpToLeagueView(leagueIdx) {
  if (!STATE.leagueTeamsInitialized) {
    initLeagueView();
    STATE.leagueTeamsInitialized = true;
  }
  document.getElementById('leagueTeamsPicker').value = leagueIdx;
  renderLeagueView();
  showView('leagueTeams');
}

function jumpToTeamByLeagueId(leagueId) {
  const idx = STATE.leagues.findIndex(lg => lg.league_id === leagueId);
  if (idx < 0) return;
  STATE.currentTeamIdx = idx;
  STATE.teamDetailTab = 'overview';
  renderTeamDetail();
  showView('team');
}
window.jumpToTeamByLeagueId = jumpToTeamByLeagueId;

function jumpToTrade(leagueIdx) {
  if (!STATE.tradeInitialized) {
    initTradeCalculator();
    STATE.tradeInitialized = true;
  }
  // The real Trades tab, not a second calculator inside League Overview
  // (Owen, 2026-10-18). STATE.teamDetailTab is deliberately NOT set: leaving
  // it on 'trade' is what turned a later visit to League Overview into a
  // trade screen.
  STATE.currentTeamIdx = leagueIdx;
  const picker = document.getElementById('tradeLeaguePicker');
  if (picker) { picker.value = String(leagueIdx); onTradeLeagueChange(); }
  showView('trade');
}

function jumpToTradeWith(leagueIdx, otherRosterId) {
  if (!STATE.tradeInitialized) {
    initTradeCalculator();
    STATE.tradeInitialized = true;
  }
  STATE.currentTeamIdx = leagueIdx;
  const picker = document.getElementById('tradeLeaguePicker');
  if (picker) { picker.value = String(leagueIdx); onTradeLeagueChange(); }
  const sideB = document.getElementById('tradeSideBPicker');
  if (sideB) { sideB.value = otherRosterId; onTradeSideChange(); }
  showView('trade');
}

function jumpToTradeHistoryForLeague(leagueId) {
  const idx = STATE.leagues.findIndex((l) => l.league_id === leagueId);
  if (idx >= 0) STATE.currentTeamIdx = idx;
  else if (STATE.currentTeamIdx == null && STATE.leagues.length) STATE.currentTeamIdx = 0;
  // Show the STANDALONE Trade History view (its own identity under Trades),
  // scoped to this league via the filter — not the team-detail subtab.
  STATE.tradeHistoryFilter = leagueId;
  showView('tradeHistory');
}
window.jumpToTradeHistoryForLeague = jumpToTradeHistoryForLeague;

function switchToLeague(idx) {
  if (idx == null || idx < 0 || idx >= STATE.leagues.length) return;
  STATE.currentTeamIdx = idx;
  const lg = STATE.leagues[idx];
  if (STATE.teamDetailTab === 'tradeHistory' && lg) {
    STATE.tradeHistoryFilter = lg.league_id;
  }
  renderTeamDetail();
  updateLeagueNavTab();
}
window.switchToLeague = switchToLeague;

function loadProposedTrade(jsonStr) {
  try {
    const data = JSON.parse(jsonStr);
    // Trade Finder (TACO-006) proposals carry their own leagueIdx, since the
    // card can be from a league other than whatever's currently active — the
    // single-league Trade Suggestions panel never sets this, so it falls
    // back to the existing behavior unchanged.
    const leagueIdx = data.leagueIdx ?? STATE.currentTeamIdx;
    if (!STATE.tradeInitialized) {
      initTradeCalculator();
      STATE.tradeInitialized = true;
    }
    document.getElementById('tradeLeaguePicker').value = leagueIdx;
    onTradeLeagueChange();
    document.getElementById('tradeSideBPicker').value = data.partnerRosterId;
    onTradeSideChange();
    TRADE.sideAAssets.clear();
    TRADE.sideBAssets.clear();
    data.myAssets.forEach(k => TRADE.sideAAssets.add(k));
    data.theirAssets.forEach(k => TRADE.sideBAssets.add(k));
    renderTradeSides();
    renderTradeVerdict();
    renderFitPanel();
    STATE.currentTeamIdx = leagueIdx;
    // The Trades tab, and teamDetailTab left alone (2026-10-18).
    showView('trade');
    // Saved for this tab so a refresh brings the deal back (syncOpenedTrade, 31).
    if (typeof syncOpenedTrade === 'function') syncOpenedTrade();
  } catch (e) {
    console.error('Failed to load proposed trade:', e);
    // Previously silent -- clicking "Build trade with X" (Trade Finder
    // proposals, League View strips) did nothing visible on failure.
    // TACO overhaul Phase 2.
    if (typeof window.showToast === 'function') {
      window.showToast('Couldn\'t load that trade proposal. Try again from the original page.', { type: 'error' });
    }
  }
}
window.loadProposedTrade = loadProposedTrade;

window.jumpToLeagueView = jumpToLeagueView;
window.jumpToTrade = jumpToTrade;
window.jumpToTradeWith = jumpToTradeWith;
;
/*! ==== 61-my-assets-data.js ==== */
// Cross-league player/pick aggregation for My Assets and exposure summary.

function buildMyAssetsData() {
  const playerMap = new Map();
  const pickMap = new Map();

  for (const lg of STATE.leagues) {
    for (const p of lg.myPlayers) {
      const key = p.playerId;
      if (!playerMap.has(key)) {
        playerMap.set(key, {
          playerId: p.playerId,
          name: p.name,
          position: p.position,
          team: p.team,
          age: p.age,
          rookie: p.rookie,
          exposures: [],
        });
      }
      playerMap.get(key).exposures.push({
        leagueId: lg.league_id,
        leagueName: lg.name,
        scoringTab: lg.scoringTab,
        value: p.value || 0,
        isStarter: p.isStarter,
        isIR: p.isIR,
        isTaxi: p.isTaxi,
        nTrades: p.nTrades || 0,
      });
    }

    for (const pk of (lg.myPicks || [])) {
      const key = `${pk.season}-${pk.round}-${pk.slot || '?'}`;
      if (!pickMap.has(key)) {
        pickMap.set(key, {
          label: pk.label,
          season: pk.season,
          round: pk.round,
          slot: pk.slot,
          bucket: pk.bucket,
          exposures: [],
        });
      }
      pickMap.get(key).exposures.push({
        leagueId: lg.league_id,
        leagueName: lg.name,
        scoringTab: lg.scoringTab,
        value: pk.value || 0,
        ownerNote: pk.ownerNote,
      });
    }
  }

  return {
    players: [...playerMap.values()],
    picks: [...pickMap.values()],
  };
}
;
/*! ==== 62-my-assets-results.js ==== */
// My Assets results list — filters, search hits, stat strip. Uses data-ma-* delegation.

/** Small trust badge for how much real trade data backs a player's price --
 * turns the manual "check n_trades via /api/debug/first-party-trace"
 * workflow used all through the 2026-07-11/12 calibration work into
 * something visible without a debug call. Tiers loosely mirror
 * tradeConfidence's n/12-capped-at-1 curve (shared/value-engine.mjs) --
 * duplicated here as a small UI-only tier split rather than wiring that
 * whole module into the frontend bundle for one formula. Uses the highest
 * nTrades across a player's exposures (their most-evidenced format), since
 * a player's real trade count can differ by format (SF vs 1QB trade
 * graphs aren't the same population). Picks aren't covered here -- they're
 * anchor-seeded, not primarily a trade-confidence signal the same way. */
function tradeConfidenceBadge(exposures) {
  const nTrades = Math.max(0, ...exposures.map(e => e.nTrades || 0));
  let tier, label;
  if (nTrades >= 12) { tier = 'verified'; label = 'Verified'; }
  else if (nTrades >= 4) { tier = 'moderate'; label = 'Moderate'; }
  else if (nTrades >= 1) { tier = 'thin'; label = 'Thin'; }
  else { tier = 'none'; label = 'No trades'; }
  const tip = nTrades > 0
    ? `Priced with ${nTrades} real trade${nTrades === 1 ? '' : 's'} in its best-evidenced format: more trades behind a price means less influence from stats/ADP alone.`
    : 'No real trades yet for this player, so it is priced from trailing stats and ADP only.';
  return `<span class="ma-confidence-badge ma-confidence-${tier}" data-tooltip="${escapeHtml(tip)}">${label}</span>`;
}

let maWeekLineupsAsked = false;

// Rows the user has opened, so a re-render (sort, filter, show more) keeps them.
const maExpanded = new Set();
document.addEventListener('click', function (e) {
  const btn = e.target.closest ? e.target.closest('[data-ma-expand]') : null;
  if (!btn) return;
  const key = btn.getAttribute('data-ma-expand');
  const row = btn.closest('.ma-row2');
  const list = row && row.querySelector('.ma-lgs');
  if (!list) return;
  const open = list.hidden;
  list.hidden = !open;
  row.classList.toggle('ma-open', open);
  btn.setAttribute('aria-expanded', String(open));
  btn.querySelector('span').textContent = (open ? 'Hide' : 'Show') + ' leagues';
  if (open) maExpanded.add(key); else maExpanded.delete(key);
});

function renderMyAssetsResults() {
  const totalLeagues = STATE.leagues.length;
  const searchQuery = STATE.assetsSearchQuery || '';
  const isSearching = searchQuery.trim().length >= 2;
  const subEl = document.getElementById('maSub');
  const filtersEl = document.getElementById('maFilters');
  const listEl = document.getElementById('maList');
  if (!subEl || !filtersEl || !listEl) return;

  // ===== Search mode =====
  if (isSearching) {
    const q = normalizeName(searchQuery);
    const hits = [];
    STATE.leagues.forEach(lg => {
      lg.allRosters.forEach(r => {
        r.players.forEach(p => {
          if (normalizeName(p.name).includes(q)) {
            hits.push({ player: p, league: lg, roster: r });
          }
        });
      });
    });

    const byPlayer = {};
    hits.forEach(h => {
      if (!byPlayer[h.player.name]) byPlayer[h.player.name] = [];
      byPlayer[h.player.name].push(h);
    });
    const sortedPlayers = Object.entries(byPlayer).sort(([, a], [, b]) => b.length - a.length);

    subEl.textContent = 'Searching across all rosters in all your leagues';
    const statCard = document.getElementById('assetsStatCard');
    if (statCard) statCard.style.display = 'none';
    filtersEl.innerHTML = '';

    if (sortedPlayers.length === 0) {
      listEl.innerHTML = '<div class="tab-empty">No matches across any roster in any of your leagues.</div>';
      return;
    }

    listEl.innerHTML = sortedPlayers.map(([name, entries]) => {
      const myEntries = entries.filter(e => e.roster.isMe);
      const minesCount = myEntries.length;
      const othersCount = entries.length - minesCount;
      const firstPlayer = entries[0].player;
      const headerMeta = `${firstPlayer.position}${firstPlayer.team ? ' · ' + firstPlayer.team : ''}${firstPlayer.age ? ' · age ' + firstPlayer.age : ''}`;
      // Per-row treatment: only render leagues where YOU own the player.
      // Opponent rows used to render too, producing a long wall of info that
      // isn't actionable (popular players are owned by someone in every league
      // — obvious without needing 25 rows). When you don't own the player
      // anywhere, render a graceful empty-state row instead.
      const myRowsHtml = myEntries.length === 0
        ? `<div class="search-result-empty">Not on any of your rosters · owned by opponents in ${othersCount} league${othersCount === 1 ? '' : 's'}</div>`
        : myEntries.map(e => {
            const ownerLabel = e.roster.teamName || e.roster.ownerName || 'Your team';
            const tag = e.player.isStarter ? 'START' : e.player.isIR ? 'IR' : e.player.isTaxi ? 'TAXI' : '';
            return `
              <div class="search-result-row mine" data-ma-jump-league="${escapeHtml(e.league.league_id)}">
                <div class="search-result-league">
                  <div>${escapeHtml(e.league.name)}</div>
                  <div class="search-result-subline">${e.league.scoringTab} · ${escapeHtml(ownerLabel)}${tag ? ' · ' + tag : ''}</div>
                </div>
                <div class="search-result-rank">${e.player.posRank || e.player.position}</div>
                <div class="search-result-value">${e.player.value ? Math.round(e.player.value).toLocaleString() : '-'}</div>
              </div>
            `;
          }).join('');
      // Header avatar matches the main list — same 40px treatment via
      // playerAvatarHtml. Clicking the name/meta block opens the player
      // drawer, which is what the user expects from every other player
      // surface in the app.
      const headerAvatar = playerAvatarHtml(firstPlayer.playerId, name, firstPlayer.position);
      return `
        <div class="search-result-group">
          <div class="search-result-head">
            ${headerAvatar}
            <div class="search-result-headmain ma-main-clickable" data-ma-player="${escapeHtml(firstPlayer.playerId)}">
              <div class="search-result-name">${escapeHtml(name)}</div>
              <div class="search-result-meta">${headerMeta}</div>
            </div>
            <div class="search-result-counts">
              ${minesCount > 0 ? `<span class="search-count-pill mine">You own in ${minesCount}</span>` : ''}
              ${othersCount > 0 ? `<span class="search-count-pill">Owned by others in ${othersCount}</span>` : ''}
            </div>
          </div>
          ${myRowsHtml}
        </div>
      `;
    }).join('');
    return;
  }

  // ===== Default: portfolio browse =====
  const { players, picks } = buildMyAssetsData();
  const filter = STATE.myAssetsFilter || 'ALL';
  const pctExposure = (n) => totalLeagues > 0 ? Math.round((n / totalLeagues) * 100) : 0;
  const totalExposures = players.reduce((s, p) => s + p.exposures.length, 0);
  const uniquePlayers = players.length;
  const avgValue = players.length > 0 ? Math.round(
    players.reduce((s, p) => s + p.exposures.reduce((ss, e) => ss + e.value, 0) / p.exposures.length, 0) / players.length
  ).toLocaleString() : '0';

  let filtered;
  if (filter === 'PICK') {
    filtered = picks.map(pk => ({
      kind: 'pick',
      name: pk.label,
      meta: `${pk.season} · ${pk.bucket || 'Mid'} ${ordinal(pk.round)}`,
      exposures: pk.exposures,
      totalValue: pk.exposures.reduce((s, e) => s + e.value, 0),
      sortValue: pk.exposures.reduce((s, e) => s + e.value, 0) / pk.exposures.length,
    }));
  } else {
    const players_ = filter === 'ALL' ? players : players.filter(p => p.position === filter);
    filtered = players_.map(p => ({
      kind: 'player',
      playerId: p.playerId,
      name: p.name,
      meta: `${p.position} · ${p.team || 'FA'}${p.age ? ' · age ' + p.age : ''}${p.rookie ? ' · ROOK' : ''}`,
      position: p.position,
      exposures: p.exposures,
      totalValue: p.exposures.reduce((s, e) => s + e.value, 0),
      sortValue: p.exposures.reduce((s, e) => s + e.value, 0) / p.exposures.length,
    }));
  }

  if (filter === 'PICK') {
    filtered.sort((a, b) => {
      const pa = picks.find(p => p.label === a.name);
      const pb = picks.find(p => p.label === b.name);
      if (!pa || !pb) return 0;
      if (pa.season !== pb.season) return pa.season - pb.season;
      if (pa.round !== pb.round) return pa.round - pb.round;
      const slotA = pa.slot ?? 99;
      const slotB = pb.slot ?? 99;
      return slotA - slotB;
    });
  } else {
    // User-selectable sort for player view. Picks filter still ignores this
    // and uses chronological order — that's the only sensible sort for picks.
    const sortKey = STATE.assetsSortKey || 'exposure';
    const playerTotalValue = (asset) => asset.exposures.reduce((s, e) => s + (e.value || 0), 0);
    const playerAvgValue = (asset) => asset.exposures.length ? playerTotalValue(asset) / asset.exposures.length : 0;
    // We need access to the raw player data for age (filtered objects only carry sortValue).
    // Build a quick lookup from playerId.
    const playerById = new Map();
    for (const p of players) playerById.set(p.playerId, p);
    filtered.sort((a, b) => {
      const pa = playerById.get(a.playerId);
      const pb = playerById.get(b.playerId);
      if (sortKey === 'total') {
        return playerTotalValue(pb) - playerTotalValue(pa);
      } else if (sortKey === 'avg') {
        return playerAvgValue(pb) - playerAvgValue(pa);
      } else if (sortKey === 'age') {
        // Youngest first. Treat missing ages as "very old" so they sink.
        const ageA = pa?.age ?? 99;
        const ageB = pb?.age ?? 99;
        return ageA - ageB;
      }
      // Default: exposure count desc, then total value desc as tiebreaker.
      const d = b.exposures.length - a.exposures.length;
      if (d !== 0) return d;
      return playerTotalValue(pb) - playerTotalValue(pa);
    });
  }

  const counts = {
    ALL: players.length,
    QB: players.filter(p => p.position === 'QB').length,
    RB: players.filter(p => p.position === 'RB').length,
    WR: players.filter(p => p.position === 'WR').length,
    TE: players.filter(p => p.position === 'TE').length,
    PICK: picks.length,
  };

  // Sort dropdown — matches the existing All Leagues sort pattern
  // (overview-select). Replaces an earlier pill-row treatment that competed
  // visually with the position filter pills. Hidden on PICK filter since
  // picks have a fixed chronological order.
  const activeSortKey = STATE.assetsSortKey || 'exposure';
  const sortDropdownHtml = filter === 'PICK' ? '' : renderSortSelect({
    id: 'maSortSelect',
    label: 'Sort by',
    value: activeSortKey,
    handlerName: 'setMyAssetsSort',
    options: [
      { value: 'exposure', label: 'Exposure' },
      { value: 'total', label: 'Total value' },
      { value: 'avg', label: 'Avg value' },
      { value: 'age', label: 'Age' },
    ],
  });

  const pillsHtml = renderFilterPills({
    items: [
      { key: 'ALL', label: 'All', count: counts.ALL },
      { key: 'QB', label: 'QB', count: counts.QB },
      { key: 'RB', label: 'RB', count: counts.RB },
      { key: 'WR', label: 'WR', count: counts.WR },
      { key: 'TE', label: 'TE', count: counts.TE },
      { key: 'PICK', label: 'Picks', count: counts.PICK },
    ],
    activeKey: filter,
    handlerName: 'setMyAssetsFilter',
  });

  const maShownCap = STATE.myAssetsShown || 50;
  const maRemaining = Math.max(0, filtered.length - maShownCap);
  // Each row shows how exposed you are; the leagues themselves open on a click
  // (Owen, 2026-09-30: listing every league under every player made the page
  // 14,000px tall).
  const rowsHtml = filtered.slice(0, maShownCap).map(asset => {
    const rowKey = asset.playerId || asset.name;
    const isOpen = maExpanded.has(String(rowKey));
    const exposureChips = asset.exposures.map(e => {
      const tag = e.isStarter ? 'Start' : e.isIR ? 'IR' : e.isTaxi ? 'Taxi' : 'Bench';
      return `
        <button type="button" class="ma-lg" title="Open ${escapeHtml(e.leagueName)}" data-ma-jump-league="${escapeHtml(e.leagueId)}">
          <span class="ma-lg-name">${escapeHtml(e.leagueName)}</span>
          <span class="ma-lg-val">${e.value ? Math.round(e.value).toLocaleString() : '-'}</span>
          <span class="ma-lg-tag ma-lg-${tag.toLowerCase()}">${tag}</span>
        </button>
      `;
    }).join('');
    const avatarHtml = asset.kind === 'player'
      ? playerAvatarHtml(asset.playerId, asset.name, asset.position)
      : `<div class="avatar avatar-pick"><span class="avatar-initials">PK</span></div>`;
    const pct = pctExposure(asset.exposures.length);
    return `
      <div class="ma-row ma-row2${isOpen ? ' ma-open' : ''}">
        <div class="ma-row2-top">
          ${avatarHtml}
          <div class="ma-main ${asset.playerId ? 'ma-main-clickable' : ''}" ${asset.playerId ? `data-ma-player="${escapeHtml(asset.playerId)}"` : ""}>
            <div class="ma-name">${escapeHtml(asset.name)}${asset.kind === 'player' ? tradeConfidenceBadge(asset.exposures) : ''}</div>
            <div class="ma-meta">${escapeHtml(asset.meta)}</div>
          </div>
          <div class="ma-exp">
            <div class="ma-exp-num"><strong>${asset.exposures.length}</strong><span>/${totalLeagues}</span></div>
            <div class="ma-exp-bar"><i style="width:${pct}%"></i></div>
            <div class="ma-exp-pct">${pct}% of leagues</div>
          </div>
          <div class="ma-total-value" data-tooltip="Sum of this asset's value across every league you're exposed to it in">
            <strong>${Math.round(asset.totalValue).toLocaleString()}</strong>
            <span>total value</span>
          </div>
          <button type="button" class="ma-toggle" data-ma-expand="${escapeHtml(String(rowKey))}" aria-expanded="${isOpen}">
            <span>${isOpen ? 'Hide' : 'Show'} leagues</span><i aria-hidden="true">▾</i>
          </button>
        </div>
        <div class="ma-lgs"${isOpen ? '' : ' hidden'}>${exposureChips}</div>
      </div>
    `;
  }).join('') || '<div class="tab-empty">No assets match this filter.</div>';

  subEl.textContent = `${uniquePlayers} unique players across ${totalExposures} roster spots in ${totalLeagues} leagues · ${picks.length} unique picks · avg value ${avgValue} per player`;

  // Show the stat-grid panel (re-shown after a search clears)
  const statCardForShow = document.getElementById('assetsStatCard');
  if (statCardForShow) statCardForShow.style.display = '';

  // Populate the rich stat-grid panel above the search input.
  const statGridEl = document.getElementById('assetsStatGrid');
  if (statGridEl) {
    // Top 3 most-exposed players for the "Most exposed" strip.
    // Replaces the single-name cell — one player doesn't tell you much about
    // your portfolio's concentration; the top 3 gives a real glance.
    const topExposed = [...players]
      .sort((a, b) => b.exposures.length - a.exposures.length)
      .slice(0, 3);
    const topExposedHtml = topExposed.length > 0
      ? topExposed.map(asset => {
          const av = playerAvatarHtml(asset.playerId, asset.name, asset.position);
          // Trim long names so the strip stays compact across 3 names
          const shortName = asset.name.length > 16 ? asset.name.slice(0, 16) + '…' : asset.name;
          return `
            <div class="ma-top-exposed-item" data-ma-player="${escapeHtml(asset.playerId)}" title="Open ${escapeHtml(asset.name)}">
              ${av}
              <div class="ma-top-exposed-meta">
                <div class="ma-top-exposed-name">${escapeHtml(shortName)}</div>
                <div class="ma-top-exposed-count">${asset.exposures.length}× owned${(() => {
                  const st = TacoCore.injuryStatusOf(null, STATE.playersDB?.[asset.playerId]);
                  return st ? ' · <span class="ma-top-exposed-inj">' + escapeHtml(TacoCore.injuryLabel(st)) + '</span>' : '';
                })()}</div>
              </div>
            </div>
          `;
        }).join('')
      : '<div class="ma-top-exposed-empty">-</div>';
    // Count PLAYERS, and report the lineup spots separately.
    //
    // This counted roster slots and labelled them "hurt starters", so one
    // questionable player rostered in twelve leagues showed up as twelve. On
    // 2026-09-03 it read a red 91 against 29 actual players -- and the cell
    // immediately to its left counts unique players over exposures, so the
    // same panel was using two different units without saying so.
    //
    // Then it disagreed with the Action Queue two screens away (4 players / 14
    // spots against the queue's 3 / 12, 2026-09-27): it read each roster's
    // last-edited lineup rather than this week's, and counted Questionable.
    // Now: this week's lineup when loaded, Out / Doubtful / IR by the queue's
    // own rules, and Questionable reported beside it rather than inside it.
    const weekStarters = typeof lineupSweepLineups === 'function' ? lineupSweepLineups() : null;
    if (!weekStarters && !maWeekLineupsAsked && typeof ensureWeekLineups === 'function') {
      maWeekLineupsAsked = true; // once: a failed fetch must not re-render in a loop
      Promise.resolve(ensureWeekLineups()).catch(() => null).then(() => {
        const v = document.querySelector('.view.active');
        if (v && v.id === 'myAssetsView' && typeof lineupSweepLineups === 'function' && lineupSweepLineups()) renderMyAssetsResults();
      });
    }
    const hurtStarterIds = new Set();
    const questStarterIds = new Set();
    let hurtStarterSlots = 0;
    for (const lg of STATE.leagues) {
      const wk = weekStarters && weekStarters[String(lg.league_id)];
      const startIds = Array.isArray(wk) ? new Set(wk.map(String)) : null;
      for (const p of lg.myPlayers || []) {
        if (startIds ? !startIds.has(String(p.playerId)) : !p.isStarter) continue;
        const sev = TacoCore.injurySeverityKey(TacoCore.injuryStatusOf(p, STATE.playersDB?.[p.playerId]));
        if (sev === 'out' || sev === 'doubt') {
          hurtStarterIds.add(p.playerId);
          hurtStarterSlots += 1;
        } else if (sev === 'quest') {
          questStarterIds.add(p.playerId);
        }
      }
    }
    const hurtStarters = hurtStarterIds.size;
    const questStarters = questStarterIds.size;
    const concThreshold = Math.ceil(totalLeagues * 0.5);
    const concentrated = players.filter((p) => p.exposures.length >= concThreshold).length;
    const posExposure = { QB: 0, RB: 0, WR: 0, TE: 0 };
    for (const p of players) {
      if (posExposure[p.position] != null) posExposure[p.position] += p.exposures.length;
    }
    const exposureBars = ['QB', 'RB', 'WR', 'TE'].map((pos) => {
      const n = posExposure[pos] || 0;
      const pct = totalExposures > 0 ? Math.round((n / totalExposures) * 100) : 0;
      return `<div class="ma-exposure-bar"><span class="ma-exposure-bar-label pos-${pos.toLowerCase()}">${pos}</span><div class="ma-exposure-bar-track"><div class="ma-exposure-bar-fill pos-${pos.toLowerCase()}" style="width:${pct}%"></div></div><span class="ma-exposure-bar-pct">${pct}%</span></div>`;
    }).join('');

    // Where your value is concentrated (roadmap #6, shared/concentration.mjs):
    // one NFL team, or one player, carrying a big share of the whole book.
    const conc = TacoCore.portfolioConcentration ? TacoCore.portfolioConcentration(players, totalLeagues) : { teams: [], players: [] };
    const concLines = [
      ...conc.teams.map((t) => '<div class="ma-conc-item ma-conc-stack"><strong>' + t.share + '% on ' + escapeHtml(t.team) + '</strong> - ' +
        escapeHtml(t.players.slice(0, 5).join(', ')) + (t.players.length > 5 ? ' +' + (t.players.length - 5) : '') + '. One bad week for that offense hits every league.</div>'),
      ...conc.players.slice(0, 6).map((pl) => '<div class="ma-conc-item" data-ma-player="' + escapeHtml(pl.playerId) + '"><strong>' + escapeHtml(pl.name) + '</strong> - ' +
        pl.share + '% of your value, in ' + pl.leagues + ' of ' + totalLeagues + ' leagues</div>'),
    ];
    if (!concLines.length && conc.topTeam && conc.topPlayer) {
      concLines.push('<div class="ma-conc-item"><strong>Well spread.</strong> Your biggest NFL team is ' + escapeHtml(conc.topTeam.team) + ' at ' + conc.topTeam.share +
        '% of your value; your biggest player, ' + escapeHtml(conc.topPlayer.name) + ', is ' + conc.topPlayer.share + '% (in ' + conc.topPlayer.leagues + ' of ' + totalLeagues + ' leagues).</div>');
    }
    const concentrationHtml = concLines.length
      ? '<div class="ma-concentration"><div class="stat-strip-grouplabel">Concentration</div>' + concLines.join('') +
        '<div class="ma-conc-note">Flagged: an NFL team with 15%+ of your total value across 3+ players; a player worth 8%+ of it, or in half your leagues.</div></div>'
      : '';

    statGridEl.innerHTML = `
      <div class="stat-strip">
        <div class="stat-strip-group">
          <div class="stat-strip-grouplabel">Inventory</div>
          <div class="stat-strip-cells">
            <div class="stat-strip-cell">
              <div class="stat-strip-num">${uniquePlayers}</div>
              <div class="stat-strip-label">unique players</div>
              <div class="stat-strip-sub">${totalExposures} exposures</div>
            </div>
            <div class="stat-strip-cell">
              <div class="stat-strip-num muted">${picks.length}</div>
              <div class="stat-strip-label">unique picks</div>
            </div>
          </div>
        </div>

        <div class="stat-strip-divider"></div>

        <div class="stat-strip-group">
          <div class="stat-strip-grouplabel">Portfolio health</div>
          <div class="stat-strip-cells">
            <div class="stat-strip-cell">
              <div class="stat-strip-num ${hurtStarters ? 'warn' : ''}">${hurtStarters}</div>
              <div class="stat-strip-label">starters out</div>
              <div class="stat-strip-sub">${hurtStarterSlots} lineup spot${hurtStarterSlots === 1 ? '' : 's'}${questStarters ? ' · ' + questStarters + ' questionable' : ''}</div>
            </div>
            <div class="stat-strip-cell">
              <div class="stat-strip-num">${concentrated}</div>
              <div class="stat-strip-label">50%+ exposure</div>
              <!-- Says what this number counts. It used to read "depth in WR",
                   which is maxPos -- the position you hold the MOST of -- a
                   different statistic entirely. With concentrated at 0 the pair
                   rendered as "0 / depth in WR", i.e. exactly the opposite of
                   what maxPos means. The positional split it was trying to show
                   is already the exposure bars directly below. -->
              <div class="stat-strip-sub">in ${concThreshold}+ of ${totalLeagues} leagues</div>
            </div>
          </div>
        </div>

        <div class="stat-strip-divider"></div>

        <div class="stat-strip-group">
          <div class="stat-strip-grouplabel">Most exposed</div>
          <div class="ma-top-exposed-strip">${topExposedHtml}</div>
        </div>
      </div>
      <div class="ma-exposure-bars">${exposureBars}</div>
      ${concentrationHtml}
    `;
    if (typeof animateStatNumbers === 'function') animateStatNumbers(statGridEl);
  }

  filtersEl.innerHTML = `<div class="ma-filters-row">${pillsHtml}${sortDropdownHtml}</div>`;
  listEl.innerHTML = rowsHtml + (maRemaining > 0
    ? `<div class="ma-show-row"><button class="show-more-btn" data-taco-pill-fn="showMoreMyAssets">Show ${Math.min(50, maRemaining)} more<span class="show-more-count">${maRemaining} remaining</span></button>` +
      (maRemaining > 50 ? '<button class="ghost small" data-taco-pill-fn="showAllMyAssets">Show all ' + filtered.length + '</button>' : '') + '</div>'
    : '');
}

function showMoreMyAssets() {
  STATE.myAssetsShown = (STATE.myAssetsShown || 50) + 50;
  renderMyAssetsResults();
}
window.showMoreMyAssets = showMoreMyAssets;

function showAllMyAssets() {
  STATE.myAssetsShown = 100000;
  renderMyAssetsResults();
}
window.showAllMyAssets = showAllMyAssets;

(function wireMyAssetsDelegation() {
  if (wireMyAssetsDelegation._wired) return;
  wireMyAssetsDelegation._wired = true;
  document.addEventListener('click', (e) => {
    const root = e.target.closest('#myAssetsContent');
    if (!root) return;
    const jump = e.target.closest('[data-ma-jump-league]');
    if (jump?.dataset.maJumpLeague) {
      jumpToTeamByLeagueId(jump.dataset.maJumpLeague);
      return;
    }
    const player = e.target.closest('[data-ma-player]');
    if (player?.dataset.maPlayer) openPlayerDrawer(player.dataset.maPlayer);
  });
})();

;
/*! ==== 44-my-assets-consolidated-cross-league-view.js ==== */
// My Assets shell — static frame, search input, filter/sort handlers.
// Data aggregation → 61; results rendering → 62.

function renderMyAssetsView() {
  const container = document.getElementById('myAssetsContent');
  if (!container) return;
  if (window.TacoAuth && !TacoAuth.hasFreeAccount()) {
    container.innerHTML = TacoAuth.gateHtml('myAssets');
    container.dataset.initialized = '';
    return;
  }

  const searchQuery = STATE.assetsSearchQuery || '';

  if (!container.dataset.initialized) {
    // The portfolio summary sits above the list (Owen, 2026-09-30: the side
    // rail "looks terrible, should have just left it up top"). Module 62
    // targets #assetsStatGrid / #maFilters / #maList by id.
    container.innerHTML = `
      <div class="ma-head">
        <div>
          <h2 class="ma-title">Assets &amp; Exposure</h2>
          <div class="ma-lede">Every player you own, in every league: who you are heavy on and who is hurt</div>
          <div class="ma-sub" id="maSub"></div>
        </div>
      </div>
      <div id="assetsStatCard" class="ma-overview">
        <div id="assetsStatGrid"></div>
      </div>
      <div class="ma-listcol">
        <div class="assets-search-wrap">
          <input
            type="text"
            class="assets-search-input"
            id="assetsSearchInput"
            placeholder="Search any player across all rosters…"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
          >
          <button class="assets-search-clear" id="assetsSearchClear" data-tooltip="Clear search" aria-label="Clear search" style="display: none;">×</button>
        </div>
        <div class="ma-filters" id="maFilters"></div>
        <div class="ma-list" id="maList"></div>
      </div>
    `;
    const input = document.getElementById('assetsSearchInput');
    const clearBtn = document.getElementById('assetsSearchClear');
    input.addEventListener('input', (e) => {
      STATE.assetsSearchQuery = e.target.value;
      clearBtn.style.display = e.target.value.length > 0 ? 'flex' : 'none';
      renderMyAssetsResults();
    });
    clearBtn.addEventListener('click', () => {
      input.value = '';
      STATE.assetsSearchQuery = '';
      clearBtn.style.display = 'none';
      input.focus();
      renderMyAssetsResults();
    });
    container.dataset.initialized = 'true';
  }

  const input = document.getElementById('assetsSearchInput');
  const clearBtn = document.getElementById('assetsSearchClear');
  if (input && input.value !== searchQuery) {
    input.value = searchQuery;
    if (clearBtn) clearBtn.style.display = searchQuery.length > 0 ? 'flex' : 'none';
  }

  renderMyAssetsResults();
}

function setMyAssetsSort(key) {
  STATE.assetsSortKey = key;
  STATE.myAssetsShown = 50; // new sort, fresh page
  renderMyAssetsResults();
}
window.setMyAssetsSort = setMyAssetsSort;

function setAssetsSearch(query) {
  STATE.assetsSearchQuery = query;
  STATE.myAssetsShown = 50;
  const input = document.getElementById('assetsSearchInput');
  if (input && input.value !== query) input.value = query;
  renderMyAssetsResults();
}
window.setAssetsSearch = setAssetsSearch;

function setMyAssetsFilter(filter) {
  STATE.myAssetsFilter = filter;
  STATE.myAssetsShown = 50;
  renderMyAssetsResults();
}
window.setMyAssetsFilter = setMyAssetsFilter;
window.renderMyAssetsView = renderMyAssetsView;
;
/*! ==== 34-archetype-starter-based-structure-aware.js ==== */
﻿// Archetype classification + proposed lineup — browser-enriched (ADP/FC thresholds).
// Depth safety + trade fit analysis live in shared/ and 60-trade-fit-analysis.

function computeStartersNeeded(lg) {
  return TacoCore.computeStartersNeeded(lg);
}

// Build a proposed starting lineup based on the league's roster_positions and KTC value.
// Walks the roster_positions array in order, greedily assigning the best remaining eligible
// player to each slot. Returns an array of slot objects: { slotLabel, slotType, player, eligible }.
// Position-locked slots are filled first (QB/RB/WR/TE), then flex variants, then SUPER_FLEX.
// This ordering matters: if you filled SUPER_FLEX before QB, you could waste your QB1 there.
function buildProposedLineup(lg, roster) {
  const rp = lg.roster_positions || [];
  // Map slot type -> eligible position list
  const ELIGIBILITY = {
    QB: ['QB'],
    RB: ['RB'],
    WR: ['WR'],
    TE: ['TE'],
    FLEX: ['RB', 'WR', 'TE'],
    REC_FLEX: ['WR', 'TE'],
    WRRB_FLEX: ['RB', 'WR'],
    SUPER_FLEX: ['QB', 'RB', 'WR', 'TE'],
  };

  // Active offensive players only (skip IR, taxi, and non-offensive slots).
  // Rank via playerLeagueValue (now flat market value, see 10-sleeper-api.js)
  // -- must match the Roster tab's own ranking/display (renderPlayerRow,
  // 54-team-detail-roster-tab.js's groupActive sort) or the same player
  // shows two different numbers depending which panel you're looking at.
  const pool = roster.players
    .filter(p => p.isActive !== false && ['QB','RB','WR','TE'].includes(p.position))
    .sort((a, b) => (playerLeagueValue(b, lg) || 0) - (playerLeagueValue(a, lg) || 0));

  // Separate scratch pool — we'll remove players as we assign them
  const available = [...pool];
  const usedIds = new Set();

  // Slot fill order: position-locked slots first, then FLEX variants (most-restrictive first),
  // then SUPER_FLEX last. This greedy order protects scarce positions from being wasted
  // on less-restrictive slots.
  const SLOT_ORDER = ['QB', 'RB', 'WR', 'TE', 'REC_FLEX', 'WRRB_FLEX', 'FLEX', 'SUPER_FLEX'];
  const NON_OFFENSE_SLOTS = new Set(['K', 'DEF', 'DL', 'LB', 'DB', 'IDP_FLEX', 'BN']);

  // Index all offensive slot positions so we preserve the display order
  // (rosters render in roster_positions order, which is usually QB, RB, RB, WR, WR, WR, TE, FLEX, SF)
  const slotsInOrder = rp.map((slotType, idx) => ({ idx, slotType })).filter(s => !NON_OFFENSE_SLOTS.has(s.slotType));

  const filled = new Array(slotsInOrder.length).fill(null);

  // Fill in SLOT_ORDER priority
  for (const slotType of SLOT_ORDER) {
    const eligible = ELIGIBILITY[slotType];
    if (!eligible) continue;
    // Find all slots of this type that haven't been filled yet (in display order)
    for (let i = 0; i < slotsInOrder.length; i++) {
      if (filled[i]) continue;
      if (slotsInOrder[i].slotType !== slotType) continue;
      // Grab best available player matching eligibility
      const bestIdx = available.findIndex(p => eligible.includes(p.position) && !usedIds.has(p.playerId));
      if (bestIdx === -1) continue;
      const picked = available[bestIdx];
      usedIds.add(picked.playerId);
      filled[i] = { slotType, player: picked };
    }
  }

  // Build final array, including empty slots
  return slotsInOrder.map((s, i) => ({
    slotType: s.slotType,
    player: filled[i]?.player || null,
  }));
}

// Human-friendly label for a slot type
function slotTypeLabel(slotType) {
  switch (slotType) {
    case 'SUPER_FLEX': return 'SFLEX';
    case 'REC_FLEX': return 'W/T';
    case 'WRRB_FLEX': return 'R/W';
    default: return slotType;
  }
}

// Returns true if ADP signal indicates the player is community-startable.
// Used to override pure-value "below threshold" hole detection — a rookie
// like Quinshon Judkins or Tre Harris going in the early second round of
// startup drafts is a startable asset even if their trade value lags.
//
// Threshold: top 36 overall (3 rounds in a 12-team draft) means consensus
// flex-or-better. Top 60 (5 rounds) means consensus bench-startable depth.
// Beyond pick 60 we don't override — value rankings handle the long tail.
function isAdpStartable(playerId, lg) {
  const adp = STATE.adpByPlayer?.[playerId];
  if (!adp || adp.avgPick == null) return false;
  // In SF leagues, the startable bar is wider — more positions to fill,
  // and rookie SF QBs especially get drafted early without FC value yet.
  const isSF = lg?.scoringTab && lg.scoringTab.startsWith('SF');
  const startableCap = isSF ? 48 : 36;
  return adp.avgPick <= startableCap;
}

// A team's archetype is determined by three things:
//   1. Starter-quality value (sum of top-N at each required position, where N = starter slots)
//   2. Structural completeness (does every required starter slot have a viable player?)
//   3. Starter age (the age of the players they'd actually field, not bench depth)
//
// A team with massive bench value but zero startable RBs is NOT a contender. It's Middle Tier
// with a critical hole. This matches how humans actually evaluate rosters.
//
// Threshold for "startable" player value. In an SF league, a starter-quality
// player carries 2000+ FC value; in 1QB, the value pool is smaller (QBs dominate
// less of the total value), so the same percentile player has a lower raw value.
//
// We compute the threshold as a percentage of the max value in the format,
// derived empirically from how FC distributes values: ~25% of max value
// roughly corresponds to a startable starter (top 30-40 at flex positions in
// a 12-team league). This adapts naturally to any format.
//
// Falls back to 2000 if maxValue isn't loaded (shouldn't happen in practice).
const STARTABLE_THRESHOLD = 2000;  // legacy fallback for any code that hasn't migrated

// Per-position, rank-based startable thresholds. The Nth-ranked player at
// each position in a 12-team league represents "the last roster-worthy
// starter" — below them you're scrambling. Calibrated for typical lineup
// requirements (1 QB, 2 RB + flex, 3 WR + flex, 1 TE) plus reasonable
// roster depth. SF leagues need more QB depth.
//
// These are the rank cutoffs we use as "still a startable piece":
//   QB:  24 in SF, 18 in 1QB (depth roster spots beyond actual starters)
//   RB:  30 (top 30 RBs are all starter-quality somewhere in dynasty)
//   WR:  40 (deeper position; top 40 WRs are all starter-quality)
//   TE:  12 (1 starter slot * 12 teams; TE drops off a cliff after ~10)
const STARTABLE_RANK_CUTOFFS = {
  '1qb': { QB: 18, RB: 30, WR: 40, TE: 12 },
  'sf':  { QB: 24, RB: 30, WR: 40, TE: 12 },
};

// Cache per-format thresholds so we don't recompute on every player check.
function getPositionStartableThresholds(scoringTab) {
  if (STATE._startableThresholdCache?.[scoringTab]) {
    return STATE._startableThresholdCache[scoringTab];
  }
  STATE._startableThresholdCache = STATE._startableThresholdCache || {};

  const isSF = scoringTab && scoringTab.startsWith('SF');
  const cutoffs = isSF ? STARTABLE_RANK_CUTOFFS.sf : STARTABLE_RANK_CUTOFFS['1qb'];

  // Walk every player in our value lookup for this format, group by
  // position, sort, take the Nth-ranked value as the threshold.
  const fcLookup = STATE.fcPlayerLookup?.[scoringTab];
  if (!fcLookup || fcLookup.size === 0) {
    return { QB: STARTABLE_THRESHOLD, RB: STARTABLE_THRESHOLD, WR: STARTABLE_THRESHOLD, TE: STARTABLE_THRESHOLD };
  }

  const byPos = { QB: [], RB: [], WR: [], TE: [] };
  for (const entry of fcLookup.values()) {
    if (!entry || !entry.position || !byPos[entry.position]) continue;
    // The lookup already holds our composite value, priced by the engine for
    // this exact format. It used to get a TE-premium multiplier on top (a
    // double-count) and then go through computeCompositeValue, which replaces
    // it with Dynasty Daddy's KTC price when it has one -- so the "startable"
    // thresholds every archetype is judged against were partly KTC's board,
    // on a different scale from the roster values being compared to them.
    const v = entry.value || 0;
    if (v > 0) byPos[entry.position].push(v);
  }

  const thresholds = {};
  for (const pos of ['QB', 'RB', 'WR', 'TE']) {
    const sorted = byPos[pos].sort((a, b) => b - a);
    const n = cutoffs[pos] || 24;
    // The threshold is the value of the Nth-ranked player. If we have fewer
    // players than N (shouldn't happen in practice), fall back to last value.
    thresholds[pos] = sorted[n - 1] || sorted[sorted.length - 1] || STARTABLE_THRESHOLD;
  }

  STATE._startableThresholdCache[scoringTab] = thresholds;
  return thresholds;
}

// Backward-compat: position-agnostic threshold for callers that haven't
// migrated. Returns the WR threshold (deepest position, most lenient floor).
function getStartableThreshold(scoringTab) {
  const t = getPositionStartableThresholds(scoringTab);
  return t.WR || STARTABLE_THRESHOLD;
}

// Position-aware startable check. Use this in new code paths so a TE6 isn't
// flagged below startable just because their absolute value is below a WR4.
function isPositionStartable(value, position, scoringTab) {
  const t = getPositionStartableThresholds(scoringTab);
  return (value || 0) >= (t[position] || STARTABLE_THRESHOLD);
}

function computeArchetypeForRoster(lg, roster) {
  const startersNeeded = computeStartersNeeded(lg);
  const positions = ['QB', 'RB', 'WR', 'TE'];
  const positionThresholds = getPositionStartableThresholds(lg.scoringTab);

  // For each position, pull starters + depth (depth-weighted) and sum values.
  // Same depth formula as computePositionalSummary / computeTeamNeeds:
  //   - TE: 3 deep at 70% (3 startable TEs is rare, valuable for byes/trades)
  //   - Other: N capped at 3 at 50%
  let starterValueTotal = 0;
  const starterPlayers = []; // flat list of starter-level players across all positions
  const holes = [];
  for (const pos of positions) {
    const n = startersNeeded[pos] || 0;
    if (n === 0) continue;
    const threshold = positionThresholds[pos] || STARTABLE_THRESHOLD;
    const pool = roster.players
      .filter(p => p.isActive !== false && p.position === pos)
      .sort((a, b) => (b.value || 0) - (a.value || 0));
    const topN = pool.slice(0, n);

    // Add starter values (with ADP-startable override for community-priced rookies)
    for (let i = 0; i < n; i++) {
      const p = topN[i];
      let v = p?.value || 0;
      if (p && v < threshold && isAdpStartable(p.playerId, lg)) {
        v = threshold;
      }
      starterValueTotal += v;
      if (p) starterPlayers.push(p);
      if (!p) {
        holes.push({ pos, severity: 'critical', reason: `No player in slot ${i + 1}/${n}` });
      } else if ((p.value || 0) < threshold) {
        if (!isAdpStartable(p.playerId, lg)) {
          holes.push({ pos, severity: 'major', reason: `${p.name} (${Math.round(p.value || 0).toLocaleString()}) below startable` });
        }
      }
    }

    // Add depth-weighted bench value — bye coverage, injury insurance, trade leverage.
    const { depthN, depthWeight } = depthWeighting(pos, n);
    const depthSlice = pool.slice(n, n + depthN);
    const depthValue = depthSlice.reduce((s, p) => s + (p.value || 0), 0) * depthWeight;
    starterValueTotal += depthValue;
  }

  // Starter-weighted avg age (based on the players we'd actually field)
  const starterAges = starterPlayers.filter(p => p.age && p.age > 0).map(p => p.age);
  const starterAvgAge = starterAges.length ? starterAges.reduce((a, b) => a + b, 0) / starterAges.length : null;

  return {
    starterValueTotal,
    starterAvgAge,
    holes,
    starterPlayers,
  };
}

// Rank all rosters in a league by starter value, return { rosterId: rank }
function computeStarterValueRanks(lg) {
  const entries = lg.allRosters.map(r => {
    const { starterValueTotal } = computeArchetypeForRoster(lg, r);
    return { rosterId: r.rosterId, starterValueTotal };
  });
  entries.sort((a, b) => b.starterValueTotal - a.starterValueTotal);
  const ranks = {};
  entries.forEach((e, idx) => { ranks[e.rosterId] = idx + 1; });
  return ranks;
}

// Team style (archetype). The rule lives in ONE place, shared/archetypes.mjs
// (leagueArchetypes): lineup strength blended with results, future capital
// (picks + players 24 or under) and starter age, each against the league.
// Reworked 2026-09-27 after Owen saw clear rebuilds mislabelled and
// non-rebuilds called rebuilds. This page passes its own position-aware
// strength check (computeArchetypeForRoster above), so the page and the trade
// engine share the rule while the page keeps its finer "startable" cut-offs.
//
// Memoised per league: callers ask one roster at a time, and each answer
// needs the whole league ranked. The key changes whenever values, records or
// points do, so a re-price or a refresh can never serve a stale label.
const archetypeMemo = new WeakMap();
function leagueArchetypeMap(lg) {
  const key = (lg.allRosters || []).map((r) =>
    r.rosterId + ':' + Math.round(r.totalValue || 0) + ':' + (r.wins || 0) + '-' + (r.losses || 0) + ':' + Math.round(r.pointsFor || 0)).join('|');
  // Projected strength only once it has been worked out (warmArchetypeStrengths
  // below) -- never computed inline here, where one call from a page render
  // would do all 30 leagues at once: a 0.75s freeze (lag report, 2026-09-28).
  // Until then the label is value-only and every page shows "Style…".
  const projections = STATE.seasonProjections && !STATE.seasonProjections.failed ? STATE.seasonProjections : null;
  const strength = projections ? cachedArchetypeStrength(lg, projections) : null;
  const sp = strength ? projections : null;
  const hit = archetypeMemo.get(lg);
  if (hit && hit.key === key && hit.sp === sp) return hit.map;
  const map = TacoCore.leagueArchetypes(lg, {
    starterEval: (r) => computeArchetypeForRoster(lg, r),
    strengthOf: strength ? (r) => strength[r.rosterId] : undefined,
  });
  archetypeMemo.set(lg, { key, sp, map });
  return map;
}

/** Each team's projected points per week, rest of the regular season, best
 * lineup -- the Projected Finish engine (84) -- or null when it cannot be had. */
function archetypeProjectedStrength(lg, sp) {
  if (typeof scoreWeeksForLeague !== 'function' || typeof seasonProjectionTeams !== 'function' || !TacoCore.projectTeamSeason) return null;
  const pbw = scoreWeeksForLeague(sp, lg);
  if (!pbw) return null;
  const pws = (lg.settings && lg.settings.playoff_week_start) || 15;
  const regular = Object.keys(pbw).map(Number).filter((w) => w < pws);
  let weeks = TacoCore.unplayedWeeks ? TacoCore.unplayedWeeks(regular, lg.allRosters, (lg.settings && lg.settings.start_week) || 1) : regular;
  if (!weeks.length) weeks = regular; // season over: judge on the whole regular season
  if (!weeks.length) return null;
  const out = {};
  for (const t of seasonProjectionTeams(lg)) {
    const p = TacoCore.projectTeamSeason(t, lg.roster_positions || [], pbw, weeks);
    if (!p.weeksProjected) return null;
    out[t.rosterId] = p.avgPoints;
  }
  return out;
}

/**
 * Team styles judge "can this team win now" on this season's projections,
 * which load after first paint (1.3MB). Before they land, a label is a
 * value-only guess that can flip a second later -- Ain't no mountain read
 * Dynasty Core, then a rebuild. So pages show a placeholder until the
 * answer is final (Owen, 2026-09-27). A failed load is final too: value alone
 * is then the answer.
 *
 * If nothing has asked for the projections yet (a page reached some other
 * way), this asks once and redraws when they arrive, so the placeholder can
 * never be permanent.
 */
let archetypeProjAsked = false;
let archetypeProjDone = false;
function archetypesSettled() {
  if (typeof loadSeasonProjections !== 'function') return true;
  const sp = STATE.seasonProjections;
  if (sp) {
    if (sp.failed) return true; // value alone is the final answer
    if (archetypeWarmedFor === sp) return true;
    warmArchetypeStrengths(sp);
    return false;
  }
  if (archetypeProjDone) return true;
  if (!archetypeProjAsked) {
    archetypeProjAsked = true;
    Promise.resolve(loadSeasonProjections()).catch(() => null).then(() => {
      archetypeProjDone = true;
      if (STATE.seasonProjections && !STATE.seasonProjections.failed) warmArchetypeStrengths(STATE.seasonProjections);
      else archetypeRedraw();
    });
  }
  return false;
}

function archetypeRedraw() {
  if (typeof rerenderActiveView === 'function') rerenderActiveView();
  const v = document.querySelector('.view.active');
  if (v && v.id === 'scoreboardView' && typeof renderScoreboardView === 'function') renderScoreboardView();
}

// Each league's projected strength, worked out one league per slice so the page
// stays responsive, then one redraw when all are in.
const archetypeStrengthCache = new WeakMap(); // season projections -> Map(league_id -> { rosters, strength })
let archetypeWarmedFor = null;
let archetypeWarming = null;
// Who is on which team, as a string -- the cache key. Roster ARRAYS are
// replaced on every refresh with the same contents, so identity would throw
// the work away (and quietly drop the label to value-only until re-warmed).
const rosterContentKeyMemo = new WeakMap();
function rosterContentKey(lg) {
  const rosters = lg.allRosters || [];
  let k = rosterContentKeyMemo.get(rosters);
  if (k === undefined) {
    k = rosters.map((r) => r.rosterId + ':' + (r.players || []).map((p) => p.playerId).join(',')).join('|');
    rosterContentKeyMemo.set(rosters, k);
  }
  return k;
}
function cachedArchetypeStrength(lg, sp) {
  const per = archetypeStrengthCache.get(sp);
  const hit = per && per.get(lg.league_id);
  if (hit && hit.key === rosterContentKey(lg)) return hit.strength;
  // A roster changed after warming (a trade, a waiver claim): redo that league.
  if (archetypeWarmedFor === sp) { archetypeWarmedFor = null; warmArchetypeStrengths(sp); }
  return null;
}
function warmArchetypeStrengths(sp) {
  if (archetypeWarming === sp || archetypeWarmedFor === sp) return;
  archetypeWarming = sp;
  let per = archetypeStrengthCache.get(sp);
  if (!per) { per = new Map(); archetypeStrengthCache.set(sp, per); }
  // Small units, run in ~8ms bursts. A whole league per slice was still
  // 150-300ms on a phone -- a tap landing in one waited for it. Units: score
  // one week of one league's rostered players (filling memoFantasyPoints), then
  // that league's projection, which by then is cache hits plus the lineups.
  const units = [];
  for (const lg of STATE.leagues || []) {
    const hit = per.get(lg.league_id);
    if (hit && hit.key === rosterContentKey(lg)) continue;
    const ids = [...leagueRosteredIds(lg)];
    const settings = lg.scoring_settings;
    if (settings && typeof memoFantasyPoints === 'function') {
      for (const w of Object.keys(sp.weeks || {})) {
        const byPlayer = sp.weeks[w];
        if (!byPlayer) continue;
        units.push(() => { for (const pid of ids) { const st = byPlayer[pid]; if (st) memoFantasyPoints(st, settings); } });
      }
    }
    units.push(() => {
      let strength = null;
      try { strength = archetypeProjectedStrength(lg, sp); } catch (e) { console.warn('[archetypes] strength failed', lg.league_id, e); }
      per.set(lg.league_id, { key: rosterContentKey(lg), strength });
    });
  }
  const burst = () => {
    if (STATE.seasonProjections !== sp) { archetypeWarming = null; return; } // superseded
    const deadline = performance.now() + 8;
    while (units.length && performance.now() < deadline) units.shift()();
    if (units.length) { setTimeout(burst, 0); return; }
    archetypeWarming = null;
    archetypeWarmedFor = sp;
    archetypeRedraw();
  };
  setTimeout(burst, 0);
}
window.warmArchetypeStrengths = warmArchetypeStrengths;

/** The pill shown in place of a team style while it is still being worked out. */
function archetypePendingPill(baseCls) {
  return '<span class="' + baseCls + ' arch-pending" data-tooltip="Team style is waiting on this season\'s projections">Style…</span>';
}
window.archetypesSettled = archetypesSettled;
window.archetypePendingPill = archetypePendingPill;

function archetypeForRoster(lg, roster) {
  const hit = leagueArchetypeMap(lg)[roster.rosterId];
  return (hit && hit.label) || 'Middle Tier';
}
window.leagueArchetypeMap = leagueArchetypeMap;


;
/*! ==== 60-trade-fit-analysis.js ==== */
// Trade-calculator fit analysis — before/after positional impact for two-sided deals.

function resolveAsset(key, lg) {
  const [type, ...rest] = key.split(':');
  const id = rest.join(':');
  if (type === 'P') {
    for (const r of lg.allRosters) {
      const p = r.players.find((pp) => pp.playerId === id);
      if (p) return { kind: 'player', ...p };
    }
    return null;
  }
  if (type === 'D') {
    const [season, round, origRosterId] = id.split('-').map(Number);
    for (const rid of [TRADE.sideARosterId, TRADE.sideBRosterId]) {
      const arr = lg.picksByRoster[rid] || [];
      const match = arr.find((p) => p.season === season && p.round === round && p.originalRosterId === origRosterId);
      if (match) return { kind: 'pick', ...match, position: 'PICK' };
    }
    return null;
  }
  return null;
}

function computeRosterProfile(players, startersNeeded) {
  const positions = ['QB', 'RB', 'WR', 'TE'];
  const profile = { posTotals: {}, posTopN: {}, posAge: {}, totalValue: 0, avgAge: null };
  const active = players.filter((p) => p.isActive !== false);
  profile.totalValue = active.reduce((s, p) => s + (p.value || 0), 0);

  const ages = active.filter((p) => p.age && p.age > 0).map((p) => p.age);
  profile.avgAge = ages.length ? ages.reduce((a, b) => a + b, 0) / ages.length : null;

  for (const pos of positions) {
    const pp = active.filter((p) => p.position === pos).sort((a, b) => (b.value || 0) - (a.value || 0));
    profile.posTotals[pos] = pp.reduce((s, p) => s + (p.value || 0), 0);
    const topN = pp.slice(0, startersNeeded[pos] || 1);
    profile.posTopN[pos] = topN.reduce((s, p) => s + (p.value || 0), 0);
    const posAges = topN.filter((p) => p.age && p.age > 0).map((p) => p.age);
    profile.posAge[pos] = posAges.length ? posAges.reduce((a, b) => a + b, 0) / posAges.length : null;
  }
  return profile;
}

function computePosRanks(lg, rosterPlayers, startersNeeded) {
  const positions = ['QB', 'RB', 'WR', 'TE'];
  const ranks = {};
  for (const pos of positions) {
    const n = startersNeeded[pos] || 1;
    const allTopN = lg.allRosters.map((r) => {
      const usePlayers = r.rosterId === rosterPlayers._rosterId ? rosterPlayers.players : r.players;
      const active = usePlayers.filter((p) => p.isActive !== false && p.position === pos);
      const sorted = active.sort((a, b) => (b.value || 0) - (a.value || 0)).slice(0, n);
      return { rosterId: r.rosterId, val: sorted.reduce((s, p) => s + (p.value || 0), 0) };
    });
    allTopN.sort((a, b) => b.val - a.val);
    const myIdx = allTopN.findIndex((x) => x.rosterId === rosterPlayers._rosterId);
    ranks[pos] = { rank: myIdx + 1, of: allTopN.length, value: allTopN[myIdx]?.val || 0 };
  }
  return ranks;
}

function computeFitAnalysis(lg, rosterId, givingAssets, receivingAssets) {
  const roster = lg.allRosters.find((r) => r.rosterId === rosterId);
  if (!roster) return null;
  const startersNeeded = computeStartersNeeded(lg);

  const beforePlayers = roster.players.map((p) => ({ ...p }));
  const givingKeys = new Set(givingAssets.filter((k) => k.startsWith('P:')).map((k) => k.slice(2)));
  const afterPlayers = beforePlayers.filter((p) => !givingKeys.has(p.playerId));
  receivingAssets.filter((k) => k.startsWith('P:')).forEach((k) => {
    const resolved = resolveAsset(k, lg);
    if (resolved && resolved.kind === 'player') {
      afterPlayers.push({ ...resolved, isActive: true, isStarter: false, isIR: false, isTaxi: false });
    }
  });

  const beforeProfile = computeRosterProfile(beforePlayers, startersNeeded);
  const afterProfile = computeRosterProfile(afterPlayers, startersNeeded);
  const beforeRanks = computePosRanks(lg, { _rosterId: rosterId, players: beforePlayers }, startersNeeded);
  const afterRanks = computePosRanks(lg, { _rosterId: rosterId, players: afterPlayers }, startersNeeded);

  const allValues = lg.allRosters.map((r) => {
    const pp = r.rosterId === rosterId ? afterPlayers : r.players;
    return { rosterId: r.rosterId, val: pp.reduce((s, p) => s + (p.value || 0), 0) };
  }).sort((a, b) => b.val - a.val);
  const valueRank = allValues.findIndex((x) => x.rosterId === rosterId) + 1;
  const totalTeams = lg.allRosters.length;

  const archetypeBefore = archetypeForRoster(lg, roster);
  const afterRosterClone = { ...roster, players: afterPlayers };
  const lgClone = { ...lg, allRosters: lg.allRosters.map((r) => (r.rosterId === rosterId ? afterRosterClone : r)) };
  const archetypeAfter = archetypeForRoster(lgClone, afterRosterClone);

  const starterImpact = [];
  for (const pos of ['QB', 'RB', 'WR', 'TE']) {
    const n = startersNeeded[pos];
    const beforeStarters = beforePlayers.filter((p) => p.isActive !== false && p.position === pos)
      .sort((a, b) => (b.value || 0) - (a.value || 0)).slice(0, n);
    const afterStarters = afterPlayers.filter((p) => p.isActive !== false && p.position === pos)
      .sort((a, b) => (b.value || 0) - (a.value || 0)).slice(0, n);
    const beforeIds = new Set(beforeStarters.map((p) => p.playerId));
    const afterIds = new Set(afterStarters.map((p) => p.playerId));
    afterStarters.forEach((p) => {
      if (!beforeIds.has(p.playerId)) starterImpact.push({ pos, kind: 'promoted', player: p });
    });
    beforeStarters.forEach((p) => {
      if (!afterIds.has(p.playerId)) starterImpact.push({ pos, kind: 'demoted', player: p });
    });
  }

  const posNotes = [];
  for (const pos of ['QB', 'RB', 'WR', 'TE']) {
    const b = beforeRanks[pos];
    const a = afterRanks[pos];
    if (!b || !a) continue;
    const rankDelta = b.rank - a.rank;
    const bottomThird = Math.ceil(totalTeams * 2 / 3);
    const topThird = Math.ceil(totalTeams / 3);
    if (rankDelta > 0 && b.rank > bottomThird) {
      posNotes.push({ pos, kind: 'good', text: `Filled a need - ${pos} rank ${b.rank}→${a.rank}` });
    } else if (rankDelta > 0) {
      posNotes.push({ pos, kind: 'neutral', text: `Improved ${pos} (${b.rank}→${a.rank}) from an already-average position` });
    } else if (rankDelta < 0 && a.rank > bottomThird && b.rank <= bottomThird) {
      posNotes.push({ pos, kind: 'bad', text: `${pos} dropped out of viable tier: ${b.rank}→${a.rank}` });
    } else if (rankDelta < 0 && b.rank <= topThird) {
      posNotes.push({ pos, kind: 'neutral', text: `${pos} trimmed from top group: ${b.rank}→${a.rank}${a.rank <= topThird ? ' (still strong)' : ''}` });
    } else if (rankDelta < 0) {
      posNotes.push({ pos, kind: 'bad', text: `${pos} weakened: ${b.rank}→${a.rank}` });
    }
  }

  const ageDelta = (afterProfile.avgAge || 0) - (beforeProfile.avgAge || 0);
  const valueDelta = afterProfile.totalValue - beforeProfile.totalValue;
  let verdictCls = 'ok';
  let verdictLbl = 'Mixed Fit';
  let verdictTxt;

  const goodNotes = posNotes.filter((n) => n.kind === 'good').length;
  const badNotes = posNotes.filter((n) => n.kind === 'bad').length;

  if (goodNotes > badNotes && valueDelta >= -100) {
    verdictCls = 'good';
    verdictLbl = 'Good Fit';
    const parts = [];
    if (goodNotes > 0) parts.push(`addresses ${posNotes.filter((n) => n.kind === 'good').map((n) => n.pos).join('/')} need`);
    if (archetypeAfter !== archetypeBefore) parts.push(`shifts archetype ${archetypeBefore} → ${archetypeAfter}`);
    if (ageDelta < -0.5) parts.push(`gets younger (${ageDelta.toFixed(1)} yrs)`);
    else if (ageDelta > 0.5) parts.push(`gets older (+${ageDelta.toFixed(1)} yrs)`);
    verdictTxt = parts.length ? `${parts.join('; ')}.` : 'Improves structure without significant cost.';
  } else if (badNotes > goodNotes || valueDelta < -500) {
    verdictCls = 'bad';
    verdictLbl = 'Poor Fit';
    const parts = [];
    if (badNotes > 0) parts.push(`weakens ${posNotes.filter((n) => n.kind === 'bad').map((n) => n.pos).join('/')}`);
    if (valueDelta < -500) parts.push(`loses ${Math.round(Math.abs(valueDelta)).toLocaleString()} in total value`);
    const contenderGettingOlder = archetypeAfter.includes('Rebuild') === false && ageDelta > 0.8;
    if (contenderGettingOlder) parts.push(`gets older (+${ageDelta.toFixed(1)} yrs)`);
    verdictTxt = parts.length ? `${parts.join('; ')}.` : 'Trade weakens roster structure.';
  } else {
    verdictCls = 'ok';
    verdictLbl = goodNotes === 0 && badNotes === 0 ? 'Neutral' : 'Mixed Fit';
    const parts = [];
    if (Math.abs(ageDelta) > 0.3) parts.push(`avg age ${ageDelta > 0 ? '+' : ''}${ageDelta.toFixed(1)} yrs`);
    if (Math.abs(valueDelta) > 100) parts.push(`value ${valueDelta > 0 ? '+' : ''}${Math.round(valueDelta).toLocaleString()}`);
    verdictTxt = (posNotes.length ? posNotes.map((n) => n.text).join('; ') : 'No meaningful structural shift.') + (parts.length ? ` (${parts.join(', ')})` : '');
  }

  return {
    rosterId,
    rosterName: roster.teamName,
    isMe: roster.isMe,
    beforeProfile,
    afterProfile,
    beforeRanks,
    afterRanks,
    startersNeeded,
    starterImpact,
    archetypeBefore,
    archetypeAfter,
    valueRank,
    totalTeams,
    verdictCls,
    verdictLbl,
    verdictTxt,
    posNotes,
    ageDelta,
    valueDelta,
  };
}
;
/*! ==== 35-cross-league-exposure.js ==== */
// For a given player name/id, find all OTHER leagues where I roster them.
// Returns { leagues: [{ leagueName, scoringTab, value, isStarter }], totalValue, leagueCount }
function computeExposure(playerId, playerName, excludeLeagueIdx) {
  const hits = [];
  STATE.leagues.forEach((lg, idx) => {
    if (idx === excludeLeagueIdx) return;
    // Match by playerId first (most accurate), then fall back to name
    const myRoster = lg.allRosters.find(r => r.isMe);
    if (!myRoster) return;
    const match = myRoster.players.find(p => p.playerId === playerId || normalizeName(p.name) === normalizeName(playerName));
    if (match) {
      hits.push({
        leagueName: lg.name,
        leagueIdx: idx,
        scoringTab: lg.scoringTab,
        value: match.value || 0,
        isStarter: match.isStarter,
        isIR: match.isIR,
        isTaxi: match.isTaxi,
      });
    }
  });
  const totalValue = hits.reduce((s, h) => s + h.value, 0);
  return { leagues: hits, totalValue, leagueCount: hits.length };
}

/** Portfolio-wide exposure summary for All Leagues hero + assets cross-links. */
function buildPortfolioExposureSummary(leagues) {
  if (!leagues || leagues.length < 2) return null;
  if (typeof buildMyAssetsData !== 'function') return null;

  const { players, picks } = buildMyAssetsData();
  const totalLeagues = leagues.length;
  const concThreshold = Math.ceil(totalLeagues * 0.5);

  const topOverlaps = [...players]
    .sort((a, b) => b.exposures.length - a.exposures.length)
    .slice(0, 6);

  const concentrated = players.filter((p) => p.exposures.length >= concThreshold);

  const posExposure = { QB: 0, RB: 0, WR: 0, TE: 0 };
  let totalExp = 0;
  for (const p of players) {
    if (posExposure[p.position] != null) {
      posExposure[p.position] += p.exposures.length;
      totalExp += p.exposures.length;
    }
  }
  const posPcts = ['QB', 'RB', 'WR', 'TE'].map((pos) => ({
    pos,
    count: posExposure[pos] || 0,
    pct: totalExp ? Math.round((posExposure[pos] / totalExp) * 100) : 0,
  })).sort((a, b) => b.pct - a.pct);

  const rookieStacks = [...players]
    .filter((p) => p.rookie && p.exposures.length >= 2)
    .sort((a, b) => b.exposures.length - a.exposures.length)
    .slice(0, 3);

  return {
    totalLeagues,
    uniquePlayers: players.length,
    totalExposures: totalExp,
    topOverlaps,
    concentratedCount: concentrated.length,
    posPcts,
    heaviestPos: posPcts[0] || null,
    lightestPos: posPcts[posPcts.length - 1] || null,
    rookieStacks,
    picksCount: picks.length,
  };
}

function openPortfolioExposureView() {
  if (typeof showView === 'function') showView('myAssets');
  if (typeof applyRouteFromPath === 'function') {
    try { history.pushState(null, '', '/tools/assets'); } catch (_e) { /* ignore */ }
    applyRouteFromPath();
  }
}
window.openPortfolioExposureView = openPortfolioExposureView;
;
/*! ==== 79-trade-fit-panel.js ==== */
// Trade fit analysis panel — extracted from 36.

function renderFitPanel() {
  const lg = STATE.leagues[TRADE.leagueIdx];
  const el = document.getElementById('tradeFitPanel');
  const aAssets = [...TRADE.sideAAssets];
  const bAssets = [...TRADE.sideBAssets];

  // Gate: both sides must have at least one asset selected.
  if (aAssets.length === 0 || bAssets.length === 0) {
    el.style.display = 'none';
    return;
  }
  el.style.display = 'block';

  // Side A gives away aAssets, receives bAssets. Side B is the inverse.
  const fitA = computeFitAnalysis(lg, TRADE.sideARosterId, aAssets, bAssets);
  const fitB = computeFitAnalysis(lg, TRADE.sideBRosterId, bAssets, aAssets);

  // Exposure analysis — only relevant for the side that is "me"
  // (since we only know cross-league rosters for the user, not other owners).
  const aRoster = lg.allRosters.find(r => r.rosterId === TRADE.sideARosterId);
  const bRoster = lg.allRosters.find(r => r.rosterId === TRADE.sideBRosterId);

  // Roster size and depth after the trade (roadmap #3, shared/roster-impact.mjs):
  // does the roster still fit, and does a position get thin?
  const rosterLimit = (lg.roster_positions || []).length;
  const leagueAvg = TacoCore.leagueDepthAverages ? TacoCore.leagueDepthAverages(lg.allRosters) : {};
  const playersFor = (keys, fromRoster) => keys.filter((k) => k.startsWith('P:'))
    .map((k) => (fromRoster && fromRoster.players || []).find((pl) => 'P:' + pl.playerId === k))
    .filter(Boolean);
  const rosterCheckHtml = (roster, givingAssets, receivingAssets, otherRoster) => {
    if (!roster || !TacoCore.rosterImpact) return '';
    const impact = TacoCore.rosterImpact({
      roster,
      outIds: givingAssets.filter((k) => k.startsWith('P:')).map((k) => k.slice(2)),
      inPlayers: playersFor(receivingAssets, otherRoster),
      limit: rosterLimit,
      leagueAvg,
    });
    const items = [];
    if (impact.overBy) {
      items.push('<div class="fit-starter-item demoted">Over the roster limit: ' + impact.after + ' of ' + impact.limit +
        ' active spots. Must cut ' + impact.overBy + ' (or move ' + (impact.overBy === 1 ? 'one' : 'some') + ' to IR or taxi).</div>');
    }
    for (const d of impact.depth) {
      items.push('<div class="fit-starter-item demoted">' + d.pos + ' depth drops ' + d.before + ' → ' + d.after +
        ' (league average ' + d.leagueAvg + ').</div>');
    }
    if (!items.length) {
      items.push('<div class="fit-starter-item">Roster fits: ' + impact.after + ' of ' + impact.limit + ' active spots, depth holds.</div>');
    }
    return '<div class="fit-starter-impact"><div class="fit-metric-label">ROSTER CHECK</div>' + items.join('') + '</div>';
  };

  // Lineup points per week before and after (roadmap #9, shared/lineup-impact.mjs):
  // the best lineup each remaining week, scored by this league's own rules.
  const pointsByWeek = fitPointsByWeek(lg);
  const nowWeek = (STATE.nflState && STATE.nflState.week) || TacoCore.resolveNflWeekContext().week;
  const span = pointsByWeek && TacoCore.remainingWeeks
    ? TacoCore.remainingWeeks(Object.keys(pointsByWeek), nowWeek, lg.settings && lg.settings.playoff_week_start)
    : null;
  // Sides whose lineup was scored in points; for them the value-based
  // "STARTING LINEUP IMPACT" is dropped. It ignores injuries, so beside the
  // points block it contradicted it (an IR quarterback "entering" a lineup).
  const pointsShown = {};
  const lineupPointsHtml = (roster, givingAssets, receivingAssets, otherRoster) => {
    const head = '<div class="fit-starter-impact fit-lineup-pts"><div class="fit-metric-label">LINEUP POINTS PER WEEK</div>';
    if (!roster || !TacoCore.lineupImpact) return '';
    if (!pointsByWeek) return head + '<div class="fit-starter-item">Loading projections…</div></div>';
    const impact = TacoCore.lineupImpact({
      players: fitProjectable(roster.players),
      outIds: givingAssets.filter((k) => k.startsWith('P:')).map((k) => k.slice(2)),
      inPlayers: fitProjectable(playersFor(receivingAssets, otherRoster)),
      rosterPositions: lg.roster_positions || [],
      pointsByWeek,
      weeks: span ? span.weeks : [],
    });
    if (!impact) {
      const why = STATE.seasonProjections && STATE.seasonProjections.failed
        ? 'Could not reach the projections service.'
        : 'No projections published for the weeks left.';
      return head + '<div class="fit-starter-item">' + why + '</div></div>';
    }
    const nameOf = (id) => {
      const p = [...(roster.players || []), ...((otherRoster && otherRoster.players) || [])].find((x) => String(x.playerId) === id);
      return p ? p.name : id;
    };
    pointsShown[roster.rosterId] = true;
    const cls = impact.delta > 0.4 ? 'up' : impact.delta < -0.4 ? 'down' : 'flat';
    const basis = span.basis === 'rest'
      ? 'best lineup, avg of the ' + impact.weeks + ' regular-season week' + (impact.weeks === 1 ? '' : 's') + ' left'
      : 'best lineup, avg of ' + impact.weeks + ' projected week' + (impact.weeks === 1 ? '' : 's');
    const moves = impact.newStarters.map((s) =>
      '<div class="fit-starter-item promoted">↑ <b>' + escapeHtml(nameOf(s.playerId)) + '</b> ' +
      (s.incoming ? 'arrives as a regular starter' : 'moves into the lineup') + '</div>').concat(
      impact.lostStarters.map((s) =>
        '<div class="fit-starter-item demoted">↓ <b>' + escapeHtml(nameOf(s.playerId)) + '</b> ' +
        (s.outgoing ? 'leaves the lineup' : 'drops to the bench') + '</div>')).concat(
      (impact.sidelined || []).map((id) =>
        '<div class="fit-starter-item">✚ <b>' + escapeHtml(nameOf(id)) + '</b> arrives injured: no lineup points counted</div>'));
    return head +
      '<div class="fit-lineup-pts-row"><span>' + impact.before.toFixed(1) + ' <span class="fit-pos-arrow">→</span> <b>' + impact.after.toFixed(1) + '</b></span>' +
      '<span class="fit-pos-delta ' + cls + '">' + (impact.delta > 0 ? '+' : '') + impact.delta.toFixed(1) + '</span></div>' +
      '<div class="fit-lineup-pts-basis">' + basis + '</div>' +
      moves.join('') + '</div>';
  };

  // Playoff and title odds before and after (roadmap #10, Pro): the whole
  // season simulated twice with the same seed, once with the trade made.
  const odds = fitOddsDelta(lg, aRoster, bRoster, aAssets, bAssets, playersFor);
  const oddsHtml = (roster) => {
    if (!odds || !roster) return '';
    const head = '<div class="fit-starter-impact fit-odds"><div class="fit-metric-label">PLAYOFF ODDS</div>';
    if (odds.pending) return head + '<div class="fit-starter-item">' + odds.pending + '</div></div>';
    const o = odds.byRoster[roster.rosterId];
    if (!o) return '';
    const line = (label, pair) => {
      const d = Math.round((pair[1] - pair[0]) * 10) / 10;
      const cls = d > 0.9 ? 'up' : d < -0.9 ? 'down' : 'flat';
      return '<div class="fit-odds-row"><span class="fit-odds-label">' + label + '</span><span>' +
        pair[0].toFixed(1) + '% <span class="fit-pos-arrow">→</span> <b>' + pair[1].toFixed(1) + '%</b></span>' +
        '<span class="fit-pos-delta ' + cls + '">' + (d > 0 ? '+' : '') + d.toFixed(1) + '</span></div>';
    };
    return head + line('Make playoffs', o.playoff) + (o.title ? line('Win title', o.title) : '') +
      '<div class="fit-lineup-pts-basis">' + odds.iterations.toLocaleString() + ' simulated seasons from the current standings; picks not counted</div></div>';
  };

  // Spare parts (roadmap #11, Pro): what else of yours could go in, priced as
  // what it costs your lineup vs what it adds to theirs. Shown on your side
  // (side A when you are on neither), measured from the rosters as the trade
  // stands now.
  const spareSide = bRoster && bRoster.isMe && !(aRoster && aRoster.isMe) ? 'B' : 'A';
  const sparePartsHtml = (roster, givingAssets, receivingAssets, otherRoster, side) => {
    if (side !== spareSide || !roster || !otherRoster || !pointsByWeek || !span || !TacoCore.spareParts) return '';
    if (!(typeof window.accountCanUse === 'function' && window.accountCanUse('tradeInsights'))) return '';
    const outIds = new Set(givingAssets.filter((k) => k.startsWith('P:')).map((k) => k.slice(2)));
    const inIds = new Set(receivingAssets.filter((k) => k.startsWith('P:')).map((k) => k.slice(2)));
    const minePlayers = fitProjectable(roster.players);
    const theirPlayers = fitProjectable(otherRoster.players);
    const mine = minePlayers.filter((p) => !outIds.has(p.playerId)).concat(theirPlayers.filter((p) => inIds.has(p.playerId)));
    const theirs = theirPlayers.filter((p) => !inIds.has(p.playerId)).concat(minePlayers.filter((p) => outIds.has(p.playerId)));
    const candidateIds = minePlayers.filter((p) => !outIds.has(p.playerId)).map((p) => p.playerId);
    const rows = TacoCore.spareParts({ mine, theirs, candidateIds, rosterPositions: lg.roster_positions || [], pointsByWeek, weeks: span.weeks });
    if (!rows.length) return '';
    const who = escapeHtml(otherRoster.teamName || otherRoster.ownerName || 'them');
    const nameOf = (id) => { const p = (roster.players || []).find((x) => String(x.playerId) === id); return p ? p : { name: id, position: '' }; };
    return '<div class="fit-starter-impact fit-spare"><div class="fit-metric-label">SPARE PARTS</div>' +
      '<div class="fit-lineup-pts-basis">Players you could add: what losing each costs your lineup per week, and what he adds to ' + who + '\'s. Tap to add.</div>' +
      rows.map((r) => {
        const p = nameOf(r.playerId);
        return '<button type="button" class="fit-spare-row" data-tc-asset="' + side + '|P:' + escapeHtml(r.playerId) + '">' +
          '<span class="fit-spare-name"><b>' + escapeHtml(p.name) + '</b> <span class="fit-spare-pos">' + escapeHtml(p.position || '') + '</span></span>' +
          '<span class="fit-spare-cost">' + (r.covered ? 'costs you nothing' : 'costs you ' + r.cost.toFixed(1)) + '</span>' +
          '<span class="fit-spare-gain">adds +' + r.gain.toFixed(1) + ' for them</span>' +
          '</button>';
      }).join('') + '</div>';
  };

  // How they deal (roadmap #12, Pro): the Manager Dossier's own rules
  // (buildDossier), fed from what is already in memory -- their teams in the
  // leagues you share and your leagues' trade history -- so the calculator
  // never fetches their whole book. The full dossier is one tap away.
  const dealHtml = (roster, fit) => {
    if (!roster || roster.isMe || !roster.ownerId || !TacoCore.buildDossier) return '';
    if (!(typeof window.accountCanUse === 'function' && window.accountCanUse('tradeInsights'))) return '';
    const d = fitDealDossier(roster.ownerId);
    if (!d) return '';
    const shared = d.leagues;
    const weakHere = ['QB', 'RB', 'WR', 'TE']
      .map((pos) => ({ pos, r: fit && fit.beforeRanks && fit.beforeRanks[pos] }))
      .filter((x) => x.r && x.r.rank && x.r.of)
      .sort((a, b) => b.r.rank / b.r.of - a.r.rank / a.r.of)[0];
    const lines = [];
    if (weakHere && weakHere.r.rank > weakHere.r.of / 2) {
      lines.push('In this league their thinnest spot is ' + weakHere.pos + ' (' + ordinal(weakHere.r.rank) + ' of ' + weakHere.r.of + '). Lead with one.');
    }
    lines.push(...d.tips);
    if (!STATE.tradeHistory) lines.push(STATE.tradeHistoryLoading ? 'Reading their trade history…' : 'Their trade record appears once trade history loads.');
    return '<div class="fit-starter-impact fit-deal"><div class="fit-metric-label">HOW THEY DEAL</div>' +
      '<div class="fit-lineup-pts-basis">From the ' + shared + ' league' + (shared === 1 ? '' : 's') + ' you share with them.</div>' +
      '<ul class="fit-deal-tips">' + lines.slice(0, 5).map((t) => '<li>' + escapeHtml(t) + '</li>').join('') + '</ul>' +
      '<button type="button" class="fit-deal-more" data-taco-pill="runInvestigatorLookup|' + escapeHtml(String(roster.ownerId)) + '">Full dossier across all their leagues ›</button>' +
      '</div>';
  };

  const renderSide = (fit, givingAssets, receivingAssets, isMe, roster, otherRoster) => {
    if (!fit) return '';

    // Per-position before/after rows.
    // Show BOTH totals: full positional value (all players at that pos) and starter-only value (top-N).
    // This matters because trading a bench piece doesn't affect starters but still shifts total exposure.
    const posRows = ['QB', 'RB', 'WR', 'TE'].map(pos => {
      const n = fit.startersNeeded[pos] || 1;
      const beforeTotal = fit.beforeProfile.posTotals[pos] || 0;
      const afterTotal = fit.afterProfile.posTotals[pos] || 0;
      const beforeStarter = fit.beforeProfile.posTopN[pos] || 0;
      const afterStarter = fit.afterProfile.posTopN[pos] || 0;
      const totalDelta = afterTotal - beforeTotal;
      const starterDelta = afterStarter - beforeStarter;

      const deltaCls = (d) => d > 100 ? 'up' : d < -100 ? 'down' : 'flat';
      const deltaTxt = (d) => d === 0 ? '-' : (d > 0 ? '+' : '') + Math.round(d).toLocaleString();

      // Rank info from beforeRanks/afterRanks (which is starter-quality rank)
      const b = fit.beforeRanks[pos], a = fit.afterRanks[pos];
      const rankDelta = b.rank - a.rank;
      let rankCell;
      if (b.rank === a.rank) {
        rankCell = `<b>${a.rank}</b>/${a.of}`;
      } else {
        const arrow = rankDelta > 0 ? '↑' : '↓';
        const cls = rankDelta > 0 ? 'up' : 'down';
        rankCell = `${b.rank}→<b>${a.rank}</b>/${a.of} <span class="fit-pos-delta ${cls}" style="margin-left: 4px;">${arrow}${Math.abs(rankDelta)}</span>`;
      }

      return `
        <div class="fit-pos-row">
          <span class="fit-pos-label ${pos.toLowerCase()}">${pos.charAt(0)}</span>
          <div class="fit-pos-lines">
            <div class="fit-pos-line">
              <span class="fit-pos-line-label">Total</span>
              <span class="fit-pos-line-vals">${Math.round(beforeTotal).toLocaleString()} <span class="fit-pos-arrow">→</span> ${Math.round(afterTotal).toLocaleString()}</span>
              <span class="fit-pos-delta ${deltaCls(totalDelta)}">${deltaTxt(totalDelta)}</span>
            </div>
            <div class="fit-pos-line">
              <span class="fit-pos-line-label">Starters (top ${n})</span>
              <span class="fit-pos-line-vals">${Math.round(beforeStarter).toLocaleString()} <span class="fit-pos-arrow">→</span> ${Math.round(afterStarter).toLocaleString()}</span>
              <span class="fit-pos-delta ${deltaCls(starterDelta)}">${deltaTxt(starterDelta)}</span>
            </div>
            <div class="fit-pos-line">
              <span class="fit-pos-line-label">League rank</span>
              <span class="fit-pos-line-vals fit-pos-rank">${rankCell}</span>
              <span></span>
            </div>
          </div>
        </div>
      `;
    }).join('');

    // Starter impact
    const starterHtml = fit.starterImpact.length > 0 ? `
      <div class="fit-starter-impact">
        <div class="fit-metric-label">STARTING LINEUP IMPACT</div>
        ${fit.starterImpact.map(s => `
          <div class="fit-starter-item ${s.kind}">
            ${s.kind === 'promoted' ? '↑' : '↓'} ${s.pos}: <b>${escapeHtml(s.player.name)}</b> ${s.kind === 'promoted' ? 'enters starting lineup' : 'drops from starting lineup'}
          </div>
        `).join('')}
      </div>
    ` : `
      <div class="fit-starter-impact">
        <div class="fit-metric-label">STARTING LINEUP IMPACT</div>
        <div class="fit-starter-item">No change to starters.</div>
      </div>
    `;

    // Position notes
    const notesHtml = fit.posNotes.length > 0 ? `
      <div class="fit-starter-impact">
        <div class="fit-metric-label">POSITIONAL NOTES</div>
        ${fit.posNotes.map(n => `<div class="fit-starter-item ${n.kind === 'good' ? 'promoted' : n.kind === 'bad' ? 'demoted' : ''}">${escapeHtml(n.text)}</div>`).join('')}
      </div>
    ` : '';

    // Exposure (only meaningful for "me")
    let exposureHtml = '';
    if (isMe) {
      const givingPlayers = givingAssets
        .filter(k => k.startsWith('P:'))
        .map(k => resolveAsset(k, lg))
        .filter(a => a && a.kind === 'player');
      const receivingPlayers = receivingAssets
        .filter(k => k.startsWith('P:'))
        .map(k => resolveAsset(k, lg))
        .filter(a => a && a.kind === 'player');

      const giveBlocks = givingPlayers.map(p => {
        const exp = computeExposure(p.playerId, p.name, TRADE.leagueIdx);
        const chips = exp.leagues.length > 0
          ? exp.leagues.map(e => `<span class="exposure-chip" title="${escapeHtml(e.leagueName)}">${escapeHtml(e.leagueName.slice(0, 22))}${e.leagueName.length > 22 ? '…' : ''} · ${Math.round(e.value).toLocaleString()}</span>`).join('')
          : '<span class="exposure-chip none">No other leagues</span>';
        return `
          <div class="fit-exposure-player">
            <div class="fit-exposure-name">Giving up ${escapeHtml(p.name)} <span class="exposure-total">still on ${exp.leagueCount} other league${exp.leagueCount === 1 ? '' : 's'} · ${Math.round(exp.totalValue).toLocaleString()}</span></div>
            <div class="fit-exposure-leagues">${chips}</div>
          </div>
        `;
      }).join('');
      const getBlocks = receivingPlayers.map(p => {
        const exp = computeExposure(p.playerId, p.name, TRADE.leagueIdx);
        const chips = exp.leagues.length > 0
          ? exp.leagues.map(e => `<span class="exposure-chip" title="${escapeHtml(e.leagueName)}">${escapeHtml(e.leagueName.slice(0, 22))}${e.leagueName.length > 22 ? '…' : ''} · ${Math.round(e.value).toLocaleString()}</span>`).join('')
          : '<span class="exposure-chip none">Not on any other league</span>';
        return `
          <div class="fit-exposure-player">
            <div class="fit-exposure-name">Acquiring ${escapeHtml(p.name)} <span class="exposure-total">already on ${exp.leagueCount} other league${exp.leagueCount === 1 ? '' : 's'} · ${Math.round(exp.totalValue).toLocaleString()}</span></div>
            <div class="fit-exposure-leagues">${chips}</div>
          </div>
        `;
      }).join('');

      exposureHtml = (giveBlocks || getBlocks) ? `
        <div class="fit-exposure">
          <div class="fit-exposure-head">Cross-League Exposure</div>
          ${giveBlocks}
          ${getBlocks}
        </div>
      ` : '';
    }

    return `
      <div class="fit-side">
        <div class="fit-side-header">
          <div>
            <div class="fit-side-name">${escapeHtml(fit.rosterName)}${fit.isMe ? ' (you)' : ''}</div>
            <div class="fit-pos-rank" style="margin-top: 2px;">Team Value: ${fit.valueRank}/${fit.totalTeams}${fit.ageDelta !== 0 ? ' · Age ' + (fit.ageDelta > 0 ? '+' : '') + fit.ageDelta.toFixed(1) : ''}</div>
          </div>
          <div class="fit-side-archetype">${fit.archetypeBefore === fit.archetypeAfter ? fit.archetypeAfter : fit.archetypeBefore + ' → ' + fit.archetypeAfter}</div>
        </div>

        <div class="fit-verdict ${fit.verdictCls}">
          <strong>${fit.verdictLbl}</strong>
          ${escapeHtml(fit.verdictTxt)}
        </div>

        ${lineupPointsHtml(roster, givingAssets, receivingAssets, otherRoster)}
        ${oddsHtml(roster)}
        ${sparePartsHtml(roster, givingAssets, receivingAssets, otherRoster, roster === aRoster ? 'A' : 'B')}
        ${dealHtml(roster, fit)}

        <div class="fit-metric-label" style="margin-bottom: 8px;">POSITIONAL IMPACT · BEFORE → AFTER</div>
        <div class="fit-pos-list">${posRows}</div>

        ${rosterCheckHtml(roster, givingAssets, receivingAssets, otherRoster)}
        ${notesHtml}
        ${pointsShown[roster && roster.rosterId] ? '' : starterHtml}
        ${exposureHtml}
      </div>
    `;
  };

  el.innerHTML = `
    <div class="fit-panel-head">
      <div>
        <div class="fit-panel-title">Fit Analysis</div>
      </div>
      <div class="fit-panel-hint">Before & after · Per-side impact · Cross-league exposure</div>
    </div>
    <div class="fit-sides">
      ${renderSide(fitA, aAssets, bAssets, aRoster?.isMe, aRoster, bRoster)}
      ${renderSide(fitB, bAssets, aAssets, bRoster?.isMe, bRoster, aRoster)}
    </div>
    ${fitRealTradesHtml(lg, aAssets, bAssets)}
  `;
}
window.renderFitPanel = renderFitPanel;

// Two full-season simulations per distinct trade; cache the last answer so a
// repaint that changes nothing (a filter, a collapse) does not rerun them.
const FIT_ODDS_ITERATIONS = 1000;
let fitOddsCache = null;
let fitOddsBusyKey = null;
let fitOddsTimer = null;

/**
 * Playoff and title odds for both sides, before and after the trade.
 * null when this account has no access (the War Room gate) or the league
 * cannot be simulated; { pending } while projections or the schedule load.
 */
function fitOddsDelta(lg, aRoster, bRoster, aAssets, bAssets, playersFor) {
  if (!(typeof window.accountCanUse === 'function' && window.accountCanUse('tradeInsights'))) return null;
  if (!aRoster || !bRoster || typeof seasonSimArgs !== 'function' || !TacoCore.monteCarloStandings) return null;
  if (!STATE.seasonProjections) return { pending: 'Loading projections…' };
  const repaint = () => {
    const el = document.getElementById('tradeFitPanel');
    if (el && el.style.display !== 'none') renderFitPanel();
  };
  const sim = seasonSimArgs(lg, repaint);
  if (!sim.args.weeks.length) return null;
  if (!sim.args.matchupsByWeek) return { pending: 'Loading the schedule…' };

  const key = [lg.league_id, aRoster.rosterId, bRoster.rosterId, aAssets.join(','), bAssets.join(','),
    Object.keys(sim.args.matchupsByWeek).length, sim.args.weeks.join(',')].join('|');
  if (fitOddsCache && fitOddsCache.key === key) return fitOddsCache.value;
  // ~250ms on a laptop, more on a phone: paint the rest of the panel first
  // and fill the odds in straight after, rather than freezing the tap.
  if (fitOddsBusyKey !== key) {
    fitOddsBusyKey = key;
    // Wait for a pause in tapping: every tap used to start its own ~0.7s pair
    // of simulations, so a quick three-piece trade froze the calculator for
    // two seconds (lag report, 2026-09-28).
    clearTimeout(fitOddsTimer);
    fitOddsTimer = setTimeout(() => {
      const value = fitOddsCompute(lg, sim, aRoster, bRoster, aAssets, bAssets, playersFor);
      if (fitOddsBusyKey !== key) return; // a newer trade superseded this one
      fitOddsBusyKey = null;
      fitOddsCache = { key, value };
      repaint();
    }, 350);
  }
  return { pending: 'Simulating ' + FIT_ODDS_ITERATIONS.toLocaleString() + ' seasons…' };
}

function fitOddsCompute(lg, sim, aRoster, bRoster, aAssets, bAssets, playersFor) {
  const moveIds = (keys) => new Set(keys.filter((k) => k.startsWith('P:')).map((k) => k.slice(2)));
  const outA = moveIds(aAssets);
  const outB = moveIds(bAssets);
  const inA = fitProjectable(playersFor(bAssets, bRoster));
  const inB = fitProjectable(playersFor(aAssets, aRoster));
  const traded = sim.args.teams.map((t) => {
    if (t.rosterId === aRoster.rosterId) return { ...t, players: t.players.filter((p) => !outA.has(p.playerId)).concat(inA) };
    if (t.rosterId === bRoster.rosterId) return { ...t, players: t.players.filter((p) => !outB.has(p.playerId)).concat(inB) };
    return t;
  });
  // Same seed both times, and monteCarloStandings draws each team-week from its
  // own stream: every team draws the same luck in both runs, so the difference
  // is the trade, not simulation noise.
  const run = (teams) => TacoCore.monteCarloStandings({ ...sim.args, teams, iterations: FIT_ODDS_ITERATIONS, seed: 1 });
  let before, after;
  try {
    // "Before" is the league's own projection -- Projected Finish has usually
    // run it already (84); only "after" is new work per trade.
    before = (typeof cachedSeasonSim === 'function' && cachedSeasonSim(lg, sim.args)) || run(sim.args.teams);
    if (typeof rememberSeasonSim === 'function') rememberSeasonSim(lg, sim.args, before);
    after = run(traded);
  } catch (e) {
    console.warn('[fit-odds] simulation failed', e);
    return null;
  }
  const byRoster = {};
  for (const id of [aRoster.rosterId, bRoster.rosterId]) {
    const b = before.teams.find((t) => t.rosterId === id);
    const a = after.teams.find((t) => t.rosterId === id);
    if (!b || !a) continue;
    byRoster[id] = {
      playoff: [b.playoffOdds, a.playoffOdds],
      title: before.hasBracket ? [b.titleOdds, a.titleOdds] : null,
    };
  }
  const value = { byRoster, iterations: FIT_ODDS_ITERATIONS };
  return value;
}

/**
 * A dossier for one manager built only from leagues you share with them:
 * per-league snapshots from computeFitAnalysis (style, positional ranks) and
 * your leagues' priced trade history. Starts the trade-history load if it has
 * not run; repaints the panel when it lands.
 */
function fitDealDossier(ownerId) {
  const id = String(ownerId);
  const snapshots = [];
  for (const lg of STATE.leagues || []) {
    const r = (lg.allRosters || []).find((x) => String(x.ownerId) === id);
    if (!r) continue;
    const fit = computeFitAnalysis(lg, r.rosterId, [], []);
    if (!fit) continue;
    const positions = ['QB', 'RB', 'WR', 'TE'].map((pos) => {
      const b = fit.beforeRanks && fit.beforeRanks[pos];
      if (!b || !b.rank || !b.of) return null;
      const tier = b.rank <= b.of / 3 ? 'top' : b.rank > (2 * b.of) / 3 ? 'bottom' : 'middle';
      return { pos, myRank: b.rank, totalTeams: b.of, tier };
    }).filter(Boolean);
    snapshots.push({
      leagueId: lg.league_id, name: lg.name, teams: fit.totalTeams, valueRank: fit.valueRank,
      archetype: fit.archetypeBefore, positions,
      players: (r.players || []).map((p) => ({ playerId: p.playerId, name: p.name, position: p.position, value: p.value || 0 })),
    });
  }
  if (!snapshots.length) return null;
  if (!STATE.tradeHistory && !STATE.tradeHistoryLoading && typeof loadTradeHistory === 'function') {
    loadTradeHistory().then(() => {
      const el = document.getElementById('tradeFitPanel');
      if (el && el.style.display !== 'none') renderFitPanel();
    }).catch(() => {});
  }
  return TacoCore.buildDossier({
    subjectId: id,
    snapshots,
    trades: STATE.tradeHistory || [],
    ageOf: (pid) => (STATE.playersDB && STATE.playersDB[pid] ? STATE.playersDB[pid].age : null),
  });
}

// --- Real trades (roadmap #13, tier 2) ---------------------------------------
// Real trades from the crawl, in this league's format, that moved the same
// players. One request per distinct set of players; answers are kept for the
// session. The Worker enforces the tier too (it reads D1 on every call).

const fitRealTrades = {}; // key -> { status: 'loading'|'done'|'error', trades }
const FIT_REAL_SHOWN = 6;

function fitRealTradesHtml(lg, aAssets, bAssets) {
  if (!(typeof window.accountCanUse === 'function' && window.accountCanUse('tradeDatabase'))) return '';
  if (typeof BACKEND_URL === 'undefined' || !BACKEND_URL || !lg.scoringTab) return '';
  const ids = [...aAssets, ...bAssets].filter((k) => k.startsWith('P:'))
    .map((k) => ({ id: k.slice(2), v: typeof assetValue === 'function' ? assetValue(k, lg) : 0 }))
    .sort((x, y) => y.v - x.v).slice(0, 4).map((x) => x.id);
  if (!ids.length) return '';
  const key = lg.scoringTab + '|' + [...ids].sort().join(',');
  const entry = fitRealTrades[key];
  const head = '<div class="fit-real"><div class="fit-metric-label">REAL TRADES WITH THESE PLAYERS</div>';
  if (!entry) { fitRealTradesLoad(key, ids, lg.scoringTab); return head + '<div class="fit-starter-item">Searching the trade database…</div></div>'; }
  if (entry.status === 'loading') return head + '<div class="fit-starter-item">Searching the trade database…</div></div>';
  if (entry.status === 'error') return '';
  if (!entry.trades.length) {
    return head + '<div class="fit-starter-item">No ' + escapeHtml(lg.scoringTab) + ' trades with these players in the database yet.</div></div>';
  }
  const name = (pid) => {
    const p = STATE.playersDB && STATE.playersDB[pid];
    return p ? (p.full_name || ((p.first_name || '') + ' ' + (p.last_name || '')).trim()) : 'Player ' + pid;
  };
  const pick = (p) => p.season + ' ' + ordinal(p.round);
  const sideHtml = (s, matched) => {
    const items = s.players.map((pid) => (matched.includes(pid) ? '<b>' + escapeHtml(name(pid)) + '</b>' : escapeHtml(name(pid))))
      .concat(s.picks.map((p) => escapeHtml(pick(p))));
    return items.length ? items.join(', ') : 'nothing';
  };
  const when = (ms) => (ms ? new Date(ms).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }) : '');
  const row = (t) => '<div class="fit-real-trade">' +
    '<div class="fit-real-meta">' + escapeHtml(when(t.statusUpdated)) + (t.numTeams ? ' · ' + t.numTeams + '-team' : '') + '</div>' +
    t.sides.map((s, i) => '<div class="fit-real-side">' + (t.sides.length === 2 ? (i === 0 ? 'One side got ' : 'The other got ') : 'A team got ') + sideHtml(s, t.matched) + '</div>').join('') +
    '</div>';
  const shown = entry.trades.slice(0, FIT_REAL_SHOWN).map(row).join('');
  const more = entry.trades.length > FIT_REAL_SHOWN
    ? '<details class="fit-real-more"><summary>' + (entry.trades.length - FIT_REAL_SHOWN) + ' more</summary>' +
      entry.trades.slice(FIT_REAL_SHOWN).map(row).join('') + '</details>'
    : '';
  return head +
    '<div class="fit-lineup-pts-basis">Real ' + escapeHtml(lg.scoringTab) + ' trades from other Sleeper leagues, newest first; trades with more of these players come first. Bold is the player you are trading.</div>' +
    shown + more + '</div>';
}

function fitRealTradesLoad(key, ids, format) {
  fitRealTrades[key] = { status: 'loading', trades: [] };
  const token = typeof window.tacoSessionToken === 'function' ? window.tacoSessionToken() : null;
  const url = BACKEND_URL + '/api/trades/comparable?players=' + encodeURIComponent(ids.join(',')) + '&format=' + encodeURIComponent(format);
  fetch(url, { headers: token ? { authorization: 'Bearer ' + token } : {} })
    .then((r) => (r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status))))
    .then((data) => { fitRealTrades[key] = { status: 'done', trades: (data && data.trades) || [] }; })
    .catch((e) => { console.warn('[real-trades]', e.message); fitRealTrades[key] = { status: 'error', trades: [] }; })
    .finally(() => {
      const el = document.getElementById('tradeFitPanel');
      if (el && el.style.display !== 'none') renderFitPanel();
    });
}

/** Roster rows in the shape season-projection wants. */
function fitProjectable(players) {
  return (players || []).map((p) => ({
    playerId: String(p.sleeperId ?? p.playerId ?? ''),
    position: p.position,
    isActive: p.isActive,
  })).filter((p) => p.playerId);
}

// One projections fetch however many taps land while it is in flight.
let fitProjLoading = false;

/** League-scored points by week (memoised in 84), or null while the projections load. */
function fitPointsByWeek(lg) {
  const sp = STATE.seasonProjections;
  if (!sp) {
    if (typeof loadSeasonProjections === 'function' && !fitProjLoading) {
      fitProjLoading = true;
      loadSeasonProjections().finally(() => {
        fitProjLoading = false;
        const el = document.getElementById('tradeFitPanel');
        if (el && el.style.display !== 'none') renderFitPanel();
      });
    }
    return null;
  }
  return (typeof scoreWeeksForLeague === 'function' && scoreWeeksForLeague(sp, lg)) || {};
}

;
/*! ==== 80-trade-verdict-share.js ==== */
// Trade verdict bar + share-link restore — extracted from 36.

/** The current trade's league and verdict.
 *
 * Every number comes from shared/trade-verdict.mjs: tier premium, consolidation
 * discount, 5% fairness band, suggested add. It is tested against the formula
 * that used to be written out inline here. The panel below and the share card
 * (81-trade-card.js) both read THIS, so neither derives values or calls the
 * maths on its own, and the two cannot disagree. */
function currentTradeVerdict() {
  const lg = STATE.leagues[TRADE.leagueIdx];
  if (!lg) return null;
  const aValues = [...TRADE.sideAAssets].map((k) => assetValue(k, lg)).filter((v) => v > 0);
  const bValues = [...TRADE.sideBAssets].map((k) => assetValue(k, lg)).filter((v) => v > 0);
  const pool = getValuePoolForTab(lg.scoringTab).map((p) => p.value || 0);
  return { lg, verdict: TacoCore.tradeVerdict(aValues, bValues, pool.length ? Math.max(...pool) : undefined) };
}
window.currentTradeVerdict = currentTradeVerdict;

/**
 * The actual assets that would even this trade (roadmap #2, 2026-09-27), from
 * the short side's roster: players and picks not already in the deal, each
 * scored through the verdict itself (TacoCore.suggestBalancers). One tap adds
 * one -- the chips carry the same data-tc-asset the roster chips do.
 */
function tradeBalancerHtml(lg, r) {
  if (!r.winner || !r.adder || !TacoCore.suggestBalancers) return '';
  const side = r.adder === 'a' ? 'A' : 'B';
  const rid = side === 'A' ? TRADE.sideARosterId : TRADE.sideBRosterId;
  const selected = side === 'A' ? TRADE.sideAAssets : TRADE.sideBAssets;
  const roster = lg.allRosters.find((x) => x.rosterId === rid);
  if (!roster) return '';
  const cands = [];
  for (const p of roster.players || []) {
    const key = 'P:' + p.playerId;
    if (!selected.has(key)) cands.push({ key, value: assetValue(key, lg), label: p.name, pos: p.position });
  }
  for (const pk of lg.picksByRoster[rid] || []) {
    const key = 'D:' + pk.season + '-' + pk.round + '-' + pk.originalRosterId;
    if (!selected.has(key)) cands.push({ key, value: assetValue(key, lg), label: pk.label + (pk.ownerNote && pk.ownerNote !== 'Own' ? ' ' + pk.ownerNote : '') });
  }
  const aValues = [...TRADE.sideAAssets].map((k) => assetValue(k, lg)).filter((v) => v > 0);
  const bValues = [...TRADE.sideBAssets].map((k) => assetValue(k, lg)).filter((v) => v > 0);
  const pool = getValuePoolForTab(lg.scoringTab).map((p) => p.value || 0);
  const picks = TacoCore.suggestBalancers(aValues, bValues, r.adder, cands, pool.length ? Math.max(...pool) : undefined);
  if (!picks.length) return '';
  const who = escapeHtml(roster.teamName || (side === 'A' ? 'Side A' : 'Side B'));
  return '<div class="tc-balancers"><div class="tc-balancers-head">To even it, ' + who + ' could add:</div>' +
    picks.map((c) =>
      '<button type="button" class="asset-chip tc-balancer' + (c.pos ? ' pos-' + c.pos.toLowerCase() : ' pos-pick') + '" data-tc-asset="' + side + '|' + escapeHtml(c.key) + '">' +
      escapeHtml(c.label) + ' <span class="val">' + Math.round(c.value).toLocaleString() + '</span>' +
      (c.fair ? '<span class="tc-balancer-fair">makes it fair</span>' : '') + '</button>').join('') +
    '</div>';
}

function renderTradeVerdict() {
  const el = document.getElementById('tradeVerdict');
  const cur = currentTradeVerdict();
  if (!cur || cur.verdict.empty) { el.style.display = 'none'; return; }
  el.style.display = 'block';
  const { lg, verdict: r } = cur;

  const aCount = TRADE.sideAAssets.size;
  const bCount = TRADE.sideBAssets.size;
  const fmt = (n) => Math.round(n).toLocaleString();

  let summary;
  if (r.fair) {
    summary = `<strong>Fair Trade.</strong> Within the 5% fairness band (effective gap ${fmt(r.effectiveDiff)}, threshold ${fmt(r.fairnessThreshold)}).`;
  } else {
    const winnerId = r.winner === 'a' ? TRADE.sideARosterId : TRADE.sideBRosterId;
    const fallbackWinner = r.winner === 'a' ? 'Side A' : 'Side B';
    const winnerName = escapeHtml(lg.allRosters.find((x) => x.rosterId === winnerId)?.teamName || fallbackWinner);
    const adderLabel = r.adder === 'a' ? 'Side A' : 'Side B';
    const pct = r.gapPct != null ? ` (${r.gapPct.toFixed(1)}% in effective value)` : '';
    summary = `<strong>${winnerName} wins by ${fmt(r.effectiveDiff)}</strong>${pct}. ${adderLabel} would need to add about ${fmt(r.suggestedAdd)} in value to even it.`;
  }

  const aRoster = lg.allRosters.find((x) => x.rosterId === TRADE.sideARosterId);
  const bRoster = lg.allRosters.find((x) => x.rosterId === TRADE.sideBRosterId);

  el.innerHTML = `
    <div style="display: flex; justify-content: space-between; align-items: baseline; margin-bottom: 10px;">
      <div style="font-family: 'Plus Jakarta Sans', system-ui, sans-serif; font-size: 22px; font-weight: 700; letter-spacing: -0.01em;">Trade Verdict</div>
      <div style="font-size: 12px; color: var(--text-muted); font-weight: 600;">
        ${aCount} ↔ ${bCount} pieces
      </div>
    </div>
    <div style="font-size: 11px; color: var(--text-dim); margin-bottom: 10px; letter-spacing: 0.04em; text-transform: uppercase; font-weight: 600;">What each side receives</div>
    <div class="verdict-bar">
      <div class="verdict-bar-left" style="width: ${r.aShare.toFixed(1)}%;"></div>
      <div class="verdict-bar-right" style="width: ${r.bShare.toFixed(1)}%;"></div>
      <div class="verdict-bar-center"></div>
    </div>
    <div class="verdict-numbers">
      <span>${escapeHtml(aRoster?.teamName || 'Side A')}: <strong>${fmt(r.aReceives.effective)}</strong><span style="color: var(--text-dim); font-size: 12px; font-weight: 500;"> (raw ${fmt(r.aReceives.total)} +${fmt(r.aReceives.premium)} tier premium)</span></span>
      <span>${escapeHtml(bRoster?.teamName || 'Side B')}: <strong>${fmt(r.bReceives.effective)}</strong><span style="color: var(--text-dim); font-size: 12px; font-weight: 500;"> (raw ${fmt(r.bReceives.total)} +${fmt(r.bReceives.premium)} tier premium)</span></span>
    </div>
    <div class="verdict-summary">${summary}</div>
    ${r.fair ? '' : tradeBalancerHtml(lg, r)}
    <div style="font-size: 11px; color: var(--text-dim); margin-top: 14px; font-weight: 500; letter-spacing: 0.02em;">
      Effective value = raw trade value + tier premium (elite assets carry more real value than face). Fairness band: ±5%.
    </div>
    <div class="value-trust-footnote">
      Values come from our own first-party engine - real trades + trailing stats/ADP - scaled to <strong>${escapeHtml(lg.scoringTab)}</strong>.
    </div>
    <div class="trade-share-row">
      <button class="ghost small" data-share-trade-card>🖼️ Share as image</button>
      <button class="ghost small" data-copy-trade-share>📋 Copy share link</button>
      <span class="trade-share-hint">The image works in any group chat. The link opens this trade for leaguemates who use The Armchair Office.</span>
    </div>
  `;
}

// Generate a compact URL containing the current trade scenario, copy it to
// the user's clipboard, and flash a confirmation on the button. The link
// contains: league index, both side roster IDs, and both sides' assets.
//
// On load, parseTradeShareLink() looks for these params and auto-restores
// the trade — so opening the link drops you straight into the same analysis.
async function copyTradeShareLink(btnEl) {
  if (TRADE.leagueIdx == null) return;
  const lg = STATE.leagues[TRADE.leagueIdx];
  if (!lg) return;
  // Use league_id (Sleeper's stable ID) rather than array index, so the
  // link still works if the user reloads with leagues in a different order.
  const params = new URLSearchParams();
  params.set('trade', '1');
  params.set('lg', lg.league_id);
  if (TRADE.sideARosterId != null) params.set('a', String(TRADE.sideARosterId));
  if (TRADE.sideBRosterId != null) params.set('b', String(TRADE.sideBRosterId));
  if (TRADE.sideAAssets.size > 0) params.set('aa', [...TRADE.sideAAssets].join(','));
  if (TRADE.sideBAssets.size > 0) params.set('ba', [...TRADE.sideBAssets].join(','));
  const url = `${window.location.origin}${window.location.pathname}?${params.toString()}`;
  try {
    await navigator.clipboard.writeText(url);
    const original = btnEl.textContent;
    btnEl.textContent = '✓ Link copied';
    btnEl.classList.add('copied');
    setTimeout(() => {
      btnEl.textContent = original;
      btnEl.classList.remove('copied');
    }, 2000);
  } catch (_e) {
    // Clipboard API can fail on insecure contexts or when the page isn't focused.
    // Fall back to a prompt so the user can copy manually.
    prompt('Copy this link:', url);
  }
}
window.copyTradeShareLink = copyTradeShareLink;

// On app boot (after leagues are loaded), check if the URL contains trade
// share params and auto-restore the trade scenario. If matched, jump to the
// trade view with all sides + assets pre-populated.
function applyTradeShareLink() {
  const params = new URLSearchParams(window.location.search);
  if (params.get('trade') !== '1') return false;
  const leagueId = params.get('lg');
  if (!leagueId) return false;
  const idx = STATE.leagues.findIndex(l => l.league_id === leagueId);
  if (idx < 0) {
    console.warn('[trade-share] league not found:', leagueId);
    return false;
  }
  // Stash a preload object that initTradeCalculator / applyTradePreload will consume
  const preload = {
    leagueIdx: idx,
    sideARosterId: params.get('a') ? parseInt(params.get('a')) : null,
    sideBRosterId: params.get('b') ? parseInt(params.get('b')) : null,
    sideAAssets: params.get('aa') ? params.get('aa').split(',') : [],
    sideBAssets: params.get('ba') ? params.get('ba').split(',') : [],
  };
  STATE.tradePreload = preload;
  // The Trades tab (2026-10-18). This used to park teamDetailTab on 'trade'
  // and render the calculator inside League Overview, which is what left that
  // page showing a trade screen afterwards.
  STATE.currentTeamIdx = idx;
  if (!STATE.tradeInitialized && typeof initTradeCalculator === 'function') {
    initTradeCalculator();
    STATE.tradeInitialized = true;
  }
  showView('trade');
  // Re-arm the preload and apply it as the guaranteed-last step.
  // initTradeCalculator() calls applyTradePreload() itself, which CONSUMES
  // STATE.tradePreload and nulls it; anything that syncs the league picker
  // afterwards can then reset TRADE's sides back to defaults with no preload
  // left to restore them. Keeping a local copy and replaying it last is what
  // makes a shared trade link land on the actual deal. (Was explained in
  // terms of initTradeCalcInSubtab, which no longer exists -- the calculator
  // is never mounted inside a league page now.)
  STATE.tradePreload = { ...preload };
  applyTradePreload();
  // Clean the URL so a refresh doesn't keep replaying the share — replaceState
  // keeps the user's history clean.
  if (window.history?.replaceState) {
    window.history.replaceState(null, '', window.location.pathname);
  }
  // Caller (finishPortfolioLoad) must not let its own route-restore logic
  // run after this returns true — /tools/trade-calculator is itself an app
  // route that resolves to the standalone trade view, and re-navigating
  // there would undo showView('team') above and land on an empty tab (the
  // standalone view's DOM children were just lifted into the subtab slot).
  return true;
}
window.applyTradeShareLink = applyTradeShareLink;

;
/*! ==== 81-trade-card.js ==== */
// Trade card -- the verdict as an image, for the group chat.
//
// The only way to share a trade was a link into this app, and that link opens
// nothing for a leaguemate who has not connected the same league here. A group
// chat is where trades actually get argued, and every chat app takes an image.
// So this draws the verdict onto a canvas and hands it to the phone's share
// sheet, or downloads it on desktop. No server, nothing stored, no link to rot.
//
// Numbers come from currentTradeVerdict() in 80-trade-verdict-share.js, the same
// call the panel renders from, so the card cannot say anything the panel does
// not.
//
// Drawn SYNCHRONOUSLY on purpose. Phones only open the share sheet from a user
// gesture, and an await between the tap and navigator.share() can spend that
// gesture before the sheet is asked for. Fonts are preloaded at startup instead
// of awaited on tap, and the PNG comes from toDataURL, not the async toBlob.

const TRADE_CARD_W = 1080;
const TRADE_CARD_ROWS = 6;
const TRADE_CARD_ROW_H = 82;

(function preloadTradeCardFonts() {
  try {
    ['600 76px Fraunces', '700 30px "Plus Jakarta Sans"', '500 30px "Plus Jakarta Sans"', '600 28px "Plus Jakarta Sans"'].forEach((f) => {
      document.fonts.load(f).catch(() => {});
    });
  } catch (_e) {
    /* fonts API unavailable: the card falls back to system faces */
  }
})();

/** Asset keys -> [{name, pos, value}], most valuable first. */
function tradeCardAssets(lg, keys) {
  const out = [];
  for (const key of keys) {
    const [type, ...rest] = key.split(':');
    const id = rest.join(':');
    let name = '';
    let pos = '';
    if (type === 'P') {
      for (const r of lg.allRosters) {
        const p = r.players.find((pp) => pp.playerId === id);
        if (p) {
          name = p.name;
          pos = p.position || '';
          break;
        }
      }
    } else if (type === 'D') {
      const [season, round, orig] = id.split('-').map(Number);
      const picks = [].concat(lg.picksByRoster[TRADE.sideARosterId] || [], lg.picksByRoster[TRADE.sideBRosterId] || []);
      const pk = picks.find((p) => p.season === season && p.round === round && p.originalRosterId === orig);
      name = pk ? pk.label + (pk.ownerNote && pk.ownerNote !== 'Own' ? ' ' + pk.ownerNote : '') : season + ' Round ' + round;
      pos = 'PICK';
    }
    out.push({ name: name || 'Unknown', pos, value: assetValue(key, lg) });
  }
  return out.sort((a, b) => b.value - a.value);
}

function tradeCardFit(ctx, text, maxWidth) {
  let t = String(text);
  if (ctx.measureText(t).width <= maxWidth) return t;
  while (t.length > 1 && ctx.measureText(t + '…').width > maxWidth) t = t.slice(0, -1);
  return t + '…';
}

/** The site's own palette, read from the live tokens so the card matches the theme. */
function tradeCardColors() {
  const cs = getComputedStyle(document.documentElement);
  const v = (name, fallback) => (cs.getPropertyValue(name) || '').trim() || fallback;
  return {
    bg: v('--bg-chrome', '#0b0b0e'),
    panel: v('--bg-elev', '#141418'),
    text: v('--text', '#f2e8d5'),
    dim: v('--text-dim', '#8a8494'),
    accent: v('--accent', '#d4a84b'),
  };
}

function tradeCardBox(ctx, x, y, w, h, r) {
  ctx.beginPath();
  if (typeof ctx.roundRect === 'function') ctx.roundRect(x, y, w, h, r);
  else ctx.rect(x, y, w, h);
  ctx.fill();
}

/** Returns a canvas. Pure drawing, no awaits (see the note at the top).
 *
 * Height follows the trade: a 1-for-1 is a short card, not a tall one that is
 * mostly empty panel. Gold marks the WINNER everywhere it appears -- bar
 * segment, column rule, effective value -- and nothing when the trade is fair,
 * so the colour never points at the side that lost. */
function drawTradeCard({ lg, verdict: r, aTeam, bTeam, aGets, bGets }) {
  const W = TRADE_CARD_W;
  const PAD = 72;
  const serif = 'Fraunces, Georgia, serif';
  const sans = "'Plus Jakarta Sans', system-ui, sans-serif";
  const mono = "'Plus Jakarta Sans', system-ui, sans-serif";
  const fmt = (n) => Math.round(n).toLocaleString('en-US');
  const col = tradeCardColors();

  const rows = Math.max(1, Math.min(TRADE_CARD_ROWS, Math.max(aGets.length, bGets.length)));
  const overflow = aGets.length > TRADE_CARD_ROWS || bGets.length > TRADE_CARD_ROWS;
  const addLine = !r.fair && r.winner && r.suggestedAdd > 0;
  const colY = 492;
  const colH = 196 + rows * TRADE_CARD_ROW_H + (overflow ? 34 : 0) + 110;
  const H = colY + colH + (addLine ? 84 : 24) + 136;

  const canvas = document.createElement('canvas');
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext('2d');
  ctx.textBaseline = 'alphabetic';

  ctx.fillStyle = col.bg;
  ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = col.accent;
  ctx.fillRect(0, 0, W, 8);

  // Brand, then the league and format the values were scaled to.
  ctx.fillStyle = col.accent;
  ctx.font = '600 26px ' + sans;
  ctx.fillText('THE ARMCHAIR OFFICE', PAD, 104);
  ctx.fillStyle = col.dim;
  ctx.font = '500 30px ' + sans;
  ctx.fillText(tradeCardFit(ctx, lg.name + ' · ' + lg.scoringTab, W - PAD * 2), PAD, 150);

  // The verdict, as the panel states it.
  const winnerTeam = r.winner === 'a' ? aTeam : r.winner === 'b' ? bTeam : '';
  ctx.fillStyle = col.text;
  ctx.font = '600 76px ' + serif;
  ctx.fillText(tradeCardFit(ctx, r.fair ? 'Fair trade' : winnerTeam + ' wins', W - PAD * 2), PAD, 270);
  ctx.fillStyle = r.fair ? col.accent : col.dim;
  ctx.font = '500 34px ' + sans;
  const sub = r.fair
    ? 'Within the 5% fairness band'
    : 'by ' + fmt(r.effectiveDiff) + ' in effective value' + (r.gapPct != null ? ' (' + r.gapPct.toFixed(1) + '%)' : '');
  ctx.fillText(tradeCardFit(ctx, sub, W - PAD * 2), PAD, 326);

  // Share of the combined value each team receives. Labelled at both ends, so
  // the bar reads without the panel beside it.
  const barY = 372;
  const barW = W - PAD * 2;
  const aW = Math.round((barW * r.aShare) / 100);
  ctx.save();
  ctx.globalAlpha = 0.28;
  ctx.fillStyle = col.dim;
  tradeCardBox(ctx, PAD, barY, barW, 22, 11);
  ctx.restore();
  if (r.winner === 'b') {
    ctx.fillStyle = col.accent;
    tradeCardBox(ctx, PAD + aW, barY, barW - aW, 22, 11);
  } else {
    ctx.fillStyle = r.winner === 'a' ? col.accent : col.dim;
    tradeCardBox(ctx, PAD, barY, aW, 22, 11);
  }
  // The percentage is the point of the label, so the team name is what gets
  // truncated. Fitting the joined string cut the % off every long team name,
  // and long team names are the norm in dynasty leagues.
  const half = barW / 2 - 16;
  ctx.font = '500 26px ' + sans;
  const aPct = ' ' + Math.round(r.aShare) + '%';
  const bPct = Math.round(r.bShare) + '% ';
  ctx.fillStyle = r.winner === 'a' ? col.text : col.dim;
  ctx.fillText(tradeCardFit(ctx, aTeam, half - ctx.measureText(aPct).width) + aPct, PAD, barY + 64);
  ctx.fillStyle = r.winner === 'b' ? col.text : col.dim;
  const bLabel = bPct + tradeCardFit(ctx, bTeam, half - ctx.measureText(bPct).width);
  ctx.fillText(bLabel, W - PAD - ctx.measureText(bLabel).width, barY + 64);

  // Two columns: what each team gets.
  const colGap = 24;
  const colW = (W - PAD * 2 - colGap) / 2;
  const columns = [
    { x: PAD, team: aTeam, gets: aGets, eff: r.aReceives.effective, lead: r.winner === 'a' },
    { x: PAD + colW + colGap, team: bTeam, gets: bGets, eff: r.bReceives.effective, lead: r.winner === 'b' },
  ];
  for (const c of columns) {
    ctx.fillStyle = col.panel;
    tradeCardBox(ctx, c.x, colY, colW, colH, 22);
    const inner = c.x + 32;
    const innerW = colW - 64;

    ctx.fillStyle = c.lead ? col.accent : col.dim;
    ctx.fillRect(inner, colY + 34, 36, 6);
    ctx.fillStyle = col.dim;
    ctx.font = '600 22px ' + sans;
    ctx.fillText('GETS', inner, colY + 84);
    ctx.fillStyle = col.text;
    ctx.font = '600 34px ' + serif;
    ctx.fillText(tradeCardFit(ctx, c.team, innerW), inner, colY + 128);

    let y = colY + 196;
    const shown = c.gets.slice(0, TRADE_CARD_ROWS);
    if (!shown.length) {
      ctx.fillStyle = col.dim;
      ctx.font = '500 28px ' + sans;
      ctx.fillText('Nothing yet', inner, y);
    }
    for (const a of shown) {
      ctx.font = '500 20px ' + mono;
      ctx.fillStyle = col.dim;
      ctx.fillText(a.pos, inner, y - 30);
      ctx.font = '500 28px ' + mono;
      const val = a.value ? fmt(a.value) : '-';
      const valW = ctx.measureText(val).width;
      ctx.fillText(val, inner + innerW - valW, y);
      ctx.fillStyle = col.text;
      ctx.font = '500 30px ' + sans;
      ctx.fillText(tradeCardFit(ctx, a.name, innerW - valW - 20), inner, y);
      y += TRADE_CARD_ROW_H;
    }
    if (c.gets.length > TRADE_CARD_ROWS) {
      ctx.fillStyle = col.dim;
      ctx.font = '500 26px ' + sans;
      ctx.fillText('+ ' + (c.gets.length - TRADE_CARD_ROWS) + ' more', inner, y - 30);
    }

    ctx.fillStyle = col.dim;
    ctx.font = '600 22px ' + sans;
    ctx.fillText('EFFECTIVE VALUE', inner, colY + colH - 76);
    ctx.fillStyle = c.lead ? col.accent : col.text;
    ctx.font = '600 40px ' + mono;
    ctx.fillText(fmt(c.eff), inner, colY + colH - 32);
  }

  // What would even it -- the line a group chat actually argues about.
  if (addLine) {
    const adderTeam = r.adder === 'a' ? aTeam : bTeam;
    ctx.fillStyle = col.text;
    ctx.font = '500 30px ' + sans;
    ctx.fillText(
      tradeCardFit(ctx, 'To even it, ' + adderTeam + ' adds a player worth ~' + fmt(r.suggestedAdd), W - PAD * 2),
      PAD,
      colY + colH + 64,
    );
  }

  // Method and address.
  ctx.fillStyle = col.dim;
  ctx.font = '500 24px ' + sans;
  ctx.fillText(tradeCardFit(ctx, 'Tier premium and consolidation applied · ±5% fairness band', W - PAD * 2), PAD, H - 88);
  ctx.fillStyle = col.accent;
  ctx.font = '600 28px ' + sans;
  ctx.fillText('thearmchairoffice.com', PAD, H - 46);

  return canvas;
}

function tradeCardBlob(canvas) {
  const dataUrl = canvas.toDataURL('image/png');
  const bin = atob(dataUrl.split(',')[1]);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], { type: 'image/png' });
}

function shareTradeCard() {
  const cur = typeof currentTradeVerdict === 'function' ? currentTradeVerdict() : null;
  if (!cur || cur.verdict.empty) return;
  const { lg, verdict } = cur;
  const teamName = (id, fallback) => lg.allRosters.find((x) => x.rosterId === id)?.teamName || fallback;

  try {
    const canvas = drawTradeCard({
      lg,
      verdict,
      aTeam: teamName(TRADE.sideARosterId, 'Side A'),
      bTeam: teamName(TRADE.sideBRosterId, 'Side B'),
      // What each side RECEIVES is what the other gives, exactly as the panel reads.
      aGets: tradeCardAssets(lg, [...TRADE.sideBAssets]),
      bGets: tradeCardAssets(lg, [...TRADE.sideAAssets]),
    });
    const blob = tradeCardBlob(canvas);
    const file = new File([blob], 'trade-verdict.png', { type: 'image/png' });

    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      navigator
        .share({ files: [file], title: 'Trade verdict' })
        .then(() => {
          if (typeof trackEvent === 'function') trackEvent('trade_card_shared');
        })
        .catch((e) => {
          if (e && e.name !== 'AbortError') tradeCardDownload(blob);
        });
      return;
    }
    tradeCardDownload(blob);
  } catch (err) {
    console.error('[trade-card]', err);
    if (typeof window.showToast === 'function') window.showToast("Couldn't make the image. Try again.", { type: 'error' });
  }
}
window.shareTradeCard = shareTradeCard;
window.drawTradeCard = drawTradeCard;

function tradeCardDownload(blob) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'trade-verdict.png';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
  if (typeof trackEvent === 'function') trackEvent('trade_card_downloaded');
}

document.addEventListener('click', (e) => {
  if (e.target.closest('[data-share-trade-card]')) shareTradeCard();
});

;
/*! ==== 36-render-fit-panel.js ==== */
// Trade fit UI — panel → 79, verdict/share → 80.

;
/*! ==== 38-taco-storage-safe-localstorage-wrapper.js ==== */
// localStorage throws in two real-world cases: private/incognito browsing
// (Safari is the common offender) and quota exhaustion. Every call should
// be try/wrapped. This namespace centralizes that and adds JSON serialization
// for non-string values so we don't have to remember to .stringify everywhere.
//
// Keys are prefixed `taco_` to namespace away from the legacy `fo_` keys
// (which date back to the FrontOffice rename and stay backward-compatible).
const TacoStorage = {
  prefix: 'taco_',
  get(key, fallback = null) {
    try {
      const raw = localStorage.getItem(this.prefix + key);
      if (raw == null) return fallback;
      return JSON.parse(raw);
    } catch (_e) {
      return fallback;
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(this.prefix + key, JSON.stringify(value));
      return true;
    } catch (e) {
      // Quota exceeded, private mode, etc. — fail silently rather than crash.
      console.warn('[storage] set failed for', key, e);
      return false;
    }
  },
  remove(key) {
    try { localStorage.removeItem(this.prefix + key); return true; } catch (_e) { return false; }
  },
  // For use cases where the value is keyed off a dynamic ID (e.g., per-league
  // notes). Builds a composite key under the same prefix.
  getNamespaced(namespace, id, fallback = null) {
    return this.get(`${namespace}.${id}`, fallback);
  },
  setNamespaced(namespace, id, value) {
    return this.set(`${namespace}.${id}`, value);
  },
};
window.TacoStorage = TacoStorage;

// Error boundary for panel renders. Wraps any function that returns HTML
// and catches errors so a single broken panel doesn't blank an entire view.
// Usage: html += safePanelRender('League Rankings', () => renderPowerRankingsPanel(lg));
// Returns the HTML on success, or a small fallback block on failure.
function safePanelRender(panelName, renderFn) {
  try {
    return renderFn();
  } catch (err) {
    console.error(`[panel] ${panelName} failed:`, err);
    return `
      <div class="panel-error" style="padding:14px 16px; margin:8px 0; background: rgba(194, 74, 90, 0.08); border:1px solid rgba(194, 74, 90, 0.3); border-radius: var(--r-md); font-size:12px; color: var(--text-muted);">
        <strong style="color:#c24a5a;">${escapeHtml(panelName)} failed to render.</strong>
        Other sections still work - <a href="#" data-storage-reload style="color:var(--accent);">refresh</a> if it persists.
      </div>
    `;
  }
}
window.safePanelRender = safePanelRender;

;
/*! ==== 39-masthead-refresh-button-last-sync-indicator.js ==== */
// Format a timestamp as a relative phrase ("just now", "2m ago", "3h ago",
// "yesterday", "Apr 14"). Used in the masthead sync chip.
function formatRelativeTime(ts) {
  if (!ts) return '-';
  const diff = Date.now() - ts;
  const sec = Math.floor(diff / 1000);
  if (sec < 30) return 'just now';
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const days = Math.floor(hr / 24);
  if (days === 1) return 'yesterday';
  if (days < 7) return `${days}d ago`;
  const d = new Date(ts);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

// Show or update the refresh chip based on STATE.lastSyncAt
// Phase F: render the masthead user badge — Sleeper avatar + display name +
// quick portfolio totals. Called whenever leagues finish loading. Hidden
// before that point and on landing/setup views.
function updateUserBadge() {
  const el = document.getElementById('userBadge');
  // Settings button (TACO overhaul Phase 3) follows the same visibility
  // rule as the profile badge -- only relevant once there's a real session
  // to have preferences for.
  const settingsBtn = document.getElementById('settingsBtn');
  if (!el) return;
  if (!STATE.userId || !STATE.leagues || STATE.leagues.length === 0) {
    el.style.display = 'none';
    if (settingsBtn) settingsBtn.style.display = 'none';
    return;
  }
  if (settingsBtn) settingsBtn.style.display = '';
  const avatarUrl = STATE.userAvatar
    ? `https://sleepercdn.com/avatars/${STATE.userAvatar}`
    : null;
  const name = STATE.userDisplayName || STATE.username || 'You';
  const active = STATE.leagues.filter(lg => lg.startupComplete !== false);
  const lgCount = active.length;

  // Cheap stats first — synchronous, no API needed.
  // "Dynasty since YEAR" uses Sleeper's `season` field on each league; it's
  // the CURRENT season, not the league's first season. To get true startup
  // year we'd walk previous_league_id chains. Until that resolves below, we
  // show the earliest current-season we have as a quick approximation.
  let earliestSeason = null;
  for (const lg of active) {
    const s = parseInt(lg.season);
    if (!isNaN(s) && (earliestSeason === null || s < earliestSeason)) {
      earliestSeason = s;
    }
  }

  el.innerHTML = `
    ${avatarUrl
      ? `<img class="user-badge-avatar" src="${avatarUrl}" alt="" data-img-fallback="hide">`
      : `<span class="user-badge-avatar user-badge-avatar-fallback">${escapeHtml(name.charAt(0).toUpperCase())}</span>`
    }
    <span class="user-badge-text">
      <span class="user-badge-name">${escapeHtml(name)}</span>
      <span class="user-badge-meta">
        <span data-stat="leagues">${lgCount} leagues</span><!--
     --> · <span data-stat="dynasty-since">Dynasty since ${earliestSeason || '-'}</span><!--
     --> · <span data-stat="avg-age">Avg -</span><!--
     --> · <span data-stat="oldest">Oldest -</span>
      </span>
    </span>
  `;
  el.style.display = 'inline-flex';

  // Async fill: walk league chains to derive true startup year + avg/max
  // league ages. Cached per-league for 24h so this is a no-op on warm loads.
  // Doesn't block initial render; updates the stats in place when ready.
  (async () => {
    const ages = [];
    let startupYears = [];
    for (const lg of active) {
      const seasons = await getLeagueAge(lg.league_id);
      if (seasons != null && seasons > 0) {
        ages.push(seasons);
        const currentSeason = parseInt(lg.season);
        if (!isNaN(currentSeason)) {
          // First startup season = current - (seasons - 1).
          // e.g. season 2026, 3 seasons played → started in 2024.
          startupYears.push(currentSeason - (seasons - 1));
        }
      }
    }
    if (ages.length === 0) return;
    const avg = (ages.reduce((a, b) => a + b, 0) / ages.length);
    const max = Math.max(...ages);
    const earliestStartup = startupYears.length > 0 ? Math.min(...startupYears) : null;

    // Update each stat span in place. Guard against the badge being torn down
    // and re-rendered between the call and resolution.
    const elNow = document.getElementById('userBadge');
    if (!elNow) return;
    const since = elNow.querySelector('[data-stat="dynasty-since"]');
    const avgEl = elNow.querySelector('[data-stat="avg-age"]');
    const oldEl = elNow.querySelector('[data-stat="oldest"]');
    if (since && earliestStartup) since.textContent = `Dynasty since ${earliestStartup}`;
    if (avgEl) avgEl.textContent = `Avg ${avg.toFixed(1)}y`;
    if (oldEl) oldEl.textContent = `Oldest ${max}y`;
  })();
}
window.updateUserBadge = updateUserBadge;

;
/*! ==== 40-profile-drawer-centered-modal.js ==== */
// Opens when the user clicks their badge in the masthead. Shows the same
// stats as the badge but laid out properly, plus standings snapshot,
// format breakdown, and quick actions (refresh, switch user, info links).
function openProfileDrawer() {
  const overlay = document.getElementById('profileOverlay');
  const modal = document.getElementById('profileModal');
  if (!overlay || !modal) return;
  renderProfileDrawer();
  overlay.classList.add('open');
  overlay.setAttribute('aria-hidden', 'false');
  modal.classList.add('open');
  modal.setAttribute('aria-hidden', 'false');
  if (window.TacoFocus) TacoFocus.capture(modal, { focus: '.profile-close' });
  // Esc closes
  document.addEventListener('keydown', _profileEscHandler);
}
window.openProfileDrawer = openProfileDrawer;

function closeProfileDrawer(event) {
  // If invoked via overlay click, only close when the click was actually
  // on the overlay itself (not bubbled from the modal child)
  if (event && event.target && event.target.id && event.target.id !== 'profileOverlay') {
    return;
  }
  const overlay = document.getElementById('profileOverlay');
  const modal = document.getElementById('profileModal');
  if (overlay) {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
  }
  if (modal) {
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
  }
  if (window.TacoFocus && modal) TacoFocus.release(modal);
  document.removeEventListener('keydown', _profileEscHandler);
}
window.closeProfileDrawer = closeProfileDrawer;

function _profileEscHandler(e) {
  if (e.key === 'Escape') closeProfileDrawer();
}

function renderProfileDrawer() {
  const el = document.getElementById('profileContent');
  if (!el) return;

  const avatarUrl = STATE.userAvatar
    ? `https://sleepercdn.com/avatars/${STATE.userAvatar}`
    : null;
  const name = STATE.userDisplayName || STATE.username || 'You';
  const username = STATE.username || '';
  const active = STATE.leagues.filter(lg => lg.startupComplete !== false);
  const lgCount = active.length;

  // Format breakdown — counts of each scoringTab
  const formatCounts = {};
  for (const lg of active) {
    const tab = lg.scoringTab || (lg.roster_positions?.includes('SUPER_FLEX') ? 'SF' : '1QB');
    formatCounts[tab] = (formatCounts[tab] || 0) + 1;
  }
  // Order so we always render SF first, then 1QB, then TEP variants in order
  const formatOrder = ['SF', 'SF TE+', 'SF TE++', 'SF TE+++', '1QB', '1QB TE+', '1QB TE++', '1QB TE+++'];
  const formatRows = formatOrder
    .filter(f => formatCounts[f])
    .map(f => `<span class="profile-format-pill">${escapeHtml(f)} <strong>${formatCounts[f]}</strong></span>`)
    .join('');

  // Initial render — async stats show '—' until getLeagueAge fills them
  el.innerHTML = `
    <div class="profile-header">
      ${avatarUrl
        ? `<img class="profile-avatar" src="${avatarUrl}" alt="" data-img-fallback="hide">`
        : `<span class="profile-avatar profile-avatar-fallback">${escapeHtml(name.charAt(0).toUpperCase())}</span>`}
      <div>
        <div class="profile-name">${escapeHtml(name)}</div>
        <div class="profile-handle">@${escapeHtml(username)}</div>
      </div>
    </div>

    <div class="profile-section">
      <div class="profile-section-label">Portfolio</div>
      <div class="profile-stat-grid">
        <div class="profile-stat">
          <div class="profile-stat-num">${lgCount}</div>
          <div class="profile-stat-label">Active leagues</div>
        </div>
        <div class="profile-stat" data-stat="dynasty-since">
          <div class="profile-stat-num"><span class="profile-stat-pending">…</span></div>
          <div class="profile-stat-label">Dynasty since</div>
        </div>
        <div class="profile-stat" data-stat="avg-age">
          <div class="profile-stat-num"><span class="profile-stat-pending">…</span></div>
          <div class="profile-stat-label">Avg league age</div>
        </div>
        <div class="profile-stat" data-stat="oldest">
          <div class="profile-stat-num"><span class="profile-stat-pending">…</span></div>
          <div class="profile-stat-label">Oldest league</div>
        </div>
        <div class="profile-stat" data-stat="total-seasons">
          <div class="profile-stat-num"><span class="profile-stat-pending">…</span></div>
          <div class="profile-stat-label">Total seasons</div>
        </div>
      </div>
    </div>

    ${formatRows ? `
    <div class="profile-section">
      <div class="profile-section-label">Format breakdown</div>
      <div class="profile-format-row">${formatRows}</div>
    </div>
    ` : ''}

    <div class="profile-section">
      <div class="profile-section-label">Actions</div>
      <div class="profile-actions">
        <button class="profile-action-btn" data-profile-refresh>↻ Refresh data</button>
        <button class="profile-action-btn danger" data-profile-switch>⇄ Switch user</button>
      </div>
    </div>

    <div class="profile-foot-links">
      <a href="/about.html">About</a>
      <a href="/methodology.html">Methodology</a>
      <a href="/terms.html">Terms</a>
      <a href="/privacy.html">Privacy</a>
    </div>
  `;

  // Async fill: walk league chains for age stats — same pattern as masthead.
  // Cached per-league for 24h so it's near-instant on warm reloads.
  (async () => {
    const ages = [];
    const startupYears = [];
    for (const lg of active) {
      const seasons = await getLeagueAge(lg.league_id);
      if (seasons != null && seasons > 0) {
        ages.push(seasons);
        const cs = parseInt(lg.season);
        if (!isNaN(cs)) startupYears.push(cs - (seasons - 1));
      }
    }
    // Modal might be closed by now — re-query and bail if gone
    const elNow = document.getElementById('profileContent');
    if (!elNow) return;
    if (ages.length === 0) return;
    const avg = ages.reduce((a, b) => a + b, 0) / ages.length;
    const max = Math.max(...ages);
    const totalSeasons = ages.reduce((a, b) => a + b, 0);
    const earliestStartup = startupYears.length > 0 ? Math.min(...startupYears) : null;

    const setStat = (key, value) => {
      const node = elNow.querySelector(`[data-stat="${key}"] .profile-stat-num`);
      if (node) node.textContent = value;
    };
    if (earliestStartup) setStat('dynasty-since', String(earliestStartup));
    setStat('avg-age', `${avg.toFixed(1)}y`);
    setStat('oldest', `${max}y`);
    setStat('total-seasons', String(totalSeasons));
  })();
}
window.renderProfileDrawer = renderProfileDrawer;

// Switch user — clears the cached username + currentTeamIdx and reloads.
// localStorage is the only persistence layer, so wiping the relevant keys
// + a reload returns the app to the landing page asking for a username.
function profileSwitchUser() {
  if (!confirm('Switch user? Your current session will be cleared and you\'ll return to the landing page.')) {
    return;
  }
  try {
    // Known keys the app reads on boot. Be conservative — don't nuke unrelated
    // localStorage entries (e.g. another app on the same domain shouldn't be affected).
    const keysToRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (!k) continue;
      // TacoStorage namespaces everything with `taco_` prefix; legacy keys
      // include sleeperUsername / currentTeamIdx without prefix.
      if (k.startsWith('taco_') || k === 'sleeperUsername' || k === 'sleeper_username' || k === 'currentTeamIdx') {
        keysToRemove.push(k);
      }
    }
    keysToRemove.forEach(k => localStorage.removeItem(k));
  } catch (e) {
    console.warn('[switch-user] localStorage clear failed:', e.message);
  }
  // Hard reload returns us to the landing flow
  window.location.href = '/';
}
window.profileSwitchUser = profileSwitchUser;

function updateSyncIndicator() {
  const wrap = document.getElementById('statusRefresh');
  const time = document.getElementById('statusSyncTime');
  if (!wrap || !time) return;
  if (!STATE.lastSyncAt) {
    wrap.style.display = 'none';
    return;
  }
  wrap.style.display = 'inline-flex';
  time.textContent = `synced ${formatRelativeTime(STATE.lastSyncAt)}`;
  // Tooltip shows the absolute time for users who want precise freshness info
  const exact = new Date(STATE.lastSyncAt).toLocaleString();
  time.setAttribute('data-tooltip', `Last full Sleeper sync: ${exact}`);
}

// Tick the relative-time chip every 30s so "2m ago" rolls forward without
// the user needing to refresh
setInterval(updateSyncIndicator, 30000);

// Wire the refresh button. Spinner state during the re-sync; resets on done.
(function wireRefreshButton() {
  const btn = document.getElementById('statusRefreshBtn');
  if (!btn) return;
  btn.addEventListener('click', async () => {
    if (btn.classList.contains('spinning')) return; // ignore double-clicks
    btn.classList.add('spinning');
    try {
      // Reuse the main load path — it already handles full refresh of leagues,
      // composites, traded picks, etc. News fetched as part of view rendering.
      await loadEverything();
    } catch (e) {
      console.warn('[refresh] failed:', e.message);
    } finally {
      btn.classList.remove('spinning');
    }
  });
})();

;
/*! ==== 41-portal-tooltip-system.js ==== */
// Single tooltip element appended to <body>. Event delegation listens for
// hover/focus on any [data-tooltip] element and positions the tooltip near
// it, flipping above→below if it would overflow the viewport top, and
// shifting horizontally to stay onscreen. On touch devices, taps toggle
// instead of hover, with a single global "outside tap to dismiss" handler.
(function installTooltipSystem() {
  const TIP_ID = 'foTooltip';
  let tipEl = null;
  let currentTarget = null;
  // Crude touch-detection — anything that fires touchstart at least once
  // gets the tap-to-toggle behavior.
  let isTouch = false;
  document.addEventListener('touchstart', () => { isTouch = true; }, { passive: true, once: true });

  function ensureTooltipEl() {
    if (tipEl) return tipEl;
    tipEl = document.createElement('div');
    tipEl.className = 'fo-tooltip';
    tipEl.id = TIP_ID;
    document.body.appendChild(tipEl);
    return tipEl;
  }

  function showTooltip(target) {
    const text = target.getAttribute('data-tooltip');
    if (!text) return;
    const tip = ensureTooltipEl();
    tip.textContent = text;
    tip.classList.add('visible');
    currentTarget = target;
    positionTooltip(target, tip);
  }

  function positionTooltip(target, tip) {
    const rect = target.getBoundingClientRect();
    // Reset to measure natural size
    tip.style.left = '0px';
    tip.style.top  = '0px';
    const tipRect = tip.getBoundingClientRect();
    const margin = 8;
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    // Default: above and centered
    let top  = rect.top - tipRect.height - margin;
    let left = rect.left + rect.width / 2 - tipRect.width / 2;

    // Flip below if no room above
    if (top < margin) top = rect.bottom + margin;
    // Clamp horizontally
    if (left < margin) left = margin;
    if (left + tipRect.width > vw - margin) left = vw - tipRect.width - margin;
    // Clamp vertically (last-resort)
    if (top + tipRect.height > vh - margin) top = vh - tipRect.height - margin;

    tip.style.left = left + 'px';
    tip.style.top  = top + 'px';
  }

  function hideTooltip() {
    if (!tipEl) return;
    tipEl.classList.remove('visible');
    currentTarget = null;
  }

  // Hover (desktop)
  document.addEventListener('mouseover', (e) => {
    if (isTouch) return;
    const target = e.target.closest('[data-tooltip]');
    if (!target) return;
    if (target === currentTarget) return;
    showTooltip(target);
  });
  document.addEventListener('mouseout', (e) => {
    if (isTouch) return;
    const target = e.target.closest('[data-tooltip]');
    if (!target || target !== currentTarget) return;
    // Only hide if we're leaving entirely (not moving to a child)
    const related = e.relatedTarget;
    if (related && target.contains(related)) return;
    hideTooltip();
  });

  // Focus (keyboard accessibility)
  document.addEventListener('focusin', (e) => {
    const target = e.target.closest('[data-tooltip]');
    if (!target) return;
    showTooltip(target);
  });
  document.addEventListener('focusout', (e) => {
    const target = e.target.closest('[data-tooltip]');
    if (target === currentTarget) hideTooltip();
  });

  // Touch (mobile): tap to toggle. Only fire if the element doesn't have its
  // own click handler we'd interfere with. Uses 'touchend' to avoid conflict
  // with click events that follow.
  document.addEventListener('touchend', (e) => {
    const target = e.target.closest('[data-tooltip]');
    if (!target) {
      // Tap outside any tooltip element → dismiss
      if (currentTarget) hideTooltip();
      return;
    }
    // If the element is ALSO a control, let the tap do its job and skip the
    // tooltip. This used to test for an inline onclick -- but the codebase
    // moved off those to delegated data-taco-* handlers years ago (AGENTS.md),
    // so the guard never tripped: tapping the league switcher or the refresh
    // button showed a tooltip AND fired the action, and the tooltip flashed as
    // the view changed under it (2026-10-17).
    //
    // Asking whether the thing is interactive is the durable form of the
    // question. Delegated controls are promoted to role="button" + tabindex by
    // 69-taco-click-delegation, so they answer it without being enumerated
    // here twice.
    if (target.closest('a[href], button, input, select, textarea, summary, [role="button"], [tabindex]:not([tabindex="-1"])')) return;
    // Toggle
    if (target === currentTarget) {
      hideTooltip();
    } else {
      showTooltip(target);
    }
  }, { passive: true });

  // Reposition on scroll/resize while visible
  window.addEventListener('scroll', () => {
    if (currentTarget && tipEl) positionTooltip(currentTarget, tipEl);
  }, { passive: true });
  window.addEventListener('resize', () => {
    if (currentTarget && tipEl) positionTooltip(currentTarget, tipEl);
  });
})();

// Escape key closes whichever overlay is open. Glossary takes precedence
// (since opening it from inside the drawer would be unusual but possible).
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  // Info modals (About, Privacy) — close first if open
  const openInfo = document.querySelector('.info-overlay.open');
  if (openInfo) {
    closeInfoModal();
    return;
  }
  const glossary = document.getElementById('glossaryModal');
  if (glossary && glossary.classList.contains('open')) {
    closeGlossary();
    return;
  }
  const drawer = document.getElementById('playerDrawer');
  if (drawer && drawer.classList.contains('open')) closePlayerDrawer();
});


// Clean up any legacy mode preference (app is dynasty-only now)
try {
  localStorage.removeItem('fo_mode');
  const savedSortKey = localStorage.getItem('fo_portfolio_sort_key');
  if (savedSortKey) STATE.portfolioSortKey = savedSortKey;
  const savedSortDir = localStorage.getItem('fo_portfolio_sort_dir');
  if (savedSortDir === 'asc' || savedSortDir === 'desc') STATE.portfolioSortDir = savedSortDir;
  const savedPowerSort = localStorage.getItem('fo_power_rankings_sort');
  if (savedPowerSort) STATE.powerRankingsSort = savedPowerSort;
  const savedPowerBasis = localStorage.getItem('fo_power_rankings_basis');
  if (savedPowerBasis) STATE.powerRankingsIncludePicks = savedPowerBasis !== 'roster';
} catch (_e) {}

;
/*! ==== 42-site-chrome.js ==== */
// Site chrome — FantasyPros-style web shell (marketing nav, tool nav, breadcrumbs).

function setSiteChromeMode(mode) {
  const isApp = mode === 'app';
  document.body.classList.toggle('chrome-app', isApp);
  document.body.classList.toggle('chrome-marketing', !isApp);
  const marketing = document.getElementById('siteNavMarketing');
  const cta = document.getElementById('siteEnterCta');
  if (marketing) marketing.hidden = isApp;
  if (cta) cta.hidden = isApp;
  closeSiteDrawer();
}

function updatePageBreadcrumb(viewName) {
  // No visible breadcrumb in 2.0. Every app page rendered "Portfolio / <page>",
  // a root link to somewhere the section menus and tool bar already go (Owen,
  // 2026-09-13: "its not needed"). The element stays, empty and hidden by
  // :empty, so layout and the smoke check that looks for it are unchanged. The
  // one job left is keeping the screen-reader h1 naming the page.
  const el = document.getElementById('pageBreadcrumb');
  if (el) el.innerHTML = '';
  const lg = STATE.leagues && STATE.leagues[STATE.currentTeamIdx];
  // Labels come from the route table (shared/routes.mjs), not a copy kept here.
  const labels = {
    ...(window.TacoRoutes?.VIEW_LABELS || {}),
    team: lg ? lg.name : 'League',
  };
  const extra = labels[viewName];
  const headingEl = document.getElementById('appViewHeading');
  if (headingEl) {
    headingEl.textContent = extra ? `${extra} - The Armchair Office` : 'The Armchair Office';
  }
}

async function refreshLandingStats() {
  const tradesEl = document.getElementById('landingStatTrades');
  const leaguesEl = document.getElementById('landingStatLeagues');
  if (!tradesEl && !leaguesEl) return;
  let status = null;
  if (window.TacoCrawl && TacoCrawl.fetchCrawlStatus) {
    status = await TacoCrawl.fetchCrawlStatus();
  }
  if (!status) return;
  if (tradesEl) {
    tradesEl.textContent = (status.trades_indexed || 0).toLocaleString();
  }
  if (leaguesEl) {
    leaguesEl.textContent = (status.leagues_crawled || status.leagues_registered || 0).toLocaleString();
  }
}

function openSiteDrawer() {
  const drawer = document.getElementById('siteMobileDrawer');
  const btn = document.getElementById('siteMenuBtn');
  const overlay = document.getElementById('siteDrawerOverlay');
  if (!drawer) return;
  drawer.hidden = false;
  drawer.setAttribute('aria-hidden', 'false');
  if (btn) btn.setAttribute('aria-expanded', 'true');
  if (overlay) overlay.hidden = false;
  document.body.classList.add('site-drawer-open');
}

function closeSiteDrawer() {
  const drawer = document.getElementById('siteMobileDrawer');
  const btn = document.getElementById('siteMenuBtn');
  const overlay = document.getElementById('siteDrawerOverlay');
  if (!drawer) return;
  drawer.hidden = true;
  drawer.setAttribute('aria-hidden', 'true');
  if (btn) btn.setAttribute('aria-expanded', 'false');
  if (overlay) overlay.hidden = true;
  document.body.classList.remove('site-drawer-open');
}
window.closeSiteDrawer = closeSiteDrawer;

// "More" sheet — the four cross-league tools (Trade Finder, Player Rankings,
// League View, Market Radar) plus Trade History live in .tools-sidebar,
// which is desktop-only. The 5-icon bottom nav has no room for them, so on
// mobile they had NO path at all. Same overlay+sheet pattern as the site
// drawer, just its own instance since this is in-app tool navigation, not
// the marketing-site menu the header hamburger opens.
function openMobileMoreSheet() {
  const sheet = document.getElementById('mobileMoreSheet');
  const overlay = document.getElementById('mobileMoreOverlay');
  const btn = document.getElementById('mobileMoreBtn');
  if (!sheet) return;
  sheet.hidden = false;
  sheet.setAttribute('aria-hidden', 'false');
  if (overlay) overlay.hidden = false;
  if (btn) btn.setAttribute('aria-expanded', 'true');
}
function closeMobileMoreSheet() {
  const sheet = document.getElementById('mobileMoreSheet');
  const overlay = document.getElementById('mobileMoreOverlay');
  const btn = document.getElementById('mobileMoreBtn');
  if (!sheet) return;
  sheet.hidden = true;
  sheet.setAttribute('aria-hidden', 'true');
  if (overlay) overlay.hidden = true;
  if (btn) btn.setAttribute('aria-expanded', 'false');
}
window.closeMobileMoreSheet = closeMobileMoreSheet;

(function initSiteChrome() {
  const menuBtn = document.getElementById('siteMenuBtn');
  if (menuBtn) {
    menuBtn.addEventListener('click', () => {
      const drawer = document.getElementById('siteMobileDrawer');
      if (drawer && drawer.hidden) openSiteDrawer();
      else closeSiteDrawer();
    });
  }
  const moreBtn = document.getElementById('mobileMoreBtn');
  if (moreBtn) {
    moreBtn.addEventListener('click', () => {
      const sheet = document.getElementById('mobileMoreSheet');
      if (sheet && sheet.hidden) openMobileMoreSheet();
      else closeMobileMoreSheet();
    });
  }
  // Match whatever page mode is already set: a /u/<name> boot can reach
  // showApp() before this runs, and a flat 'marketing' here put the marketing
  // nav state and "Enter the Office" back on top of the app.
  setSiteChromeMode(document.body.classList.contains('page-app') ? 'app' : 'marketing');
})();

window.setSiteChromeMode = setSiteChromeMode;
window.updatePageBreadcrumb = updatePageBreadcrumb;
window.refreshLandingStats = refreshLandingStats;
// Sub-nav for the current moment.
//
// The bottom tab (mobile) or sidebar group (desktop) picks the moment; this
// strip picks the tool inside it. Rendered from NAV_GROUPS rather than written
// into the HTML, so a view added to a group appears here automatically and the
// two can never disagree — the drift that produced a "More" tab holding six
// destinations the bar had no room for.
function syncGroupSubNav(viewName) {
  const nav = document.getElementById('groupSubNav');
  const R = window.TacoRoutes;
  if (!nav || !R?.groupForView) return;

  const group = R.groupForView(viewName);
  nav.querySelectorAll('[data-group-link]').forEach((el) => el.remove());
  if (!group) return;

  const leagueWrap = nav.querySelector('.nav-tab-league-wrap');
  for (const view of group.views) {
    const entry = R.navEntryFor ? R.navEntryFor(view) : null;
    if (!entry) continue;
    const a = document.createElement('a');
    a.className = 'nav-tab' + (view === viewName ? ' active' : '');
    a.href = entry.href;
    a.dataset.view = view;
    a.dataset.groupLink = '1';
    a.textContent = entry.label;
    nav.insertBefore(a, leagueWrap);
  }
}
window.syncGroupSubNav = syncGroupSubNav;

// Overhead tool bar — the desktop half of the moment model.
//
// Four sections, each opening a dropdown of its tools, rendered from NAV_GROUPS
// so the bar, the sidebar and the mobile tabs cannot disagree. Replaces the
// 252px left rail above 960px, which hands that width back to the content —
// a thirty-league board wants it more than navigation does.
//
// Deliberately not a hamburger: everything is visible in the bar, and only the
// contents of a section are one click away. A drawer behind an icon groups just
// as well and charges a discovery tax to every first-time visitor.
function renderToolBar() {
  const bar = document.getElementById('toolBar');
  const R = window.TacoRoutes;
  if (!bar || !R?.NAV_GROUPS) return;
  if (bar.dataset.built === '1') return;

  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  bar.innerHTML =
    '<div class="tool-bar-groups">' +
    R.NAV_GROUPS.map(
      (g) =>
        `<div class="tool-bar-group" data-group="${esc(g.key)}">` +
        `<button type="button" class="tool-bar-btn" data-tool-bar-toggle="${esc(g.key)}" aria-expanded="false" aria-haspopup="true">` +
        `${esc(g.label)}<span class="tool-bar-caret" aria-hidden="true">▾</span></button>` +
        `<div class="tool-bar-menu" data-group-menu="${esc(g.key)}" hidden>` +
        g.views
          .map((v) => {
            // navEntryFor, not VIEW_ROUTES: `team` has no fixed route and was
            // being silently dropped from this bar -- the league page, missing
            // from the menu that is supposed to contain it.
            const entry = R.navEntryFor ? R.navEntryFor(v) : null;
            return entry
              ? `<a class="tool-bar-item" href="${esc(entry.href)}" data-view="${esc(v)}">${esc(entry.label)}</a>`
              : '';
          })
          .join('') +
        '</div></div>',
    ).join('') +
    '</div>' +
    '<div class="tool-bar-scope">' +
    '<span class="tool-bar-scope-label">Viewing</span>' +
    '<button type="button" class="tool-bar-scope-btn" id="toolBarLeagueLabel" data-taco-open-league-picker>Select a league<span class="tool-bar-caret" aria-hidden="true">▾</span></button>' +
    '<span class="tool-bar-scope-all" id="toolBarScopeAll" hidden></span>' +
    '</div>';

  bar.dataset.built = '1';
}
window.renderToolBar = renderToolBar;

function closeToolBarMenus(exceptKey) {
  document.querySelectorAll('[data-group-menu]').forEach((m) => {
    if (m.dataset.groupMenu === exceptKey) return;
    m.hidden = true;
  });
  document.querySelectorAll('[data-tool-bar-toggle]').forEach((b) => {
    if (b.dataset.toolBarToggle === exceptKey) return;
    b.setAttribute('aria-expanded', 'false');
  });
}
window.closeToolBarMenus = closeToolBarMenus;

/** Marks the section containing the current view, so the bar says where you are
 * rather than only where you can go. */
function syncToolBarActive(viewName) {
  const R = window.TacoRoutes;
  if (!R?.groupForView) return;
  const group = R.groupForView(viewName);
  document.querySelectorAll('.tool-bar-group').forEach((el) => {
    el.classList.toggle('active', !!group && el.dataset.group === group.key);
  });
  document.querySelectorAll('.tool-bar-item').forEach((a) => {
    a.classList.toggle('active', a.dataset.view === viewName);
  });
  // The scope switch says WHERE you are, so global-vs-league is never a guess.
  // On a single-league page (League Overview, League Rankings) it names that
  // league and lets you switch. On the whole-book home it says "All N leagues".
  // Everywhere else -- Game Day, Scouting, Trades -- it stays hidden rather than
  // make a scope claim about pages that are self-evidently whole-book or carry
  // their own in-page picker (the trade calc).
  const scopeEl = document.querySelector('.tool-bar-scope');
  if (scopeEl) {
    const R2 = window.TacoRoutes || {};
    const isLeagueScoped = R2.isLeagueScopedView ? R2.isLeagueScopedView(viewName) : false;
    const label = scopeEl.querySelector('.tool-bar-scope-label');
    const btn = document.getElementById('toolBarLeagueLabel');
    const allChip = document.getElementById('toolBarScopeAll');
    if (isLeagueScoped) {
      scopeEl.hidden = false;
      if (label) label.hidden = false;
      if (allChip) allChip.hidden = true;
      if (btn) {
        btn.hidden = false;
        const lg = (STATE.leagues || [])[STATE.currentTeamIdx];
        const name = lg && lg.name ? lg.name : null;
        btn.innerHTML =
          (name ? escapeHtml(name) : 'Select a league') +
          '<span class="tool-bar-caret" aria-hidden="true">▾</span>';
      }
    } else if (viewName === 'overview') {
      scopeEl.hidden = false;
      if (label) label.hidden = true;
      if (btn) btn.hidden = true;
      if (allChip) {
        allChip.hidden = false;
        const n = (STATE.leagues || []).length;
        allChip.textContent = n ? 'All ' + n + ' leagues' : 'All leagues';
      }
    } else {
      scopeEl.hidden = true;
    }
  }
}
window.syncToolBarActive = syncToolBarActive;

document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-tool-bar-toggle]');
  if (toggle) {
    e.preventDefault();
    const key = toggle.dataset.toolBarToggle;
    const menu = document.querySelector(`[data-group-menu="${key}"]`);
    const wasOpen = menu && !menu.hidden;
    closeToolBarMenus();
    if (menu && !wasOpen) {
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }
    return;
  }
  // Any click elsewhere, including on a menu item, closes the menus.
  closeToolBarMenus();
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeToolBarMenus();
});

// Mobile section menu -- the phone half of the moment model.
//
// A bottom tab used to navigate straight to its section's first tool, and the
// strip meant to list the rest (#groupSubNav) is hidden at every width, so Who
// You Need, Injuries, Trade Finder and most of Scouting had no mobile path at
// all. Owen, 2026-09-13: tapping a tab "just highlights them".
//
// Full screen rather than a floating card, per the 2026-09-12 nav plan: a
// partial overlay floats over a dimmed page and reads as provisional, while a
// committed screen with real rows reads as the place you navigate from. The
// league switcher is pinned at the top because scope is the axis single-league
// tools do not have.

// Text glyphs, not emoji, so they take the theme colour. U+FE0E asks iOS for the
// text presentation of the few (flag, gear, star) it would otherwise render as
// colour emoji.
const MOBILE_GROUP_ICONS = {
  scoreboard: '◷',
  rooting: '⚑',
  injuries: '✚',
  lineups: '⇅',
  overview: '▤',
  team: '⌂',
  roster: '▦',
  leagueTeams: '≡',
  leagueRosters: '▦',  trade: '⇄',
  tradeFinder: '⌕',
  tradeHistory: '↺',
  rankings: '★',
  advancedStats: '≣',
  myAssets: '◧',
  waiverWire: '+',
  drafts: '▣',
  marketRadar: '◎',
  dossier: '☷',
  leagueScout: '⚐',
  commish: '⚖',
  investigator: '☰',
};

function renderMobileGroupSheet(key) {
  const sheet = document.getElementById('mobileGroupSheet');
  const R = window.TacoRoutes;
  if (!sheet || !R?.NAV_GROUPS) return null;
  const group = R.NAV_GROUPS.find((g) => g.key === key);
  if (!group) return null;

  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const activeId = document.querySelector('.view.active')?.id || '';
  const leagues = STATE.leagues || [];
  const lg = leagues[STATE.currentTeamIdx];

  const scope =
    leagues.length > 1 && group.scoped
      ? '<button type="button" class="mobile-group-scope" data-taco-open-league-picker>' +
        '<span class="mobile-group-scope-label">League</span>' +
        '<span class="mobile-group-scope-name">' + esc(lg ? lg.name : 'All leagues') + '</span>' +
        '<span class="mobile-group-chev" aria-hidden="true">▾</span>' +
        '</button>'
      : '';

  const rows = group.views
    .map((v) => {
      const entry = R.navEntryFor ? R.navEntryFor(v) : null;
      if (!entry) return '';
      const on = activeId === v + 'View';
      // data-router: the router navigates these like any in-app link, including
      // resolving `team` to the selected league.
      return (
        '<a class="mobile-group-link' + (on ? ' active' : '') + '" href="' + esc(entry.href) + '"' +
        ' data-router data-view="' + esc(v) + '"' + (on ? ' aria-current="page"' : '') + '>' +
        '<span class="mobile-group-icon" aria-hidden="true">' + (MOBILE_GROUP_ICONS[v] || '•') + '︎</span>' +
        '<span class="mobile-group-label">' + esc(entry.label) + '</span>' +
        '<span class="mobile-group-chev" aria-hidden="true">›</span>' +
        '</a>'
      );
    })
    .join('');

  sheet.innerHTML =
    '<div class="mobile-group-head">' +
    '<h2 class="mobile-group-title">' + esc(group.label) + '</h2>' +
    '<button type="button" class="mobile-group-close" aria-label="Close menu">×</button>' +
    '</div>' +
    scope +
    '<div class="mobile-group-list">' + rows + '</div>';
  return sheet;
}

function openMobileGroupSheet(key) {
  const sheet = renderMobileGroupSheet(key);
  if (!sheet) return;
  sheet.dataset.group = key;
  sheet.hidden = false;
  sheet.scrollTop = 0;
  document.body.classList.add('mobile-group-open');
  document.querySelectorAll('.mobile-nav-tab[data-nav-group]').forEach((t) => {
    t.setAttribute('aria-expanded', String(t.dataset.navGroup === key));
  });
}

function closeMobileGroupSheet() {
  const sheet = document.getElementById('mobileGroupSheet');
  if (!sheet || sheet.hidden) return;
  sheet.hidden = true;
  delete sheet.dataset.group;
  document.body.classList.remove('mobile-group-open');
  document.querySelectorAll('.mobile-nav-tab[data-nav-group]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
}
window.openMobileGroupSheet = openMobileGroupSheet;
window.closeMobileGroupSheet = closeMobileGroupSheet;

document.addEventListener('click', (e) => {
  const tab = e.target.closest('.mobile-nav-tab[data-nav-group]');
  if (tab) {
    // The router deliberately does not claim these (see 43-router.js); the href
    // only matters with JS off.
    e.preventDefault();
    const sheet = document.getElementById('mobileGroupSheet');
    if (sheet && !sheet.hidden && sheet.dataset.group === tab.dataset.navGroup) closeMobileGroupSheet();
    else openMobileGroupSheet(tab.dataset.navGroup);
    return;
  }
  // A tap on the menu's own background or heading keeps it open. A row (which
  // the router is navigating at this same moment), the close button, the league
  // switcher (whose picker opens over the page) and anything outside close it.
  if (e.target.closest('#mobileGroupSheet') && !e.target.closest('a, button')) return;
  closeMobileGroupSheet();
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeMobileGroupSheet();
});

// Section guides (Scouting and Trades briefs, 2026-09-27): each page in a
// section says in a line what it is for, so nobody has to open all of them to
// find out that Rankings is values and Market Radar is trades, or that Trades
// runs find -> price -> review. Built once, here, rather than pasted per view.
// Every tab gets them now (Owen, 2026-09-30: Scouting was the only tab with
// pills to move between its pages). A fifth entry adds link attributes:
// League Overview's link is stateful, so it goes through data-view="team".
const SECTION_GUIDES = [
  { label: 'Command Center pages', pages: [
    ['overviewView', '/portfolio', 'All Leagues', 'every league at a glance'],
    ['teamView', '/portfolio', 'League Overview', 'one league in depth', ' data-view="team"'],
    ['leagueRostersView', '/tools/rosters', 'Rosters', 'every team, roster and picks'],
    ['leagueTeamsView', '/tools/league-view', 'League Rankings', 'every team ranked'],
    ['myAssetsView', '/tools/assets', 'Assets & Exposure', 'who you own everywhere'],
  ] },
  { label: 'Game Day pages', pages: [
    ['scoreboardView', '/tools/slate', 'The Slate', 'every matchup this week'],
    ['lineupsView', '/tools/lineups', 'Lineup Sweep', 'fix your lineups'],
    ['rootingView', '/tools/who-you-need', 'Makers & Breakers', 'who you need to score'],
    ['injuriesView', '/tools/injuries', 'Injury Report', 'who is hurt'],
    ['waiverWireView', '/tools/waivers', 'Waivers', 'who to pick up'],
  ] },
  { label: 'Trades pages', pages: [
    ['tradeFinderView', '/tools/trade-finder', '1 · Trade Finder', 'find a fair deal'],
    ['tradeView', '/tools/trade-calculator', '2 · Trade Calculator', 'price any deal'],
    ['tradeHistoryView', '/tools/trade-history', '3 · Trade History', 'review what happened'],
  ] },
  { label: 'Scouting pages', pages: [
    ['rankingsView', '/tools/rankings', 'Rankings', 'values for a format'],
    ['marketRadarView', '/tools/market-radar', 'Market Radar', 'what is moving on trades'],
    ['advancedStatsView', '/tools/advanced-stats', 'Advanced Stats', 'usage and role'],
    ['draftsView', '/tools/drafts', 'Active Drafts', 'live pick help'],
  ] },
  // Keep in step with NAV_GROUPS in shared/routes.mjs -- this list is a
  // second place the same pages are named, and the Manager Board sat here
  // for a render after it had been folded into the Dossier everywhere else.
  { label: 'War Room pages', pages: [
    ['dossierView', '/tools/dossier', 'Manager Dossier', 'every manager, profiled'],
    ['leagueScoutView', '/tools/league-scout', 'League Scout', 'any league, scouted'],
    ['commishView', '/tools/commish', 'Commish Desk', 'for the commissioner'],
  ] },
];
function mountSectionGuides() {
  for (const group of SECTION_GUIDES) {
    for (const [viewId] of group.pages) {
      const view = document.getElementById(viewId);
      if (!view || view.querySelector('.scout-guide')) continue;
      const nav = document.createElement('nav');
      nav.className = 'scout-guide section-pills';
      nav.setAttribute('aria-label', group.label);
      nav.innerHTML = group.pages.map(([id, href, name, what, attrs]) =>
        '<a data-router href="' + href + '"' + (attrs || '') + (id === viewId ? ' aria-current="page" class="active"' : '') +
        '><b>' + name + '</b><span>' + what + '</span></a>').join('');
      view.insertBefore(nav, view.firstChild);
    }
  }
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountSectionGuides);
else mountSectionGuides();

;
/*! ==== 69-taco-click-delegation.js ==== */
// Shared click delegation for player/owner/jump/trade/proposal/pill/shell actions.

(function wireTacoClickDelegation() {
  if (wireTacoClickDelegation._wired) return;
  wireTacoClickDelegation._wired = true;

  const pillHandlers = {
    setTradeHistoryFilter: (key) => setTradeHistoryFilter(key),
    setRankingsFilter: (key) => setRankingsFilter(key),
    setMyAssetsFilter: (key) => setMyAssetsFilter(key),
    setMyAssetsSort: (key) => setMyAssetsSort(key),
    setWaiverWireFilter: (key) => setWaiverWireFilter(key),
    setWaiverWireSort: (key) => setWaiverWireSort(key),
  };

  // ---- Keyboard access for delegated click targets -------------------------
  //
  // Every interactive thing in this app is a plain <div> carrying a data-*
  // attribute, activated by the delegated click listener below. That works for
  // a mouse and for nothing else: measured on /tools/rankings, 56 of 56
  // clickable elements were unreachable by keyboard -- no tabindex, no role,
  // no focus style. Opening a player drawer was impossible without a pointer,
  // which fails WCAG 2.1.1 Keyboard (Level A).
  //
  // Fixed centrally rather than in the ~20 templates that emit these, because
  // the templates are strings scattered across modules and a per-template fix
  // would be wrong again the first time someone adds a new row type. This
  // promotes them as they appear: anything matching a delegated selector gets
  // tabindex="0" and role="button" if it does not already carry a role, and
  // Enter/Space activate it the same way a click does.
  // Attribute selectors are EXACT: '[data-taco-jump]' does not match
  // data-taco-jump-league. That is how a dozen delegated controls -- every
  // column sort on Advanced Stats, picking assets into the trade calculator,
  // expanding a team on League Rankings -- ended up mouse-only, with no tab
  // stop and no Enter/Space (2026-10-16). Anything given a delegated click
  // handler belongs in this list.
  const CLICKABLE_SELECTOR = [
    '[data-taco-player]', '[data-taco-owner]', '[data-taco-trade]', '[data-taco-jump]',
    '[data-taco-pill]', '[data-taco-pill-fn]', '[data-ma-player]', '[data-pd-player]',
    '[data-strip-toggle]', '[data-team-tab]', '[data-pr-sort]', '[data-pr-basis]',
    '[data-pr-expand-all]', '[data-pr-collapse-all]', '[data-th-show-more]', '[data-th-refresh]',
    '[data-adv-sort]', '[data-adv-player]', '[data-pr-toggle]', '[data-tc-asset]',
    '[data-injury-toggle]', '[data-ry-player]', '[data-pd-jump-league]',
    '[data-taco-jump-league]', '[data-ma-jump-league]', '[data-lcb-back]',
    '[data-slate-fix]', '[data-taco-realized]', '[data-taco-manager]', '[data-dos-tab]', '[data-dos-page]', '[data-dos-season]',
  ].join(',');

  function promoteForKeyboard(root) {
    const scope = root && root.querySelectorAll ? root : document;
    let list;
    try { list = scope.querySelectorAll(CLICKABLE_SELECTOR); } catch (_e) { return; }
    for (const el of list) {
      // Native controls are already reachable; don't fight them.
      const tag = el.tagName;
      if (tag === 'BUTTON' || tag === 'A' || tag === 'INPUT' || tag === 'SELECT' || tag === 'TEXTAREA') continue;
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      if (!el.hasAttribute('role')) el.setAttribute('role', 'button');
    }
  }

  // Re-render replaces whole subtrees, so watch rather than run once.
  const mo = new MutationObserver((records) => {
    for (const r of records) {
      for (const node of r.addedNodes) {
        if (node.nodeType !== 1) continue;
        promoteForKeyboard(node);
        if (node.matches && node.matches(CLICKABLE_SELECTOR)) promoteForKeyboard(node.parentNode || document);
      }
    }
  });
  const startObserving = () => {
    promoteForKeyboard(document);
    mo.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObserving);
  else startObserving();

  // Enter and Space activate, matching native button behaviour. Space is
  // preventDefault'd so the page does not scroll out from under the user.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    const el = e.target;
    if (!el || !el.closest) return;
    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') return;
    if (el.getAttribute('role') !== 'button') return;
    if (!el.matches(CLICKABLE_SELECTOR)) return;
    e.preventDefault();
    el.click();
  });

  // Broken avatar images. Was three different inline onerror="" snippets on
  // every rendered <img>; inline handlers are what force a CSP to allow
  // 'unsafe-hashes', so they had to go for script-src to be enforceable.
  //
  // Capture phase because error events from <img> do not bubble.
  document.addEventListener('error', (e) => {
    const img = e.target;
    if (!img || img.tagName !== 'IMG') return;
    const mode = img.getAttribute('data-img-fallback');
    if (!mode) return;
    if (mode === 'silhouette') {
      if (img.parentElement) img.parentElement.classList.add('silhouette');
      img.remove();
    } else if (mode === 'avatar') {
      if (img.parentNode && img.parentNode.classList) img.parentNode.classList.add('avatar-fallback');
      img.remove();
    } else {
      img.style.display = 'none';
    }
  }, true);

  // Former inline on* attributes, moved to delegation.
  //
  // Four of these existed (two in index.html, two emitted by render
  // templates). Inline handlers are the single thing that forces a CSP to
  // carry 'unsafe-hashes' on top of 'unsafe-inline', so removing them is what
  // lets script-src be enforced with nothing but 'self' plus per-script
  // hashes. They were also the last two entries in the inline-handler audit.
  document.addEventListener('input', (e) => {
    const search = e.target.closest('[data-taco-unified-search]');
    if (search && typeof onUnifiedSearchInput === 'function') {
      onUnifiedSearchInput(search.value);
    }
    const tradeSearch = e.target.closest('[data-taco-trade-search]');
    if (tradeSearch && typeof filterTradeSide === 'function') {
      filterTradeSide(tradeSearch.dataset.tacoTradeSearch, tradeSearch.value);
    }
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-taco-show-setup]')) {
      if (typeof showSetup === 'function') showSetup();
      return;
    }
    // "How it played out" on a trade row: load that league's played weeks,
    // then redraw. Every trade from the league gets its grade at once, so the
    // button is a one-time cost per league rather than per row.
    // A manager from search: their cross-league profile.
    const manager = e.target.closest('[data-taco-manager]');
    if (manager && typeof openManagerDrawer === 'function') {
      openManagerDrawer(manager.dataset.tacoManager);
      const box = document.getElementById('unifiedSearchResults');
      if (box) { box.style.display = 'none'; box.innerHTML = ''; }
      return;
    }
    const realized = e.target.closest('[data-taco-realized]');
    if (realized && typeof loadRealizedTradeContext === 'function') {
      const leagueId = realized.dataset.tacoRealized;
      const lg = STATE.leagues.find((l) => l.league_id === leagueId);
      if (lg) {
        realized.disabled = true;
        realized.textContent = 'Checking the box scores…';
        loadRealizedTradeContext(lg)
          .then(() => { if (typeof renderTradeHistoryView === 'function') renderTradeHistoryView(); })
          .catch((err) => {
            console.warn('[realized] load failed', err.message);
            realized.disabled = false;
            realized.textContent = 'How it played out';
          });
      }
      return;
    }
    const share = e.target.closest('[data-taco-share]');
    if (share) {
      const which = share.dataset.tacoShare;
      if (which === 'weekRecap' && typeof shareWeekRecap === 'function') {
        shareWeekRecap(share);
        return;
      }
      if (which === 'myReportCard' && typeof window.shareMyReportCard === 'function') window.shareMyReportCard(share);
      if (which === 'leagueRankings' && typeof window.shareLeagueRankings === 'function') window.shareLeagueRankings(share);
    }
  });

  document.addEventListener('change', (e) => {
    const sortEl = e.target.closest('[data-taco-sort]');
    if (sortEl?.dataset.tacoSort) {
      const fn = window[sortEl.dataset.tacoSort];
      if (typeof fn === 'function') fn(sortEl.value);
    }
    if (e.target.closest('[data-taco-settings-toggle-toasts]')) {
      settingsToggleToasts(e.target.checked);
    }
  });

  document.addEventListener('click', (e) => {
    // "Open in Sleeper" button (14-render-team-detail.js) -- rendered since
    // early on but never actually wired to anything; confirmed live the
    // click did nothing at all. sleeper.com/leagues/{id}/league is Sleeper's
    // own real league URL format.
    const sleeperOpen = e.target.closest('[data-sleeper-league-open]');
    if (sleeperOpen?.dataset.sleeperLeagueOpen) {
      window.open(`https://sleeper.com/leagues/${sleeperOpen.dataset.sleeperLeagueOpen}/league`, '_blank', 'noopener,noreferrer');
      return;
    }

    const proposal = e.target.closest('[data-taco-proposal]');
    if (proposal?.dataset.tacoProposal) {
      loadProposedTrade(proposal.dataset.tacoProposal);
      return;
    }

    const posToggle = e.target.closest('[data-tc-pos-toggle]');
    if (posToggle) {
      toggleTradeGroup(posToggle.getAttribute('data-tc-pos-toggle'));
      return;
    }

    const asset = e.target.closest('[data-tc-asset]');
    if (asset?.dataset.tcAsset) {
      const [side, key] = asset.dataset.tcAsset.split('|');
      if (side && key) toggleAsset(side, key);
      return;
    }

    const pillFn = e.target.closest('[data-taco-pill-fn]');
    if (pillFn?.dataset.tacoPillFn) {
      const fn = window[pillFn.dataset.tacoPillFn];
      if (typeof fn === 'function') fn();
      return;
    }

    const pill = e.target.closest('[data-taco-pill]');
    if (pill?.dataset.tacoPill) {
      const pipe = pill.dataset.tacoPill.indexOf('|');
      if (pipe > 0) {
        const handler = pill.dataset.tacoPill.slice(0, pipe);
        const key = pill.dataset.tacoPill.slice(pipe + 1);
        const fn = pillHandlers[handler] || window[handler];
        if (typeof fn === 'function') fn(key);
      }
      return;
    }

    const statsSeason = e.target.closest('[data-stats-season]');
    if (statsSeason?.dataset.statsSeason) {
      const [pid, season] = statsSeason.dataset.statsSeason.split('|');
      if (pid && season) setStatsSeason(pid, Number(season));
      return;
    }

    const leagueFocus = e.target.closest('[data-league-focus]');
    if (leagueFocus && typeof applyLeagueFocus === 'function') {
      STATE.leagueFocus = leagueFocus.dataset.leagueFocus;
      applyLeagueFocus();
      return;
    }

    const leaguePick = e.target.closest('[data-league-pick]');
    if (leaguePick?.dataset.leaguePick != null) {
      pickLeague(Number(leaguePick.dataset.leaguePick));
      return;
    }

    const stripToggle = e.target.closest('[data-strip-toggle]');
    if (stripToggle?.dataset.stripToggle != null) {
      toggleStrip(Number(stripToggle.dataset.stripToggle));
      return;
    }

    if (e.target.closest('[data-th-refresh]')) {
      refreshTradeHistory();
      return;
    }
    if (e.target.closest('[data-th-show-more]')) {
      showMoreTradeHistory();
      return;
    }
    if (e.target.closest('[data-news-refresh]')) {
      refreshNews();
      return;
    }
    if (e.target.closest('[data-portfolio-sort-dir]')) {
      togglePortfolioSortDir();
      return;
    }
    if (e.target.closest('[data-profile-refresh]')) {
      closeProfileDrawer();
      document.getElementById('statusRefreshBtn')?.click();
      return;
    }
    if (e.target.closest('[data-profile-switch]')) {
      profileSwitchUser();
      return;
    }
    if (e.target.closest('[data-pick-sim-clear]')) {
      const id = e.target.closest('[data-pick-sim-clear]').dataset.pickSimClear;
      if (id) clearPickSim(id);
      return;
    }
    const copyShare = e.target.closest('[data-copy-trade-share]');
    if (copyShare) {
      copyTradeShareLink(copyShare);
      return;
    }
    if (e.target.closest('[data-require-league]')) {
      if (requireLeagueSelection({ force: true }) && typeof renderTeamDetail === 'function') renderTeamDetail();
      return;
    }

    if (e.target.closest('[data-lcb-back]')) {
      showView('team');
      return;
    }
    const lcbPivot = e.target.closest('[data-lcb-pivot]');
    if (lcbPivot?.dataset.lcbPivot) {
      const bar = lcbPivot.closest('[data-lcb-league]');
      const leagueId = bar?.dataset.lcbLeague;
      if (lcbPivot.dataset.lcbPivot === 'team') showView('team');
      else if (lcbPivot.dataset.lcbPivot === 'trade') jumpToTrade(STATE.currentTeamIdx);
      else if (lcbPivot.dataset.lcbPivot === 'tradeHistory' && leagueId) jumpToTradeHistoryForLeague(leagueId);
      return;
    }

    if (e.target.closest('[data-taco-open-glossary]')) {
      openGlossary();
      closeSiteDrawer();
      return;
    }
    if (e.target.closest('[data-taco-close-glossary]')) {
      closeGlossary();
      return;
    }
    if (e.target.closest('[data-taco-open-profile]')) {
      openProfileDrawer();
      return;
    }
    if (e.target.closest('[data-taco-close-profile]')) {
      closeProfileDrawer();
      return;
    }
    if (e.target.closest('[data-taco-settings-save-sleeper]')) {
      settingsSaveSleeper();
      return;
    }

    if (e.target.closest('[data-taco-settings-sign-out]')) {
      settingsSignOut();
      return;
    }

    const archChip = e.target.closest('[data-taco-arch-filter]');
    if (archChip) {
      toggleOverviewArchetype(archChip.getAttribute('data-taco-arch-filter'));
      return;
    }
    if (e.target.closest('[data-taco-arch-filter-clear]')) {
      clearOverviewArchetypes();
      return;
    }

    const checkoutBtn = e.target.closest('[data-taco-checkout]');
    if (checkoutBtn) {
      checkoutBtn.disabled = true;
      settingsCheckout(checkoutBtn.getAttribute('data-taco-checkout'));
      setTimeout(function () { checkoutBtn.disabled = false; }, 4000);
      return;
    }

    if (e.target.closest('[data-taco-billing-portal]')) {
      settingsBillingPortal();
      return;
    }

    if (e.target.closest('[data-taco-open-settings]')) {
      openSettingsPanel();
      return;
    }
    if (e.target.closest('[data-taco-close-settings]')) {
      closeSettingsPanel();
      return;
    }    if (e.target.closest('[data-taco-close-site-drawer]')) {
      closeSiteDrawer();
      return;
    }
    if (e.target.closest('[data-taco-close-mobile-more]')) {
      closeMobileMoreSheet();
      return;
    }
    if (e.target.closest('[data-taco-open-league-picker]')) {
      e.stopPropagation();
      openLeaguePicker();
      return;
    }
    if (e.target.closest('[data-taco-close-league-picker]')) {
      closeLeaguePicker();
      return;
    }
    if (e.target.closest('[data-strip-expand-all]')) {
      expandAllStrips();
      return;
    }
    if (e.target.closest('[data-strip-collapse-all]')) {
      collapseAllStrips();
      return;
    }
    if (e.target.closest('[data-ld-rail-expand]')) {
      expandLiveDraftRoom();
      return;
    }
    if (e.target.closest('[data-pd-overlay-close]')) {
      closePlayerDrawer();
      return;
    }
    if (e.target.closest('[data-info-close]')) {
      closeInfoModal();
      return;
    }

    const player = e.target.closest('[data-taco-player]');
    if (player?.dataset.tacoPlayer) {
      e.stopPropagation();
      openPlayerDrawer(player.dataset.tacoPlayer, player.dataset.tacoTab || null);
      return;
    }

    const owner = e.target.closest('[data-taco-owner]');
    if (owner?.dataset.tacoOwner) {
      e.stopPropagation();
      const [leagueId, rosterId] = owner.dataset.tacoOwner.split('|');
      if (leagueId && rosterId != null) openOwnerDrawer(leagueId, rosterId);
      return;
    }

    const jump = e.target.closest('[data-taco-jump-league]');
    if (jump?.dataset.tacoJumpLeague) {
      jumpToTeamByLeagueId(jump.dataset.tacoJumpLeague);
      if (jump.hasAttribute('data-taco-clear-search')) {
        const inp = document.getElementById('leagueSearchInput');
        if (inp) inp.value = '';
        if (typeof onUnifiedSearchInput === 'function') onUnifiedSearchInput('');
      }
      return;
    }

    const trade = e.target.closest('[data-taco-trade]');
    if (trade?.dataset.tacoTrade) {
      e.stopPropagation();
      const [lgIdx, rosterId] = trade.dataset.tacoTrade.split('|');
      if (lgIdx !== '' && rosterId != null) jumpToTradeWith(Number(lgIdx), Number(rosterId));
      return;
    }

    const exposure = e.target.closest('[data-taco-open-exposure]');
    if (exposure) {
      openPortfolioExposureView();
      return;
    }

    const prRow = e.target.closest('[data-pr-toggle]');
    if (prRow?.dataset.prToggle != null) {
      togglePowerRankingRow(Number(prRow.dataset.prToggle));
      return;
    }

    const prBasis = e.target.closest('[data-pr-basis]');
    if (prBasis?.dataset.prBasis) {
      setPowerRankingsBasis(prBasis.dataset.prBasis);
      return;
    }

    const prSort = e.target.closest('[data-pr-sort]');
    if (prSort?.dataset.prSort) {
      setPowerRankingsSort(prSort.dataset.prSort);
      return;
    }

    if (e.target.closest('[data-pr-jump-me]')) {
      const mine = document.querySelector('.pr-row-mine');
      if (mine) {
        scrollIntoViewSafely(mine, { behavior: 'smooth', block: 'center' });
        mine.classList.remove('taco-focus-flash');
        void mine.offsetWidth; // restart the flash on a second tap
        mine.classList.add('taco-focus-flash');
        setTimeout(() => mine.classList.remove('taco-focus-flash'), 3200);
      }
      return;
    }
    if (e.target.closest('[data-pr-expand-all]')) {
      expandAllPowerRankings();
      return;
    }
    if (e.target.closest('[data-pr-collapse-all]')) {
      collapseAllPowerRankings();
      return;
    }

  });

  document.addEventListener('click', (e) => {
    const infoOverlay = e.target.closest('[data-info-overlay]');
    if (infoOverlay && e.target === infoOverlay) closeInfoModal(e);
    const profileOverlay = e.target.closest('[data-profile-overlay]');
    if (profileOverlay && e.target === profileOverlay) closeProfileDrawer(e);
    const settingsOverlay = e.target.closest('[data-settings-overlay]');
    if (settingsOverlay && e.target === settingsOverlay) closeSettingsPanel(e);
  });
})();

;
/*! ==== 43-router.js ==== */
// Path-based routing — real URLs with History API (logic in TacoRoutes bundle).

// Read the bundle LAZILY, per call. This used to be
//
//     const R = window.TacoRoutes || {};
//
// a single snapshot taken when this module is evaluated. If TacoRoutes was not
// on window at that instant, R stayed permanently {} for the life of the page,
// every parseAppPath returned {kind:'unknown'}, and the unknown branch of
// initRouter rewrote the address bar to '/'. The symptom is a deep link to
// /portfolio silently dumping the visitor on the marketing page — which is
// exactly what shared and bookmarked links do.
//
// A getter cannot go stale, so the failure mode cannot recur regardless of
// script ordering, caching, or a slow bundle.
const routes = () => window.TacoRoutes || {};

function parseAppPath(pathname) {
  const R = routes();
  return R.parseAppPath ? R.parseAppPath(pathname) : { kind: 'unavailable' };
}

function leaguePath(leagueId, tab) {
  const R = routes();
  return R.leaguePath ? R.leaguePath(leagueId, tab) : `/league/${leagueId}`;
}

function viewToPath(viewName) {
  const R = routes();
  if (R.viewToPath) {
    return R.viewToPath(viewName, {
      leagues: STATE.leagues,
      currentTeamIdx: STATE.currentTeamIdx,
      teamDetailTab: STATE.teamDetailTab,
    });
  }
  return null;
}

function isAppPath(pathname) {
  const R = routes();
  return R.isAppPath ? R.isAppPath(pathname) : false;
}

function scrollToLandingHash(hash) {
  if (!hash) return;
  const el = document.getElementById(hash);
  if (el) scrollIntoViewSafely(el, { behavior: 'smooth', block: 'start' });
}

function navigateLandingHash(href) {
  const R = routes();
  const split = R.splitPathAndHash ? R.splitPathAndHash(href) : { path: '/', hash: null };
  if (!split.hash) return false;
  const base = (split.path || '/').replace(/\/+$/, '') || '/';
  if (base !== '/' && base !== '') return false;

  if (typeof showLanding === 'function') showLanding();
  try {
    history.pushState(null, '', `/#${split.hash}`);
  } catch (_e) { /* ignore */ }
  requestAnimationFrame(() => scrollToLandingHash(split.hash));
  return true;
}

function trackPageView(path) {
  if (typeof gtag !== 'function') return;
  const pagePath = path || (location.pathname + location.search);
  gtag('event', 'page_view', {
    page_path: pagePath,
    page_location: window.location.origin + pagePath,
    page_title: document.title,
  });
}

/** Thin GA4 event wrapper — TACO-009. No-ops if gtag isn't loaded, same guard as trackPageView. */
function trackEvent(name, params) {
  if (typeof gtag !== 'function') return;
  gtag('event', name, params || {});
}
window.trackEvent = trackEvent;

/** Keep <link rel="canonical"> and robots honest as the SPA navigates.
 *
 * index.html is the shell for the landing page, /connect, and every app route.
 * A single static canonical in the HTML would therefore be wrong for all but
 * one of them, which is why there wasn't one at all — and with no canonical,
 * every app route was a separate indexable URL serving the same shell.
 *
 * Public surface (/ and /connect) is canonical to itself. Everything else is
 * a personal view of someone's leagues: it needs a Sleeper username to render
 * anything, has no content for a crawler, and shouldn't be in an index. Those
 * get noindex and canonical back to the landing page. */
const PUBLIC_PATHS = new Set(['/', '/connect']);

function syncSeoTags() {
  try {
    const path = location.pathname || '/';
    const isPublic = PUBLIC_PATHS.has(path);
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = 'https://thearmchairoffice.com' + (isPublic ? path : '/');

    let robots = document.querySelector('meta[name="robots"]');
    if (!isPublic) {
      if (!robots) {
        robots = document.createElement('meta');
        robots.name = 'robots';
        document.head.appendChild(robots);
      }
      robots.content = 'noindex, follow';
    } else if (robots) {
      robots.remove();
    }
  } catch (_e) { /* never let SEO tags break navigation */ }
}
window.syncSeoTags = syncSeoTags;

function syncUrlToView(viewName) {
  // Scouting keeps its own /scout URL. The league page it opens belongs to
  // someone else, and a /league/ address would reload into the viewer's own
  // portfolio instead of this league.
  if (STATE.scoutMode) return;
  const path = viewToPath(viewName);
  if (!path || location.pathname === path) return;
  // /u/<name> already means "this person's portfolio", so rewriting it to
  // /portfolio strips the only part of the URL that says whose book this is.
  // A visitor who arrived on a shared link could then no longer copy the
  // address bar and pass it on, and a bookmark taken after load would quietly
  // resolve to whoever that browser last looked at. This file already argues at
  // length that taking a visitor's URL away from them is the worse failure.
  if (viewName === 'overview' && parseAppPath(location.pathname).kind === 'user') return;
  try {
    history.pushState({ view: viewName }, '', path);
    syncSeoTags();
    trackPageView(path);
  } catch (_e) { /* ignore */ }
}

function migrateHashRoute() {
  const raw = (location.hash || '').replace(/^#/, '').replace(/^\//, '');
  if (!raw) return false;
  const parts = raw.split('/').filter(Boolean);
  let path = '/portfolio';
  if (!parts.length || parts[0] === 'overview') path = '/portfolio';
  else if (parts[0] === 'league' && parts[1]) path = `/league/${parts[1]}`;
  else if (parts[0] === 'assets') path = '/tools/assets';
  else if (parts[0] === 'waivers') path = '/tools/waivers';
  else return false;
  try {
    history.replaceState(null, '', path);
    location.hash = '';
  } catch (_e) { /* ignore */ }
  return true;
}

// A public player page (thearmchairoffice.com/player/<id>-<name>) links into
// the app as /portfolio?player=<id>. Read it the moment this script runs: a
// visitor with no username yet is sent to /connect first, which drops the
// query, and the player should still open once their leagues load.
(function capturePlayerDeepLink() {
  try {
    const id = new URLSearchParams(location.search).get('player');
    if (id && /^\d+$/.test(id)) sessionStorage.setItem('taco.openPlayer', id);
  } catch (_e) { /* storage blocked: the link just opens the portfolio */ }
})();

function openPendingPlayerDeepLink() {
  let id = null;
  try { id = sessionStorage.getItem('taco.openPlayer'); } catch (_e) { return; }
  if (!id) return;
  try { sessionStorage.removeItem('taco.openPlayer'); } catch (_e) { /* ignore */ }
  // The drawer reads the players database; wait for it (bounded).
  let tries = 0;
  const open = () => {
    if (STATE.playersDB || tries++ > 40) { if (typeof openPlayerDrawer === 'function') openPlayerDrawer(id); return; }
    setTimeout(open, 250);
  };
  setTimeout(open, 300);
}

function applyRouteFromPath() {
  if (!STATE.leagues?.length) return false;
  openPendingPlayerDeepLink();
  // An Action Queue link carries ?focus=<player>; keep it before the view sync
  // rewrites the address bar to the plain league path (applyLeagueFocus, 14).
  try {
    const focus = new URLSearchParams(location.search).get('focus');
    if (focus) STATE.leagueFocus = focus;
  } catch (_e) { /* ignore */ }
  migrateHashRoute();
  const route = parseAppPath(location.pathname);

  if (route.kind === 'league') {
    const idx = STATE.leagues.findIndex((l) => String(l.league_id) === String(route.leagueId));
    if (idx < 0) {
      showView('overview');
      return true;
    }
    STATE.currentTeamIdx = idx;

    // League Overview is the league's overview and nothing else (Owen,
    // 2026-10-18: "i also do not see the need to have an entire separate
    // version of the trade page there ... not a remake of our already
    // existing trade tab"). The old /league/<id>/trade and /trade-history
    // deep links rendered a second Trade Calculator and a second Trade
    // History INSIDE this page, and because STATE.teamDetailTab persisted,
    // one visit left League Overview showing a trade screen from then on --
    // which is what Owen hit. Those links now land on the real tabs with this
    // league already selected, so nothing that was shared or bookmarked
    // breaks.
    if (route.tab === 'trade') {
      if (typeof jumpToTrade === 'function') jumpToTrade(idx);
      else showView('trade');
      return true;
    }
    if (route.tab === 'tradeHistory') {
      STATE.tradeHistoryFilter = route.leagueId;
      showView('tradeHistory');
      return true;
    }

    STATE.teamDetailTab = route.tab || 'overview';
    showView('team');
    return true;
  }

  // A loaded /u/<name> is just the portfolio. The username did its work at boot
  // by choosing whose book to fetch; there is nothing further to route to.
  if (route.kind === 'user') {
    showView('overview');
    return true;
  }

  if (route.kind === 'view' && document.getElementById(route.view + 'View')) {
    showView(route.view);
    return true;
  }

  return false;
}

function syncToolsSidebar(viewName) {
  const sidebar = document.getElementById('toolsSidebar');
  if (!sidebar) return;

  const lg = STATE.leagues?.[STATE.currentTeamIdx];
  const leagueLabel = document.getElementById('sidebarLeagueLabel');
  if (leagueLabel) {
    leagueLabel.textContent = lg ? lg.name : 'Select league';
  }

  const leagueLinks = sidebar.querySelectorAll('[data-league-tab]');
  leagueLinks.forEach((el) => {
    const tab = el.dataset.leagueTab;
    const isTeam = viewName === 'team';
    const tabMatch = isTeam && (STATE.teamDetailTab || 'overview') === tab;
    el.classList.toggle('active', tabMatch);
    if (lg) el.href = leaguePath(lg.league_id, tab);
    else el.href = '/connect';
  });

  sidebar.querySelectorAll('[data-view]').forEach((el) => {
    const v = el.dataset.view;
    el.classList.toggle('active', v === viewName);
  });

  // Desktop quick-nav / mobile-bottom-nav .active state is handled once by
  // syncNavActiveState() (04-ui-helpers.js), called from showView() before
  // this function runs -- this used to be duplicated here too (TACO overhaul
  // Phase 1b). Only the href/label logic below is unique to this function.
  const quickLeague = document.getElementById('navTabLeagueQuick');
  if (quickLeague && lg && viewName === 'team') {
    const name = lg.name.length > 20 ? lg.name.slice(0, 18) + '…' : lg.name;
    quickLeague.textContent = name;
    quickLeague.href = leaguePath(lg.league_id, STATE.teamDetailTab || 'overview');
  } else if (quickLeague) {
    quickLeague.textContent = 'My Team';
  }

  const teamMobile = document.querySelector('.mobile-nav-tab[data-view="team"]');
  if (teamMobile) {
    teamMobile.href = lg ? leaguePath(lg.league_id, 'overview') : '/portfolio';
  }
}

function navigateFromLink(event, href) {
  if (event) event.preventDefault();
  const path = href || (event?.currentTarget?.getAttribute('href'));
  if (!path) return;

  const R = routes();
  if (R.isLandingHashLink && R.isLandingHashLink(path)) {
    navigateLandingHash(path);
    return;
  }

  if (path === '/' || path === '') {
    if (typeof showLanding === 'function') showLanding();
    history.pushState(null, '', '/');
    return;
  }
  if (path === '/connect') {
    if (typeof showSetup === 'function') showSetup();
    history.pushState(null, '', '/connect');
    return;
  }

  if (!STATE.leagues?.length) {
    STATE.pendingRoute = path;
    if (typeof showSetup === 'function') showSetup();
    history.pushState(null, '', '/connect');
    return;
  }

  const prev = location.pathname;
  history.pushState(null, '', path);
  trackPageView(path);
  if (!applyRouteFromPath()) {
    history.replaceState(null, '', prev);
  }
}

function onRouterClick(event) {
  try {
    onRouterClickInner(event);
  } catch (err) {
    console.error('[router] navigation failed:', err);
    // Was previously bouncing the user all the way back to the connect
    // screen (showSetup()) for what's usually a transient in-app nav error --
    // jarring, and it discarded their loaded session context in the UI for
    // no reason. A toast surfaces the failure without leaving the page they
    // were on. TACO overhaul Phase 2.
    if (typeof window.showToast === 'function') {
      window.showToast(err.message || 'Navigation failed. Try refreshing the page.', { type: 'error' });
    }
  }
}

function onRouterClickInner(event) {
  const link = event.target.closest([
    'a[data-router]',
    '.tools-sidebar a[href^="/"]',
    '.app-quick-nav a[href^="/"]',
    // .mobile-nav-tab is deliberately absent: a tab opens its section sheet
    // (42-site-chrome.js) instead of navigating.
    'a.tool-card[href^="/"]',
    'a.cta-primary[href^="/"]',
    'a.site-cta[href^="/"]',
    'a.site-drawer-cta[href^="/"]',
    'a.back-to-landing[href^="/"]',
    '.page-breadcrumb a[href^="/"]',
    'a.site-nav-link[href^="/"]',
    'a.site-drawer-link[href^="/"]',
    // Desktop overhead tool bar (42-site-chrome.js). These carry data-view but
    // no data-router, so without this line the browser followed the raw href
    // (team/roster resolve to /portfolio) and every Command tab bounced back to
    // All Leagues instead of the stateful view resolving below.
    '.tool-bar-menu a[href^="/"]',
  ].join(', '));
  if (!link || link.target === '_blank' || event.metaKey || event.ctrlKey || event.shiftKey) return;
  const href = link.getAttribute('href');
  if (!href || !href.startsWith('/')) return;
  if (/\.html?$/.test(href)) return;

  if (link.dataset.leagueTab) {
    event.preventDefault();
    if (!STATE.leagues?.length) {
      STATE.pendingLeagueTab = link.dataset.leagueTab;
      navigateFromLink(event, '/connect');
      return;
    }
    // Selects the first league when none is chosen; the picker only if none can open.
    if (!hasSelectedLeague() && !requireLeagueSelection()) {
      STATE.pendingLeagueTab = link.dataset.leagueTab;
      return;
    }
    const lg = STATE.leagues[STATE.currentTeamIdx];
    navigateFromLink(event, leaguePath(lg.league_id, link.dataset.leagueTab));
    return;
  }

  if (link.dataset.view === 'team') {
    event.preventDefault();
    if (!STATE.leagues?.length) {
      navigateFromLink(event, '/connect');
      return;
    }
    if (!hasSelectedLeague() && !requireLeagueSelection({ force: true })) {
      return;
    }
    const lg = STATE.leagues[STATE.currentTeamIdx];
    navigateFromLink(event, leaguePath(lg.league_id, STATE.teamDetailTab || 'overview'));
    return;
  }

  navigateFromLink(event, href);
}

/** Load a portfolio for this username, as if it had been typed and submitted.
 * Returns false when the connect form is not on the page to carry it. */
function bootWithUsername(name) {
  const input = document.getElementById('usernameInput');
  if (!name || !input || typeof loadEverything !== 'function') return false;
  input.value = name;
  if (typeof window.checkReady === 'function') window.checkReady();
  loadEverything();
  return true;
}
window.bootWithUsername = bootWithUsername;

/** The signed-in account's saved username, if one is known locally. */
function signedInUsername() {
  return typeof window.accountSleeperUsername === 'function' ? window.accountSleeperUsername() : null;
}

function initRouter() {
  if (!window.TacoRoutes) {
    console.error('[router] TacoRoutes bundle missing - rebuild with npm run build:values');
  }
  migrateHashRoute();
  document.addEventListener('click', onRouterClick);

  window.addEventListener('popstate', () => {
    trackPageView();
    const route = parseAppPath(location.pathname);
    if (route.kind === 'landing') { if (typeof showLanding === 'function') showLanding(); return; }
    if (route.kind === 'connect') { if (typeof showSetup === 'function') showSetup(); return; }
    // A scout page holds one league that is not the viewer's. Moving between it
    // and anything else is a full load, so the two never share STATE.leagues.
    if (route.kind === 'scout' || STATE.scoutMode) { location.reload(); return; }
    if (STATE.leagues?.length) applyRouteFromPath();
  });

  const route = parseAppPath(location.pathname);
  // Signed in with a Sleeper username on the account: the home page and the
  // connect form are both a step they have already done, so go straight to the
  // portfolio. Fresh loads only -- clicking "Enter the Office" or the logo later
  // is an in-app navigation and never passes through here.
  if (route.kind === 'connect' || route.kind === 'landing') {
    if (bootWithUsername(signedInUsername())) return;
  }
  if (route.kind === 'connect') {
    if (typeof showSetup === 'function') showSetup();
    return;
  }
  if (route.kind === 'landing') {
    if (location.pathname !== '/') history.replaceState(null, '', '/');
    if (typeof showLanding === 'function') showLanding();
    if (location.hash) {
      requestAnimationFrame(() => scrollToLandingHash(location.hash.replace(/^#/, '')));
    }
    return;
  }
  // Routing data missing, as opposed to a path we understand and reject.
  //
  // These two used to be the same branch, and that is what made the failure
  // silent: if TacoRoutes was not ready, every path — including a perfectly
  // valid /portfolio — looked "unknown", so the router rewrote the address bar
  // to '/' and showed the marketing page. Losing the visitor's URL because our
  // own bundle was slow is strictly worse than showing them nothing yet, and
  // it is indistinguishable from the app deciding their link was bad.
  //
  // So: say so loudly, leave the URL alone, and still try to boot.
  if (route.kind === 'unavailable') {
    console.error('[router] TacoRoutes unavailable at boot - leaving the URL alone rather than rewriting it to /');
    const savedName = (() => { try { return localStorage.getItem('fo_username'); } catch (_e) { return null; } })();
    if (savedName && document.getElementById('usernameInput') && typeof loadEverything === 'function') {
      STATE.pendingRoute = location.pathname;
      document.getElementById('usernameInput').value = savedName;
      if (typeof window.checkReady === 'function') window.checkReady();
      loadEverything();
    } else if (typeof showLanding === 'function') {
      showLanding();
    }
    return;
  }

  // Unknown path: show the landing page AND correct the address bar.
  //
  // Cloudflare Pages cannot answer a real 404 for this project without
  // breaking every app route -- verified on a preview deployment, where
  // adding a 404.html made /connect, /portfolio, /tools/* and /league/* all
  // 404, because Pages ignores 200-rewrites here and SPA routing depends
  // entirely on its index.html fallback. A plain 301 rule in the same file
  // works, so the file is read; it is rewrites specifically that do not.
  //
  // So the status stays 200 and the handling moves here. Crawlers are already
  // covered -- syncSeoTags marks every non-public path noindex -- and this is
  // the user-facing half: land them on a real page instead of leaving a
  // mistyped URL in the address bar pretending to be somewhere.
  // Scouting boots without a username by design, before any saved username is
  // replayed below (see parseAppPath).
  if (route.kind === 'scout') {
    if (typeof loadScoutLeague === 'function') loadScoutLeague(route.leagueId, { invalid: !!route.invalid });
    return;
  }
  if (route.kind === 'unknown') {
    if (location.pathname !== '/') history.replaceState(null, '', '/');
    if (typeof syncSeoTags === 'function') syncSeoTags();
    if (typeof showLanding === 'function') showLanding();
    return;
  }
  if (isAppPath(location.pathname)) {
    STATE.pendingRoute = location.pathname;
    // A /u/<name> link names its own user, and that beats whatever this browser
    // last looked at. Otherwise a shared link would silently show the recipient
    // their own book under someone else's URL -- the worst possible failure,
    // because it looks like it worked.
    const linked = route.kind === 'user' ? route.username : null;
    const saved = linked
      || (() => { try { return localStorage.getItem('fo_username'); } catch (_e) { return null; } })()
      || signedInUsername();
    if (saved && document.getElementById('usernameInput')) {
      document.getElementById('usernameInput').value = saved;
      if (typeof window.checkReady === 'function') window.checkReady();
      loadEverything();
    } else {
      if (typeof showSetup === 'function') showSetup();
      history.replaceState(null, '', '/connect');
    }
  }
}

window.applyRouteFromPath = applyRouteFromPath;
window.applyRouteFromHash = applyRouteFromPath;
window.syncUrlToView = syncUrlToView;

// initial SEO tags — pushState only fires on navigation, so the first painted
// route would otherwise keep whatever (nothing) the shell shipped with.
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", syncSeoTags);
else syncSeoTags();
window.syncToolsSidebar = syncToolsSidebar;
window.navigateFromLink = navigateFromLink;
window.viewToPath = viewToPath;
window.trackPageView = trackPageView;
window.initRouter = initRouter;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRouter);
} else {
  initRouter();
}
;
/*! ==== 82-toast-notifications.js ==== */
// Toast notifications -- lightweight, stacked, auto-dismissing confirmations
// and errors for actions the user just took (trade saved, background fetch
// failed, etc.). TACO overhaul Phase 2: closes a real gap -- showError()/
// #errorSlot (04-ui-helpers.js) only ever covered the initial Sleeper-connect
// flow; every later failure (trade save, drawer fetch, background
// hydration) had no user-visible path at all before this. Client-side,
// action-triggered only -- not push/server-driven notifications (see
// site_design_document's "no real-time notifications" non-goal, which this
// does not touch).

const TOAST_DEFAULT_DURATION_MS = 4500;

function ensureToastContainer() {
  let el = document.getElementById('toastContainer');
  if (!el) {
    el = document.createElement('div');
    el.id = 'toastContainer';
    el.className = 'toast-container';
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');
    document.body.appendChild(el);
  }
  return el;
}

/** Show a stacked, auto-dismissing toast.
 * opts.type: 'success' | 'error' | 'info' (default 'info').
 * opts.duration: ms before auto-dismiss (default 4500; 0 = stays until the
 * user closes it manually).
 * opts.action: { label, onClick } -- one button (e.g. Undo) that runs onClick
 * and closes the toast.
 * Returns the toast's DOM element (rarely needed by callers). */
function showToast(message, opts = {}) {
  // Settings panel preference (TACO overhaul Phase 3) -- respected here so
  // every call site stays a plain showToast() call, no per-caller check
  // needed. settingsToastsEnabled defaults true when the settings module
  // hasn't run yet for any reason, so toasts fail open, not silently off.
  if (typeof window.settingsToastsEnabled === 'function' && !window.settingsToastsEnabled()) {
    return null;
  }
  const type = opts.type === 'success' || opts.type === 'error' ? opts.type : 'info';
  const duration = opts.duration ?? TOAST_DEFAULT_DURATION_MS;
  const container = ensureToastContainer();

  const el = document.createElement('div');
  el.className = `toast toast-${type}`;
  el.setAttribute('role', type === 'error' ? 'alert' : 'status');

  const msgEl = document.createElement('span');
  msgEl.className = 'toast-message';
  msgEl.textContent = message;
  el.appendChild(msgEl);

  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = 'toast-close';
  closeBtn.setAttribute('aria-label', 'Dismiss');
  closeBtn.textContent = '×';
  el.appendChild(closeBtn);

  let dismissed = false;
  const dismiss = () => {
    if (dismissed) return;
    dismissed = true;
    el.classList.remove('toast-visible');
    el.classList.add('toast-leaving');
    el.addEventListener('transitionend', () => el.remove(), { once: true });
    // Fallback in case transitionend never fires (reduced-motion strips the
    // transition entirely, or the tab is backgrounded and rAF/transitions stall).
    setTimeout(() => { if (el.isConnected) el.remove(); }, 400);
  };
  closeBtn.addEventListener('click', dismiss);
  if (opts.action && typeof opts.action.onClick === 'function') {
    const actBtn = document.createElement('button');
    actBtn.type = 'button';
    actBtn.className = 'toast-action';
    actBtn.textContent = opts.action.label || 'Undo';
    actBtn.addEventListener('click', () => { opts.action.onClick(); dismiss(); });
    el.insertBefore(actBtn, closeBtn);
  }

  container.appendChild(el);
  // Force layout before adding the "entered" class so the enter transition plays.
  requestAnimationFrame(() => el.classList.add('toast-visible'));

  if (duration > 0) setTimeout(dismiss, duration);
  return el;
}
window.showToast = showToast;

;
/*! ==== 83-settings-panel.js ==== */
// Settings panel -- LocalStorage-only preferences, no accounts. TACO
// overhaul Phase 3: the design doc's own roadmap already scopes real
// accounts as a future ground-up rebuild (Next.js + Clerk), not a bolt-on
// to this vanilla-JS app -- confirmed live that no real Clerk integration
// exists today (AUTH_SETUP.md/auth-config.example.js are inert planning
// docs), so this deliberately doesn't add one. Reuses the profile drawer's
// centered-modal chrome (.profile-overlay/.profile-modal/.profile-close/
// .profile-content -- same classes, different content, not duplicated CSS)
// and TacoStorage for persistence.
//
// Deliberately does NOT resurrect the old global market-source (KTC/FC/DP)
// toggle as a "default value source" setting -- that control was
// intentionally removed from the player drawer earlier this project
// ("my notes can just go" / drawer simplification pass), and STATE.marketSource
// has had no live setter anywhere in the codebase since. Re-adding it here,
// just relocated, would go against that explicit removal rather than
// respect it.

const SETTINGS_TOASTS_KEY = 'settings.toastsEnabled';

function settingsToastsEnabled() {
  return TacoStorage.get(SETTINGS_TOASTS_KEY, true);
}
window.settingsToastsEnabled = settingsToastsEnabled;

function openSettingsPanel() {
  const overlay = document.getElementById('settingsOverlay');
  const modal = document.getElementById('settingsModal');
  if (!overlay || !modal) return;
  renderSettingsPanel();
  overlay.classList.add('open');
  overlay.setAttribute('aria-hidden', 'false');
  modal.classList.add('open');
  modal.setAttribute('aria-hidden', 'false');
  if (window.TacoFocus) TacoFocus.capture(modal, { focus: '.profile-close' });
  document.addEventListener('keydown', _settingsEscHandler);
}
window.openSettingsPanel = openSettingsPanel;

function closeSettingsPanel(event) {
  // Mirrors closeProfileDrawer's guard: if invoked via overlay click, only
  // close when the click landed on the overlay itself, not a bubbled child.
  if (event && event.target && event.target.id && event.target.id !== 'settingsOverlay') {
    return;
  }
  const overlay = document.getElementById('settingsOverlay');
  const modal = document.getElementById('settingsModal');
  if (overlay) {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
  }
  if (modal) {
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
  }
  if (window.TacoFocus && modal) TacoFocus.release(modal);
  document.removeEventListener('keydown', _settingsEscHandler);
}
window.closeSettingsPanel = closeSettingsPanel;

function _settingsEscHandler(e) {
  if (e.key === 'Escape') closeSettingsPanel();
}

// Account block. Signed out it is an invitation, not a wall -- the whole site
// still works without an account, and this says what signing in buys.
//
// The Sleeper username saved here lives on the account row (server-side), not
// in this browser, so signing in on a phone loads the same portfolio. It is a
// public handle, not a credential: TACO never asks for a Sleeper password.
function renderAccountSection() {
  const acct = (typeof STATE !== 'undefined' && STATE.account) || null;
  if (!acct) {
    return `
    <div class="profile-section">
      <div class="profile-section-label">Account</div>
      <p class="settings-note">Sign in to save your Sleeper username and settings to your account, so they follow you to any device.</p>
      <div class="profile-actions">
        <button class="profile-action-btn" id="accountBtn">Sign in</button>
      </div>
    </div>`;
  }
  const isPro = typeof window.isProAccount === 'function' && window.isProAccount();
  const tierLabel = typeof window.accountTierLabel === 'function' ? window.accountTierLabel(acct.tier) : (isPro ? 'Pro' : 'Free');
  const saved = acct.sleeper_username || '';
  const current = (typeof STATE !== 'undefined' && STATE.username) || '';
  const suggest = !saved && current ? current : '';
  return `
    <div class="profile-section">
      <div class="profile-section-label">Account</div>
      <div class="settings-account-row">
        <span class="settings-account-email">${escapeHtml(acct.email || '')}</span>
        <span class="settings-plan-badge ${isPro ? 'settings-plan-pro' : ''}">${tierLabel}</span>
      </div>
      <label class="settings-field">
        <span>Sleeper username</span>
        <input type="text" id="settingsSleeperInput" class="settings-input" value="${escapeHtml(saved || suggest)}"
               placeholder="yourSleeperName" autocomplete="off" spellcheck="false">
      </label>
      <p class="settings-note">Saved to your account, so any device you sign in on loads these leagues. Sleeper never sees a password ${'—'} this is just your public handle.</p>
      <div class="profile-actions">
        <button class="profile-action-btn" data-taco-settings-save-sleeper>Save username</button>
        <button class="profile-action-btn" data-taco-settings-sign-out>Sign out</button>
      </div>
    </div>`;
}
window.renderAccountSection = renderAccountSection;

// The plan block. Prices come from TacoCore.PLANS (shared/billing.mjs) so the
// page and checkout cannot disagree; Stripe's price is still what is charged.
const PLAN_COPY = {
  // Tier 1 is what costs nothing to run; tier 2 adds what costs money per use
  // (FEATURE_TIER in shared/entitlements.mjs). Keep these blurbs in step with it.
  // Names come from accountTierLabel (91) at render time, the one place a tier
  // is named -- 91 loads after this file, so it cannot be read here.
  pro: { blurb: 'The War Room, plus playoff odds, spare parts and a read on the other manager in the trade calculator.' },
  ai: { blurb: 'Everything in Pro, plus Ask TACO, the real-trade database and the Commish Desk.' },
};

function planPrice(key) {
  const plan = window.TacoCore && TacoCore.PLANS && TacoCore.PLANS[key];
  if (!plan) return '';
  return '$' + (plan.cents / 100).toFixed(plan.cents % 100 ? 2 : 0) + (plan.interval === 'year' ? ' / year' : ' / month');
}

function renderPlanCard(tier) {
  const copy = PLAN_COPY[tier];
  return `
      <div class="settings-plan-card">
        <div class="settings-plan-name">${escapeHtml(accountTierLabel(tier))}</div>
        <p class="settings-note">${copy.blurb}</p>
        <div class="profile-actions">
          <button class="profile-action-btn" data-taco-checkout="${tier}_month">${planPrice(tier + '_month')}</button>
          <button class="profile-action-btn" data-taco-checkout="${tier}_year">${planPrice(tier + '_year')}</button>
        </div>
      </div>`;
}

function renderPlanSection() {
  const acct = (typeof STATE !== 'undefined' && STATE.account) || null;
  if (!acct || !window.TacoCore || !TacoCore.PLANS) return '';
  // Not on sale yet on production -- see billingIsPublic in 91-account.js.
  if (typeof window.billingIsPublic === 'function' && !window.billingIsPublic()) return '';
  const tier = acct.tier || 'free';
  const billing = acct.billing || null;
  const subscribed = billing && ['active', 'trialing', 'past_due'].includes(billing.status);

  if (subscribed) {
    const when = billing.current_period_end
      ? new Date(billing.current_period_end).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
      : '';
    let line = '';
    if (billing.status === 'past_due') line = 'Your last payment did not go through. Update your card to keep your plan.';
    else if (billing.cancel_at_period_end) line = when ? `Cancelled. Your plan stays on until ${when}.` : 'Cancelled at the end of this period.';
    else if (when) line = `Renews ${when}.`;
    return `
    <div class="profile-section">
      <div class="profile-section-label">Plan</div>
      <p class="settings-note">${escapeHtml(line)}${tier === 'pro' ? ' Ask TACO comes with Hall of Fame; switch plans under Manage billing.' : ''}</p>
      <div class="profile-actions">
        <button class="profile-action-btn" data-taco-billing-portal>Manage billing</button>
      </div>
    </div>`;
  }

  // Not paying: offer whatever is above the tier they have (a hand-granted
  // Pro account still sees Hall of Fame).
  const rank = window.TacoCore.tierRank ? TacoCore.tierRank(tier) : 0;
  const offers = ['pro', 'ai'].filter((t) => !TacoCore.tierRank || TacoCore.tierRank(t) > rank);
  if (!offers.length) return '';
  return `
    <div class="profile-section">
      <div class="profile-section-label">Upgrade</div>
      ${offers.map(renderPlanCard).join('')}
      <p class="settings-note">Yearly is billed once and works out cheaper. Cancel any time. Paid plans never show ads.</p>
    </div>`;
}
window.renderPlanSection = renderPlanSection;

function settingsCheckout(key) {
  if (typeof window.startCheckout === 'function') window.startCheckout(key);
}
window.settingsCheckout = settingsCheckout;

function settingsBillingPortal() {
  if (typeof window.openBillingPortal === 'function') window.openBillingPortal();
}
window.settingsBillingPortal = settingsBillingPortal;

function settingsSaveSleeper() {
  const input = document.getElementById('settingsSleeperInput');
  if (!input || typeof window.saveSleeperUsername !== 'function') return;
  window.saveSleeperUsername(input.value).then(function (ok) {
    if (ok) renderSettingsPanel();
  });
}
window.settingsSaveSleeper = settingsSaveSleeper;

function settingsSignOut() {
  if (typeof window.signOutAccount === 'function') {
    window.signOutAccount().then(function () { renderSettingsPanel(); });
  }
}
window.settingsSignOut = settingsSignOut;

function renderSettingsPanel() {
  const el = document.getElementById('settingsContent');
  if (!el) return;
  const toastsOn = settingsToastsEnabled();
  el.innerHTML = `
    <div class="profile-header">
      <div class="profile-name" id="settingsTitle">Settings</div>
    </div>

    ${renderAccountSection()}

    ${renderPlanSection()}

    <div class="profile-section">
      <div class="profile-section-label">Notifications</div>
      <label class="settings-toggle-row">
        <span>Show notification toasts (trade saves, errors, etc.)</span>
        <input type="checkbox" id="settingsToastsToggle" ${toastsOn ? 'checked' : ''} data-taco-settings-toggle-toasts>
      </label>
    </div>
    <div class="profile-foot-links">
      <a href="/about.html">About</a>
      <a href="/methodology.html">Methodology</a>
      <a href="/privacy.html">Privacy</a>
    </div>
  `;
}
window.renderSettingsPanel = renderSettingsPanel;

function settingsToggleToasts(checked) {
  TacoStorage.set(SETTINGS_TOASTS_KEY, checked);
  // Only confirm via toast when turning ON -- confirming via toast that
  // toasts are now off would be a contradiction the user would immediately
  // notice.
  if (checked && typeof window.showToast === 'function') {
    window.showToast('Toast notifications are on.', { type: 'success', duration: 2500 });
  }
}
window.settingsToggleToasts = settingsToggleToasts;


;
/*! ==== 84-season-projection-panel.js ==== */
// Projected finish — season-long team projections (league tab).
//
// The question the other league surfaces don't answer. Power Rankings sorts
// by current dynasty value and the playoff picture reports the record a team
// already has; both describe today. This projects the rest of the season from
// Sleeper's weekly stat projections, scored through THIS league's real
// scoring_settings, and reports odds rather than a single fake outcome.
//
// Why odds and not a projected record: the deterministic simulation is
// indefensible as a forecast. With no week-to-week variance a marginally
// better team wins every single matchup, which turned a real 128-vs-105
// points-per-week spread into 18-0 and 1-17. TacoCore.monteCarloStandings
// samples each starter around his projection using variance MEASURED from
// 2025 (QB 0.47 CV, RB 0.60, WR 0.64, TE 0.70) and reports playoff odds and a
// win range instead.

const SEASON_PROJ_ITERATIONS = 1000;

let seasonProjectionsInFlight = null;

async function loadSeasonProjections() {
  if (!BACKEND_URL) return;
  const { season } = TacoCore.resolveNflWeekContext();
  if (STATE.seasonProjections?.season === season) return;
  if (seasonProjectionsInFlight) return seasonProjectionsInFlight;
  seasonProjectionsInFlight = fetchSeasonProjections(season).finally(() => { seasonProjectionsInFlight = null; });
  return seasonProjectionsInFlight;
}

async function fetchSeasonProjections(season) {
  try {
    const res = await fetch(`${BACKEND_URL}/api/projections/season?season=${season}`);
    if (!res.ok) throw new Error('HTTP ' + res.status);
    const data = await res.json();
    STATE.seasonProjections = {
      season,
      weeks: data.weeks || {},
      weeksPublished: data.weeksPublished || [],
    };
    const lg = STATE.leagues?.[STATE.currentTeamIdx];
    if (lg) rerenderSeasonProjectionPanel(lg);
  } catch (e) {
    console.warn('[season-projection] fetch failed', e.message);
    STATE.seasonProjections = { season, weeks: {}, weeksPublished: [], failed: true };
  }
}
window.loadSeasonProjections = loadSeasonProjections;

/** Sleeper's real week-by-week schedule for one league, as
 * {week: [[rosterA, rosterB], ...]}.
 *
 * Sleeper returns one row per roster per week carrying a `matchup_id`; the two
 * rosters sharing an id are the ones playing. Groups that are not exactly a
 * pair are skipped rather than guessed at -- an odd team count or a bye leaves
 * a singleton, and inventing an opponent for it would fabricate results.
 *
 * Only the weeks that actually have projections are fetched. That is the
 * natural bound: a schedule for a week we cannot project is useless, and it
 * keeps this at one request per usable week (6 today) instead of 18. */
async function loadLeagueSchedule(lg, weeks) {
  const cacheKey = lg.league_id;
  STATE.leagueSchedules = STATE.leagueSchedules || {};
  const cached = STATE.leagueSchedules[cacheKey];
  if (cached && cached.weeks.length === weeks.length) return cached.matchups;

  const matchups = {};
  const results = await Promise.all(weeks.map(async (w) => {
    try {
      const rows = await api(`/league/${lg.league_id}/matchups/${w}`);
      return { week: w, rows: Array.isArray(rows) ? rows : [] };
    } catch (e) {
      console.warn('[season-projection] matchups fetch failed for week', w, e.message);
      return { week: w, rows: [] };
    }
  }));

  for (const { week, rows } of results) {
    const byMatchup = {};
    for (const r of rows) {
      if (r?.matchup_id == null || r.roster_id == null) continue;
      (byMatchup[r.matchup_id] = byMatchup[r.matchup_id] || []).push(r.roster_id);
    }
    const pairs = Object.values(byMatchup).filter((g) => g.length === 2);
    if (pairs.length) matchups[week] = pairs;
  }

  STATE.leagueSchedules[cacheKey] = { weeks, matchups };
  return matchups;
}

// Strength of schedule FACED — average scoring strength (points per game) of the
// opponents each team has actually played, then ranked (hardest = 1). Fetches
// the played weeks' matchups once per league, lazily, and caches the result;
// the caller re-renders when it lands. Frontend-only — no backend needed.
async function loadLeagueSOS(lg) {
  if (!lg || !lg.allRosters || !lg.allRosters.length) return;
  STATE.leagueSOS = STATE.leagueSOS || {};
  if (STATE.leagueSOS[lg.league_id]) return;
  STATE.leagueSOS[lg.league_id] = { ready: false, ranks: {}, sos: {} }; // in-flight guard
  const ctx = window.TacoCore && TacoCore.resolveNflWeekContext ? TacoCore.resolveNflWeekContext() : {};
  const curWeek = Math.max(1, Math.min(18, Number(ctx.week) || 1));
  const playedWeeks = [];
  for (let w = 1; w < curWeek; w += 1) playedWeeks.push(w);
  if (!playedWeeks.length) {
    STATE.leagueSOS[lg.league_id] = { ready: true, ranks: {}, sos: {} };
    return;
  }

  let rowsByWeek;
  try {
    rowsByWeek = await Promise.all(playedWeeks.map(async (w) => {
      try {
        const rows = await api(`/league/${lg.league_id}/matchups/${w}`);
        return Array.isArray(rows) ? rows : [];
      } catch (_e) {
        return [];
      }
    }));
  } catch (_e) {
    STATE.leagueSOS[lg.league_id] = { ready: true, ranks: {}, sos: {} };
    return;
  }

  // Who each roster played, week by week.
  const opponents = {};
  rowsByWeek.forEach((rows) => {
    const byMatchup = {};
    rows.forEach((r) => {
      if (r && r.matchup_id != null && r.roster_id != null) {
        (byMatchup[r.matchup_id] = byMatchup[r.matchup_id] || []).push(r.roster_id);
      }
    });
    Object.values(byMatchup).forEach((pair) => {
      if (pair.length === 2) {
        (opponents[pair[0]] = opponents[pair[0]] || []).push(pair[1]);
        (opponents[pair[1]] = opponents[pair[1]] || []).push(pair[0]);
      }
    });
  });

  // Each roster's scoring strength = points-for per game played.
  const strength = {};
  lg.allRosters.forEach((r) => {
    const gp = (r.wins || 0) + (r.losses || 0) + (r.ties || 0);
    strength[r.rosterId] = gp > 0 ? (r.pointsFor || 0) / gp : 0;
  });

  // SOS = average scoring strength of the opponents faced.
  const sos = {};
  lg.allRosters.forEach((r) => {
    const opps = opponents[r.rosterId] || [];
    const vals = opps.map((o) => strength[o] || 0).filter((v) => v > 0);
    sos[r.rosterId] = vals.length ? vals.reduce((a, b) => a + b, 0) / vals.length : 0;
  });

  const ranks = {};
  lg.allRosters.forEach((r) => {
    const mine = sos[r.rosterId] || 0;
    ranks[r.rosterId] = lg.allRosters.filter((o) => (sos[o.rosterId] || 0) > mine).length + 1;
  });

  STATE.leagueSOS[lg.league_id] = { ready: true, ranks, sos };

  const cur = STATE.leagues[STATE.currentTeamIdx];
  const teamActive = document.getElementById('teamView')?.classList.contains('active');
  if (cur && cur.league_id === lg.league_id && teamActive && typeof renderTeamDetail === 'function') {
    renderTeamDetail();
  }
}
window.loadLeagueSOS = loadLeagueSOS;

function rerenderSeasonProjectionPanel(lg) {
  const el = document.getElementById('seasonProjectionPanel-' + lg.league_id);
  if (!el) return;
  el.outerHTML = renderSeasonProjectionPanel(lg);
}
window.rerenderSeasonProjectionPanel = rerenderSeasonProjectionPanel;

/** Score every published week through this league's own rules. Same reason
 * start/sit does it client side: the server has no league context, so it
 * ships raw stats and each league scores them itself. */
// ~18 weeks x ~1,000 players of computeFantasyPoints per call, and the trade
// calculator asks on every tap: remember each league's answer for as long as
// the projections object it came from is the current one.
const scoredWeeksCache = new WeakMap(); // projections object -> league_id -> points

function scoreWeeksForLeague(sp, lg) {
  if (!sp || !lg?.scoring_settings || typeof computeFantasyPoints !== 'function') return null;
  let perLeague = scoredWeeksCache.get(sp);
  if (!perLeague) { perLeague = new Map(); scoredWeeksCache.set(sp, perLeague); }
  const hit = perLeague.get(lg.league_id);
  if (hit && hit.rosters === lg.allRosters && hit.settings === lg.scoring_settings) return hit.out;
  // Rostered players only, points shared across leagues with the same scoring
  // (memoFantasyPoints, 20) -- see the note there for the 8.4-second freeze.
  const ids = leagueRosteredIds(lg);
  const out = {};
  for (const [week, byPlayer] of Object.entries(sp.weeks || {})) {
    if (!byPlayer) continue;
    const pts = {};
    for (const playerId of ids) {
      const stats = byPlayer[playerId];
      if (!stats) continue;
      const v = memoFantasyPoints(stats, lg.scoring_settings);
      if (v > 0) pts[playerId] = v;
    }
    if (Object.keys(pts).length) out[Number(week)] = pts;
  }
  perLeague.set(lg.league_id, { rosters: lg.allRosters, settings: lg.scoring_settings, out });
  return out;
}

function seasonProjectionTeams(lg) {
  return (lg.allRosters || []).map((r) => ({
    rosterId: r.rosterId,
    name: r.teamName || r.ownerName || 'Team',
    isMe: !!r.isMe,
    players: (r.players || []).map((p) => ({
      playerId: String(p.sleeperId ?? p.playerId ?? ''),
      position: p.position,
      isActive: p.isActive,
    })).filter((p) => p.playerId),
  }));
}

/**
 * Everything monteCarloStandings needs for one league, built in ONE place so
 * Projected Finish and the trade calculator's odds (79) simulate the same
 * season. Returns { args, seasonOver, gamesPlayed }; args.weeks is empty while
 * projections are missing. The schedule loads lazily and `onSchedule` fires
 * once it lands.
 */
function seasonSimArgs(lg, onSchedule) {
  const pointsByWeek = scoreWeeksForLeague(STATE.seasonProjections, lg) || {};
  // REGULAR SEASON ONLY. Sleeper publishes projections for all 18 NFL weeks,
  // but a league's regular season ends at playoff_week_start (15 here, so
  // weeks 1-14). Simulating all 18 counted four playoff weeks as regular-season
  // games: average wins came out at 9.0 in a 12-team league, i.e. 18 games
  // each, win ranges were measured against a 14-win ceiling that did not exist,
  // and the seeding that decides playoff odds was taken from a standings table
  // four games too long.
  //
  // This was invisible until 2026-09-03, when the season backfill first filled
  // every week. Before that only weeks 1 and 8-12 had projections, so the list
  // was short for an unrelated reason and never reached the playoffs.
  const playoffWeekStart = lg.settings?.playoff_week_start ?? 15;
  const regularWeeks = Object.keys(pointsByWeek).map(Number)
    .filter((w) => w < playoffWeekStart).sort((a, b) => a - b);
  // ONLY THE WEEKS STILL TO PLAY. Until 2026-09-27 every regular-season week
  // was simulated, including those already decided, so in week 3 a team at
  // 0-2 got the odds of a team at 0-0. Played games are now banked from
  // Sleeper's own standings and only the rest is simulated.
  const weeks = TacoCore.unplayedWeeks(regularWeeks, lg.allRosters, lg.settings?.start_week ?? 1);

  const teams = seasonProjectionTeams(lg);
  const playoffSpots = lg.settings?.playoff_teams ?? lg.settings?.playoff_team_count
    ?? Math.max(2, Math.floor(teams.length / 2));
  const startRecords = {};
  for (const r of lg.allRosters || []) {
    startRecords[r.rosterId] = { wins: Number(r.wins) || 0, pointsFor: Number(r.pointsFor) || 0 };
  }

  // The schedule turns "who scores enough" into "who beats whom". Fetched once
  // per league, lazily, and only for the weeks still to play.
  const sched = STATE.leagueSchedules?.[lg.league_id];
  if (!sched && weeks.length && typeof loadLeagueSchedule === 'function') {
    setTimeout(() => {
      loadLeagueSchedule(lg, weeks)
        .then(() => { if (onSchedule) onSchedule(); })
        .catch((e) => console.warn('[season-projection] schedule load failed', e.message));
    }, 0);
  }

  return {
    seasonOver: regularWeeks.length > 0 && weeks.length === 0,
    args: {
      rosterPositions: lg.roster_positions || [],
      teams,
      pointsByWeek,
      weeks,
      matchupsByWeek: sched?.matchups,
      playoffSpots,
      startRecords,
      roundWeeks: TacoCore.playoffRoundWeeks(playoffWeekStart, playoffSpots, Number(lg.settings?.playoff_round_type) || 0),
    },
  };
}
window.seasonSimArgs = seasonSimArgs;

const seasonSimMemo = new WeakMap(); // season projections -> Map(league_id -> { key, mc })
const seasonSimPending = new Set();
/** What the simulation depends on, cheaply: rosters, records, the weeks left
 * and whether the schedule has arrived. */
function seasonSimKey(lg, args) {
  const recs = (lg.allRosters || []).map((r) => r.rosterId + ':' + (r.wins || 0) + '-' + (r.losses || 0) + ':' +
    Math.round(r.pointsFor || 0) + ':' + (r.players || []).map((p) => p.playerId).join(',')).join('|');
  const sched = STATE.leagueSchedules && STATE.leagueSchedules[lg.league_id] ? 'S' : '-';
  return recs + '#' + (args.weeks || []).join(',') + '#' + sched;
}

/** The remembered no-trade simulation for this league, or null. Trade-fit odds
 * (79) reuse it as their "before" run -- same inputs, same seed. */
function cachedSeasonSim(lg, args) {
  const per = STATE.seasonProjections && seasonSimMemo.get(STATE.seasonProjections);
  const hit = per && per.get(lg.league_id);
  return hit && hit.key === seasonSimKey(lg, args) && !hit.mc.failed ? hit.mc : null;
}
function rememberSeasonSim(lg, args, mc) {
  const sp = STATE.seasonProjections;
  if (!sp || !mc) return;
  let per = seasonSimMemo.get(sp);
  if (!per) { per = new Map(); seasonSimMemo.set(sp, per); }
  per.set(lg.league_id, { key: seasonSimKey(lg, args), mc });
}
window.cachedSeasonSim = cachedSeasonSim;
window.rememberSeasonSim = rememberSeasonSim;

function renderSeasonProjectionPanel(lg) {
  const id = 'seasonProjectionPanel-' + lg.league_id;
  const wrap = (inner) => `<div id="${id}" class="section-card">${inner}</div>`;

  if (!lg.allRosters?.length) {
    return wrap('<div class="tab-empty">No roster data available for this league.</div>');
  }

  const sp = STATE.seasonProjections;
  if (!sp) {
    if (typeof loadSeasonProjections === 'function') setTimeout(loadSeasonProjections, 0);
    return wrap('<div class="tab-empty">Loading season projections…</div>');
  }

  const sim = seasonSimArgs(lg, () => rerenderSeasonProjectionPanel(lg));

  if (sim.seasonOver) {
    return wrap('<div class="tab-empty">The regular season is over: the standings are final, so there is nothing left to project.</div>');
  }
  if (!sim.args.weeks.length) {
    // Distinguish "not published yet" from "we broke". Thin coverage looking
    // identical to an outage is exactly how start/sit's silent fallback hid
    // for a season, so say which one this is.
    const msg = sp.failed
      ? 'Couldn\'t reach the projections service. This panel will fill in once it\'s back.'
      : `Sleeper hasn't published ${escapeHtml(String(sp.season))} projections yet. Projected finish appears as soon as they do.`;
    return wrap(`<div class="tab-empty">${msg}</div>`);
  }

  // 1,000 seeded seasons (~350ms): the same inputs give the same answer, so run
  // it once per league until rosters, records, schedule or projections change,
  // and never inside the tap that opens the tab -- the panel paints first and
  // the simulation fills it a moment later (lag report, 2026-09-28).
  const key = seasonSimKey(lg, sim.args);
  let perLeague = seasonSimMemo.get(sp);
  if (!perLeague) { perLeague = new Map(); seasonSimMemo.set(sp, perLeague); }
  const hit = perLeague.get(lg.league_id);
  const mc = hit && hit.key === key ? hit.mc : null;
  if (!mc) {
    if (!seasonSimPending.has(lg.league_id)) {
      seasonSimPending.add(lg.league_id);
      setTimeout(() => {
        seasonSimPending.delete(lg.league_id);
        try {
          perLeague.set(lg.league_id, { key, mc: TacoCore.monteCarloStandings({ ...sim.args, iterations: SEASON_PROJ_ITERATIONS, seed: 1 }) });
        } catch (e) {
          console.error('[season-projection] simulation failed', e);
          perLeague.set(lg.league_id, { key, mc: { failed: true } });
        }
        rerenderSeasonProjectionPanel(lg);
      }, 30);
    }
    return wrap('<div class="tab-empty">Simulating 1,000 seasons…</div>');
  }
  if (mc.failed) return wrap('<div class="tab-empty">Couldn\'t run the projection for this league.</div>');

  // Wins only exist if there were matchups to simulate. Sleeper's schedule
  // isn't on the league object yet, so today these columns would be a wall of
  // zeros -- omit them rather than print a number that means nothing.
  const showWins = mc.hasSchedule;
  // Byes only exist in fields that are not a power of two (6 teams: seeds 1-2).
  const showBye = mc.hasBracket && mc.byes > 0;
  const gamesPlayed = Math.max(0, ...(lg.allRosters || []).map((r) => (r.wins || 0) + (r.losses || 0) + (r.ties || 0)));

  const rows = mc.teams.map((t) => {
    const odds = t.playoffOdds;
    const tier = odds >= 70 ? 'good' : odds >= 35 ? 'mid' : 'low';
    const range = t.winsRange[0] === t.winsRange[1]
      ? String(t.winsRange[0])
      : `${t.winsRange[0]}-${t.winsRange[1]}`;
    const winCells = showWins
      ? `<td class="sp-num">${t.meanWins}</td><td class="sp-num sp-dim">${range}</td>`
      : '';
    return `
      <tr class="${t.isMe ? 'sp-me' : ''}">
        <td class="sp-rank">${t.projectedRank}</td>
        <td class="sp-team">${escapeHtml(t.name)}${t.isMe ? ' <span class="pr-vs pr-vs-self">You</span>' : ''}</td>
        <td class="sp-num"><span class="sp-odds sp-odds-${tier}">${odds}%</span></td>
        ${mc.hasBracket ? `<td class="sp-num">${t.titleOdds}%</td>` : ''}
        ${showBye ? `<td class="sp-num">${t.byeOdds}%</td>` : ''}
        ${winCells}
        <td class="sp-num sp-dim">${Math.round(t.meanPoints / mc.weeksSimulated)}</td>
      </tr>`;
  }).join('');

  return wrap(`
    <div class="section-card-head">
      <h3 class="section-card-title">Projected finish</h3>
      <div class="section-card-sub">
        ${mc.weeksSimulated} week${mc.weeksSimulated === 1 ? '' : 's'} of Sleeper projections,
        scored to your league's real rules, simulated ${mc.iterations.toLocaleString()} times.
        ${gamesPlayed ? `The ${gamesPlayed} week${gamesPlayed === 1 ? '' : 's'} already played count as they finished. ` : ''}Top ${mc.playoffSpots} make the playoffs${showBye ? `, the top ${mc.byes} with a bye` : ''}${mc.hasBracket ? '; the bracket is simulated too' : ''}.
      </div>
    </div>
    <div class="sp-scroll">
      <table class="sp-table">
        <thead>
          <tr>
            <th>#</th><th>Team</th><th class="sp-num">Playoff</th>
            ${mc.hasBracket ? '<th class="sp-num">Title</th>' : ''}
            ${showBye ? '<th class="sp-num">Bye</th>' : ''}
            ${showWins ? '<th class="sp-num">Wins</th><th class="sp-num">Range</th>' : ''}
            <th class="sp-num">Pts/wk</th>
          </tr>
        </thead>
        <tbody>${rows}</tbody>
      </table>
    </div>
    <div class="sp-note">
      ${showWins
        ? `Wins are an average across simulated seasons and <strong>Range</strong> covers the
           middle 80% of them - a projection is a spread, not a number.`
        : `Ranked on simulated points: your league's week-by-week schedule isn't available here,
           so there are no matchups to win. Odds still come from a thousand simulated seasons,
           they just answer "who scores enough" rather than "who beats whom".`}
    </div>
  `);
}
window.renderSeasonProjectionPanel = renderSeasonProjectionPanel;

;
/*! ==== 86-scoreboard-panel.js ==== */
// The Slate — where you stand in every league at once, this week.
//
// The competition prints a win percentage without showing its work. This one
// comes out of shared/scoreboard.mjs, which simulates each matchup against the
// measured per-position variance already used for playoff odds. Banked points
// carry no uncertainty, so the number slides from a projection before kickoff to
// a near-certainty by Monday night without any special casing.
//
// 2026-09-13, from the first Sunday of real use:
//   - The board loaded once and never again. Its cache was described as "per
//     week", but nothing ever invalidated it, so scores and win odds sat where
//     the first load left them until a full page reload. It now refreshes itself
//     while games are on, and whenever the page is revisited after two minutes.
//   - Game state came from the schedule's date alone, so every Sunday player
//     counted as still playing until 8am UTC Monday: a finished back who ended
//     short of his projection kept the difference as upside all evening and the
//     odds could not settle. Sleeper's schedule publishes a real status per game
//     (pre_game / in_game / complete), used whenever it loads.
//
// All maths and all state classification live in shared/ and are unit tested.
// This file fetches, assembles and renders.

/** Bounded fan-out, same six-deep shape as refreshTradeSuggestionsFromServer.
 *
 * One matchup fetch per league: thirty for Owen, 209 for the heaviest account on
 * the platform. Firing those at once is the exact burst that was capped on
 * 2026-09-12, and a Sunday morning is when it would have hurt most. */
async function scoreboardMapLimited(items, limit, fn) {
  const out = new Array(items.length);
  let cursor = 0;
  const worker = async () => {
    for (;;) {
      const i = cursor;
      cursor += 1;
      if (i >= items.length) return;
      try {
        out[i] = await fn(items[i], i);
      } catch (e) {
        console.warn('[scoreboard] league failed', items[i]?.league_id, e?.message);
        // Kept as a marker so the page can say which leagues are missing and
        // offer a retry, instead of quietly showing a shorter board.
        out[i] = { failed: true, leagueId: items[i]?.league_id, leagueName: items[i]?.name };
      }
    }
  };
  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, worker));
  return out;
}

/** NFL team → kickoff date for this week. The fallback for game state, and the
 * source of the day label on a game that has not started. */
async function scoreboardKickoffs(season, week) {
  try {
    const res = await fetch(`${BACKEND_URL}/api/projections?season=${season}&week=${week}`);
    if (!res.ok) return { map: {}, full: {} };
    const data = await res.json();
    // Keep the whole schedule, not just kickoffs: Who You Need groups players
    // by matchup and needs the opponent too. The caller decides whether to
    // publish `full` to STATE.weeklyScheduleMap -- only the live week should,
    // or browsing the Slate to a past week would regroup Who You Need.
    const full = {};
    const map = {};
    for (const [team, g] of Object.entries(data?.schedule || {})) {
      const T = String(team).toUpperCase();
      full[T] = g;
      if (g?.kickoffAt) map[T] = g.kickoffAt;
    }
    return { map, full };
  } catch (_e) {
    return { map: {}, full: {} };
  }
}

// Sleeper's public schedule, which carries a status per game. Allowed by the
// CSP (api.sleeper.com) and needs no backend, so it costs one fetch per refresh.
const SLATE_SCHEDULE_URL = 'https://api.sleeper.com/schedule/nfl/regular/';

/** NFL team → 'upcoming' | 'live' | 'final' for this week, or {} if the schedule
 * cannot be read, in which case game state falls back to the kickoff date. */
async function scoreboardGameStates(season, week) {
  try {
    const res = await fetch(SLATE_SCHEDULE_URL + encodeURIComponent(season));
    if (!res.ok) return {};
    return TacoCore.scheduleStatesForWeek(await res.json(), week);
  } catch (_e) {
    return {};
  }
}

/** playerId → {position, team}, gathered from every roster in the league so the
 * opponent's starters resolve too, not just ours. */
function scoreboardPlayerMeta(lg) {
  const meta = {};
  for (const r of lg.allRosters || []) {
    for (const p of r.players || []) {
      if (p?.playerId) meta[String(p.playerId)] = { name: p.name, position: p.position, team: p.team };
    }
  }
  return meta;
}

/** A side's starters in lineup order, each with its own game state. The drawer
 * renders these and buildSide simulates from the same rows, so what a player is
 * shown doing and what the odds assume he is doing come from one call. */
function scoreboardStarterRows(row, meta, weekPoints, kickoffs, states, now) {
  return (row?.starters || []).map((pid, i) => {
    const m = meta[String(pid)] || {};
    const team = String(m.team || '').toUpperCase();
    return {
      playerId: String(pid),
      name: m.name || String(pid),
      position: m.position,
      team: m.team,
      actual: Number(row?.starters_points?.[i] ?? row?.players_points?.[pid] ?? 0),
      projected: Number(weekPoints?.[String(pid)] ?? 0),
      kickoffAt: kickoffs[team] || null,
      state: TacoCore.teamGameState(team, kickoffs, states, now),
    };
  });
}

function scoreboardAvatarRef(roster) {
  return roster ? { leagueAvatar: roster.leagueAvatar || null, accountAvatar: roster.accountAvatar || roster.avatar || null } : null;
}

function scoreboardLocalYmd(ts) {
  const d = new Date(ts);
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

/** The live NFL week, clamped to the 1-18 regular season. The Slate defaults
 * here; Who You Need and the live-refresh timer always use it. */
function slateCurrentWeek() {
  // Sleeper's own week wins when we have it. The local calculation is a
  // fallback for the first paint and for a failed fetch -- being a week ahead
  // is not a cosmetic error here, it empties every score on the board.
  const live = Number(STATE.nflState && STATE.nflState.week);
  if (live >= 1 && live <= 18) return live;
  const ctx = window.TacoCore && TacoCore.resolveNflWeekContext ? TacoCore.resolveNflWeekContext() : {};
  return Math.max(1, Math.min(18, Number(ctx.week) || 1));
}
window.slateCurrentWeek = slateCurrentWeek;

// Per-week in-flight guard: browsing to a past week must not cancel the live
// week's refresh, and two callers wanting the same week share one fetch.
const slateLoading = {};

/** One fetch, two views. Who You Need is a group-by over exactly the data the
 * Slate pulled. `week` defaults to the live NFL week; the Slate passes an
 * explicit week to browse previous results and upcoming matchups. Boards are
 * cached per week in STATE.scoreboardBoards; the live week is mirrored to
 * STATE.scoreboardBoard, which Who You Need and the refresh timer read, so
 * those stay on "this week" regardless of what the Slate is showing. */
async function loadScoreboardBoard(weekArg) {
  if (!STATE.scoreboardBoards) STATE.scoreboardBoards = {};
  const currentWeek = slateCurrentWeek();
  const week = Math.max(1, Math.min(18, Number(weekArg) || currentWeek));
  if (slateLoading[week]) return slateLoading[week];
  slateLoading[week] = (async () => {
    const leagues = STATE.leagues || [];
    if (!leagues.length) return { week, board: [], loadedAt: Date.now() };

    // loadSeasonProjections() returns nothing -- it fills STATE.seasonProjections
    // and early-returns when that cache is already warm. Awaiting its return value
    // yields undefined, which silently produced a board where every projection was
    // zero and every matchup read "Tied".
    const ctx = TacoCore.resolveNflWeekContext ? TacoCore.resolveNflWeekContext() : {};
    const season = ctx.season || STATE.season || String(new Date().getFullYear());
    if (typeof loadSeasonProjections === 'function') await loadSeasonProjections();
    const sp = STATE.seasonProjections || null;
    const [kick, states] = await Promise.all([scoreboardKickoffs(season, week), scoreboardGameStates(season, week)]);
    const kickoffs = kick.map;
    // Only the live week owns the shared schedule map Who You Need groups on.
    if (week === currentWeek) STATE.weeklyScheduleMap = kick.full;
    const weekStats = sp?.weeks?.[String(week)] || sp?.weeks?.[week] || null;
    const now = Date.now();
    const today = scoreboardLocalYmd(now);

    const rows = await scoreboardMapLimited(leagues, 6, async (lg) => {
      const mine = (lg.allRosters || []).find((r) => r.isMe);
      if (!mine) return null;
      const matchups = await api(`/league/${lg.league_id}/matchups/${week}`);
      if (!Array.isArray(matchups) || !matchups.length) return null;

      const myRow = matchups.find((m) => String(m.roster_id) === String(mine.rosterId));
      if (!myRow) return null;
      const oppRow = matchups.find(
        (m) => m.matchup_id != null && m.matchup_id === myRow.matchup_id && String(m.roster_id) !== String(myRow.roster_id),
      );
      if (!oppRow) return null;

      // Projections scored through THIS league's rules, which is the whole point:
      // the same player is worth different points in a TE-premium league.
      const weekPoints = {};
      if (weekStats && lg.scoring_settings && typeof computeFantasyPoints === 'function') {
        // Only the two teams in this matchup: this ran over every player in the
        // NFL, per league, on every live refresh -- 30 leagues x ~1,000 players
        // each poll while you watch the Slate (lag report, 2026-09-28).
        const ids = new Set([...(myRow.players || []), ...(myRow.starters || []), ...(oppRow.players || []), ...(oppRow.starters || [])].map(String));
        for (const pid of ids) {
          const stats = weekStats[pid];
          if (!stats) continue;
          const v = computeFantasyPoints(stats, lg.scoring_settings);
          if (v > 0) weekPoints[pid] = v;
        }
      }

      const meta = scoreboardPlayerMeta(lg);
      const mineRows = scoreboardStarterRows(myRow, meta, weekPoints, kickoffs, states, now);
      const theirRows = scoreboardStarterRows(oppRow, meta, weekPoints, kickoffs, states, now);
      const me = TacoCore.buildSide(mineRows, kickoffs, now, states);
      const them = TacoCore.buildSide(theirRows, kickoffs, now, states);
      const sim = TacoCore.simulateMatchup({ me, them });
      const both = mineRows.concat(theirRows);

      const oppRoster = (lg.allRosters || []).find((r) => String(r.rosterId) === String(oppRow.roster_id));
      return {
        leagueId: lg.league_id,
        leagueName: lg.name,
        format: lg.scoringTab || '',
        myTeam: mine.teamName || 'You',
        opponent: oppRoster?.teamName || oppRoster?.ownerName || 'Opponent',
        myAvatar: scoreboardAvatarRef(mine),
        oppAvatar: scoreboardAvatarRef(oppRoster),
        myRecord: TacoCore.formatRecord ? TacoCore.formatRecord(mine) : null,
        oppRecord: TacoCore.formatRecord ? TacoCore.formatRecord(oppRoster) : null,
        myActual: me.actual,
        theirActual: them.actual,
        myStarters: (myRow.starters || []).map(String),
        mine: mineRows,
        theirs: theirRows,
        anyLive: both.some((p) => p.state === 'live'),
        anyToday: both.some((p) => p.state === 'upcoming' && String(p.kickoffAt || '').slice(0, 10) === today),
        ...sim,
      };
    });

    const board = rows.filter((r) => r && !r.failed);
    const failed = rows.filter((r) => r && r.failed);
    const result = { week, board, failed, loadedAt: Date.now(), usedLiveStatus: Object.keys(states).length > 0 };
    STATE.scoreboardBoards[week] = result;
    if (week === currentWeek) STATE.scoreboardBoard = result;
    return result;
  })();
  try {
    return await slateLoading[week];
  } finally {
    delete slateLoading[week];
  }
}

// --- freshness and auto-refresh ------------------------------------------------

// 2026-09-27 (Owen watching a live Sunday): 2 minutes behind a 30s tick meant
// scores moved every ~2.5 minutes, and the proxy let the browser cache each
// answer for 2 minutes on top of that, so the page looked frozen and a full
// reload was the only thing that worked. Live games now refresh every minute
// (the proxy no longer lets the browser cache live scores at all).
const SLATE_REFRESH_MS = 2 * 60 * 1000;
const SLATE_LIVE_REFRESH_MS = 60 * 1000;
const SLATE_TICK_MS = 15 * 1000;
let slateTimer = null;

function slateBoardAgeMs() {
  const b = STATE.scoreboardBoard;
  return b && b.loadedAt ? Date.now() - b.loadedAt : Infinity;
}

/** Fresh enough to show without reloading. Who You Need reads the same board and
 * uses this, so neither page can sit on a Sunday-morning copy all day. */
function scoreboardBoardIsFresh() {
  const b = STATE.scoreboardBoard;
  return !!(b && b.board && b.board.length && slateBoardAgeMs() < slateRefreshMs());
}
window.scoreboardBoardIsFresh = scoreboardBoardIsFresh;

function slateGamesInPlay() {
  return (STATE.scoreboardBoard?.board || []).some((r) => r.anyLive || r.anyToday);
}

function slateAnyLive() {
  return (STATE.scoreboardBoard?.board || []).some((r) => r.anyLive);
}

/** How often to pull scores right now: every minute during games, else two. */
function slateRefreshMs() {
  return slateAnyLive() ? SLATE_LIVE_REFRESH_MS : SLATE_REFRESH_MS;
}

function slateActiveView() {
  const id = document.querySelector('.view.active')?.id;
  return id === 'scoreboardView' ? 'scoreboard' : id === 'rootingView' ? 'rooting' : null;
}

function slateUpdatedText() {
  const age = slateBoardAgeMs();
  if (!Number.isFinite(age)) return '';
  const secs = Math.max(0, Math.round(age / 1000));
  const when = secs < 60 ? secs + 's ago' : Math.round(secs / 60) + 'm ago';
  return 'Updated ' + when + (slateAnyLive() ? ' · live, updating every minute' : slateGamesInPlay() ? ' · updating every 2 min today' : '');
}

/** One timer for both pages. It ticks every 30s but only reloads when the board
 * is two minutes old AND a game is live or kicks off today, so a Tuesday visit
 * costs nothing and a Sunday stays current. Paused while the tab is hidden. */
function ensureSlateTimer() {
  if (slateTimer) return;
  // Back on the tab after a while: catch up now rather than on the next tick.
  document.addEventListener('visibilitychange', () => {
    if (document.hidden || !slateActiveView() || !slateGamesInPlay() || slateBoardAgeMs() < slateRefreshMs()) return;
    loadScoreboardBoard().then(() => {
      const v = slateActiveView();
      if (v === 'scoreboard') renderScoreboardView();
      else if (v === 'rooting' && typeof renderRootingView === 'function') renderRootingView();
      if (typeof refreshOpenMatchupDrawer === 'function') refreshOpenMatchupDrawer();
    }).catch(() => {});
  });
  slateTimer = setInterval(async () => {
    const view = slateActiveView();
    if (!view || document.hidden) return;
    const label = document.getElementById('slateUpdated');
    if (label) label.textContent = slateUpdatedText();
    if (!slateGamesInPlay() || slateBoardAgeMs() < slateRefreshMs()) return;
    try {
      await loadScoreboardBoard();
    } catch (e) {
      console.warn('[slate] refresh failed', e && e.message);
      return;
    }
    const after = slateActiveView();
    if (after === 'scoreboard') renderScoreboardView();
    else if (after === 'rooting' && typeof renderRootingView === 'function') renderRootingView();
    if (typeof refreshOpenMatchupDrawer === 'function') refreshOpenMatchupDrawer();
  }, SLATE_TICK_MS);
}

// --- render ----------------------------------------------------------------------------

function slatePlayerStateLabel(p) {
  if (p.state === 'live') return 'Live';
  if (p.state === 'final') return 'Final';
  const day = TacoCore.kickoffDayName ? TacoCore.kickoffDayName(p.kickoffAt) : '';
  return day ? day.slice(0, 3) : 'Later';
}

function slateLineupHtml(rows, teamName, actual, projected, esc, settled) {
  return (
    '<div class="sb-lineup">' +
    '<div class="sb-lineup-head">' +
    '<span class="sb-lineup-name">' + esc(teamName) + '</span>' +
    '<span class="sb-lineup-total">' + actual.toFixed(1) +
    (settled ? '' : ' <span class="sb-lineup-proj">proj ' + projected.toFixed(1) + '</span>') + '</span>' +
    '</div>' +
    rows
      .map(
        (p) =>
          '<div class="sb-player sb-p-' + esc(p.state) + '">' +
          (typeof playerAvatarHtml === 'function' ? playerAvatarHtml(p.playerId, p.name, p.position) : '') +
          '<span class="sb-pos">' + esc(p.position || '') + '</span>' +
          '<span class="sb-pname">' + esc(p.name) +
          '<span class="sb-pteam">' + (typeof teamLogoHtml === 'function' ? teamLogoHtml(p.team, 'sb-team-logo') : '') + esc(p.team || 'FA') + '</span></span>' +
          '<span class="sb-pstate">' + esc(slatePlayerStateLabel(p)) + '</span>' +
          // A player whose game has not started has nothing banked; showing his
          // projection there says what he is expected to add.
          '<span class="sb-ppts">' + (p.state === 'upcoming' ? p.projected.toFixed(1) : p.actual.toFixed(1)) + '</span>' +
          '</div>',
      )
      .join('') +
    '</div>'
  );
}

/** The week the Slate is displaying, defaulting to the live NFL week. */
function slateSelectedWeek() {
  return Math.max(1, Math.min(18, Number(STATE.slateWeek) || slateCurrentWeek()));
}

/** ‹ Week N › stepper + jump dropdown, always rendered so a user can leave a
 * week that has no matchups posted yet. */
function slateWeekNavHtml(week, currentWeek) {
  const opts = [];
  for (let w = 1; w <= 18; w += 1) {
    const tag = w === currentWeek ? ' · now' : '';
    opts.push('<option value="' + w + '"' + (w === week ? ' selected' : '') + '>Week ' + w + tag + '</option>');
  }
  return (
    '<div class="sb-weeknav">' +
    '<button type="button" class="sb-week-step" data-slate-week-step="-1"' + (week <= 1 ? ' disabled' : '') + ' aria-label="Previous week">‹</button>' +
    '<select class="sb-week-select" data-slate-week-select aria-label="Week">' + opts.join('') + '</select>' +
    '<button type="button" class="sb-week-step" data-slate-week-step="1"' + (week >= 18 ? ' disabled' : '') + ' aria-label="Next week">›</button>' +
    (week === currentWeek ? '' : '<button type="button" class="ghost small sb-week-now" data-slate-week-now>This week</button>') +
    '</div>'
  );
}

/**
 * The summary tiles, in the order they read: the whole board first, then the
 * three outcome buckets, then the number those buckets add up to.
 *
 * `count` pulls each tile's number out of summarizeBoard rather than counting
 * rows here, so the figure on the tile and the games it opens can only ever
 * come from the same place. `empty` finishes the sentence "No ___ this week."
 */
const SLATE_FILTER_META = {
  all: { label: 'All leagues', done: 'All leagues', count: (s) => s.leagues, empty: 'games', doneEmpty: 'games' },
  wins: { label: 'Projected wins', done: 'Wins', count: (s) => s.projectedWins, tone: 'sb-win', empty: 'games you are favored in', doneEmpty: 'wins' },
  losses: { label: 'Projected losses', done: 'Losses', count: (s) => s.projectedLosses, tone: 'sb-loss', empty: 'games you are an underdog in', doneEmpty: 'losses' },
  toss: { label: 'Too close to call', done: 'Ties', count: (s) => s.tooCloseToCall, empty: 'coin-flip games', doneEmpty: 'ties' },
  // Lineups with something you can still fix (the Action Queue's own rules,
  // see slateFixes). Hidden once the week is over: nothing is fixable then.
  fix: { label: 'Need a fix', count: (s) => s.needFix || 0, tone: 'sb-fixn', empty: 'lineups that need a fix' },
  // Once every game is decided, expected wins is just the win count again --
  // summarizeBoard sums win probabilities that are all 1 or 0 by then. The
  // tile is dropped rather than printed twice.
  expected: { label: 'Expected wins', count: (s) => s.expectedWins, empty: 'games' },
};

/** A tile's wording, which changes once the week is in the books. */
function slateFilterLabel(key, done) {
  const meta = SLATE_FILTER_META[key];
  return (done && meta.done) || meta.label;
}

/** The active tile, guarded against a STATE value that is no longer a filter. */
function slateFilter() {
  const f = STATE.slateFilter;
  return SLATE_FILTER_META[f] ? f : 'all';
}

/** The summary row: every tile is a button that narrows the board below it. */
function slateSummaryHtml(s, active, done) {
  const keys = Object.keys(SLATE_FILTER_META).filter((k) => !(done && (k === 'expected' || k === 'fix')));
  const tiles = keys.map((key) => {
    const meta = SLATE_FILTER_META[key];
    const n = meta.count(s);
    const on = key === active;
    // A tile with nothing behind it would open an empty board, so it stays a
    // dead number rather than a button that punishes the click.
    const dead = n === 0 && key !== 'all';
    return (
      '<button type="button" class="sb-stat' + (on ? ' is-on' : '') + '"' +
      ' data-slate-filter="' + key + '" aria-pressed="' + (on ? 'true' : 'false') + '"' +
      (dead ? ' disabled' : '') + '>' +
      '<span class="sb-stat-n' + (meta.tone ? ' ' + meta.tone : '') + '">' + n + '</span>' +
      '<span class="sb-stat-l">' + slateFilterLabel(key, done) + '</span>' +
      '</button>'
    );
  });
  return (
    '<div class="sb-summary" role="group" aria-label="Filter the board">' + tiles.join('') + '</div>' +
    (active === 'all'
      ? ''
      : '<div class="sb-filter-note">Showing ' + slateFilterLabel(active, done).toLowerCase() +
        (active === 'expected' ? ' - every league, best odds first.' : ' only.') +
        ' <button type="button" class="ghost small" data-slate-filter="all">Show all leagues</button></div>')
  );
}

/** Narrow the board to one summary bucket (or back to all of it). */
function setSlateFilter(filter) {
  STATE.slateFilter = SLATE_FILTER_META[filter] ? filter : 'all';
  renderScoreboardView();
}
window.setSlateFilter = setSlateFilter;

async function renderScoreboardView() {
  const container = document.getElementById('scoreboardContent');
  if (!container) return;
  if (!(STATE.leagues || []).length) {
    container.innerHTML = '<div class="tab-empty">Connect your Sleeper leagues to see this week.</div>';
    return;
  }
  if (!window.TacoCore || typeof TacoCore.simulateMatchup !== 'function') {
    container.innerHTML = '<div class="tab-empty">The Slate is still loading.</div>';
    return;
  }
  ensureSlateTimer();
  // Fire-and-forget: if Sleeper's week differs from the one we calculated, the
  // board we are about to paint is the wrong week, so repaint when it lands.
  if (!STATE.nflState && typeof ensureNflState === 'function') {
    const guessed = slateCurrentWeek();
    ensureNflState().then((s) => {
      const wk = Number(s && s.week);
      if (wk >= 1 && wk <= 18 && wk !== guessed && slateActiveView() === 'scoreboard') {
        // Drop any week the user had not explicitly chosen, so the board
        // follows the corrected week rather than staying on the guess.
        if (STATE.slateWeek === guessed) STATE.slateWeek = null;
        renderScoreboardView();
      }
    }).catch(() => {});
  }
  if (!STATE.scoreboardBoards) STATE.scoreboardBoards = {};

  const currentWeek = slateCurrentWeek();
  const week = slateSelectedWeek();
  const isCurrent = week === currentWeek;
  const phase = isCurrent ? 'this week' : (week < currentWeek ? 'final results' : 'upcoming');

  const cachedBoard = STATE.scoreboardBoards[week];
  const hasCache = !!(cachedBoard && cachedBoard.board && cachedBoard.board.length);
  if (!hasCache) {
    container.innerHTML = '<div class="tab-empty">Reading week ' + week + ' across ' + STATE.leagues.length + ' leagues…</div>';
  }
  const data = hasCache ? cachedBoard : await loadScoreboardBoard(week);
  // Stale on return: only the live week changes under you, so only it refreshes.
  if (hasCache && isCurrent && !scoreboardBoardIsFresh()) {
    loadScoreboardBoard(week)
      .then(() => {
        if (slateActiveView() === 'scoreboard') renderScoreboardView();
      })
      .catch(() => {});
  }
  let board = (data.board || []).slice();

  const headHtml =
    '<div class="ma-head sb-head"><div>' +
    '<h2 class="ma-title">The Slate</h2>' +
    '<div class="ma-sub">Week ' + week + ' · ' + phase +
    (board.length ? ' · ' + board.length + ' leagues' : '') +
    ' · projections scored to each league\'s own rules</div>' +
    '</div>' + slateWeekNavHtml(week, currentWeek) + '</div>';

  if (!board.length) {
    container.innerHTML =
      headHtml +
      '<div class="tab-empty">' +
      (isCurrent
        ? 'No matchups found for week ' + week + '. Sleeper publishes these once the week is set.'
        : week > currentWeek
          ? 'Week ' + week + ' has not been posted yet - check back closer to kickoff.'
          : 'No matchups found for week ' + week + '.') +
      '</div>';
    return;
  }

  const anyLive = board.some((r) => r.anyLive);
  const sort = STATE.scoreboardSort || 'closest';
  // On gameday lead with the games actually being played; otherwise honor the
  // chosen sort. byLiveThenClosest degrades to byClosest when nothing is live.
  if (anyLive && TacoCore.byLiveThenClosest) board.sort(TacoCore.byLiveThenClosest);
  else board.sort(sort === 'closest' ? TacoCore.byClosest : TacoCore.byWinProb);
  // Team styles (Owen, 2026-09-27): the same six archetypes and chips as the
  // portfolio's filter, with the Slate's own selection. A selection narrows
  // EVERYTHING below -- cards, summary tiles and the live record -- so the
  // tile counts always describe the cards on screen.
  const archOf = (r) => slateArchetype(r.leagueId);
  const stylesReady = archetypesSettled();
  const styles = stylesReady ? (STATE.slateArchetypeFilter || []).filter((a) => board.some((r) => archOf(r) === a)) : [];
  const styleCounts = {};
  for (const r of board) { const a = archOf(r); styleCounts[a] = (styleCounts[a] || 0) + 1; }
  board = styles.length ? board.filter((r) => styles.includes(archOf(r))) : board;
  const s = TacoCore.summarizeBoard(board);
  const done = week <= currentWeek && board.every((r) => r.settled);
  const fixes = week === currentWeek ? slateFixes(board) : {};
  s.needFix = board.filter((r) => fixes[r.leagueId]).length;
  // Sleeper stores one season-to-date record per roster, so it describes NOW.
  // Printing it on an earlier week would date it wrong, the same way the
  // projections did before they were split from results.
  const showRecords = week === currentWeek;
  const filter = slateFilter();
  const shown = filter === 'fix'
    ? board.filter((r) => fixes[r.leagueId])
    : (TacoCore.filterBoard ? TacoCore.filterBoard(board, filter) : board);
  const live = TacoCore.summarizeLive ? TacoCore.summarizeLive(board) : null;
  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const pct = (p) => Math.round(p * 100);
  const avatar = (ref, name) => '<span class="sb-avatar">' + teamAvatarHtml(ref, name) + '</span>';

  // Live scoreboard mode: when games are on, the headline is your record RIGHT
  // NOW by points on the board -- a different fact from the projected summary
  // below, which asks who is favored by the final whistle.
  const liveHeroHtml = anyLive && live && live.started
    ? '<div class="sb-live-hero">' +
      '<div class="sb-live-hero-head">' +
      '<span class="sb-live-dot" aria-hidden="true"></span>' +
      '<span class="sb-live-hero-title">Live now</span>' +
      '<span class="sb-live-hero-sub">' + live.live + ' game' + (live.live === 1 ? '' : 's') + ' in play</span>' +
      '</div>' +
      '<div class="sb-live-record">' +
      '<div class="sb-lr sb-lr-win"><span class="sb-lr-n">' + live.leading + '</span><span class="sb-lr-l">winning</span></div>' +
      '<div class="sb-lr sb-lr-loss"><span class="sb-lr-n">' + live.trailing + '</span><span class="sb-lr-l">losing</span></div>' +
      (live.tied ? '<div class="sb-lr sb-lr-tie"><span class="sb-lr-n">' + live.tied + '</span><span class="sb-lr-l">tied</span></div>' : '') +
      '</div>' +
      '<div class="sb-live-points">' +
      '<span class="sb-lp-side"><span class="sb-lp-n">' + live.myPoints.toFixed(1) + '</span><span class="sb-lp-l">your points</span></span>' +
      '<span class="sb-lp-diff sb-lp-' + (live.pointDiff >= 0 ? 'up' : 'down') + '">' + (live.pointDiff > 0 ? '+' : '') + live.pointDiff.toFixed(1) + '</span>' +
      '<span class="sb-lp-side"><span class="sb-lp-n">' + live.oppPoints.toFixed(1) + '</span><span class="sb-lp-l">against you</span></span>' +
      '</div>' +
      '</div>'
    : '';

  const card = (r) => {
    const state = r.settled ? 'final' : r.tossUp ? 'toss' : r.winProb > 0.5 ? 'up' : 'down';
    const proj = (n) => (r.settled ? '' : `<span class="sb-proj">${n.toFixed(1)}</span>`);
    const rec = (v) => (showRecords && v ? `<span class="sb-record">${esc(v)}</span>` : '');
    const verdict = r.settled
      ? (r.margin > 0 ? 'Won' : r.margin < 0 ? 'Lost' : 'Tied')
      : r.tossUp ? 'Too close to call' : `${pct(r.winProb)}% to win`;
    // A button that opens the matchup drawer - the lineups no longer expand
    // inline (which grew the board), they open as a clean pop-up.
    //
    // The fix control is a SIBLING of that button, not a child (2026-10-17).
    // It used to be a ~60x18 <span> nested inside the card button, which made
    // it three things it should not have been: a tap target a thumb misses by
    // 13px (hitting the card and opening the drawer instead), a control no
    // keyboard could reach, and interactive content inside a <button>. What is
    // actually broken lived only in title=, which never reaches a phone -- so
    // the card said "2 fixes" and gave you no way to find out which. The list
    // is visible text now.
    const fx = fixes[r.leagueId];
    return (
      '<div class="sb-cell">' +
      `<button type="button" class="sb-card sb-${state}${fx ? ' sb-card-has-fix' : ''}" data-slate-open="${esc(r.leagueId)}">` +
      '<div class="sb-card-head">' +
      `<span class="sb-league">${esc(r.leagueName)}</span>` +
      slateArchPill(archOf(r)) +
      (r.anyLive ? '<span class="sb-card-live">Live</span>' : '') +
      '</div>' +
      '<div class="sb-line">' +
      `<span class="sb-who">${avatar(r.myAvatar, r.myTeam)}<span class="sb-who-name">${esc(r.myTeam)}</span>${rec(r.myRecord)}</span>` +
      `<span class="sb-now">${r.myActual.toFixed(1)}</span>` +
      proj(r.projected) +
      '</div>' +
      '<div class="sb-line sb-opp">' +
      `<span class="sb-who">${avatar(r.oppAvatar, r.opponent)}<span class="sb-who-name">${esc(r.opponent)}</span>${rec(r.oppRecord)}</span>` +
      `<span class="sb-now">${r.theirActual.toFixed(1)}</span>` +
      proj(r.opponentProjected) +
      '</div>' +
      `<div class="sb-verdict"><span class="sb-margin">${r.margin > 0 ? '+' : ''}${r.margin.toFixed(1)}</span>` +
      `<span class="sb-prob">${esc(verdict)}</span>` +
      '<span class="sb-chevron" aria-hidden="true">›</span></div>' +
      '</button>' +
      (fx
        ? `<button type="button" class="sb-fix" data-slate-fix="${esc(r.leagueId)}" aria-label="${esc(fx.count + ' lineup fix' + (fx.count === 1 ? '' : 'es') + ' in ' + r.leagueName + ': ' + fx.what.join(', ') + '. Opens the lineup.')}">` +
          `<span class="sb-fix-n">${fx.count} fix${fx.count === 1 ? '' : 'es'}</span>` +
          `<span class="sb-fix-what">${esc(fx.what.join(' · '))}</span>` +
          '<span class="sb-fix-go" aria-hidden="true">→</span>' +
          '</button>'
        : '') +
      '</div>'
    );
  };

  container.innerHTML =
    headHtml +
    liveHeroHtml +
    '<div class="sb-status sb-sticky">' +
    (anyLive ? '<span class="sb-live-dot" aria-hidden="true"></span><span class="sb-live-label">Live</span>' : '') +
    slateBarHtml(s, live, anyLive, done) +
    `<span class="sb-updated" id="slateUpdated">${esc(slateUpdatedText())}</span>` +
    '<button type="button" class="ghost small sb-refresh" data-slate-refresh>Refresh</button>' +
    '</div>' +
    (data.usedLiveStatus === false
      ? '<div class="sb-note">Live game status is unavailable right now, so games are judged by their date.</div>'
      : '') +
    ((data.failed || []).length
      ? '<div class="sb-note sb-failed">' + data.failed.length + ' league' + (data.failed.length === 1 ? '' : 's') +
        ' could not load: ' + data.failed.map((x) => esc(x.leagueName || x.leagueId)).join(', ') +
        '. <button type="button" class="ghost small" data-slate-refresh>Retry</button></div>'
      : '') +
    slateStylesHtml(styleCounts, styles) +
    slateSummaryHtml(s, filter, done) +
    // No key here (Owen, 2026-09-30: "probably doesnt even need to be there"):
    // the tiles and cards label themselves.
    (shown.length
      ? `<div class="sb-grid">${shown.map(card).join('')}</div>`
      : '<div class="tab-empty">No ' + SLATE_FILTER_META[filter].empty + ' this week.</div>');
}

window.renderScoreboardView = renderScoreboardView;

/**
 * Lineups that still need a fix, per league: the Action Queue's own rules
 * (TacoCore.buildActionQueue) over THIS week's starters from the Slate's rows,
 * so the two pages can never disagree about what is broken. Only what can
 * still be fixed counts: a player whose game has started is locked, and a
 * finished matchup has nothing left to fix.
 * @returns {Object<string, {count, what: string[]}>}
 */
function slateFixes(board) {
  if (!window.TacoCore || !TacoCore.buildActionQueue) return {};
  const open = board.filter((r) => !r.settled);
  if (!open.length) return {};
  const ids = new Set(open.map((r) => String(r.leagueId)));
  const lineups = {};
  const stateOf = {};
  for (const r of open) {
    lineups[String(r.leagueId)] = r.myStarters || [];
    for (const p of r.mine || []) stateOf[String(r.leagueId) + ':' + p.playerId] = p.state;
  }
  const { groups } = TacoCore.buildActionQueue({
    leagues: (STATE.leagues || []).filter((lg) => ids.has(String(lg.league_id))),
    playersDB: STATE.playersDB,
    schedule: STATE.weeklyScheduleMap,
    lineups,
  });
  const out = {};
  const label = { injured: 'injured starter', mistake: 'IR/taxi starter', bye: 'starter on bye', empty: 'empty slot' };
  for (const g of groups || []) {
    if (!label[g.kind]) continue; // questionable and no-NFL-team are not lineup fixes
    for (const l of g.leagues || []) {
      const id = String(l.leagueId);
      if (g.kind !== 'empty' && stateOf[id + ':' + g.playerId] && stateOf[id + ':' + g.playerId] !== 'upcoming') continue;
      const n = g.kind === 'empty' ? (g.slots || 1) : 1;
      const o = (out[id] ||= { count: 0, what: [] });
      o.count += n;
      o.what.push(g.kind === 'empty' ? n + ' ' + label.empty + (n === 1 ? '' : 's') : (g.name || 'player') + ' (' + label[g.kind] + ')');
    }
  }
  return out;
}

/** The sticky bar's numbers: the live record while games are on, else the projection. */
function slateBarHtml(s, live, anyLive, done) {
  const n = (x) => (Number.isFinite(x) ? x : 0);
  if (anyLive && live && live.started) {
    return '<span class="sb-bar"><b>' + n(live.leading) + '-' + n(live.trailing) + (live.tied ? '-' + live.tied : '') + '</b> right now · ' +
      n(live.myPoints).toFixed(1) + ' to ' + n(live.oppPoints).toFixed(1) + '</span>';
  }
  if (done) return '<span class="sb-bar">Final <b>' + n(s.projectedWins) + '-' + n(s.projectedLosses) + '</b></span>';
  return '<span class="sb-bar">Projected <b>' + n(s.projectedWins) + '-' + n(s.projectedLosses) + '</b> · ' +
    n(s.tooCloseToCall) + ' close · ' + (Math.round(n(s.expectedWins) * 10) / 10) + ' exp. wins</span>';
}

// A fix badge sits inside the card button: open the league's lineup instead of the drawer.
document.addEventListener('click', (e) => {
  const fix = e.target.closest && e.target.closest('[data-slate-fix]');
  if (!fix) return;
  e.preventDefault();
  e.stopPropagation();
  const path = '/league/' + fix.dataset.slateFix + '/roster';
  if (typeof navigateFromLink === 'function') navigateFromLink(null, path);
  else location.assign(path);
}, true);

/** Your team's style in a league: the portfolio's own archetypeForRoster. */
function slateArchetype(leagueId) {
  const lg = (STATE.leagues || []).find((l) => l.league_id === leagueId);
  const me = lg && (lg.allRosters || []).find((r) => r.isMe);
  return me && typeof archetypeForRoster === 'function' ? archetypeForRoster(lg, me) : 'Middle Tier';
}

function slateArchPill(arch) {
  if (!archetypesSettled()) return archetypePendingPill('snapshot-arch-pill sb-arch');
  const cls = 'arch-' + String(arch).toLowerCase().replace(/\s+/g, '-');
  return '<span class="snapshot-arch-pill sb-arch ' + cls + '">' + escapeHtml(arch) + '</span>';
}

/** The chip row, in the portfolio's order: strongest style first. */
function slateStylesHtml(counts, active) {
  const order = ['Dynasty Core', 'Contender', 'Ascending', 'Middle Tier', 'Rebuild'];
  const keys = Object.keys(counts).sort((a, b) => (order.indexOf(a) + 1 || 99) - (order.indexOf(b) + 1 || 99));
  if (keys.length < 2 || !archetypesSettled()) return '';
  return '<div class="sb-styles' + (active.length ? ' is-filtering' : '') + '">' +
    '<span class="sb-styles-label">Team styles</span>' +
    keys.map((a) => {
      const on = active.includes(a);
      return '<button type="button" class="stat-strip-arch-item' + (on ? ' active' : '') + '" data-slate-arch="' + escapeHtml(a) + '" aria-pressed="' + on + '">' +
        slateArchPill(a).replace(' sb-arch', '') + '<strong class="snapshot-arch-count">' + counts[a] + '</strong></button>';
    }).join('') +
    (active.length ? '<button type="button" class="stat-strip-arch-clear" data-slate-arch-clear>Show all</button>' : '') +
    '</div>';
}

document.addEventListener('click', (e) => {
  if (!e.target.closest) return;
  const chip = e.target.closest('[data-slate-arch]');
  if (chip) {
    const a = chip.dataset.slateArch;
    const cur = STATE.slateArchetypeFilter || [];
    STATE.slateArchetypeFilter = cur.includes(a) ? cur.filter((x) => x !== a) : [...cur, a];
    renderScoreboardView();
    return;
  }
  if (e.target.closest('[data-slate-arch-clear]')) {
    STATE.slateArchetypeFilter = [];
    renderScoreboardView();
  }
});

/** Change which week the Slate shows. Clamped to the 1-18 regular season; the
 * board for that week loads on demand and is cached, so stepping back to a week
 * already seen is instant. */
function setSlateWeek(week) {
  const w = Math.max(1, Math.min(18, Number(week) || slateCurrentWeek()));
  STATE.slateWeek = w;
  STATE.slateFilter = 'all';
  renderScoreboardView();
}
window.setSlateWeek = setSlateWeek;

// Week stepper (‹ ›) and "This week" reset.
document.addEventListener('click', (e) => {
  if (!e.target.closest) return;
  const step = e.target.closest('[data-slate-week-step]');
  if (step) {
    setSlateWeek(slateSelectedWeek() + Number(step.dataset.slateWeekStep));
    return;
  }
  if (e.target.closest('[data-slate-week-now]')) { setSlateWeek(slateCurrentWeek()); return; }
  const tile = e.target.closest('[data-slate-filter]');
  if (tile) setSlateFilter(tile.dataset.slateFilter);
});

// Week jump dropdown.
document.addEventListener('change', (e) => {
  const sel = e.target.closest ? e.target.closest('[data-slate-week-select]') : null;
  if (sel) setSlateWeek(Number(sel.value));
});

// --- matchup drawer -----------------------------------------------------------
// A game opens as a centered pop-up rather than expanding inline, so the board
// stays short and the breakdown gets room: a two-team hero with a win-probability
// bar, then both full lineups.

let openMatchupLeagueId = null;

function slateMatchupRow(leagueId) {
  const cached = (STATE.scoreboardBoards && STATE.scoreboardBoards[slateSelectedWeek()]) || STATE.scoreboardBoard;
  const list = (cached && cached.board) || [];
  return list.find((x) => String(x.leagueId) === String(leagueId)) || null;
}

function slateMatchupDrawerHtml(r) {
  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const settled = r.settled;
  const myPct = Math.max(0, Math.min(100, Math.round((r.winProb || 0) * 100)));
  const theirPct = 100 - myPct;
  const state = settled ? 'final' : r.tossUp ? 'toss' : r.winProb > 0.5 ? 'up' : 'down';
  const verdict = settled
    ? (r.margin > 0 ? 'Won' : r.margin < 0 ? 'Lost' : 'Tied')
    : r.tossUp ? 'Too close to call' : (myPct + '% to win');
  const phase = r.anyLive ? 'Live' : settled ? 'Final' : 'Upcoming';
  const closeGlyph = typeof icon === 'function' ? icon('close', 16) : '×';
  // Only on the live week: the stored record is season-to-date, so on an
  // earlier week it would describe a season that had not happened yet.
  const drawerRecords = slateSelectedWeek() === slateCurrentWeek();
  const teamCol = (avatarRef, name, actual, proj, record) =>
    '<div class="md-team">' +
    '<div class="md-avatar">' + teamAvatarHtml(avatarRef, name) + '</div>' +
    '<div class="md-team-name">' + esc(name) + '</div>' +
    (drawerRecords && record ? '<div class="md-record">' + esc(record) + '</div>' : '') +
    '<div class="md-score">' + actual.toFixed(1) + '</div>' +
    (settled ? '' : '<div class="md-proj">proj ' + proj.toFixed(1) + '</div>') +
    '</div>';
  return (
    '<div class="md-head">' +
    '<div><div class="md-league">' + esc(r.leagueName) + '</div>' +
    '<div class="md-sub">' + (r.format ? esc(r.format) + ' · ' : '') + phase + '</div></div>' +
    '<button type="button" class="drawer-close md-close" data-slate-drawer-close aria-label="Close">' + closeGlyph + '</button>' +
    '</div>' +
    '<div class="md-hero md-' + state + '">' +
    teamCol(r.myAvatar, r.myTeam, r.myActual, r.projected, r.myRecord) +
    '<div class="md-vs">' +
    '<div class="md-verdict">' + esc(verdict) + '</div>' +
    '<div class="md-margin">' + (r.margin > 0 ? '+' : '') + r.margin.toFixed(1) + '</div>' +
    (settled
      ? ''
      : '<div class="md-prob-bar" aria-hidden="true"><span class="md-prob-me" style="width:' + myPct + '%"></span><span class="md-prob-them" style="width:' + theirPct + '%"></span></div>' +
        '<div class="md-prob-labels"><span>' + myPct + '%</span><span>' + theirPct + '%</span></div>') +
    '</div>' +
    teamCol(r.oppAvatar, r.opponent, r.theirActual, r.opponentProjected, r.oppRecord) +
    '</div>' +
    '<div class="md-lineups">' +
    slateLineupHtml(r.mine || [], r.myTeam, r.myActual, r.projected, esc, settled) +
    slateLineupHtml(r.theirs || [], r.opponent, r.theirActual, r.opponentProjected, esc, settled) +
    '</div>'
  );
}

function openMatchupDrawer(leagueId) {
  const r = slateMatchupRow(leagueId);
  const drawer = document.getElementById('matchupDrawer');
  const overlay = document.getElementById('matchupDrawerOverlay');
  const content = document.getElementById('matchupDrawerContent');
  if (!r || !drawer || !overlay || !content) return;
  openMatchupLeagueId = String(leagueId);
  content.innerHTML = slateMatchupDrawerHtml(r);
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  if (window.TacoFocus) TacoFocus.capture(drawer, { focus: '.drawer-close' });
}
window.openMatchupDrawer = openMatchupDrawer;

function closeMatchupDrawer() {
  const drawer = document.getElementById('matchupDrawer');
  const overlay = document.getElementById('matchupDrawerOverlay');
  openMatchupLeagueId = null;
  if (drawer) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); }
  if (overlay) overlay.classList.remove('open');
  // Leave the scroll lock if the player drawer is also open.
  const pd = document.getElementById('playerDrawer');
  if (!pd || !pd.classList.contains('open')) document.body.style.overflow = '';
  if (window.TacoFocus && drawer) TacoFocus.release(drawer);
}
window.closeMatchupDrawer = closeMatchupDrawer;

// Keep an open drawer current when a live refresh updates the board.
function refreshOpenMatchupDrawer() {
  if (!openMatchupLeagueId) return;
  const content = document.getElementById('matchupDrawerContent');
  const r = slateMatchupRow(openMatchupLeagueId);
  if (content && r) content.innerHTML = slateMatchupDrawerHtml(r);
}
window.refreshOpenMatchupDrawer = refreshOpenMatchupDrawer;

document.addEventListener('click', async (e) => {
  if (!e.target.closest) return;
  const opener = e.target.closest('[data-slate-open]');
  if (opener) { openMatchupDrawer(opener.dataset.slateOpen); return; }
  if (e.target.closest('[data-slate-drawer-close]')) { closeMatchupDrawer(); return; }
  const btn = e.target.closest('[data-slate-refresh]');
  if (!btn) return;
  btn.disabled = true;
  btn.textContent = 'Refreshing…';
  try {
    await loadScoreboardBoard(slateSelectedWeek());
  } catch (err) {
    console.warn('[slate] manual refresh failed', err && err.message);
  }
  if (slateActiveView() === 'scoreboard') renderScoreboardView();
  refreshOpenMatchupDrawer();
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape' && openMatchupLeagueId) closeMatchupDrawer();
});

;
/*! ==== 87-injury-report-panel.js ==== */
// Injury Report — every hurt starter you own, across the whole book.
//
// This is one of the three things a manager opens before kickoff, so it is built
// as an ACTION LIST, not a flat roll-call: players are grouped by severity
// (decisions before worries), each row shows where you're affected (which
// leagues), when the game kicks off (your deadline to act), and the injury
// detail. Cross-league by construction — only this page can tell you a tight end
// is doubtful in nine of your leagues at once.

// Buckets come from shared/action-queue.mjs, the same call "Fix these now"
// makes, so the two pages cannot report different counts for one starter.
function irSeverity(status) {
  const key = window.TacoCore && TacoCore.injurySeverityKey
    ? TacoCore.injurySeverityKey(status)
    : null;
  return key || 'other';
}

// Order = the order a manager should deal with them in. The note states the
// intent of the group so the page reads as advice, not a list.
const IR_GROUPS = [
  { key: 'out', label: 'Out & IR', note: 'Lineup changes you have to make.' },
  { key: 'doubt', label: 'Doubtful', note: 'Likely out - line up a replacement now.' },
  { key: 'quest', label: 'Questionable', note: 'Game-time calls to keep an eye on.' },
  { key: 'other', label: 'Other designations', note: '' },
];

// Players whose "recent updates" panel is expanded, so a re-render can restore it.
const injuryOpen = new Set();

// playerId -> full league-name list, captured at render so the expanded panel
// can show ALL leagues (the row only shows the first few + "+N more").
let injuryLeaguesById = {};

// Kickoff is the deadline to act on a player, so surface it when we know it. The
// schedule map is populated by The Slate; if the user hasn't been there we fetch
// it once (below), so this stays graceful either way.
function injuryKickoffLabel(team) {
  const map = STATE.weeklyScheduleMap;
  const g = map && map[String(team || '').toUpperCase()];
  if (!g || !g.kickoffAt) return '';
  // Day only unless the schedule carries a real time -- it is date-only today,
  // and formatting that as a time printed "8:00 PM" for every game.
  return window.TacoCore && TacoCore.kickoffLabel ? TacoCore.kickoffLabel(g.kickoffAt) : '';
}

let injurySchedLoading = false;
// One light fetch to fill kickoff times if The Slate hasn't already. The schedule
// rides on the projections endpoint. Re-renders when it lands; never blocks the
// list, and a failure just means no kickoff labels.
async function ensureInjurySchedule() {
  if (STATE.weeklyScheduleMap || injurySchedLoading || !BACKEND_URL) return;
  const ctx = window.TacoCore && TacoCore.resolveNflWeekContext ? TacoCore.resolveNflWeekContext() : {};
  const season = ctx.season || String(new Date().getFullYear());
  const week = Number(ctx.week) || 1;
  injurySchedLoading = true;
  try {
    const res = await fetch(BACKEND_URL + '/api/projections?season=' + encodeURIComponent(season) + '&week=' + week);
    if (res.ok) {
      const data = await res.json();
      const full = {};
      for (const [team, g] of Object.entries(data && data.schedule ? data.schedule : {})) {
        full[String(team).toUpperCase()] = g;
      }
      STATE.weeklyScheduleMap = full;
    }
  } catch (_e) {
    // Kickoff labels are a nice-to-have; the report works without them.
  } finally {
    injurySchedLoading = false;
  }
  const active = document.querySelector('.view.active');
  if (active && active.id === 'injuriesView' && Object.keys(STATE.weeklyScheduleMap || {}).length) {
    renderInjuryReportView();
  }
}

function injuryRowHtml(p, esc) {
  const sev = irSeverity(p.status);
  const photo = typeof playerAvatarHtml === 'function' ? playerAvatarHtml(p.playerId, p.name, p.position) : '';
  const logo = p.team && typeof teamLogoHtml === 'function' ? teamLogoHtml(p.team, 'ir-team-logo') : '';
  const kick = injuryKickoffLabel(p.team);
  const n = p.leagues && p.leagues.length ? p.leagues.length : 0;
  const chipArr = (p.leagues || []).slice(0, 3).map((name) => '<span class="ir-league-chip">' + esc(name) + '</span>');
  if (n > 3) chipArr.push('<span class="ir-league-chip ir-league-more">+' + (n - 3) + ' more</span>');
  const pid = esc(p.playerId || '');
  const isOpen = p.playerId && injuryOpen.has(String(p.playerId));
  return (
    '<div class="ir-item">' +
    `<div class="ir-row ir-${sev}${isOpen ? ' ir-open' : ''}"${p.playerId ? ` data-injury-toggle="${pid}"` : ''}>` +
    photo +
    '<div class="ir-body">' +
    '<div class="ir-line1">' +
    `<span class="ir-name">${esc(p.name)}</span>` +
    `<span class="ir-status-pill ir-pill-${sev}">${esc(p.status)}</span>` +
    (kick ? `<span class="ir-kick">${esc(kick)}</span>` : '') +
    '</div>' +
    `<div class="ir-meta">${esc(p.position || '')}${p.team ? ' · ' + logo + esc(p.team) : ''}${p.bodyPart ? ' · ' + esc(p.bodyPart) : ''}</div>` +
    (chipArr.length ? `<div class="ir-leagues">${chipArr.join('')}</div>` : '') +
    '</div>' +
    `<div class="ir-right"><span class="ir-count">${n}</span><span class="ir-count-l">league${n === 1 ? '' : 's'}</span></div>` +
    (p.playerId ? '<span class="ir-expand-chev" aria-hidden="true">▾</span>' : '<span aria-hidden="true"></span>') +
    '</div>' +
    (p.playerId ? `<div class="ir-updates" id="ir-updates-${pid}"${isOpen ? '' : ' hidden'}></div>` : '') +
    '</div>'
  );
}

function renderInjuryReportView() {
  const container = document.getElementById('injuriesContent');
  if (!container) return;

  const leagues = STATE.leagues || [];
  if (!leagues.length) {
    container.innerHTML = '<div class="tab-empty">Connect your Sleeper leagues to see your injury report.</div>';
    return;
  }
  if (typeof collectInjuredStarters !== 'function') {
    container.innerHTML = '<div class="tab-empty">Injury report is still loading.</div>';
    return;
  }

  ensureInjurySchedule(); // fire-and-forget; re-renders with kickoff times when they arrive

  const players = collectInjuredStarters();
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  // Capture each player's full league list so the expanded panel can list them
  // all, including the ones hidden behind "+N more" in the collapsed row.
  injuryLeaguesById = {};
  players.forEach((p) => { if (p.playerId) injuryLeaguesById[String(p.playerId)] = p.leagues || []; });

  const head =
    '<div class="ma-head"><div>' +
    '<h2 class="ma-title">Injury report</h2>' +
    `<div class="ma-sub">Every hurt starter you own, before kickoff - the decisions come first</div>` +
    '</div></div>';

  if (!players.length) {
    container.innerHTML = head + '<div class="tab-empty">No injured starters anywhere in your book. Enjoy it.</div>';
    return;
  }

  const buckets = { out: [], doubt: [], quest: [], other: [] };
  players.forEach((p) => { buckets[irSeverity(p.status)].push(p); });
  const byExposure = (a, b) =>
    (b.leagues ? b.leagues.length : 0) - (a.leagues ? a.leagues.length : 0) ||
    String(a.name).localeCompare(String(b.name));
  Object.keys(buckets).forEach((k) => buckets[k].sort(byExposure));

  const exposure = players.reduce((sum, p) => sum + (p.leagues ? p.leagues.length : 0), 0);
  const summary =
    '<div class="ir-summary">' +
    `<div class="ir-stat"><span class="ir-stat-n">${players.length}</span><span class="ir-stat-l">Injured starters</span></div>` +
    `<div class="ir-stat"><span class="ir-stat-n ir-bad">${buckets.out.length}</span><span class="ir-stat-l">Out or worse</span></div>` +
    `<div class="ir-stat"><span class="ir-stat-n">${exposure}</span><span class="ir-stat-l">Lineup slots affected</span></div>` +
    '</div>';

  const sections = IR_GROUPS.map((g) => {
    const arr = buckets[g.key];
    if (!arr.length) return '';
    return (
      `<div class="ir-section ir-section-${g.key}">` +
      '<div class="ir-section-head">' +
      `<span class="ir-section-title">${g.label}</span>` +
      `<span class="ir-section-count">${arr.length}</span>` +
      (g.note ? `<span class="ir-section-note">${g.note}</span>` : '') +
      '</div>' +
      arr.map((p) => injuryRowHtml(p, esc)).join('') +
      '</div>'
    );
  }).join('');

  container.innerHTML = head + summary + sections;

  // Re-render keeps rows expanded (schedule fetch re-renders once) - reload the
  // updates for anything left open so the panel isn't blank after a rebuild.
  injuryOpen.forEach((id) => loadInjuryUpdates(id));
}

window.renderInjuryReportView = renderInjuryReportView;

// Fill a row's expanded panel with recent news for that player. Reuses the same
// feed the player drawer uses — general player news, which is where injury
// updates land.
function loadInjuryUpdates(playerId) {
  const panel = document.getElementById('ir-updates-' + playerId);
  if (!panel) return;
  const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const bodyId = 'ir-updates-body-' + playerId;
  // Full league list (all of them, not the "+N more" truncation from the row).
  const leagues = injuryLeaguesById[String(playerId)] || [];
  const leaguesHtml = leagues.length
    ? '<div class="ir-updates-head">In ' + leagues.length + ' league' + (leagues.length === 1 ? '' : 's') + '</div>' +
      '<div class="ir-updates-leagues">' + leagues.map((name) => '<span class="ir-league-chip">' + esc(name) + '</span>').join('') + '</div>'
    : '';
  panel.innerHTML =
    leaguesHtml +
    '<div class="ir-updates-head">Recent updates</div>' +
    '<div class="ir-updates-body" id="' + bodyId + '"><div class="drawer-news-empty">Loading recent updates…</div></div>';
  if (typeof loadNewsSection === 'function') loadNewsSection(playerId, bodyId);
}

// Click a player row to expand recent injury updates beneath it.
document.addEventListener('click', (e) => {
  const row = e.target.closest ? e.target.closest('[data-injury-toggle]') : null;
  if (!row) return;
  const pid = row.dataset.injuryToggle;
  const panel = document.getElementById('ir-updates-' + pid);
  if (!panel) return;
  const willOpen = panel.hidden;
  panel.hidden = !willOpen;
  row.classList.toggle('ir-open', willOpen);
  if (willOpen) {
    injuryOpen.add(String(pid));
    loadInjuryUpdates(pid);
  } else {
    injuryOpen.delete(String(pid));
  }
});

;
/*! ==== 88-who-you-need-panel.js ==== */
// Who You Need — the whole book, organised the way a Sunday actually unfolds.
//
// Two things a flat player list cannot do, and both are why this exists:
//
//   It groups by GAME. You do not watch players, you watch games, and the
//   question at 1pm is which of these games you care about and which way.
//   Grouping by matchup also surfaces what a list hides -- a single game where
//   you need one side to score and the other side to fail, because you own
//   players on both. That is the most interesting fact on the page and a flat
//   list can never show it.
//
//   It lets leagues be switched off. A book of thirty is not one question; a
//   manager watching the early window may only care about six of them.
//
// Reads the Slate's cached board, so it costs no extra fetching. All grouping
// maths lives in shared/scoreboard.mjs and is unit tested.

/** Selected league ids. Empty = all, the honest default for a tool whose whole
 * premise is the whole book.
 *
 * A dropdown rather than a row of chips: thirty leagues is thirty chips, which
 * is a wall of buttons above the content people came to read. A select also
 * gets the native picker on a phone for free. */
function rootingSelectedLeagues() {
  if (!Array.isArray(STATE.rootingLeagueFilter)) STATE.rootingLeagueFilter = [];
  return STATE.rootingLeagueFilter;
}

function setRootingLeague(leagueId) {
  STATE.rootingLeagueFilter = leagueId ? [String(leagueId)] : [];
  renderRootingView();
}
window.setRootingLeague = setRootingLeague;

function rootingEsc(t) {
  return String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
}

/** A team as a person would say it. Falls back to the raw code when the
 * shared bundle predates nfl-teams.mjs, so a stale cache degrades to "KC". */
function rootingTeamName(abbr) {
  return window.TacoCore && typeof TacoCore.teamNickname === 'function'
    ? TacoCore.teamNickname(abbr)
    : String(abbr || '');
}

/** One bar per player: green for the leagues where you need him to score, red
 * for the leagues where you need him quiet. Widths share one scale across the
 * whole page, so a long bar means the same number of leagues on every card --
 * scaling per card would make a 1-league game look as loud as a 12-league one. */
function rootingBar(p, scale) {
  const pct = (n) => (scale > 0 ? Math.round((n / scale) * 1000) / 10 : 0);
  return (
    '<div class="ry-bar" aria-hidden="true">' +
    (p.forCount ? '<span class="ry-bar-for" style="width:' + pct(p.forCount) + '%"></span>' : '') +
    (p.againstCount ? '<span class="ry-bar-against" style="width:' + pct(p.againstCount) + '%"></span>' : '') +
    '</div>'
  );
}

// Players whose points breakdown is expanded, so a re-render can restore it.
const rootingOpen = new Set();
// Games the user has opened, by rootingByGame's matchup key. Games start
// closed -- the maker/breaker chip is there so the shut card still says
// whether the game is worth watching.
const rootingGamesOpen = new Set();

function rootingPlayerRow(p, scale) {
  const side = p.conflicted ? 'split' : p.forCount > 0 ? 'for' : 'against';
  const detail = p.conflicted
    ? '<span class="ry-for">' + p.forCount + '</span><span class="ry-sep">/</span><span class="ry-against">' + p.againstCount + '</span>'
    : '<span class="ry-' + side + '">' + (p.forCount || p.againstCount) + '</span>';
  const verb = p.conflicted ? 'both' : p.forCount > 0 ? 'maker' : 'breaker';
  const pid = p.playerId ? rootingEsc(p.playerId) : '';
  const photo = (p.playerId && typeof playerAvatarHtml === 'function') ? playerAvatarHtml(p.playerId, p.name, p.position) : '';
  const isOpen = p.playerId && rootingOpen.has(String(p.playerId));
  return (
    '<div class="ry-player-wrap">' +
    '<div class="ry-player ry-' + side + (p.playerId ? ' ry-clickable' : '') + (isOpen ? ' ry-open' : '') + '"' +
      (p.playerId ? ' data-ry-player="' + pid + '"' : '') + '>' +
    photo +
    '<span class="ry-name">' + rootingEsc(p.name) + '</span>' +
    '<span class="ry-pos">' + rootingEsc(p.position || '') + '</span>' +
    '<span class="ry-verb">' + verb + '</span>' +
    '<span class="ry-count">' + detail + '</span>' +
    rootingBar(p, scale) +
    '</div>' +
    (p.playerId ? '<div class="ry-points" id="ry-points-' + pid + '"' + (isOpen ? '' : ' hidden') + '></div>' : '') +
    '</div>'
  );
}

// Where a player is scoring for or against you this week, per league - from the
// Slate's board (the same fetch this page already reads).
function rootingPlayerBreakdown(playerId) {
  const board = (STATE.scoreboardBoard && STATE.scoreboardBoard.board) || [];
  const rows = [];
  board.forEach(function (r) {
    (r.mine || []).forEach(function (sp) {
      if (String(sp.playerId) === String(playerId)) rows.push({ league: r.leagueName, side: 'for', sp: sp });
    });
    (r.theirs || []).forEach(function (sp) {
      if (String(sp.playerId) === String(playerId)) rows.push({ league: r.leagueName, side: 'against', sp: sp });
    });
  });
  return rows;
}

function rootingPointsHtml(playerId) {
  const rows = rootingPlayerBreakdown(playerId);
  if (!rows.length) return '<div class="ry-points-empty">Not in a starting lineup in your leagues this week.</div>';
  return '<div class="ry-points-list">' + rows.map(function (x) {
    const sp = x.sp;
    const upcoming = sp.state === 'upcoming';
    const num = upcoming
      ? (sp.projected != null ? sp.projected.toFixed(1) : '-')
      : (sp.actual != null ? sp.actual.toFixed(1) : '-');
    return (
      '<div class="ry-points-row">' +
      '<span class="ry-points-side ry-' + x.side + '">' + (x.side === 'for' ? 'For' : 'Against') + '</span>' +
      '<span class="ry-points-league">' + rootingEsc(x.league) + '</span>' +
      '<span class="ry-points-val">' + num + (upcoming ? ' <span class="ry-points-proj">proj</span>' : '') + '</span>' +
      '</div>'
    );
  }).join('') + '</div>';
}

function rootingGameCard(g, scale) {
  const stake = g.stake + ' slot' + (g.stake === 1 ? '' : 's');
  const logo = (abbr) => (typeof teamLogoHtml === 'function' ? teamLogoHtml(abbr, 'ry-team-logo') : '');
  const norm = (t) => String(t || '').toUpperCase();
  const key = rootingEsc(g.key);
  const open = rootingGamesOpen.has(String(g.key));
  const sides = window.TacoCore && typeof TacoCore.gameSideCounts === 'function'
    ? TacoCore.gameSideCounts(g)
    : { makers: 0, breakers: 0, both: 0 };
  const teamGroup = (abbr) => {
    const players = g.players.filter(function (p) { return norm(p.team) === norm(abbr); });
    if (!players.length) return '';
    return (
      '<div class="ry-team-group">' +
      '<div class="ry-team-group-head">' + logo(abbr) + rootingEsc(rootingTeamName(abbr)) + '</div>' +
      players.map(function (p) { return rootingPlayerRow(p, scale); }).join('') +
      '</div>'
    );
  };
  const known = [norm(g.teams[0]), norm(g.teams[1])];
  const orphans = g.players.filter(function (p) { return known.indexOf(norm(p.team)) === -1; });
  // A scoreboard tile, not a text row (Owen: "no life to it"): each team's
  // colour bleeds in from its side, logos stacked, a for/against bar, and the
  // faces you are counting on. The "both ways" tag is gone -- the bar shows it.
  const tc = (abbr) => (typeof NFL_TEAM_COLORS !== 'undefined' && NFL_TEAM_COLORS[norm(abbr)]) || 'var(--border)';
  const total = sides.makers + sides.breakers;
  const forPct = total ? Math.round((sides.makers / total) * 100) : 0;
  const faces = g.players
    .filter(function (p) { return p.forCount > 0 && p.playerId; })
    .sort(function (a, b) { return b.forCount - a.forCount; })
    .slice(0, 4)
    .map(function (p) { return typeof playerAvatarHtml === 'function' ? playerAvatarHtml(p.playerId, p.name, p.position) : ''; })
    .join('');
  return (
    '<div class="ry-game ry2' + (g.crossed ? ' ry-crossed' : '') + (open ? ' ry-game-open' : '') + '"' +
      ' style="--away:' + tc(g.teams[0]) + ';--home:' + tc(g.teams[1]) + '">' +
    '<button type="button" class="ry-game-head ry2-head" data-ry-game="' + key + '"' +
      ' aria-expanded="' + (open ? 'true' : 'false') + '" aria-controls="ry-game-body-' + key + '">' +
    '<span class="ry2-teams">' +
    '<span class="ry2-team">' + logo(g.teams[0]) + '<b>' + rootingEsc(rootingTeamName(g.teams[0])) + '</b></span>' +
    '<span class="ry2-team">' + logo(g.teams[1]) + '<b><i>@</i> ' + rootingEsc(rootingTeamName(g.teams[1])) + '</b></span>' +
    '</span>' +
    '<span class="ry2-meta">' +
    '<span class="ry2-when">' + (g.kickoffDay ? rootingEsc(g.kickoffDay) + ' · ' : '') + stake + '</span>' +
    '<span class="ry2-bar" aria-hidden="true"><i style="width:' + forPct + '%"></i></span>' +
    '<span class="ry2-count"><b class="ry2-for">' + sides.makers + '</b> for you · <b class="ry2-against">' + sides.breakers + '</b> against</span>' +
    '</span>' +
    '<span class="ry2-faces">' + faces + '</span>' +
    '<span class="ry-chevron" aria-hidden="true">›</span>' +
    '</button>' +
    '<div class="ry-game-body" id="ry-game-body-' + key + '"' + (open ? '' : ' hidden') + '>' +
    teamGroup(g.teams[0]) +
    teamGroup(g.teams[1]) +
    (orphans.length
      ? '<div class="ry-team-group">' + orphans.map(function (p) { return rootingPlayerRow(p, scale); }).join('') + '</div>'
      : '') +
    '</div>' +
    '</div>'
  );
}

// Click a game to open its lineups.
document.addEventListener('click', function (e) {
  const head = e.target.closest ? e.target.closest('[data-ry-game]') : null;
  if (!head) return;
  const key = head.dataset.ryGame;
  const body = document.getElementById('ry-game-body-' + key);
  if (!body) return;
  const open = body.hidden;
  body.hidden = !open;
  head.setAttribute('aria-expanded', open ? 'true' : 'false');
  head.closest('.ry-game').classList.toggle('ry-game-open', open);
  if (open) rootingGamesOpen.add(String(key));
  else rootingGamesOpen.delete(String(key));
});

// Click a player to expand where he's scoring for / against you, per league.
document.addEventListener('click', function (e) {
  const row = e.target.closest ? e.target.closest('[data-ry-player]') : null;
  if (!row) return;
  const pid = row.dataset.ryPlayer;
  const panel = document.getElementById('ry-points-' + pid);
  if (!panel) return;
  if (panel.hidden) {
    panel.innerHTML = rootingPointsHtml(pid);
    panel.hidden = false;
    row.classList.add('ry-open');
    rootingOpen.add(String(pid));
  } else {
    panel.hidden = true;
    row.classList.remove('ry-open');
    rootingOpen.delete(String(pid));
  }
});

async function renderRootingView() {
  const container = document.getElementById('rootingContent');
  if (!container) return;
  if (!(STATE.leagues || []).length) {
    container.innerHTML = '<div class="tab-empty">Connect your Sleeper leagues to see who you need.</div>';
    return;
  }
  if (!window.TacoCore || typeof TacoCore.rootingByGame !== 'function') {
    container.innerHTML = '<div class="tab-empty">Still loading.</div>';
    return;
  }

  const cached = STATE.scoreboardBoard;
  if (!cached || !cached.board || !cached.board.length) {
    container.innerHTML = '<div class="tab-empty">Reading this week across ' + STATE.leagues.length + ' leagues…</div>';
  }
  // Reuse the Slate's board only while it is fresh. It never used to expire, so
  // this page sat on whatever the first load of the day had seen.
  const fresh = typeof scoreboardBoardIsFresh === 'function'
    ? scoreboardBoardIsFresh()
    : !!(cached && cached.board && cached.board.length);
  const loaded = fresh ? cached : await loadScoreboardBoard();
  const week = loaded.week;
  const board = loaded.board;
  if (!board.length) {
    container.innerHTML = '<div class="tab-empty">No matchups found for week ' + week + '.</div>';
    return;
  }

  const selected = rootingSelectedLeagues();
  const scoped = TacoCore.filterBoardByLeagues(board, selected);
  const guide = TacoCore.rootingGuide(scoped);
  const games = TacoCore.rootingByGame(guide, STATE.weeklyScheduleMap || {});

  const current = selected.length ? String(selected[0]) : '';
  const options =
    '<option value=""' + (current ? '' : ' selected') + '>All leagues</option>' +
    board
      .map(function (r) {
        const id = String(r.leagueId);
        return (
          '<option value="' + rootingEsc(id) + '"' + (id === current ? ' selected' : '') + '>' +
          rootingEsc(r.leagueName) + '</option>'
        );
      })
      .join('');

  // The busiest player on the page sets the bar scale for every card.
  const scale = games.reduce(function (m, g) {
    return g.players.reduce(function (n, p) { return Math.max(n, p.forCount + p.againstCount); }, m);
  }, 0);

  const scopeNote = selected.length
    ? scoped.length + ' of ' + board.length + ' leagues'
    : 'all ' + board.length + ' leagues';

  container.innerHTML =
    '<div class="ma-head"><div>' +
    '<h2 class="ma-title">Makers &amp; Breakers</h2>' +
    '<div class="ma-sub">Week ' + week + ' by game · ' + scopeNote + '</div>' +
    '</div></div>' +
    // The page name is ours, not the hobby's, and the layout (NFL games, not
    // fantasy matchups) is the second thing that needs explaining.
    '<p class="ry-intro">Every NFL game this week that one of your lineups is riding on. ' +
    'Green is a player you start somewhere, red is one starting against you - ' +
    'open a game to see who.</p>' +
    '<div class="ry-filter">' +
    '<label class="ry-filter-label" for="rootingLeagueSelect">League</label>' +
    '<select id="rootingLeagueSelect" class="ry-select" data-rooting-select>' + options + '</select>' +
    '</div>' +
    (games.length
      ? '<div class="ry-games">' + games.map(function (g) { return rootingGameCard(g, scale); }).join('') + '</div>'
      : '<div class="tab-empty">Nothing to root for in the selected leagues.</div>');

  // Restore any expanded points panels after a re-render (the Slate timer can
  // re-render this view while a panel is open).
  rootingOpen.forEach(function (pid) {
    const panel = document.getElementById('ry-points-' + pid);
    if (panel) { panel.innerHTML = rootingPointsHtml(pid); panel.hidden = false; }
  });
}

window.renderRootingView = renderRootingView;

document.addEventListener('change', function (e) {
  const sel = e.target.closest('[data-rooting-select]');
  if (sel) setRootingLeague(sel.value);
});

;
/*! ==== 89-scout-league.js ==== */
// Scout a League -- any public Sleeper dynasty league, analysed without a login.
//
// Every other page describes the viewer's own book. This one answers the
// question someone has BEFORE connecting, or about a league that is not theirs:
// who is strong here, who is rebuilding, how does it score. Sleeper's league
// endpoints are public, and nothing in enrichment needs the viewer to be a
// member. Only the "me" fields do, and a scout has no me.
//
// Kept apart from a loaded portfolio on purpose. It replaces STATE.leagues with
// the one scouted league, and every way in or out is a full page load, so the
// two never share state. The app nav is hidden in scout mode for the same
// reason: its pages would present this league as the viewer's own book.
//
// Writes nothing. STATE.username stays null, which keeps crawl registration and
// trade-history pushes off (crawl-sync.js), and the share buttons that would
// insert into D1 are hidden while scoutMode is set.

// Sleeper roster owner_ids are numeric strings, so this can never equal one. The
// default userId is null, and null DOES equal an orphaned roster's owner_id,
// which would quietly crown an ownerless team "you".
const SCOUT_NO_OWNER = 'scout:no-owner';

const SCOUT_MESSAGES = {
  empty: 'Paste a league link first.',
  invite: "That's an invite link. Open it in Sleeper, go to the league, and copy that page's address instead.",
  draft: "That's a draft link. Open the league itself on sleeper.com and copy that address.",
  unknown: "That doesn't look like a Sleeper league link. It should look like sleeper.com/leagues/ followed by a long number.",
};

const SCOUT_NOT_FOUND = 'No Sleeper league matches that link. Check you copied the whole address.';

function scoutEsc(t) {
  return escapeHtml(String(t == null ? '' : t));
}

function scoutFormHtml(buttonLabel) {
  return (
    '<form class="scout-form" data-scout-form novalidate>' +
    '<input class="scout-input" type="text" inputmode="url" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false"' +
    ' aria-label="Sleeper league link or ID" placeholder="sleeper.com/leagues/…">' +
    '<button type="submit" class="scout-go">' + scoutEsc(buttonLabel) + '</button>' +
    '</form>'
  );
}

function renderScoutIntro(message) {
  const c = document.getElementById('scoutContent');
  if (!c) return;
  c.innerHTML =
    '<div class="scout-intro">' +
    '<div class="scout-eyebrow">Scout a league</div>' +
    '<h2 class="scout-title">See how any league stacks up</h2>' +
    '<p class="scout-note">Paste a Sleeper dynasty league\'s link: the address of its page on sleeper.com. ' +
    "Every team gets ranked by value in that league's own format. No login, and you don't need to be in the league.</p>" +
    (message ? '<div class="scout-error" role="alert">' + scoutEsc(message) + '</div>' : '') +
    scoutFormHtml('Scout league') +
    '</div>';
}

async function scoutFail(message) {
  await showView('scout');
  renderScoutIntro(message);
}

/** Enrich the cached league as `ownerId` (or as nobody) and install it. No
 * network: the payloads were cached by loadScoutLeague, and enrichLeague reads
 * that cache before it would fetch. */
async function scoutEnrichAs(ownerId) {
  const payload = STATE._portfolioBootstrap?.leaguePayloads?.[0];
  if (!payload) return null;
  const enriched = await enrichLeague(payload.league, { userId: ownerId || SCOUT_NO_OWNER });
  STATE.leagues = [enriched];
  STATE.currentTeamIdx = 0;
  STATE.scoutViewAs = ownerId || null;
  await hydrateReturnStatsForLeagues(STATE.leagues).catch(() => {});
  applyLeagueValuesToRosters(STATE.leagues);
  rebuildAllPlayerValues();
  // A different "me" is a different trade. The calculator keeps its sides and
  // picks across renders, so start it over rather than show the last team's.
  STATE.tradeInitialized = false;
  TRADE.sideARosterId = null;
  TRADE.sideBRosterId = null;
  TRADE.sideAAssets.clear();
  TRADE.sideBAssets.clear();
  return enriched;
}

async function loadScoutLeague(leagueId, opts = {}) {
  STATE.scoutMode = true;
  STATE.username = null;
  document.body.classList.add('scout-mode');

  if (!leagueId) {
    await showView('scout');
    renderScoutIntro(opts.invalid ? SCOUT_MESSAGES.unknown : '');
    return;
  }

  showLoading();
  setLoader('Reading the league');
  let lg;
  try {
    lg = await api('/league/' + encodeURIComponent(leagueId));
  } catch (err) {
    // An unknown league ID is a 404 from Sleeper (checked 2026-09-13). The Worker
    // proxy relays it as a 502, api() falls back to Sleeper directly, and that
    // throws "Sleeper API 404". A wrong link, not an outage, so say so.
    if (/Sleeper API 404/.test(String(err && err.message))) return scoutFail(SCOUT_NOT_FOUND);
    return scoutFail("Sleeper isn't responding right now. Try again in a minute.");
  }
  // Some Sleeper endpoints answer an unknown ID with 200 and null instead.
  if (!lg || !lg.league_id) return scoutFail(SCOUT_NOT_FOUND);
  if (!isDynastyLeague(lg)) return scoutFail(`“${lg.name}” is a redraft league. The Armchair Office reads dynasty leagues.`);

  try {
    STATE.season = lg.season;
    const tab = detectScoringTab(lg);
    setLoader('Loading players and ' + tab + ' values');
    await ensurePlayersDB();
    // The value sources a portfolio load uses, for this one format. The market
    // fallbacks may fail without harm; the composite is what prices the board.
    await Promise.allSettled([hydrateBackendComposites([tab]), fetchAllFcValues([lg]), loadDynastyProcess()]);
    setLoader('Pricing all ' + (lg.total_rosters || '') + ' rosters');
    // Fetched once and cached where enrichLeague looks first, so viewing the
    // league as any of its managers re-enriches without fetching again.
    STATE._portfolioBootstrap = { leaguePayloads: [await fetchLeaguePayload(lg)] };
    await scoutEnrichAs(null);
    await showView('scout');
    renderScoutView();
    if (typeof trackEvent === 'function') trackEvent('scout_loaded', { teams: lg.total_rosters, format: tab });
  } catch (err) {
    console.error('[scout]', err);
    scoutFail("Couldn't read that league. Try again in a minute.");
  }
}
window.loadScoutLeague = loadScoutLeague;

/** Managers who can be viewed as: rosters with an owner. An orphaned roster has
 * no owner_id, and "me" is matched on owner_id, so it cannot play the part. */
function scoutViewAsOptions() {
  const payload = STATE._portfolioBootstrap?.leaguePayloads?.[0];
  const lg = STATE.leagues && STATE.leagues[0];
  if (!payload || !lg) return [];
  return (payload.rosters || [])
    .filter((r) => r && r.owner_id)
    .map((r) => {
      const row = (lg.allRosters || []).find((x) => String(x.rosterId) === String(r.roster_id));
      const team = row?.teamName || 'Team ' + r.roster_id;
      const owner = row?.ownerName && row.ownerName !== team ? ' (' + row.ownerName + ')' : '';
      return { ownerId: String(r.owner_id), label: team + owner };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
}

function scoutViewAsSelectHtml(emptyLabel) {
  const current = STATE.scoutViewAs || '';
  return (
    '<select data-scout-viewas aria-label="View this league as a manager">' +
    '<option value=""' + (current ? '' : ' selected') + '>' + scoutEsc(emptyLabel) + '</option>' +
    scoutViewAsOptions()
      .map((o) => '<option value="' + scoutEsc(o.ownerId) + '"' + (o.ownerId === current ? ' selected' : '') + '>' + scoutEsc(o.label) + '</option>')
      .join('') +
    '</select>'
  );
}

/** Top of the league page while a scouted league is viewed as someone: whose
 * side this is, a way back to the board, and a way to switch. Called from
 * renderTeamDetail. */
function scoutTeamBarHtml(lg) {
  const me = (lg.allRosters || []).find((r) => r.isMe);
  return (
    '<div class="scout-teambar">' +
    '<button type="button" class="scout-back" data-scout-back>← ' + scoutEsc(lg.name) + '</button>' +
    '<span class="scout-teambar-label">Viewing as <strong>' + scoutEsc(me ? me.teamName : 'a manager') + '</strong></span>' +
    scoutViewAsSelectHtml('Back to the league board') +
    '</div>'
  );
}
window.scoutTeamBarHtml = scoutTeamBarHtml;

function renderScoutView() {
  const c = document.getElementById('scoutContent');
  const lg = STATE.scoutMode && STATE.leagues ? STATE.leagues[0] : null;
  if (!c || !lg) return;
  const status = { pre_draft: 'Pre-draft', drafting: 'Drafting', in_season: 'In season', complete: 'Season complete' }[lg.status] || '';
  const facts = [lg.total_rosters + ' teams', lg.scoringTab, lg.season + ' season', status].filter(Boolean);
  c.innerHTML =
    '<div class="scout-head">' +
    '<div class="scout-eyebrow">Scouting</div>' +
    '<h2 class="scout-title">' + scoutEsc(lg.name) + '</h2>' +
    '<div class="scout-sub">' + facts.map(scoutEsc).join(' · ') + '</div>' +
    '<div class="scout-actions">' +
    '<a class="scout-sleeper" href="https://sleeper.com/leagues/' + scoutEsc(lg.league_id) + '" target="_blank" rel="noopener">Open in Sleeper ↗</a>' +
    // A plain link, not data-router: leaving scout mode is a full load.
    '<a class="scout-cta" href="/connect">One of these teams yours? Load your leagues →</a>' +
    '</div>' +
    '</div>' +
    '<div class="scout-viewas">' +
    '<span class="scout-viewas-label">View as a manager</span>' +
    scoutViewAsSelectHtml('Pick a team…') +
    '<span class="scout-viewas-note">See this league from their side: roster, needs, picks and trade tools.</span>' +
    '</div>' +
    '<div class="scout-section">' + safePanelRender('League scoring', () => renderLeagueScoringPanelHtml(lg)) + '</div>' +
    '<div class="scout-section">' + safePanelRender('League Rankings', () => renderPowerRankingsPanel(lg)) + '</div>' +
    '<div class="scout-again">' +
    '<div class="scout-note">Scout another league</div>' +
    scoutFormHtml('Scout') +
    '</div>';
}
window.renderScoutView = renderScoutView;

async function scoutViewAs(ownerId) {
  if (!STATE.scoutMode) return;
  if (!ownerId) {
    await scoutEnrichAs(null);
    await showView('scout');
    renderScoutView();
    return;
  }
  const enriched = await scoutEnrichAs(ownerId);
  if (!enriched) return;
  STATE.teamDetailTab = 'overview';
  await showView('team');
  renderTeamDetail();
  if (typeof trackEvent === 'function') trackEvent('scout_view_as', { format: enriched.scoringTab });
}
window.scoutViewAs = scoutViewAs;

document.addEventListener('change', (e) => {
  const sel = e.target && e.target.closest ? e.target.closest('[data-scout-viewas]') : null;
  if (sel) scoutViewAs(sel.value);
});

// Back to the board, still viewing as the same manager: the board then marks
// that team, which is the comparison someone just went looking for.
document.addEventListener('click', async (e) => {
  if (!e.target.closest || !e.target.closest('[data-scout-back]')) return;
  e.preventDefault();
  await showView('scout');
  renderScoutView();
});

// Paste form, on both the intro and the bottom of a scouted board. A league goes
// to its own URL with a full load; anything else explains itself in place, so a
// bad paste never wipes the board someone is reading.
document.addEventListener('submit', (e) => {
  const form = e.target && e.target.closest ? e.target.closest('[data-scout-form]') : null;
  if (!form) return;
  e.preventDefault();
  const value = form.querySelector('input')?.value || '';
  const R = window.TacoRoutes || {};
  const parsed = R.parseLeagueInput ? R.parseLeagueInput(value) : { kind: 'unknown' };
  if (parsed.kind === 'league') {
    window.location.assign('/scout/' + parsed.leagueId);
    return;
  }
  let err = form.previousElementSibling;
  if (!err || !err.classList.contains('scout-error')) {
    err = document.createElement('div');
    err.className = 'scout-error';
    err.setAttribute('role', 'alert');
    form.parentNode.insertBefore(err, form);
  }
  err.textContent = SCOUT_MESSAGES[parsed.kind] || SCOUT_MESSAGES.unknown;
});

;
/*! ==== 90-advanced-stats.js ==== */
// Advanced Stats explorer (Scouting). Leaderboards on top, a sortable/filterable
// table below. One bulk Sleeper fetch per season, joined to the full players DB
// for names/positions/teams (so team-share denominators are accurate) and to the
// value data for a dynasty-value column. All the metric math lives in
// shared/advanced-stats.mjs (TacoCore); this file fetches, joins and renders.

// api.sleeper.app is allowed by the CSP connect-src. The v1 bulk season endpoint
// returns every player keyed by pid in one ~1.2MB payload.
const ADV_STATS_BASE = 'https://api.sleeper.app/v1/stats/nfl/regular';

function advStatsCurrentSeason() {
  return String(STATE.season || new Date().getFullYear());
}

/**
 * nflverse-derived numbers for a season (CPOE, PROE, expected points, deep /
 * goal-line share), built daily by the Worker (taco-backend/src/nflverse.js).
 * Optional: a failure or a season with no file leaves those columns empty and
 * everything else works. On arrival the rows are rebuilt and the page repainted.
 */
async function fetchNflverseAdvanced(season) {
  const key = String(season);
  if (!STATE.advNflverseBySeason) STATE.advNflverseBySeason = {};
  if (key in STATE.advNflverseBySeason) return;
  STATE.advNflverseBySeason[key] = null; // in flight / tried
  try {
    const res = await fetch(`${BACKEND_URL}/api/advanced/nflverse?season=${encodeURIComponent(key)}`);
    if (!res.ok) return;
    STATE.advNflverseBySeason[key] = await res.json();
    if (STATE._advStatsRows) delete STATE._advStatsRows[key];
    if (document.querySelector('.view.active')?.id === 'advancedStatsView' && STATE.advStatsBySeason[key]) paintAdvancedStats();
  } catch (_e) { /* optional data: the page stands without it */ }
}

/** One bulk fetch per season, cached with an in-flight guard. */
async function fetchAdvancedBulkStats(season) {
  const key = String(season);
  if (STATE.advStatsBySeason[key]) return STATE.advStatsBySeason[key];
  if (STATE._advStatsFetching[key]) return STATE._advStatsFetching[key];
  STATE._advStatsFetching[key] = (async () => {
    try {
      const res = await fetch(`${ADV_STATS_BASE}/${encodeURIComponent(key)}?season_type=regular`);
      if (!res.ok) throw new Error('stats ' + res.status);
      const data = await res.json();
      STATE.advStatsBySeason[key] = data && typeof data === 'object' ? data : {};
    } catch (e) {
      console.warn('[advstats] bulk fetch failed', e && e.message);
      // Deliberately do NOT cache a failure: an empty object is truthy, so it
      // would satisfy the refetch guard forever and render "no stats posted
      // yet" -- a false claim about the data -- until a hard reload. Rethrow so
      // the caller can show a real error with a retry.
      throw e;
    } finally {
      delete STATE._advStatsFetching[key];
    }
    return STATE.advStatsBySeason[key];
  })();
  return STATE._advStatsFetching[key];
}

/** pid -> {name, position, team, value, age} from the players DB (all players,
 * for accurate team totals) overlaid with dynasty value from a preferred format. */
function advStatsPreferredValueTab() {
  const tabs = Object.keys(STATE.fcRaw || {});
  return ['SF TE+', 'SF', '1QB TE+', '1QB'].find((t) => tabs.includes(t)) || tabs[0];
}

/** Cheap fingerprint of what the rows' value/age would be built from. This runs
 * on every cache check -- including every search keystroke -- so it stays O(1):
 * fcRaw has a handful of format tabs, and a Map's size is free. Rows snapshot
 * value/age, so without this the Value column would stay frozen at whatever had
 * hydrated when the rows were first built while every other view moved on.
 * A not-yet-loaded players DB needs no term here: the caller already refuses a
 * cache whose rows are empty. */
function advStatsMetaKey() {
  const preferTab = advStatsPreferredValueTab();
  const vlook = preferTab && STATE.fcPlayerLookup ? STATE.fcPlayerLookup[preferTab] : null;
  return (preferTab || '-') + ':' + (vlook && vlook.size != null ? vlook.size : 0);
}

function advStatsMetaById() {
  const meta = {};
  const db = STATE.playersDB || {};
  const preferTab = advStatsPreferredValueTab();
  const vlook = preferTab && STATE.fcPlayerLookup ? STATE.fcPlayerLookup[preferTab] : null;
  for (const pid of Object.keys(db)) {
    const p = db[pid];
    if (!p || !p.position) continue;
    const name = p.full_name || [p.first_name, p.last_name].filter(Boolean).join(' ') || pid;
    const v = vlook && vlook.get ? vlook.get(String(pid)) : null;
    meta[pid] = {
      name,
      position: p.position,
      team: p.team || '',
      value: v && v.value != null ? v.value : null,
      age: v && v.age != null ? v.age : (p.age != null ? p.age : null),
    };
  }
  return { meta, valueFormat: preferTab || null };
}

/** Compute (and cache) the advanced rows for one season. */
function advStatsRowsForSeason(season) {
  if (!STATE._advStatsRows) STATE._advStatsRows = {};
  const key = String(season);
  const metaKey = advStatsMetaKey();
  const hit = STATE._advStatsRows[key];
  // Require a non-empty cache: a cache built before playersDB loaded would be
  // empty, and returning it would leave the drawer/explorer blank forever.
  // Also require the same value fingerprint, or the Value column stays frozen
  // at whatever was hydrated when the rows were first built.
  if (hit && hit.rows && hit.rows.length && hit.metaKey === metaKey) return hit.rows;
  const { meta, valueFormat } = advStatsMetaById();
  const raw = STATE.advStatsBySeason[key] || {};
  // Team shares divide by a denominator summed via each player's CURRENT team,
  // so they are only trustworthy for the live season -- see computeAdvancedRows.
  const rows = TacoCore.computeAdvancedRows(raw, meta, {
    minGames: 1,
    teamShares: key === advStatsCurrentSeason(),
  });
  const nfl = STATE.advNflverseBySeason && STATE.advNflverseBySeason[key];
  if (nfl && TacoCore.mergeNflverseAdvanced) {
    TacoCore.mergeNflverseAdvanced(rows, nfl, { teamStats: key === advStatsCurrentSeason() });
  }
  STATE._advStatsRows[key] = { rows, metaKey };
  STATE._advStatsValueFormat = valueFormat;
  return rows;
}

// --- rendering ---------------------------------------------------------------

// The page is position-first: pick QB / RB / WR / TE and both the leaderboards
// and the table below switch to that position's relevant stats. No "ALL" -- a
// board mixing a QB's pass yards with a WR's target share means nothing.
const ADV_POS_FILTERS = ['QB', 'RB', 'WR', 'TE'];
const ADV_DEFAULT_POS = 'WR';

// Short column headers for the table (the registry labels are long).
const ADV_COL_LABELS = {
  passYdsPerGame: 'PaYd/g', passAttPerGame: 'Att/g', completionPct: 'Cmp%', ydsPerAttempt: 'Y/Att', passADOT: 'aDOT', passTdPerGame: 'PaTD/g', rzPassAttPerGame: 'RZAtt/g', teamRzPassRate: 'TmRZPass%', cpoe: 'CPOE', teamProe: 'PROE', teamIn10PassRate: 'TmIn10Pass%', xfpPerGame: 'xFP/g', fpoePerGame: 'FPOE/g', deepShare: 'Deep%', glShare: 'GL%',
  snapShare: 'Snap%', targetShare: 'Tgt%', targetsPerGame: 'Tgt/g', oppsPerGame: 'Opp/g', airYardsPerGame: 'AirY/g', aDOT: 'aDOT', rzOppsPerGame: 'RZ/g', rzOppShare: 'RZ%', airYardsShare: 'Air%', wopr: 'WOPR', ydsPerTeamPassAtt: 'Y/TmAtt',
  rushShare: 'Ru%', carriesPerGame: 'Ru/g', rushYdsPerGame: 'RuYd/g', ydsPerCarry: 'Y/Ca',
  ydsPerTarget: 'Y/Tgt', ydsPerRec: 'Y/Rec', yacPerRec: 'YAC/Rec', ptsPerOpp: 'Pts/Opp', ptsPerSnap: 'Pts/Snp', pprPerGame: 'PPR/g',
  halfPprPerGame: 'Half/g', stdPerGame: 'Std/g', totalTd: 'TD', recPerGame: 'Rec/g', recYdsPerGame: 'RecYd/g', catchRate: 'Catch%',
  touchesPerGame: 'Tch/g', scrimmageYdsPerGame: 'Scrim/g', firstDownsPerGame: '1D/g', snapsPerGame: 'Snp/g', intRate: 'INT%',
};

/** Table columns for one position: every metric that applies to it, plus value. */
function advColumnsFor(pos) {
  const cols = TacoCore.ADV_METRICS
    .filter((m) => m.positions.includes(pos))
    .map((m) => ({ key: m.key, label: ADV_COL_LABELS[m.key] || m.label, fmt: m.fmt }));
  cols.push({ key: 'value', label: 'Value', fmt: 'val' });
  return cols;
}

const ADV_MAX_ROWS = 200;

// Which columns each preset shows. A key in no list appears under All only.
// The sorted column always stays visible, whatever the preset.
const ADV_PRESETS = {
  usage: ['snapShare', 'snapsPerGame', 'touchesPerGame', 'recPerGame', 'targetShare', 'targetsPerGame', 'oppsPerGame', 'rushShare', 'carriesPerGame', 'airYardsPerGame', 'airYardsShare',
    'aDOT', 'wopr', 'deepShare', 'rzOppsPerGame', 'rzOppShare', 'glShare', 'passAttPerGame', 'passADOT', 'rzPassAttPerGame', 'teamRzPassRate', 'teamProe', 'teamIn10PassRate'],
  efficiency: ['catchRate', 'ydsPerTeamPassAtt', 'ydsPerTarget', 'ydsPerRec', 'yacPerRec', 'ydsPerCarry', 'ptsPerOpp', 'ptsPerSnap', 'completionPct', 'ydsPerAttempt', 'intRate', 'cpoe', 'fpoePerGame'],
  scoring: ['pprPerGame', 'halfPprPerGame', 'stdPerGame', 'totalTd', 'xfpPerGame', 'fpoePerGame', 'recYdsPerGame', 'scrimmageYdsPerGame', 'firstDownsPerGame', 'passYdsPerGame', 'passTdPerGame', 'rushYdsPerGame', 'value'],
};
const ADV_PRESET_LABELS = [['usage', 'Usage'], ['efficiency', 'Efficiency'], ['scoring', 'Scoring'], ['all', 'All']];
function advPreset() { return ADV_PRESETS[STATE.advStatsPreset] || STATE.advStatsPreset === 'all' ? STATE.advStatsPreset : 'usage'; }

function advFmt(val, fmt) {
  if (val == null) return '<span class="adv-null">-</span>';
  if (fmt === 'pct') return val + '%';
  if (fmt === 'val') return typeof formatCompactNumber === 'function' ? formatCompactNumber(val) : val;
  return val;
}

function advSortRows(rows, key, dir) {
  const mult = dir === 'asc' ? 1 : -1;
  const textKey = key === 'name' || key === 'position' || key === 'team';
  return [...rows].sort((a, b) => {
    const av = a[key];
    const bv = b[key];
    const an = av == null;
    const bn = bv == null;
    if (an && bn) return 0;
    if (an) return 1; // nulls always last, regardless of direction
    if (bn) return -1;
    if (textKey) return String(av).localeCompare(String(bv)) * mult;
    return (av - bv) * mult;
  });
}

function advPlayerCell(r) {
  const photo = typeof playerAvatarHtml === 'function' ? playerAvatarHtml(r.pid, r.name, r.position) : '';
  const logo = r.team && typeof teamLogoHtml === 'function' ? teamLogoHtml(r.team, 'adv-team-logo') : '';
  return (
    '<span class="adv-player">' + photo +
    '<span class="adv-player-txt"><span class="adv-player-name">' + escapeHtml(r.name) + '</span>' +
    '<span class="adv-player-meta"><span class="adv-pos pos-' + escapeHtml((r.position || '').toLowerCase()) + '">' + escapeHtml(r.position || '') + '</span>' +
    logo + escapeHtml(r.team || '') + '</span></span></span>'
  );
}

function renderAdvancedStatsView() {
  const el = document.getElementById('advancedStatsContent');
  if (!el) return;
  if (!window.TacoCore || typeof TacoCore.computeAdvancedRows !== 'function') {
    el.innerHTML = '<div class="tab-empty">Advanced stats are still loading.</div>';
    return;
  }

  // Season totals (never week-by-week). Defaults to the live season, which
  // accumulates as games are played; the picker steps back through prior seasons.
  const season = STATE.advStatsSeason || advStatsCurrentSeason();
  STATE.advStatsSeason = season;
  fetchNflverseAdvanced(season); // optional, repaints when it lands

  // Need both the players DB (metadata) and the bulk stats for this season.
  const needDb = !STATE.playersDB;
  const needStats = !STATE.advStatsBySeason[String(season)];
  if (needDb || needStats) {
    el.innerHTML = '<div class="adv-loading"><h2 class="overview-title">Advanced Stats</h2>' +
      '<div class="tab-empty">Loading the ' + escapeHtml(String(season)) + ' league-wide stats…</div></div>';
    Promise.all([
      needDb && typeof ensurePlayersDB === 'function' ? ensurePlayersDB() : Promise.resolve(),
      fetchAdvancedBulkStats(season),
    ]).then(() => {
      if (STATE._advStatsRows) delete STATE._advStatsRows[String(season)];
      // Only paint if the user is still on this view.
      if (document.querySelector('.view.active')?.id === 'advancedStatsView') paintAdvancedStats();
    }).catch((err) => {
      // ensurePlayersDB() rethrows, and the bulk fetch now rethrows too. Without
      // this the view sits on "Loading..." forever on a cold, offline visit.
      console.warn('[advstats] load failed', err && err.message);
      if (document.querySelector('.view.active')?.id === 'advancedStatsView') paintAdvancedStatsError(season);
    });
    return;
  }
  paintAdvancedStats();
}
window.renderAdvancedStatsView = renderAdvancedStatsView;

/** The load failed (Sleeper down, offline). Distinct from "no stats yet", and
 * retryable -- nothing was cached, so re-rendering the view refetches. */
function paintAdvancedStatsError(season) {
  const el = document.getElementById('advancedStatsContent');
  if (!el) return;
  el.innerHTML = advStatsHeaderHtml(season) +
    '<div class="tab-empty">Could not load the ' + escapeHtml(String(season)) + ' stats just now. ' +
    '<button type="button" class="adv-retry" data-adv-retry>Try again</button></div>';
}

function paintAdvancedStats() {
  const el = document.getElementById('advancedStatsContent');
  if (!el) return;
  const season = STATE.advStatsSeason || advStatsCurrentSeason();
  STATE.advStatsSeason = season;
  const allRows = advStatsRowsForSeason(season);
  const pos = ADV_POS_FILTERS.includes(STATE.advStatsPos) ? STATE.advStatsPos : ADV_DEFAULT_POS;
  STATE.advStatsPos = pos;

  const posTabs = '<div class="adv-postabs">' + ADV_POS_FILTERS.map((p) =>
    '<button type="button" class="adv-postab' + (p === pos ? ' active' : '') + '" data-adv-pos="' + p + '">' + p + '</button>').join('') + '</div>';

  if (!allRows.length) {
    el.innerHTML = advStatsHeaderHtml(season) + posTabs + advStatsControlsHtml(season) +
      '<div class="tab-empty">No stats posted for ' + escapeHtml(String(season)) + ' yet - check back once games are played.</div>';
    return;
  }

  const posRows = allRows.filter((r) => r.position === pos);
  // Full season stats: the table shows every player, no games filter. maxGp
  // feeds the header's sample line. (The leaderboard games floor that used to
  // sit here went with the top-10 boards on 2026-09-30.)
  const maxGp = posRows.reduce((m, r) => Math.max(m, r.games), 0) || 1;

  // No per-position top-10 boards above the table (Owen, 2026-09-30: "we do not
  // need the top 10 rankings ... the large board is fine"). Sort any column instead.
  const isLiveSeason = String(season) === advStatsCurrentSeason();
  const shareNote = isLiveSeason ? '' :
    '<div class="adv-cap-note">Target and rush share are hidden for past seasons: the team denominator comes from current rosters, so a player traded since would be counted against the wrong team.</div>';

  const searchHtml = '<input type="search" class="adv-search" data-adv-search placeholder="Search ' + escapeHtml(pos) + 's" value="' + escapeHtml(STATE.advStatsSearch || '') + '" aria-label="Search player">';

  el.innerHTML =
    advStatsHeaderHtml(season, maxGp) +
    posTabs +
    advStatsControlsHtml(season) +
    shareNote +
    '<div class="adv-section-label">All ' + escapeHtml(pos) + 's</div>' +
    '<div class="adv-players-bar">' + searchHtml + '</div>' +
    advStatsKeyHtml() +
    '<div id="advTableRegion">' + advTableRegionHtml(posRows, { pos }) + '</div>' +
    // Visible, not only inside the collapsed key: CC-BY wants the credit where
    // the data is shown.
    '<p class="adv-sources">Data: Sleeper · nflverse (CC-BY 4.0) · ffopportunity · DynastyProcess</p>';
}
window.paintAdvancedStats = paintAdvancedStats;

function advStatsKeyHtml() {
  return typeof renderKey === 'function' ? renderKey([
    { term: 'Snap%', def: 'Share of the team\'s offensive snaps this player was on the field for.' },
    { term: 'Target share', def: 'Share of the team\'s total targets that went to this player.' },
    { term: 'Rush share', def: 'Share of the team\'s carries this player got.' },
    { term: 'aDOT', def: 'Average depth of target (or throw, for a QB) - how far downfield, in yards.' },
    { term: 'RZ/g', def: 'Red-zone opportunities (targets + carries inside the 20) per game.' },
    { term: 'RZ%', def: 'Share of the team\'s red-zone opportunities this player got - who the offense trusts where touchdowns are scored.' },
    { term: 'Air%', def: 'Share of the team\'s air yards (how far downfield every target travelled, caught or not) - his downfield role.' },
    { term: 'WOPR', def: 'Weighted opportunity rating: 1.5 x target share + 0.7 x air-yards share. Around 0.7 or more is a true No. 1 receiver.' },
    { term: 'Y/TmAtt', def: 'Receiving yards per team pass attempt. A stand-in for yards per route run, which needs paid route charting - it credits every dropback, route or not.' },
    { term: 'RZAtt/g · TmRZPass%', def: 'QB: red-zone pass attempts per game, and how often his team throws rather than runs inside the 20.' },
    { term: 'CPOE', def: 'Completion % over expected: how much more (or less) often he completes passes than throws of that difficulty usually are. Weighted by attempts.' },
    { term: 'PROE · TmIn10Pass%', def: 'Team pass rate over expected, given down, distance and score - how pass-happy the offense is. And its pass rate inside the 10.' },
    { term: 'xFP/g · FPOE/g', def: 'Expected PPR points per game from the volume and quality of his touches, and how far his real points ran above or below that.' },
    { term: 'Deep%', def: 'Share of the team\'s deep targets (20+ yards downfield).' },
    { term: 'GL%', def: 'Share of the team\'s goal-line touches (targets + carries inside the 5).' },
    { term: 'Pts/Opp', def: 'PPR points earned per opportunity - efficiency with the volume he gets.' },
    { term: 'PPR/g · Half/g · Std/g', def: 'Fantasy points per game in full-PPR, half-PPR and standard scoring, from Sleeper.' },
    { term: 'Tch/g · Scrim/g · 1D/g', def: 'Touches (carries + receptions), scrimmage yards and first downs per game.' },
    { term: 'Catch% · INT%', def: 'Receptions per target; for a QB, interceptions per pass attempt.' },
    { term: 'Per route run', def: 'Not shown: routes are charted only by paid providers, so Y/TmAtt stands in and says so.' },
    { term: 'Value', def: 'Dynasty trade value' + (STATE._advStatsValueFormat ? ' (' + STATE._advStatsValueFormat + ')' : '') + ', for spotting production the market has not priced in.' },
    // CC-BY requires the credit wherever the data is shown.
    { term: 'Sources', def: 'Box scores: Sleeper. CPOE, PROE, deep and goal-line share: nflverse (CC-BY 4.0). Expected points: ffopportunity. Player IDs: DynastyProcess.' },
  ]) : '';
}

/** Cap note + sortable table for one position. Rows come in pre-filtered to the
 * position; columns are that position's metrics. Re-rendered in isolation on
 * search/sort so the search box keeps focus. */
function advTableRegionHtml(rows0, { pos }) {
  const columns = advColumnsFor(pos);
  const search = (STATE.advStatsSearch || '').trim().toLowerCase();
  // A sort key from a different position may not be a column here; fall back.
  let sortKey = STATE.advStatsSort || 'pprPerGame';
  if (sortKey !== 'name' && sortKey !== 'games' && !columns.some((c) => c.key === sortKey)) {
    sortKey = 'pprPerGame';
    // Write the fallback back to STATE, or the first click on the header we are
    // actually sorted by reads as "a different key" and re-applies desc instead
    // of toggling to asc -- the click looks inert.
    STATE.advStatsSort = sortKey;
  }
  const sortDir = STATE.advStatsSortDir || 'desc';
  const preset = advPreset();
  const shown = preset === 'all' ? columns : columns.filter((c) => ADV_PRESETS[preset].includes(c.key) || c.key === sortKey);

  let rows = rows0.slice(); // full season: every player at this position
  if (search) rows = rows.filter((r) => r.name.toLowerCase().includes(search));
  const totalMatched = rows.length;
  rows = advSortRows(rows, sortKey, sortDir).slice(0, ADV_MAX_ROWS);

  const arrow = (key) => (key === sortKey ? (sortDir === 'desc' ? ' ▾' : ' ▴') : '');
  // aria-sort, so which column is sorted and in which direction is not carried
  // by a bare glyph alone (2026-10-17). Without it a screen-reader user hears
  // the column names and nothing about the ordering -- on a table whose entire
  // job is ordering.
  const sortAttr = (key) =>
    ' aria-sort="' + (key === sortKey ? (sortDir === 'desc' ? 'descending' : 'ascending') : 'none') + '"';
  const headCells =
    '<th scope="col" class="adv-th-player adv-sortable" data-adv-sort="name"' + sortAttr('name') + '>Player' + arrow('name') + '</th>' +
    '<th scope="col" class="adv-sortable" data-adv-sort="games"' + sortAttr('games') + '>G' + arrow('games') + '</th>' +
    shown.map((c) => '<th scope="col" class="adv-sortable" data-adv-sort="' + c.key + '"' + sortAttr(c.key) + '>' + escapeHtml(c.label) + arrow(c.key) + '</th>').join('');

  const bodyRows = rows.length ? rows.map((r, i) =>
    '<tr>' +
    '<td class="adv-td-rank">' + (i + 1) + '</td>' +
    '<td class="adv-td-player" data-adv-player="' + escapeHtml(r.pid) + '">' + advPlayerCell(r) + '</td>' +
    '<td>' + r.games + '</td>' +
    shown.map((c) => '<td class="' + (c.key === sortKey ? 'adv-sorted' : '') + '">' + advFmt(r[c.key], c.fmt) + '</td>').join('') +
    '</tr>',
  ).join('') : '<tr><td class="adv-empty-row" colspan="' + (shown.length + 3) + '">No players match this filter.</td></tr>';

  const capNote = totalMatched > ADV_MAX_ROWS
    ? '<div class="adv-cap-note">Showing the top ' + ADV_MAX_ROWS + ' of ' + totalMatched + ' - narrow with search.</div>'
    : '<div class="adv-cap-note">' + totalMatched + ' ' + escapeHtml(pos) + (totalMatched === 1 ? '' : 's') + '.</div>';

  const presetBar = '<div class="adv-presets" role="group" aria-label="Columns">' + ADV_PRESET_LABELS.map(([k, label]) =>
    '<button type="button" class="mkt-window-btn' + (k === preset ? ' active' : '') + '" data-adv-preset="' + k + '" aria-pressed="' + (k === preset) + '">' + label + '</button>').join('') + '</div>';
  return (
    presetBar +
    capNote +
    '<div class="adv-table-scroll"><table class="adv-table"><thead><tr>' +
    '<th class="adv-td-rank">#</th>' + headCells +
    '</tr></thead><tbody>' + bodyRows + '</tbody></table></div>'
  );
}

/** Re-render only the table region (search + sort) so the search box keeps focus. */
function refreshAdvTableRegion() {
  const region = document.getElementById('advTableRegion');
  if (!region) { paintAdvancedStats(); return; }
  const season = STATE.advStatsSeason || advStatsCurrentSeason();
  const pos = ADV_POS_FILTERS.includes(STATE.advStatsPos) ? STATE.advStatsPos : ADV_DEFAULT_POS;
  const posRows = advStatsRowsForSeason(season).filter((r) => r.position === pos);
  region.innerHTML = advTableRegionHtml(posRows, { pos });
}

function advStatsHeaderHtml(season, maxGames) {
  // Early in a season one big game tops a board; say how much is behind it.
  const sample = maxGames
    ? '<div class="adv-sample' + (maxGames <= 3 ? ' adv-sample-warn' : '') + '">' + escapeHtml(String(season)) + ' · through ' + maxGames + ' game' + (maxGames === 1 ? '' : 's') +
      (maxGames <= 3 ? ' - small samples: one big game can top a board, so read these as early signs, not the season' : '') + '</div>'
    : '';
  return (
    '<div class="ma-head"><div>' +
    '<h2 class="ma-title">Advanced Stats</h2>' +
    '<div class="ma-sub">Usage and efficiency by position - who is on the field and getting the ball. Not dynasty trade value: that is Rankings and Market Radar.</div>' +
    sample +
    '</div></div>'
  );
}

// Season picker: the live season plus the two before it. Season totals only.
function advStatsControlsHtml(season) {
  const cur = +advStatsCurrentSeason();
  const seasons = [cur, cur - 1, cur - 2];
  const opts = seasons.map((s) => '<option value="' + s + '"' + (String(s) === String(season) ? ' selected' : '') + '>' + s + (s === cur ? ' (live)' : '') + '</option>').join('');
  return (
    '<div class="adv-controls">' +
    '<select class="adv-season" data-adv-season aria-label="Season">' + opts + '</select>' +
    '</div>'
  );
}

// --- interaction -------------------------------------------------------------

function setAdvStatsSeason(season) {
  STATE.advStatsSeason = String(season);
  renderAdvancedStatsView(); // a new season may need its own fetch
}
function setAdvStatsPos(pos) {
  STATE.advStatsPos = ADV_POS_FILTERS.includes(pos) ? pos : ADV_DEFAULT_POS;
  paintAdvancedStats(); // switches leaders + table to the position
}
function setAdvStatsSearch(v) {
  STATE.advStatsSearch = v || '';
  refreshAdvTableRegion(); // table only; keeps focus in the search box
}
function setAdvStatsSort(key) {
  if (STATE.advStatsSort === key) {
    STATE.advStatsSortDir = STATE.advStatsSortDir === 'desc' ? 'asc' : 'desc';
  } else {
    STATE.advStatsSort = key;
    // Text columns read best ascending; metrics best descending (leaders first).
    STATE.advStatsSortDir = (key === 'name' || key === 'position' || key === 'team') ? 'asc' : 'desc';
  }
  refreshAdvTableRegion(); // sorting only touches the table
}

document.addEventListener('click', (e) => {
  if (!e.target.closest) return;
  const view = document.getElementById('advancedStatsView');
  if (!view || !view.classList.contains('active')) return;
  const retry = e.target.closest('[data-adv-retry]');
  if (retry) { renderAdvancedStatsView(); return; }
  const posBtn = e.target.closest('[data-adv-pos]');
  if (posBtn) { setAdvStatsPos(posBtn.dataset.advPos); return; }
  const presetBtn = e.target.closest('[data-adv-preset]');
  if (presetBtn) { STATE.advStatsPreset = presetBtn.dataset.advPreset; refreshAdvTableRegion(); return; }
  const th = e.target.closest('[data-adv-sort]');
  if (th) { setAdvStatsSort(th.dataset.advSort); return; }
  const pl = e.target.closest('[data-adv-player]');
  if (pl && typeof openPlayerDrawer === 'function') { openPlayerDrawer(pl.dataset.advPlayer); }
});

document.addEventListener('change', (e) => {
  const s = e.target.closest ? e.target.closest('[data-adv-season]') : null;
  if (s) setAdvStatsSeason(s.value);
});

document.addEventListener('input', (e) => {
  const box = e.target.closest ? e.target.closest('[data-adv-search]') : null;
  if (box) setAdvStatsSearch(box.value);
});

// --- player drawer section --------------------------------------------------
// The same advanced metrics, for one player, where you actually evaluate him.

/** This player's rank among same-position peers for a metric (1 = best). */
function advPositionalRank(allRows, row, key, floor) {
  // The player must clear the same sample floor his peers do. Otherwise a guy
  // back from injury with 3 games and one fluke game ranks "WR1" against a pool
  // he isn't in -- and if every peer beats him, `better + 1` prints a rank
  // larger than the pool (WR41 of 40).
  if (row.games < floor) return null;
  const peers = allRows.filter((r) => r.position === row.position && r.games >= floor && r[key] != null);
  if (row[key] == null || !peers.length) return null;
  const better = peers.filter((r) => r[key] > row[key]).length;
  return { rank: better + 1, of: peers.length };
}

function advDrawerHtml(row, allRows, season) {
  const maxGp = allRows.reduce((m, r) => Math.max(m, r.games), 0) || 1;
  const floor = Math.max(1, Math.ceil(maxGp / 2)); // scales with the season, never collapses to one team early
  const metrics = TacoCore.ADV_METRICS.filter((m) => m.positions.includes(row.position) && row[m.key] != null);
  if (!metrics.length) {
    return '<div class="drawer-stats-empty">No advanced usage data for ' + escapeHtml(String(season)) + '.</div>';
  }
  const cells = metrics.map((m) => {
    const r = advPositionalRank(allRows, row, m.key, floor);
    const rankTag = r ? '<div class="drawer-adv-rank">' + escapeHtml(row.position) + r.rank + '</div>' : '';
    return (
      '<div class="drawer-adv-cell">' +
      '<div class="drawer-adv-label">' + escapeHtml(m.label) + '</div>' +
      '<div class="drawer-adv-val">' + advFmt(row[m.key], m.fmt) + '</div>' +
      rankTag +
      '</div>'
    );
  }).join('');
  // Below the floor there are no rank tags to explain -- say why instead of
  // promising a comparison the cells don't show.
  const rankNote = row.games >= floor
    ? ' · rank vs ' + escapeHtml(row.position) + 's'
    : ' · too few games to rank';
  return (
    '<div class="drawer-adv-meta">' + escapeHtml(String(season)) + ' · ' + row.games + ' game' + (row.games === 1 ? '' : 's') +
    rankNote + '</div>' +
    '<div class="drawer-adv-grid">' + cells + '</div>'
  );
}

/** Lazy-fill the drawer's Advanced section. Reuses the explorer's bulk fetch +
 * cached rows, so opening a drawer after visiting the page is instant. */
async function loadAdvancedStatsSection(playerId, position, containerId) {
  const container = document.getElementById(containerId);
  if (!container) return;
  if (!window.TacoCore || typeof TacoCore.computeAdvancedRows !== 'function') {
    container.innerHTML = '<div class="drawer-stats-empty">Advanced stats unavailable.</div>';
    return;
  }
  // The bulk season fetch is ~1.2MB. Don't pay it for a position that has no
  // advanced metrics to show anyway (picks, K, DEF) -- the drawer is the most
  // opened surface in the app.
  const hasMetrics = (TacoCore.ADV_METRICS || []).some((m) => m.positions.includes(position));
  if (!hasMetrics) {
    container.innerHTML = '<div class="drawer-stats-empty">No advanced usage data for this position.</div>';
    return;
  }
  const season = STATE.advStatsSeason || advStatsCurrentSeason();
  try {
    await Promise.all([
      !STATE.playersDB && typeof ensurePlayersDB === 'function' ? ensurePlayersDB() : Promise.resolve(),
      fetchAdvancedBulkStats(season),
    ]);
  } catch (_e) { /* fall through to the empty state */ }
  // Guard: the drawer may have been closed or swapped to another player.
  if (!document.getElementById(containerId)) return;
  const rows = advStatsRowsForSeason(season);
  const row = rows.find((r) => String(r.pid) === String(playerId));
  if (!row) {
    container.innerHTML = '<div class="drawer-stats-empty">No ' + escapeHtml(String(season)) + ' usage data for this player.</div>';
    return;
  }
  container.innerHTML = advDrawerHtml(row, rows, season);
}
window.loadAdvancedStatsSection = loadAdvancedStatsSection;

window.setAdvStatsSeason = setAdvStatsSeason;
window.setAdvStatsPos = setAdvStatsPos;
window.setAdvStatsSearch = setAdvStatsSearch;
window.setAdvStatsSort = setAdvStatsSort;

;
/*! ==== 91-account.js ==== */
// Accounts: Clerk sign-in exchanged for a TACO session.
//
// Clerk holds the identity -- Google, or an emailed code -- so the site never
// sees or stores a password. What comes back is a short-lived Clerk JWT signed
// by Clerk's key; the Worker verifies it against Clerk's published keys and
// issues its own session token, which is what every authenticated request uses
// after that. The Clerk token is never stored.
//
// The email comes from a Clerk JWT template named `taco`, so the Worker does
// not need Clerk's secret key to look a user up. If that template is ever
// deleted, sign-in fails with the Worker's own message rather than silently
// creating accounts with no email.
//
// DEVELOPMENT INSTANCE. Going live on thearmchairoffice.com needs a Clerk
// production instance (DNS records, a real Google OAuth app) and the two
// constants below change. The key is publishable by design -- it ships in the
// page source of every Clerk site -- so it is not a secret in this file.
var CLERK_PUBLISHABLE_KEY = 'pk_test_d2FudGVkLW94LTY0LmNsZXJrLmFjY291bnRzLmRldiQ';
var CLERK_FRONTEND_API = 'https://wanted-ox-64.clerk.accounts.dev';
var CLERK_JWT_TEMPLATE = 'taco';
var SESSION_KEY = 'taco_session_token';
// The signed-in account's saved Sleeper username, kept locally so the router
// can go straight to the portfolio on the next load without waiting for
// /api/me. Only honoured while a session token exists; cleared on sign-out.
var ACCOUNT_SLEEPER_KEY = 'taco_account_sleeper';

var clerkLoading = null;

function accountStorage() {
  return window.TacoStorage || null;
}

function readSessionToken() {
  var store = accountStorage();
  try {
    return store ? store.get(SESSION_KEY) : localStorage.getItem(SESSION_KEY);
  } catch (_e) {
    return null;
  }
}

function writeSessionToken(token) {
  var store = accountStorage();
  try {
    if (token) {
      if (store) store.set(SESSION_KEY, token);
      else localStorage.setItem(SESSION_KEY, token);
    } else if (store) {
      store.remove(SESSION_KEY);
    } else {
      localStorage.removeItem(SESSION_KEY);
    }
  } catch (_e) { /* private mode: session lasts the tab, which is survivable */ }
}

// Same storage path as the session token, so the two cannot disagree about
// where they live.
function rememberAccountSleeper(acct) {
  var name = acct && acct.sleeper_username;
  var store = accountStorage();
  try {
    if (name) {
      if (store) store.set(ACCOUNT_SLEEPER_KEY, name);
      else localStorage.setItem(ACCOUNT_SLEEPER_KEY, name);
    } else if (store) {
      store.remove(ACCOUNT_SLEEPER_KEY);
    } else {
      localStorage.removeItem(ACCOUNT_SLEEPER_KEY);
    }
  } catch (_e) { /* private mode: falls back to waiting for /api/me */ }
}

/** The signed-in account's Sleeper username, or null when signed out. */
function accountSleeperUsername() {
  if (!readSessionToken()) return null;
  var store = accountStorage();
  try {
    return (store ? store.get(ACCOUNT_SLEEPER_KEY) : localStorage.getItem(ACCOUNT_SLEEPER_KEY)) || null;
  } catch (_e) {
    return null;
  }
}
window.accountSleeperUsername = accountSleeperUsername;

// Signed in with a username saved on the account: skip the username step.
// Owen, 2026-09-26: "If i am logged in and have my username attached, i should
// not need to enter my username every time i load the site."
//
// Only from the home page or /connect, and only when nothing is loaded or
// loading yet. The router already does this on the first paint when the name
// is stored locally; this catches the first visit on a new device, where the
// name only arrives with /api/me, and a sign-in made from /connect.
function enterFromAccount() {
  var name = STATE.account && STATE.account.sleeper_username;
  if (!name || STATE.username || (STATE.leagues && STATE.leagues.length)) return;
  var path = window.location.pathname;
  if (path !== '/' && path !== '/connect') return;
  if (typeof window.bootWithUsername === 'function') window.bootWithUsername(name);
}

/** The one place anything asks whether this visitor has paid.
 *
 * Rank, not string equality. `tier === 'pro'` said NO to a subscriber on a
 * higher tier, so the moment a second paid tier exists the people paying the
 * most would have lost the paid site entirely -- the account badge, the
 * settings block and every gated panel at once. shared/entitlements.mjs holds
 * the ladder; this asks it. */
function isProAccount() {
  const tier = STATE.account && STATE.account.tier;
  if (!tier) return false;
  return window.TacoCore && typeof TacoCore.tierAllows === 'function'
    ? TacoCore.tierAllows(tier, 'pro')
    : tier === 'pro';
}

/** Can this visitor use one named feature? The gate a panel should ask. */
function accountCanUse(feature) {
  const tier = (STATE.account && STATE.account.tier) || 'free';
  return !!(window.TacoCore && typeof TacoCore.canUse === 'function'
    ? TacoCore.canUse(tier, feature)
    : false);
}
window.accountCanUse = accountCanUse;

/**
 * Is the paid tier on sale here? Owen, 2026-09-26: not on production yet -- it
 * needs more testing and more content first. The checkout code is finished and
 * stays; this hides it. Until launch, production shows no plans, prices or
 * upgrade prompts, the paid features' nav entries only appear for accounts
 * that already have access, and the Worker refuses checkout (BILLING_OPEN,
 * unset on production). The sandbox keeps everything visible for testing.
 *
 * Keyed off the backend the page talks to, which is itself decided by hostname
 * (00-backend-toggle.js), so this cannot ship to production switched on by
 * accident. **At launch: return true here and set BILLING_OPEN on taco-api.**
 */
function billingIsPublic() {
  // Owen, 2026-11-01: "make sure nobody else can see tiered levels yet besides
  // me. war room should not ever show to anyone who isnt a paid member, like
  // even appear right now."
  //
  // This used to return true off production, which meant the SANDBOX showed
  // the plans, the prices and the whole War Room section to anyone who opened
  // it -- including signed-out visitors, verified on 2026-11-01. The "keep it
  // visible for testing" convenience was the hole. It is false everywhere now,
  // so visibility is decided only by whether the account actually has access
  // (accountCanUse), which is how production already behaved.
  //
  // **At launch: return true here and set BILLING_OPEN on taco-api.**
  return false;
}
window.billingIsPublic = billingIsPublic;

/** What a tier is called on screen. */
function accountTierLabel(tier) {
  // Tier 2. The key stays 'ai' (it is stored in D1 and in the Stripe price
  // lookup keys); only the name people see changed (Owen, 2026-09-27).
  if (tier === 'ai') return 'Hall of Fame';
  if (tier === 'pro') return 'Pro';
  return 'Free';
}
window.accountTierLabel = accountTierLabel;

// ─── Billing ───────────────────────────────────────────────────────────────
// Checkout and the portal are Stripe-hosted pages: the Worker hands back a URL
// and the browser goes there. No card field ever touches this site, and
// nothing here can grant a tier -- that is the webhook's job, server-side.

/** The current path without our own ?checkout= marker, to come back to. */
function billingReturnPath() {
  var params = new URLSearchParams(window.location.search);
  params.delete('checkout');
  var q = params.toString();
  return window.location.pathname + (q ? '?' + q : '');
}

async function billingPost(path, extra) {
  var token = readSessionToken();
  var res = await fetch(window.BACKEND_URL + path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
    body: JSON.stringify(Object.assign({ return_path: billingReturnPath() }, extra || {})),
  });
  var data = await res.json().catch(function () { return {}; });
  return { ok: res.ok, status: res.status, data: data };
}

/** Send a signed-in visitor to Stripe Checkout for one plan (e.g. 'pro_year'). */
async function startCheckout(planKey) {
  var plan = window.TacoCore && TacoCore.PLANS && TacoCore.PLANS[planKey];
  if (!plan) return;
  if (!STATE.account || !readSessionToken()) {
    if (window.showToast) showToast('Sign in first, then pick a plan.');
    openSignIn();
    return;
  }
  try {
    var r = await billingPost('/api/billing/checkout', { tier: plan.tier, interval: plan.interval });
    if (r.ok && r.data.url) {
      window.location.href = r.data.url;
      return;
    }
    if (r.status === 409 && r.data.manage) {
      openBillingPortal();
      return;
    }
    if (window.showToast) showToast(r.data.error || 'Could not start checkout.', { type: 'error' });
  } catch (_e) {
    if (window.showToast) showToast('Could not reach the server.', { type: 'error' });
  }
}

/** Stripe's own page for changing plan, updating a card, or cancelling. */
async function openBillingPortal() {
  try {
    var r = await billingPost('/api/billing/portal');
    if (r.ok && r.data.url) {
      window.location.href = r.data.url;
      return;
    }
    if (window.showToast) showToast(r.data.error || 'Could not open billing.', { type: 'error' });
  } catch (_e) {
    if (window.showToast) showToast('Could not reach the server.', { type: 'error' });
  }
}

// Back from Stripe. The webhook usually lands before the redirect does, but
// not always, so re-read the account a few times before saying anything --
// "you're on Pro" while every gate still says Free would be worse than a
// short wait.
async function handleCheckoutReturn() {
  var params = new URLSearchParams(window.location.search);
  var outcome = params.get('checkout');
  if (!outcome) return;
  try {
    window.history.replaceState(null, '', billingReturnPath() + window.location.hash);
  } catch (_e) { /* cosmetic */ }
  if (outcome === 'cancel') {
    if (window.showToast) showToast('Checkout cancelled. Nothing was charged.');
    return;
  }
  if (outcome !== 'success') return;
  var before = (STATE.account && STATE.account.tier) || 'free';
  for (var i = 0; i < 8; i++) {
    var acct = await restoreAccount();
    if (acct && acct.tier && acct.tier !== before && isProAccount()) {
      if (window.showToast) showToast('You’re on ' + accountTierLabel(acct.tier) + '. Thank you!', { type: 'success' });
      return;
    }
    await new Promise(function (resolve) { setTimeout(resolve, 1500); });
  }
  if (window.showToast) {
    showToast('Payment received. Your plan is still unlocking - reload in a minute if it has not.', { type: 'success' });
  }
}

function loadClerk() {
  if (window.Clerk) return Promise.resolve(window.Clerk);
  if (clerkLoading) return clerkLoading;
  clerkLoading = new Promise(function (resolve, reject) {
    var s = document.createElement('script');
    s.async = true;
    s.crossOrigin = 'anonymous';
    s.setAttribute('data-clerk-publishable-key', CLERK_PUBLISHABLE_KEY);
    s.src = CLERK_FRONTEND_API + '/npm/@clerk/clerk-js@5/dist/clerk.browser.js';
    s.onload = function () {
      window.Clerk.load({ afterSignOutUrl: window.location.pathname })
        .then(function () { resolve(window.Clerk); })
        .catch(reject);
    };
    s.onerror = function () {
      clerkLoading = null;
      reject(new Error('Clerk failed to load'));
    };
    document.head.appendChild(s);
  });
  return clerkLoading;
}

// Trade a verified Clerk token for a TACO session. The Worker creates the
// account row on first sign-in; `tier` on the way back is what gates paid
// features, and it is only ever written server-side.
async function exchangeClerkToken(clerk) {
  var token = await clerk.session.getToken({ template: CLERK_JWT_TEMPLATE });
  if (!token) throw new Error('no Clerk token');
  var res = await fetch(window.BACKEND_URL + '/api/auth/clerk', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      token: token,
      sleeper_username: (STATE && STATE.username) || null,
    }),
  });
  var data = await res.json().catch(function () { return {}; });
  if (!res.ok) throw new Error(data.error || 'sign-in failed');
  writeSessionToken(data.token);
  STATE.account = data.user || null;
  rememberAccountSleeper(STATE.account);
  renderAccountButton();
  enterFromAccount();
  return data.user;
}

/**
 * Save the Sleeper handle on the account row, so the next device that signs in
 * loads the same portfolio. Resolves true on success; the caller re-renders.
 */
async function saveSleeperUsername(name) {
  var token = readSessionToken();
  if (!token) {
    if (window.showToast) showToast('Sign in first.', { type: 'error' });
    return false;
  }
  try {
    var res = await fetch(window.BACKEND_URL + '/api/user/sleeper', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
      body: JSON.stringify({ sleeper_username: String(name || '').trim() }),
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok) {
      if (window.showToast) showToast(data.error || 'Could not save that.', { type: 'error' });
      return false;
    }
    STATE.account = data.user || STATE.account;
    rememberAccountSleeper(STATE.account);
    renderAccountButton();
    if (window.showToast) {
      showToast(
        data.user && data.user.sleeper_username
          ? 'Saved. Signing in anywhere loads these leagues.'
          : 'Sleeper username cleared.',
        { type: 'success' },
      );
    }
    return true;
  } catch (_e) {
    if (window.showToast) showToast('Could not reach the server.', { type: 'error' });
    return false;
  }
}

/** Restore a session on load. A rejected token means expired, not broken. */
async function restoreAccount() {
  var token = readSessionToken();
  if (!token) return null;
  try {
    var res = await fetch(window.BACKEND_URL + '/api/me', {
      headers: { Authorization: 'Bearer ' + token },
    });
    if (!res.ok) {
      writeSessionToken(null);
      rememberAccountSleeper(null);
      return null;
    }
    var data = await res.json();
    STATE.account = data.user || data || null;
    rememberAccountSleeper(STATE.account);
  } catch (_e) {
    return null; // offline: keep the token, try again next load
  }
  renderAccountButton();
  return STATE.account;
}

async function openSignIn() {
  var btn = document.getElementById('accountBtn');
  if (btn) btn.disabled = true;
  try {
    var clerk = await loadClerk();
    if (clerk.user) {
      await exchangeClerkToken(clerk);
      return;
    }
    clerk.openSignIn({
      fallbackRedirectUrl: window.location.pathname,
      signUpFallbackRedirectUrl: window.location.pathname,
    });
    // Clerk's modal resolves nothing, so watch for the session it creates.
    clerk.addListener(function (payload) {
      if (payload && payload.user && !STATE.account) {
        exchangeClerkToken(clerk).catch(function (err) {
          if (window.showToast) showToast(err.message || 'Sign-in failed', { type: 'error' });
        });
      }
    });
  } catch (err) {
    if (window.showToast) showToast('Could not open sign-in. Try again.', { type: 'error' });
    console.error('[account] sign-in failed:', err);
  } finally {
    if (btn) btn.disabled = false;
  }
}

async function signOutAccount() {
  writeSessionToken(null);
  rememberAccountSleeper(null);
  STATE.account = null;
  renderAccountButton();
  try {
    if (window.Clerk && window.Clerk.signOut) await window.Clerk.signOut();
  } catch (_e) { /* the local session is already gone, which is what matters */ }
  if (window.showToast) showToast('Signed out');
}

// This ran ~100 times a second on every page from 2026-09-22 to 2026-09-28:
// the header MutationObserver below redraws the button, the redraw rewrote the
// button's text (a mutation inside the header), which fired the observer again
// -- every frame, each one re-dispatching taco:account-changed and toggling a
// class on <html>. Now: only an actual change is written or announced, and the
// observer ignores the button's own mutations.
var lastAccountAnnounced;
function setIfDifferent(el, attr, value) {
  if (el.getAttribute(attr) !== value) el.setAttribute(attr, value);
}
function renderAccountButton() {
  // Anything keyed off paid state (the Ask panel now, ad slots later) listens
  // for this rather than polling: the tier arrives from /api/me after load.
  // Dispatched before the early return, so a page with no masthead button
  // still tells its listeners who is signed in -- but only when it changed.
  var who = STATE.account ? (STATE.account.email || '') + '|' + (STATE.account.tier || '') : '';
  if (who !== lastAccountAnnounced) {
    lastAccountAnnounced = who;
    try {
      document.dispatchEvent(new CustomEvent('taco:account-changed', { detail: STATE.account || null }));
    } catch (_e) { /* never let a listener break the render */ }
  }
  // Nav entries for paid views are built before the account loads, so they
  // are hidden by a class rather than left out of the markup. While the tier
  // is not on sale, nobody without access should see a door they cannot open.
  // The whole War Room (the paid tier's section) goes with it.
  document.documentElement.classList.toggle(
    'taco-hide-warroom',
    !billingIsPublic() && !accountCanUse('investigator'),
  );
  var btn = document.getElementById('accountBtn');
  if (!btn) return;
  var acct = STATE.account;
  if (btn.style.display) btn.style.display = '';
  var signedIn = !!(acct && acct.email);
  var text = signedIn ? acct.email.charAt(0).toUpperCase() : 'Sign in';
  if (btn.textContent !== text) btn.textContent = text;
  btn.classList.toggle('account-btn-in', signedIn);
  btn.classList.toggle('account-btn-pro', signedIn && isProAccount());
  setIfDifferent(btn, 'data-tooltip', signedIn
    ? acct.email + (isProAccount() ? ' · ' + accountTierLabel(acct.tier) : '') + ' - account settings'
    : 'Sign in to The Armchair Office');
  setIfDifferent(btn, 'aria-label', signedIn ? 'Signed in as ' + acct.email : 'Sign in');
}

// Signed in, the button opens the account rather than signing you out.
// Sign-out is one action inside Settings; making it the ONLY thing a click
// could do meant the account badge was a trapdoor -- click it to find out
// you are logged out. Settings is also reachable this way from the marketing
// pages, where the gear icon is hidden.
function handleAccountClick() {
  if (!STATE.account) {
    openSignIn();
    return;
  }
  if (typeof window.openSettingsPanel === 'function') openSettingsPanel();
  else signOutAccount();
}

// Delegated from the document, not bound to the button.
//
// A listener attached to the node itself was silently lost: the masthead is
// re-rendered after load (site chrome, route changes), and the replacement
// button looks identical but carries no handler -- the button appeared to
// work, did nothing, and logged nothing. Delegation survives any re-render.
function initAccount() {
  document.addEventListener('click', function (e) {
    var hit = e.target && e.target.closest && e.target.closest('#accountBtn');
    if (hit) handleAccountClick();
  });
  // Same reason the click is delegated: a re-rendered button reverts to the
  // markup's "Sign in" label, which would tell a signed-in user they are not.
  var header = document.getElementById('siteHeader');
  if (header && window.MutationObserver) {
    var pending = false;
    new MutationObserver(function (records) {
      // The button's own redraw is not news; only a rebuilt header is.
      var own = document.getElementById('accountBtn');
      if (own && records.every(function (r) { return own === r.target || own.contains(r.target); })) return;
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        renderAccountButton();
      });
    }).observe(header, { childList: true, subtree: true });
  }
  renderAccountButton();
  restoreAccount().then(function () {
    enterFromAccount();
    return handleCheckoutReturn();
  });
}

window.tacoSessionToken = readSessionToken;
// One definition of the session token, shared rather than re-derived: a
// second copy of the storage key is exactly how this codebase grows a bug.
window.tacoSessionToken = readSessionToken;
window.isProAccount = isProAccount;
window.saveSleeperUsername = saveSleeperUsername;
window.openSignIn = openSignIn;
window.startCheckout = startCheckout;
window.openBillingPortal = openBillingPortal;
window.signOutAccount = signOutAccount;
window.renderAccountButton = renderAccountButton;
window.initAccount = initAccount;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAccount);
} else {
  initAccount();
}

;
/*! ==== 92-ask-panel.js ==== */
// Ask TACO — the floating assistant. Pro only.
//
// Split of labour: the Worker asks the model what to look for, this runs the
// search over STATE.leagues with TacoCore.runAskPlan, and the sentence is
// written from the counts that search returned. The model never supplies a
// number, so the prose above the list cannot contradict the list.
//
// Free accounts see nothing at all -- no locked door, no upsell in the
// corner of every page (Owen, 2026-09-22).

var ASK_EXAMPLES = [
  'Which leagues do I have more than one 2027 1st in?',
  'Where am I holding acquired 2026 firsts?',
  'Show my running backs worth over 6000',
];

var askBusy = false;

function askPanelVisible() {
  // Asks for the FEATURE, not the tier: when Ask moves to the ai tier at
  // launch this gate follows without being edited.
  return typeof window.accountCanUse === 'function' && window.accountCanUse('ask');
}

function ensureAskMounted() {
  var existing = document.getElementById('askRoot');
  if (!askPanelVisible()) {
    if (existing) existing.remove();
    return null;
  }
  if (existing) return existing;
  var root = document.createElement('div');
  root.id = 'askRoot';
  root.className = 'ask-root';
  root.innerHTML =
    '<button type="button" class="ask-fab" id="askFab" aria-label="Ask TACO" data-tooltip="Ask about your leagues">' +
    '<span class="ask-fab-mark">?</span></button>' +
    '<section class="ask-panel" id="askPanel" role="dialog" aria-label="Ask TACO" hidden>' +
    '<header class="ask-head"><span class="ask-title">Ask TACO</span>' +
    '<button type="button" class="ask-close" id="askClose" aria-label="Close">&times;</button></header>' +
    '<div class="ask-body" id="askBody"></div>' +
    '<form class="ask-form" id="askForm">' +
    '<input type="text" id="askInput" class="ask-input" autocomplete="off" maxlength="400" ' +
    'placeholder="Ask about your leagues…">' +
    '<button type="submit" class="ask-send" id="askSend">Ask</button>' +
    '</form></section>';
  document.body.appendChild(root);
  root.querySelector('#askFab').addEventListener('click', toggleAskPanel);
  root.querySelector('#askClose').addEventListener('click', closeAskPanel);
  root.querySelector('#askForm').addEventListener('submit', submitAsk);
  renderAskIntro();
  return root;
}

function renderAskIntro() {
  var body = document.getElementById('askBody');
  if (!body) return;
  body.innerHTML =
    '<p class="ask-intro">Ask about your own leagues - picks, players, who you own where. ' +
    'The answer is computed from your league data, not guessed.</p>' +
    '<ul class="ask-examples">' +
    ASK_EXAMPLES.map(function (q) {
      return '<li><button type="button" class="ask-example" data-ask-example="' + escapeHtml(q) + '">' +
        escapeHtml(q) + '</button></li>';
    }).join('') +
    '</ul>';
  body.querySelectorAll('[data-ask-example]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById('askInput');
      if (!input) return;
      input.value = btn.getAttribute('data-ask-example');
      submitAsk();
    });
  });
}

function toggleAskPanel() {
  var panel = document.getElementById('askPanel');
  if (!panel) return;
  if (panel.hasAttribute('hidden')) {
    panel.removeAttribute('hidden');
    var input = document.getElementById('askInput');
    if (input) input.focus();
  } else {
    panel.setAttribute('hidden', '');
  }
}

function closeAskPanel() {
  var panel = document.getElementById('askPanel');
  if (panel) panel.setAttribute('hidden', '');
}

function askStatus(html, cls) {
  var body = document.getElementById('askBody');
  if (body) body.innerHTML = '<p class="ask-status ' + (cls || '') + '">' + html + '</p>';
}

async function submitAsk(e) {
  if (e && e.preventDefault) e.preventDefault();
  if (askBusy) return;
  var input = document.getElementById('askInput');
  var question = input ? input.value.trim() : '';
  if (question.length < 3) return;

  askBusy = true;
  var send = document.getElementById('askSend');
  if (send) send.disabled = true;
  askStatus('Working on it...', 'ask-thinking');

  try {
    var token = typeof window.tacoSessionToken === 'function' ? window.tacoSessionToken() : null;
    var res = await fetch(window.BACKEND_URL + '/api/ask', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
      body: JSON.stringify({ question: question }),
    });
    var data = await res.json().catch(function () { return {}; });
    if (!res.ok) {
      askStatus(escapeHtml(data.error || 'Ask TACO could not answer that one. Try again in a moment.'), 'ask-error');
      return;
    }
    if (data.cannotAnswer) {
      // It said it could not answer. Show that instead of an adjacent answer
      // dressed up as the right one.
      askStatus(
        '<span class="ask-declined">' + escapeHtml(data.cannotAnswer) + '</span>' +
        '<br><span class="ask-note">Right now I can search your picks and your players ' +
        '- by season, round, position and value, in one league or all of them.</span>',
      );
      return;
    }
    renderAskResult(data.plan, data.subject, question, data.used, data.limit);
  } catch (_err) {
    askStatus('Could not reach the server.', 'ask-error');
  } finally {
    askBusy = false;
    if (send) send.disabled = false;
  }
}

// Everything below this line is computed locally: the plan came back from the
// Worker, the leagues never left.
function renderAskResult(plan, subject, question, used, limit) {
  var body = document.getElementById('askBody');
  if (!body) return;
  var result = TacoCore.runAskPlan(plan, {
    leagues: STATE.leagues || [],
    currentLeagueId: currentAskLeagueId(),
  });
  var sentence = TacoCore.describeAskResult(result, subject);

  var html = '<div class="ask-answer">' +
    '<p class="ask-question">' + escapeHtml(question) + '</p>' +
    '<p class="ask-sentence">' + escapeHtml(sentence) + '</p>';

  if (!result.groups.length) {
    html += '<p class="ask-note">Nothing matched. Try naming a season and round, like "2027 firsts".</p>';
  } else {
    html += '<ul class="ask-groups">';
    result.groups.forEach(function (g) {
      html += '<li class="ask-group">' +
        '<div class="ask-group-head"><span class="ask-league">' + escapeHtml(g.leagueName) + '</span>' +
        '<span class="ask-count">' + g.count + '</span></div>' +
        '<ul class="ask-items">' +
        g.items.map(function (it) {
          return '<li><span class="ask-item-label">' + escapeHtml(it.label) + '</span>' +
            (it.note ? '<span class="ask-item-note">' + escapeHtml(it.note) + '</span>' : '') +
            (it.value ? '<span class="ask-item-value">' + formatCompactNumber(it.value) + '</span>' : '') +
            '</li>';
        }).join('') +
        '</ul></li>';
    });
    html += '</ul>';
  }
  if (limit) {
    html += '<p class="ask-quota">' + used + ' of ' + limit + ' questions today</p>';
  }
  html += '</div>';
  body.innerHTML = html;
  body.scrollTop = 0;
}

/** Which league "this league" means, when a league view is open. */
function currentAskLeagueId() {
  try {
    if (STATE.currentTeamIdx != null && STATE.leagues[STATE.currentTeamIdx]) {
      return STATE.leagues[STATE.currentTeamIdx].league_id;
    }
  } catch (_e) { /* no league open */ }
  return null;
}

window.ensureAskMounted = ensureAskMounted;
window.toggleAskPanel = toggleAskPanel;
window.closeAskPanel = closeAskPanel;
window.submitAsk = submitAsk;

// Mount when Pro is known, and re-check when the account changes: the flag
// arrives from /api/me after load, so the first pass usually says "not pro".
document.addEventListener('DOMContentLoaded', ensureAskMounted);
document.addEventListener('taco:account-changed', ensureAskMounted);

;
/*! ==== 93-investigator-panel.js ==== */
// League Investigator — the scouting desk for the people you play against.
//
// One board, not three lists. The first version showed leaguemates, trade
// partners and "worst traders" as separate flat lists which were, on
// inspection, the SAME PEOPLE three times with one number each — rendered as
// grey letters in circles, on a site whose standing rule is photos and logos on
// every page. It read as cheap because it was thin.
//
// This is built from what the browser already holds: lg.allRosters names every
// roster owner in your leagues WITH their avatar, and the trade history is
// already fetched and priced. So it paints at once, uses real faces, and needs
// none of the roster inference — inside your own leagues Sleeper tells us
// exactly who owns what. The crawl is asked only for the one thing you cannot
// see yourself: their leagues you are not in.

function investigatorCanUse() {
  return typeof window.accountCanUse === 'function' && window.accountCanUse('investigator');
}

function investigatorMeId() {
  return STATE.userId || null;
}

/** My own owner id, so the board can leave me off it. */
function investigatorMyOwnerId() {
  for (const lg of STATE.leagues || []) {
    const mine = (lg.allRosters || []).find((r) => r.isMe);
    if (mine && mine.ownerId) return String(mine.ownerId);
  }
  return null;
}

/** Trade records for everyone in the book, from history already priced. */
function investigatorRecords() {
  if (!window.TacoCore || !TacoCore.traderRecords) return [];
  const trades = STATE.tradeHistory;
  if (!trades || !trades.length) return [];
  return TacoCore.traderRecords(trades, { excludeOwnerId: investigatorMyOwnerId() });
}

/** The board. Local data only — the crawl overlay arrives separately. */
function investigatorBoard() {
  if (!window.TacoCore || !TacoCore.buildManagerBoard) return [];
  return TacoCore.buildManagerBoard({
    leagues: STATE.leagues || [],
    tradeRecords: investigatorRecords(),
    overlapById: STATE.investigatorOverlap || null,
  });
}

function investigatorIsOnScreen() {
  const el = document.getElementById('investigatorView');
  return !!(el && el.classList.contains('active'));
}

/** Ask the crawl what it can see that we cannot: their OTHER leagues. */
function loadInvestigatorOverlap() {
  const me = investigatorMeId();
  if (!me || STATE.investigatorOverlap || STATE.investigatorLoading) return;
  if (typeof BACKEND_URL === 'undefined' || !BACKEND_URL) return;
  STATE.investigatorLoading = true;
  const token = typeof window.tacoSessionToken === 'function' ? window.tacoSessionToken() : null;
  fetch(BACKEND_URL + '/api/investigator?me=' + encodeURIComponent(me), {
    headers: token ? { authorization: 'Bearer ' + token } : {},
  })
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      const map = {};
      for (const m of (data && data.mates) || []) {
        map[String(m.sleeperUserId)] = {
          hiddenLeagues: m.hiddenFromYou,
          theirLeagues: m.sharedLeagues,
        };
      }
      STATE.investigatorOverlap = map;
    })
    .catch(() => { STATE.investigatorOverlap = {}; })
    .finally(() => {
      STATE.investigatorLoading = false;
      if (warRoomOnScreen()) renderWarRoom();
    });
}

/** The priced trade history is what grades a manager; make sure it exists. */
function ensureInvestigatorTrades() {
  if (STATE.tradeHistory || STATE.tradeHistoryLoading) return;
  if (typeof loadTradeHistory !== 'function') return;
  loadTradeHistory().then(() => {
    if (warRoomOnScreen()) renderWarRoom();
  }).catch(() => {});
}

// --- rendering ---------------------------------------------------------------

const BADGE_LABEL = { target: 'Offer target', shark: 'Tough trade' };

function investigatorRow(m) {
  const avatar = typeof teamAvatarHtml === 'function' ? teamAvatarHtml(m.avatarRef, m.name) : '';
  const rec = m.tradeRecord
    ? m.tradeRecord.won + '-' + m.tradeRecord.lost + (m.tradeRecord.fair ? '-' + m.tradeRecord.fair : '')
    : null;
  const netCls = !m.netValue ? 'mb-net-none' : (m.netValue < 0 ? 'mb-net-down' : 'mb-net-up');
  const net = m.trades
    ? '<span class="mb-net ' + netCls + '">' +
      (m.netValue > 0 ? '+' : '') + m.netValue.toLocaleString() + '</span>'
    : '<span class="mb-net mb-net-none">—</span>';
  const badge = m.badge
    ? ' <span class="mb-badge mb-badge-' + m.badge + '">' + BADGE_LABEL[m.badge] + '</span>'
    : '';
  const hidden = m.hiddenLeagues
    ? '<span class="mb-sub mb-sub-dim">' + m.hiddenLeagues + ' league' +
      (m.hiddenLeagues === 1 ? '' : 's') + ' you cannot see</span>'
    : '';
  return (
    '<button type="button" class="mb-row" data-inv-manager="' + escapeHtml(m.ownerId) + '">' +
    '<span class="mb-avatar">' + avatar + '</span>' +
    '<span class="mb-main">' +
    '<span class="mb-name">' + escapeHtml(m.name) + badge + '</span>' +
    '<span class="mb-sub">' +
    m.sharedLeagues + ' league' + (m.sharedLeagues === 1 ? '' : 's') + ' with you' +
    (rec ? ' · ' + rec + ' in ' + m.trades + ' trade' + (m.trades === 1 ? '' : 's') : ' · no trades scored') +
    '</span>' + hidden +
    '</span>' +
    net +
    '<span class="mb-chev" aria-hidden="true">›</span>' +
    '</button>'
  );
}

/** The Scout Report for one manager. */
function investigatorScoutHtml(ownerId) {
  const m = investigatorBoard().find((x) => String(x.ownerId) === String(ownerId));
  if (!m) return '<div class="tab-empty">That manager is not in your leagues.</div>';

  const avatar = typeof teamAvatarHtml === 'function' ? teamAvatarHtml(m.avatarRef, m.name) : '';
  const tend = TacoCore.playerTendencies
    ? TacoCore.playerTendencies({ leagues: STATE.leagues || [], ownerId: m.ownerId, playersDB: STATE.playersDB })
    : [];

  const stat = (n, l, cls) =>
    '<div class="mb-stat"><span class="mb-stat-n' + (cls ? ' ' + cls : '') + '">' + n + '</span>' +
    '<span class="mb-stat-l">' + l + '</span></div>';

  const summary = TacoCore.describeTrader
    ? TacoCore.describeTrader({
      trades: m.trades,
      won: m.tradeRecord ? m.tradeRecord.won : 0,
      lost: m.tradeRecord ? m.tradeRecord.lost : 0,
      fair: m.tradeRecord ? m.tradeRecord.fair : 0,
      net: m.netValue,
    })
    : '';

  const tendencies = tend.length
    ? '<div class="inv-sec-head">Players they keep coming back to</div>' +
      '<p class="inv-note">Rostered in more than one of the leagues you share - the ones they will not give up, or will pay for again.</p>' +
      '<div class="mb-tend">' + tend.map(function (p) {
        const photo = typeof playerAvatarHtml === 'function' ? playerAvatarHtml(p.playerId, p.name, p.position) : '';
        return '<div class="mb-tend-row">' + photo +
          '<span class="mb-tend-name">' + escapeHtml(p.name) + '</span>' +
          '<span class="mb-tend-meta">' + escapeHtml([p.position, p.team].filter(Boolean).join(' · ')) + '</span>' +
          '<span class="mb-tend-n">' + p.leagues + ' of ' + p.ofShared + '</span>' +
          '</div>';
      }).join('') + '</div>'
    : (m.sharedLeagues < 2
      ? '<div class="inv-sec-head">Players they keep coming back to</div>' +
        '<p class="inv-note">You only share one league with ' + escapeHtml(m.name) +
        ', so there is nothing to compare across. This fills in when you face someone twice.</p>'
      : '');

  const teams = TacoCore.managerTeams
    ? TacoCore.managerTeams({ leagues: STATE.leagues || [], ownerId: m.ownerId })
    : [];
  const teamsHtml = teams.length
    ? '<div class="inv-sec-head">Their team' + (teams.length === 1 ? '' : 's') + '</div>' +
      teams.map(function (t) {
        const players = t.topPlayers.map(function (p) {
          const photo = typeof playerAvatarHtml === 'function' ? playerAvatarHtml(p.playerId, p.name, p.position) : '';
          return '<div class="mb-asset">' + photo +
            '<span class="mb-asset-name">' + escapeHtml(p.name) + '</span>' +
            '<span class="mb-asset-val">' + p.value.toLocaleString() + '</span>' +
            '</div>';
        }).join('');
        return '<div class="mb-team">' +
          '<div class="mb-team-head">' +
          '<span class="mb-team-league">' + escapeHtml(t.leagueName) + '</span>' +
          '<span class="mb-team-meta">' + escapeHtml(t.record) +
          (t.rank ? ' · ' + ordinal(t.rank) + ' of ' + t.ofTeams + ' by value' : '') +
          '</span>' +
          '<span class="mb-team-value">' + t.rosterValue.toLocaleString() + '</span>' +
          '</div>' +
          (players ? '<div class="mb-assets">' + players + '</div>' : '') +
          '</div>';
      }).join('')
    : '';

  const leagues = teamsHtml;

  return (
    '<div class="mb-scout">' +
    '<button type="button" class="ghost small" data-inv-back>‹ All managers</button>' +
    '<div class="mb-scout-head">' +
    '<span class="mb-scout-avatar">' + avatar + '</span>' +
    '<div class="mb-scout-id">' +
    '<div class="mb-scout-name">' + escapeHtml(m.name) +
    (m.badge ? ' <span class="mb-badge mb-badge-' + m.badge + '">' + BADGE_LABEL[m.badge] + '</span>' : '') +
    '</div>' +
    '<div class="mb-scout-sub">' + escapeHtml(summary) + '</div>' +
    '</div></div>' +
    // Everything above is the leagues you share; the dossier is all of theirs.
    '<button type="button" class="inv-lookup-go dos-open" data-inv-lookup="' + escapeHtml(m.ownerId) + '">Full dossier: every league they are in ›</button>' +
    '<div class="mb-stats">' +
    stat(m.sharedLeagues, 'league' + (m.sharedLeagues === 1 ? '' : 's') + ' with you') +
    stat(m.trades || 0, 'trade' + (m.trades === 1 ? '' : 's') + ' scored') +
    stat((m.netValue > 0 ? '+' : '') + (m.netValue || 0).toLocaleString(), 'net value',
      m.netValue < 0 ? 'mb-net-down' : 'mb-net-up') +
    (m.hiddenLeagues ? stat(m.hiddenLeagues, 'league' + (m.hiddenLeagues === 1 ? '' : 's') + ' you cannot see') : '') +
    '</div>' +
    tendencies +
    leagues +
    '</div>'
  );
}

// --- the War Room (paid) -----------------------------------------------------
//
// Owen, 2026-09-27: "The paid features should have their own tab to make it
// more distinct what is offered in the paid tier." Three pages share one gate:
// Manager Dossier (94), League Scout (95) and this Manager Board.

const WAR_ROOM_VIEWS = ['dossierView', 'leagueScoutView', 'investigatorView', 'commishView'];

function warRoomOnScreen() {
  const el = document.querySelector('.view.active');
  return !!(el && WAR_ROOM_VIEWS.includes(el.id));
}
window.warRoomOnScreen = warRoomOnScreen;

/** Re-render whichever War Room page is showing. */
function renderWarRoom() {
  const id = (document.querySelector('.view.active') || {}).id;
  if (id === 'dossierView' && typeof renderDossierView === 'function') renderDossierView();
  else if (id === 'leagueScoutView' && typeof renderLeagueScoutView === 'function') renderLeagueScoutView();
  else if (id === 'investigatorView') renderInvestigatorView();
  else if (id === 'commishView' && typeof renderCommishView === 'function') renderCommishView();
}
window.renderWarRoom = renderWarRoom;

/** A War Room page's header. */
function warRoomHead(title, sub) {
  return '<div class="ma-head"><div><h2 class="ma-title">' + escapeHtml(title) + '</h2>' +
    '<div class="ma-sub">' + escapeHtml(sub) + '</div></div></div>';
}
window.warRoomHead = warRoomHead;

/** The locked state for a War Room page, or '' when this account has access. */
function warRoomLockedHtml() {
  if (investigatorCanUse()) return '';
  // Reachable only by typing the URL while the tier is not on sale (the nav
  // entry is hidden), so say so plainly and offer nothing to buy.
  if (typeof window.billingIsPublic === 'function' && !window.billingIsPublic()) {
    return '<div class="tab-empty">The War Room is in early access and not open yet.</div>';
  }
  // Point at the way in, not just the wall: signed out, that is sign-in;
  // signed in, the plans in Settings.
  const action = STATE.account
    ? '<button class="profile-action-btn" data-taco-open-settings>See plans</button>'
    : '<button class="profile-action-btn" id="accountBtn">Sign in</button>';
  return '<div class="tab-empty">The War Room is part of Pro, from $6 a month.' +
    '<div class="profile-actions investigator-upsell">' + action + '</div></div>';
}
window.warRoomLockedHtml = warRoomLockedHtml;

function renderInvestigatorView() {
  const container = document.getElementById('investigatorContent');
  if (!container) return;

  const head = warRoomHead('Managers', 'Everyone you play against. Open one for the full dossier.');

  const locked = warRoomLockedHtml();
  if (locked) { container.innerHTML = head + locked; return; }
  if (!(STATE.leagues || []).length) {
    container.innerHTML = head + '<div class="tab-empty">Connect your Sleeper leagues to scout your opponents.</div>';
    return;
  }
  if (!window.TacoCore || !TacoCore.buildManagerBoard) {
    container.innerHTML = head + '<div class="tab-empty">Still loading.</div>';
    return;
  }

  ensureInvestigatorTrades();
  loadInvestigatorOverlap();

  if (STATE.investigatorSubject) {
    container.innerHTML = head + investigatorScoutHtml(STATE.investigatorSubject);
    return;
  }

  const all = investigatorBoard();
  const sortKey = STATE.investigatorSort || 'target';
  const query = STATE.investigatorQuery || '';

  const sortOptions = Object.keys(TacoCore.BOARD_SORTS).map(function (k) {
    return '<option value="' + k + '"' + (k === sortKey ? ' selected' : '') + '>' +
      TacoCore.BOARD_SORTS[k].label + '</option>';
  }).join('');

  const grading = !STATE.tradeHistory && STATE.tradeHistoryLoading;

  container.innerHTML =
    head +
    // Anyone outside your leagues lives on the War Room's other two pages.
    '<section class="wr-card">' +
    '<div class="inv-sec-head">Look anyone up <span class="mb-sub">including managers you do not share a league with</span></div>' +
    '<form class="dos-lookup" data-inv-lookup-form>' +
    '<input type="text" class="assets-search-input" id="mbLookupInput" placeholder="Sleeper username…" ' +
    'autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" aria-label="Sleeper username">' +
    '<button type="submit" class="inv-lookup-go">Full dossier</button>' +
    '</form>' +
    '<p class="inv-note">Every league they are in, how they trade, who with, and whether they have walked away from teams before. ' +
    '<a href="/tools/league-scout" data-router>League Scout</a> grades a whole league instead.</p>' +
    '</section>' +
    '<p class="inv-lede">' + escapeHtml(TacoCore.describeBoard(all)) + '</p>' +
    '<div class="assets-search-wrap wr-board-search">' +
    '<input type="text" class="assets-search-input" id="mbSearch" placeholder="Search a manager…" ' +
    'autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" value="' + escapeHtml(query) + '">' +
    '</div>' +
    '<div class="ma-filters-row mb-controls">' +
    '<label class="ry-filter-label" for="mbSort">Sort by</label>' +
    '<select id="mbSort" class="ry-select" data-inv-sort>' + sortOptions + '</select>' +
    (grading ? '<span class="inv-note mb-grading">Grading trades…</span>' : '') +
    '</div>' +
    investigatorDupesHtml() +
    bandwidthCheckHtml() +
    '<section class="wr-card">' +
    '<div class="inv-sec-head">Your leagues <span class="mb-sub">every manager you play against</span></div>' +
    '<div id="mbResults">' + investigatorResultsHtml() + '</div></section>';

  const input = document.getElementById('mbSearch');
  if (input && document.activeElement !== input) input.value = query;
}
window.renderInvestigatorView = renderInvestigatorView;

/** The managers-you-play-against board, as a block the Manager Dossier mounts
 * under its lookup. It was a page of its own until 2026-11-03; a list and a
 * detail view of the same thing do not need two nav entries. */
function investigatorBoardHtml() {
  if (!(STATE.leagues || []).length) return '';
  if (!window.TacoCore || !TacoCore.buildManagerBoard) return '';
  ensureInvestigatorTrades();
  loadInvestigatorOverlap();
  const all = investigatorBoard();
  if (!all.length) return '';
  // Capped on purpose. Across 31 leagues this is several hundred managers,
  // and rendering all of them ran this page past 21,000px -- the wall Owen
  // has now objected to three times. The search box above finds anybody not
  // in the top slice.
  const BOARD_PREVIEW = 20;
  const sortKey = STATE.investigatorSort || 'target';
  const sortOptions = Object.keys(TacoCore.BOARD_SORTS).map(function (k) {
    return '<option value="' + k + '"' + (k === sortKey ? ' selected' : '') + '>' +
      TacoCore.BOARD_SORTS[k].label + '</option>';
  }).join('');
  const grading = !STATE.tradeHistory && STATE.tradeHistoryLoading;
  return '<section class="wr-card">' +
    '<div class="inv-sec-head">Managers you play against <span class="dos-sub">' +
    escapeHtml(TacoCore.describeBoard(all)) + '</span></div>' +
    '<div class="assets-search-wrap">' +
    '<input type="text" class="assets-search-input" id="mbSearch" placeholder="Search a manager…" ' +
    'autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" value="' +
    escapeHtml(STATE.investigatorQuery || '') + '">' +
    '</div>' +
    '<div class="ma-filters-row mb-controls">' +
    '<label class="ry-filter-label" for="mbSort">Sort by</label>' +
    '<select id="mbSort" class="ry-select" data-inv-sort>' + sortOptions + '</select>' +
    (grading ? '<span class="inv-note mb-grading">Grading trades…</span>' : '') +
    '</div>' +
    '<div id="mbResults">' + investigatorResultsHtml({ limit: BOARD_PREVIEW }) + '</div>' +
    (all.length > BOARD_PREVIEW && !(STATE.investigatorQuery || '').trim()
      ? '<p class="inv-note">Showing ' + BOARD_PREVIEW + ' of ' + all.length.toLocaleString() +
        ' managers. Search above for anyone else.</p>'
      : '') +
    '</section>';
}
window.investigatorBoardHtml = investigatorBoardHtml;

/**
 * The part of the board that depends on the search box and the sort.
 *
 * Split out so typing can repaint the results WITHOUT rebuilding the search
 * input. Replacing the container's innerHTML destroys the focused element, so
 * every keystroke used to throw you out of the box and you had to click back in
 * to type the next letter. It also re-ran the duplicate-account scan (2,065
 * pairs across 30 leagues) per letter and snapped the collapsible shut.
 */
function investigatorResultsHtml({ limit = 0 } = {}) {
  const all = investigatorBoard();
  const query = STATE.investigatorQuery || '';
  let rows = TacoCore.sortManagerBoard(
    TacoCore.searchManagerBoard(all, query),
    STATE.investigatorSort || 'target',
  );
  // A limit applies to the unsearched board only: once somebody has typed a
  // name, truncating the matches would hide the thing they asked for.
  if (limit > 0 && !query.trim()) rows = rows.slice(0, limit);
  return (
    (rows.length
      ? '<div class="mb-list">' + rows.map(investigatorRow).join('') + '</div>'
      : '<div class="tab-empty">No manager by that name in your leagues.</div>') +
    investigatorLookupHintHtml(query)
  );
}

/** Repaint just the results. Falls back to a full render if the board is not up. */
function renderInvestigatorResults() {
  const host = document.getElementById('mbResults');
  if (!host) { renderInvestigatorView(); return; }
  host.innerHTML = investigatorResultsHtml();
}

function openScoutReport(ownerId) {
  STATE.investigatorSubject = String(ownerId);
  renderInvestigatorView();
}
window.openScoutReport = openScoutReport;

function closeScoutReport() {
  STATE.investigatorSubject = null;
  renderInvestigatorView();
}
window.closeScoutReport = closeScoutReport;

// Delegated: the board is rebuilt on every keystroke and every sort change.
document.addEventListener('click', function (e) {
  if (!e.target.closest) return;
  if (e.target.closest('[data-inv-back]')) { closeScoutReport(); return; }
  const row = e.target.closest('[data-inv-manager]');
  if (row) openScoutReport(row.dataset.invManager);
});

document.addEventListener('input', function (e) {
  if (e.target && e.target.id === 'mbSearch') {
    STATE.investigatorQuery = e.target.value;
    // Results only — a full render would replace the box being typed into.
    renderInvestigatorResults();
  }
});

document.addEventListener('submit', function (e) {
  const form = e.target && e.target.closest && e.target.closest('[data-inv-lookup-form]');
  if (!form) return;
  e.preventDefault();
  const input = form.querySelector('#dosLookupInput');
  const q = input ? input.value.trim() : '';
  if (q) runInvestigatorLookup(q, false);
});

document.addEventListener('change', function (e) {
  if (!e.target.closest) return;
  if (e.target.closest('[data-inv-sort]')) {
    STATE.investigatorSort = e.target.value;
    // Same reason: leave the select alone so it keeps focus and its own value.
    renderInvestigatorResults();
  }
});

// --- looking somebody up who is not in your leagues -------------------------
//
// The board above can only show managers you play against, because it is built
// from your own rosters. Owen, 2026-09-23: he also wants to look up somebody he
// shares one league with, or none at all — "so I can see if they might be
// cheating". That needs Sleeper rather than the crawl, so it is one request,
// made only when asked for.

var investigatorLookupBusy = false;

function investigatorLookupHintHtml(query) {
  if (!query || query.length < 2) return '';
  return (
    '<div class="inv-lookup-offer">' +
    'Not in your leagues? ' +
    '<button type="button" class="inv-lookup-go" data-inv-lookup="' + escapeHtml(query) + '">' +
    'Look up ' + escapeHtml(query) + ' on Sleeper</button>' +
    '</div>'
  );
}

function runInvestigatorLookup(query, deep) {
  if (investigatorLookupBusy) return;
  investigatorLookupBusy = true;
  STATE.investigatorLookup = { query: query, loading: true };
  // The dossier builds in the browser alongside the header lookup. A "read all
  // seasons" re-run of the same person keeps the dossier already built.
  if (typeof loadDossier === 'function' && !(STATE.dossier && STATE.dossier.query === String(query).trim().replace(/^@+/, ''))) {
    loadDossier(query);
  }
  // From the board, a report or a partner row, a lookup lands on its own page.
  if ((document.querySelector('.view.active') || {}).id !== 'dossierView' && typeof navigateFromLink === 'function') {
    navigateFromLink(null, '/tools/dossier');
  } else {
    renderWarRoom();
  }

  var me = investigatorMeId();
  var url = BACKEND_URL + '/api/investigator?lookup=' + encodeURIComponent(query) +
    (me ? '&me=' + encodeURIComponent(me) : '') + (deep ? '&deep=1' : '');
  var token = typeof window.tacoSessionToken === 'function' ? window.tacoSessionToken() : null;

  fetch(url, { headers: token ? { authorization: 'Bearer ' + token } : {} })
    .then(function (r) { return r.json().catch(function () { return {}; }); })
    .then(function (data) {
      STATE.investigatorLookup = { query: query, data: data, error: data && data.error ? data.error : null };
    })
    .catch(function () {
      STATE.investigatorLookup = { query: query, error: 'Could not reach the server.' };
    })
    .finally(function () {
      investigatorLookupBusy = false;
      if (warRoomOnScreen()) renderWarRoom();
    });
}
window.runInvestigatorLookup = runInvestigatorLookup;

function investigatorLookupHtml() {
  var st = STATE.investigatorLookup;
  if (!st) return '';
  var back = '<button type="button" class="ma-back" data-inv-lookup-close>← New lookup</button>';

  // The dossier is built in the browser, so it stands on its own: a slow or
  // failed header lookup (server) must not hide it.
  var dossierOnly = function (note) {
    var dos = typeof dossierHtml === 'function' ? dossierHtml() : '';
    var head2 = STATE.dossier && STATE.dossier.user
      ? '<div class="mb-scout-head"><div class="mb-scout-name">' + escapeHtml(STATE.dossier.user.name) + '</div></div>' : '';
    return back + '<div class="mb-scout">' + head2 + (note ? '<p class="inv-note">' + note + '</p>' : '') + dos + '</div>';
  };
  if (st.loading) return dossierOnly('Looking up ' + escapeHtml(st.query) + '…');
  if (st.error) {
    return STATE.dossier && STATE.dossier.status !== 'notfound'
      ? dossierOnly('Account details are unavailable right now (' + escapeHtml(st.error) + ').')
      : back + '<div class="tab-empty">' + escapeHtml(st.error) + '</div>';
  }

  var d = st.data || {};
  if (d.notFound) {
    return back +
      '<div class="tab-empty">No Sleeper account called <strong>' + escapeHtml(st.query) + '</strong>. ' +
      'That is the username, not the team name.</div>';
  }

  var m = d.manager || {};
  var name = m.name || st.query;
  var stat = function (n, l) {
    return '<div class="mb-stat"><span class="mb-stat-n">' + escapeHtml(String(n)) + '</span>' +
      '<span class="mb-stat-l">' + escapeHtml(l) + '</span></div>';
  };

  var stats = stat(m.leaguesTotal, 'dynasty leagues');
  if (m.accountCreated) stats += stat(m.accountCreated.slice(0, 4), 'on Sleeper since');
  if (m.longestRunning) stats += stat(m.longestRunning.seasons, 'longest league, seasons');
  stats += stat(m.sharedWithYou, m.sharedWithYou === 1 ? 'league with you' : 'leagues with you');

  // The overlap line is what people came for, so it reads as a sentence.
  var overlap;
  if (m.sharedWithYou) {
    var names = (m.sharedLeagues || []).map(function (l) { return l.name; }).filter(Boolean);
    overlap = 'You and ' + escapeHtml(name) + ' share <strong>' + m.sharedWithYou + '</strong> ' +
      (m.sharedWithYou === 1 ? 'league' : 'leagues') +
      (names.length ? ': ' + escapeHtml(names.slice(0, 6).join(', ')) : '') +
      (names.length > 6 ? ' and ' + (names.length - 6) + ' more' : '') + '.';
  } else {
    overlap = 'You share no leagues with ' + escapeHtml(name) + '.';
  }

  var seasons = (m.leaguesBySeason || []).length > 1
    ? '<div class="inv-seasons">' + m.leaguesBySeason.map(function (s) {
      return '<span class="inv-season"><strong>' + s.count + '</strong> ' + escapeHtml(s.season) + '</span>';
    }).join('') + '</div>'
    : '';

  var sharedIds = {};
  (m.sharedLeagues || []).forEach(function (l) { sharedIds[String(l.league_id)] = true; });
  var list = (m.leagues || []).length
    ? '<div class="inv-sec-head">Their leagues</div><div class="mb-list inv-lookup-list">' +
      m.leagues.map(function (lg) {
        var withYou = sharedIds[String(lg.league_id)];
        return '<div class="inv-lookup-row' + (withYou ? ' inv-lookup-row-shared' : '') + '">' +
          '<span class="inv-lookup-name">' + escapeHtml(lg.name || 'Unnamed league') + '</span>' +
          '<span class="inv-lookup-meta">' +
          (lg.num_teams ? lg.num_teams + '-team' : '') +
          (lg.seasonsCount > 1 ? ' · ' + lg.seasonsCount + ' seasons' : '') +
          (withYou ? ' · with you' : '') +
          '</span></div>';
      }).join('') + '</div>'
    : '';

  var foot = 'Counted across ' + escapeHtml(d.basis || 'recent seasons') + '.' +
    (d.truncated ? ' Showing the first ' + (m.leagues || []).length + '; the totals are complete.' : '') +
    (d.deep ? '' : ' <button type="button" class="inv-deep-go" data-inv-lookup-deep="' +
      escapeHtml(st.query) + '">Read all seven seasons</button>');

  return back +
    '<div class="mb-scout">' +
    '<div class="mb-scout-head"><div class="mb-scout-name">' + escapeHtml(name) + '</div>' +
    (m.username && m.username !== name ? '<div class="mb-scout-sub">@' + escapeHtml(m.username) + '</div>' : '') +
    '</div>' +
    '<div class="mb-stats">' + stats + '</div>' +
    '<p class="inv-lede">' + overlap + '</p>' +
    // The dossier (94) values every league as them. Once it has, its "Their
    // book" replaces the bare list of league names below.
    (typeof dossierHtml === 'function' ? dossierHtml() : '') +
    (STATE.dossier && STATE.dossier.status === 'done' && STATE.dossier.data && STATE.dossier.data.leagues
      ? '' : seasons + list + '<p class="inv-note">' + foot + '</p>') +
    '</div>';
}

// --- two accounts, one person ----------------------------------------------
//
// Runs locally over lg.allRosters, so it covers every league you are in with no
// request and no crawl gap. Facts only: it names the pair, the dates and the
// leagues, and stops. Whether they are brothers, roommates or one person with
// two phones is a thing the commissioner knows and we do not.

// The scan is O(pairs) across every league — 2,065 comparisons on a 30-league
// book. It depends only on who is in your leagues, which does not change while
// the page is open, so compute it once per set of leagues rather than per
// render.
var investigatorDupeCache = { key: null, hits: null };

function investigatorDupes() {
  if (!window.TacoCore || !TacoCore.scanDuplicateAccounts) return [];
  var leagues = STATE.leagues || [];
  var key = leagues.length + ':' + leagues.reduce(function (n, lg) {
    return n + ((lg && lg.allRosters) ? lg.allRosters.length : 0);
  }, 0);
  if (investigatorDupeCache.key !== key) {
    investigatorDupeCache = { key: key, hits: TacoCore.scanDuplicateAccounts({ leagues: leagues }) };
  }
  return investigatorDupeCache.hits;
}

function investigatorDupesHtml() {
  var hits = investigatorDupes();
  if (!hits.length) return '';

  return '<details class="inv-dupes"><summary class="inv-dupes-sum">' +
    'Two accounts, one person? <span class="inv-dupes-n">' + hits.length + '</span>' +
    '</summary>' +
    '<p class="inv-note">Pairs in your leagues where more than one thing lines up. ' +
    'These are facts, not findings - two friends who signed up together at a draft ' +
    'look exactly like this.</p>' +
    hits.map(function (h) {
      return '<div class="inv-dupe">' +
        '<div class="inv-dupe-who">' + escapeHtml(h.a.name) + ' · ' + escapeHtml(h.b.name) + '</div>' +
        '<ul class="inv-dupe-facts">' +
        h.evidence.map(function (e) {
          return '<li>' + escapeHtml(e.fact) +
            (e.detail ? ' <span class="inv-dupe-detail">' + escapeHtml(e.detail) + '</span>' : '') +
            '</li>';
        }).join('') +
        '</ul>' +
        '<div class="inv-dupe-lg">' + escapeHtml(h.leagues.join(', ')) + '</div>' +
        '</div>';
    }).join('') +
    '</details>';
}

// --- Bandwidth (roadmap #8) -------------------------------------------------
//
// How many Sleeper leagues each leaguemate runs this season. Sleeper answers
// that per user, so it costs one request per manager (~250 for a 30-league
// book): run only when asked, and remembered on this device for a day.

var BANDWIDTH_CACHE_KEY = 'bandwidthCheck';
var BANDWIDTH_CACHE_MS = 24 * 60 * 60 * 1000;
var BANDWIDTH_CONCURRENCY = 6;
var BANDWIDTH_SHOWN = 10;

function bandwidthSeason() {
  return String(STATE.season || TacoCore.resolveNflWeekContext().season);
}

/** A run from earlier today on this device, if there is one for this account. */
function bandwidthRestore() {
  if (STATE.bandwidthCheck || typeof TacoStorage === 'undefined') return;
  var saved = TacoStorage.get(BANDWIDTH_CACHE_KEY, null);
  if (!saved || saved.me !== investigatorMeId() || saved.season !== bandwidthSeason()) return;
  if (!(Date.now() - saved.at < BANDWIDTH_CACHE_MS)) return;
  STATE.bandwidthCheck = { status: 'done', done: 0, total: 0, counts: saved.counts || {}, mine: saved.mine, at: saved.at };
}

function bandwidthCount(leagues) {
  var list = Array.isArray(leagues) ? leagues : [];
  var dyn = typeof isDynastyLeague === 'function' ? list.filter(isDynastyLeague).length : 0;
  return { total: list.length, dynasty: dyn };
}

async function runBandwidthCheck() {
  var st = STATE.bandwidthCheck;
  if (st && st.status === 'loading') return;
  var season = bandwidthSeason();
  var ids = investigatorBoard().map(function (m) { return m.ownerId; });
  st = { status: 'loading', done: 0, total: ids.length, counts: {}, mine: null, at: Date.now() };
  STATE.bandwidthCheck = st;
  var repaint = function () { if (STATE.bandwidthCheck === st) bandwidthRepaint(); };
  repaint();

  var me = investigatorMeId();
  var next = 0;
  var worker = async function () {
    while (next < ids.length) {
      var id = ids[next++];
      try {
        st.counts[id] = bandwidthCount(await api('/user/' + id + '/leagues/nfl/' + season));
      } catch (_e) { /* left out and reported as missing, never ranked at zero */ }
      st.done += 1;
      if (st.done % 10 === 0) repaint();
    }
  };
  try {
    if (me) st.mine = bandwidthCount(await api('/user/' + me + '/leagues/nfl/' + season));
  } catch (_e) { /* your own count is a nicety */ }
  await Promise.all(Array.from({ length: BANDWIDTH_CONCURRENCY }, worker));
  if (STATE.bandwidthCheck !== st) return;
  st.status = 'done';
  if (typeof TacoStorage !== 'undefined') {
    TacoStorage.set(BANDWIDTH_CACHE_KEY, { me: me, season: season, at: st.at, counts: st.counts, mine: st.mine });
  }
  repaint();
}
window.runBandwidthCheck = runBandwidthCheck;

/** Repaint only this block: the board around it holds a search box that may have focus. */
function bandwidthRepaint() {
  var host = document.getElementById('bandwidthBlock');
  if (host) host.outerHTML = bandwidthCheckHtml();
  else if (warRoomOnScreen()) renderWarRoom();
}

function bandwidthRowHtml(r, i) {
  return '<button type="button" class="bw-row" data-inv-manager="' + escapeHtml(r.ownerId) + '">' +
    '<span class="bw-rank">' + (i + 1) + '</span>' +
    '<span class="bw-main"><span class="bw-name">' + escapeHtml(r.name) + '</span>' +
    '<span class="bw-sub">' + r.dynasty + ' dynasty · ' + r.sharedLeagues + ' with you</span></span>' +
    '<span class="bw-tier bw-' + r.tier.key + '">' + escapeHtml(r.tier.label) + '</span>' +
    '<span class="bw-n">' + r.total + '</span>' +
    '</button>';
}

function bandwidthCheckHtml() {
  bandwidthRestore();
  var st = STATE.bandwidthCheck;
  var open = '<section class="inv-dupes bw" id="bandwidthBlock">' +
    '<div class="inv-dupes-sum">Bandwidth</div>';
  var close = '</section>';

  if (!st) {
    var n = investigatorBoard().length;
    return open +
      '<p class="inv-note">How many Sleeper leagues each of your ' + n + ' leaguemates runs this season. ' +
      'Someone in forty leagues gives each one a fortieth of their attention.</p>' +
      '<button type="button" class="profile-action-btn" data-bw-run>Run the check</button>' + close;
  }
  if (st.status === 'loading') {
    return open + '<p class="inv-note">Counting leagues… ' + st.done + ' of ' + st.total + ' managers.</p>' + close;
  }

  var board = TacoCore.bandwidthBoard(investigatorBoard(), st.counts);
  var rows = board.rows;
  var lede = (board.median != null ? 'Your median leaguemate plays in ' + board.median + ' league' + (board.median === 1 ? '' : 's') : '') +
    (st.mine ? '; you play in ' + st.mine.total : '') + '.';
  var extra = rows.length > BANDWIDTH_SHOWN
    ? '<details class="bw-more"><summary>Show the other ' + (rows.length - BANDWIDTH_SHOWN) + '</summary>' +
      rows.slice(BANDWIDTH_SHOWN).map(function (r, i) { return bandwidthRowHtml(r, i + BANDWIDTH_SHOWN); }).join('') + '</details>'
    : '';
  var age = Math.round((Date.now() - st.at) / 60000);
  return open +
    '<p class="inv-note">' + escapeHtml(lede) + ' Tiers: ' + escapeHtml(TacoCore.describeBandwidthTiers()) + ' leagues, set from how many your own leaguemates run.</p>' +
    '<div class="bw-list">' + rows.slice(0, BANDWIDTH_SHOWN).map(bandwidthRowHtml).join('') + '</div>' + extra +
    '<p class="bw-foot">' +
    (board.missing ? board.missing + ' could not be looked up. ' : '') +
    'Counted ' + (age < 1 ? 'just now' : age < 60 ? age + ' min ago' : Math.round(age / 60) + 'h ago') +
    '. <button type="button" class="bw-rerun" data-bw-run>Recount</button></p>' +
    close;
}

document.addEventListener('click', function (e) {
  if (!e.target.closest) return;
  if (e.target.closest('[data-bw-run]')) runBandwidthCheck();
});

document.addEventListener('click', function (e) {
  if (!e.target.closest) return;
  var go = e.target.closest('[data-inv-lookup]');
  if (go) { runInvestigatorLookup(go.dataset.invLookup, false); return; }
  var deep = e.target.closest('[data-inv-lookup-deep]');
  if (deep) { runInvestigatorLookup(deep.dataset.invLookupDeep, true); return; }
  if (e.target.closest('[data-inv-lookup-close]')) {
    STATE.investigatorLookup = null;
    renderWarRoom();
  }
});

;
/*! ==== 94-manager-dossier.js ==== */
// Manager dossier -- any Sleeper manager, every dynasty league they are in.
//
// Owen, 2026-09-27: the Investigator "still only shows things related to
// leagues you are also in" and "does nothing to give people reason to pay
// more". The stranger lookup returned a list of league names; this values every
// one of those leagues AS that manager and says what it adds up to (see
// shared/dossier.mjs for the rules).
//
// Runs in the browser, like all enrichment (AGENTS.md: the Worker stays slim).
// Per league: the four league payloads plus that season's trade weeks -- ~8
// Sleeper calls, four leagues at a time. Capped at DOSSIER_MAX_LEAGUES so a
// manager in 300 leagues does not cost 2,400 requests; the page says so.
//
// Pro-gated with the rest of the Investigator (93); this module only builds
// and renders, 93 decides who gets here.

// Owen, 2026-11-03: "the scan should pull every league for the need of the
// data ... some of these freaks might have 1k leagues."
//
// So the scan is two depths, because the cost per league is wildly different
// depending on what you want from it:
//
//   LIGHT, every league, 1 request each: /league/<id>/rosters carries wins,
//   losses, ties, points for, points against and ppts (potential points) for
//   every team in the league. That is the entire headline read -- record, win
//   rate, points per game, lineup efficiency, scoring rank, schedule luck --
//   out of one call. A manager in 1,000 leagues costs 1,000 requests, which at
//   this concurrency is under a minute, not the 8,000+ a full enrich would be.
//
//   DEEP, capped: enrichLeague is four requests and loadLeagueTrades is one
//   per played week, so a fully-read league is ~13-22. That buys team value,
//   archetype, top players, trading and exposure -- the parts that need prices
//   and transactions. Capped, and the page says how many it read.
//
// Nothing is silently truncated: every count on the page says which depth it
// came from.
const DOSSIER_DEEP_MAX = 40;
// The history walk is one request per prior season per league. Capped well
// above the deep read but not unbounded, because it is the one pass that can
// still run away on a 1,000-league account.
const DOSSIER_HISTORY_MAX = 150;
const DOSSIER_CONCURRENCY = 4;
// The light pass is one small request per league, so it can run wider than the
// deep pass without being rude to Sleeper.
const DOSSIER_LIGHT_CONCURRENCY = 8;
// How many leagues a page of the Leagues tab shows.
const DOSSIER_PAGE_SIZE = 25;

let dossierRun = 0; // a newer lookup cancels an older one's rendering

function dossierEsc(t) {
  return escapeHtml(String(t == null ? '' : t));
}

/** One league, enriched as the subject, boiled down to what the dossier reads. */
function dossierSnapshot(lg) {
  const me = (lg.allRosters || []).find((r) => r.isMe);
  if (!me) return null; // co-owner or not actually on a roster
  const values = TacoCore.leagueTeamValues(lg).map((v) => v.value);
  const mine = TacoCore.teamValue(lg, me);
  const players = (me.players || []).map((p) => ({ playerId: p.playerId, name: p.name, position: p.position, value: p.value || 0, age: p.age }));
  const aged = players.filter((p) => p.age && p.value > 0);
  const w = aged.reduce((a, p) => a + p.value, 0);
  let positions = [];
  try { positions = (TacoCore.computePositionNeeds(lg) || {}).positions || []; } catch (_e) { /* thin roster */ }
  // Starting-lineup value and its rank: the "can they win now" number, next to
  // team value's "what do they own" (Owen: the book should say what a rank is).
  const startersOf = (r) => TacoCore.rosterPlayersValue((r.players || []).filter((p) => p.isStarter), { activeOnly: true });
  const starterValues = (lg.allRosters || []).map(startersOf);
  const starterValue = startersOf(me);
  // Standing as Sleeper sorts it: wins, then points for.
  const standing = (lg.allRosters || []).filter((r) =>
    (r.wins || 0) > (me.wins || 0) || ((r.wins || 0) === (me.wins || 0) && (r.pointsFor || 0) > (me.pointsFor || 0))).length + 1;
  const gamesPlayed = (me.wins || 0) + (me.losses || 0) + (me.ties || 0);
  return {
    starterValue: Math.round(starterValue),
    starterRank: TacoCore.rankAmong(starterValues, starterValue),
    standing: gamesPlayed ? standing : null,
    topPlayers: players.slice().sort((a, b) => b.value - a.value).slice(0, 5),
    leagueId: lg.league_id,
    name: lg.name,
    scoringTab: lg.scoringTab,
    teams: (lg.allRosters || []).length,
    teamName: me.teamName,
    teamValue: Math.round(mine),
    valueRank: TacoCore.rankAmong(values, mine),
    archetype: typeof archetypeForRoster === 'function' ? archetypeForRoster(lg, me) : null,
    wins: me.wins || 0,
    losses: me.losses || 0,
    ties: me.ties || 0,
    pointsFor: me.pointsFor || 0,
    // Already in the roster payload, previously discarded. pointsAgainst gives
    // a differential; maxPointsFor (Sleeper's ppts -- what the roster WOULD
    // have scored with a perfect lineup) gives lineup efficiency, which is the
    // single most useful thing you can know about an opponent and is on no
    // competitor's page. pointsForRank places their scoring inside their own
    // league, which is what schedule luck is measured against.
    pointsAgainst: me.pointsAgainst || 0,
    maxPointsFor: me.maxPointsFor || 0,
    pointsForRank: gamesPlayed
      ? (lg.allRosters || []).filter((r) => (r.pointsFor || 0) > (me.pointsFor || 0)).length + 1
      : null,
    ownerId: me.ownerId ? String(me.ownerId) : null,
    avgAge: w ? Math.round((aged.reduce((a, p) => a + p.age * p.value, 0) / w) * 10) / 10 : null,
    picksValue: Math.round(TacoCore.picksValue(lg.myPicks || [])),
    positions,
    players,
  };
}

/** One league read at the cheap depth: a single /rosters call.
 *
 * Everything summarizeManager needs is in here. No value, no archetype, no
 * trades -- those need prices and transactions, which is what the deep pass
 * is for. */
async function dossierLiteSnapshot(lg, subjectId) {
  const rosters = await api('/league/' + lg.league_id + '/rosters');
  if (!Array.isArray(rosters)) return null;
  const me = rosters.find((r) => String(r.owner_id) === String(subjectId)
    || (Array.isArray(r.co_owners) && r.co_owners.map(String).includes(String(subjectId))));
  if (!me) return null;
  const s = me.settings || {};
  const num = (a, b) => (Number(a) || 0) + (Number(b) || 0) / 100;
  const pointsFor = num(s.fpts, s.fpts_decimal);
  const games = (s.wins || 0) + (s.losses || 0) + (s.ties || 0);
  return {
    leagueId: lg.league_id,
    name: lg.name,
    scoringTab: TacoCore.detectScoringTab(lg),
    teams: rosters.length || lg.total_rosters || 0,
    wins: s.wins || 0,
    losses: s.losses || 0,
    ties: s.ties || 0,
    pointsFor,
    pointsAgainst: num(s.fpts_against, s.fpts_against_decimal),
    maxPointsFor: num(s.ppts, s.ppts_decimal),
    pointsForRank: games
      ? rosters.filter((r) => num(r.settings?.fpts, r.settings?.fpts_decimal) > pointsFor).length + 1
      : null,
    standing: games
      ? rosters.filter((r) => {
        const rw = r.settings?.wins || 0;
        const mw = s.wins || 0;
        return rw > mw || (rw === mw && num(r.settings?.fpts, r.settings?.fpts_decimal) > pointsFor);
      }).length + 1
      : null,
  };
}

/** Look someone up by username or Sleeper user id and build their dossier. */
async function loadDossier(query) {
  const run = ++dossierRun;
  const q = String(query || '').trim().replace(/^@+/, '');
  const st = { query: q, status: 'loading', done: 0, total: 0 };
  STATE.dossier = st;
  STATE.dossierTab = 'overview';
  STATE.dossierPage = 1;
  STATE.careerSeason = 'all';
  const repaint = () => { if (run === dossierRun && typeof warRoomOnScreen === 'function' && warRoomOnScreen()) renderWarRoom(); };
  repaint();
  try {
    const user = await api('/user/' + encodeURIComponent(q));
    if (!user || !user.user_id) { st.status = 'notfound'; repaint(); return; }
    st.user = { id: String(user.user_id), name: user.display_name || user.username || q, avatar: user.avatar || null };
    const season = String(STATE.season || TacoCore.resolveNflWeekContext().season);
    const all = (await api('/user/' + user.user_id + '/leagues/nfl/' + season)) || [];
    const leagues = all.filter(isDynastyLeague);
    st.leaguesTotal = leagues.length;
    st.total = leagues.length;
    repaint();

    // Pass 1: every league, one request each. The headline read is complete
    // after this, for all of them, however many there are.
    const lite = [];
    const unreadable = [];
    let liteNext = 0;
    const liteWorker = async () => {
      while (liteNext < leagues.length) {
        const lg = leagues[liteNext++];
        let snap = null;
        for (let attempt = 0; attempt < 2 && !snap; attempt++) {
          try {
            snap = await dossierLiteSnapshot(lg, st.user.id);
            // A null here is "they are not on a roster in this league", which
            // is an answer, not a failure -- do not retry it.
            if (!snap) break;
          } catch (_e) {
            // Sleeper rate-limits a sweep this wide. One backoff, then give
            // up on this league and record that we did.
            if (attempt === 0) await new Promise((r) => setTimeout(r, 900));
            else unreadable.push(lg.name || lg.league_id);
          }
        }
        if (snap) lite.push(snap);
        st.done += 1;
        if (st.done % 10 === 0) repaint();
      }
    };
    await Promise.all(Array.from({ length: DOSSIER_LIGHT_CONCURRENCY }, liteWorker));
    if (run !== dossierRun) return;
    st.lite = lite;
    st.unreadable = unreadable.length;
    st.summary = TacoCore.summarizeManager(lite);
    st.phase = 'deep';
    st.done = 0;
    // Read the deepest leagues first: the ones where they own the most is
    // where a value read is worth spending the requests.
    const ranked = leagues.slice().sort((a, b) => {
      const la = lite.find((x) => x.leagueId === a.league_id);
      const lb = lite.find((x) => x.leagueId === b.league_id);
      return ((lb ? lb.pointsFor : 0) - (la ? la.pointsFor : 0));
    });
    const todo = ranked.slice(0, DOSSIER_DEEP_MAX);
    st.total = todo.length;
    repaint();

    if (typeof ensurePlayersDB === 'function') await ensurePlayersDB();
    // Their formats may not be ones you play; load those value boards first or
    // every player in them would price at zero.
    const tabs = [...new Set(todo.map((lg) => TacoCore.detectScoringTab(lg)))];
    if (typeof hydrateBackendComposites === 'function') await hydrateBackendComposites(tabs);

    const snapshots = [];
    const trades = [];
    let next = 0;
    const worker = async () => {
      while (next < todo.length) {
        const lg = todo[next++];
        try {
          const enriched = await enrichLeague(lg, { userId: st.user.id });
          const snap = dossierSnapshot(enriched);
          if (snap) snapshots.push(snap);
          if (typeof loadLeagueTrades === 'function') {
            trades.push(...(await loadLeagueTrades(enriched, { cache: false })));
          }
        } catch (_e) { /* one bad league does not sink the dossier */ }
        st.done += 1;
        if (st.done % 3 === 0) repaint();
      }
    };
    await Promise.all(Array.from({ length: DOSSIER_CONCURRENCY }, worker));
    if (run !== dossierRun) return;
    snapshots.sort((a, b) => (a.valueRank / a.teams) - (b.valueRank / b.teams));
    st.snapshots = snapshots;
    // Kept so a partner row can open and show the actual trades. These were
    // fetched, aggregated and discarded, which meant the page could tell you
    // somebody had won 14 trades off this manager without ever showing you
    // one of them.
    st.trades = trades;
    st.data = TacoCore.buildDossier({
      subjectId: st.user.id,
      snapshots,
      trades,
      ageOf: (pid) => (STATE.playersDB && STATE.playersDB[pid] ? STATE.playersDB[pid].age : null),
    });
    st.status = 'done';
    // Built from the LIGHT set deliberately: that is every league they are in,
    // where st.snapshots is only the deeply-read subset. The headline numbers
    // must describe all of them.
    st.summary = TacoCore.summarizeManager(st.lite || snapshots);
    repaint();
    // Everything above is this season. The history pass runs after the page is
    // already on screen, because it is the slow half and nobody should stare
    // at a spinner for it: one chain walk per league, each cached forever
    // (a finished season never changes). It fills in all-time records and
    // whether this manager has walked away from teams before.
    deepenDossier(st, run).catch((e) => console.warn('[dossier] deep pass', e && e.message));
    // Their whole career, asked for one season at a time. The deepen pass
    // above walks the leagues they are in NOW; this finds the ones they
    // played and left, which that walk is structurally blind to.
    if (typeof loadCareer === 'function') {
      loadCareer(st.user.id, {
        onProgress: () => { if (run === dossierRun) repaint(); },
      }).then((career) => {
        if (run !== dossierRun) return;
        st.career = career;
        repaint();
      }).catch((e) => console.warn('[dossier] career', e && e.message));
    }
  } catch (err) {
    st.status = 'error';
    st.error = (err && err.message) || 'Could not load that manager.';
  }
  repaint();
}
window.loadDossier = loadDossier;

/** Second pass: every league's past seasons, for this manager.
 *
 * Reuses module 12's chain walk and season-snapshot cache, so a league already
 * visited by the All Leagues all-time record -- or by a previous dossier --
 * costs nothing at all. */
async function deepenDossier(st, run) {
  const pool = (st.lite && st.lite.length ? st.lite : st.snapshots) || [];
  if (!pool.length) return;
  if (typeof getLeagueChain !== 'function' || typeof fetchSeasonSnapshot !== 'function') return;
  const subject = st.user.id;
  // Over every league, not just the deeply-read ones -- an all-time record
  // that covered 40 of somebody's 500 leagues would be worse than none.
  // Capped, because this is the one pass that can still run away.
  const walk = pool.slice(0, DOSSIER_HISTORY_MAX);
  st.historyCapped = pool.length > walk.length ? pool.length : 0;
  st.deep = { done: 0, total: walk.length };

  const turnoverPerLeague = [];
  const names = {};
  let next = 0;
  const worker = async () => {
    while (next < walk.length) {
      const snap = walk[next++];
      try {
        const chain = await getLeagueChain(snap.leagueId);
        if (chain.length > 1) {
          const seasons = [];
          for (const link of chain) {
            const s = await fetchSeasonSnapshot(link.leagueId, link.season);
            if (!s) continue;
            Object.assign(names, s.names);
            seasons.push({ season: s.season, leagueId: s.leagueId, leagueName: snap.name, rosters: s.rosters });
          }
          if (seasons.length > 1) {
            turnoverPerLeague.push(TacoCore.buildLeagueTurnover({ seasons }));
            // Their record in every season of this league they actually
            // played. A team taken over last winter does not inherit the
            // previous owner's losses.
            const theirs = seasons
              .map((s) => (s.rosters || []).find((r) => String(r.ownerId) === String(subject)
                || (r.coOwners || []).map(String).includes(String(subject))))
              .filter(Boolean);
            if (theirs.length) {
              const sum = TacoCore.summarizeLeagueRecord(theirs);
              if (sum.games > 0) snap.allTime = sum;
            }
          }
        }
      } catch (_e) { /* one league's history missing is not fatal */ }
      st.deep.done += 1;
      if (run !== dossierRun) return;
      if (st.deep.done % 4 === 0 && typeof warRoomOnScreen === 'function' && warRoomOnScreen()) renderWarRoom();
    }
  };
  await Promise.all(Array.from({ length: DOSSIER_CONCURRENCY }, worker));
  if (run !== dossierRun) return;

  const agg = TacoCore.aggregateOwnerTurnover(turnoverPerLeague, names);
  st.turnover = agg.owners.find((o) => String(o.ownerId) === String(subject))
    || { ownerId: subject, left: 0, tookOver: 0, net: 0, leftIn: [], tookOverIn: [] };
  st.summary = TacoCore.summarizeManager(pool);
  st.deep.complete = true;
  if (typeof warRoomOnScreen === 'function' && warRoomOnScreen()) renderWarRoom();
}
window.deepenDossier = deepenDossier;

const DOSSIER_STYLE_LABEL = { contending: 'Contending', building: 'Building', middle: 'Middle', rebuilding: 'Rebuilding' };

function dossierStat(n, label) {
  return '<div class="mgr-stat"><b>' + dossierEsc(n) + '</b><span>' + dossierEsc(label) + '</span></div>';
}

/** One stat cell, in the manager-card language shared with the drawer. */
function mgrStat(value, label, cls, tip) {
  return '<div class="mgr-stat"' + (tip ? ' data-tooltip="' + dossierEsc(tip) + '"' : '') + '>' +
    '<b' + (cls ? ' class="' + cls + '"' : '') + '>' + dossierEsc(value) + '</b>' +
    '<span>' + dossierEsc(label) + '</span></div>';
}

function mgrBlock(label, sub, cells) {
  return '<div class="mgr-statline"><div class="mgr-statline-head">' + dossierEsc(label) +
    (sub ? '<span class="mgr-statline-sub">' + dossierEsc(sub) + '</span>' : '') + '</div>' +
    '<div class="mgr-stats">' + cells + '</div></div>';
}

/** The deep read, above the dossier's trading and exposure work.
 *
 * Owen, 2026-11-03: "merge them but then i want way more data ... I want a
 * fucking deep dive like the site i shared but even fucking deeper."
 *
 * The expensive half (every league's past seasons) lands after the page does,
 * so this renders what it has and fills in. */
function dossierDeepHtml(st) {
  const s = st.summary;
  if (!s || !s.record.games) return '';

  // The season filter (Owen: "we need to almost have a filter. all, then tabs
  // for current seasons"). It only appears once the career has loaded and
  // there is more than one season to choose between.
  const career = st.career;
  const tabs = career && typeof TacoCore.careerTabs === 'function' ? TacoCore.careerTabs(career) : [];
  const seasonKey = tabs.some((t) => t.key === STATE.careerSeason) ? STATE.careerSeason : 'all';
  const seasonBar = tabs.length
    ? '<div class="sub-tab-bar wr-season-bar">' + tabs.map((t) =>
      '<button type="button" class="sub-tab' + (t.key === seasonKey ? ' active' : '') +
      '" data-dos-season="' + dossierEsc(t.key) + '" title="' + dossierEsc(t.sub) + '">' +
      dossierEsc(t.label) + '</button>').join('') + '</div>'
    : '';
  // When the career is loaded, the record comes from it -- that is the whole
  // point, since it includes leagues they left. Until then the this-season
  // numbers stand in.
  const careerRows = career ? TacoCore.filterCareer(career.rows, seasonKey) : null;
  const careerCut = careerRows ? TacoCore.careerSummary(careerRows) : null;
  const pct = (v) => (v == null ? '-' : v.toFixed(1) + '%');
  const tone = (v) => {
    const t = TacoCore.winPctTone(v);
    return t === 'good' ? 'mgr-good' : t === 'bad' ? 'mgr-bad' : '';
  };
  const rec = (r) => r.wins + '-' + r.losses + (r.ties ? '-' + r.ties : '');

  const headline = TacoCore.managerHeadline(s);
  const headHtml = headline
    ? '<p class="mgr-headline">' + dossierEsc(st.user.name) + ' ' + dossierEsc(headline) + '.</p>'
    : '';

  // Built here, chosen at the single return below -- relHtml and youHtml are
  // declared further down, so returning from inside this block reads them in
  // their temporal dead zone.
  let careerBlock = '';
  let careerLineup = '';
  let careerNote = '';
  if (careerCut && careerCut.games > 0) {
    const label = seasonKey === 'all' ? 'All time' : seasonKey;
    const sub = careerCut.games + ' games across ' + careerCut.leagues + ' league' +
      (careerCut.leagues === 1 ? '' : 's') +
      (seasonKey === 'all' && career.firstSeason !== career.lastSeason
        ? ' · ' + career.firstSeason + '-' + career.lastSeason : '');
    careerBlock = mgrBlock(label, sub,
      mgrStat(careerCut.record, 'record') +
      mgrStat(pct(careerCut.winPct), 'win %', tone(careerCut.winPct)) +
      mgrStat(careerCut.pointsPerGame != null ? careerCut.pointsPerGame.toFixed(1) : '-', 'pts / game') +
      mgrStat(careerCut.pointDiffPerGame != null
        ? (careerCut.pointDiffPerGame > 0 ? '+' : '') + careerCut.pointDiffPerGame.toFixed(1) : '-', 'pt diff / g',
      careerCut.pointDiffPerGame > 0 ? 'mgr-good' : careerCut.pointDiffPerGame < 0 ? 'mgr-bad' : ''));
    careerLineup = careerCut.efficiency
      ? mgrBlock('Lineup management', 'how much of their own roster they start',
        mgrStat(careerCut.efficiency.pct.toFixed(1) + '%', 'started',
          careerCut.efficiency.pct >= 90 ? 'mgr-good' : careerCut.efficiency.pct < 82 ? 'mgr-bad' : '') +
        mgrStat(careerCut.efficiency.perGame != null ? careerCut.efficiency.perGame.toFixed(1) : '-', 'left on bench / g') +
        mgrStat(Math.round(careerCut.efficiency.pointsLeft).toLocaleString(), 'left in total') +
        mgrStat(careerCut.seasonsPlayed || careerCut.leagues, 'league-seasons'))
      : '';
    careerNote = '<p class="inv-note">' +
      dossierEsc(TacoCore.careerCoverageNote(career, { seasonsFetched: career.seasonsFetched })) + '</p>';
  }

  const season = mgrBlock('This season', s.record.games + ' games across ' + s.leaguesPlayed + ' leagues',
    mgrStat(rec(s.record), 'record') +
    mgrStat(pct(s.winPct), 'win %', tone(s.winPct), 'Every head-to-head game they have played this season, in every league. A tie counts as half a win.') +
    mgrStat(s.pointsPerGame != null ? s.pointsPerGame.toFixed(1) : '-', 'pts / game') +
    mgrStat(s.pointDiffPerGame != null ? (s.pointDiffPerGame > 0 ? '+' : '') + s.pointDiffPerGame.toFixed(1) : '-', 'pt diff / g',
      s.pointDiffPerGame > 0 ? 'mgr-good' : s.pointDiffPerGame < 0 ? 'mgr-bad' : ''));

  const at = s.allTime;
  let allTimeHtml = '';
  if (st.deep && st.deep.complete && at.games > s.record.games) {
    allTimeHtml = mgrBlock('All time', at.seasonsPlayed + ' league-seasons · ' + at.games + ' games',
      mgrStat(rec(at), 'record') +
      mgrStat(pct(at.winPct), 'win %', tone(at.winPct)) +
      mgrStat(at.pointsPerGame != null ? at.pointsPerGame.toFixed(1) : '-', 'pts / game') +
      mgrStat(s.avgStanding != null ? s.avgStanding.toFixed(1) : '-', 'avg standing'));
  } else if (st.deep && !st.deep.complete) {
    allTimeHtml = '<div class="mgr-pending">Reading past seasons… ' + st.deep.done + ' of ' + st.deep.total + '</div>';
  }

  // The number no competitor shows: how much of their own roster they
  // actually start. Free -- Sleeper puts potential points on the roster.
  let lineupHtml = '';
  if (s.efficiency) {
    const e = s.efficiency;
    const effCls = e.pct >= 90 ? 'mgr-good' : e.pct < 82 ? 'mgr-bad' : '';
    lineupHtml = mgrBlock('Lineup management', 'how much of their own roster they start',
      mgrStat(e.pct.toFixed(1) + '%', 'started', effCls, 'Points they actually scored, over what their roster COULD have scored with a perfect lineup every week. Sleeper publishes both.') +
      mgrStat(e.perGame != null ? e.perGame.toFixed(1) : '-', 'left on bench / g', e.perGame >= 10 ? 'mgr-bad' : '') +
      mgrStat(Math.round(e.pointsLeft).toLocaleString(), 'left all season') +
      mgrStat(s.scheduleLuck != null ? (s.scheduleLuck > 0 ? '+' : '') + s.scheduleLuck.toFixed(1) : '-', 'schedule luck',
        s.scheduleLuck > 0 ? 'mgr-good' : s.scheduleLuck < 0 ? 'mgr-bad' : '',
        'Wins above or below what their scoring rank in each league deserved. An approximation from scoring rank, not a full all-play record.')) +
      '<p class="inv-note">' + dossierEsc(TacoCore.lineupEfficiencyNote(e)) +
      (s.worstLineups.length
        ? ' Worst: ' + s.worstLineups.map((l) => dossierEsc(l.name) + ' ' + l.pct.toFixed(0) + '%').join(', ') + '.'
        : '') + '</p>';
  }

  // Have they walked away from teams before.
  let relHtml = '';
  if (st.turnover) {
    const t = st.turnover;
    const CHIP_CAP = 8;
    const all = [
      ...t.leftIn.map((x) => ({ cls: 'mgr-bad', text: 'left ' + x.season + ' ' + x.league })),
      ...t.tookOverIn.map((x) => ({ cls: 'mgr-good', text: 'took over ' + x.season + ' ' + x.league })),
    ];
    const rest = all.length - CHIP_CAP;
    const where = all.slice(0, CHIP_CAP)
      .map((x) => '<span class="mgr-where ' + x.cls + '">' + dossierEsc(x.text) + '</span>').join('') +
      (rest > 0 ? '<span class="mgr-where">+' + rest + ' more</span>' : '');
    relHtml = mgrBlock('Teams given up', 'across their leagues that have run more than one season',
      mgrStat(t.left, 'teams left', t.left > 1 ? 'mgr-bad' : '') +
      mgrStat(t.tookOver, 'orphans taken', t.tookOver > 0 ? 'mgr-good' : '') +
      mgrStat(s.leagues, 'leagues now') +
      mgrStat(at.seasonsPlayed || '-', 'seasons played')) +
      (where ? '<div class="mgr-wheres">' + where + '</div>' : '') +
      '<p class="inv-note">A team changing hands is a handover, not a verdict - somebody may have quit, been removed, or simply had a year. ' +
      'This counts only leagues still reachable from the ones they are in now: Sleeper has no forward pointer, so a league that ' +
      'folded and a league that carried on without them look identical from here. A zero means none seen, not never.</p>';
  }

  // Where you two overlap, if you do.
  let youHtml = '';
  const mine = (STATE.leagues || []).filter((lg) => (lg.allRosters || [])
    .some((r) => String(r.ownerId) === String(st.user.id)));
  if (mine.length) {
    const w = TacoCore.tradesWithYou(STATE.tradeHistory || [], st.user.id, STATE.userId);
    youHtml = mgrBlock('With you', mine.length + ' league' + (mine.length === 1 ? '' : 's') + ' you share',
      mgrStat(mine.length, 'shared leagues') +
      mgrStat(w.trades, 'trades') +
      mgrStat(w.youWon, 'you won', 'mgr-good') +
      mgrStat(w.theyWon, 'they won', 'mgr-bad'));
  }

  // The career blocks replace the this-season ones once the per-season walk
  // has landed: they cover the leagues this manager played and LEFT, which
  // the current-season walk is structurally blind to.
  const recordBlocks = careerBlock
    ? careerBlock + careerLineup
    : season + allTimeHtml + lineupHtml;
  return '<div class="mgr-deep mgr-deep-bare">' + headHtml + seasonBar + recordBlocks +
    relHtml + youHtml + careerNote +
    (career ? '' : '<p class="inv-note">Reading their earlier seasons…</p>') + '</div>';
}
window.dossierDeepHtml = dossierDeepHtml;

/** Every trade between the subject and one partner, newest first.
 *
 * Rendered with renderTradeHistoryRow -- the same builder Trade History uses
 * -- so a trade looks identical wherever it appears, carries the calculator's
 * verdict rather than a second opinion, and picks up the realized-points
 * strip for free. withHead keeps the league name and date, which matters here
 * because these span several leagues. */
function dossierPartnerTradesHtml(st, partnerId) {
  const all = Array.isArray(st.trades) ? st.trades : [];
  const subject = String(st.user.id);
  const pid = String(partnerId);
  const between = all.filter((t) => {
    if (!t || !Array.isArray(t.sides) || t.sides.length !== 2) return false;
    const ids = t.sides.map((s) => String(s.ownerId || ''));
    return ids.includes(subject) && ids.includes(pid);
  }).sort((a, b) => (b.statusUpdated || 0) - (a.statusUpdated || 0));

  if (!between.length) {
    return '<p class="inv-note">These trades were counted from league transactions, but the detail is not loaded for this pair.</p>';
  }
  if (typeof renderTradeHistoryRow !== 'function') {
    return '<p class="inv-note">Trade detail is still loading.</p>';
  }
  return '<div class="dos-partner-trades">' +
    between.map((t) => renderTradeHistoryRow(t, { withHead: true, meLabel: st.user.name })).join('') +
    '</div>';
}
window.dossierPartnerTradesHtml = dossierPartnerTradesHtml;

/** The dossier body (below the lookup header 93 already renders). */
function dossierHtml() {
  const st = STATE.dossier;
  if (!st) return '';
  if (st.status === 'loading') {
    if (!st.total) return '<div class="dos-loading">Finding their leagues…</div>';
    return '<div class="dos-loading">' + (st.phase === 'deep'
      ? 'Valuing ' + st.done.toLocaleString() + ' of ' + st.total.toLocaleString() + ' leagues…'
      : 'Reading ' + st.done.toLocaleString() + ' of ' + st.total.toLocaleString() + ' leagues…') + '</div>';
  }
  if (st.status === 'notfound') return '';
  if (st.status === 'error') return '<div class="tab-empty">' + dossierEsc(st.error) + '</div>';
  const d = st.data;
  if (!d || !d.leagues) return '<div class="tab-empty">No dynasty leagues this season.</div>';

  const t = d.trading;
  const styleLine = Object.keys(DOSSIER_STYLE_LABEL)
    .filter((k) => d.styles[k])
    .map((k) => '<span class="dos-chip dos-' + k + '">' + DOSSIER_STYLE_LABEL[k] + ' ' + d.styles[k] + '</span>')
    .join('');

  // The combined record used to sit in this strip; it is stated properly in
  // the deep block above now, with a win rate and points beside it, so this
  // strip keeps only what is about their BOOK rather than their results.
  const summary = dossierDeepHtml(st);
  const bookSummary =
    '<div class="inv-sec-head">Their book <span class="dos-sub">value across every league</span></div>' +
    '<div class="mgr-stats">' +
    dossierStat(d.leagues + (st.leaguesTotal > d.leagues ? ' of ' + st.leaguesTotal : ''), 'leagues valued') +
    dossierStat(d.firstInValue, '#1 by value') +
    dossierStat(d.topThird, 'top third') +
    dossierStat(st.summary && st.summary.avgValueRank != null ? st.summary.avgValueRank.toFixed(1) : '—', 'avg value rank') +
    '</div>' +
    '<div class="dos-chips">' + styleLine + '</div>';

  const tips = d.tips.length
    ? '<div class="inv-sec-head">How to approach them</div><ul class="dos-tips">' +
      d.tips.map((x) => '<li>' + dossierEsc(x) + '</li>').join('') + '</ul>'
    : '';

  const graded = t.won + t.lost + t.fair;
  const trading =
    '<div class="inv-sec-head">How they trade <span class="dos-sub">this season</span></div>' +
    (t.trades
      ? '<div class="mgr-stats">' +
        dossierStat(t.trades, t.trades === 1 ? 'trade' : 'trades') +
        dossierStat(graded ? t.won + '-' + t.lost + (t.fair ? '-' + t.fair : '') : '—', 'won-lost-fair') +
        dossierStat(graded ? (t.net > 0 ? '+' : '') + t.net.toLocaleString() : '—', 'value net') +
        dossierStat(t.partners, 'partners') +
        '</div>' +
        '<p class="inv-note">' +
        (t.lastTradeAt ? 'Last trade ' + new Date(t.lastTradeAt).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) + '. ' : '') +
        (t.pickNet ? (t.pickNet > 0 ? 'Net buyer of picks (+' : 'Net seller of picks (') + t.pickNet.toLocaleString() + '). ' : '') +
        (t.ageIn != null && t.ageOut != null ? 'Players in average ' + t.ageIn + ', out ' + t.ageOut + '.' : '') +
        '</p>' +
        (graded && graded < TacoCore.MIN_TRADES_FOR_VERDICT ? '<p class="inv-note">Too few trades to call them a good or bad trader yet.</p>' : '')
      : '<p class="inv-note">No trades yet this season.</p>');

  // Who they trade with most (Owen: "to show possible collusion"). Facts only;
  // each partner opens their own dossier, so a chain can be followed.
  const partners = (d.partners || []).length
    ? '<div class="inv-sec-head">Who they trade with most <span class="dos-sub">two-team trades, this season</span></div>' +
      '<div class="mb-list">' + d.partners.map((p) => {
        const flow = !p.flow ? 'even' : p.flow > 0
          ? '+' + p.flow.toLocaleString() + ' to ' + dossierEsc(st.user.name)
          : '+' + Math.abs(p.flow).toLocaleString() + ' to ' + dossierEsc(p.name);
        return '<details class="dos-partner' + (p.facts.length ? ' dos-partner-flag' : '') + '">' +
          '<summary>' +
          '<div class="dos-league-top">' +
          '<span class="dos-partner-name">' + dossierEsc(p.name) + '</span>' +
          '<span class="dos-row-val">' + p.trades + ' trades · ' + p.leagues + ' league' + (p.leagues === 1 ? '' : 's') +
          (p.share != null ? ' · ' + p.share + '% of theirs' : '') + '</span></div>' +
          '<div class="dos-league-sub">Value: ' + flow + ' · won-lost-fair ' + p.toSubject + '-' + p.toPartner + '-' + p.fair + '</div>' +
          (p.facts.length ? '<ul class="dos-facts">' + p.facts.map((f) => '<li>' + dossierEsc(f) + '</li>').join('') + '</ul>' : '') +
          '</summary>' +
          '<div class="dos-partner-body">' + dossierPartnerTradesHtml(st, p.ownerId) +
          '<button type="button" class="ghost small" data-inv-lookup="' + dossierEsc(p.ownerId) + '">Open ' + dossierEsc(p.name) + '\u2019s dossier \u2192</button>' +
          '</div>' +
          '</details>';
      }).join('') + '</div>' +
      (d.partners.some((p) => p.facts.length)
        ? '<p class="inv-note">Patterns, not proof: friends who joined together and trade often look exactly like this. It is for a commissioner to weigh.</p>'
        : '')
    : '';

  const pos = d.positions
    .filter((p) => p.leagues)
    .sort((a, b) => a.avgRankPct - b.avgRankPct)
    .map((p) => {
      const cls = p.avgRankPct <= 33 ? 'dos-strong' : p.avgRankPct >= 67 ? 'dos-weak' : '';
      return '<div class="dos-pos ' + cls + '"><span class="dos-pos-name">' + dossierEsc(p.pos) + '</span>' +
        '<span class="dos-pos-detail">strong in ' + p.strongIn + ' · thin in ' + p.weakIn + ' of ' + p.leagues + '</span></div>';
    }).join('');
  const positions = pos ? '<div class="inv-sec-head">Where they are strong and thin</div><div class="dos-pos-grid">' + pos + '</div>' : '';

  const exp = d.exposure.length
    ? '<div class="inv-sec-head">Who they believe in <span class="dos-sub">owned in the most leagues</span></div>' +
      '<div class="mb-list">' + d.exposure.map((p) =>
        '<button type="button" class="dos-row" data-taco-player="' + dossierEsc(p.playerId) + '">' +
        '<span class="dos-row-name">' + dossierEsc(p.name) + ' <span class="dos-row-pos">' + dossierEsc(p.position) + '</span></span>' +
        '<span class="dos-row-val">' + p.leagues + ' leagues · ' + p.share + '%</span></button>').join('') +
      '</div>'
    : '';

  // One card per league. The summary line carries the three ranks, each named
  // (Owen: "has a ranking on it but it doesnt describe what that ranking
  // means"); tapping opens values, picks, age and their top players there.
  const fmtN = (n) => (typeof formatCompactNumber === 'function' ? formatCompactNumber(n) : String(n));
  const ord = (n) => (typeof ordinal === 'function' ? ordinal(n) : String(n));
  // Every league they are in -- the deeply-read ones first, carrying value and
  // top players, then the rest from the light pass with their record. A row
  // without a value read says so rather than showing a zero.
  const deepById = {};
  for (const s of st.snapshots) deepById[s.leagueId] = s;
  const allRows = st.snapshots.concat(
    (st.lite || []).filter((l) => !deepById[l.leagueId]).map((l) => ({ ...l, liteOnly: true })),
  );
  const pageCount = Math.max(1, Math.ceil(allRows.length / DOSSIER_PAGE_SIZE));
  const page = Math.min(Math.max(1, Number(STATE.dossierPage) || 1), pageCount);
  const pageRows = allRows.slice((page - 1) * DOSSIER_PAGE_SIZE, page * DOSSIER_PAGE_SIZE);
  const pager = pageCount > 1
    ? '<div class="dos-pager">' +
      '<button type="button" class="ghost small" data-dos-page="' + (page - 1) + '"' + (page === 1 ? ' disabled' : '') + '>Previous</button>' +
      '<span class="dos-pager-at">' + ((page - 1) * DOSSIER_PAGE_SIZE + 1).toLocaleString() + '-' +
      Math.min(page * DOSSIER_PAGE_SIZE, allRows.length).toLocaleString() + ' of ' + allRows.length.toLocaleString() + '</span>' +
      '<button type="button" class="ghost small" data-dos-page="' + (page + 1) + '"' + (page === pageCount ? ' disabled' : '') + '>Next</button>' +
      '</div>'
    : '';
  const book = '<div class="inv-sec-head">Every league <span class="dos-sub">' +
    allRows.length.toLocaleString() + ' · tap one for detail</span></div>' + pager + '<div class="mb-list">' +
    pageRows.map((s) => {
      if (s.liteOnly) {
        const lrec = s.wins + '-' + s.losses + (s.ties ? '-' + s.ties : '');
        const leff = TacoCore.lineupEfficiency(s.pointsFor, s.maxPointsFor, s.wins + s.losses + s.ties);
        return '<div class="dos-league dos-league-lite">' +
          '<div class="dos-league-top"><span class="dos-league-name">' + dossierEsc(s.name) + '</span>' +
          '<span class="dos-league-style">' + dossierEsc(s.scoringTab || '') + '</span></div>' +
          '<div class="dos-ranks"><span class="dos-rank"><b>' + lrec + '</b>' +
          (s.standing ? ' ' + (typeof ordinal === 'function' ? ordinal(s.standing) : s.standing) : '') + '</span>' +
          (leff ? '<span class="dos-rank"><b>' + leff.pct.toFixed(0) + '%</b> started</span>' : '') +
          '<span class="dos-of">of ' + s.teams + '</span></div></div>';
      }
      return dossierLeagueRow(s);
    }).join('') + '</div>' + pager;
  function dossierLeagueRow(s) {
      const rec = s.wins + '-' + s.losses + (s.ties ? '-' + s.ties : '');
      const ranks =
        '<span class="dos-rank"><b>' + ord(s.valueRank) + '</b> value</span>' +
        '<span class="dos-rank"><b>' + ord(s.starterRank) + '</b> starters</span>' +
        '<span class="dos-rank"><b>' + rec + '</b>' + (s.standing ? ' ' + ord(s.standing) : '') + '</span>';
      const cell = (label, value) => '<div class="dos-cell"><span class="dos-cell-v">' + value + '</span><span class="dos-cell-l">' + label + '</span></div>';
      const top = (s.topPlayers || []).map((p) =>
        '<button type="button" class="dos-top" data-taco-player="' + dossierEsc(p.playerId) + '">' +
        '<span>' + dossierEsc(p.name) + ' <span class="dos-row-pos">' + dossierEsc(p.position) + '</span></span>' +
        '<span class="dos-row-val">' + fmtN(p.value) + '</span></button>').join('');
      return '<details class="dos-league">' +
        '<summary><div class="dos-league-top"><span class="dos-league-name">' + dossierEsc(s.name) + '</span>' +
        '<span class="dos-league-style">' + dossierEsc(s.archetype || '') + '</span></div>' +
        '<div class="dos-ranks">' + ranks + '<span class="dos-of">of ' + s.teams + '</span></div></summary>' +
        '<div class="dos-league-body">' +
        '<div class="dos-cells">' +
        cell('Team value · ' + ord(s.valueRank), fmtN(s.teamValue)) +
        cell('Starters · ' + ord(s.starterRank), fmtN(s.starterValue)) +
        cell('Draft picks', fmtN(s.picksValue)) +
        cell('Avg age', s.avgAge != null ? s.avgAge : '—') +
        '</div>' +
        (top ? '<div class="dos-top-head">Top players</div>' + top : '') +
        '<div class="dos-league-sub">' + dossierEsc(s.teamName || '') + ' · ' + dossierEsc(s.scoringTab || '') + '</div>' +
        '</div></details>';
  }

  // Say exactly which depth each number came from. "Scanned 530, valued 40"
  // is honest; a bare "40 leagues" on a 530-league account is not.
  const liteCount = (st.lite || []).length;
  const cap = liteCount > d.leagues
    ? '<p class="inv-note">Read all ' + liteCount.toLocaleString() + ' of their leagues for records, points and lineup efficiency. ' +
      'Valued the top ' + d.leagues + ' in full - team value, trades and exposure need prices and transactions, which is a dozen more requests each.' +
      (st.historyCapped ? ' All-time history walked for the first ' + DOSSIER_HISTORY_MAX + '.' : '') + '</p>'
    : '';
  const missed = st.unreadable
    ? '<p class="inv-note">' + st.unreadable.toLocaleString() + ' league' + (st.unreadable === 1 ? '' : 's') +
      ' could not be read (Sleeper rate-limited the sweep). The numbers above leave them out - reload to try again.</p>'
    : '';

  // Tabs, for the same reason the Commish Desk got them an hour earlier
  // (Owen: "its just a big wall of text"). A manager in 40 leagues ran this
  // page to roughly 10,000px, and the deep read at the top -- the part
  // somebody actually opened it for -- was buried above eight other sections.
  //
  // Overview leads because it answers "who is this" on its own. The rest is
  // there when you want to go further, which is what a dossier is for.
  const TABS = [
    ['overview', 'Overview'],
    ['trading', 'Trading'],
    ['roster', 'Roster'],
    ['leagues', 'Leagues'],
  ];
  const active = TABS.some(([k]) => k === STATE.dossierTab) ? STATE.dossierTab : 'overview';
  const tabBar = '<div class="sub-tab-bar">' + TABS.map(([key, label]) =>
    '<button type="button" class="sub-tab' + (key === active ? ' active' : '') + '" data-dos-tab="' +
    key + '"' + (key === active ? ' aria-current="true"' : '') + '>' + label + '</button>').join('') + '</div>';

  // One card per section, the same surface every other screen uses. These
  // were bare stacks on the page background, which is what made the War Room
  // read as a data dump next to the rest of the site.
  const card = (inner) => (inner ? '<section class="wr-card">' + inner + '</section>' : '');
  let body;
  if (active === 'trading') body = card(trading) + card(partners);
  else if (active === 'roster') body = card(positions) + card(exp);
  else if (active === 'leagues') body = card(book + cap + missed);
  else body = card(summary) + card(bookSummary) + card(tips);

  return '<div class="dos">' + tabBar + body +
    '<p class="inv-note">Values are TACO\'s, in each league\'s own format. Trades are this season\'s, graded at today\'s values.</p></div>';
}
window.dossierHtml = dossierHtml;

document.addEventListener('click', function (e) {
  const pageBtn = e.target && e.target.closest && e.target.closest('[data-dos-page]');
  if (pageBtn && !pageBtn.disabled) {
    STATE.dossierPage = Number(pageBtn.dataset.dosPage) || 1;
    if (typeof warRoomOnScreen === 'function' && warRoomOnScreen()) renderWarRoom();
    else if (typeof renderDossierView === 'function') renderDossierView();
    return;
  }
  const seasonBtn = e.target && e.target.closest && e.target.closest('[data-dos-season]');
  if (seasonBtn && seasonBtn.dataset.dosSeason) {
    STATE.careerSeason = seasonBtn.dataset.dosSeason;
    if (typeof warRoomOnScreen === 'function' && warRoomOnScreen()) renderWarRoom();
    else if (typeof renderDossierView === 'function') renderDossierView();
    return;
  }
  const tab = e.target && e.target.closest && e.target.closest('[data-dos-tab]');
  if (tab && tab.dataset.dosTab) {
    STATE.dossierTab = tab.dataset.dosTab;
    STATE.dossierPage = 1;
    if (typeof warRoomOnScreen === 'function' && warRoomOnScreen()) renderWarRoom();
    else if (typeof renderDossierView === 'function') renderDossierView();
  }
});

/** The Manager Dossier page (War Room). The lookup view itself is 93's. */
function renderDossierView() {
  const el = document.getElementById('dossierContent');
  if (!el) return;
  const head = warRoomHead('Manager Dossier', 'Any Sleeper manager, every dynasty league they are in');
  const locked = warRoomLockedHtml();
  if (locked) { el.innerHTML = head + locked; return; }
  if (STATE.investigatorLookup && typeof investigatorLookupHtml === 'function') {
    el.innerHTML = head + investigatorLookupHtml();
    return;
  }
  // No subject yet: show the lookup AND the board of managers you already
  // play against, which is what the separate Manager Board page used to be.
  // One door into one feature.
  const board = (typeof investigatorBoardHtml === 'function') ? investigatorBoardHtml() : '';
  el.innerHTML = head +
    '<section class="wr-card">' +
    '<div class="inv-sec-head">Look anyone up <span class="dos-sub">including managers you do not share a league with</span></div>' +
    '<form class="dos-lookup" data-inv-lookup-form>' +
    '<input type="text" class="assets-search-input" id="dosLookupInput" placeholder="Sleeper username…" ' +
    'autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" aria-label="Sleeper username">' +
    '<button type="submit" class="inv-lookup-go">Look up</button>' +
    '</form>' +
    '<p class="inv-note">Their book in every league, how they trade and with whom, who they believe in, and how to approach them. Works on anyone, whether or not you share a league.</p>' +
    '</section>' + board;
}
window.renderDossierView = renderDossierView;

;
/*! ==== 95-league-report.js ==== */
// League scouting report (Investigator plan #2, Owen 2026-09-27): paste any
// Sleeper league, get every manager graded -- value and starter rank, record,
// style, activity this season, trade record, and red flags (orphan, asleep,
// lineup hole this week, big trade swings). Logic: shared/league-scout.mjs.
//
// Browser-side, like all enrichment. One league: its four payloads, this
// season's transaction weeks (twice: once raw for activity, once valued by
// 70's loader for the trade record), and this week's matchups for lineups.

let leagueReportRun = 0;

function lrEsc(t) {
  return escapeHtml(String(t == null ? '' : t));
}

/** Parse a pasted link / id and build the report into STATE.leagueReport. */
async function loadLeagueReport(input) {
  const run = ++leagueReportRun;
  const parsed = window.TacoRoutes && TacoRoutes.parseLeagueInput ? TacoRoutes.parseLeagueInput(input) : { kind: 'unknown' };
  const st = { input: String(input || ''), status: 'loading' };
  STATE.leagueReport = st;
  const repaint = () => { if (run === leagueReportRun && typeof warRoomOnScreen === 'function' && warRoomOnScreen()) renderWarRoom(); };
  if (parsed.kind !== 'league') {
    st.status = 'error';
    st.error = typeof SCOUT_MESSAGES !== 'undefined' && SCOUT_MESSAGES[parsed.kind] ? SCOUT_MESSAGES[parsed.kind] : 'Paste a Sleeper league link or ID.';
    repaint();
    return;
  }
  repaint();
  try {
    const league = await api('/league/' + parsed.leagueId);
    if (!league || !league.league_id) throw new Error('No Sleeper league matches that link.');
    st.league = { id: league.league_id, name: league.name, teams: league.total_rosters, season: league.season };
    if (typeof ensurePlayersDB === 'function') await ensurePlayersDB();
    const tab = TacoCore.detectScoringTab(league);
    if (typeof hydrateBackendComposites === 'function') await hydrateBackendComposites([tab]);
    // Enriched as nobody: no team becomes "me" (same trick as Scout a League).
    const lg = await enrichLeague(league, { userId: 'scout:no-owner' });
    st.scoringTab = lg.scoringTab;

    const nflWeek = TacoCore.resolveNflWeekContext().week;
    const week = Math.max(1, league.settings?.leg || 1, nflWeek);
    const lastWeek = Math.min(18, week + 1);
    const weeks = [];
    for (let w = 1; w <= lastWeek; w++) weeks.push(w);
    const [txnWeeks, trades, matchups] = await Promise.all([
      Promise.all(weeks.map((w) => api('/league/' + league.league_id + '/transactions/' + w).catch(() => []))),
      typeof loadLeagueTrades === 'function' ? loadLeagueTrades(lg, { cache: false }) : Promise.resolve([]),
      api('/league/' + league.league_id + '/matchups/' + (typeof slateCurrentWeek === 'function' ? slateCurrentWeek() : week)).catch(() => []),
    ]);
    const lineups = {};
    for (const m of Array.isArray(matchups) ? matchups : []) {
      if (m && Array.isArray(m.starters)) lineups[String(m.roster_id)] = m.starters;
    }

    const rosters = (lg.allRosters || []).map((r) => ({
      rosterId: r.rosterId,
      ownerId: r.ownerId || null,
      ownerName: r.ownerName,
      teamName: r.teamName,
      wins: r.wins, losses: r.losses, ties: r.ties, pointsFor: r.pointsFor,
      teamValue: TacoCore.teamValue(lg, r),
      starterValue: TacoCore.rosterPlayersValue((r.players || []).filter((p) => p.isStarter), { activeOnly: true }),
      archetype: typeof archetypeForRoster === 'function' ? archetypeForRoster(lg, r) : null,
    }));
    if (run !== leagueReportRun) return;
    st.report = TacoCore.scoutLeagueReport({
      rosters,
      transactions: [].concat(...txnWeeks.filter(Array.isArray)),
      trades,
      lineups: Object.keys(lineups).length ? lineups : null,
      rosterPositions: league.roster_positions || [],
      week,
    });
    st.status = 'done';
  } catch (err) {
    st.status = 'error';
    st.error = (err && err.message) || 'Could not load that league.';
  }
  repaint();
}
window.loadLeagueReport = loadLeagueReport;

const LR_FLAG_CLASS = { orphan: 'lr-flag-orphan', inactive: 'lr-flag-warn', lineup: 'lr-flag-warn', shark: 'lr-flag-shark', target: 'lr-flag-target' };

function leagueReportHtml() {
  const st = STATE.leagueReport;
  if (!st) return '';
  const back = '<button type="button" class="ma-back" data-lr-close>← Scout another league</button>';
  if (st.status === 'loading') return back + '<div class="dos-loading">Scouting ' + lrEsc(st.league ? st.league.name : 'the league') + '…</div>';
  if (st.status === 'error') return back + '<div class="tab-empty">' + lrEsc(st.error) + '</div>';
  const { rows, summary } = st.report;
  const ord = (n) => (typeof ordinal === 'function' ? ordinal(n) : String(n));
  const days = (ms) => {
    if (!ms) return 'no moves yet';
    const d = Math.floor((Date.now() - ms) / 864e5);
    return d <= 0 ? 'moved today' : d === 1 ? 'last move yesterday' : 'last move ' + d + ' days ago';
  };
  const stat = (n, l) => '<div class="mb-stat"><span class="mb-stat-n">' + lrEsc(n) + '</span><span class="mb-stat-l">' + lrEsc(l) + '</span></div>';

  const head =
    '<div class="mb-scout-head"><div class="mb-scout-name">' + lrEsc(st.league.name) + '</div>' +
    '<div class="mb-scout-sub">' + lrEsc(summary.teams + ' teams · ' + (st.scoringTab || '') + ' · ' + st.league.season) + '</div></div>' +
    '<div class="mb-stats dos-stats">' +
    stat(summary.moves, 'moves this season') +
    stat(summary.trades, 'trades') +
    stat(summary.inactive, 'look inactive') +
    stat(summary.orphans, summary.orphans === 1 ? 'open team' : 'open teams') +
    '</div>' +
    (summary.mostActive ? '<p class="inv-note">Most active: ' + lrEsc(summary.mostActive.ownerName) + ' (' + summary.mostActive.moves + ' moves).</p>' : '');

  const list = rows.map((r) => {
    const rec = r.wins + '-' + r.losses + (r.ties ? '-' + r.ties : '');
    const tr = r.tradeRecord
      ? r.tradeRecord.won + '-' + r.tradeRecord.lost + '-' + r.tradeRecord.fair + ' (' + (r.tradeRecord.net > 0 ? '+' : '') + r.tradeRecord.net.toLocaleString() + ')'
      : 'none graded';
    const name = r.ownerId
      ? '<button type="button" class="dos-partner-name" data-inv-lookup="' + lrEsc(r.ownerId) + '">' + lrEsc(r.ownerName) + ' ›</button>'
      : '<span class="dos-partner-name">' + lrEsc(r.teamName || 'Open team') + '</span>';
    return '<div class="dos-partner' + (r.flags.length ? ' dos-partner-flag' : '') + '">' +
      '<div class="dos-league-top">' + name + '<span class="dos-league-style">' + lrEsc(r.archetype || '') + '</span></div>' +
      '<div class="dos-ranks">' +
      '<span class="dos-rank"><b>' + ord(r.valueRank) + '</b> value</span>' +
      '<span class="dos-rank"><b>' + ord(r.starterRank) + '</b> starters</span>' +
      '<span class="dos-rank"><b>' + rec + '</b>' + (r.standing ? ' ' + ord(r.standing) : '') + '</span></div>' +
      '<div class="dos-league-sub">' + r.moves + (r.moves === 1 ? ' move (' : ' moves (') + r.trades + ' trades, ' + r.adds + ' adds) · ' + days(r.lastMoveAt) + ' · trades ' + tr + '</div>' +
      (r.flags.length ? '<div class="lr-flags">' + r.flags.map((f) => '<span class="lr-flag ' + (LR_FLAG_CLASS[f.kind] || '') + '">' + lrEsc(f.text) + '</span>').join('') + '</div>' : '') +
      '</div>';
  }).join('');

  return back + '<div class="mb-scout">' + head +
    '<div class="inv-sec-head">Every manager <span class="dos-sub">by team value · tap a name for their dossier</span></div>' +
    '<div class="mb-list">' + list + '</div>' +
    '<p class="inv-note">Moves and trades are this season\'s. "Inactive" means no transaction in ' + TacoCore.INACTIVE_DAYS + '+ days once the season is under way: a set lineup can look the same.</p>' +
    '</div>';
}
window.leagueReportHtml = leagueReportHtml;

document.addEventListener('click', function (e) {
  if (!e.target.closest) return;
  if (e.target.closest('[data-lr-close]')) {
    STATE.leagueReport = null;
    if (typeof renderWarRoom === 'function') renderWarRoom();
  }
});

document.addEventListener('submit', function (e) {
  const form = e.target && e.target.closest && e.target.closest('[data-lr-form]');
  if (!form) return;
  e.preventDefault();
  const input = form.querySelector('input');
  if (input && input.value.trim()) loadLeagueReport(input.value.trim());
});

/** The League Scout page (War Room). */
function renderLeagueScoutView() {
  const el = document.getElementById('leagueScoutContent');
  if (!el) return;
  const head = warRoomHead('League Scout', 'Every manager in any league, graded');
  const locked = warRoomLockedHtml();
  if (locked) { el.innerHTML = head + locked; return; }
  if (STATE.leagueReport) { el.innerHTML = head + leagueReportHtml(); return; }
  el.innerHTML = head +
    '<section class="wr-card">' +
    '<div class="inv-sec-head">Scout a league <span class="dos-sub">paste a Sleeper league link or id</span></div>' +
    '<form class="dos-lookup" data-lr-form>' +
    '<input type="text" class="assets-search-input" placeholder="Paste a Sleeper league link…" ' +
    'inputmode="url" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" aria-label="Sleeper league link or ID">' +
    '<button type="submit" class="inv-lookup-go">Scout</button>' +
    '</form>' +
    '<p class="inv-note">Before you join a league, take an orphan or open trade talks: who is active, who is asleep, who wins and loses trades, and whose lineup has a hole this week.</p>' +
    '</section>';
}
window.renderLeagueScoutView = renderLeagueScoutView;

;
/*! ==== 96-lineup-sweep.js ==== */
// Lineup Sweep (roadmap #14): every league's real Sleeper lineup against the
// best one by this week's projections, on one page, with a link out to fix it
// in Sleeper (the API is read-only, so the fix itself happens there).
//
// Logic: shared/lineup-sweep.mjs. Points: currentWeekContext (20), the same
// league-scored projections the start/sit panel uses.

let lineupSweepLoading = false;
// Asked once per leagues load. The view re-renders when the data lands, and a
// re-render that asks again whenever data is still missing (a loader that
// resolves without data, say) spins in microtasks and freezes the tab.
let lineupSweepAskedFor = null;

/** This week's lineups by league (55's loader), once they are in. */
function lineupSweepLineups() {
  const wl = STATE.weekLineups;
  return wl && wl.leaguesRef === STATE.leagues ? wl.byLeague : null;
}

function lineupSweepEnsureData() {
  if (lineupSweepLoading || lineupSweepAskedFor === STATE.leagues) return;
  const needProj = !STATE.weeklyProjections && typeof loadWeeklyProjections === 'function';
  const needLineups = !lineupSweepLineups() && typeof ensureWeekLineups === 'function';
  if (!needProj && !needLineups) return;
  lineupSweepLoading = true;
  lineupSweepAskedFor = STATE.leagues;
  Promise.all([
    needProj ? loadWeeklyProjections() : null,
    needLineups ? ensureWeekLineups() : null,
  ]).finally(() => {
    lineupSweepLoading = false;
    const active = document.querySelector('.view.active');
    if (active && active.id === 'lineupsView') renderLineupSweepView();
  });
}

/** Called by the projections (20) and lineups (55) loaders when data lands,
 * whoever started the fetch, so the page never waits on its own request. */
function lineupSweepDataLanded() {
  const active = document.querySelector('.view.active');
  if (active && active.id === 'lineupsView') renderLineupSweepView();
}
window.lineupSweepDataLanded = lineupSweepDataLanded;

/** One league's sweep, or null when it cannot be scored. */
function lineupSweepForLeague(lg, now, lineups) {
  const roster = (lg.allRosters || []).find((r) => r.isMe);
  // THIS week's lineup from the matchups row, never roster.starters: those
  // follow whichever week was edited last, and showed Owen an "empty WR" in a
  // week-3 lineup that was full (the same trap the Action Queue fell into).
  const starters = lineups && lineups[String(lg.league_id)];
  if (!roster || !Array.isArray(starters)) return null;
  const ctx = typeof currentWeekContext === 'function' ? currentWeekContext(lg) : null;
  if (!ctx) return null;
  const schedule = ctx.schedule || {};
  const locked = new Set();
  let maybe = false;
  const players = (roster.players || []).map((p) => {
    const g = schedule[String(p.team || '').toUpperCase()];
    const st = TacoCore.gameStarted(g && g.kickoffAt, now);
    if (st.started) locked.add(String(p.playerId));
    return { playerId: String(p.playerId), position: p.position, isActive: p.isActive, name: p.name, team: p.team, maybe: st.maybe };
  });
  // Sleeper keeps projecting a player after he is ruled out (Achane, Out,
  // still 17.2 on 2026-09-27), so the sweep would keep an Out starter in the
  // "best" lineup and never say bench him. Out / Doubtful / IR / suspended
  // score zero here -- the Action Queue's own injury rules, so the two agree.
  const points = { ...ctx.projections };
  if (TacoCore.injuryStatusOf && TacoCore.injurySeverityKey) {
    for (const p of roster.players || []) {
      const sev = TacoCore.injurySeverityKey(TacoCore.injuryStatusOf(p, STATE.playersDB && STATE.playersDB[p.playerId]));
      if (sev === 'out' || sev === 'doubt') points[String(p.playerId)] = 0;
    }
  }
  const out = TacoCore.lineupSweep({
    rosterPositions: lg.roster_positions || [],
    starters: starters.map(String),
    players,
    points,
    locked,
  });
  // Warn only when a suggested move touches a game that may be under way.
  const maybeIds = new Set(players.filter((p) => p.maybe).map((p) => p.playerId));
  for (const m of out.moves) {
    if (maybeIds.has(m.start.playerId) || (m.sit && maybeIds.has(m.sit.playerId))) maybe = true;
  }
  return { lg, ...out, maybe };
}

function renderLineupSweepView() {
  const el = document.getElementById('lineupsContent');
  if (!el) return;
  const head = '<div class="ma-head"><div><h2 class="ma-title">Lineup Sweep</h2>' +
    '<div class="ma-sub">Your Sleeper lineups against the best by this week\'s projections</div></div></div>';
  if (!(STATE.leagues || []).length) { el.innerHTML = head + '<div class="tab-empty">Connect your Sleeper leagues first.</div>'; return; }
  if (!window.TacoCore || !TacoCore.lineupSweep) { el.innerHTML = head + '<div class="tab-empty">Still loading.</div>'; return; }
  lineupSweepEnsureData();
  const lineups = lineupSweepLineups();
  if (!STATE.weeklyProjections || !lineups) {
    const gaveUp = !lineupSweepLoading && lineupSweepAskedFor === STATE.leagues;
    el.innerHTML = head + '<div class="tab-empty">' + (gaveUp
      ? 'This week\'s lineups or projections did not load. Refresh the page to try again.'
      : 'Loading this week\'s lineups and projections…') + '</div>';
    return;
  }

  const now = new Date();
  const results = STATE.leagues.map((lg) => lineupSweepForLeague(lg, now, lineups)).filter(Boolean);
  const fixes = results.filter((r) => r.moves.length).sort((a, b) => b.gain - a.gain);
  const total = Math.round(fixes.reduce((s, r) => s + r.gain, 0) * 10) / 10;
  const week = STATE.weeklyProjections.week;

  const set = results.filter((r) => !r.moves.length);
  const slot = (t) => (typeof slotTypeLabel === 'function' ? slotTypeLabel(t) : t);
  const avatar = (pl) => (typeof playerAvatarHtml === 'function' ? playerAvatarHtml(pl.playerId, pl.name, pl.position) : '');
  // The same two helpers the sweep itself uses, so the reason shown on the
  // card matches the reason the player was benched, in the same words every
  // other page uses ("IR", not "Injured Reserve").
  const statusOf = (pl) => {
    const raw = TacoCore.injuryStatusOf(pl, STATE.playersDB && STATE.playersDB[pl.playerId]);
    return raw ? TacoCore.injuryLabel(raw) : '';
  };

  // Summary first: how many leagues, how many points, how many are already right.
  const summary = '<div class="ls2-summary">' +
    '<div class="ls2-stat"><span>Leagues to fix</span><b>' + fixes.length + '<small> of ' + results.length + '</small></b></div>' +
    '<div class="ls2-stat"><span>Points on the table</span><b class="ls2-up">+' + total.toFixed(1) + '</b></div>' +
    '<div class="ls2-stat"><span>Already set</span><b>' + set.length + '</b></div>' +
    '<div class="ls2-stat"><span>Week</span><b>' + week + '</b></div>' +
    '</div>';

  // The same wrongly started player across many leagues is the one fix worth
  // saying out loud (Justin Jefferson, Out, started in six on 2026-09-29).
  const sitCount = {};
  for (const r of fixes) {
    for (const m of r.moves) {
      if (!m.sit) continue;
      const k = m.sit.playerId;
      sitCount[k] = sitCount[k] || { pl: m.sit, n: 0, gain: 0 };
      sitCount[k].n += 1;
      sitCount[k].gain += m.gain || 0;
    }
  }
  // Rank by the points the swap returns, not by how many leagues it appears
  // in: three leagues at +0.6 is not a bigger fix than two at +9.0, and the
  // copy below calls this the biggest one (2026-10-16).
  const repeat = Object.values(sitCount).sort((x, y) => y.gain - x.gain || y.n - x.n)[0];
  const repeatHtml = repeat && repeat.n >= 2
    ? '<div class="ls2-callout">' + avatar(repeat.pl) + '<div><b>' + escapeHtml(repeat.pl.name || repeat.pl.playerId) + '</b> is in ' + repeat.n +
      ' of your lineups' + (statusOf(repeat.pl) ? ' and is <span class="ls2-bad">' + escapeHtml(statusOf(repeat.pl)) + '</span>' : '') +
      '. Benching him is worth <b class="ls2-up">+' + repeat.gain.toFixed(1) + '</b> across them - the biggest single fix this week.</div></div>'
    : '';

  const side = (pl, kind) => {
    const st = kind === 'out' ? statusOf(pl) : '';
    return '<div class="ls2-p ls2-' + kind + '">' + avatar(pl) +
      '<div class="ls2-pn"><span class="ls2-verb">' + (kind === 'in' ? 'Start' : 'Bench') + '</span><b>' + escapeHtml(pl.name || pl.playerId) + '</b>' +
      (st ? '<span class="ls2-st">' + escapeHtml(st) + '</span>' : '') + '</div>' +
      '<span class="ls2-pts">' + pl.points.toFixed(1) + '</span></div>';
  };
  const cards = fixes.map((r) => {
    const fix = TacoCore.sleeperLineupUrl ? TacoCore.sleeperLineupUrl(r.lg.league_id) : null;
    return '<article class="ls2-card">' +
      '<header class="ls2-head"><div><h3>' + escapeHtml(r.lg.name) + '</h3><p>' + r.current.toFixed(1) + ' → ' + r.best.toFixed(1) + ' projected</p></div>' +
      '<span class="ls2-gain">+' + r.gain.toFixed(1) + '</span></header>' +
      r.moves.map((m) =>
        '<div class="ls2-move"><span class="ls2-slot">' + escapeHtml(slot(m.slotType)) + '</span>' +
        side(m.start, 'in') + '<span class="ls2-arrow" aria-hidden="true">⇄</span>' +
        (m.sit ? side(m.sit, 'out') : '<div class="ls2-p ls2-out ls2-empty"><div class="ls2-pn"><span class="ls2-verb">Fills</span><b>Empty slot</b></div></div>') +
        (m.shuffle ? '<span class="ls2-shuffle">Slide a flex over to make room</span>' : '') +
        '</div>').join('') +
      (fix ? '<footer class="ls2-foot"><a class="ls2-fix" href="' + escapeHtml(fix) + '" target="_blank" rel="noopener noreferrer">Fix in Sleeper ↗</a></footer>' : '') +
      '</article>';
  }).join('');

  const setHtml = set.length
    ? '<section class="ls2-set"><h3>Already set</h3><div class="ls2-chips">' +
      set.map((r) => '<span class="ls2-chip">' + escapeHtml(r.lg.name) + '</span>').join('') + '</div></section>'
    : '';

  const anyMaybe = fixes.some((r) => r.maybe);
  el.innerHTML = head + summary + repeatHtml +
    (anyMaybe ? '<p class="ls-warn">Some of these games are today and may already be locked in Sleeper.</p>' : '') +
    (fixes.length
      ? '<div class="ls2-grid">' + cards + '</div>'
      : '<p class="inv-lede">All ' + results.length + ' lineups are already the best by week ' + week + ' projections.</p>') +
    setHtml +
    '<p class="inv-note">Projections are Sleeper\'s, scored by each league\'s own rules. Players whose game has already been played stay where they are.</p>';
}
window.renderLineupSweepView = renderLineupSweepView;

;
/*! ==== 97-commish-desk.js ==== */
// Commish Desk (roadmap #15, tier 2 `commissioner`): the leagues you run.
// Whose lineup is broken this week (every team, not just yours), orphaned
// teams, next year's draft order as copy-paste text, and the settings that
// differ across your leagues. Logic: shared/commish.mjs.
//
// This week's lineups for EVERY team come from one Sleeper matchups call per
// league you run (the rows carry every roster's starters); fetched on first
// open and kept for the week.

let commishLoading = false;

function commishLeagues() {
  return (STATE.leagues || []).filter((lg) => TacoCore.runsLeague(lg, STATE.userId));
}

function commishEnsureLineups(leagues) {
  const week = typeof slateCurrentWeek === 'function' ? slateCurrentWeek() : null;
  if (!week || commishLoading) return;
  const cache = STATE.commishLineups;
  if (cache && cache.week === week && cache.leaguesRef === STATE.leagues) return;
  commishLoading = true;
  const byLeague = {};
  let next = 0;
  const worker = async () => {
    while (next < leagues.length) {
      const lg = leagues[next++];
      try {
        const rows = await api(`/league/${lg.league_id}/matchups/${week}`);
        const map = {};
        for (const m of Array.isArray(rows) ? rows : []) if (Array.isArray(m.starters)) map[String(m.roster_id)] = m.starters.map(String);
        byLeague[String(lg.league_id)] = map;
      } catch (_e) { /* that league shows no compliance rather than a guess */ }
    }
  };
  Promise.all(Array.from({ length: 6 }, worker)).finally(() => {
    commishLoading = false;
    STATE.commishLineups = { week, leaguesRef: STATE.leagues, byLeague };
    if (typeof warRoomOnScreen === 'function' && warRoomOnScreen()) renderWarRoom();
  });
}

function commishLockedHtml() {
  if (typeof window.accountCanUse === 'function' && window.accountCanUse('commissioner')) return '';
  if (typeof window.billingIsPublic === 'function' && !window.billingIsPublic()) {
    return '<div class="tab-empty">The Commish Desk is in early access and not open yet.</div>';
  }
  return '<div class="tab-empty">The Commish Desk is part of Hall of Fame, with Ask TACO and the trade database.' +
    '<div class="profile-actions investigator-upsell"><button class="profile-action-btn" data-taco-open-settings>See plans</button></div></div>';
}

function renderCommishView() {
  const el = document.getElementById('commishContent');
  if (!el) return;
  const head = typeof warRoomHead === 'function'
    ? warRoomHead('Commish Desk', 'The leagues you run')
    : '<h2 class="ma-title">Commish Desk</h2>';
  const locked = commishLockedHtml();
  if (locked) { el.innerHTML = head + locked; return; }
  if (!window.TacoCore || !TacoCore.runsLeague) { el.innerHTML = head + '<div class="tab-empty">Still loading.</div>'; return; }
  const leagues = commishLeagues();
  if (!leagues.length) {
    el.innerHTML = head + '<div class="tab-empty">You are not the commissioner of any of your Sleeper leagues.</div>';
    return;
  }
  // Which tab, before anything is fetched or computed. Each tab below does
  // only its own work -- a Desk that loaded all five sections to show one
  // would be the same page it was before the tabs, just with more clicks.
  const TABS = [
    ['lineups', 'Lineups'],
    ['managers', 'Managers'],
    ['draft', 'Draft order'],
    ['settings', 'Settings'],
  ];
  const activeTab = TABS.some(([k]) => k === STATE.commishTab) ? STATE.commishTab : 'lineups';

  if (activeTab === 'lineups') {
    commishEnsureLineups(leagues);
    if (!STATE.weeklyScheduleMap && typeof ensureInjurySchedule === 'function') ensureInjurySchedule();
  }

  const cache = STATE.commishLineups;
  const lineups = cache && cache.leaguesRef === STATE.leagues ? cache.byLeague : null;
  const schedule = STATE.weeklyScheduleMap || null;

  // 1. Lineups this week, every team in every league you run. (Lineups tab.)
  let compliance;
  if (!lineups) {
    compliance = '<div class="tab-empty">Reading this week\'s lineups…</div>';
  } else {
    const rows = leagues.map((lg) => ({ lg, teams: TacoCore.lineupCompliance(lg, lineups[String(lg.league_id)], STATE.playersDB, schedule) }))
      .filter((x) => x.teams.length);
    const broken = rows.reduce((n, x) => n + x.teams.length, 0);
    compliance = rows.length
      ? '<p class="inv-lede">' + broken + ' team' + (broken === 1 ? '' : 's') + ' across ' +
        rows.length + ' of your ' + leagues.length + ' leagues need a lineup fix this week.</p>' +
        rows.map((x) => '<div class="cd-league"><div class="cd-league-name">' + escapeHtml(x.lg.name) +
          '<span class="cd-league-n">' + x.teams.length + '</span></div>' +
          x.teams.map((t) => {
            const bits = [];
            if (t.empty) bits.push(t.empty + ' empty slot' + (t.empty === 1 ? '' : 's'));
            for (const p of t.out) bits.push(escapeHtml(p.name) + ' (' + escapeHtml(p.status) + ')');
            for (const p of t.bye) bits.push(escapeHtml(p.name) + ' (bye)');
            return '<div class="cd-team"><span class="cd-team-name">' + escapeHtml(t.teamName) +
              (t.orphan ? ' <span class="cd-orphan">orphan</span>' : '') + '</span>' +
              '<span class="cd-issues">' + bits.join(' · ') + '</span></div>';
          }).join('') + '</div>').join('')
      : '<div class="cd-ok">Every team in every league you run has a full, healthy lineup this week.</div>';
  }

  // 2. Orphans.
  const orphans = leagues.map((lg) => ({ lg, teams: TacoCore.orphanTeams(lg) })).filter((x) => x.teams.length);
  const orphanHtml = orphans.length
    ? orphans.map((x) => '<div class="cd-team"><span class="cd-team-name">' + escapeHtml(x.lg.name) + '</span><span class="cd-issues">' +
        x.teams.map((t) => escapeHtml(t.teamName)).join(', ') + '</span></div>').join('')
    : '<div class="cd-ok">No orphaned teams.</div>';

  // 2b. Manager turnover -- who has walked away from a team, and who has
  // stepped up to take one on.
  //
  // Scoped two ways on purpose. The per-league list covers the leagues you
  // RUN, because that is what a commissioner acts on. The roll-up underneath
  // counts each person across every league of yours with more than one
  // season, because somebody who quit on two of your leagues is the thing
  // worth knowing before you hand them a third, and one league alone would
  // never show it.
  //
  // It is a handover, not a verdict. A team changes hands because somebody
  // quit, or was removed, or the league restructured, or life happened --
  // the data shows the change, never the reason, and the copy says so.
  const turnover = STATE.ownerTurnover;
  if (activeTab === 'managers' && !turnover && typeof loadOwnerTurnover === 'function') {
    loadOwnerTurnover().then((t) => { if (t) renderCommishView(); });
  }
  let turnoverHtml;
  if (!turnover) {
    turnoverHtml = '<div class="cd-ok">Reading past seasons…</div>';
  } else if (!turnover.leaguesWithHistory) {
    turnoverHtml = '<div class="cd-ok">None of your leagues has run more than one season yet, so there is no history to compare.</div>';
  } else {
    const nameFor = (o) => escapeHtml(o.name || 'Unknown manager');
    const runIds = new Set(leagues.map((l) => l.league_id));
    const mine = (turnover.byLeague || []).filter((r) => runIds.has(r.leagueId) && r.departures.length);
    const NAME_CAP = 6;
    const perLeague = mine.length
      ? mine.map((r) => {
          const shown = r.departures.slice(0, NAME_CAP);
          const rest = r.departures.length - shown.length;
          const who = shown.map((d) => {
            const label = escapeHtml(turnover.names?.[d.ownerId] || r.names?.[d.ownerId] || 'Unknown');
            return label + ' <span class="cd-turn-season">' + escapeHtml(d.season) + '</span>' +
              (d.replacedBy ? '' : ' <span class="cd-orphan">went unclaimed</span>');
          }).join(' · ') + (rest > 0 ? ' <span class="cd-turn-season">+' + rest + ' more</span>' : '');
          return '<div class="cd-team"><span class="cd-team-name">' + escapeHtml(r.leagueName) +
            ' <span class="cd-turn-count">' + r.departures.length + ' left</span></span>' +
            '<span class="cd-issues">' + who + '</span></div>';
        }).join('')
      : '<div class="cd-ok">Nobody has left a team in the leagues you run.</div>';

    const repeat = turnover.serialLeavers.slice(0, 8);
    const repeatHtml = repeat.length
      ? '<div class="cd-turn-group"><div class="cd-turn-head">Left more than one team</div>' +
        repeat.map((o) => '<div class="cd-team"><span class="cd-team-name">' + nameFor(o) +
          '</span><span class="cd-issues"><b class="cd-turn-bad">' + o.left + ' teams</b> · ' +
          o.leftIn.map((x) => escapeHtml(x.season + ' ' + x.league)).join(' · ') +
          (o.tookOver ? ' · <span class="cd-turn-good">also took over ' + o.tookOver + '</span>' : '') +
          '</span></div>').join('') + '</div>'
      : '<div class="cd-turn-group"><div class="cd-turn-head">Left more than one team</div><div class="cd-ok">Nobody in your leagues has left more than one.</div></div>';

    const rescuers = turnover.rescuers.slice(0, 6);
    const rescueHtml = rescuers.length
      ? '<div class="cd-turn-group"><div class="cd-turn-head">Took over an orphan</div>' +
        rescuers.map((o) => '<div class="cd-team"><span class="cd-team-name">' + nameFor(o) +
          '</span><span class="cd-issues"><b class="cd-turn-good">' + o.tookOver + '</b> · ' +
          o.tookOverIn.map((x) => escapeHtml(x.season + ' ' + x.league)).join(' · ') +
          (o.left ? ' · <span class="cd-turn-bad">left ' + o.left + '</span>' : '') +
          '</span></div>').join('') +
        '<p class="inv-note">The people who stepped in last time. Worth asking first when a team needs a new manager.</p></div>'
      : '';

    turnoverHtml = perLeague + repeatHtml + rescueHtml +
      '<p class="inv-note">' + escapeHtml(TacoCore.turnoverScopeNote(turnover.leaguesWithHistory)) +
      ' A team changing hands is a handover, not a verdict - somebody may have quit, been removed, or simply had a year.</p>';
  }

  // 3. Draft order, one league at a time.
  const pickId = STATE.commishLeague && leagues.some((l) => l.league_id === STATE.commishLeague) ? STATE.commishLeague : leagues[0].league_id;
  const pickLg = leagues.find((l) => l.league_id === pickId);
  const order = TacoCore.nextDraftOrder(pickLg);
  const options = leagues.map((l) => '<option value="' + escapeHtml(l.league_id) + '"' + (l.league_id === pickId ? ' selected' : '') + '>' + escapeHtml(l.name) + '</option>').join('');
  const orderHtml =
    '<div class="ma-filters-row"><select class="ry-select" data-cd-league aria-label="League">' + options + '</select>' +
    '<button type="button" class="profile-action-btn cd-copy" data-cd-copy>Copy</button></div>' +
    '<ol class="cd-order">' + order.map((o) => '<li>' + escapeHtml(o.teamName) + (o.playoff ? ' <span class="cd-po">playoffs</span>' : '') + '</li>').join('') + '</ol>' +
    '<p class="inv-note">Projected from today: playoff teams by projected finish (the champion picks last), everyone else by lowest Max PF first. Final once the title game is played.</p>';

  // 4. Settings that differ.
  const diff = leagues.length > 1 ? TacoCore.settingsDiff(leagues) : [];
  const diffHtml = leagues.length < 2
    ? '<div class="cd-ok">You run one league, so there is nothing to compare.</div>'
    : diff.length
      ? diff.map((d) => '<div class="cd-setting"><div class="cd-setting-label">' + escapeHtml(d.label) + '</div>' +
          d.values.map((v) => '<div class="cd-setting-row"><b>' + escapeHtml(v.value) + '</b> <span class="cd-setting-lg">' +
            (v.leagues.length > 3 ? v.leagues.length + ' leagues' : v.leagues.map(escapeHtml).join(', ')) + '</span></div>').join('') + '</div>').join('')
      : '<div class="cd-ok">These settings match across all ' + leagues.length + ' of your leagues.</div>';

  const sec = (title, body) => '<section class="cd-sec"><div class="inv-sec-head">' + title + '</div>' + body + '</section>';

  // Tabs, not one long scroll (Owen, 2026-11-03: "its just a big wall of
  // text. need to break into tabs or something"). Five stacked sections had
  // grown past a screen on their own, and the manager-turnover work pushed it
  // well past two.
  //
  // Orphans and turnover share a tab because they are the same subject -- who
  // is actually running these teams -- and "No orphaned teams." is one line
  // that does not deserve a tab of its own.
  //
  // Reuses .sub-tab-bar / .sub-tab, the same pills the league page uses, so a
  // second tab language does not appear inside one app. They are real
  // <button>s, so Enter and Space already work without the keyboard promotion
  // in module 69.
  const tabBar = '<div class="sub-tab-bar">' + TABS.map(([key, label]) =>
    '<button type="button" class="sub-tab' + (key === activeTab ? ' active' : '') + '" data-cd-tab="' +
    key + '"' + (key === activeTab ? ' aria-current="true"' : '') + '>' + label + '</button>').join('') + '</div>';

  let body;
  if (activeTab === 'managers') {
    body = sec('Orphaned teams', orphanHtml) + sec('Manager turnover', turnoverHtml);
  } else if (activeTab === 'draft') {
    body = sec('Next rookie draft order', orderHtml);
  } else if (activeTab === 'settings') {
    body = sec('Settings that differ', diffHtml);
  } else {
    body = sec('Lineups this week', compliance);
  }

  el.innerHTML = head +
    '<p class="inv-lede">You run ' + leagues.length + ' league' + (leagues.length === 1 ? '' : 's') + '.</p>' +
    tabBar + body;
}
window.renderCommishView = renderCommishView;

document.addEventListener('click', function (e) {
  const tab = e.target && e.target.closest && e.target.closest('[data-cd-tab]');
  if (tab && tab.dataset.cdTab) {
    STATE.commishTab = tab.dataset.cdTab;
    renderCommishView();
  }
});

document.addEventListener('change', function (e) {
  if (e.target && e.target.closest && e.target.closest('[data-cd-league]')) {
    STATE.commishLeague = e.target.value;
    renderCommishView();
  }
});

document.addEventListener('click', function (e) {
  if (!e.target.closest || !e.target.closest('[data-cd-copy]')) return;
  const leagues = commishLeagues();
  const lg = leagues.find((l) => l.league_id === STATE.commishLeague) || leagues[0];
  if (!lg) return;
  const text = TacoCore.draftOrderText(lg, TacoCore.nextDraftOrder(lg));
  const btn = e.target.closest('[data-cd-copy]');
  const done = () => { btn.textContent = 'Copied'; setTimeout(() => { btn.textContent = 'Copy'; }, 1500); };
  if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, () => {});
});

;
/*! ==== 98-rookie-odds.js ==== */
// Rookie Odds (roadmap #16): how often a rookie at each position and draft
// round became a top-12 / 24 / 36 fantasy player within three seasons, and
// which season it happened. Data: shared/rookie-odds*.mjs (nflverse). Free:
// it is static, so it costs nothing to serve.

function renderRookieOdds() {
  const el = document.getElementById('rookieOddsMount');
  if (!el || !window.TacoCore || !TacoCore.rookieOddsRows) return;
  const pos = STATE.rookieOddsPos || 'RB';
  const rows = TacoCore.rookieOddsRows(pos);
  const span = TacoCore.ROOKIE_ODDS_SPAN;
  const pills = ['QB', 'RB', 'WR', 'TE'].map((p) =>
    '<button type="button" class="th-pill' + (p === pos ? ' active' : '') + '" data-rookie-odds-pos="' + p + '">' + p + '</button>').join('');
  const cell = (v) => '<td class="ro-num"><span class="ro-bar" style="--w:' + v + '%"></span><span class="ro-v">' + v + '%</span></td>';
  const body = rows.map((r) =>
    '<tr><th scope="row">' + r.label + '<span class="ro-n">' + r.n + ' players' + (r.small ? ' · small sample' : '') + '</span>' +
    (r.breakout.some((x) => x) ? '<span class="ro-when">Hit in year 1/2/3: ' + r.breakout.join(' / ') + '%</span>' : '') +
    '</th>' + cell(r.top12) + cell(r.top24) + cell(r.top36) + '</tr>').join('');
  el.innerHTML =
    '<div class="section-card rookie-odds">' +
    '<div class="section-card-head"><div>' +
    '<h3 class="section-card-title">Rookie Odds</h3>' +
    '<div class="section-card-sub">How often a drafted rookie became a fantasy starter within three seasons</div>' +
    '</div></div>' +
    '<div class="ro-pills">' + pills + '</div>' +
    '<div class="ro-scroll"><table class="ro-table"><thead><tr><th></th><th class="ro-num">Top 12</th><th class="ro-num">Top 24</th><th class="ro-num">Top 36</th></tr></thead>' +
    '<tbody>' + body + '</tbody></table></div>' +
    '<p class="ro-note">Every ' + pos + ' drafted ' + span.firstClass + '-' + span.lastClass + ', by his best season (PPR total, regular season) in his first three. ' +
    '"Hit in year 1/2/3" is the season he first finished top 24, as a share of the ones who did. Data: nflverse (CC-BY 4.0).</p>' +
    '</div>';
}
window.renderRookieOdds = renderRookieOdds;

document.addEventListener('click', function (e) {
  const b = e.target.closest && e.target.closest('[data-rookie-odds-pos]');
  if (!b) return;
  STATE.rookieOddsPos = b.dataset.rookieOddsPos;
  renderRookieOdds();
});

;